import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';

const messages = {
  th: {
    tokenUsageWarningTitle: 'แจ้งเตือนการใช้งานโทเค็น',
    tokenUsageWarningText: 'หน้านี้มีการเรียกใช้งาน AI ซึ่งจะมีการใช้งานโทเค็น (Token) ในการประมวลผล',
    tokenUsageWarningConfirm: 'รับทราบ',
    thaillm_noticeTitle: 'โมเดลตระกูล ThaiLLM',
    thaillm_noticeText: 'โมเดลนี้เป็นโมเดลตระกูล ThaiLLM ซึ่งรองรับจำนวนโทเค็น (Token) ได้น้อยกว่าโมเดลทั่วไป และคำตอบอาจมีความแม่นยำน้อยกว่า กรุณาควบคุมความยาวของ Prompt/ข้อมูลที่ส่งเข้าโมเดล และตรวจสอบคำตอบก่อนนำไปใช้งานจริง',
    thaillm_noticeMaxToken: 'โมเดลนี้รองรับสูงสุดประมาณ {maxToken} โทเค็น',
    thaillm_noticeConfirm: 'รับทราบ',
    maintenancePageAlt: 'ระบบอยู่ระหว่างปิดปรับปรุง',
    UserQuery: 'คำถามของผู้ใช้',
    OrgVectorSearch: 'ข้อมูลต้นฉบับสำหรับเวกเตอร์',
    ModVectorSearch: 'ข้อมูลปรับปรุงสำหรับเวกเตอร์ (อังกฤษ)',
    Company: 'บริษัท',
    StreamFileNamePrivateMemory: 'ชื่อเอกสาร',
    StreamUploadPrivateMemory: 'อัปโหลด',
    StreamPrivateMemory: 'เวกเตอร์',
    StreamPrivateMemoryAdd: 'เพิ่ม',
    StreamPrivateMemoryEdit: 'แก้ไข',
    StreamPopupFileHeader: 'อัปโหลดไฟล์',
    StreamPopupVoiceHeader: 'เสียงพูด',
    StreamPopuplang: 'ภาษา',
    StreamPopupRecord: 'บันทึกเสียง',
    FullStream: 'ฟูลสตรีม',
    Stream: 'แชท เพลย์กราวด์',
    no: 'ลำดับ',
    date: 'วันที่',
    description: 'คำอธิบาย',
    usermanagement: 'การจัดการผู้ใช้ในพอร์ทัล',
    userChatManagement: 'การจัดการผู้ใช้แชท',
    user: 'ผู้ใช้งาน',
    _CompanyCode: 'รหัสบริษัท',
    companyCodePlaceholder: 'กรอกรหัสบริษัท',
    companyCodeLoginHint: 'ผู้ใช้แชทเฟรมเวิร์กต้องกรอกรหัสบริษัท ส่วนซูเปอร์แอดมินของโปรดักต์แอดมินไม่ต้องกรอก',
    loginWithUsername: 'เข้าสู่ระบบด้วยชื่อผู้ใช้',
    loginWithSSO: 'เข้าสู่ระบบด้วย SSO',
    orLoginWith: 'หรือเข้าสู่ระบบด้วย',
    loginErrorWithCompanyCodeHint: 'เข้าสู่ระบบไม่สำเร็จ กรุณาตรวจสอบชื่อผู้ใช้/รหัสผ่าน หรือกรอกรหัสบริษัทสำหรับผู้ใช้แชทเฟรมเวิร์ก',
    username: 'ชื่อผู้ใช้',
    email: 'อีเมล',
    search: 'ค้นหา',
    UploadImageEx: 'ตัวอย่าง',
    UploadImage: 'รูป',
    add: 'เพิ่ม',
    New: 'ใหม่',
    manage: 'จัดการ',
    phonenumber: 'เบอร์โทรศัพท์',
    employeename: 'ชื่อพนักงาน',
    usertype: 'ประเภทผู้ใช้',
    edit: 'แก้ไข',
    delete: 'ลบ',
    download: 'ดาวน์โหลด',
    deleteAll: 'ลบทั้งหมด',
    users: 'ผู้ใช้',
    usergroup: 'กลุ่มผู้ใช้',
    permissionmanagement: 'การจัดการสิทธิ์',
    menumanagement: 'การจัดการเมนู',
    managementModelQuick: 'การจัดการควิกโมเดล',
    managementGPTModel: 'สร้างโมเดล',
    // managementGPTModelDetail: "รายละเอียดการจัดการโมเดลแอลแอลเอ็ม",
    managementGPTModelNode: 'การจัดการโมเดลจีพีทีภายใน',
    managementModelAndVector: 'การจัดการโมเดลและฐานข้อมูลเวกเตอร์',
    ValidationGenerateUpload: 'อัปโหลดชุดตรวจสอบ',
    calendar: 'ปฏิทิน',
    log: 'เข้าสู่ระบบ',
    setting: 'การตั้งค่า',
    groupname: 'ชื่อกลุ่ม',
    permissionname: 'ชื่อสิทธิ์',
    save: 'บันทึก',
    close: 'ปิด',
    update: 'อัปเดต',
    firstname: 'ชื่อจริง',
    lastname: 'นามสกุล',
    indicatesrequiredfield: 'แสดงถึงฟิลด์ที่จำเป็น',
    userprofile: 'โปรไฟล์',
    switchcompany: 'เปลี่ยนองค์กร',
    logout: 'ออกจากระบบ',
    password: 'รหัสผ่าน',
    confirmpassword: 'ยืนยันรหัสผ่าน',
    checklengthcharacters: 'ความยาวอย่างน้อย 8 ตัวอักษร',
    checklowercaseletter: 'อักษรตัวพิมพ์เล็กอย่างน้อย 1 ตัวอักษร',
    checkuppercaseletter: 'อักษรตัวพิมพ์ใหญ่อย่างน้อย 1 ตัวอักษร',
    checknumber: 'ตัวเลข(0-9)',
    checkspecialcharacter: 'อักขระพิเศษอย่างน้อย 1 ตัว',
    checkpasswordmatch: 'ยืนยันรหัสผ่านไม่ตรงกัน',
    rememberme: 'จดจำฉัน',
    forgotpassword: 'ลืมรหัสผ่าน?',
    login: 'เข้าสู่ระบบ',
    successMessage: 'เข้าสู่ระบบเรียบร้อยแล้ว',
    adduseringroup: 'เพิ่มผู้ใช้ในกลุ่ม',
    menuname: 'ชื่อเมนู',
    number: 'จำนวน',
    addgroupinmenu: 'เพิ่มกลุ่มในเมนู',
    addGPTModel: 'เพิ่มโมเดลจีพีที',
    updateGPTModel: 'แก้ไขโมเดลจีพีที',
    addGPTModelNode: 'เพิ่มโหนดโมเดลจีพีที',
    updateGPTModelNode: 'แก้ไขโหนดโมเดลจีพีที',
    uploadCSV: 'อัปโหลด CSV',
    uploadNegativeQuestionSet: 'อัปโหลดชุดคำถามเชิงลบ',
    upload: 'อัปโหลด',
    ddfile_browseFilesToUpload: 'เลือกไฟล์เพื่ออัปโหลด',
    ddfile_bytes: 'ไบต์',
    ddfile_normalQuestion: 'คำถามทั่วไป',
    ddfile_chainQuestion: 'คำถามแบบต่อเนื่อง',
    ddfile_download: 'ดาวน์โหลด',
    ddfile_pleaseUploadCorrectType: 'กรุณาอัปโหลดไฟล์ประเภทที่ถูกต้อง!',
    downloadTemplate: 'ดาวน์โหลดเทมเพลต',
    addModelAndVector: 'เพิ่มโมเดลและเวกเตอร์ดีบี',
    type: 'ประเภท',
    role: 'บทบาท',
    setup_title: 'การเชื่อมต่อแพลตฟอร์ม',
    general_title: 'การตั้งค่าหลัก',
    chatLogs_title: 'บันทึกแชท',
    setup_search_name: 'ชื่อ',
    setup_table_no: 'รหัส',
    setup_table_key: 'ชื่อ',
    setup_table_value: 'ค่า',
    setup_btn_apply: 'นำไปใช้',
    dashboard: 'แดชบอร์ด',
    dashboardScore: 'แดชบอร์ด คะแนน',
    question: 'คำถาม',
    answer: 'คำตอบ',
    score: 'คะแนน',
    Validation: 'การตรวจสอบ',
    GenerateTestQuestions_title: 'สร้างคำถามทดสอบ',
    NegativeDataset_title: 'ชุดคำถามเชิงลบ',
    ExecuteTestRuns_title: 'ดำเนินการทดสอบ',
    DatabaseIntegration_title: 'การเชื่อมต่อฐานข้อมูล',
    FileManagement_title: 'การจัดการไฟล์',
    Documents_title: 'เอกสาร',
    validationScore: 'คะแนนการตรวจสอบ',
    calculateScores: 'คำนวณคะแนน',
    averageScore: 'ค่าเฉลี่ยคะแนน',
    totalUser: 'ผู้ใช้ทั้งหมด',
    totalQuery: 'จำนวนคำถามทั้งหมด',
    month: 'เดือน',
    LastDayTotalUserUsage: 'การใช้งานผู้ใช้รวมในวันที่ผ่านมา',
    UpdatedIn: 'ภายในเมื่อวาน',
    UsageOverview: 'ภาพรวมการใช้งาน',
    TokensUsedMonth: 'การใช้โทเค็น',
    Usage: 'การใช้งาน',
    TokensUsed: 'โทเค็นที่ใช้ไปทั้งหมด',
    TokensUsedTokensChat: 'จำนวนโทเค็นทั้งหมดที่ใช้ในการแชท',
    DetailTokensUsedTokensChat: 'จำนวนโทเค็นทั้งหมดที่ใช้ในการแชท',
    DetailImageGenChat: 'จำนวนการสร้างภาพทั้งหมดที่ใช้ในการแชท',
    ImageGenTotalInChat: 'จำนวนการสร้างภาพทั้งหมดที่ใช้ในการแชท',
    ImageGenTotal: 'จำนวนการสร้างภาพทั้งหมด',
    ImageGenTotalPrice: 'ราคาการสร้างภาพทั้งหมด',
    ImageGenTotalPriceInChat: 'ราคาการสร้างภาพทั้งหมดที่ใช้ในการแชท',
    TokensUsedPromptTokensChat: 'จำนวนโทเค็นพรอมต์ทั้งหมดที่ใช้ในการแชท',
    TokensUsedCompletionTokensChat: 'จำนวนโทเค็นคำตอบทั้งหมดที่ใช้ในการแชท',
    TokensUsedCachedTokensChat: 'จำนวนโทเค็นแคชทั้งหมดที่ใช้ในการแชท',
    TokensUsedEmbedding: 'จำนวนโทเค็นทั้งหมดในการเอ็มเบดดิ้ง',
    NumberUsers: 'ผู้ใช้ทั้งหมด',
    TotalModels: 'จำนวนโมเดลทั้งหมด',
    WithinThisMonth: 'ภายในเดือนนี้',
    UserUsage: 'การใช้งานของผู้ใช้',
    WithinThis30daysagoToTotalUsers: 'ผู้ใช้ย้อนหลังภายใน 30 วัน/ผู้ใช้ทั้งหมด',
    UserWithinThisDay: 'ผู้ใช้ภายใน',
    DaysToTotalUsers: 'วัน/ผู้ใช้ทั้งหมด',
    TotalUsagePerMonth: 'การใช้งานรวมต่อเดือน',
    NumberPeople: 'จำนวนคน',
    NumberData: 'จำนวนข้อมูล',
    People: 'ผู้ใช้',
    NumberQuestions: 'จำนวนคำถาม',
    LoginUserChartTitle: 'ผู้ใช้งานที่เข้าสู่ระบบและไม่เข้าสู่ระบบรายวัน',
    CategoryQuestionMonthly: 'หมวดหมู่คำถาม',
    OtherQuestionMonthly: 'คำถามอื่นๆ',
    AnalyticsPendingNotice: 'ข้อมูลอันดับคำถามยังประมวลผลไม่ครบทั้งช่วงวันที่เลือก (แสดงเฉพาะบางส่วนเพื่อให้โหลดทัน) ตัวเลขอาจยังไม่สมบูรณ์',
    QuestionsTabLogin: 'ผู้ใช้ Login',
    QuestionsTabNonLogin: 'ผู้ใช้ NonLogin',
    QuestionsEmpty: 'ไม่มีคำถามในช่วงที่เลือก',
    LoginCountPerDayTooltip: 'ยอดผู้ใช้ที่เข้าใช้งานของแต่ละวัน นำมาบวกรวมกันทั้งช่วง — เช่น คนเดิมที่เข้าใช้ 3 วัน จะถูกนับเป็น 3 ไม่ใช่ 1',
    RankNo: 'อันดับ',
    TopicLabel: 'เรื่อง',
    SearchCountLabel: 'การค้นหา (ครั้ง)',
    QuestionCompanyLabel: 'หน่วยงาน',
    SeriesLoginUsers: 'จำนวนคน (เข้าสู่ระบบ)',
    SeriesNonLoginUsers: 'จำนวนคน (ไม่เข้าสู่ระบบ)',
    SeriesTotal: 'รวม',
    ChartSubtotalLogin: 'เข้าสู่ระบบ',
    ChartSubtotalNonLogin: 'ไม่เข้าสู่ระบบ',
    People2: 'ผู้ใช้',
    saDashboardWelcome: 'ยินดีต้อนรับกลับ',
    saDashboardWelcomeSubtitle: 'ภาพรวมการใช้งานทั้งหมดของระบบซูเปอร์แอดมิน',
    saDashboardExportAll: 'ส่งออกทั้งหมด',
    saDashboardProvider: 'ผู้ให้บริการ',
    saDashboardAllProviders: 'ทุกผู้ให้บริการ',
    saDashboardChooseAgencies: 'เลือกหน่วยงาน',
    saDashboardAllAgencies: 'ทุกหน่วยงาน',
    saDashboardSearchAgency: 'ค้นหาหน่วยงาน...',
    saDashboardSelectByStructure: 'เลือกตามโครงสร้าง',
    saDashboardApplyFilter: 'นำไปใช้',
    saDashboardNoCompanyFound: 'ไม่พบหน่วยงาน',
    saDashboardStartDate: 'วันที่เริ่มต้น',
    saDashboardEndDate: 'วันที่สิ้นสุด',
    saDashboardOverview: 'ภาพรวม',
    saDashboardOverviewSubtitle: 'สถิติภาพรวมของระบบทั้งหมด',
    saDashboardTotalUser: 'ผู้ใช้งานสมาร์ตแชท',
    saDashboardSmartChat: 'สมาร์ตแชท',
    saDashboardAIUsers: 'ผู้ใช้เอไอ',
    saDashboardLikeLabel: 'ชอบ',
    saDashboardTotalModels: 'จำนวนโมเดลทั้งหมด',
    saDashboardActiveModels: 'โมเดลที่ถูกใช้งาน',
    saDashboardActiveModelsTrend: 'จำนวนโมเดลที่ใช้งานอยู่ในช่วงเวลาที่เลือก',
    saDashboardLikedMessages: 'ข้อความที่ถูกกดถูกใจ',
    saDashboardDislikeLabel: 'ไม่ชอบ',
    saDashboardCompanies: 'หน่วยงาน',
    saDashboardSelectedFilters: 'ตัวกรองที่เลือก',
    saDashboardAllValue: 'ทั้งหมด',
    saDashboardAgencies: 'หน่วยงาน',
    saDashboardTotalAgencies: 'หน่วยงานทั้งหมด',
    saDashboardTokenDetail: 'รายละเอียดโทเค็น',
    saDashboardUsage: 'การใช้งาน',
    saDashboardTokenDetailSubtitle: 'รายละเอียดการใช้โทเค็นของทุกหน่วยงาน',
    saDashboardTokenUsageTitle: 'การใช้โทเค็น',
    saDashboardTokenUsageSubtitle: 'แยกตามโมเดล 5 อันดับแรก',
    saDashboardSystemUsersTitle: 'แนวโน้มผู้ใช้งานสมาร์ตแชทรายวัน',
    saDashboardPerMonth: 'รายเดือน',
    saDashboardPerDay: 'รายวัน',
    saDashboardCategoryQuestionsSubtitle: 'คำถามตามหมวดหมู่ที่ถูกค้นหามากที่สุด',
    saDashboardOtherQuestionsSubtitle: 'คำถามอื่นที่ถูกค้นหามากที่สุด',
    saDashboardCompanyDetails: 'รายละเอียดหน่วยงาน',
    saDashboardCompanyDetailsSubtitle: 'ประเภทหน่วยงาน ชื่อ จำนวนโทเค็นที่ใช้ และจำนวนผู้ใช้ของแต่ละหน่วยงาน',
    saDashboardWorkgroupType: 'ประเภทหน่วยงาน',
    saDashboardCode: 'รหัสหน่วยงาน',
    saDashboardCompanyCards: 'สรุปข้อมูลรายหน่วยงาน',
    saDashboardCompanyCardsSubtitle: 'โทเค็น ผู้ใช้ และเอกสารของแต่ละหน่วยงาน',
    saDashboardCardUsage: 'การใช้งาน',
    saDashboardName: 'ชื่อ',
    saDashboardUsedToken: 'โทเค็นที่ใช้',
    saDashboardUsers: 'ผู้ใช้',
    saDashboardNoData: 'ไม่มีข้อมูล',
    saDashboardNoCompanyData: 'ไม่มีข้อมูลหน่วยงาน',
    saDashboardNoSubscription: 'ยังไม่มีแพ็กเกจสมัครใช้งาน',
    saDashboardExportFail: 'ส่งออกไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
    saDashboardExportSuccess: 'ส่งออกสำเร็จ',
    saDashboardDocuments: 'เอกสาร',
    saDashboardDocLastUpdated: 'อัปเดตเอกสารล่าสุด',
    saDashboardDocSortTip: 'คลิกเพื่อเรียงตามวันที่อัปเดตเอกสารล่าสุด (ใหม่สุด → เก่าสุด → ปกติ)',
    saDashboardDocDaysAgo: 'วันที่แล้ว',
    saDashboardDocToday: 'วันนี้',
    saDashboardDocumentDetails: 'รายละเอียดเอกสารความรู้',
    saDashboardDocumentName: 'ชื่อเอกสาร',
    saDashboardDocumentCreatedBy: 'สร้างโดย',
    saDashboardDocumentUpdatedAt: 'อัปเดตล่าสุด',
    saDashboardDocumentProcess: 'ประมวลผล',
    saDashboardDocReviewStatus: 'สถานะ',
    saDocStatusDraft: 'แบบร่าง',
    saDocStatusTesting: 'กำลังทดสอบ',
    saDocStatusReady: 'เรียบร้อย',
    saDocStatusIssue: 'ทำงานผิดพลาด',
    saDocStatusNone: 'ยังไม่กำหนด',
    saDocStatusUpdated: 'อัปเดตสถานะแล้ว',
    saDocStatusUpdateFailed: 'อัปเดตสถานะไม่สำเร็จ',
    saDashboardDocumentNoData: 'ไม่มีเอกสารความรู้',
    saDashboardDocumentDialogClose: 'ปิด',
    saDashboardViewDocuments: 'ดูเอกสารของ',
    saDashboardTotalTokensAll: 'โทเค็นรวมทั้งหมด',
    saDashboardPromptTokens: 'โทเค็นพรอมต์',
    saDashboardTotalTokensFormulaTip: 'โทเค็นพรอมต์ + โทเค็นคำตอบ + โทเค็นเอ็มเบดดิ้ง = โทเค็นรวมทั้งหมด · โทเค็นแคชรวมอยู่ในพรอมต์แล้ว',
    saDashboardTotalTokensFormulaNote: 'แคชอยู่ในพรอมต์ · รวมเอ็มเบดดิ้ง',
    saDashboardChatPromptTokens: 'โทเค็นพรอมต์แชท',
    saDashboardCachedTokens: 'โทเค็นแคช',
    saDashboardNonCachedTokens: 'โทเค็นไม่แคช',
    saDashboardNonCachedFormulaTip: 'โทเค็นพรอมต์ − โทเค็นแคช = โทเค็นไม่แคช · ส่วนของพรอมต์ที่ไม่ได้ใช้แคช (จ่ายเต็มราคา)',
    saDashboardNonCachedFormulaNote: 'พรอมต์ − แคช · ส่วนที่ไม่เข้าแคช',
    saDashboardCompletionTokens: 'โทเค็นคำตอบ',
    saDashboardEmbeddingTokens: 'โทเค็นเอ็มเบดดิ้ง',
    saDashboardProcessingTokens: 'โทเค็นประมวลผล',
    saDashboardProcessingTokensInfo: 'โทเค็นที่ระบบเอไอใช้เบื้องหลังเพื่อประมวลผลคำถาม แต่ไม่แสดงเป็นข้อความแชทโดยตรง ได้แก่ การจำแนกอินเทนต์, การค้นหา/ดึงข้อมูลความรู้และเอกสาร, การสร้างคำสั่งค้นข้อมูล, การจัดรูปแบบคำตอบ และการเรียกซ้ำเมื่อรีทราย — โทเค็นเหล่านี้ถูกนับรวมในโควต้าการใช้งานเช่นเดียวกับคำตอบในแชท',
    saDashboardTotalInclProcessing: 'รวมทั้งหมด (รวมการประมวลผล)',
    saDashboardTotalInclProcessingNote: 'โทเค็นรวมทั้งหมด + โทเค็นประมวลผล · เท่ากับยอดที่นับเข้าโควต้าการใช้งานในช่วงที่เลือก',
    saDashboardLimitTokens: 'โทเค็นจำกัด',
    saDashboardQuotaValidUntil: 'ใช้ได้ถึง',
    saDashboardQuotaExpiredOn: 'หมดอายุเมื่อ',
    saDashboardTokenDetailPeriod: 'รายละเอียดโทเค็น (เฉพาะช่วงที่เลือก)',
    saDashboardTokenDetailPeriodTip: 'ยอดการใช้โทเค็นจริงจากล็อกเฉพาะช่วงวันที่ที่เลือกด้านบน',
    saDashboardQuotaGroup: 'โควต้าแพ็กเกจสมัครใช้งาน (สะสม)',
    saDashboardQuotaGroupTip: 'โควต้าที่ใช้ไปสะสมของแพ็กเกจปัจจุบัน — เริ่มนับใหม่ทุกครั้งที่ต่ออายุ/เปลี่ยนแพ็กเกจ และไม่ขึ้นกับช่วงวันที่ที่เลือก ดังนั้นถ้าหน่วยงานเพิ่งต่ออายุ ตัวเลขนี้จะน้อยกว่ายอดใช้ในช่วงที่เลือกได้ (มาจากตารางแพ็กเกจสมัครใช้งาน)',
    saDashboardUnlimited: 'ไม่จำกัด',
    saDashboardNoSubscription: 'ยังไม่มีแพ็กเกจ',
    saDashboardFooterTotal: 'รวมทั้งหมด',
    saDashboardTokensSeries: 'โทเค็น',
    saDashboardUserActivity: 'กิจกรรมผู้ใช้',
    saDashboardTotalLikeDislike: 'ถูกใจ/ไม่ถูกใจ รวม',
    saDashboardSelectedAgencies: 'เลือก {n} หน่วยงาน',
    saDashboardClearAll: 'ล้างทั้งหมด',
    saDashboardShowTokens: 'โทเค็น',
    saDashboardShowUsd: 'ดอลลาร์สหรัฐ ($)',
    saDashboardShowThb: 'บาท (฿)',
    saDashboardPriceApproxNote: 'ราคาโดยประมาณ',
    saDashboardBillableNote: 'ยอดที่ลูกค้าต้องจ่ายจริง (รวมการประมวลผล ตรงกับโควต้าที่ถูกหัก)',
    gpt_model_management_replace: 'แทนที่',
    gpt_model_management_version_history: 'ประวัติเวอร์ชัน',
    gpt_model_management_version_history_detail: 'รายละเอียดประวัติเวอร์ชัน',
    gpt_model_management_export_file_config: 'ส่งออกไฟล์',
    importVectorTitle: 'คุณต้องการนำเข้าเวกเตอร์หรือไม่',
    importPrivate_MemoryTitle: 'คุณต้องการนำเข้าเวกเตอร์หรือไม่',
    doctype: 'ประเภทเอกสาร',
    vectortype: 'ประเภทโครงสร้าง',
    process_type: 'ประเภทกระบวนการ',
    yes: 'ใช่',
    cancel: 'ยกเลิก',
    // ── ความยินยอมตามพีดีพีเอ ก่อนลงทะเบียน / ขอผูกดีจีเอ ดิจิทัล ไอดี หรือไทยดี ──
    ssoConsentTitle: 'ความยินยอมในการเก็บรวบรวมข้อมูลส่วนบุคคล',
    ssoConsentIntroRegister: 'เพื่อสมัครและยืนยันตัวตนผ่าน {provider} ระบบจำเป็นต้องเก็บรวบรวมและใช้ข้อมูลส่วนบุคคลของท่านดังต่อไปนี้',
    ssoConsentIntroLink: 'เพื่อผูกบัญชีของท่านกับ {provider} ระบบจำเป็นต้องเก็บรวบรวมและใช้ข้อมูลส่วนบุคคลของท่านดังต่อไปนี้',
    ssoConsentItem1: 'ชื่อ-นามสกุล',
    ssoConsentItem2: 'เลขประจำตัวประชาชน',
    ssoConsentItem3: 'วันเดือนปีเกิด และเพศ',
    ssoConsentItem4: 'ที่อยู่ตามทะเบียนบ้าน',
    ssoConsentItem5: 'ข้อมูลอื่นที่ได้รับจากผู้ให้บริการพิสูจน์และยืนยันตัวตน',
    ssoConsentPurpose: 'ข้อมูลข้างต้นจะถูกเก็บรวบรวมและใช้เพื่อการพิสูจน์และยืนยันตัวตน และการให้บริการตามวัตถุประสงค์ของระบบ ภายใต้พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562',
    ssoConsentCheckbox: 'ข้าพเจ้าได้อ่านและยินยอมให้เก็บรวบรวมและใช้ข้อมูลส่วนบุคคลข้างต้น',
    ssoConsentAgree: 'ยินยอมและดำเนินการต่อ',
    confirm: 'ยืนยัน',
    confirmDeletion: 'ยืนยันการลบ',
    confirmRenewal: 'ยืนยันการต่ออายุ',
    confirmDeletion2: 'คุณต้องการยืนยันการลบนี้หรือไม่',
    confirmDeletionGroup: 'คุณต้องการยืนยันการลบกลุ่มนี้หรือไม่',
    // confirmDeletionModel: 'คุณต้องการยืนยันการลบโมเดลนี้หรือไม่',
    confirmDeletionModelPart1: 'คุณต้องการยืนยันการลบโมเดล', // Added part 1
    confirmDeletionModelPart2: 'หรือไม่', // Added part 2
    confirmDeletionMessage: 'คุณต้องการยืนยันการลบข้อความนี้หรือไม่',
    confirmDeletionModelGroup: 'คุณต้องการยืนยันการลบกลุ่มโมเดลนี้หรือไม่',
    confirmDeletionModelShortcut: 'คุณต้องการยืนยันการลบโมเดลชอร์ตคัตนี้หรือไม่',
    confirmDeletionSetting: 'คุณต้องการยืนยันการลบการตั้งค่านี้หรือไม่',
    confirmDeletionVectorName: 'คุณต้องการยืนยันการลบเวกเตอร์เนมนี้หรือไม่',
    confirmDeletionDocumentName: 'คุณต้องการยืนยันการลบชื่อเอกสารนี้หรือไม่',
    confirmDeletionDocument: 'คุณต้องการยืนยันการลบเอกสารนี้หรือไม่',
    confirmDeletionTableName: 'คุณต้องการยืนยันการลบชื่อตารางนี้หรือไม่',
    confirmDeletionIntentGroup: 'คุณต้องการยืนยันการลบกลุ่มอินเทนต์นี้หรือไม่',
    confirmDeletionIntentSession: 'คุณต้องการยืนยันการลบเซสชันอินเทนต์นี้หรือไม่',
    confirmDeletionVector: 'คุณต้องการยืนยันการลบเวกเตอร์นี้หรือไม่',
    confirmDeletionUser: 'คุณต้องการยืนยันการลบผู้ใช้งานนี้หรือไม่',
    confirmDeletionFile: 'คุณต้องการยืนยันการลบไฟล์นี้หรือไม่',
    confirmDeletionAllFile: 'คุณต้องการยืนยันการลบไฟล์ทั้งหมดนี้หรือไม่',
    confirmDeletionQuestion: 'คุณต้องการยืนยันการลบคำถามนี้หรือไม่',
    confirmDeletionAllQuestion: 'คุณต้องการยืนยันการลบคำถามทั้งหมดนี้หรือไม่',
    confirmDeletionPrompt: 'คุณต้องการยืนยันการลบพรอมต์นี้หรือไม่',
    confirmOn: 'ยืนยันการเปิด',
    confirmOff: 'ยืนยันการปิด',
    confirmOnVectorName: 'คุณต้องการยืนยันการเปิดเวกเตอร์นี้หรือไม่',
    confirmOffVectorName: 'คุณต้องการยืนยันการปิดเวกเตอร์นี้หรือไม่',
    confirmDeleteConfirmation: 'ยืนยันการลบ',
    vectorReprocess: 'คุณต้องการประมวลผลใหม่',
    conditionScore0: '0 = คำตอบจากจีพีทีไม่เกี่ยวข้องกับคำถาม',
    conditionScore1: '1 = คำตอบจากจีพีทีเกี่ยวข้องกับคำถามประมาณ 50% - 80%',
    conditionScore2: '2 = คำตอบจากจีพีทีมีความเกี่ยวข้องกับคำถามมากที่สุด หรือคำตอบที่จีพีทีไม่สามารถตอบได้',
    general: 'พื้นฐาน',
    social: 'โซเชียล',
    QuickModel: 'ทางลัดโมเดล',
    groupModel: 'การจัดกลุ่มโมเดล',
    groupModelName: 'ชื่อกลุ่มโมเดล',
    groupIntentName: 'ชื่อกลุ่มอินเทนต์',
    modelQuickGroupName: 'ชื่อกลุ่มควิกโมเดล',
    modelID: 'รหัสโมเดล',
    model: 'โมเดล',
    modelName: 'ชื่อโมเดล',
    modeldata: 'การจัดการแอลแอลเอ็ม',
    editnewmodel: 'แก้ไขโมเดลใหม่',
    deletemodeldata: 'ลบข้อมูลโมเดล',
    areyousuretodeletethisdata: 'คุณแน่ใจที่จะลบข้อมูลนี้หรือไม่?',
    addnewmodel: 'เพิ่มโมเดลใหม่',
    loadingpleasewait: 'กำลังโหลด กรุณารอสักครู่...',
    pleasefillininformation: 'กรุณากรอกข้อมูล',
    superAdmin: 'ผู้ดูแลระบบสูงสุด',
    oneSuperAdmin: 'ต้องมีบทบาทผู้ดูแลระบบขั้นสูง อย่างน้อย 1 คน',
    notAuthoritySuperAdmin: 'คุณไม่มีสิทธิ์ลบบทบาทผู้ดูแลระบบขั้นสูง',
    admin: 'ผู้ดูแลระบบ',
    generalUsers: 'ผู้ใช้งาน',
    totalNumber: 'จำนวนทั้งหมด',
    groupReplaceText: 'การแทนที่ข้อความ',
    replaceText: 'แทนที่ข้อความ',
    specificText: 'ข้อความจำเพาะ',
    importReplaceTextTitle: 'คุณต้องการนำเข้าข้อความแทนที่หรือไม่ ?',
    importIntentText: 'คุณต้องการนำเข้าข้อความอินเทนต์หรือไม่ ?',
    warning: 'คำเตือน',
    warningSpecialCharacters: 'ตรวจพบมีตัวอักขระพิเศษ! กรุณาลบทิ้ง',
    warningFillAll: 'กรุณากรอกข้อมูลให้ครบถ้วน',
    questionSetName: 'ชื่อชุดคำถาม',
    questionSetType: 'ประเภทชุดคำถาม',
    warningFillIntentGroupName: 'กรุณากรอกชื่อกลุ่มอินเทนต์',
    warningModelName: 'กรุณากรอกชื่อโมเดล',
    warningProvider: 'กรุณาเลือกผู้ให้บริการ',
    warningModel: 'กรุณาเลือกโมเดล',
    warningPublish: 'กรุณาเลือกแบบร่างหรือเผยแพร่',
    warningTemperature: 'กรุณากรอกค่าเทมเพอเรเจอร์ ตั้งแต่ 0 - 1 (ทศนิยม 2 ตำแหน่ง)',
    warningChainMassage: 'กรุณาใส่ลำดับหรือระยะเวลาเพื่อเปิดใช้งานอินพุตหลายรอบ',
    warningTopP: 'กรุณากรอกค่า Top P ตั้งแต่ 0 - 1 (ทศนิยม 2 ตำแหน่ง)',
    warningVectordbName: 'กรุณาเลือกชื่อฐานข้อมูลเวกเตอร์ (เลือกได้มากกว่า 1 รายการ)',
    warningTopVDB: 'กรุณากรอกจำนวนฐานข้อมูลเวกเตอร์สูงสุด โดยตั้งค่า 1 เป็นต้นไป',
    warningAPIVersion: 'กรุณาเพิ่มเวอร์ชันเอพีไอในข้อมูลหลัก',
    warningWaitProcess: 'กรุณารอให้กระบวนการก่อนหน้านี้ทำงานเสร็จก่อน',
    warningFillCustomMaxCharacter: 'กรุณากรอกจำนวนตัวอักษรสูงสุดแบบกำหนดเอง',
    warnningStartdateEnddate: 'กรุณากรอกวันที่เริ่มต้นและวันที่สิ้นสุด',
    warningDuplicateDomain: 'ตรวจพบมีการใช้โดเมนนี้แล้ว',
    warningEnableTime: 'กรุณาระบุเขตเวลาหากเปิดใช้งานเวลา เพื่อให้บอทเข้าใจเวลาปัจจุบัน',

    errorUploadImage: 'ไม่สามารถอัพโหลดรูปภาพได้ กรุณาลองใหม่อีกครั้ง',
    totalUsedChatExpense: 'ค่าใช้จ่ายทั้งหมดที่ใช้ในการแชท',
    totalExpense: 'ราคารวมทั้งหมด',
    totalPriceForEmbedding: 'ราคาทั้งหมดในการเอ็มเบดดิ้ง',
    priceForAllChatUsage: 'ราคาทั้งหมดสำหรับการใช้งานแชท',
    totalPriceOfPromptChat: 'ราคาทั้งหมดสำหรับการใช้งานพรอมต์',
    totalPriceOfCompletionChat: 'ราคาทั้งหมดสำหรับการใช้งาน การเสร็จสิ้น',
    totalPriceOfCachedChat: 'ราคาทั้งหมดสำหรับการใช้งานแคช',
    totalPriceOfPromptGPT3: 'ราคาทั้งหมดสำหรับการใช้งานพรอมต์จีพีที-3-เทอร์โบ',
    totalPriceOfPromptGPT316k: 'ราคาทั้งหมดสำหรับการใช้งานพรอมต์จีพีที-3-เทอร์โบ-16เค',
    totalPriceOfPromptGPT4: 'ราคาทั้งหมดสำหรับการใช้งานพรอมต์จีพีที-4',
    totalPriceOfPromptGPTOTHER: 'ราคาทั้งหมดสำหรับการใช้งานพรอมต์อื่น',
    totalPriceOfCompletionChatGPT3: 'ราคาทั้งหมดสำหรับการสร้างคำตอบด้วยจีพีที-3-เทอร์โบ',
    totalPriceOfCompletionChatGPT316k: 'ราคาทั้งหมดสำหรับการสร้างคำตอบด้วยจีพีที-3-เทอร์โบ-16เค',
    totalPriceOfCompletionChatGPT4: 'ราคาทั้งหมดสำหรับการสร้างคำตอบด้วยจีพีที-4',
    totalPriceOfCompletionChatGPTOTHER: 'ราคาทั้งหมดสำหรับการสร้างคำตอบอื่นๆ',
    baht: 'บาท',
    TokensUsedPromptGPT3TokensChat: 'จำนวนโทเค็นพรอมต์จีพีที-3-เทอร์โบทั้งหมดที่ใช้ในการแชท',
    TokensUsedPromptGPT316kTokensChat: 'จำนวนโทเค็นพรอมต์จีพีที-3-เทอร์โบ-16เคทั้งหมดที่ใช้ในการแชท',
    TokensUsedPromptGPT4TokensChat: 'จำนวนโทเค็นพรอมต์จีพีที-4 ทั้งหมดที่ใช้ในการแชท',
    TokensUsedCompletionGPT3TokensChat: 'จำนวนโทเค็นคำตอบจีพีที-3-เทอร์โบทั้งหมดที่ใช้ในการแชท',
    TokensUsedCompletionGPT316kTokensChat: 'จำนวนโทเค็นคำตอบจีพีที-3-เทอร์โบ-16เคทั้งหมดที่ใช้ในการแชท',
    TokensUsedCompletionGPT4TokensChat: 'จำนวนโทเค็นคำตอบจีพีที-4 ทั้งหมดที่ใช้ในการแชท',
    promptPrice: 'ราคาพรอมต์',
    completionPrice: 'ราคาคำตอบ',
    T30dayago: 'ย้อนหลังภายใน 30 วัน',
    WithinThis30daysago: 'ย้อนหลังภายใน 30 วัน',
    WithinThisDaysAgo: 'ภายใน',
    Day: 'วัน',
    ReportQuestion: 'แนวโน้มคำถาม',
    ReportUser: 'ผู้ใช้งานยอดนิยม',
    ReportFeedback: 'รายงานฟีดแบ็ก',
    Questions: 'คำถาม',
    Answers: 'คำตอบ',
    LikeDislike: 'ชอบ/ไม่ชอบ',
    Comments: 'ความคิดเห็น',
    PromptTemplate: 'เทมเพลตพรอมต์',
    Active: 'เปิดใช้งาน',
    Inactive: 'ไม่ใช้งาน',
    active: 'ใช้งาน',
    inactive: 'ไม่ใช้งาน',
    ReportTotalQuestionByUser: 'ข้อมูลการใช้งานทั้งหมด',
    SettingExternalConnector: 'การเชื่อมต่อภายนอก',
    previousTab: 'แท็บก่อนหน้า',
    nextTab: 'แท็บถัดไป',
    ModelDisplay: 'โมเดลที่แสดง',
    Provider: 'ผู้ให้บริการ',
    releases: 'บันทึกการเปลี่ยนแปลงรุ่น',
    vector_management_duplicate: 'ทำซ้ำ',
    vector_management_replace: 'แทนที่',
    vector_duplicate: 'เพิ่มเวกเตอร์',

    importUserTitle: 'คุณต้องการนำเข้าผู้ใช้หรือไม่ ',
    system: 'ระบบ',
    internal: 'ภายใน',
    external: 'ภายนอก',
    testConnection: 'ทดสอบการเชื่อมต่อ',
    allcolumn: 'ดึงทุกคอลัมน์',
    connectionString: 'สตริงการเชื่อมต่อ',
    view: 'ดู',
    view_detail: 'ดูรายละเอียด',
    dataIntegrationName: 'ชื่อการรวมข้อมูล',
    SocialUserID: 'รหัสผู้ใช้ไลน์',
    RecipientId: 'รหัสผู้ใช้เฟซบุ๊ก',
    RecipientId_Instagram: 'รหัสผู้ใช้อินสตาแกรม',
    ConfirmDataAddition: 'ยืนยันการเพิ่มข้อมูล',
    TranslateEnglish: 'แปลภาษาอังกฤษ',
    DataSearchVector: 'ข้อมูลค้นหาเวกเตอร์',
    selectToDeleteFile: 'เลือกลบไฟล์',

    _InfoModelDisplay: 'ข้อมูลชื่อแสดงผลโมเดลจะแสดงเลขชื่อแสดงผลโมเดลเมื่อมีการเผยแพร่หรือบันทึกเป็นร่าง',
    _InfoModelName: 'ชื่อโมเดล',
    _InfoProvider: 'เลือกผู้ให้บริการ',
    _InfoModel: 'โมเดลจากผู้ให้บริการ',
    _InfoExtension: 'ส่วนขยายของโมเดล',
    _InfoDescriptiion: 'คำอธิบายเพิ่มเติม',
    _InfoGender: 'เพศของแชทบอท',
    _InfoVersion: 'เวอร์ชันที่ใช้งานอยู่ในปัจจุบัน',
    _InfoStream: 'กรณีเลือกสตรีม ระบบจะแสดงการตอบแบบทีละตัวอักษร',
    _InfoByPass: 'กรณีเลือกบายพาส ระบบจะตอบข้อมูลนอกเหนือจากพรอมต์หรือเวกเตอร์ที่กำหนดไว้ โดยค้นหาข้อมูลจากความรู้สาธารณะเพื่อนำมาตอบได้',
    _InfoFeedback: 'กรณีเลือกฟีดแบ็ก ระบบจะเปิดให้รับความคิดเห็นจากผู้ใช้ได้',
    _InfoEnableTime: 'กรณีเลือกเปิดใช้งานเวลาในพรอมต์ ระบบจะเพิ่มวันและเวลาปัจจุบันเข้าไปในการสนทนา ทำให้บอทสามารถรับรู้และตอบสนองตามเวลาจริงได้',
    _InfoImageUpload: 'กรณีเลือกอัปโหลดรูปภาพ ระบบจะเปิดให้ใช้งานการอัปโหลดรูปภาพเพื่อใช้ในการถาม',
    _InfoVectorDBName: 'เลือกคลังความรู้ที่สร้างไว้แล้ว (เลือกได้มากกว่า 1) หากต้องการเพิ่มหรือแก้เนื้อหาข้างใน ให้ไปที่เมนู "จัดการเอกสาร"',
    _InfoGroupReplaceText: 'กลุ่มคำที่ได้แก้ไขไว้ สามารถแก้ไขได้ในหน้าการแทนที่ข้อความ',
    _InfoTopVDB: 'จำนวนรายการเวกเตอร์ที่นำมาใช้สูงสุด',
    _InfoCosine: 'ค่าความน่าจะเป็น',
    _InfoSequence: 'จำนวนลำดับของบทสนทนาที่จะนำมารวมกันเพื่อใช้ในการค้นหาและตอบคำถามครั้งล่าสุด',
    _InfoTimeSeconds: 'เชื่อมโยงคำถามที่อยู่ในช่วงเวลาที่กำหนด(วินาที)',
    _InfoMemory: 'เปิดใช้งานลำดับและเวลา',
    _InfoMultiTurnInput: 'เปิดใช้งานอินพุตหลายรอบ',
    _InfoTurn: 'จำนวนรอบที่สามารถจำข้อมูลได้',
    _InfoMinute: 'เวลาที่สามารถจำข้อมูลได้',
    _InfoShortMemory: 'จำนวนตัวอักษร สำหรับจำข้อมูล',
    _InfoLongtermMemory: 'เก็บข้อมูลแบบระยะยาว (เก็บข้อมูลรูปแบบของชังก์)',
    _InfoTemperature:
      'ควบคุมความสุ่ม การลด temperature หมายความว่าโมเดลจะสร้างคำตอบที่ซ้ำซ้อนและคาดเดาได้มากขึ้น การเพิ่ม temperature จะทำให้ได้คำตอบที่ไม่คาดคิดหรือสร้างสรรค์มากขึ้น ลองปรับ temperature หรือ Top P อย่างใดอย่างหนึ่ง',
    _InfoTopP:
      'คล้ายกับ temperature ค่านี้ควบคุมความสุ่มด้วยวิธีที่ต่างกัน การลด Top P จะทำให้โมเดลเลือกโทเค็นเฉพาะกลุ่มที่มีความน่าจะเป็นสูง การเพิ่ม Top P จะทำให้โมเดลเลือกได้ทั้งโทเค็นที่มีความน่าจะเป็นสูงและต่ำ ลองปรับ temperature หรือ Top P อย่างใดอย่างหนึ่ง',
    _InfoFrequencyPenalty: 'ลดโอกาสในการทำซ้ำโทเค็น โดยอิงจากความถี่ที่โทเค็นนั้นปรากฏในข้อความก่อนหน้า ช่วยลดโอกาสที่คำตอบจะใช้ข้อความเดิมซ้ำ',
    _InfoPresencePenalty: 'ลดโอกาสในการทำซ้ำโทเค็นที่เคยปรากฏในข้อความก่อนหน้า ช่วยเพิ่มโอกาสให้คำตอบนำเสนอหัวข้อใหม่',
    _InfoMaxToken: 'จำนวนโทเค็นสูงสุด',
    _InfoStop:
      "กำหนดให้โมเดลหยุดตอบที่ตำแหน่งที่ต้องการ คำตอบของโมเดลจะสิ้นสุดก่อนลำดับที่ระบุ จึงไม่มีข้อความของลำดับหยุดอยู่ในคำตอบ สำหรับแชทจีพีที การใช้ <{'|'}im_end{'|'}> ช่วยให้แน่ใจว่าโมเดลจะไม่สร้างคำถามต่อจากผู้ใช้ คุณสามารถใส่ลำดับหยุดได้สูงสุดสี่ลำดับ",
    _InfoDataIntegration: 'ข้อมูลจากการเชื่อมต่อข้อมูล',
    _InfoSQLExtractStatement: 'โมเดลที่ใช้สำหรับสร้างคำสั่งเอสคิวแอล',
    _InfoPromt:
      'ให้คำแนะนำแก่โมเดลเกี่ยวกับวิธีการทำงานและบริบทที่ควรอ้างอิงเมื่อสร้างคำตอบ คุณสามารถบรรยายลักษณะของผู้ช่วย บอกว่าควรและไม่ควรตอบอะไร และบอกวิธีจัดรูปแบบคำตอบ ไม่มีขีดจำกัดสำหรับส่วนนี้ แต่จะรวมอยู่ในทุกการเรียกเอพีไอ ดังนั้นจึงนับเป็นส่วนหนึ่งของขีดจำกัดโทเค็นโดยรวม',
    _InfoAdditionalPromt: 'สามารถเลือกเทมเพลตพรอมต์แทนพรอมต์',
    prefixMessage: 'ข้อความนำหน้า',
    prefixPreview: 'ตัวอย่างข้อความตอบกลับ',
    prefixQuestionLine: 'ตามที่ถามผมว่า',
    prefixSampleQuestion: 'ตัวอย่างคำถาม',
    prefixSampleAnswer: 'ตัวอย่างคำตอบจากเอไอ',
    enabled: 'เปิดใช้',
    disabled: 'ปิดใช้งาน',
    _InfoVectorDatabaseName: 'ชื่อเวกเตอร์',
    _InfoProcess_type: 'เลือกประเภทการดำเนินการ',
    _InfoCustomMaxCharacter: 'จำนวนตัวอักษรสูงสุด',
    _InfoDetectLanguage: 'ตรวจสอบภาษา',
    _InfoDoctype: 'ประเภทเอกสารที่ต้องการอัปโหลด',
    _InfoVectortype: 'ประเภทโครงสร้างของเอกสารที่อัปโหลด ตรวจสอบประเภทของเอกสารได้ที่เทมเพลต',
    _InfofillterModelType: 'ประเภทของการแบ่งข้อมูล',
    _InfoDataIntegrationName: 'ชื่อที่ใช้เรียกการเชื่อมต่อข้อมูลชุดนี้ในระบบ ตั้งเองได้ ห้ามซ้ำกับชุดอื่นในบริษัทเดียวกัน — จะใช้ชื่อนี้ตอนเลือกแหล่งข้อมูลให้โมเดลหรือโฟลว์',
    _InfoConnectionString: 'สตริงการเชื่อมต่อของเอสคิวแอลเซิร์ฟเวอร์',
    _InfoSchema: 'ชื่อสกีมา',
    _InfoTable: 'ชื่อตาราง',
    _InfoFuzzy: 'เปรียบเทียบข้อมูลที่มีในตารางเพื่อใช้ในการแก้ไขคำผิด',
    _InfoFuzzyWithBot: 'ฟัซซี่ร่วมกับบอท: เปรียบเทียบข้อมูลที่มีในตารางเพื่อใช้ในการแก้ไขคำผิดโดยใช้บอทเป็นตัวช่วย',
    _Personal_Info: 'ข้อมูลคอลัมน์ส่วนนี้จะถูกตรวจสอบการเข้าถึงของผู้ใช้',
    _InfoAllCloumns: 'ดึงทุกคอลัมน์ในตาราง',
    _InfoAddColumn: 'เพิ่มเฉพาะคอลัมน์ที่ต้องการ (ไม่จำเป็นต้องใช้ทุกคอลัมน์ที่มีอยู่ในตาราง)',
    _InfoReplaceGroup: 'กรุณากรอกชื่อกลุ่ม',
    _InfoNumberOfQuestions: 'จำนวนคำถามที่จะนำไปสร้าง',
    _InfoNumberOfQuestionsTone: 'กำหนดจำนวนที่จะสร้างคำถามของแต่ละโทน',
    _InfoTypeOptions: 'การใช้โทเค็น = สำหรับตรวจสอบจำนวนโทเค็นที่ใช้ไป, ล็อกดิบ = ล็อกทั้งหมด, ตัวตรวจหน่วยความจำ = ข้อมูลหน่วยความจำที่ถูกจัดเก็บในการถามตอบแต่ละครั้ง',
    _InfoStartDate: 'วันที่เริ่มต้น',
    _InfoEndDate: 'วันที่สิ้นสุด',
    _InfoValidationNegariveName: 'ชื่อชุดตรวจสอบเชิงลบ',
    _InfoValidationPositiveName: 'ชื่อชุดตรวจสอบเชิงบวก',
    _InfoValidationName: 'ชื่อชุดตรวจสอบ',
    _InfoQuestionPositiveName: 'ชื่อคำถามเชิงบวก',
    _InfoQuestionNegativeName: 'ชื่อคำถามเชิงลบ',
    _InfoSelectModel: 'เลือกโมเดล',

    _InfoBoxFirm: 'หนักแน่น',
    _InfoBoxConfident: 'มั่นใจ',
    _InfoBoxPoetic: 'เชิงกวี',
    _InfoBoxNarrative: 'เล่าเรื่อง',
    _InfoBoxProfessional: 'มืออาชีพ',
    _InfoBoxDescriptive: 'เชิงอธิบาย',
    _InfoBoxHumorous: 'ตลกขบขัน',
    _InfoBoxAcademic: 'เชิงวิชาการ',
    _InfoBoxPersausive: 'เชิงโน้มน้าว',
    _InfoBoxFormat: 'รูปแบบ',
    _InfoBoxInformal: 'ไม่เป็นทางการ',
    _InfoBoxFriendly: 'เป็นมิตร',

    _InfoSelectGroupModel: 'เลือกกลุ่มโมเดล หากต้องการแก้ไขโมเดลที่อยู่ภายในกลุ่มสามารถแก้ไขได้ที่หน้ากลุ่มโมเดล',
    _InfoSelectQuickModel: 'เลือกโมเดลตอบกลับด่วน หากต้องการแก้ไขโมเดลที่อยู่ภายในกลุ่ม แก้ไขได้ที่หน้า "โมเดลตอบกลับด่วน"',
    _InfoCurrentPrompPrice: 'ราคาสำหรับการถามคำถามต่อ 1,000 โทเค็น',
    _InfoCurrentComppletionPrice: 'ราคาสำหรับการตอบคำถามต่อ 1,000 โทเค็น',
    _InfoVersionOfModel: 'เวอร์ชันของโมเดล',
    _InfoPromptTemplateName: 'ชื่อเทมเพลตพรอมต์',
    _InfoStatusTemplate: 'สถานะการใช้งานเทมเพลต คุณสามารถเปิดใช้งานเทมเพลตได้สูงสุด 10 รายการ',
    _InfoPriority: 'ลำดับความสำคัญ',
    _InfoGroupModelName: 'ชื่อโมเดลที่ถูกจัดเป็นกลุ่ม',
    _InfoAllModel: 'ทุกโมเดล',
    _InfoModelinGroup: 'โมเดลที่ถูกเลือกจะถูกจัดอยู่ในกลุ่มเดียวกัน',
    _InfoTimeDelay: 'ระยะการหน่วงเวลา(มิลลิวินาที)',
    _InfoLimitedCharacter: 'การจำกัดตัวอักษร',
    _InfoHostName: 'ชื่อโฮสต์',
    _InfoEmailHost: 'โฮสต์อีเมล',
    _InfoSetupLinkMS: 'ลิงก์สำหรับใช้งานบนไมโครซอฟท์ทีมส์ (ไอเฟรม)',
    _InfoModelQuickGroupName: 'โมเดลที่อยู่ภายใต้กลุ่มโมเดล',
    _InfoGroupName: 'ชื่อกลุ่มโมเดล',
    _InfoGroupPromptTemplate: 'เลือกกลุ่มเทมเพลตพรอมต์',
    _InfoMSTeamsName: 'ชื่อที่ไว้ใช้สำหรับไมโครซอฟท์ทีมส์',
    _InfoMonitorLINEUserid: 'รหัสผู้ใช้ไลน์ที่ไว้ใช้สำหรับมอนิเตอร์',
    _InfoLINEName: 'ชื่อไลน์',
    _InfoTypingSpeed: 'กำหนดความเร็วในการตอบคำถาม (มิลลิวินาที)',
    _InfoMaximumChatInput: 'กำหนดข้อความในการพิม์สูงสุด',
    _InfoDomainNameForSnippet: 'ชื่อโดเมนสำหรับใช้งานในสนิปเพ็ต',
    _InfoFacebookName: 'ชื่อสำหรับใช้งานในเฟซบุ๊ก',
    _InfoAPI_Version: 'เวอร์ชันเอพีไอสำหรับใช้งานในเอพีไอเฟซบุ๊กเมสเซนเจอร์',
    _InfoPageId: 'รหัสเพจสำหรับใช้งานในเพจเฟซบุ๊ก',
    _InfoMaximumFileUpload: 'กำหนดขีดจำกัดอัปโหลดไฟล์ (กิโลไบต์)',
    _UseUploadFile: 'ใช้การอัปโหลดไฟล์',
    _InfoScore: 'คะแนนคือระดับการให้ความสำคัญ เรียงลำดับจากน้อยไปมาก ตัวอย่างเช่น ถ้าเจออินเทนต์ที่ตรงกันมากกว่า 1 ตัว ระบบจะเลือกอินเทนต์จากค่าคะแนนที่น้อยที่สุด',
    _InfoForUploadDateTimeDataType: 'ถ้าเลือกประเภทข้อมูลเป็น วันที่และเวลา ให้ใส่ในรูปแบบ ปี/เดือน/วัน ชั่วโมง:นาที:วินาที เท่านั้น เช่น 2024/12/31 12:30:00',
    _InfoForDeleteAllFile: 'ลบไฟล์ทั้งหมด',
    _InfoInstagramName: 'ชื่อสำหรับใช้งานในอินสตาแกรม',

    _InfoNotiOn: 'เปิดเสียงแจ้งเตือนแล้ว',
    _InfoNotiOff: 'ปิดเสียงแจ้งเตือนแล้ว',

    loginMicrosoft: 'เข้าสู่ระบบด้วยไมโครซอฟท์',
    sync: 'ซิงก์',
    _SSOWarning: 'ระบบเข้าสู่ระบบครั้งเดียวยังไม่ได้เปิดใช้งาน กรุณาไปเปิดใช้งานที่เมนูตั้งค่า',
    PlayGround: 'แชท เพลย์กราวด์คู่',
    _columnDataIntegration: 'คอลัมน์',
    _typeDataIntegration: 'ชนิดข้อมูล',
    _duplicateColumn: 'หัวคอลัมน์มีการซ้ำกัน',
    _incorrectColumn: 'หัวคอลัมน์ไม่ถูกต้อง',
    _ConfirmDataUpdate: 'ยืนยันการแก้ไขข้อมูล',

    _ShowAllText: 'แสดงข้อความทั้งหมด',
    _ShowAllTextOn: 'เปิด',
    _ShowAllTextOff: 'ปิด',
    _ShowPromptTemplate: 'แสดงเทมเพลตพรอมต์',
    _ShowAll: 'แสดงทั้งหมด',

    // ชื่อเมนูนำทาง
    _Dashboard: 'แดชบอร์ด',
    _ModelCreator: 'สร้างโมเดล',
    _KnowledgeManagement: 'การจัดการความรู้',
    _Documents: 'เอกสาร',
    _DatabaseIntegration: 'การเชื่อมต่อฐานข้อมูล',
    _OptimizationTechniques: 'เทคนิคการเพิ่มประสิทธิภาพ',
    _TextReplacement: 'การแทนที่ข้อความ',
    _ModelTesting: 'การทดสอบโมเดล',
    _GenerateTestQuestions: 'สร้างคำถามทดสอบ',
    _NegativeQuestionSet: 'ชุดคำถามเชิงลบ',
    _UploadNegativeQuestionSet: 'อัปโหลดชุดคำถามเชิงลบ',
    _ExecuteTestRuns: 'ดำเนินการทดสอบ',
    _UserManagement: 'การจัดการผู้ใช้',
    _PortalUserManagement: 'การจัดการผู้ใช้ในพอร์ทัล',
    _ChatUserManagement: 'การจัดการผู้ใช้แชท',
    _ChatManagement: 'การจัดการแชท',
    _Setting: 'การตั้งค่า',
    _CoreConfigurations: 'การตั้งค่าหลัก',
    _PlatformIntegration: 'การเชื่อมต่อแพลตฟอร์ม',
    _EntraApps: 'แอพเอนทรา',
    _entraStatus: 'สถานะ',
    _entraActive: 'เปิด',
    _entraInactive: 'ปิด',
    _entraVerification: 'การยืนยันไมโครซอฟท์เอนทรา',
    _entraVerificationOn: 'เปิด — ผู้ใช้ต้องยืนยันเอนทราก่อนใช้บอท',
    _entraVerificationOff: 'ปิด — บอททำงานปกติ ไม่ต้องยืนยัน (พฤติกรรมเดิม)',
    _entraApp: 'แอพเอนทรา',
    _entraAppPlaceholder: '— เลือกแอพเอนทรา —',
    _manageEntraApps: 'จัดการแอพเอนทรา',
    _liffId: 'รหัสลิฟฟ์',
    _liffIdPlaceholder: 'เช่น 2001234567-AbCdEfGh',
    _entraAppName: 'ชื่อแอพเอนทรา',
    _entraTenantId: 'Tenant ID',
    _entraClientId: 'Client ID',
    _entraClientSecret: 'Client Secret',
    _entraScopes: 'ขอบเขตสิทธิ์',
    _entraSecretHint: 'ค่าปัจจุบันถูกโหลดมาแล้ว (ซ่อนไว้) — กดรูปตาเพื่อดู, แก้ไขแล้วบันทึก = เข้ารหัสทับ',
    _addEntraApp: 'เพิ่มแอพเอนทรา',
    _editEntraApp: 'แก้ไขแอพเอนทรา',
    _entraAppManagement: 'การตั้งค่าแอพไมโครซอฟท์เอนทรา',
    _entraAppTableHint: '1 แถว = การลงทะเบียนแอพเอนทรา 1 รายการ — การ์ดโอเอในการเชื่อมต่อแพลตฟอร์มเลือกผ่านรายการเลือก (หลายโอเอใช้ร่วมกันได้)',
    _lineEntraLinkManagement: 'ผู้ใช้ไลน์ที่ยืนยันตัวตนกับเอนทรา',
    _lineEntraLinkTableHint: '1 แถว = ผู้ใช้ไลน์ 1 คนที่ยืนยันตัวตนกับเอนทราสำเร็จ — กด "ถอดการยืนยัน" แล้วผู้ใช้ต้องยืนยันใหม่เมื่อทักบอทครั้งถัดไป',
    _manageVerifiedUsers: 'จัดการผู้ใช้ที่ยืนยันแล้ว',
    _backToEntraApps: 'กลับไปจัดการแอพเอนทรา',
    _filterByEntraApp: 'กรองตามแอพเอนทรา',
    _lineDisplayName: 'ชื่อไลน์',
    _entraUpn: 'บัญชีเอนทรา (UPN)',
    _entraName: 'ชื่อในเอนทรา',
    _verifiedAt: 'ยืนยันเมื่อ',
    _unlink: 'ถอดการยืนยัน',
    _showInactive: 'แสดงรายการที่ถอดแล้ว',
    _confirmUnlinkTitle: 'ยืนยันการถอดการเชื่อมโยง?',
    _confirmUnlinkText: 'ผู้ใช้รายนี้จะต้องยืนยันตัวตนใหม่เมื่อทักบอทครั้งถัดไป',
    _unlinkSuccess: 'ถอดการยืนยันสำเร็จ',
    _ModelGrouping: 'การจัดกลุ่มโมเดล',
    _ExternalConnector: 'การเชื่อมต่อภายนอก',
    _SnippetCustomization: 'ปรับแต่ง Snippet',
    _SnippetSmallCustomization: 'ปรับแต่ง Snippet เล็ก',
    _SnippetFullCustomization: 'ปรับแต่ง Snippet เต็มจอ',
    _ModelShortcut: 'ทางลัดโมเดล',
    _LLMsManagement: 'การจัดการแอลแอลเอ็ม',
    _PromptTemplate: 'เทมเพลตพรอมต์',
    _Reports: 'รายงาน',
    _QuestionTrends: 'แนวโน้มคำถาม',
    _TopUsers: 'ผู้ใช้งานยอดนิยม',
    _TotalUsageInsights: 'ข้อมูลการใช้งานทั้งหมด',
    _TokenPerPage: 'โทเค็นแยกตามหน้า',
    rpt_title: 'รายงานโทเค็นแยกตามหน้า',
    rpt_pageTokenManagement: 'การใช้งานโทเค็นแยกตามหน้า',
    rpt_dateRange: 'ช่วงวันที่',
    rpt_startDate: 'วันที่เริ่มต้น',
    rpt_endDate: 'วันที่สิ้นสุด',
    rpt_search: 'ค้นหา',
    rpt_rank: 'ลำดับ',
    rpt_no: 'ลำดับ',
    rpt_pageName: 'ชื่อหน้า',
    rpt_modelName: 'ชื่อโมเดล',
    rpt_totalToken: 'โทเค็นทั้งหมด',
    rpt_cachedToken: 'โทเค็นแคช',
    rpt_pageNameTooltip: 'หน้า/ฟีเจอร์ที่มีการใช้งานโทเค็น เช่น แชท เพลย์กราวด์, แชท เพลย์กราวด์คู่, Snippet, External API, เอกสาร', // BUG3 fix: examples match pageLabel() localized values
    rpt_modelNameTooltip: 'โมเดล AI ที่ใช้ในหน้านี้ (การทำ embedding จะแสดงเป็นเครื่องหมาย -)',
    rpt_totalTokenTooltip: 'ผลรวมโทเค็นทั้งหมด (ขาเข้า + ขาออก + embedding) ของหน้านี้',
    rpt_cachedTokenTooltip: 'โทเค็นที่ดึงมาจากแคชของหน้านี้',
    rpt_dataRecords: 'ข้อมูลทั้งหมด {n} รายการ',
    rpt_noModel: '-',
    rpt_loadingPleaseWait: 'กำลังโหลด กรุณารอสักครู่...',
    rpt_pleaseFillRequiredFields: 'กรุณาเลือกช่วงวันที่ให้ครบถ้วน',
    _ChatLogs: 'บันทึกแชท',
    _ChatPlayground: 'แชท เพลย์กราวด์',
    _DualChatPlayground: 'แชท เพลย์กราวด์คู่',
    _Snippet: 'Snippet', // BUG3 fix: channel/PageName label
    _ExternalAPI: 'External API', // BUG3 fix: channel/PageName label
    _Document: 'เอกสาร', // BUG3 fix: channel/PageName label (ReportPageToken already had a plural _Documents key for a different page title)
    _ChatService: 'บริการแชท',
    _DocumentManagement: 'จัดการเอกสาร',
    _Product: 'ผลิตภัณฑ์',
    _ProductDetail: 'รายละเอียดผลิตภัณฑ์',
    _KnowledgeGraphs: 'กราฟความรู้',
    _KnowledgeGraphDetail: 'รายละเอียดกราฟความรู้',
    _KnowledgeGraphCreate: 'สร้างกราฟความรู้',
    _KnowledgeGraphVisualize: 'แสดงผลกราฟ',
    _KnowledgeGraphImport: 'นำเข้าข้อมูลกราฟ',
    _KnowledgeGraphSchema: 'จัดการสกีมา',
    _KnowledgeGraphAdvancedRetrieval: 'ตั้งค่าการดึงข้อมูลขั้นสูง',
    _KnowledgeGraphCitationContext: 'ใช้ข้อมูลอ้างอิง',
    _KnowledgeGraphCitationContextHint: 'ดึงข้อความบริบทอ้างอิงจากเน็กซา และให้แอลแอลเอ็มอ้างอิงด้วย [n] เมื่อมีข้อมูล',
    _KgCitationPromptLabel: 'ข้อความกำกับการอ้างอิง (Citation Rule)',
    _KgCitationPromptHint: 'ข้อความสั่งให้ LLM อ้างอิงด้วย [n] — เว้นว่างเพื่อใช้ค่าเริ่มต้นของระบบ',
    _WaterfallTierCitationLabel: 'เปิดการอ้างอิง (citation) สำหรับชั้นนี้',
    _CitationReference: 'อ้างอิง',
    _CitationFile: 'เอกสาร',
    _CitationGraph: 'กราฟ',
    _CitationType: 'ประเภท',
    _CitationNode: 'หัวข้อ',
    _CitationSection: 'ส่วน',
    _CitationDate: 'วันที่',
    _CitationEvidence: 'อ้างอิง',
    _PdfToMarkdownTool: 'เครื่องมือ',
    _PdfToMarkdownDialogButton: 'แปลง PDF เป็น Markdown',
    _PdfToMarkdownClose: 'ปิด',
    _PdfToMarkdownRefresh: 'รีเฟรช',
    _PdfToMarkdownOpenNewTab: 'เปิดในแท็บใหม่',
    _PdfToMarkdownNotConfigured: 'ยังไม่ได้ตั้งค่ายูอาร์แอลของเครื่องมือ',
    _PdfToMarkdownConfigureHint: 'ตั้งค่าได้ที่ซูเปอร์แอดมิน / การตั้งค่าระบบ',
    _PdfToMarkdownGoCoreConfig: 'ไปที่การตั้งค่าระบบ',
    _PdfToMarkdownLoadFailed: 'โหลดการตั้งค่าเครื่องมือไม่สำเร็จ',
    _PdfToMarkdownCoreConfigTitle: 'เครื่องมือ',
    _PdfToMarkdownCoreConfigSubtitle: 'ยูอาร์แอลสำหรับแสดงเครื่องมือแปลงพีดีเอฟเป็นมาร์กดาวน์ภายในไอเฟรม',
    _PdfToMarkdownIframeUrl: 'ยูอาร์แอลไอเฟรมเครื่องมือแปลงพีดีเอฟเป็นมาร์กดาวน์',
    _PdfToMarkdownIframeUrlPlaceholder: 'https://pdf2md.example.com',
    _PdfToMarkdownIframeUrlHint: 'ใช้ยูอาร์แอลจากระบบแปลงพีดีเอฟเป็นมาร์กดาวน์ที่เผยแพร่ใช้งานแล้ว',
    _PdfToMarkdownLeaveTitle: 'ยังอัพโหลดไฟล์ไม่เสร็จ',
    _PdfToMarkdownLeaveMessage: 'ไฟล์กำลังถูกแปลงอยู่ หากออกจากหน้านี้งานที่ค้างอาจถูกยกเลิก ต้องการออกหรือไม่?',
    _PdfToMarkdownLeaveConfirm: 'ออกจากหน้า',
    _PdfToMarkdownLeaveStay: 'อยู่ต่อ',

    _EnableTime: 'ใช้วันและเวลาในพรอมต์',
    serviceTheme: 'ตั้งค่าธีม',
    consentConfig: 'การกำหนดความยินยอม',
    IntentGroup: 'กลุ่มอินเทนต์',
    IntentSession: 'เซสชันอินเทนต์',
    TokenSummation: 'สรุปโทเค็น',
    Intent: 'อินเทนต์',
    Flow: 'โฟลว์',
    'Create Model': 'สร้างโมเดล',
    DataIntegrationDetail: 'รายละเอียดการเชื่อมต่อข้อมูล',
    'Generate Question Set': 'สร้างชุดคำถาม',
    'Intent Session Detail': 'รายละเอียดชุดอินเทนต์',
    'Prompt Template Detail': 'รายละเอียดเทมเพลตพรอมต์',
    'Add Text Group': 'เพิ่มกลุ่มข้อความ',
    'Upload Positive Question Set': 'อัปโหลดชุดคำถามเชิงบวก',
    'Dashboard score': 'แดชบอร์ดคะแนน',
    'API External Log': 'บันทึกเอพีไอภายนอก',
    _uploadCSVVector: 'อัปโหลดไฟล์ซีเอสวีเวกเตอร์',
    configTheme: 'ตั้งค่าธีม',
    loginAuthentik: 'เข้าสู่ระบบด้วยออเทนทิก',
    _GroupUserManagement: 'การจัดการกลุ่มผู้ใช้',
    groupPromptName: 'ชื่อกลุ่มเทมเพลตพรอมต์',
    modelGroup: 'กลุ่มโมเดล',
    _UserGroupDetail: 'รายละเอียดกลุ่มผู้ใช้',
    _SetupUserGroup: 'ตั้งค่ากลุ่มผู้ใช้',
    action: 'การดำเนินการ',
    groupObjectID: 'รหัสออบเจ็กต์กลุ่ม',
    fullName: 'ชื่อ-นามสกุล',
    loginLine: 'เข้าสู่ระบบด้วยไลน์',
    statusSync: 'สถานะซิงก์',
    _BlacklistChatUserManagement: 'การจัดการบัญชีดำผู้ใช้แชท',
    _InvitationManagement: 'จัดการคำเชิญ',
    _SendInvitation: 'ส่งคำเชิญ',
    _username: 'ชื่อผู้ใช้',
    _userid: 'รหัสผู้ใช้',
    _date: 'วันที่',
    _FileManagement: 'การจัดการไฟล์',
    confirmToSetDefault: 'ยืนยันตั้งค่าเริ่มต้น',
    infoconfirmToSetDefault: 'คุณต้องการยืนยันการตั้งค่าธีมเริ่มต้นหรือไม่?',
    headerLogo: 'โลโก้ส่วนหัว',
    background: 'พื้นหลัง',
    _LockStatus: 'สถานะล็อก',
    _Locked: 'ล็อก',
    _Unlocked: 'ปลดล็อก',
    _Connection_failed: 'การเชื่อมต่อล้มเหลว โปรดตรวจสอบอินเทอร์เน็ตของคุณ',
    _Please_check_internet: 'โปรดตรวจสอบอินเทอร์เน็ตของคุณ',
    _Operator: 'ผู้ดำเนินการ',
    _Please_Question: 'กรุณาระบุคำถาม',
    _HumanAnswer: 'คำตอบของมนุษย์',
    _Reprocess: 'คุณต้องการประมวลผลใหม่',
    'Upload Sound To Document': 'อัปโหลดเสียงเป็นเอกสาร',
    'Positive Question set': 'ชุดคำถามเชิงบวก',
    'Model Quick Reply': 'โมเดลตอบกลับด่วน',
    Logs: 'ล็อก',
    'Report Feedback': 'รายงานฟีดแบ็ก',
    ShortcutCommands: 'คำสั่งทางลัด',
    shortcutMenu: 'เมนูทางลัด',
    usermanual: 'คู่มือผู้ใช้',
    releasesnotes: 'บันทึกการเปลี่ยนแปลงรุ่น',
    backtosuperadmin: 'กลับซูเปอร์แอดมิน',

    alreadyPublishedModel: 'โมเดลนี้เผยแพร่อยู่แล้ว',
    gotIt: 'เข้าใจแล้ว',
    'Event Log': 'อีเวนต์ล็อก',
    _ReasoningEffort: 'ใช้การกำหนดระดับความพยายามในการใช้เหตุผล',
    _EndPointURL: 'ยูอาร์แอลเอนด์พอยต์',
    _WarningJSONFormat: 'กรอกข้อมูลในรูปแบบเจสัน',
    _API_Key: 'API Key',
    warningReasoningEffort: 'กรุณาเลือกการกำหนดค่าระดับการใช้เหตุผล',
    publish: 'เผยแพร่',
    success: 'สำเร็จ',
    restoreVersion: 'กู้คืนเวอร์ชัน',
    latest: 'ล่าสุด',
    logEvent: 'อีเวนต์ล็อก',
    log_menagement: 'การจัดการบันทึก',
    dateRange: 'ช่วงวันที่',
    Filters: 'ตัวกรอง',
    search: 'ค้นหา',
    PositiveQuestionSet: 'ชุดคำถามเชิงบวก',
    Result: 'ผลลัพธ์',
    ClearAll: 'ล้างทั้งหมด',
    Download: 'ดาวน์โหลด',
    AdvancedFilters: 'ตัวกรองขั้นสูง',
    ClearFilters: 'ล้างตัวกรอง',
    textValidateGroupName: 'มีชื่อกลุ่มนี้อยู่แล้ว กรุณากรอกชื่อกลุ่มใหม่',
    _inv_recipient_email: 'อีเมลผู้รับเชิญ',
    _inv_status: 'สถานะ',
    _inv_send_date: 'วันที่ส่ง',
    _inv_expire_date: 'หมดอายุ',
    _inv_used_date: 'วันที่ใช้งาน',
    _inv_registered_by: 'ผู้ลงทะเบียน',
    _inv_user_deleted: 'ถูกลบ',
    _inv_status_used_deleted: 'ใช้แล้ว (ผู้ใช้ถูกลบ)',
    _inv_status_used_deleted_hint: 'ผู้ใช้คนนี้ลงทะเบียนด้วยคำเชิญนี้แล้ว แต่ภายหลังถูกลบออกจากระบบ — สามารถส่งคำเชิญใหม่ได้',
    _inv_status_used_unlinked: 'ต้องเชื่อมเอสเอสโอใหม่',
    _inv_status_used_unlinked_hint: 'ผู้ใช้ยังอยู่ในระบบ แต่ไม่มีการผูกไทยดีหรือดีจีเอ — กรุณาส่งคำเชิญใหม่เพื่อให้ผู้ใช้ผูกเอสเอสโออีกครั้ง',
    _inv_status_used_dga_taken: 'ใช้แล้ว (ดีจีเอถูกใช้กับบัญชีอื่น)',
    _inv_status_used_dga_taken_hint: 'ดีจีเอหรือไทยดีของผู้ใช้คนนี้ปัจจุบันถูกผูกกับบัญชี {email} — ผู้ใช้จะลงทะเบียนใหม่ไม่ได้จนกว่าเจ้าของปัจจุบันจะยกเลิกการผูกก่อน',
    _inv_status_pending: 'รอดำเนินการ',
    _inv_status_used: 'ใช้แล้ว',
    _inv_status_expired: 'หมดอายุ',
    _inv_status_revoked: 'ถูกเพิกถอน',
    _inv_reinvite_blocked_dga_taken: 'ดีจีเอถูกใช้กับบัญชีอื่นอยู่ — กรุณาให้เจ้าของปัจจุบันยกเลิกการผูกก่อน',
    _no_access_sso_owned_by_other_title: 'ดีจีเอหรือไทยดีนี้ถูกใช้กับบัญชีอื่นแล้ว',
    _no_access_sso_owned_by_other_msg: 'หมายเลขดีจีเอหรือไทยดีที่ท่านใช้ลงทะเบียนปัจจุบันผูกอยู่กับบัญชีอื่นแล้ว กรุณาติดต่อผู้ดูแลระบบเพื่อตรวจสอบ หรือให้เจ้าของบัญชีปัจจุบันยกเลิกการผูกก่อน',
    _inv_reinvite: 'ส่งคำเชิญใหม่',
    _inv_reinvite_short: 'เชื่อมใหม่',
    _inv_reinvite_success: 'ส่งคำเชิญใหม่เรียบร้อยแล้ว',
    _inv_reinvite_pending_exists: 'มีคำเชิญที่รอดำเนินการอยู่แล้ว กรุณายกเลิกคำเชิญเดิมก่อน',
    _inv_reinvite_fail: 'ไม่สามารถส่งคำเชิญใหม่ได้',
    _inv_resend: 'ส่งซ้ำ',
    _inv_revoke: 'ยกเลิกคำเชิญ',
    _inv_recipient_info: 'ข้อมูลผู้รับเชิญ',
    _inv_permission_usage: 'สิทธิ์การใช้งาน',
    _inv_expire_in: 'หมดอายุใน',
    _inv_email_hint: 'พิมพ์อีเมลแล้วกดเอนเทอร์เพื่อเพิ่ม สามารถใส่ได้หลายรายการ',
    _inv_invalid_emails: 'อีเมลไม่ถูกต้อง',
    _inv_dialog_subtitle: 'ส่งคำเชิญให้ผู้ใช้ใหม่',
    _inv_send_success: 'ส่งคำเชิญสำเร็จ',
    _inv_items: 'รายการ',
    _inv_send_mixed: 'ส่งสำเร็จ',
    _inv_sent_label: 'ส่งแล้ว',
    _inv_pending_exists: 'มีคำเชิญที่รอดำเนินการแล้ว',
    _inv_already_registered: 'ลงทะเบียนแล้ว',
    _inv_failed_label: 'ล้มเหลว',
    _inv_send_fail: 'ไม่สามารถส่งคำเชิญได้ กรุณาลองใหม่',
    _inv_resend_success: 'ส่งอีเมลซ้ำเรียบร้อยแล้ว',
    _inv_resend_fail: 'ไม่สามารถส่งอีเมลซ้ำได้',
    _inv_revoke_confirm: 'ยืนยันการยกเลิกคำเชิญสำหรับ',
    _inv_revoke_confirm_title: 'ยืนยันการยกเลิกคำเชิญ',
    _inv_revoke_confirm_message: 'คุณต้องการยกเลิกคำเชิญสำหรับ {email} ใช่หรือไม่?',
    _inv_revoke_confirm_button: 'ตกลง',
    _inv_revoke_success: 'ยกเลิกคำเชิญเรียบร้อยแล้ว',
    _inv_revoke_fail: 'ไม่สามารถยกเลิกคำเชิญได้',
    _inv_load_fail: 'ไม่สามารถโหลดรายการได้',
    _inv_days: 'วัน',
    _inv_valid_min_email: 'กรุณาระบุอีเมลอย่างน้อย 1 รายการ',
    _register_invite_title: 'ลงทะเบียนเข้าใช้งาน',
    _register_invite_subtitle: 'ยืนยันตัวตนเพื่อเปิดใช้งานบัญชี',
    _register_invite_loading: 'กำลังตรวจสอบคำเชิญ...',
    _register_back_login: 'กลับหน้าเข้าสู่ระบบ',
    _register_invited_email: 'อีเมลที่ได้รับเชิญ',
    _register_invited_org: 'หน่วยงาน',
    _register_invited_role: 'สิทธิ์การใช้งาน',
    _register_invited_expire: 'หมดอายุ',
    _register_with_dga: 'ยืนยันตัวตนด้วยดีจีเอ ดิจิทัล ไอดี',
    _register_with_thaid: 'ยืนยันตัวตนด้วยไทยดี',
    _register_no_sso: 'ยังไม่มีช่องทางยืนยันตัวตนที่เปิดใช้งาน กรุณาติดต่อผู้ดูแลระบบ',
    _register_invite_identity_hint: 'ระบบจะเชื่อมโยงตัวตนที่ยืนยันกับคำเชิญนี้',
    _register_invite_validate_error: 'ไม่สามารถตรวจสอบคำเชิญได้ กรุณาลองใหม่อีกครั้ง',
    _register_invite_expired: 'ลิงก์ลงทะเบียนหมดอายุแล้ว กรุณาติดต่อแอดมินเพื่อขอรับลิงก์ใหม่',
    _register_invite_used: 'ลิงก์นี้ถูกใช้งานแล้ว หากท่านลงทะเบียนแล้ว ลองเข้าสู่ระบบได้เลย',
    _register_invite_revoked: 'ลิงก์นี้ถูกยกเลิกแล้ว กรุณาติดต่อแอดมิน',
    _register_invite_not_found: 'ไม่พบลิงก์คำเชิญนี้ในระบบ',
    _register_invite_invalid: 'ลิงก์ไม่ถูกต้อง กรุณาตรวจสอบลิงก์ที่ได้รับจากอีเมล',
    _register_invite_missing: 'ไม่พบโทเค็นคำเชิญ กรุณาตรวจสอบลิงก์ที่ได้รับจากอีเมล',
    _register_invite_unknown: 'เกิดข้อผิดพลาด กรุณาติดต่อแอดมิน',
    refresh: 'รีเฟรช',
    _LLMManagement_NAV: 'การจัดการแอลแอลเอ็ม',
    _sa_nav_dashboard: 'แดชบอร์ด',
    _sa_nav_companies: 'การจัดการหน่วยงาน',
    _sa_nav_workgroups: 'การจัดกลุ่มทำงาน',
    _sa_nav_org_structure: 'โครงสร้างองค์กร',
    _sa_nav_users: 'ผู้ใช้',
    _sa_nav_sales: 'จุดติดต่อ',
    _sa_nav_setting: 'ตั้งค่า',
    _sa_nav_core_config: 'การตั้งค่าระบบ',
    _sa_nav_persona_api: 'ตั้งค่า Persona API',
    gdxConnectionCacheHint: 'ผู้ให้บริการนี้ใช้เฉพาะสวัสดิการ/จีดีเอ็กซ์เท่านั้น (ฮอตรีโหลด) สถานะเรดิสด้านล่างหมายถึงแบ็กเอนด์เชื่อมต่อและเขียนคีย์ตรวจสุขภาพได้ การ์ดสวัสดิการจะเขียนเรดิสเมื่อกระบวนการบันทึกคำถามสวัสดิการทำงานและเปิดแคชอยู่ ส่วนการโต้ตอบของการ์ดบันทึกลงล็อกเอสคิวแอล',
    gdxRedisChipPrefix: 'เรดิส',
    gdxRedisConnectable: 'เชื่อมต่อได้',
    gdxRedisConnectableCacheOff: 'เชื่อมต่อได้ · ปิดสวิตช์แคช',
    gdxRedisNotConnectable: 'เชื่อมต่อไม่ได้',
    gdxRedisNotConfigured: 'ยังไม่ได้ตั้งค่า',
    gdxCredentialSourceLabel: 'แหล่งที่มาของข้อมูลรับรอง',
    gdxKeyVaultSecretPrefix: 'พรีฟิกซ์ซีเคร็ตในคีย์วอลต์',
    gdxCredentialTitle: 'ข้อมูลรับรองจีดีเอ็กซ์ (ค่าจริง)',
    gdxCredentialModeHint: 'ตั้งค่าพรีฟิกซ์แล้วเว้น 3 ช่องข้อมูลรับรองว่าง = ใช้คีย์วอลต์และล้างค่าแทนที่ในฐานข้อมูลตอนบันทึก; ถ้ากรอกช่องใดช่องหนึ่ง = ใช้ค่าแทนที่จากการตั้งค่าฐานข้อมูล (สำหรับพัฒนา/กรอกเอง) มีผลทันทีหลังฮอตรีโหลด',
    gdxCredentialChipPrefix: 'ข้อมูลรับรอง',
    gdxKeyVaultSecretsChip: 'ซีเคร็ตในคีย์วอลต์',
    gdxCredentialSourceKeyVault: 'คีย์วอลต์',
    gdxCredentialSourceDbsettings: 'การตั้งค่าฐานข้อมูล',
    gdxCredentialSourceError: 'ข้อผิดพลาด',
    gdxCredentialSourceNone: 'ไม่มี',
    gdxCredentialPrefixHint: 'เช่น จีดีเอ็กซ์ → GDX-ConsumerKey, GDX-ConsumerSecret, GDX-AgentId',
    nexaApiKeyVaultPrefix: 'พรีฟิกซ์ซีเคร็ตในคีย์วอลต์',
    nexaApiKeyVaultPrefixPlaceholder: 'เน็กซา',
    nexaApiKeyVaultPrefixHint: 'พรีฟิกซ์สำหรับซีเคร็ตคีย์เอพีไอของเน็กซา ในสภาพแวดล้อมที่ยังใช้พรีฟิกซ์คีย์วอลต์',
    _sa_nav_consent_config: 'ข้อกำหนดและเงื่อนไข',
    _sa_nav_llm: 'การจัดการแอลแอลเอ็ม',
    _sa_nav_llm_groups: 'กลุ่ม LLM',
    _llmgroup_title: 'จัดการกลุ่ม LLM',
    _llmgroup_subtitle: 'จัดสรรโมเดล LLM ให้แต่ละหน่วยงานผ่านกลุ่ม',
    _llmgroup_tab_groups: 'กลุ่ม',
    _llmgroup_tab_assign: 'จัดสรรให้หน่วยงาน',
    _llmgroup_assign_readonly_hint: 'การจัดสรรย้ายไปทำที่หน้าต่างแก้ไขกลุ่มแล้ว (เพิ่มบริษัทเข้ากลุ่มได้หลายตัวพร้อมกัน) — แท็บนี้แสดงภาพรวมอย่างเดียว',
    _llmgroup_tab_drift: 'คอนฟิกนอกกลุ่ม',
    _llmgroup_add: 'กลุ่มใหม่',
    _llmgroup_edit_title: 'แก้ไขกลุ่ม LLM',
    _llmgroup_add_title: 'สร้างกลุ่ม LLM',
    _llmgroup_col_name: 'ชื่อกลุ่ม',
    _llmgroup_col_members: 'จำนวนโมเดล',
    _llmgroup_col_assigned: 'จำนวนหน่วยงานที่ใช้',
    _llmgroup_col_default: 'ค่าเริ่มต้น',
    _llmgroup_col_actions: 'จัดการ',
    _llmgroup_members: 'โมเดลในกลุ่ม',
    _llmgroup_default: 'กลุ่มเริ่มต้น',
    _llmgroup_default_model: 'โมเดลเริ่มต้นของกลุ่ม',
    _llmgroup_set_default: 'ตั้งเป็นกลุ่มเริ่มต้น',
    _llmgroup_is_default_chip: 'เริ่มต้น',
    _llmgroup_field_name: 'ชื่อกลุ่ม',
    _llmgroup_field_members: 'เลือกโมเดลในกลุ่ม',
    _llmgroup_field_default_model: 'เลือกโมเดลเริ่มต้น',
    _llmgroup_field_companies: 'บริษัทในกลุ่มนี้',
    _llmgroup_field_companies_hint: 'เพิ่มบริษัทเข้ากลุ่มได้หลายบริษัทพร้อมกัน — บริษัทที่เอาออกจะกลับไปใช้กลุ่ม Default',
    _llmgroup_required: 'กรุณากรอกข้อมูลนี้',
    _llmgroup_confirm_delete: 'ยืนยันการลบกลุ่มนี้?',
    _llmgroup_delete_blocked_assigned: 'ไม่สามารถลบได้ เนื่องจากมีหน่วยงานผูกกลุ่มนี้อยู่',
    _llmgroup_delete_blocked_default: 'ไม่สามารถลบกลุ่มเริ่มต้นได้',
    _llmgroup_success: 'บันทึกสำเร็จ',
    _llmgroup_assign: 'จัดสรรให้หน่วยงาน',
    _llmgroup_assign_col_company: 'หน่วยงาน',
    _llmgroup_assign_col_group: 'กลุ่มปัจจุบัน',
    _llmgroup_assign_group_placeholder: 'เลือกกลุ่ม',
    _llmgroup_assign_default_unset: 'เริ่มต้น (ยังไม่ได้ตั้งค่า)',
    _llmgroup_assign_success: 'จัดสรรกลุ่มสำเร็จ',
    _llmgroup_drift: 'คอนฟิกนอกกลุ่ม',
    _llmgroup_drift_col_model: 'โมเดล',
    _llmgroup_drift_col_company: 'หน่วยงาน',
    _llmgroup_drift_col_status: 'สถานะ',
    _llmgroup_drift_status_in_group: 'อยู่ในกลุ่ม',
    _llmgroup_drift_status_out_of_group: 'นอกกลุ่ม',
    _llmgroup_drift_status_orphan: 'ไม่พบในแคตตาล็อก',
    _llmgroup_remediate: 'แก้ไข',
    _llmgroup_remediate_reassign: 'กำหนดเป็นโมเดลเริ่มต้นของกลุ่ม',
    _llmgroup_remediate_disable: 'ปิดใช้งานโมเดลนี้',
    _llmgroup_remediate_confirm: 'ยืนยันการแก้ไขคอนฟิกนี้?',
    _llmgroup_remediate_success: 'แก้ไขคอนฟิกสำเร็จ',
    _llmgroup_model_not_allowed: 'โมเดลนี้ไม่อยู่ในกลุ่มที่หน่วยงานได้รับอนุญาต',
    _llmgroup_model_out_of_group: 'ไม่มีสิทธิ์ใช้งาน',
    _llmgroup_model_out_of_group_tip: 'โมเดลนี้ใช้ LLM ที่อยู่นอกกลุ่มที่หน่วยงานได้รับอนุญาต — จะถูกบล็อกหรือสลับเป็นโมเดลเริ่มต้นของกลุ่มตอนใช้งานจริง',
    _llmgroup_model_out_of_group_banner: 'โมเดลนี้ใช้ LLM ที่หน่วยงานไม่มีสิทธิ์ใช้งานแล้ว — กรุณาเปลี่ยนเป็นโมเดลที่อยู่ในกลุ่มที่ได้รับอนุญาต',
    _llmgroup_company_field_label: 'กลุ่ม LLM',
    _llmgroup_company_field_default_option: 'ค่าเริ่มต้น (ยังไม่กำหนดกลุ่ม)',
    _sa_nav_subscriptions: 'การจัดการสมัครสมาชิก',
    _sa_nav_packages: 'การจัดการแพ็กเกจ',
    _sa_nav_event_logs: 'อีเวนต์ล็อก',
    _sa_nav_inv_mgmt: 'จัดการคำเชิญ',
    _sa_nav_landing_page: 'แลนดิ้งเพจ',
    _sa_nav_release_notes: 'บันทึกการเปลี่ยนแปลงรุ่น',
    _sa_nav_documents: 'เอกสาร',
    _sa_doc_title: 'จัดการเอกสาร',
    _sa_doc_subtitle: 'จัดการเอกสารความรู้ของทุกบริษัทในระบบ',
    _sa_doc_col_name: 'ชื่อเอกสาร',
    _sa_doc_col_company: 'บริษัท',
    _sa_doc_col_createby: 'สร้างโดย',
    _sa_doc_col_process: 'สถานะประมวลผล',
    _sa_doc_search_name: 'ค้นหาชื่อเอกสาร',
    _sa_doc_filter_company: 'กรองตามบริษัท',
    _sa_doc_all_companies: 'ทุกบริษัท',
    _sa_doc_add: 'เพิ่มเอกสาร',
    _sa_doc_add_title: 'เพิ่มเอกสารใหม่',
    _sa_doc_field_company: 'บริษัทปลายทาง',
    _sa_doc_field_name: 'ชื่อเอกสาร',
    _sa_doc_field_process_type: 'วิธีประมวลผล',
    _sa_doc_field_maxchar: 'จำนวนตัวอักษรสูงสุดต่อชังก์',
    _sa_doc_field_custom_char: 'ตัวอักษรแบ่งแบบกำหนดเอง',
    _sa_doc_field_detect_lang: 'ตรวจจับภาษาอัตโนมัติ',
    _sa_doc_field_personal_info: 'ตรวจจับข้อมูลส่วนบุคคล',
    _sa_doc_field_file: 'ไฟล์เอกสาร',
    _sa_doc_view: 'ดู',
    _sa_doc_share: 'แชร์',
    _sa_doc_detail_title: 'รายละเอียดเอกสาร',
    _sa_doc_chunk_no: 'ลำดับ',
    _sa_doc_chunk_org: 'ข้อความต้นฉบับ',
    _sa_doc_chunk_en: 'ข้อความภาษาอังกฤษ',
    _sa_doc_chunk_status: 'สถานะ',
    _sa_doc_required: 'กรุณากรอกข้อมูลให้ครบ',
    _sa_doc_upload_success: 'เพิ่มเอกสารสำเร็จ',
    _sa_doc_no_file: 'กรุณาเลือกไฟล์',
    _sa_doc_drag_drop: 'ลากไฟล์มาวางที่นี่ หรือคลิกเพื่อเลือก',
    _sa_doc_drop_here: 'วางไฟล์ที่นี่',
    _sa_doc_click_browse: 'คลิกเพื่อเลือกไฟล์',
    _sa_doc_select_doctype_first: 'เลือกประเภทเอกสารก่อน',
    _sa_doc_invalid_file_type: 'ชนิดไฟล์ไม่ตรงกับประเภทเอกสารที่เลือก',
    _sa_doc_upload_file: 'อัปโหลดไฟล์',
    _sa_doc_upload_mode_label: 'เลือกวิธีการอัปโหลด',
    _sa_doc_add_mode: 'เพิ่มเข้าไป (คงเนื้อหาเดิม)',
    _sa_doc_replace_mode: 'แทนที่ทั้งหมด',
    _sa_doc_replace_warning: 'การแทนที่จะลบเนื้อหาเดิมทั้งหมดก่อน แล้วนำเข้าจากไฟล์ใหม่',
    _sa_doc_change_file: 'เปลี่ยนไฟล์',
    _sa_doc_remove_file: 'ลบ',
    _sa_doc_back: 'ย้อนกลับ',
    _sa_doc_add_chunk: 'เพิ่มเนื้อหา',
    _sa_doc_edit_chunk: 'แก้ไขเนื้อหา',
    _sa_doc_chunk_content: 'เนื้อหา',
    _sa_doc_reprocess: 'ประมวลผลใหม่',
    _sa_doc_delete: 'ลบ',
    _sa_doc_delete_all: 'ลบทั้งหมด',
    _sa_doc_actions: 'จัดการ',
    _sa_doc_confirm_delete_chunk: 'ยืนยันการลบเนื้อหานี้?',
    _sa_doc_confirm_delete_doc: 'ยืนยันการลบเอกสารทั้งหมด?',
    _sa_doc_confirm_reprocess: 'ยืนยันการประมวลผลเอกสารใหม่?',
    _sa_doc_personal_info: 'ข้อมูลส่วนบุคคล',
    _sa_doc_success: 'สำเร็จ',
    _sa_doc_active: 'เปิดใช้งาน',
    _sa_doc_inactive: 'ไม่ใช้งาน',
    _sa_doc_duplicate: 'ทำสำเนา',
    _sa_doc_replace: 'แทนที่',
    _sa_doc_version_history: 'ประวัติเวอร์ชัน',
    _sa_doc_download: 'ดาวน์โหลด',
    _sa_doc_duplicate_title: 'ทำสำเนาเอกสาร',
    _sa_doc_new_name: 'ชื่อเอกสารใหม่',
    _sa_doc_replace_title: 'แทนที่เอกสาร',
    _sa_doc_replace_target: 'เลือกเอกสารปลายทางที่จะถูกแทนที่',
    _sa_doc_version: 'เวอร์ชัน',
    _sa_doc_modified: 'แก้ไขล่าสุด',
    _sa_doc_modified_by: 'แก้ไขโดย',
    _sa_doc_restore: 'กู้คืน',
    _sa_doc_view_version_title: 'ดูข้อมูลเวอร์ชัน',
    _sa_doc_confirm_restore: 'ยืนยันการกู้คืนเวอร์ชันนี้?',
    _sa_doc_duplicate_success: 'ทำสำเนาสำเร็จ',
    _rn_page_title: 'จัดการบันทึกการเปลี่ยนแปลงรุ่น',
    _rn_page_subtitle: 'สร้างและจัดการบันทึกการเปลี่ยนแปลงรุ่นสำหรับระบบ',
    _rn_new: 'บันทึกการเปลี่ยนแปลงรุ่นใหม่',
    _rn_col_version: 'เวอร์ชัน',
    _rn_col_title: 'ชื่อ',
    _rn_col_target_system: 'ระบบ',
    _rn_col_status: 'สถานะ',
    _rn_col_release_date: 'วันที่ปล่อย',
    _rn_col_items: 'รายการ',
    _rn_col_published_at: 'เผยแพร่เมื่อ',
    _rn_col_actions: 'การดำเนินการ',
    _rn_filter_all_systems: 'ทุกระบบ',
    _rn_status_draft: 'แบบร่าง',
    _rn_status_published: 'เผยแพร่แล้ว',
    _rn_status_archived: 'เก็บถาวร',
    _rn_cat_feature: 'ฟีเจอร์',
    _rn_cat_bugfix: 'แก้ไขข้อผิดพลาด',
    _rn_cat_improvement: 'ปรับปรุง',
    _rn_cat_external_api: 'API ภายนอก',
    _rn_item_connector: 'ตัวเชื่อมต่อ',
    _rn_item_api_version: 'เวอร์ชัน API',
    _rn_validation_required_connector: 'กรุณาเลือกคอนเน็กเตอร์',
    _rn_validation_required_api_version: 'กรุณาเลือกเวอร์ชันเอพีไอ',
    _rn_sys_product_admin: 'โปรดักต์แอดมิน',
    _rn_sys_chat_framework: 'แชทเฟรมเวิร์ก',
    _rn_sys_both: 'ทั้งสองระบบ',
    _rn_field_version: 'เวอร์ชัน',
    _rn_field_title: 'ชื่อบันทึกการเปลี่ยนแปลงรุ่น',
    _rn_field_summary: 'สรุป',
    _rn_field_release_date: 'วันที่ปล่อย',
    _rn_field_target_system: 'ระบบเป้าหมาย',
    _rn_items_section: 'รายการเปลี่ยนแปลง',
    _rn_item_category: 'ประเภท',
    _rn_item_detail: 'รายละเอียด',
    _rn_add_item: 'เพิ่มรายการ',
    _rn_move_up: 'เลื่อนขึ้น',
    _rn_move_down: 'เลื่อนลง',
    _rn_dialog_create: 'สร้างบันทึกการเปลี่ยนแปลงรุ่น',
    _rn_dialog_edit: 'แก้ไขบันทึกการเปลี่ยนแปลงรุ่น',
    _rn_confirm_publish: 'ต้องการเผยแพร่บันทึกการเปลี่ยนแปลงรุ่นนี้หรือไม่?',
    _rn_confirm_publish_title: 'ยืนยันการเผยแพร่',
    _rn_confirm_delete: 'ต้องการลบบันทึกการเปลี่ยนแปลงรุ่นนี้หรือไม่?',
    _rn_confirm_delete_title: 'ยืนยันการลบ',
    _rn_success_create: 'สร้างบันทึกการเปลี่ยนแปลงรุ่นสำเร็จ',
    _rn_success_update: 'อัปเดตบันทึกการเปลี่ยนแปลงรุ่นสำเร็จ',
    _rn_success_publish: 'เผยแพร่บันทึกการเปลี่ยนแปลงรุ่นสำเร็จ',
    _rn_success_delete: 'ลบบันทึกการเปลี่ยนแปลงรุ่นสำเร็จ',
    _rn_error_load: 'โหลดบันทึกการเปลี่ยนแปลงรุ่นไม่สำเร็จ',
    _rn_no_data: 'ไม่มีบันทึกการเปลี่ยนแปลงรุ่น',
    _rn_validation_required_version: 'กรุณากรอกเวอร์ชัน',
    _rn_validation_required_title: 'กรุณากรอกชื่อบันทึกการเปลี่ยนแปลงรุ่น',
    _rn_validation_required_release_date: 'กรุณาเลือกวันที่ปล่อย',
    _rn_validation_required_target_system: 'กรุณาเลือกระบบเป้าหมาย',
    _rn_validation_max_version: 'เวอร์ชันต้องไม่เกิน 20 ตัวอักษร',
    _rn_validation_max_title: 'ชื่อต้องไม่เกิน 200 ตัวอักษร',
    _rn_validation_items_required: 'กรุณาเพิ่มรายการเปลี่ยนแปลงอย่างน้อย 1 รายการ',
    _rn_validation_item_detail_required: 'กรุณากรอกรายละเอียดของรายการนี้',
    _noti_title: 'การแจ้งเตือน',
    _noti_mark_all_read: 'อ่านทั้งหมด',
    _noti_empty: 'ไม่มีการแจ้งเตือน',
    _noti_view_all: 'ดูทั้งหมด',
    _noti_just_now: 'เมื่อกี้',
    _noti_minutes_ago: '{n} นาทีที่แล้ว',
    _noti_hours_ago: '{n} ชั่วโมงที่แล้ว',
    _noti_history_subtitle: 'ประวัติการแจ้งเตือนทั้งหมด',
    _noti_type: 'ประเภท',
    _noti_level: 'ระดับ',
    _noti_mark_read: 'ทำเครื่องหมายว่าอ่านแล้ว',
    _noti_go_to: 'ไปที่',
    _noti_col_level: 'ระดับ',
    _noti_col_type: 'ประเภท',
    _noti_col_title: 'รายละเอียด',
    _noti_col_read: 'อ่านแล้ว',
    _noti_col_date: 'วันที่',
    reset: 'รีเซ็ต',
    _sa_inv_mgmt: 'จัดการคำเชิญซูเปอร์แอดมิน',
    _sa_inv_page_title: 'จัดการคำเชิญซูเปอร์แอดมิน',
    _sa_inv_page_subtitle: 'ส่งคำเชิญให้ผู้ใช้เข้าร่วมในฐานะซูเปอร์แอดมิน',
    _sa_portal: 'ผู้ดูแลระบบสูงสุด',
    _sa_companies_subtitle: 'จัดการองค์กรทั้งหมดในระบบ',
    _sa_workgroups_subtitle: 'จัดการโครงสร้างองค์กร',
    _sa_users_subtitle: 'จัดการผู้ใช้งาน ทั้งหมดในระบบ',
    _sa_sales_subtitle: 'จัดการจุดติดต่อทั้งหมดในระบบ',
    _sa_sales_search_placeholder: 'ค้นหาชื่อ, อีเมล...',
    _sa_sales_staff_section: 'จุดติดต่อ',
    _sa_sales_organization: 'หน่วยงาน',
    _sa_admin_contact: 'ผู้ติดต่อผู้ดูแลระบบ',
    _sa_packages_subtitle: 'จัดการแพ็กเกจทั้งหมดในระบบ',
    _sa_event_logs_subtitle: 'ตรวจสอบอีเวนต์ล็อกการใช้งานเอพีไอในระบบ',
    _sa_core_config_subtitle: 'ตั้งค่าระบบหลักสำหรับจีพีที บล็อบ อีเมล และอื่นๆ',
    _sa_consent_config_subtitle: 'จัดการข้อความข้อกำหนดและเงื่อนไข ภาษาไทย / อังกฤษ',
    consentAudienceBackend: 'สำหรับหน่วยงาน (Back Office)',
    consentAudienceFrontend: 'สำหรับผู้ใช้บริการ',
    consentAudiencePrivacy: 'นโยบายความเป็นส่วนตัว',
    consentAudienceSnippet: 'เงื่อนไขให้บริการ (Snippet)',
    consentUnsavedWarn: 'มีการแก้ไขที่ยังไม่บันทึก หากดำเนินการต่อ การแก้ไขจะถูกยกเลิก',
    termsDialogTitle: 'ข้อกำหนดและเงื่อนไข',
    termsDialogAccept: 'ยอมรับเงื่อนไข',
    termsDialogDecline: 'ปฏิเสธ',
    termsDialogEnPending: 'ฉบับภาษาอังกฤษอยู่ระหว่างจัดทำ',
    termsDialogLoading: 'กำลังโหลดข้อกำหนดและเงื่อนไข...',
    termsDialogError: 'ไม่สามารถโหลดข้อกำหนดและเงื่อนไขได้ กรุณาลองใหม่อีกครั้ง',
    termsDialogRetry: 'ลองใหม่',
    termsDialogClose: 'ปิด',
    // หัวข้อ dialog ฝั่ง backend (หน่วยงานรัฐ) — 2 ท่อนตาม Figma dialog 2070:44239 / 2070:44567
    termsDialogTitleBackend: 'ข้อกำหนดและเงื่อนไขการขอใช้บริการ Ask AI\nระบบบริการค้นหาข้อมูลด้วยเทคโนโลยีปัญญาประดิษฐ์(Ask AI) (สำหรับหน่วยงานรัฐ)',
    privacyDialogTitleBackend: 'บริการค้นหาข้อมูลด้วยเทคโนโลยีปัญญาประดิษฐ์(Ask AI) (สำหรับหน่วยงานรัฐ)',
    _sa_new_company: 'สร้างบริษัท',
    _sa_new_user: 'สร้างผู้ใช้',
    _sa_new_sale: 'เพิ่มจุดติดต่อ',
    _sa_new_package: 'สร้างแพ็กเกจ',
    _sa_add_subscription: 'เพิ่มแพ็กเกจสมัครใช้งาน',
    _sa_change_password: 'เปลี่ยนรหัสผ่าน',
    _sa_new_password: 'รหัสผ่านใหม่',
    _sa_no_data: 'ไม่พบข้อมูล',
    _sa_no_data_desc: 'ลองปรับตัวกรองหรือเพิ่มข้อมูลใหม่',
    _sa_no_results: 'ไม่พบผลลัพธ์',
    _sa_ds_gallery_title: 'Design System Gallery',
    _portal_ds_gallery_title: 'Portal Design System Gallery',
    loading: 'กำลังโหลด',
    _sa_inv_title: 'ส่งคำเชิญ',
    _sa_inv_emails: 'อีเมลผู้รับ',
    _sa_inv_emailHint: 'พิมพ์อีเมลแล้วกดเอนเทอร์',
    _sa_inv_company: 'บริษัท',
    _sa_inv_role: 'บทบาท',
    _sa_inv_expireDays: 'วันหมดอายุ',
    _sa_inv_send: 'ส่งคำเชิญ',
    _sa_inv_success: 'ส่งคำเชิญสำเร็จ',
    _sa_inv_btnLabel: 'คำเชิญ',
    _sa_add_endpoint: 'เพิ่มเอนด์พอยต์',
    _sa_login_config: 'ตั้งค่าการเข้าสู่ระบบ',
    _sa_enable_username_password_login: 'เปิดใช้งาน Username / Password',
    _sa_login_config_hint: 'เปิดเพื่อแสดงฟอร์ม Company Code / Username / Password บนหน้าเข้าสู่ระบบ',
    loginConfigNoMethodError: 'ปิด Username/Password ไม่ได้ เพราะไม่มีช่องทาง SSO เปิดอยู่ — ระบบจะไม่มีทางเข้าสู่ระบบ',
    _sa_payment_history: 'ประวัติการชำระเงิน',
    _sa_history_date: 'วันที่',
    _sa_history_action: 'การดำเนินการ',
    _sa_history_amount: 'จำนวนเงิน',
    _sa_history_note: 'หมายเหตุ',
    _sa_subscription_tier_project: 'โครงการ',
    _sa_subscription_tier_ministry: 'หน่วยงาน',
    _sa_subscription_tier_new: 'ใหม่',
    _sa_subscription_project_summary: 'ภาพรวมการใช้โทเค็นรวมจากแพ็กเกจสมัครใช้งานระดับกระทรวงทั้งหมด',
    _sa_subscription_ministry_count: '{n} กระทรวง',
    _sa_subscription_project_token_usage: 'โทเค็นโครงการที่ใช้แล้ว',
    _sa_subscription_project_token_usage_tip: 'ยอดสะสมทั้งหมดที่นับเข้าโควต้าแพ็กเกจสมัครใช้งาน (รวมทุกแพ็กเกจระดับกระทรวง) — เป็นยอดสะสมตั้งแต่เริ่มใช้ ไม่ขึ้นกับตัวกรองวันที่ จึงเป็นคนละค่ากับรายละเอียดโทเค็น (ซึ่งนับเฉพาะช่วงวันที่ที่เลือก)',
    _sa_subscription_project_remaining_token: 'โทเค็นโครงการคงเหลือ',
    _sa_subscription_edit_project: 'แก้ไขระดับโครงการ',
    _sa_subscription_project_token_limit: 'โทเค็นรวมของโครงการ',
    _sa_subscription_project_image_limit: 'เครดิตสร้างภาพรวมของโครงการ ($)',
    _sa_subscription_project_unlimited_token: 'ไม่จำกัดโทเค็นโครงการ',
    _sa_subscription_project_unlimited_image: 'ไม่จำกัดเครดิตสร้างภาพโครงการ',
    _sa_subscription_project_config_hint: 'กำหนดโทเค็นรวมที่ทุกกระทรวงใช้ร่วมกัน ระบบจะบล็อกที่แบ็กเอนด์เมื่อยอดรวมถึงขีดจำกัด',
    _sa_subscription_project_save_success: 'บันทึกระดับโครงการสำเร็จ',
    _sa_validation_required_start_date: 'กรุณาระบุวันที่เริ่มต้น',
    _sa_validation_required_end_date: 'กรุณาระบุวันที่สิ้นสุด',
    _sa_validation_invalid_date_range: 'วันที่สิ้นสุดต้องไม่น้อยกว่าวันที่เริ่มต้น',
    _sa_validation_token_limit_headroom: 'Token Limit ต้องมากกว่ายอดที่ใช้ไปแล้วอย่างน้อย 1,000 (ตั้งได้ต่ำสุด {min})',
    _sa_validation_token_limit_min: 'Token Limit ต้องไม่ติดลบ',
    _sa_reset_token_note: 'หมายเหตุ: เมื่อเลือก ยอดการใช้งานโทเค็นจะถูกรีเซ็ตเป็น 0 และปรับ Limit ได้อิสระ',
    _sa_token_limit_hint_min: 'ใช้ไปแล้ว {used} • ตั้ง Limit ได้ต่ำสุด {min}',
    _sa_token_limit_hint_free: 'ปรับ Limit ได้อิสระ (ไม่มีขั้นต่ำ)',
    _sa_subscription_project_controls_ministry: 'ควบคุมการใช้โทเค็นของระดับกระทรวงจากยอดรวมนี้',
    _sa_subscription_ministry_list_hint: 'แพ็กเกจสมัครใช้งานปัจจุบันต่อหน่วยงานระดับองค์กร',
    _sa_subscription_current_tier: 'ระดับปัจจุบัน',
    _sa_subscription_active_count: 'แพ็กเกจสมัครใช้งานที่ใช้งาน',
    _sa_subscription_usage_percent: 'สัดส่วนการใช้งาน',
    _sa_email_rules_title: 'เงื่อนไขการส่งอีเมลแจ้งเตือน',
    _sa_email_rules_subtitle: 'สรุปทุกกรณีที่ระบบส่งอีเมลแจ้งเตือนอัตโนมัติ เพื่อให้ทราบว่าจะได้รับอีเมลเมื่อใด',
    _sa_email_rules_group_expiry: 'การหมดอายุแพ็กเกจสมัครใช้งาน',
    _sa_email_rules_expiry_30: 'เหลือ 30 วันก่อนหมดอายุ — แจ้งเตือนล่วงหน้า',
    _sa_email_rules_expiry_7: 'เหลือ 7 วันก่อนหมดอายุ — เตือนให้ต่ออายุโดยด่วน',
    _sa_email_rules_expiry_0: 'หมดอายุแล้ว — บริการถูกระงับ',
    _sa_email_rules_group_token: 'การใช้โควตาโทเค็น',
    _sa_email_rules_token_80: 'ใช้โทเค็นถึง 80% — แจ้งเตือนล่วงหน้า',
    _sa_email_rules_token_95: 'ใช้โทเค็นถึง 95% — ใกล้หมดขั้นวิกฤต',
    _sa_email_rules_token_100: 'ใช้โทเค็นครบ 100% — ถูกระงับการใช้งาน',
    _sa_email_rules_group_system: 'เหตุการณ์ระบบ (เฉพาะผู้ดูแลสูงสุด)',
    _sa_email_rules_system_newcompany: 'มีหน่วยงาน/บริษัทใหม่ลงทะเบียน',
    _sa_email_rules_system_newsub: 'มีการสร้างหรือต่ออายุแพ็กเกจสมัครใช้งาน',
    _sa_email_rules_system_suspended: 'หน่วยงานถูกปิดใช้งาน',
    _sa_email_rules_group_general: 'กติกาการส่ง',
    _sa_email_rules_general_schedule: 'ระบบตรวจสอบการหมดอายุทุกวัน เวลา 08:00 น.',
    _sa_email_rules_general_active: 'ส่งเฉพาะแพ็กเกจสมัครใช้งานที่เปิดใช้งานและยังไม่ถูกยกเลิก',
    _sa_email_rules_general_recipients: 'ผู้รับ: ผู้ดูแลสูงสุดทุกประเภทการแจ้งเตือน และผู้ดูแลระบบของหน่วยงานนั้นสำหรับการแจ้งเตือนโทเค็นและแพ็กเกจสมัครใช้งาน',
    _sa_email_rules_general_antispam: 'กันส่งซ้ำ: แจ้งหมดอายุส่งวันละ 1 ครั้งต่อรายการ ส่วนแจ้งโทเค็นส่งครั้งเดียวต่อรอบแพ็กเกจสมัครใช้งาน',
    _sa_email_rules_general_email_required: 'ผู้รับต้องมีอีเมลในระบบ มิฉะนั้นจะไม่ถูกส่ง',
    _sa_items_per_page: 'รายการต่อหน้า',
    _sa_of: 'จาก',
    _sa_manage: 'จัดการ',
    _ConsentConfig_NAV: 'ข้อกำหนดและเงื่อนไข',
    _CoreConfig_NAV: 'การตั้งค่าระบบ',
    _CompanyManagement_NAV: 'การจัดการบริษัท',
    _WorkgroupManagement_NAV: 'การจัดการกลุ่มบริษัท',
    _sa_wg_org_hierarchy: 'โครงสร้างองค์กร',
    _sa_wg_add_company: 'เพิ่มบริษัท',
    _sa_wg_no_company: 'ไม่พบข้อมูลบริษัทในระบบ',
    _sa_wg_editor_mode: 'โหมดแก้ไข',
    _sa_wg_add_child: 'เพิ่มบริษัทลูก',
    _sa_wg_view_company: 'ดูบริษัท',
    _sa_wg_select_node: 'เลือกโหนดเพื่อจัดการ',
    _sa_wg_select_node_hint: 'คลิกบริษัทหรือเวิร์กกรุ๊ปในรายการทางซ้าย',
    _sa_wg_choose_action: 'เลือกการดำเนินการสำหรับบริษัทนี้',
    _sa_wg_child_workgroup: 'เวิร์กกรุ๊ปลูก',
    _sa_wg_edit_in: 'แก้ไขเวิร์กกรุ๊ปใน',
    _sa_wg_add_child_for: 'เพิ่มบริษัทลูกให้',
    _sa_wg_child_company: 'บริษัทลูก *',
    _sa_wg_search_child: 'ค้นหาหรือเลือกบริษัทลูก',
    _sa_wg_type: 'ประเภทหน่วยงาน*',
    _sa_wg_select_type: 'เลือกประเภทหน่วยงาน',
    _sa_wg_portal_user: 'ผู้ใช้พอร์ทัลแชทเฟรมเวิร์ก',
    _sa_wg_lock_status: 'สถานะล็อก',
    _sa_wg_locked: 'ล็อก',
    _sa_wg_unlocked: 'ปลดล็อก',
    _sa_wg_save_changes: 'บันทึกการเปลี่ยนแปลง',
    _sa_wg_error_title: 'ข้อผิดพลาด',
    _sa_wg_ok: 'ตกลง',
    _sa_wg_err_company_name: 'กรุณากรอกชื่อบริษัท',
    _sa_wg_err_child_company: 'กรุณาเลือกบริษัทลูก',
    _sa_wg_err_type: 'กรุณาเลือกประเภทเวิร์กกรุ๊ป',
    _sa_wg_err_circular: 'บริษัทนี้ถูกกำหนดเป็นหน่วยงานลูกของโครงสร้างอื่นอยู่แล้ว \nแต่ละบริษัทสามารถมีต้นสังกัดได้เพียงที่เดียวเท่านั้น',
    _sa_wg_err_move_child: 'ไม่สามารถย้ายเวิร์กกรุ๊ปลูกได้',
    _sa_wg_err_delete: 'ลบไม่สำเร็จ',
    _sa_wg_total_companies: 'หน่วยงาน',
    _sa_wg_total_workgroups: 'เวิร์กกรุ๊ปรวม',
    _sa_wg_filter_tree: 'ค้นหาบริษัท / เวิร์กกรุ๊ป...',
    _sa_wg_company_code: 'รหัสบริษัท',
    _sa_wg_company_name: 'ชื่อบริษัท *',
    _sa_wg_mobile: 'เบอร์มือถือ',
    _sa_wg_province: 'จังหวัด',
    _sa_wg_district: 'อำเภอ',
    _sa_wg_sub_district: 'ตำบล',
    _sa_wg_country: 'ประเทศ',
    _sa_wg_post_code: 'รหัสไปรษณีย์',
    _sa_wg_address: 'ที่อยู่',
    _sa_wg_email: 'อีเมล',
    _sa_wg_username: 'ชื่อผู้ใช้',
    _sa_wg_password: 'รหัสผ่าน',
    _sa_wg_firstname: 'ชื่อจริง',
    _sa_wg_lastname: 'นามสกุล',
    _sa_wg_idcard: 'เลขบัตรประชาชน',
    _sa_wg_company_section: 'ข้อมูลบริษัท',
    _UserManagement_NAV: 'การจัดการผู้ใช้',
    _SaleManagement_NAV: 'จุดติดต่อ',
    _SubscriptionManagement_NAV: 'การจัดการสมัครสมาชิก',
    _PackageManagement_NAV: 'การจัดการแพ็กเกจ',
    _EventLog_NAV: 'อีเวนต์ล็อก',
    editLLMModel: 'แก้ไขโมเดลแอลแอลเอ็ม',
    actions: 'การดำเนินการ',
    price: 'ราคา',
    itemPerPage: 'รายการต่อหน้า',
    confirmDeletionModel: 'คุณต้องการยืนยันการลบโมเดลนี้หรือไม่',
    _basicInformation: 'ข้อมูลพื้นฐาน',
    _modelDetails: 'รายละเอียดโมเดล',
    _configuration: 'การตั้งค่า',
    _imageOptions: 'ตัวเลือกรูปภาพ',
    _additionalOptions: 'ตัวเลือกเพิ่มเติม',
    _apiVersion: 'เวอร์ชัน API',
    _maxToken: 'โทเค็นสูงสุด',
    _inputPrice: 'ราคาอินพุต',
    _outputPrice: 'ราคาเอาต์พุต',
    _imagePriceUSD: 'ราคารูปภาพ (USD)',
    _pricePerImage: 'ราคาต่อรูปภาพ',
    _quality: 'คุณภาพ',
    _chooseQuality: 'เลือกคุณภาพ',
    _resolution: 'ความละเอียด (พิกเซล)',
    _selectResolution: 'เลือกความละเอียด',
    _enableFileUpload: 'เปิดใช้การอัปโหลดไฟล์',
    _enableReasoningEffort: 'เปิดใช้ระดับการใช้เหตุผล',
    _jsonFormat: 'รูปแบบเจสัน',
    _moreDetail: 'รายละเอียดเพิ่มเติม',
    _authenHeaderName: 'ชื่อ Header สำหรับยืนยันตัวตน',
    _profile_digital_identity: 'ผูกดิจิทัลไอดี',
    _profile_digital_identity_hint: 'เชื่อมบัญชีของคุณกับไทยดีหรือดีจีเอ ดิจิทัล ไอดี เพื่อเข้าสู่ระบบได้สะดวกยิ่งขึ้น',
    _profile_thaid_desc: 'เข้าสู่ระบบด้วยไทยดี (บัตรประชาชน)',
    _profile_dgaid_desc: 'เข้าสู่ระบบด้วยดีจีเอ ดิจิทัล ไอดี',
    _profile_link_thaid: 'ผูกไทยดี',
    _profile_link_dgaid: 'ผูกดีจีเอ ดิจิทัล ไอดี',
    _profile_link_success: 'ผูกดิจิทัลไอดีสำเร็จ',
    _profile_link_fail: 'ผูกดิจิทัลไอดีล้มเหลว กรุณาลองใหม่',
    _profile_linked: 'เชื่อมต่อแล้ว',
    _profile_unlink_thaid: 'ยกเลิกการผูกไทยดี',
    _profile_unlink_confirm_title: 'ยืนยันการยกเลิกการผูกไทยดี',
    _profile_unlink_confirm_text: 'คุณต้องการยกเลิกการผูกไทยดีกับบัญชีนี้ใช่หรือไม่? คุณจะไม่สามารถเข้าสู่ระบบด้วยไทยดีได้จนกว่าจะผูกใหม่',
    _profile_unlink_confirm_btn: 'ยืนยันการยกเลิก',
    _profile_unlink_success: 'ยกเลิกการผูกไทยดีสำเร็จ',
    _profile_unlink_dgaid: 'ยกเลิกการผูกดีจีเอ ดิจิทัล ไอดี',
    _profile_unlink_dga_confirm_title: 'ยืนยันการยกเลิกการผูกดีจีเอ ดิจิทัล ไอดี',
    _profile_unlink_dga_confirm_text: 'คุณต้องการยกเลิกการผูกดีจีเอ ดิจิทัล ไอดีกับบัญชีนี้ใช่หรือไม่?',
    _profile_unlink_dga_success: 'ยกเลิกการผูกดีจีเอ ดิจิทัล ไอดีสำเร็จ',
    _profile_unlink_no_password_title: 'กรุณาตั้งรหัสผ่านก่อน',
    _profile_unlink_no_password_text: 'บัญชีนี้ยังไม่มีรหัสผ่าน กรุณาตั้งรหัสผ่านก่อนยกเลิกการผูก เพื่อให้สามารถเข้าสู่ระบบได้ในครั้งถัดไป',
    _profile_unlink_last_method_title: 'ยกเลิกการผูกไม่ได้',
    _profile_unlink_last_method_text: 'นี่เป็นช่องทางเข้าสู่ระบบสุดท้ายของบัญชี — ต้องเหลือช่องทางเข้าสู่ระบบอย่างน้อย 1 อย่าง',
    _profile_digital_identity_disabled: 'ไม่ได้เปิดใช้งานการเข้าสู่ระบบด้วยดิจิทัลไอดีสำหรับระบบนี้',
    _sa_profile_title: 'โปรไฟล์ซูเปอร์แอดมิน',
    _vid_title: 'ข้อมูลยืนยันตัวตน',
    _vid_readonly_note: 'ข้อมูลนี้เชื่อมต่อและจัดการผ่านระบบ DGA Digital ID หรือ ThaiD  ไม่สามารถแก้ไขได้ผ่านระบบนี้ กรุณาดำเนินการแก้ไขที่ https://connect.egov.go.th',
    _vid_group_personal: 'ข้อมูลส่วนบุคคล',
    _vid_name_th: 'ชื่อ–นามสกุล (ไทย)',
    _vid_name_en: 'ชื่อ–นามสกุล (อังกฤษ)',
    _vid_idcard: 'เลขประจำตัวประชาชน',

    // หน้าโครงสร้างองค์กร
    _sa_org_breadcrumb_root: 'ผู้ดูแลระบบสูงสุด',
    _sa_org_title: 'โครงสร้างองค์กร',
    _sa_org_subtitle: 'บริหารโครงสร้างองค์กรแบบลำดับชั้น (กระทรวง → หน่วยงาน)',
    _sa_org_create_ministry: 'สร้างกระทรวง',
    _sa_org_create_unit: 'สร้างหน่วยงาน',
    _sa_org_search: 'ค้นหากระทรวงหรือหน่วยงาน',
    _sa_org_col_name: 'ชื่อหน่วยงาน',
    _sa_org_col_type: 'ประเภท',
    _sa_org_col_code: 'รหัสหน่วยงาน',
    _sa_org_code_copied: 'คัดลอกรหัสแล้ว',
    _sa_org_col_action: 'การดำเนินการ',
    _sa_org_dlg_code_ministry: 'รหัสกระทรวง',
    _sa_org_dlg_name_ministry: 'ชื่อกระทรวง',
    _sa_org_dlg_email: 'อีเมลหน่วยงาน',
    _sa_org_dlg_phone: 'เบอร์โทรศัพท์',
    _sa_org_dlg_enable: 'เปิดใช้งาน',
    _sa_org_dlg_parent: 'ภายใต้',
    _sa_org_dlg_code_unit: 'รหัสหน่วยงาน',
    _sa_org_dlg_code_unit_hint: 'สูงสุด 10 ตัวอักษร',
    _sa_org_dlg_name_unit: 'ชื่อหน่วยงาน',
    _sa_org_dlg_unit_type: 'ประเภทหน่วยงาน',
    _sa_org_dlg_code_unit_placeholder: 'เช่น COM004-01',
    _sa_org_dlg_name_unit_placeholder: 'เช่น กรมการขนส่งทางบก',
    _sa_org_col_email: 'อีเมล',
    _sa_org_col_phone: 'เบอร์โทร',
    _sa_org_col_owner: 'เจ้าของ',
    _sa_org_create_company: 'สร้างบริษัท',
    _sa_org_edit_company: 'แก้ไขข้อมูลบริษัท',
    _sa_org_section_company: 'ข้อมูลบริษัท',
    _sa_org_form_code: 'รหัสบริษัท *',
    _sa_org_form_code_hint: 'สูงสุด 10 ตัวอักษร',
    _sa_org_form_type: 'ประเภทองค์กร',
    _sa_org_form_name: 'ชื่อบริษัท *',
    _sa_org_form_mobile: 'เบอร์มือถือ',
    _sa_org_form_province: 'จังหวัด',
    _sa_org_form_district: 'อำเภอ',
    _sa_org_form_subdistrict: 'ตำบล',
    _sa_org_form_country: 'ประเทศ',
    _sa_org_form_postcode: 'รหัสไปรษณีย์',
    _sa_org_form_address: 'ที่อยู่',
    _sa_org_form_email: 'อีเมล',
    _sa_org_section_user: 'ผู้ใช้งานพอร์ทัลแชทเฟรมเวิร์ก',
    _sa_org_form_username: 'ชื่อผู้ใช้',
    _sa_org_form_password: 'รหัสผ่าน *',
    _sa_org_form_firstname: 'ชื่อ *',
    _sa_org_form_lastname: 'นามสกุล *',
    _sa_org_form_lock_status: 'ล็อกบัญชีผู้ดูแล (ผู้ใช้):',
    _sa_org_form_locked: 'ล็อก',
    _sa_org_form_unlocked: 'ปลดล็อก',
    _sa_org_form_status: 'สถานะหน่วยงาน:',
    _sa_org_form_enabled: 'เปิดใช้',
    _sa_org_form_disabled: 'ปิดใช้งาน',
    _sa_org_sub_units: 'หน่วยงานย่อย',
    _sa_org_add_child: 'เพิ่มลูก',
    _sa_org_new: 'ใหม่',
    _sa_org_no_children: 'ไม่มีหน่วยงานย่อย',
    _sa_org_select_unit_title: 'เลือกหน่วยงานย่อย',
    _sa_org_search_name_code: 'ค้นหาชื่อหรือรหัส',
    _sa_org_selected_count: 'เลือกแล้ว {count} รายการ',
    _sa_org_add_selected: 'เพิ่ม ({count})',
    _sa_org_edit_unit: 'แก้ไขหน่วยงาน',
    _sa_org_new_password: 'รหัสผ่านใหม่ *',
    _sa_org_confirm_password: 'ยืนยันรหัสผ่านใหม่ *',
    _sa_org_hierarchy_warning_title: 'ไม่สามารถเปลี่ยนประเภทองค์กรได้',
    _sa_org_hierarchy_warning_msg: 'ประเภทองค์กรที่เลือกมีระดับลำดับชั้น ต่ำกว่า หน่วยงานย่อย ไม่สามารถกำหนดได้',
    _sa_org_hierarchy_warning_hint: 'กรุณาเลือกประเภทที่มีระดับสูงกว่าหน่วยงานย่อยทั้งหมด',
    _sa_org_acknowledge: 'รับทราบ',
    _sa_org_confirm_delete_title: 'ยืนยันการลบ',
    _sa_org_confirm_delete_msg: 'คุณต้องการลบ {name} ออกจากระบบใช่หรือไม่?',
    _sa_org_delete_warning: 'ข้อควรระวัง: รายการนี้มีหน่วยงานย่อย ซึ่งจะถูกลบออกด้วย',
    _sa_org_delete: 'ลบ',
    _sa_org_type_company: 'บริษัท',
    _sa_org_type_ministry: 'กระทรวง',
    _sa_org_type_unit: 'หน่วยงาน',
    _sa_validation_required_company_code: 'กรุณากรอกรหัสบริษัท',
    _sa_validation_company_code_max: 'รหัสบริษัทต้องมีไม่เกิน 10 ตัวอักษร',
    _sa_validation_required_company_name: 'กรุณากรอกชื่อบริษัท',
    _sa_validation_required_unit_code: 'กรุณากรอกรหัสหน่วยงาน',
    _sa_validation_unit_code_max: 'รหัสหน่วยงานต้องมีไม่เกิน 10 ตัวอักษร',
    _sa_validation_required_unit_name: 'กรุณากรอกชื่อหน่วยงาน',
    _sa_validation_max_length: '{field} ต้องมีไม่เกิน {max} ตัวอักษร',
    _sa_validation_max_length_hint: 'สูงสุด {max} ตัวอักษร',
    _sa_validation_required_username: 'กรุณากรอกชื่อผู้ใช้',
    _sa_validation_required_password: 'กรุณากรอกรหัสผ่าน',
    _sa_validation_password_format: 'กรุณากรอกรหัสผ่านให้ถูกต้องตามรูปแบบ',
    _sa_validation_required_first_name: 'กรุณากรอกชื่อ',
    _sa_validation_required_last_name: 'กรุณากรอกนามสกุล',
    _sa_validation_required_email: 'กรุณากรอกอีเมล',
    _sa_validation_email_format: 'กรุณากรอกอีเมลให้ถูกต้อง',
    _sa_validation_duplicate_email: 'ห้ามใช้อีเมลซ้ำ',
    _sa_validation_required_company: 'กรุณาเลือกบริษัท',
    _sa_validation_password_min: 'อย่างน้อย 8 ตัวอักษร',
    _sa_validation_password_lowercase: 'ตัวพิมพ์เล็ก',
    _sa_validation_password_uppercase: 'ตัวพิมพ์ใหญ่',
    _sa_validation_password_number: 'มีตัวเลข',
    _sa_validation_password_special: 'มีอักขระพิเศษ',
    _sa_validation_confirm_password_match: 'รหัสผ่านยืนยันตรงกัน',
    _sa_validation_confirm_password_not_match: 'รหัสผ่านยืนยันไม่ตรงกัน',
    _sa_loading_login: 'กำลังเข้าสู่ระบบ...',
    _sa_loading_processing: 'กำลังบันทึกข้อมูล...',
    _sa_loading_deleting: 'กำลังลบข้อมูล...',
    _sa_loading_manage_company: 'กำลังเข้าสู่ระบบบริษัท...',
    _sa_loading_please_wait: 'กรุณาอย่าปิดหน้านี้',
    _sa_json_invalid: 'กรุณากรอกเจสันให้ถูกต้อง',
    _sa_unlimited: 'ไม่จำกัด',
    // ฟูลสตรีมรุ่น 2
    fs2NewChat: 'แชทใหม่',
    fs2NewChatLabel: 'แชทใหม่',
    fs2Login: 'เข้าสู่ระบบ',
    fs2Greeting: 'สวัสดีครับ',
    fs2GreetingUser: 'สวัสดีครับ คุณ{name}',
    fs2Tagline: 'ผม น้องดีเด่น AI ผู้ช่วยอัจฉริยะเพื่อประชาชน',
    fs2Subtitle1: 'สามารถถามเรื่องที่คุณอยากรู้ได้เลย!',
    fs2Subtitle2: 'ผมจะช่วยสรุปแบบกระชับ เข้าใจง่าย เชื่อถือได้',
    fs2WelcomeBeta: 'เวอร์ชันทดสอบ (Beta) - เรียนรู้และพัฒนาเพื่อคุณ',
    fs2PersonalizedDemo: 'แนะนำเฉพาะบุคคล',
    fs2PersonalizedSection: 'คำแนะนำเฉพาะบุคคล',
    fs2RecCardDefaultAction: 'ดูรายละเอียด',
    fs2RecCardDismiss: 'ปิด',
    fs2RecCarouselNav: 'เลื่อนรายการคำแนะนำ',
    fs2RecCarouselPrev: 'เลื่อนคำแนะนำไปทางซ้าย',
    fs2RecCarouselNext: 'เลื่อนคำแนะนำไปทางขวา',
    fs2InputPlaceholder: 'ถามเรื่องที่คุณอยากรู้...',
    fs2DefaultModel: 'บริการของเรา',
    fs2QuickChipRights: 'สิทธิและสวัสดิการ',
    fs2QuickChipBooking: 'จองคิวทำเอกสารที่ อำเภอ-เขต',
    fs2QuickChipLand: 'สอบถามเรื่องที่ดิน',
    fs2QuickChipPolicy: 'นโยบายรัฐบาล',
    fs2QuickChipDga: 'ข้อมูลของ สพร.',
    fs2QuickChipServices: 'บริการสำคัญ',
    fs2QuickChipFinance: 'การเงินและประกัน',
    fs2QuickChipHousing: 'ที่ดินและที่อยู่',
    fs2QuickChipNhso: 'สอบถามข้อมูล สปสช.',
    fs2Send: 'ส่งข้อความ',
    fs2Disclaimer: 'ระบบนี้ให้คำแนะนำอัตโนมัติเบื้องต้น โปรดตรวจสอบกับหน่วยงานที่เกี่ยวข้องอีกครั้ง',
    fs2Home: 'หน้าแรก',
    fs2History: 'ประวัติการสนทนา',
    fs2NoHistory: 'ยังไม่มีประวัติการสนทนา',
    fs2ErrorGeneric: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
    fs2ErrorNoToken: 'ไม่พบโทเค็น กรุณาเข้าสู่ระบบใหม่',
    fs2Retry: 'ลองใหม่',
    fs2Portal: 'ไปยังพอร์ทัล',
    fs2Logout: 'ออกจากระบบ',
    fs2User: 'ผู้ใช้งาน',
    fs2ToggleSidebar: 'เปิด/ปิดเมนู',
    fs2SwitchLanguage: 'สลับภาษา',
    fs2LanguageThai: 'ภาษาไทย',
    fs2LanguageEnglish: 'อังกฤษ',
    fs2Copy: 'คัดลอก',
    fs2Copied: 'คัดลอกแล้ว',
    fs2Like: 'ชอบ',
    fs2NewChatConfirm: 'เริ่มการสนทนาใหม่',
    fs2NewChatAction: 'เริ่มสนทนาใหม่',
    fs2Stop: 'หยุด',
    fs2Stopped: 'หยุดการตอบแล้ว',
    fs2OurService: '+ บริการของเรา',
    fs2TermsOfService: 'เงื่อนไขให้บริการ',
    fs2PrivacyNotice: 'นโยบายความเป็นส่วนตัว',
    fs2AnonymousUser: 'ผู้ใช้งาน (ไม่ระบุตัวตน)',
    fs2Folders: 'โฟลเดอร์',
    fs2CreateFolder: 'สร้างโฟลเดอร์',
    fs2RenameFolder: 'เปลี่ยนชื่อโฟลเดอร์',
    fs2DeleteFolder: 'ลบโฟลเดอร์',
    fs2FolderName: 'ชื่อโฟลเดอร์',
    fs2MoveToFolder: 'ย้ายไปยังโฟลเดอร์',
    fs2RemoveFromFolder: 'นำออกจากโฟลเดอร์',
    fs2EmptyFolder: 'ยังไม่มีแชทในโฟลเดอร์นี้',
    fs2OtherTopics: 'แชทอื่น ๆ',
    fs2Cancel: 'ยกเลิก',
    fs2Save: 'บันทึก',
    fs2Create: 'สร้าง',
    fs2DeleteFolderConfirm: 'ต้องการลบโฟลเดอร์นี้หรือไม่? แชทภายในจะถูกย้ายออกแต่จะไม่ถูกลบ',
    fs2HistoryLoading: 'กำลังโหลดประวัติ...',
    fs2UploadImage: 'แนบไฟล์/รูปภาพ',
    fs2RemoveImage: 'ลบไฟล์/รูปภาพ',
    fs2ImageTooLarge: 'ไฟล์มีขนาดใหญ่เกิน {kb} กิโลไบต์',
    fs2UploadError: 'อัปโหลดไฟล์ไม่สำเร็จ',
    fs2UploadedFile: 'ไฟล์ที่แนบ',
    fs2UploadFileBtn: 'แนบเอกสาร',
    fs2UploadImageBtn: 'แนบรูปภาพ',
    fs2UnsupportedUploadType: 'รองรับเฉพาะซีเอสวี, เอ็กเซล, พีดีเอฟ, เวิร์ด, ทีเอ็กซ์ที, พาวเวอร์พอยต์ และรูปภาพ',
    fs2UploadDisabledByModel: 'โมเดลนี้ไม่อนุญาตให้อัปโหลดรูปภาพ',
    fs2StartRecording: 'เริ่มบันทึกเสียง',
    fs2StopRecording: 'หยุดบันทึกเสียง',
    fs2VoiceLanguageTitle: 'เลือกภาษาสำหรับเสียง',
    fs2VoiceLanguageLabel: 'ภาษา',
    fs2VoiceLanguageThai: 'ไทย',
    fs2VoiceLanguageEnglish: 'อังกฤษ',
    fs2Speak: 'อ่านออกเสียง',
    fs2StopSpeak: 'หยุดอ่าน',
    fs2SpeechUnavailable: 'ไม่สามารถใช้งานบริการเสียงได้ในขณะนี้',
    fs2MicPermissionDenied: 'กรุณาอนุญาตให้เบราว์เซอร์เข้าถึงไมโครโฟนก่อน',
    fs2Dislike: 'ไม่ชอบ',
    fs2RenameTopic: 'เปลี่ยนชื่อแชท',
    fs2DeleteTopic: 'ลบแชท',
    fs2DeleteTopicConfirm: 'ต้องการลบแชทนี้หรือไม่? ข้อมูลทั้งหมดจะหายและไม่สามารถกู้คืนได้',
    fs2TopicName: 'ชื่อแชท',
    fs2LoadingMore: 'กำลังโหลดเพิ่มเติม...',
    fs2FeedbackError: 'บันทึกความคิดเห็นไม่สำเร็จ',
    fs2TokenExpired: 'โทเค็นหมดอายุหรือไม่ถูกต้อง กรุณาเข้าสู่ระบบใหม่',
    fs2SnippetMode: 'โหมดสนิปเพ็ต',
    fs2Anonymous: 'ไม่ระบุตัวตน',
    fs2PrivateMemory: 'หน่วยความจำส่วนตัว',
    fs2PmFileName: 'ชื่อไฟล์',
    fs2PmVectorDBName: 'ชื่อ Vector DB',
    fs2PmVersion: 'เวอร์ชัน',
    fs2PmStatus: 'สถานะ',
    fs2PmActions: 'การดำเนินการ',
    fs2PmActive: 'เปิดใช้งาน',
    fs2PmInactive: 'ไม่ใช้งาน',
    fs2PmEmpty: 'ยังไม่มีไฟล์หน่วยความจำส่วนตัว',
    fs2Search: 'ค้นหา',
    fs2PmUploadTitle: 'อัปโหลดหน่วยความจำส่วนตัว',
    fs2PmSelectFile: 'เลือกไฟล์',
    fs2PmUpload: 'อัปโหลด',
    fs2PmUploadSuccess: 'อัปโหลดสำเร็จ',
    fs2PmUploadError: 'อัปโหลดไม่สำเร็จ',
    fs2PmUploadIncomplete: 'กรุณากรอกชื่อไฟล์และเลือกไฟล์',
    fs2PmVectorDBHint: 'ปล่อยว่างเพื่อให้ระบบตั้งชื่ออัตโนมัติ',
    fs2PmChunksOf: 'ชังก์ของ',
    fs2PmChunksEmpty: 'ยังไม่มีชังก์',
    fs2PmChunkEdit: 'แก้ไขชังก์',
    fs2PmChunkText: 'เนื้อหาชังก์',
    fs2PmChunkSave: 'บันทึกชังก์',
    fs2PmChunkSaved: 'บันทึกชังก์สำเร็จ',
    fs2PmChunkSaveError: 'บันทึกชังก์ไม่สำเร็จ',
    fs2PmDelete: 'ลบ',
    fs2PmDeleted: 'ลบสำเร็จ',
    fs2PmDeleteError: 'ลบไม่สำเร็จ',
    fs2PmDeleteTitle: 'ยืนยันการลบไพรเวตเมมโมรี',
    fs2PmDeleteConfirm: 'การลบไม่สามารถย้อนกลับได้',
    fs2PmOpen: 'เปิดรายการชังก์',
    fs2PmRefresh: 'รีเฟรช',
    fs2PmDeleteAll: 'ลบชังก์ทั้งหมด',
    fs2PmDetect: 'ตรวจจับภาษา',
    fs2PmReplaceExisting: 'แทนที่ข้อมูลเดิม',
    fs2LoginDGA: 'เข้าสู่ระบบด้วยดีจีเอ ดิจิทัล ไอดี',
    fs2LoginThaID: 'เข้าสู่ระบบด้วยไทยดี',
    fs2LoginError: 'เข้าสู่ระบบไม่สำเร็จ กรุณาตรวจสอบชื่อผู้ใช้และรหัสผ่าน',
    companyDisabledError: 'องค์กร/บริษัทนี้ถูกระงับการใช้งาน กรุณาติดต่อผู้ดูแลระบบ',
    fs2LoginSnippetOnly: 'การเข้าสู่ระบบในหน้านี้ต้องเปิดผ่านสนิปเพ็ตของหน่วยงาน',
    fs2ForgotInstruction: 'กรอกอีเมลหรือชื่อผู้ใช้ที่ลงทะเบียนไว้ ระบบจะส่งรหัสผ่านใหม่ไปยังอีเมลของคุณ',
    fs2ForgotEmailLabel: 'อีเมล หรือ ชื่อผู้ใช้',
    fs2ForgotSend: 'ส่งรหัสผ่านใหม่',
    fs2ForgotRequired: 'กรุณากรอกอีเมลหรือชื่อผู้ใช้',
    fs2ForgotSuccess: 'ส่งรหัสผ่านใหม่ไปยังอีเมลของคุณแล้ว กรุณาตรวจสอบกล่องจดหมาย',
    fs2ForgotFailed: 'ไม่พบบัญชีนี้ หรือส่งอีเมลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
    fs2Register: 'ลงทะเบียน',
    fs2RegisterSnippetOnly: 'การสมัครสมาชิกต้องเปิดผ่านสนิปเพ็ตของหน่วยงาน',
    fs2RegisterRequired: 'กรุณากรอกชื่อ นามสกุล อีเมล และรหัสผ่าน',
    fs2RegisterUsernameRequired: 'กรุณากรอกชื่อผู้ใช้',
    fs2RegisterUsernameRule: 'ชื่อผู้ใช้ต้องมี 3-50 ตัวอักษร และใช้ได้เฉพาะ a-z, 0-9, จุด, ขีดล่าง หรือขีดกลาง',
    fs2RegisterFirstNameRequired: 'กรุณากรอกชื่อ',
    fs2RegisterLastNameRequired: 'กรุณากรอกนามสกุล',
    fs2RegisterEmailRequired: 'กรุณากรอกอีเมล',
    fs2RegisterEmailInvalid: 'กรุณากรอกอีเมลให้ถูกต้อง',
    fs2RegisterPasswordRequired: 'กรุณากรอกรหัสผ่าน',
    fs2RegisterConfirmPasswordRequired: 'กรุณายืนยันรหัสผ่าน',
    fs2RegisterPasswordMismatch: 'รหัสผ่านยืนยันไม่ตรงกัน',
    fs2RegisterPasswordRule: 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร และมีตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก ตัวเลข และอักขระพิเศษ',
    fs2PwdRuleLength: 'อย่างน้อย 8 ตัวอักษร',
    fs2PwdRuleLowercase: 'ตัวพิมพ์เล็ก',
    fs2PwdRuleUppercase: 'ตัวพิมพ์ใหญ่',
    fs2PwdRuleNumber: 'มีตัวเลข',
    fs2PwdRuleSpecial: 'มีอักขระพิเศษ',
    fs2PwdRuleMatch: 'รหัสผ่านตรงกัน',
    fs2RegisterSuccess: 'สมัครสมาชิกสำเร็จ',
    fs2RegisterFailed: 'สมัครสมาชิกไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
    fs2RegisterOrUseSso: 'หรือสมัครด้วย',
    fs2RegisterDGA: 'สมัครด้วยดีจีเอ ดิจิทัล ไอดี',
    fs2RegisterThaID: 'สมัครด้วยไทยดี',
    fs2RegisterSsoSuccess: 'สมัครสมาชิกผ่านเอสเอสโอสำเร็จ',
    fs2LoginSsoSuccess: 'เข้าสู่ระบบเรียบร้อย',
    fs2RegisterSsoDuplicate: 'บัญชีนี้เคยถูกใช้เป็นพนักงานในระบบแล้ว — กรุณาเข้าสู่ระบบแทน',
    fs2RegisterSsoProviderNotLinked: 'บัญชีนี้ยังไม่ได้ผูกกับวิธีเข้าสู่ระบบที่เลือก — กรุณาเข้าสู่ระบบด้วยวิธีที่ใช้สมัคร หรือไปผูกในหน้าโปรไฟล์ก่อน',
    fs2RegisterSsoInvalidSnippet: 'ลิงก์สนิปเพ็ตไม่ถูกต้อง',
    fs2ChatSnippetUnavailable: 'ไม่สามารถเริ่มการสนทนาได้ ระบบแชทนี้ยังไม่ได้รับอนุญาตให้ใช้งานบนเว็บไซต์นี้ กรุณาติดต่อผู้ดูแลเว็บไซต์ (รหัสอ้างอิง: {ref})',
    fs2RegisterSsoDeleted: 'บัญชีนี้ถูกระงับการใช้งานแล้ว กรุณาติดต่อผู้ดูแลระบบ',
    fs2LoginSsoNotRegistered: 'ยังไม่ได้สมัครสมาชิก กรุณาสมัครสมาชิกก่อนเข้าสู่ระบบ',
    fs2RegisterSsoDuplicateAccount: 'อีเมลหรือชื่อผู้ใช้นี้มีอยู่ในระบบแล้ว ไม่สามารถสมัครซ้ำได้',
    fs2RegisterSsoAccountExists: 'มีบัญชีนี้อยู่แล้วในระบบ กรุณาเข้าสู่ระบบแทน',
    fs2RegisterSsoContextMissing: 'ไม่พบข้อมูลสนิปเพ็ตสำหรับสมัครผ่านเอสเอสโอ กรุณาเปิดจากลิงก์สนิปเพ็ตของหน่วยงานอีกครั้ง',
    fs2RegisterSsoFailed: 'สมัครสมาชิกผ่านเอสเอสโอไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
    fs2RequireLogin: 'กรุณาเข้าสู่ระบบก่อนใช้งานความสามารถนี้',
    fs2AnonCtaTitle: 'ลองคุยฟรี!',
    fs2AnonCtaSubtitle: 'เข้าสู่ระบบเพื่อบันทึกแชทของคุณ',
    fs2AnonSessionHeader: 'บทสนทนาในเซสชันนี้',
    fs2AnonLocalBadge: 'ในเครื่อง',
    fs2AnonWarnEphemeral: 'แชทจะหายเมื่อปิดเบราว์เซอร์',
    fs2LoginToUpload: 'เข้าสู่ระบบเพื่ออัปโหลดไฟล์',
    fs2LoginToUseVoice: 'เข้าสู่ระบบเพื่อใช้เสียง',
    fs2LoginToUsePrivateMemory: 'เข้าสู่ระบบเพื่อใช้หน่วยความจำส่วนตัว',
    fs2AnonRemaining: 'เหลือ {count} ข้อความ',
    fs2AnonLimitReached: 'หมดโควต้าทดลอง',
    fs2AnonLimitMsg: 'เข้าสู่ระบบเพื่อคุยต่อแบบไม่จำกัด',
    fs2LoginNudgeTitle: 'ปลดล็อกความสามารถเพิ่มเติม',
    fs2LoginNudgeSubtitle: 'เข้าสู่ระบบหรือลงทะเบียนเพื่อใช้งานความสามารถเต็มรูปแบบ',
    fs2LoginNudgeFeatureFolder: 'จัดเก็บแชทเป็นโฟลเดอร์',
    fs2LoginNudgeFeatureHistory: 'บันทึกและเปิดดูประวัติการสนทนาย้อนหลัง',
    fs2LoginNudgeFeatureImage: 'ถามด้วยรูปภาพและแนบไฟล์',
    fs2LoginNudgeRegister: 'ลงทะเบียน',
    fs2LoginNudgeDismiss: 'ไว้ภายหลัง',
    fs2LoginNudgeContext: 'เข้าสู่ระบบเพื่อใช้ฟีเจอร์โฟลเดอร์ ประวัติแชท และการถามด้วยรูปภาพ',
    fs2ChatFramework: 'แชทเฟรมเวิร์ก',
    fs2ProductAdmin: 'โปรดักต์แอดมิน',
    fs2PortalProductAdmin: 'พอร์ทัลโปรดักต์แอดมิน',
    fs2PortalChatFramework: 'พอร์ทัลแชทเฟรมเวิร์ก',
    landingTitle: 'ดีจีเอ แชทเฟรมเวิร์ก',
    landingHeroBadge: 'แพลตฟอร์มแชทอัจฉริยะด้วยปัญญาประดิษฐ์',
    landingHeroTitle: 'ระบบค้นหาข้อมูลด้วยเทคโนโลยีปัญญาประดิษฐ์',
    landingHeroSubtitle: 'ขับเคลื่อนด้วยเทคโนโลยีปัญญาประดิษฐ์ - ปลอดภัย รวดเร็ว และใช้งานง่าย รองรับผู้ใช้งานพร้อมกันได้หลายล้านคน',
    landingHeroBody: 'ระบบค้นหาด้วยเทคโนโลยีปัญญาประดิษฐ์ของภาครัฐ เป็นแพลตฟอร์มถามตอบที่ให้บริการค้นหาข้อมูลจากหน่วยงานภาครัฐ เพื่อนำไปประยุกต์ใช้กับบริการดิจิทัลของหน่วยงาน ช่วยเพิ่มประสิทธิภาพงานบริการให้ค้นหาข้อมูลได้อย่างถูกต้อง แม่นยำ และมีประสิทธิภาพ',
    landingHeroSecondaryCTA: 'เรียนรู้เพิ่มเติม',
    landingCTA: 'เริ่มใช้งาน',
    landingCTAChat: 'ไปยังหน้าแชท',
    landingNavAbout: 'เกี่ยวกับเรา',
    landingNavFeatures: 'คุณสมบัติ',
    landingNavSitemap: 'แผนผังเว็บไซต์',
    landingNavTerms: 'ข้อกำหนด',
    landingNavPrivacy: 'ความเป็นส่วนตัว',
    landingSitemapEyebrow: 'แผนผังเว็บไซต์',
    landingPrivacyEyebrow: 'นโยบายความเป็นส่วนตัว',
    landingFooterQuickLinks: 'ลิงก์ด่วน',
    landingFooterGetStarted: 'เริ่มใช้งาน',
    landingToggleLang: 'สลับภาษา',
    landingTrustSecurity: 'ปลอดภัยตามมาตรฐานพีดีพีเอ',
    landingTrustSpeed: 'ตอบสนองรวดเร็ว',
    landingTrustScale: 'รองรับผู้ใช้หลักล้าน',
    landingFeaturesEyebrow: 'คุณสมบัติเด่น',
    landingFeaturesTitle: 'ทุกสิ่งที่หน่วยงานคุณต้องการ',
    landingFeaturesSubtitle: 'แพลตฟอร์มแชทครบวงจรที่ออกแบบมาเพื่อหน่วยงานภาครัฐโดยเฉพาะ',
    landingFeatureAITitle: 'ปัญญาประดิษฐ์ที่เข้าใจภาษาไทย',
    landingFeatureAIDesc: 'เชื่อมต่อแอลแอลเอ็มชั้นนำ เช่น โอเพนเอไอ, อะซัวร์โอเพนเอไอ และเวอร์เท็กซ์เอไอ พร้อมปรับแต่งให้เหมาะกับหน่วยงาน',
    landingFeatureSecurityTitle: 'ความปลอดภัยระดับองค์กร',
    landingFeatureSecurityDesc: 'เข้ารหัสด้วยอาร์กอนทูไอดี และแยกข้อมูลแต่ละองค์กรตามรูปแบบหลายผู้เช่า ตามมาตรฐานพีดีพีเอ',
    landingFeatureSpeedTitle: 'รองรับผู้ใช้หลักล้าน',
    landingFeatureSpeedDesc: 'สถาปัตยกรรมคลาวด์เนทีฟบนอะซัวร์ ขยายสเกลอัตโนมัติ พร้อมซิกนัลอาร์แบบเรียลไทม์',
    landingAboutEyebrow: 'เกี่ยวกับเรา',
    landingAboutTitle: 'รู้จักกับเรา',
    landingTermsEyebrow: 'เงื่อนไขการใช้งาน',
    landingTermsTitle: 'ข้อกำหนดและเงื่อนไข',
    landingTermsAskAiSubtitle: 'ข้อกำหนดและเงื่อนไขการใช้บริการของ\nบริการค้นหาข้อมูลด้วยเทคโนโลยีปัญญาประดิษฐ์ (Ask AI)',
    landingPrivacySubtitle: 'ประกาศความเป็นส่วนตัว (Privacy Notice)\nของ สำนักงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน)',
    landingShowMore: 'อ่านเพิ่มเติม',
    landingShowLess: 'ย่อ',
    landingNoContentForLang: 'ยังไม่มีข้อมูลในภาษานี้',
    landingCTABannerTitle: 'พร้อมเริ่มใช้งานหรือยัง?',
    landingCTABannerSubtitle: 'เริ่มต้นใช้งานแชทเฟรมเวิร์กได้ทันที ไม่ต้องลงทะเบียน',
    landingFooterTagline: 'แพลตฟอร์มแชทอัจฉริยะที่ออกแบบมาสำหรับหน่วยงานภาครัฐไทย ขับเคลื่อนด้วยปัญญาประดิษฐ์ที่เข้าใจบริบทท้องถิ่น',
    landingFooterSitemap: 'แผนผังเว็บไซต์',
    landingFooterLegal: 'นโยบาย',
    landingFooterCopyright: '© {year} ดีจีเอ แชทเฟรมเวิร์ก สงวนลิขสิทธิ์',
    back: 'ย้อนกลับ',
    moveUp: 'เลื่อนขึ้น',
    moveDown: 'เลื่อนลง',
    landingPrivacyLink: 'นโยบายความเป็นส่วนตัว',
    // ออกแบบหน้าแนะนำระบบใหม่ — ธีมดีจีเอ
    landingNavHome: 'หน้าแรก',
    landingHomeHeroTitle: 'ตอบคำถามและค้นหาข้อมูลเกี่ยวกับรัฐ',
    landingHomeHeroSubtitle: 'ขับเคลื่อนด้วยเทคโนโลยีปัญญาประดิษฐ์',
    landingHomeHeroLead: 'ขับเคลื่อนด้วยปัญญาประดิษฐ์ — ที่มีความปลอดภัย รวดเร็ว และใช้งานง่าย พร้อมรองรับผู้ใช้งานพร้อมกันได้ในระดับหลายล้านราย',
    landingHomeHeroBody: 'ระบบค้นหาข้อมูลภาครัฐด้วยปัญญาประดิษฐ์ เป็นแพลตฟอร์มส่วนกลางที่ช่วยให้ผู้ใช้งานสามารถค้นหาข้อมูลจากหน่วยงานภาครัฐได้',
    landingHomeAnswerTitle: 'มอบคำตอบสำหรับทุกคำถาม',
    landingHomeAnswerSubtitle: 'แพลตฟอร์มที่ขับเคลื่อนด้วยเทคโนโลยีปัญญาประดิษฐ์ ช่วยให้ผู้ใช้งานสามารถค้นหาและเข้าถึงข้อมูลภาครัฐได้อย่างรวดเร็ว ถูกต้อง และมีประสิทธิภาพ ผ่านประสบการณ์ดิจิทัลแบบรวมศูนย์',
    landingHomeServicesHeadline: 'ระบบค้นหาข้อมูลด้วย\nเทคโนโลยีปัญญาประดิษฐ์',
    landingHomeServicesLead: 'ขับเคลื่อนด้วยเทคโนโลยีปัญญาประดิษฐ์ที่มีความปลอดภัย รวดเร็ว\nและใช้งานง่าย พร้อมรองรับผู้ใช้งานพร้อมกันได้ในระดับหลายล้านราย',
    landingHomeFeaturesTitle: 'ทุกคำถามของคุณ เรามีคำตอบ',
    landingHomePartnersTitle: 'หน่วยงานพันธมิตรของเรา',
    landingNavAboutUs: 'เกี่ยวกับเรา',
    landingNavContactUs: 'ติดต่อเรา',
    landingSearchPlaceholder: 'ค้นหาในหน้านี้...',
    landingSearchNoResult: 'ไม่พบผลลัพธ์',
    landingHeroTitleMain: 'ระบบค้นหาข้อมูลด้วย\nเทคโนโลยี',
    landingHeroTitleAccent: 'ปัญญาประดิษฐ์',
    landingMockTryTitle: 'ลองคุยฟรี!',
    landingMockTrySubtitle: 'เข้าสู่ระบบเพื่อบันทึกแชทของคุณ',
    landingMockLogin: 'เข้าสู่ระบบ',
    landingMockHome: 'หน้าแรก',
    landingMockNewChat: 'แชทใหม่',
    landingMockGreeting: 'สวัสดีครับ',
    landingMockTagline: 'ผมคือผู้ช่วยอัจฉริยะเพื่อคุณ!',
    landingMockSubtitle1: 'สามารถถามเรื่องที่คุณอยากรู้ได้เลย',
    landingMockSubtitle2: 'ผมจะสรุปแบบกระชับ เข้าใจง่าย เชื่อถือได้',
    landingMockInputPlaceholder: 'ถามเรื่องที่คุณอยากรู้...',
    landingMockService: '+ บริการของเรา',
    landingMockChipRights: 'สิทธิและสวัสดิการ',
    landingMockChipBooking: 'จองคิวทำเอกสารที่ อำเภอ-เขต',
    landingMockChipLand: 'สอบถามเรื่องที่ดิน',
    landingMockChipPolicy: 'นโยบายรัฐบาล',
    landingMockChipDga: 'ข้อมูลของ สพร.',
    landingMockChipServices: 'บริการสำคัญ',
    landingMockChipFinance: 'การเงินและประกัน',
    landingMockChipHousing: 'ที่ดินและที่อยู่',
    landingStatUsersValue: '15 ล้าน+',
    landingStatUsersLabel: 'ผู้ใช้งาน',
    landingStatConversationsValue: '10 ล้าน+',
    landingStatConversationsLabel: 'บทสนทนา',
    landingStatServiceValue: '24/7',
    landingStatServiceLabel: 'บริการตลอดเวลา',
    landingAboutOrgTitle: 'ดีจีเอ — สำนักงานพัฒนารัฐบาลดิจิทัล',
    landingFooterWebsiteTitle: 'เว็บไซต์หลัก',
    landingFooterWebsiteValue: 'www.dga.or.th',
    landingFooterContactTitle: 'ติดต่อเรา',
    landingFooterContactEmail: "contact{'@'}dga.or.th",
    landingFooterContactTel: '+66 (0) 2612-6000',
    landingFooterAddressTitle: 'ที่อยู่',
    landingFooterAddressValue: '120 หมู่ 3 ชั้น 7 อาคารรถไฟฟ้า (อาคารบี) ศูนย์ราชการเฉลิมพระเกียรติ ถนนแจ้งวัฒนะ แขวงทุ่งสองห้อง เขตหลักสี่ กรุงเทพมหานคร 10210',
    landingFooterEmailLabel: 'อีเมล',
    landingFooterTelLabel: 'โทร',
    landingFooterWebsiteLabel: 'เว็บไซต์',
    landingFooterOrgAddress: 'สำนักงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน) เลขที่ 120 อาคารศูนย์ราชการเฉลิมพระเกียรติฯ (อาคารซี) ชั้น 8 - 9 หมู่ 3 ซอยแจ้งวัฒนะ 7 ถนนแจ้งวัฒนะ แขวงทุ่งสองห้อง เขตหลักสี่ กรุงเทพฯ 10210',
    landingNavServices: 'บริการของเรา',
    landingServicesPageLead: 'ขับเคลื่อนด้วยเทคโนโลยีปัญญาประดิษฐ์ที่มีความปลอดภัย รวดเร็ว และใช้งานง่าย พร้อมรองรับผู้ใช้งานพร้อมกันได้ในระดับหลายล้านราย',
    landingServicesPageSessionChats: 'บทสนทนาในเซสชันนี้',
    landingServicesPageProfileTitle: 'โปรไฟล์',
    landingServicesPagePersonalized: 'แนะนำเฉพาะบุคคล',
    landingServicesPageWeatherMeta: '33 องศาเซลเซียส · เมฆมาก · กรุงเทพฯ',
    landingServicesPageAirMeta: 'PM2.5 15.9 · ดี',
    landingServicesPageEventMeta: 'วันวิสาขบูชา · อีก 3 วัน',
    landingServicesPageCardAlertLabel: 'การแจ้งเตือน',
    landingServicesPageCardRecommendLabel: 'คำแนะนำ',
    landingServicesPageCardAlertTitle: 'บัตรประชาชนหมดอายุในอีก 29 วัน',
    landingServicesPageCardAlertBody: 'รีบจองคิวภายในวันที่ 7 กรกฎาคม 2569 และต่ออายุได้ที่อำเภอหรือเขตใกล้บ้านก่อนกำหนด',
    landingServicesPageCardAlertAction: 'ดูรายละเอียด',
    landingServicesPageCardHousingTitle: 'การสมัครเข้ารับการอบรมอาชีพของศูนย์บริการชุมชนพัฒนาและส่งเสริมครอบครัว',
    landingServicesPageCardHousingBody: 'รับสิทธิการอบรมวิชาชีพสำหรับกลุ่มเปราะบาง พร้อมสรุปเงื่อนไขและเอกสารที่ต้องใช้ในครั้งเดียว',
    landingServicesPageCardHousingAction: 'ดูหลักสูตร',
    landingServicesPageCardWalletTitle: 'การใช้บริการศูนย์พัฒนาการจัดสวัสดิการสังคมผู้สูงอายุ',
    landingServicesPageCardWalletBody: 'สรุปสิทธิการรับคำปรึกษาและข้อมูลบริการที่ศูนย์ดูแลผู้สูงอายุพร้อมช่องทางติดต่อที่เกี่ยวข้อง',
    landingServicesPageCardWalletAction: 'ค้นหาศูนย์ใกล้ฉัน',
    landingServicesPageDismiss: 'ปิด',
    landingServicesPageDetailTitle: 'ระบบค้นหาข้อมูลด้วย\nเทคโนโลยีปัญญาประดิษฐ์',
    landingServicesPageDetailLead: 'ขับเคลื่อนด้วยเทคโนโลยีปัญญาประดิษฐ์ที่มีความปลอดภัย รวดเร็ว และใช้งานง่าย พร้อมรองรับผู้ใช้งานพร้อมกันได้ในระดับหลายล้านราย',
    landingServicesPageDetailCta: 'เริ่มใช้งาน',
    landingServicesPageDetailParagraph1: 'ระบบค้นหาอัจฉริยะภาครัฐคือแพลตฟอร์มค้นหาข้อมูลอัจฉริยะแบบศูนย์กลาง ที่ได้รับการออกแบบมาเพื่อยกระดับการเข้าถึงและการค้นหาข้อมูลจากหน่วยงานภาครัฐให้มีประสิทธิภาพมากยิ่งขึ้น โดยขับเคลื่อนด้วยเทคโนโลยีปัญญาประดิษฐ์ขั้นสูง ช่วยให้ผู้ใช้งานสามารถค้นหา สำรวจ และเข้าถึงข้อมูลได้ด้วยภาษาธรรมชาติ ทำให้ข้อมูลภาครัฐเข้าถึงได้ง่าย เข้าใจได้สะดวก และนำไปใช้ประโยชน์ได้อย่างมีประสิทธิภาพ',
    landingServicesPageDetailParagraph2: 'ในปัจจุบัน ประชาชนและเจ้าหน้าที่ภาครัฐมักเผชิญกับความท้าทายในการค้นหาข้อมูลจากเว็บไซต์ ฐานข้อมูล กฎระเบียบ และบริการดิจิทัลของหน่วยงานภาครัฐที่มีอยู่เป็นจำนวนมาก เนื่องจากข้อมูลกระจายอยู่หลายแหล่งและหลายระบบ ทำให้การค้นหาข้อมูลที่ถูกต้องและตรงตามความต้องการเป็นไปได้ยากและใช้เวลานาน ระบบค้นหาอัจฉริยะภาครัฐจึงถูกพัฒนาขึ้นเพื่อแก้ไขปัญหาดังกล่าว โดยทำหน้าที่เป็นศูนย์กลางการเชื่อมโยงข้อมูลภาครัฐจากหลากหลายหน่วยงานเข้าด้วยกัน สร้างประสบการณ์การค้นหาข้อมูลที่รวดเร็ว สะดวก และมีประสิทธิภาพในแพลตฟอร์มเดียว',
    landingPartnershipPageTitle: 'เครือข่ายความร่วมมือหน่วยงานภาครัฐ',
    landingPartnershipOlderPersons: 'กรมกิจการผู้สูงอายุ',
    landingPartnershipChildrenYouth: 'กรมกิจการเด็กและเยาวชน',
    landingPartnershipSocialDevelopmentWelfare: 'กรมพัฒนาสังคม\nและสวัสดิการ',
    landingPartnershipCommunityDevelopment: 'กรมการพัฒนาชุมชน',
    landingPartnershipMinistry: 'กระทรวงการพัฒนา\nสังคมและความมั่นคง\nของมนุษย์ (พม)',
    landingPartnershipSocialSecurity: 'สำนักงานประกันสังคม',
    landingPartnershipNHSO: 'สำนักงานหลักประกันสุขภาพแห่งชาติ (สปสช)',
    landingPartnershipWomenFamily: 'กรมกิจการสตรีและ\nสถาบันครอบครัว',
    landingPartnershipLandDevelopment: 'กรมพัฒนาที่ดิน',
    landingPartnershipDisabledEmpowerment: 'กรมส่งเสริมและพัฒนา\nคุณภาพชีวิตคนพิการ',
    landingPartnershipLandDepartment: 'กรมที่ดิน',
    landingPartnershipBangKruaiMunicipality: 'เทศบาลเมืองบางกรวย',
    landingNavPartnership: 'เครือข่ายความร่วมมือ',
    landingFeatureScaleTitle: 'รองรับผู้ใช้หลักล้าน',
    landingFeatureScaleDesc: 'สถาปัตยกรรมคลาวด์เนทีฟบนอะซัวร์ ขยายสเกลอัตโนมัติ พร้อมซิกนัลอาร์แบบเรียลไทม์',
    // การยืนยันตัวตนสองขั้นตอนด้วยรหัสโอทีพีทางอีเมล
    twoFactorAuth: 'การยืนยันตัวตนสองขั้นตอน',
    twoFactorAuthDesc: 'เมื่อเปิดใช้งาน ระบบจะส่งรหัสโอทีพีไปยังอีเมลของคุณทุกครั้งที่เข้าสู่ระบบ',
    enable2FA: 'เปิดใช้งานการยืนยันตัวตนสองขั้นตอน',
    disable2FA: 'ปิดใช้งานการยืนยันตัวตนสองขั้นตอน',
    enterOtp: 'กรอกรหัสโอทีพี',
    otpCode: 'รหัสโอทีพี',
    otpSentToEmail: 'รหัสโอทีพีถูกส่งไปยังอีเมลของคุณแล้ว',
    verifyOtp: 'ยืนยันรหัสโอทีพี',
    resendOtp: 'ส่งรหัสใหม่',
    resendIn: 'ส่งอีกครั้งใน {n} วินาที',
    twoFactorEnabledMsg: 'เปิดใช้งานการยืนยันตัวตนสองขั้นตอนเรียบร้อยแล้ว',
    twoFactorDisabledMsg: 'ปิดใช้งานการยืนยันตัวตนสองขั้นตอนเรียบร้อยแล้ว',
    otpInvalid: 'รหัสโอทีพีไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง',
    otpExpired: 'รหัสโอทีพีหมดอายุแล้ว กรุณาขอรหัสใหม่',
    otpMaxAttempts: 'กรอกรหัสผิดครบ 5 ครั้งแล้ว กรุณาเข้าสู่ระบบใหม่อีกครั้ง',
    otpNotFound: 'ไม่พบรหัสโอทีพี กรุณาขอรหัสใหม่',
    preauthExpired: 'เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่อีกครั้ง',
    twoFactorAlreadyEnabled: 'การยืนยันตัวตนสองขั้นตอนเปิดใช้งานอยู่แล้ว',
    twoFactorNotEnabled: 'การยืนยันตัวตนสองขั้นตอนยังไม่ได้เปิดใช้งาน',
    sendOtpFailed: 'ไม่สามารถส่งรหัสโอทีพีได้ กรุณาลองใหม่อีกครั้ง',
    confirmDisable2FATitle: 'ปิดใช้งานการยืนยันตัวตนสองขั้นตอน',
    confirmDisable2FAText: 'หลังปิดใช้งานแล้ว การเข้าสู่ระบบครั้งถัดไปจะไม่ต้องยืนยันรหัสโอทีพีอีก',
    twoFactorDisableFailed: 'ไม่สามารถปิดใช้งานการยืนยันตัวตนสองขั้นตอนได้ กรุณาลองใหม่อีกครั้ง',
    twoFactorRequiresPasswordNote: 'ต้องตั้งรหัสผ่านและมีอีเมลในระบบก่อน จึงจะเปิดใช้การยืนยันตัวตนแบบสองชั้นได้',
    twoFactorRequiresPasswordTitle: 'ยังเปิดใช้งานไม่ได้',
    twoFactorRequiresPasswordText: 'บัญชีของคุณเข้าสู่ระบบผ่านดิจิทัลไอดีและยังไม่มีรหัสผ่าน กรุณาตั้งรหัสผ่านและเพิ่มอีเมลให้เรียบร้อยก่อนเปิดใช้การยืนยันตัวตนแบบสองชั้น',
    twoFactorPasswordOnlyNote: 'การยืนยันตัวตนแบบสองชั้นมีผลเฉพาะการเข้าสู่ระบบด้วยชื่อผู้ใช้และรหัสผ่านเท่านั้น ไม่มีผลเมื่อเข้าสู่ระบบผ่านไทยดีหรือดีจีเอ ดิจิทัล ไอดี',

    // แก้ไขโปรไฟล์ (ฟูลสตรีมรุ่น 2)
    fs2EditProfile: 'ดูโปรไฟล์',
    fs2EditProfileTitle: 'ดูโปรไฟล์',
    fs2ProfileTabInfo: 'ข้อมูลส่วนบุคคล',
    fs2ProfileTabPassword: 'เปลี่ยนรหัสผ่าน',
    fs2ProfileTabSetPassword: 'ตั้งรหัสผ่าน',
    fs2ProfileSetPasswordHint: 'บัญชีนี้เข้าสู่ระบบด้วยดีจีเอ ดิจิทัล ไอดีหรือไทยดี และยังไม่มีรหัสผ่าน ตั้งรหัสผ่านไว้เพื่อให้สามารถยกเลิกการผูกดิจิทัลไอดีและเข้าสู่ระบบด้วยรหัสผ่านในครั้งถัดไปได้',
    fs2ProfileTabSecurity: 'ความปลอดภัย',
    fs2ProfileSsoLocked: 'ข้อมูลนี้ถูกจัดการโดยดีจีเอ ดิจิทัล ไอดีหรือไทยดี และไม่สามารถแก้ไขได้ในระบบนี้',
    fs2ProfileSaveSuccess: 'บันทึกข้อมูลสำเร็จ',
    fs2ProfileSaveError: 'บันทึกข้อมูลไม่สำเร็จ กรุณาตรวจสอบข้อมูลอีกครั้ง',
    fs2ProfileInvalidEmail: 'กรุณากรอกอีเมลให้ถูกต้อง',
    fs2ProfileInvalidPhone: 'กรุณากรอกหมายเลขโทรศัพท์ 10 หลักให้ถูกต้อง',
    fs2ProfileRequiredName: 'กรุณากรอกชื่อและนามสกุล',
    fs2ProfilePwdChanged: 'เปลี่ยนรหัสผ่านสำเร็จ',
    fs2ProfilePwdError: 'เปลี่ยนรหัสผ่านไม่สำเร็จ กรุณาตรวจสอบข้อมูล',
    fs2ProfilePwdEmpty: 'กรุณากรอกรหัสผ่านและยืนยันรหัสผ่าน',
    fs2ProfilePwdMismatch: 'รหัสผ่านและยืนยันรหัสผ่านไม่ตรงกัน',
    fs2ProfilePwdFormat: 'รหัสผ่านไม่ตรงตามเงื่อนไข กรุณาตรวจสอบอีกครั้ง',
    fs2ProfileNoPassword: 'ผู้ใช้เอสเอสโอไม่สามารถเปลี่ยนรหัสผ่านได้',
    fs2ProfileLoading: 'กำลังโหลดข้อมูลโปรไฟล์...',
    fs2ProfileLinkUnavailable: 'การผูกบัญชีจะเปิดให้ใช้งานเร็วๆ นี้',
    fs2ProfileLinkAction: 'ผูกบัญชี',
    fs2ProfileDigitalIdSection: 'การผูกบัญชีดิจิทัล',
    fs2ProfileThaiIDLabel: 'ไทยดี',
    fs2ProfileDGALabel: 'DGA Digital ID',
    fs2ProfileLinkedStatus: 'ผูกแล้ว',
    fs2ProfileNotLinkedStatus: 'ยังไม่ได้ผูก',

    landingPageConfig: {
      breadcrumbRoot: 'ผู้ดูแลระบบสูงสุด',
      title: 'จัดการเนื้อหาหน้าแนะนำระบบ',
      subtitle: 'จัดการเนื้อหาเอชทีเอ็มแอลสำหรับ 5 แผงในหน้าแนะนำระบบ',
      editButton: 'แก้ไข',
      previewButton: 'ตัวอย่าง',
      saveButton: 'บันทึกทั้งหมด',
      resetButton: 'ตั้งค่าใหม่เป็นค่าเริ่มต้น',
      charCount: '{count} ตัวอักษร',
      saveSuccess: 'บันทึกทั้งหมดสำเร็จ',
      saveError: 'บันทึกไม่สำเร็จ',
      resetSuccess: 'ตั้งค่าใหม่สำเร็จ',
      resetConfirmTitle: 'ยืนยันการตั้งค่าใหม่',
      resetConfirm: 'ข้อมูลภาษาไทยจะถูกรีเซ็ตเป็นค่าเริ่มต้น และข้อมูลภาษาอังกฤษจะถูกล้าง ต้องการดำเนินการต่อไหม?',
      previewLabel: 'แสดงตัวอย่างแถบด้านข้างหน้าเข้าสู่ระบบ',
      hint: 'เนื้อหาเหล่านี้จะแสดงในหน้าแนะนำระบบ — รองรับเอชทีเอ็มแอล',
      previewTooltip: 'สลับระหว่างโหมดแก้ไขและดูตัวอย่าง (ไม่บันทึก)',
      tab: {
        about: 'เกี่ยวกับเรา',
        aboutSubtitle: 'ข้อมูลองค์กรและพันธกิจ',
        sitemap: 'แผนผังเว็บไซต์',
        sitemapSubtitle: 'รายการลิงก์ในส่วนท้ายหน้า',
        terms: 'ข้อกำหนดและเงื่อนไข',
        termsSubtitle: 'ข้อกำหนดและเงื่อนไขสำหรับผู้ใช้',
        privacy: 'นโยบายความเป็นส่วนตัว',
        privacySubtitle: 'ประกาศความเป็นส่วนตัวตามพีดีพีเอ',
        cookie: 'นโยบายคุกกี้',
        cookieSubtitle: 'นโยบายการใช้คุกกี้ของเว็บไซต์',
      },
      lang: {
        th: 'ภาษาไทย',
        en: 'อังกฤษ',
      },
    },
    bannerPopup: {
      tab: 'แบนเนอร์/ป๊อปอัป',
      settings: {
        title: 'การตั้งค่าทั่วไป',
        subtitle: 'เปิด/ปิดการแสดงผล เลือกหน้าที่จะแสดง และระยะห่างจากขอบจอ',
        save: 'บันทึกการตั้งค่า',
        saved: 'บันทึกการตั้งค่าเรียบร้อย',
        saveError: 'บันทึกการตั้งค่าไม่สำเร็จ',
        enabledOn: 'เปิดใช้งานแบนเนอร์',
        enabledOff: 'ปิดใช้งานแบนเนอร์',
        pages: 'หน้าที่จะแสดงแบนเนอร์',
        pagesHint: 'เลือกได้หลายหน้า แบนเนอร์ที่ใช้งานอยู่จะแสดงในหน้าที่เลือกไว้',
        enabledTooltip: 'เปิด/ปิดการแสดงแบนเนอร์ทั้งระบบ',
        pageToggleTooltip: 'คลิกเพื่อเลือก/ยกเลิกหน้าที่จะแสดงแบนเนอร์',
      },
      pages: {
        login: 'เข้าสู่ระบบ',
        productAdmin: 'หน้าผู้ดูแลระบบ (Product Admin)',
        portal: 'หน้าพอร์ทัล',
        fullsnippet: 'หน้าแชท (ฟูลสนิปเพ็ต)',
        landing: 'หน้าแนะนำระบบ',
      },
      gallery: {
        title: 'คลังแบนเนอร์',
        subtitle: 'อัปโหลดได้หลายรูป แต่เลือกแสดงได้ครั้งละ 1 รูป',
        add: 'เพิ่มแบนเนอร์',
        empty: 'ยังไม่มีแบนเนอร์ กดเพิ่มแบนเนอร์เพื่อเริ่มต้น',
        active: 'กำลังแสดง',
        untitled: '(ไม่มีชื่อ)',
        use: 'เลือกใช้',
        inUse: 'กำลังแสดง',
        activated: 'ตั้งเป็นแบนเนอร์ที่แสดงแล้ว',
        activateError: 'ตั้งค่าไม่สำเร็จ',
        editTooltip: 'แก้ไขแบนเนอร์นี้',
        deleteTooltip: 'ลบแบนเนอร์นี้',
        useTooltip: 'ตั้งให้แบนเนอร์นี้เป็นตัวที่แสดง (แสดงได้ครั้งละ 1 รูป)',
      },
      form: {
        createTitle: 'เพิ่มแบนเนอร์',
        editTitle: 'แก้ไขแบนเนอร์',
        image: 'รูปภาพ',
        imageHint: 'รองรับ .png .jpg .jpeg .webp ขนาดไม่เกิน 5 เมกะไบต์',
        uploading: 'กำลังอัปโหลด...',
        titleField: 'ชื่อ/คำอธิบาย (สำหรับผู้ดูแลระบบจำ)',
        altField: 'ข้อความแทนภาพ',
        linkField: 'ลิงก์เมื่อคลิกแบนเนอร์ (ถ้ามี)',
        createBtn: 'เพิ่ม',
        invalidType: 'นามสกุลไฟล์ไม่รองรับ',
        tooLarge: 'ขนาดไฟล์เกิน {mb} เมกะไบต์',
        uploadError: 'อัปโหลดรูปไม่สำเร็จ',
        created: 'เพิ่มแบนเนอร์เรียบร้อย',
        updated: 'แก้ไขแบนเนอร์เรียบร้อย',
        saveError: 'บันทึกไม่สำเร็จ',
        clearImageTooltip: 'ลบรูปที่เลือก',
      },
      delete: {
        title: 'ยืนยันการลบ',
        confirm: 'ต้องการลบแบนเนอร์นี้ใช่ไหม?',
        btn: 'ลบ',
        deleted: 'ลบแบนเนอร์เรียบร้อย',
        error: 'ลบไม่สำเร็จ',
      },
    },
    _km_share: 'แชร์',
    _km_share_title: 'แชร์เอกสารข้ามบริษัท',
    _km_shared_from: 'แชร์จาก',
    _km_permissions: 'สิทธิ์ที่ได้รับ',
    _km_perm_view: 'ดู / ถามตอบ',
    _km_perm_edit: 'แก้ไข',
    _km_perm_delete: 'ลบ',
    _km_perm_update_failed: 'อัปเดตสิทธิ์ไม่สำเร็จ',
    _km_share_document: 'เอกสาร',
    _km_share_targets: 'บริษัทที่แชร์ให้',
    _km_share_select_all: 'เลือกทั้งหมด',
    _km_share_clear_all: 'ล้างทั้งหมด',
    _km_share_selected_count: 'เลือกแล้ว {count} บริษัท',
    _km_share_select_companies: 'เลือกบริษัทที่จะแชร์ให้',
    _km_share_no_children: 'ไม่มีบริษัทให้แชร์',
    _km_share_saved: 'บันทึกการแชร์เรียบร้อย',
    _km_share_revoked: 'ถอนการแชร์เรียบร้อย',
    _km_share_name_clash: 'บริษัทต่อไปนี้มีเอกสารชื่อซ้ำอยู่แล้ว จึงแชร์ไม่ได้ — กรุณาเปลี่ยนชื่อก่อน',
    _km_share_current: 'แชร์อยู่ปัจจุบัน',
    _km_revoke: 'ถอนการแชร์',
    _km_shared_banner: 'เอกสารนี้แชร์มาจาก',
    _km_no_permission: 'คุณไม่มีสิทธิ์ดำเนินการนี้กับเอกสารที่แชร์มา',
    _km_delete_will_revoke: 'การลบจะถอนการแชร์ออกจากทุกบริษัทที่แชร์ให้โดยอัตโนมัติ',
    _km_confirm_revoke: 'ยืนยันการถอนแชร์บริษัทนี้?',
    _km_shared_out: 'แชร์ให้ {count} บริษัท',
    _km_key_title: 'รหัสแชร์ของบริษัท',
    _km_key_desc: 'ให้รหัสนี้กับบริษัทอื่นเพื่อให้เขาแชร์เอกสารเข้ามาที่บริษัทของคุณ — รหัสมีอายุการใช้งาน 1 วัน',
    _km_key_generate: 'สร้างรหัส',
    _km_key_regenerate: 'สร้างใหม่',
    _km_key_copy: 'คัดลอก',
    _km_key_copied: 'คัดลอกแล้ว',
    _km_key_expires: 'หมดอายุ {date}',
    _km_key_none: 'ยังไม่มีรหัสที่ใช้งานได้',
    _km_key_enter: 'กรอกรหัสของบริษัทปลายทาง',
    _km_key_validate: 'ตรวจสอบ',
    _km_key_invalid: 'รหัสไม่ถูกต้องหรือหมดอายุ',
    _km_key_target_company: 'บริษัทปลายทาง',
    _km_key_generated_by: 'สร้างโดย',
    _km_key_self_share: 'ไม่สามารถแชร์เข้าบริษัทตัวเอง',
    _km_share_pending: 'รอยอมรับ',
    _km_accept: 'ยอมรับ',
    _km_reject: 'ปฏิเสธ',
    _km_accept_before_open: 'กรุณากดยอมรับเอกสารที่แชร์เข้ามาก่อน จึงจะเปิดดู/เพิ่มข้อมูล/นำเข้าเอกสารได้',
    _km_accept_confirm: 'ยอมรับเอกสารที่แชร์เข้ามานี้?',
    _km_reject_confirm: 'ปฏิเสธและลบเอกสารที่แชร์เข้ามานี้?',
    _km_accepted: 'ยอมรับแล้ว',
    _km_rejected: 'ปฏิเสธแล้ว',
    _km_key_expired: 'รหัสหมดอายุ',
    _km_cancel_shared: 'ยกเลิกเอกสารนี้',
    _km_cancel_shared_confirm: 'ยกเลิกและลบเอกสารที่แชร์เข้ามานี้ออกจากบริษัทของคุณ?',
    _km_cancel_shared_done: 'ยกเลิกเอกสารที่แชร์แล้ว',
    _km_manage_shares: 'จัดการการแชร์',
    _km_manage_shares_title: 'บริษัทที่แชร์เอกสารนี้ให้',
    _km_revoke_confirm: 'ถอนการแชร์เอกสารนี้จากบริษัทนี้?',
    _km_revoked: 'ถอนการแชร์แล้ว',
    _km_manage_no_targets: 'ยังไม่ได้แชร์เอกสารนี้ให้บริษัทใด',
    _km_search_company: 'ค้นหาชื่อบริษัท',
        'gmm_import': "นำเข้า",
    'gmm_importFileConfiguration': "นำเข้าไฟล์การตั้งค่า",
    'gmm_create': "สร้าง",
    'gmm_createNewGptModel': "สร้างโมเดล GPT ใหม่",
    'gmm_modelId': "รหัสโมเดล",
    'gmm_modelName': "ชื่อโมเดล",
    'gmm_search': "ค้นหา",
    'gmm_publish': "เผยแพร่",
    'gmm_draft': "แบบร่าง",
    'gmm_modelRequired': "โมเดล*",
    'gmm_restore': "กู้คืน",
    'gmm_view': "ดู",
    'gmm_loading': "กำลังโหลด...",
    'gmm_pleaseWait': "กรุณารอสักครู่",
    'gmm_provider': "ผู้ให้บริการ",
    'gmm_model': "โมเดล",
    'gmm_createBy': "สร้างโดย",
    'gmm_status': "สถานะ",
    'gmm_version': "เวอร์ชัน",
    'gmm_modified': "แก้ไขล่าสุด",
    'gmm_modifiedBy': "แก้ไขโดย",
    'kgl_subtitle': "เชื่อมต่อกับบริการ NEXA · กราฟถูกจำกัดขอบเขตตามบริษัทของคุณ",
    'kgl_refresh': "รีเฟรช",
    'kgl_searchPlaceholder': "ค้นหาด้วยชื่อหรือคำอธิบาย…",
    'kgl_unnamed': "(ไม่มีชื่อ)",
    'kgl_clickToEdit': "คลิกเพื่อแก้ไข",
    'kgl_clickToAddDescription': "คลิกเพื่อเพิ่มคำอธิบาย",
    'kgl_edit': "แก้ไข",
    'kgl_delete': "ลบ",
    'kgl_emptyTitle': "ยังไม่มีกราฟความรู้",
    'kgl_emptySubtitlePrefix': "คลิก",
    'kgl_emptySubtitleSuffix': "เพื่อเพิ่มรายการแรกของคุณ",
    'kgl_create': "สร้าง",
    'kgl_cancel': "ยกเลิก",
    'kgl_name': "ชื่อ",
    'kgl_required': "จำเป็นต้องกรอก",
    'kgl_descriptionOptional': "คำอธิบาย (ไม่บังคับ)",
    'kgl_editKnowledgeGraph': "แก้ไขกราฟความรู้",
    'kgl_save': "บันทึก",
    'kgl_description': "คำอธิบาย",
    'kgl_descriptionPlaceholder': "กราฟนี้เกี่ยวกับอะไร?",
    'kgl_deleteKnowledgeGraph': "ลบกราฟความรู้",
    'kgl_deleteConfirmMessage': "ลบ {name}? การดำเนินการนี้จะลบกราฟออกจากบริการ NEXA อย่างถาวรและไม่สามารถย้อนกลับได้",
    'kgl_colName': "ชื่อ",
    'kgl_colCompany': "บริษัท",
    'kgl_colDescription': "คำอธิบาย",
    'kgl_colActions': "การดำเนินการ",
    'logv_pageTitle': "บันทึกกิจกรรม",
    'logv_logId': "รหัสบันทึก",
    'logv_ipAddress': "ที่อยู่ IP",
    'logv_logType': "ประเภทบันทึก",
    'logv_methodName': "ชื่อเมธอด",
    'logv_exception': "ข้อผิดพลาด",
    'logv_logTrace': "ร่องรอยบันทึก",
    'logv_loadingPleaseWait': "กำลังโหลด กรุณารอสักครู่...",
    'levt_startDate': "วันที่เริ่มต้น",
    'levt_endDate': "วันที่สิ้นสุด",
    'levt_active': "ใช้งานอยู่",
    'levt_apiName': "ชื่อ API",
    'levt_createBy': "สร้างโดย",
    'levt_action': "การดำเนินการ",
    'levt_all': "ทั้งหมด",
    'levt_login': "เข้าสู่ระบบ",
    'levt_statusCode': "รหัสสถานะ",
    'levt_statusApi': "สถานะ API",
    'levt_viewDetails': "ดูรายละเอียด",
    'levt_colNo': "ลำดับ",
    'levt_colApiName': "ชื่อ API",
    'levt_colAction': "การดำเนินการ",
    'levt_colStatusCode': "รหัสสถานะ",
    'levt_colStatusApi': "สถานะ API",
    'levt_colMessage': "ข้อความ",
    'levt_colIpAddress': "ที่อยู่ IP",
    'levt_colCreateBy': "สร้างโดย",
    'levt_colCreateDate': "วันที่สร้าง",
    'rts_tokenSummation': "สรุปโทเค็น",
    'rts_downloadReport': "ดาวน์โหลดรายงาน",
    'rts_reportManagementTitle': "การจัดการรายงานสรุปโทเค็น",
    'rts_modelFilters': "ตัวกรองโมเดล",
    'rts_modelId': "รหัสโมเดล",
    'rts_enterModelId': "กรอกรหัสโมเดล",
    'rts_enterModelIdTooltip': "กรอกรหัสโมเดลเพื่อกรองผลลัพธ์",
    'rts_modelName': "ชื่อโมเดล",
    'rts_enterModelName': "กรอกชื่อโมเดล",
    'rts_enterModelNameTooltip': "กรอกชื่อโมเดลเพื่อกรองผลลัพธ์",
    'rts_statistics': "สถิติ",
    'rts_models': "โมเดล",
    'rts_dateRange': "ช่วงวันที่",
    'rts_startDate': "วันที่เริ่มต้น",
    'rts_selectStartDateTooltip': "เลือกวันที่เริ่มต้นสำหรับรายงาน",
    'rts_endDate': "วันที่สิ้นสุด",
    'rts_selectEndDateTooltip': "เลือกวันที่สิ้นสุดสำหรับรายงาน",
    'rts_search': "ค้นหา",
    'rts_tokenSummationDataRecords': "ข้อมูลสรุปโทเค็น ({count} รายการ)",
    'rts_loading': "กำลังโหลด...",
    'rts_pleaseWait': "กรุณารอสักครู่",
    'rts_colNo': "ลำดับ",
    'rts_colModel': "โมเดล",
    'rts_colLlm': "LLM",
    'rts_inputTokens': "โทเค็นขาเข้า",
    'rts_outputTokens': "โทเค็นขาออก",
    'rts_totalTokens': "โทเค็นรวม",
    'rts_imageGen': "สร้างรูปภาพ",
    'rts_cached': "แคช",
    'rts_reasoning': "การให้เหตุผล",
    'ucsv_refresh': "รีเฟรช",
    'ucsv_documentName': "ชื่อเอกสาร",
    'ucsv_search': "ค้นหา",
    'ucsv_togglePersonalInfoDetection': "เปิด/ปิดการตรวจจับข้อมูลส่วนบุคคล",
    'ucsv_reprocessDocument': "ประมวลผลเอกสารใหม่",
    'ucsv_edit': "แก้ไข",
    'ucsv_vectordbNameRequired': "ชื่อ vectordbName*",
    'ucsv_vectorRequired': "เวกเตอร์*",
    'ucsv_restore': "กู้คืน",
    'ucsv_view': "ดู",
    'ucsv_loading': "กำลังโหลด...",
    'ucsv_pleaseWait': "กรุณารอสักครู่",
    'ucsv_createBy': "สร้างโดย",
    'ucsv_personalInfo': "ข้อมูลส่วนบุคคล",
    'ucsv_process': "ประมวลผล",
    'ucsv_reprocess': "ประมวลผลใหม่",
    'ucsv_action': "การดำเนินการ",
    'ucsv_version': "เวอร์ชัน",
    'ucsv_modified': "แก้ไขล่าสุด",
    'ucsv_modifiedBy': "แก้ไขโดย",
    'ucsv_pleaseFillAllFields': "กรุณากรอกข้อมูลให้ครบทุกช่อง",
    'ucsv_pleaseEnterCorrectFormat': "กรุณากรอกข้อมูลให้ถูกต้องตามรูปแบบ",
    'vpos_positiveNamePlaceholder': "ชื่อชุดคำถามเชิงบวก",
    'vpos_loading': "กำลังโหลด...",
    'vpos_pleaseWait': "กรุณารอสักครู่",
    'vpos_positiveQuestionSetColumn': "ชุดคำถามเชิงบวก",
    'vpos_createByColumn': "สร้างโดย",
        'flst_flowManagement': "จัดการโฟลว์",
    'flst_create': "สร้าง",
    'flst_search': "ค้นหา",
    'flst_viewFlow': "ดูโฟลว์",
    'flst_editFlow': "แก้ไขโฟลว์",
    'flst_exportFlow': "ส่งออกโฟลว์",
    'flst_versionHistory': "ประวัติเวอร์ชัน",
    'flst_deleteFlow': "ลบโฟลว์",
    'flst_deleteOwnOnly': "คุณสามารถลบได้เฉพาะโฟลว์ที่คุณสร้างเท่านั้น",
    'flst_confirmDelete': "ยืนยันการลบ",
    'flst_confirmDeleteMessage': "คุณแน่ใจหรือไม่ว่าต้องการลบโฟลว์ \"{name}\"? การกระทำนี้ไม่สามารถย้อนกลับได้",
    'flst_cancel': "ยกเลิก",
    'flst_close': "ปิด",
    'flst_deletedSuccessfully': "ลบสำเร็จ!",
    'flst_flowLabel': "โฟลว์",
    'flst_operationLabel': "การดำเนินการ",
    'flst_delete': "ลบ",
    'flst_ok': "ตกลง",
    'flst_current': "ปัจจุบัน",
    'flst_currentVersion': "เวอร์ชันปัจจุบัน",
    'flst_restoreThisVersion': "กู้คืนเวอร์ชันนี้",
    'flst_noPermissionToRestore': "ไม่มีสิทธิ์กู้คืน",
    'flst_noVersionHistory': "ไม่มีประวัติเวอร์ชัน",
    'flst_noVersionHistorySubtitle': "โฟลว์นี้ไม่มีประวัติเวอร์ชันให้แสดง",
    'flst_restoreVersion': "กู้คืนเวอร์ชัน",
    'flst_restoreVersionSubtitle': "การดำเนินการนี้จะสร้างเวอร์ชันใหม่จากเวอร์ชันที่เลือก",
    'flst_restoringVersionPrefix': "กำลังกู้คืน",
    'flst_versionLabel': "เวอร์ชัน",
    'flst_restoringVersionSuffix': "จะสร้างเวอร์ชันใหม่จากการตั้งค่าของเวอร์ชันนั้น",
    'flst_versionNoteOptional': "หมายเหตุเวอร์ชัน (ไม่บังคับ)",
    'flst_versionNotePlaceholder': "อธิบายเหตุผลที่คุณกู้คืนเวอร์ชันนี้...",
    'flst_loading': "กำลังโหลด...",
    'flst_pleaseWait': "กรุณารอสักครู่",
    'flst_failedToLoadFlows': "โหลดรายการโฟลว์ไม่สำเร็จ",
    'flst_flowExportedSuccessfully': "ส่งออกโฟลว์ \"{name}\" สำเร็จ",
    'flst_failedToGetFlowDataForExport': "ไม่สามารถดึงข้อมูลโฟลว์เพื่อส่งออกได้",
    'flst_failedToExportFlow': "ส่งออกโฟลว์ไม่สำเร็จ",
    'flst_canOnlyDeleteOwnFlows': "คุณสามารถลบได้เฉพาะโฟลว์ที่คุณสร้างเท่านั้น",
    'flst_notAuthorizedToDelete': "คุณไม่มีสิทธิ์ลบโฟลว์นี้",
    'flst_flowDeletedSuccessfully': "ลบโฟลว์ \"{name}\" สำเร็จ",
    'flst_failedToDeleteFlow': "ลบโฟลว์ไม่สำเร็จ",
    'flst_failedToLoadVersionHistory': "โหลดประวัติเวอร์ชันไม่สำเร็จ",
    'flst_restoredFromVersion': "กู้คืนจากเวอร์ชัน {version}",
    'flst_versionRestoredSuccessfully': "กู้คืนเวอร์ชัน {version} สำเร็จ",
    'flst_versionDeletedCannotRestore': "เวอร์ชันนี้ถูกลบไปแล้วและไม่สามารถกู้คืนได้",
    'flst_noPermissionToRestoreVersion': "คุณไม่มีสิทธิ์กู้คืนเวอร์ชันนี้",
    'flst_failedToRestoreVersion': "กู้คืนเวอร์ชันไม่สำเร็จ",
    'flst_failedToRestoreVersionWithReason': "กู้คืนเวอร์ชันไม่สำเร็จ: {reason}",
    'flst_unknownError': "ข้อผิดพลาดที่ไม่ทราบสาเหตุ",
        'lmsg_logManagement': "การจัดการบันทึก",
    'lmsg_startDate': "วันที่เริ่มต้น",
    'lmsg_selectStartDateFilter': "เลือกวันที่เริ่มต้นสำหรับการกรอง",
    'lmsg_endDate': "วันที่สิ้นสุด",
    'lmsg_selectEndDateFilter': "เลือกวันที่สิ้นสุดสำหรับการกรอง",
    'lmsg_userChannel': "ช่องทางผู้ใช้",
    'lmsg_sessionId': "รหัสเซสชัน",
    'lmsg_exportLogMessage': "ส่งออกบันทึกข้อความ",
    'lmsg_exportLogMonitoring': "ส่งออกบันทึกการติดตาม",
    'lmsg_exportToQuestionSet': "ส่งออกไปยังชุดคำถาม",
    'lmsg_logDataRecords': "ข้อมูลบันทึก ({n} รายการ)",
    'lmsg_viewFlow': "ดูโฟลว์",
    'lmsg_flowVisualization': "การแสดงผลโฟลว์",
    'lmsg_stepByStepTracking': "การติดตามการทำงานทีละขั้นตอน",
    'lmsg_main': "หลัก",
    'lmsg_parallel': "ขนาน",
    'lmsg_selected': "เลือกแล้ว",
    'lmsg_selectNodeToViewDetails': "เลือกโหนดเพื่อดูรายละเอียด",
    'lmsg_clickNodeHint': "คลิกที่โหนดด้านบนเพื่อดูข้อมูล input/output และเวลาในการทำงาน",
    'lmsg_details': "รายละเอียด",
    'lmsg_inputData': "ข้อมูลนำเข้า",
    'lmsg_outputData': "ข้อมูลนำออก",
    'mdata_addModel': "เพิ่มโมเดล",
    'mdata_loadingModels': "กำลังโหลดโมเดล...",
    'mdata_textBased': "ข้อความ",
    'mdata_textToImage': "ข้อความเป็นรูปภาพ",
    'mdata_per1kTokens': "ต่อ 1,000 โทเค็น",
    'mdata_perImage': "ต่อรูปภาพ",
    'mdata_addNewModel': "เพิ่มโมเดลใหม่",
    'mdata_addNewModelSubtitle': "กำหนดค่าโมเดล AI ใหม่สำหรับแชทบอทของคุณ",
    'mdata_basicInformation': "ข้อมูลพื้นฐาน",
    'mdata_modelType': "ประเภทโมเดล",
    'mdata_modelConfiguration': "การตั้งค่าโมเดล",
    'mdata_displayName': "ชื่อที่แสดง",
    'mdata_apiVersion': "เวอร์ชัน API",
    'mdata_maxToken': "โทเค็นสูงสุด",
    'mdata_endpointUrl': "URL ปลายทาง",
    'mdata_authenticationHeaderName': "ชื่อ Header สำหรับยืนยันตัวตน",
    'mdata_authHeaderNameHint': "ชื่อของ header ที่ใช้สำหรับยืนยันตัวตน",
    'mdata_apiKey': "API Key",
    'mdata_pricingConfiguration': "การกำหนดค่าราคา",
    'mdata_inputPriceUsd': "ราคาอินพุต (USD)",
    'mdata_outputPriceUsd': "ราคาเอาต์พุต (USD)",
    'mdata_imagePriceUsd': "ราคารูปภาพ (USD)",
    'mdata_imageGenerationOptions': "ตัวเลือกการสร้างรูปภาพ",
    'mdata_quality': "คุณภาพ",
    'mdata_resolution': "ความละเอียด",
    'mdata_additionalOptions': "ตัวเลือกเพิ่มเติม",
    'mdata_fileUploadSupport': "รองรับการอัปโหลดไฟล์",
    'mdata_allowFileUploadsHint': "อนุญาตให้อัปโหลดไฟล์กับโมเดลนี้",
    'mdata_reasoningEffort': "ระดับการให้เหตุผล",
    'mdata_enableAdvancedReasoningHint': "เปิดใช้งานความสามารถการให้เหตุผลขั้นสูง",
    'mdata_jsonConfiguration': "การตั้งค่า JSON",
    'mdata_systemPromptFormatTitle': "รูปแบบ System Prompt (OpenAI o1+)",
    'mdata_roleNote': "กำหนดบทบาทของระบบเพื่อบริบทที่ดีขึ้น",
    'mdata_maxCompletionTokensNote': "ความยาวสูงสุดของคำตอบ",
    'mdata_streamNote': "เปิดใช้งานการตอบกลับแบบสตรีม",
    'mdata_invalidJsonFormat': "รูปแบบ JSON ไม่ถูกต้อง กรุณาตรวจสอบไวยากรณ์",
    'mdata_addValue': "เพิ่มค่า",
    'mdata_updateModelSubtitle': "อัปเดตการกำหนดค่าและการตั้งค่าของโมเดล",
    'mdata_selectAiProviderHint': "เลือกผู้ให้บริการ AI",
    'mdata_chooseModelTypeHint': "เลือกประเภทของโมเดล",
    'mdata_friendlyNameHint': "ชื่อที่ใช้แสดงผลอย่างเป็นมิตร",
    'saCore_gptConfiguration': "การตั้งค่า GPT",
    'saCore_azureOpenAIEndpoints': "Azure OpenAI Endpoints",
    'saCore_priority': "ลำดับความสำคัญ",
    'saCore_azureOpenAIUrl': "Azure OpenAI URL",
    'saCore_apiKey': "API Key",
    'saCore_embeddingConfiguration': "การตั้งค่า Embedding",
    'saCore_embeddingLoadBalance': "Embedding Load Balance",
    'saCore_on': "เปิด",
    'saCore_off': "ปิด",
    'saCore_azureOpenAIEmbeddingUrl': "Azure OpenAI Embedding URL",
    'saCore_azureOpenAIEmbeddingApiKey': "Azure OpenAI Embedding API Key",
    'saCore_azureOpenAIEmbeddingApiVersion': "Azure OpenAI Embedding API Version",
    'saCore_azureOpenAIEmbeddingType': "ประเภท AzureOpenAI Embedding",
    'saCore_gptModeConfiguration': "การตั้งค่าโหมด GPT",
    'saCore_gptMode': "โหมด GPT",
    'saCore_priorityMode': "ลำดับความสำคัญ",
    'saCore_fastMode': "โหมดเร็ว",
    'saCore_repeatTimeMinutes': "เวลาที่ทำซ้ำ (นาที)*",
    'saCore_modelRequired': "โมเดล*",
    'saCore_testOfQuestions': "คำถามทดสอบ*",
    'saCore_no': "ลำดับ",
    'saCore_responseTimeMs': "เวลาตอบสนอง (มิลลิวินาที)",
    'saCore_answers': "คำตอบ",
    'saCore_nexaKnowledgeGraphService': "บริการ NEXA Knowledge Graph",
    'saCore_nexaConnectionSettingsHint': "การตั้งค่าการเชื่อมต่อสำหรับบริการ NEXA แบบฝังตัว",
    'saCore_nexaBaseUrl': "NEXA Base URL",
    'saCore_nexaBaseUrlHint': "ตำแหน่งที่ ChatFramework เข้าถึงบริการ NEXA",
    'saCore_nexaSsoTokenTtl': "อายุ SSO Token (วินาที)",
    'saCore_nexaSsoTokenTtlHint': "ค่าเริ่มต้น 28800 (8 ชั่วโมง)",
    'saCore_nexaSsoSharedSecret': "SSO Shared Secret",
    'saCore_nexaSsoSharedSecretPlaceholder': "กรอก HMAC secret ที่ใช้ร่วมกัน",
    'saCore_nexaSsoSharedSecretHint': "ต้องตรงกับ CF_SSO_SHARED_SECRET ฝั่ง NEXA",
    'saCore_openAiConfig': "การตั้งค่า Open AI",
    'saCore_openAiUrl': "Open AI URL",
    'saCore_openAiKey': "Open AI Key",
    'saCore_blobConfig': "การตั้งค่า Blob",
    'saCore_azureStorageConnection': "การเชื่อมต่อ Azure Storage",
    'saCore_azureContainer': "Azure Container",
    'saCore_azureStorageConnectionPdfVector': "การเชื่อมต่อ Azure Storage PDFVector",
    'saCore_azureContainerPdfVector': "Azure Container PDFVector",
    'saCore_azureStorageConnectionGptVision': "การเชื่อมต่อ Azure Storage GPT Vision",
    'saCore_azureContainerGptVision': "Azure Container GPT Vision",
    'saCore_azureStorageSpeechDocument': "Azure Storage เอกสารเสียง (Speech)",
    'saCore_azureContainerSpeechDocument': "Azure Container เอกสารเสียง (Speech)",
    'saCore_azureStorageQuickReplyIcon': "Azure Storage ไอคอน Quick Reply",
    'saCore_azureContainerQuickReplyIcon': "Azure Container ไอคอน Quick Reply",
    'saCore_azureStorageSnippetIcon': "Azure Storage ไอคอน Snippet",
    'saCore_azureContainerSnippetIcon': "Azure Container ไอคอน Snippet",
    'saCore_languageTranslator': "ตัวแปลภาษา",
    'saCore_languageTranslatorEndpoint': "เอนด์พอยต์บริการแปลภาษา",
    'saCore_languageTranslatorKey': "Key บริการแปลภาษา",
    'saCore_languageTranslatorLocation': "ตำแหน่งบริการแปลภาษา (Location)",
    'saCore_languageService': "บริการภาษา",
    'saCore_languageServiceEndpoint': "เอนด์พอยต์ของบริการภาษา",
    'saCore_languageServiceKey': "Key ของบริการภาษา",
    'saCore_speechToTextConfig': "การตั้งค่า Speech to text",
    'saCore_speechToTextKey': "Speech to Text Key",
    'saCore_speechToTextRegion': "ภูมิภาคแปลงเสียงเป็นข้อความ (Speech to Text Region)",
    'saCore_speechToTextLanguage': "ภาษาแปลงเสียงเป็นข้อความ (Speech to Text)",
    'saCore_pathFFMpeg': "พาธ FFMpeg",
    'saCore_pathFFMpegLocal': "พาธ FFMpeg (Local)",
    'saCore_mailConfiguration': "การตั้งค่าอีเมล",
    'saCore_emailSendingMethod': "วิธีการส่งอีเมล",
    'saCore_emailSendingMethodRequired': "วิธีการส่งอีเมล *",
    'saCore_smtpProviderRequired': "ผู้ให้บริการ SMTP *",
    'saCore_authenticationMethod': "วิธีการยืนยันตัวตน",
    'saCore_oauth2Required': "OAuth2 (จำเป็น)",
    'saCore_basicAuth': "Basic Auth",
    'saCore_serverSettings': "การตั้งค่าเซิร์ฟเวอร์",
    'saCore_smtpHostRequired': "SMTP Host *",
    'saCore_smtpPortRequired': "SMTP Port *",
    'saCore_enableSsl': "เปิดใช้งาน SSL",
    'saCore_timeoutMs': "Timeout (มิลลิวินาที)",
    'saCore_fromEmailSettings': "การตั้งค่าอีเมลผู้ส่ง",
    'saCore_emailAddressFromRequired': "ที่อยู่อีเมล (ผู้ส่ง) *",
    'saCore_emailAddressFromHint': "ที่อยู่อีเมลที่ใช้ในการส่งอีเมล",
    'saCore_displayNameRequired': "ชื่อที่แสดง *",
    'saCore_displayNameHint': "ชื่อที่แสดงให้ผู้รับเห็น",
    'saCore_authentication': "การยืนยันตัวตน",
    'saCore_requiresAppPassword': "ต้องใช้ App Password",
    'saCore_appPasswordRequired': "App Password *",
    'saCore_passwordRequired': "รหัสผ่าน *",
    'saCore_gmailWith2fa': "Gmail ที่เปิด 2FA",
    'saCore_gmailAppPasswordHint': "คุณต้องสร้าง App Password จากการตั้งค่าบัญชี Google ของคุณ",
    'saCore_learnCreateAppPassword': "ดูวิธีสร้าง App Password",
    'saCore_oauth2Configuration': "การตั้งค่า OAuth2",
    'saCore_requiredForOffice365': "จำเป็นสำหรับ Office 365",
    'saCore_office365Oauth2Setup': "การตั้งค่า Office 365 OAuth2",
    'saCore_office365Oauth2SetupHint': "คุณต้องลงทะเบียนแอปพลิเคชันใน Microsoft Entra ID (Azure AD)",
    'saCore_viewMicrosoftDocs': "ดูเอกสารของ Microsoft",
    'saCore_tenantIdRequired': "Tenant ID *",
    'saCore_clientIdRequired': "Client ID *",
    'saCore_clientSecretRequired': "Client Secret *",
    'saCore_mailgunConfiguration': "การตั้งค่า Mailgun",
    'saCore_mailgunApiUrlRequired': "Mailgun API URL *",
    'saCore_mailgunApiUrlHint': "ตัวอย่างเช่น https://api.mailgun.net/v3/your-domain.com",
    'saCore_mailgunApiKeyRequired': "Mailgun API Key *",
    'saCore_fromEmailRequired': "อีเมลผู้ส่ง *",
    'saCore_fromEmailFormatHint': "รูปแบบ: ชื่อที่แสดง <email{'@'}domain.com>",
    'saCore_autoConfiguration': "การตั้งค่าอัตโนมัติ",
    'saCore_stream': "สตรีม",
    'saCore_auto': "อัตโนมัติ",
    'saCore_notAuto': "ไม่อัตโนมัติ",
    'saCore_anonymous': "ไม่ระบุตัวตน",
    'saCore_enable': "เปิดใช้งาน",
    'saCore_disable': "ปิดใช้งาน",
    'saCore_timeDelay': "หน่วงเวลา",
    'saCore_limitedCharacters': "จำกัดจำนวนตัวอักษร",
    'saCore_forceDisableGpt': "บังคับปิดใช้งาน GPT",
    'saCore_autoDisableGpt': "ปิดใช้งาน GPT อัตโนมัติ",
    'saCore_gptAutoDisableDatePeriod': "ช่วงวันที่ปิดใช้งาน GPT อัตโนมัติ",
    'saCore_gptAutoDisableMessage': "ข้อความเมื่อปิดใช้งาน GPT อัตโนมัติ",
    'saCore_gptAutoDisablePricingUsd': "ราคาปิดใช้งาน GPT อัตโนมัติ (USD)",
    'saCore_googleConfiguration': "การตั้งค่า Google",
    'saCore_projectId': "รหัสโปรเจกต์ (Project ID)",
    'saCore_locationId': "Location ID",
    'saCore_jsonCredential': "JSON Credential",
    'saCore_anthropicConfig': "การตั้งค่า Anthropic",
    'saCore_anthropicClaudeApiKey': "AnthropicClaude API Key",
    'saCore_singleSignOn': "การเข้าสู่ระบบครั้งเดียว (Single Sign-On)",
    'saCore_singleSignOnProvider': "การเข้าสู่ระบบครั้งเดียว (Single Sign-On)",
    'saCore_open': "เปิด",
    'saCore_close': "ปิด",
    'saCore_inChat': "ในแชท",
    'saCore_instance': "อินสแตนซ์ (Instance)",
    'saCore_domain': "โดเมน",
    'saCore_tenantId': "Tenant ID",
    'saCore_clientId': "Client ID",
    'saCore_priorityMustBeUnique': "กรุณาตั้ง Priority ของ Azure OpenAI Endpoint ให้ไม่ซ้ำกัน",
    'saCore_failedToReadFile': "อ่านไฟล์ไม่สำเร็จ",
    'saPersona_pageTitle': "ตั้งค่า Persona API",
    'saPersona_pageSubtitle': "ตั้งค่าการเชื่อมต่อ GDX (Government Data Exchange) สำหรับดึงข้อมูลสิทธิ/สวัสดิการรายบุคคล",
    'saPersona_section1Title': "1. Company Entitlement — เปิดสิทธิใช้เพอร์โซนาต่อบริษัทลูก",
    'saPersona_section1Hint': "บริษัทลูกจะเรียกใช้เพอร์โซนา/GDX ได้ ก็ต่อเมื่อถูก \"เปิด\" ที่นี่เท่านั้น (fail-closed — ปิดไว้เป็นค่าเริ่มต้น). ช่อง Allowed Services เว้นว่าง = ทุกบริการที่ระบบรองรับ; หรือเลือกเฉพาะบาง service จากรายการ (ดึงจากหัวข้อ 4 Service Master). ต้องเป็น <b>code เต็ม</b> เช่น <code>DEP001</code>, <code>DEP002</code> — ตัวย่อหน่วยงานอย่าง <code>DEP</code> จะไม่ match บริการใดเลย. ทุกการเปลี่ยนถูกบันทึกใน EventLog เพื่อสอบกลับ.",
    'saPersona_allowedServicesPlaceholder': "ทุกบริการ (เว้นว่าง)",
    'saPersona_allowedServicesNoData': "ยังไม่มี Service — เพิ่มที่หัวข้อ 4 (Service Master) ก่อน",
    'saPersona_on': "เปิด",
    'saPersona_off': "ปิด",
    'saPersona_noCompanyFound': "ไม่พบบริษัท",
    'saPersona_section2Title': "2. GDX Welfare API — การเชื่อมต่อและแคช (Connection & Cache)",
    'saPersona_providerLabel': "ผู้ให้บริการ",
    'saPersona_providerHint': "mock = ข้อมูลจำลอง, real = GDX จริง",
    'saPersona_baseUrlLabel': "Base URL",
    'saPersona_defaultCacheTtlLabel': "อายุแคชเริ่มต้น (Default Cache TTL) (วินาที)",
    'saPersona_ttl6HoursHint': "21600 = 6 ชม.",
    'saPersona_cacheLabelPrefix': "แคช",
    'saPersona_onCaps': "เปิด",
    'saPersona_offCaps': "ปิด",
    'saPersona_consumerKeyLabel': "Consumer Key",
    'saPersona_credentialSetPlaceholder': "●●●● ตั้งค่าแล้ว (พิมพ์เพื่อเปลี่ยน)",
    'saPersona_credentialNotSetPlaceholder': "ยังไม่กำหนด",
    'saPersona_emptyChip': "ว่าง",
    'saPersona_consumerSecretLabel': "Consumer Secret",
    'saPersona_agentIdLabel': "Agent ID (องค์กร, คงที่)",
    'saPersona_saveGdxSettings': "บันทึกการตั้งค่า GDX",
    'saPersona_section3Title': "3. Data Sources — แหล่งข้อมูลเพอร์โซนา (อากาศ / พยากรณ์ / ทะเบียนราษฎร)",
    'saPersona_section3Hint': "แต่ละแหล่งสลับ mock/real ได้ (config-driven, <code>sy.PersonaDataSource</code>); ไม่มีแถว = ใช้ <b>built-in default</b>. การตั้งค่า air/weather ต้องแก้ที่ card นี้เท่านั้น — ไม่ได้อ่าน Base URL หรือ Provider จาก GDX Connection & Cache. แหล่งที่มี <b>PII</b> (DOPA) ทดสอบกับข้อมูลจริงไม่ได้ — ปุ่มทดสอบจะใช้ mock เท่านั้น. ทุกการเรียกถูกบันทึกใน <code>log.Log_PersonaApiCall</code>; การเรียกของบริษัทลูกคุมด้วย Company Entitlement ด้านบน.",
    'saPersona_defaultBuiltIn': "ค่าเริ่มต้น (ในตัว)",
    'saPersona_test': "ทดสอบ",
    'saPersona_noDataSourceFound': "ไม่พบแหล่งข้อมูล",
    'saPersona_km': "กม.",
    'saPersona_today': "วันนี้",
    'saPersona_tomorrow': "พรุ่งนี้",
    'saPersona_currentWeather': "อากาศปัจจุบัน",
    'saPersona_humidity': "ความชื้น",
    'saPersona_rain': "ฝน",
    'saPersona_loadMshTemplate': "โหลด template MSH",
    'saPersona_scopeLabel': "ขอบเขต (Scope)",
    'saPersona_agencyParamHint': "casing จริงของ ?Agency=",
    'saPersona_activeLabelPrefix': "เปิดใช้งาน",
    'saPersona_section4Title': "4. Service Master — บริการ พม. รายตัว (เปิด/ปิด · cache · TTL)",
    'saPersona_addService': "เพิ่ม Service",
    'saPersona_section4Hint': "ทะเบียนบริการราย Service Code. <b>Coverage = เปิดใช้ ∧ มี GDX API</b> (แหล่งความจริงเดียว). แต่ละบริการตั้ง <b>cache เปิด/ปิด</b> และ <b>TTL</b> ของตัวเองได้ — แก้แล้วกด <b>บันทึก</b> ราย row (มีผลรอบเรียกถัดไป). ไม่มีแถว = ใช้ coverage built-in ในโค้ด. <code>sy.GdxService</code>.",
    'saPersona_deleteAction': "ลบ",
    'saPersona_noServiceFound': "ยังไม่มี service — ระบบใช้ coverage built-in (กด \"เพิ่ม Service\")",
    'saPersona_serviceNameLabel': "ชื่อบริการ",
    'saPersona_hasApiLabelPrefix': "มี API",
    'saPersona_noBoolean': "ไม่",
    'saPersona_enabledLabelPrefix': "เปิดใช้",
    'saPersona_section5Title': "5. Agency Configuration — logic การเรียก GDX ราย agency",
    'saPersona_addAgency': "เพิ่ม Agency",
    'saPersona_section5Hint': "override logic ราย agency แบบ config (agency param, endpoint paths, coverage 17/6, field mapping, TTL). ถ้าไม่มีแถว ระบบใช้ <b>built-in defaults (17 บริการ พม.)</b> ในโค้ด. แก้ที่นี่ = update <code>sy.GdxAgencyConfig</code> (hot ครั้งถัดไป).",
    'saPersona_codeUnit': "code",
    'saPersona_mapUnit': "map",
    'saPersona_noAgencyConfigFound': "ยังไม่มี agency config — ใช้ค่า default 17 บริการ (กด \"เพิ่ม Agency\" เพื่อ override)",
    'saPersona_editDataSourceTitle': "แก้ไขแหล่งข้อมูล: {name}",
    'saPersona_ttlSecondsHint': "ว่าง = default, 0 = ไม่ใช้ cache",
    'saPersona_piiSourceWarning': "แหล่งนี้มีข้อมูลส่วนบุคคล (PII) — ปุ่มทดสอบจะใช้ provider <b>mock</b> เสมอ ผู้ดูแลไม่สามารถดึงข้อมูลจริงของประชาชนได้.",
    'saPersona_gdxProviderMock': "Mock (ข้อมูลจำลอง GDX/Welfare)",
    'saPersona_gdxProviderReal': "Real (GDX จริง)",
    'saPersona_personaProviderMock': "Mock (ข้อมูลจำลอง)",
    'saPersona_personaProviderReal': "Real (API จริงของแหล่งข้อมูลนี้)",
    'saPersona_coverageHeader': "ความครอบคลุม",
    'saPersona_fieldMapHeader': "การแมปฟิลด์",
    'saPersona_scopeHeader': "ขอบเขต (Scope)",
    'saPersona_activeHeader': "เปิดใช้งาน",
    'saPersona_serviceNameHeader': "ชื่อบริการ",
    'saPersona_hasApiHeader': "มี API",
    'saPersona_enabledHeader': "เปิดใช้",
    'saPersona_companyHeader': "บริษัท",
    'saPersona_allowedServicesHeader': "Allowed Services (เลือก code · ว่าง = ทุกบริการ)",
    'saPersona_dataSourceHeader': "แหล่งข้อมูล",
    'saPersona_globalAllCompanies': "ทุกบริษัท (Global)",
    'saPersona_sourceBaseUrlPlaceholderDefault': "Base URL ของแหล่งข้อมูลนี้",
    'saPersona_sourceBaseUrlHintAir': "ใช้กับ Air4Thai เท่านั้น ไม่เกี่ยวกับ GDX Base URL",
    'saPersona_sourceBaseUrlHintWeather': "ใช้กับ TMD เท่านั้น ไม่เกี่ยวกับ GDX Base URL",
    'saPersona_sourceBaseUrlHintDopa': "DOPA ใช้ GDX provider แต่ admin test จะบังคับ mock เพราะเป็น PII",
    'saPersona_sourceBaseUrlHintDefault': "ค่า Base URL แยกตาม source",
    'saPersona_sourceKvPlaceholderAir': "(ไม่ใช้ key)",
    'saPersona_sourceKvPlaceholderDefault': "(เว้นว่างถ้าไม่ใช้ key)",
    'saPersona_sourceKvHintAir': "Air4Thai ไม่ต้องใช้ Key Vault prefix",
    'saPersona_sourceKvHintWeather': "TMD real provider ใช้ API key ของ TMD",
    'saPersona_sourceKvHintDopa': "DOPA ใช้ credential GDX เฉพาะ citizen runtime",
    'saPersona_sourceKvHintDefault': "เว้นว่างถ้า source นี้ไม่ใช้ key",
    'saSet_gptConfiguration': "การตั้งค่า GPT",
    'saSet_azureOpenAIEndpoints': "Azure OpenAI Endpoints",
    'saSet_priority': "ลำดับความสำคัญ",
    'saSet_azureOpenAIUrl': "AzureOpenAI URL",
    'saSet_apiKey': "API Key",
    'saSet_addEndpoint': "เพิ่มเอนด์พอยต์",
    'saSet_embeddingConfiguration': "การตั้งค่า Embedding",
    'saSet_embeddingLoadBalance': "Embedding Load Balance",
    'saSet_on': "เปิด",
    'saSet_off': "ปิด",
    'saSet_azureOpenAIEmbedingUrl': "AzureOpenAI Embedding URL",
    'saSet_azureOpenAIEmbedingApiKey': "AzureOpenAI Embedding API Key",
    'saSet_azureOpenAIEmbedingApiVersion': "AzureOpenAI Embedding API Version",
    'saSet_azureOpenAIEmbeddingType': "ประเภท AzureOpenAI Embedding",
    'saSet_gptModeConfiguration': "การตั้งค่าโหมด GPT",
    'saSet_gptMode': "โหมด GPT",
    'saSet_fast': "เร็ว",
    'saSet_repeatTimeMinutes': "เวลาที่ทำซ้ำ (นาที)*",
    'saSet_modelRequired': "โมเดล*",
    'saSet_testOfQuestions': "คำถามทดสอบ*",
    'saSet_openAIConfig': "การตั้งค่า Open AI",
    'saSet_openAIUrl': "Open AI URL",
    'saSet_openAIKey': "Open AI Key",
    'saSet_blobConfig': "การตั้งค่า Blob",
    'saSet_azureStorageConnection': "การเชื่อมต่อ Azure Storage",
    'saSet_azureContainer': "Azure Container",
    'saSet_azureStorageConnectionPDFVector': "การเชื่อมต่อ Azure Storage PDFVector",
    'saSet_azureContainerPDFVector': "Azure Container PDF Vector",
    'saSet_azureStorageConnectionGptVision': "การเชื่อมต่อ Azure Storage GPT Vision",
    'saSet_azureContainerGptVision': "Azure Container GPT Vision",
    'saSet_azureStorageSpeechDocument': "Azure Storage เอกสารเสียง",
    'saSet_azureContainerSpeechDocument': "Azure Container เอกสารเสียง",
    'saSet_azureStorageQuickReplyIcon': "Azure Storage ไอคอน Quick Reply",
    'saSet_azureContainerQuickReplyIcon': "Azure Container ไอคอน Quick Reply",
    'saSet_languageTranslator': "ตัวแปลภาษา",
    'saSet_languageTranslatorEndpoint': "เอนด์พอยต์บริการแปลภาษา",
    'saSet_languageTranslatorKey': "Key บริการแปลภาษา",
    'saSet_languageTranslatorLocation': "Location ของตัวแปลภาษา",
    'saSet_languageService': "บริการภาษา",
    'saSet_languageServiceEndpoint': "เอนด์พอยต์ของบริการภาษา",
    'saSet_languageServiceKey': "Key ของบริการภาษา",
    'saSet_speechToTextConfig': "การตั้งค่า Speech to text",
    'saSet_speechToTextKey': "Key ของ Speech to text",
    'saSet_speechToTextRegion': "ภูมิภาค Speech to Text",
    'saSet_speechToTextLanguage': "ภาษา Speech to Text",
    'saSet_pathFFMpeg': "พาธ FFMpeg",
    'saSet_pathFFMpegLocal': "พาธ FFMpeg แบบโลคัล",
    'saSet_mailConfiguration': "การตั้งค่าอีเมล",
    'saSet_emailSendingMethod': "วิธีการส่งอีเมล",
    'saSet_emailSendingMethodRequired': "วิธีการส่งอีเมล *",
    'saSet_smtpProviderRequired': "ผู้ให้บริการ SMTP*",
    'saSet_authenticationMethod': "วิธีการยืนยันตัวตน",
    'saSet_oauth2Required': "OAuth2 (จำเป็น)",
    'saSet_basicAuth': "Basic Auth",
    'saSet_oauth2': "OAuth2",
    'saSet_serverSettings': "การตั้งค่าเซิร์ฟเวอร์",
    'saSet_smtpHostRequired': "SMTP Host *",
    'saSet_smtpPortRequired': "SMTP Port *",
    'saSet_enableSSL': "เปิดใช้งาน SSL",
    'saSet_timeoutMs': "Timeout (มิลลิวินาที)",
    'saSet_fromEmailSettings': "การตั้งค่าอีเมลผู้ส่ง",
    'saSet_emailAddressFromRequired': "ที่อยู่อีเมล (ผู้ส่ง) *",
    'saSet_emailAddressHint': "ที่อยู่อีเมลที่ใช้สำหรับส่งอีเมล",
    'saSet_displayNameRequired': "ชื่อที่แสดง *",
    'saSet_displayNameHint': "ชื่อที่แสดงให้ผู้รับเห็น",
    'saSet_authentication': "การยืนยันตัวตน",
    'saSet_requiresAppPassword': "ต้องใช้ App Password",
    'saSet_appPasswordRequired': "App Password *",
    'saSet_passwordRequired': "รหัสผ่าน *",
    'saSet_gmailWith2FA': "Gmail ที่เปิด 2FA:",
    'saSet_gmailAppPasswordHint': "คุณต้องสร้าง App Password จากการตั้งค่าบัญชี Google ของคุณ",
    'saSet_learnCreateAppPassword': "เรียนรู้วิธีสร้าง App Password",
    'saSet_oauth2Configuration': "การตั้งค่า OAuth2",
    'saSet_requiredForOffice365': "จำเป็นสำหรับ Office 365",
    'saSet_office365OAuth2Setup': "การตั้งค่า Office 365 OAuth2:",
    'saSet_office365OAuth2Hint': "คุณต้องลงทะเบียนแอปพลิเคชันใน Microsoft Entra ID (Azure AD) และตั้งค่าสิทธิ์ที่จำเป็น",
    'saSet_viewMicrosoftDocs': "ดูเอกสารของ Microsoft",
    'saSet_tenantIdRequired': "Tenant ID *",
    'saSet_clientIdRequired': "Client ID *",
    'saSet_clientSecretRequired': "Client Secret *",
    'saSet_mailgunConfiguration': "การตั้งค่า Mailgun",
    'saSet_mailgunApiUrlRequired': "Mailgun API URL *",
    'saSet_mailgunApiUrlHint': "เช่น https://api.mailgun.net/v3/your-domain.com",
    'saSet_mailgunApiKeyRequired': "Mailgun API Key *",
    'saSet_fromEmailRequired': "อีเมลผู้ส่ง *",
    'saSet_fromEmailFormatHint': "รูปแบบ: ชื่อที่แสดง <email{'@'}domain.com>",
    'saSet_autoConfiguration': "การตั้งค่าอัตโนมัติ",
    'saSet_stream': "สตรีม",
    'saSet_auto': "อัตโนมัติ",
    'saSet_notAuto': "ไม่อัตโนมัติ",
    'saSet_setupAutoStream': "ตั้งค่า Stream อัตโนมัติ",
    'saSet_anonymous': "ไม่ระบุตัวตน",
    'saSet_enable': "เปิดใช้งาน",
    'saSet_disable': "ปิดใช้งาน",
    'saSet_setupAnonymous': "ตั้งค่าไม่ระบุตัวตน",
    'saSet_timeDelay': "หน่วงเวลา",
    'saSet_limitedCharacters': "จำกัดจำนวนตัวอักษร",
    'saSet_forceDisableGPT': "บังคับปิดใช้งาน GPT",
    'saSet_setupForceDisableGPT': "ตั้งค่าบังคับปิดใช้งาน GPT",
    'saSet_autoDisableGPT': "ปิดใช้งาน GPT อัตโนมัติ",
    'saSet_setupAutoDisableGPT': "ตั้งค่าปิดใช้งาน GPT อัตโนมัติ",
    'saSet_gptAutoDisableDatePeriod': "ช่วงวันที่ปิดใช้งาน GPT อัตโนมัติ",
    'saSet_gptAutoDisableMessage': "ข้อความเมื่อปิดใช้งาน GPT อัตโนมัติ",
    'saSet_gptAutoDisablePricingUSD': "ราคาปิดใช้งาน GPT อัตโนมัติ (USD)",
    'saSet_googleConfiguration': "การตั้งค่า Google",
    'saSet_projectId': "รหัสโปรเจกต์ (Project ID)",
    'saSet_locationId': "รหัสสถานที่ (Location ID)",
    'saSet_jsonCredential': "JSON Credential",
    'saSet_anthropicConfig': "การตั้งค่า Anthropic",
    'saSet_anthropicClaudeApiKey': "AnthropicClaude APIKey",
    'saSet_singleSignOn': "Single Sign-On",
    'saSet_open': "เปิด",
    'saSet_close': "ปิด",
    'saSet_inChat': "ในแชท",
    'saSet_instance': "อินสแตนซ์ (Instance)",
    'saSet_domain': "โดเมน",
    'saSet_tenantId': "Tenant ID",
    'saSet_clientId': "Client ID",
    'saSet_callbackPath': "CallbackPath",
    'ssoc_configuration': "การตั้งค่า",
    'ssoc_lineMessagingApi': "LINE Messaging API",
    'ssoc_lineDescription': "ตั้งค่าการเชื่อมต่อ LINE Bot ด้วย Channel Secret และ Token",
    'ssoc_addConfig': "เพิ่มการตั้งค่า",
    'ssoc_configurations': "การตั้งค่า",
    'ssoc_noLineConfigYet': "ยังไม่มีการตั้งค่า LINE",
    'ssoc_createFirstLineConfig': "สร้างการตั้งค่า LINE Bot แรกของคุณเพื่อเริ่มต้นใช้งาน",
    'ssoc_createFirstConfiguration': "สร้างการตั้งค่าแรก",
    'ssoc_configNumber': "การตั้งค่า #{n}",
    'ssoc_basicInformation': "ข้อมูลพื้นฐาน",
    'ssoc_configurationName': "ชื่อการตั้งค่า",
    'ssoc_enterConfigurationName': "กรอกชื่อการตั้งค่า",
    'ssoc_groupModel': "กลุ่มโมเดล",
    'ssoc_selectGroupModel': "เลือกกลุ่มโมเดล",
    'ssoc_authenticationDetails': "ข้อมูลการยืนยันตัวตน",
    'ssoc_channelSecret': "Channel Secret (รหัสลับช่องทาง)",
    'ssoc_enterChannelSecret': "กรอก Channel Secret",
    'ssoc_channelToken': "Channel Token (โทเค็นช่องทาง)",
    'ssoc_enterChannelToken': "กรอก Channel Token",
    'ssoc_addNewConfiguration': "เพิ่มการตั้งค่าใหม่",
    'ssoc_createNewLineConfig': "สร้างการตั้งค่า LINE Bot ใหม่",
    'ssoc_microsoftTeams': "Microsoft Teams",
    'ssoc_configureMsTeams': "ตั้งค่า MS Teams",
    'ssoc_noTeamsConfigYet': "ยังไม่มีการตั้งค่า Teams",
    'ssoc_createFirstTeamsConfig': "สร้างการตั้งค่า Microsoft Teams Bot แรกของคุณ",
    'ssoc_createNewTeamsConfig': "สร้างการตั้งค่า Teams Bot ใหม่",
    'ssoc_facebookMessenger': "Facebook Messenger",
    'ssoc_configureFacebookIntegration': "ตั้งค่าการเชื่อมต่อ Facebook",
    'ssoc_noFacebookConfigYet': "ยังไม่มีการตั้งค่า Facebook",
    'ssoc_createFirstFacebookConfig': "สร้างการตั้งค่า Facebook Messenger Bot แรกของคุณ",
    'ssoc_createNewFacebookConfig': "สร้างการตั้งค่า Facebook Bot ใหม่",
    'ssoc_instagramMessaging': "Instagram Messaging (การส่งข้อความ Instagram)",
    'ssoc_configureInstagramDm': "ตั้งค่า Instagram สำหรับข้อความส่วนตัว",
    'ssoc_noInstagramConfigYet': "ยังไม่มีการตั้งค่า Instagram",
    'ssoc_createFirstInstagramConfig': "สร้างการตั้งค่า Instagram Messaging Bot แรกของคุณ",
    'ssoc_createNewInstagramConfig': "สร้างการตั้งค่า Instagram Bot ใหม่",
    'ssoc_webSnippetIntegration': "การเชื่อมต่อ Web Snippet",
    'ssoc_configureWebSnippet': "ตั้งค่า Web Snippet สำหรับแชทบอทบนเว็บไซต์",
    'ssoc_noSnippetConfigYet': "ยังไม่มีการตั้งค่าสนิปเพ็ต",
    'ssoc_createFirstSnippetConfig': "สร้างการตั้งค่า Web Snippet แรกของคุณ",
    'ucm_accountLockedDesc': "บัญชีถูกล็อกอยู่ในขณะนี้และไม่สามารถเข้าใช้งานระบบได้",
    'ucm_accountSettings': "การตั้งค่าบัญชี",
    'ucm_accountUnlockedDesc': "บัญชีถูกปลดล็อกและสามารถเข้าใช้งานระบบได้",
    'ucm_addNewChatUser': "เพิ่มผู้ใช้แชทใหม่",
    'ucm_addNewUser': "เพิ่มผู้ใช้ใหม่",
    'ucm_addUserSubtitle': "สร้างบัญชีผู้ใช้แชทใหม่พร้อมข้อมูลที่จำเป็น",
    'ucm_atLeast8Characters': "อย่างน้อย 8 ตัวอักษร",
    'ucm_basicInformation': "ข้อมูลพื้นฐาน",
    'ucm_changePassword': "เปลี่ยนรหัสผ่าน",
    'ucm_changePasswordSubtitle': "สร้างรหัสผ่านใหม่ที่ปลอดภัยสำหรับบัญชีของคุณ",
    'ucm_confirmNewPasswordPlaceholder': "ยืนยันรหัสผ่านใหม่",
    'ucm_confirmNewPasswordRequired': "ยืนยันรหัสผ่านใหม่ *",
    'ucm_confirmPasswordPlaceholder': "ยืนยันรหัสผ่าน",
    'ucm_confirmPasswordRequired': "ยืนยันรหัสผ่าน *",
    'ucm_downloadTemplate': "ดาวน์โหลดเทมเพลต",
    'ucm_downloadTemplateFilesDesc': "ดาวน์โหลดไฟล์เทมเพลตสำหรับนำเข้าผู้ใช้",
    'ucm_downloadUserCsvTemplate': "ดาวน์โหลดเทมเพลตผู้ใช้ - CSV",
    'ucm_downloadUserExcelTemplate': "ดาวน์โหลดเทมเพลตผู้ใช้ - Excel",
    'ucm_editUserSubtitle': "แก้ไขข้อมูลบัญชีผู้ใช้แชท",
    'ucm_email': "อีเมล",
    'ucm_emailRequired': "อีเมล *",
    'ucm_enterEmailAddress': "กรอกที่อยู่อีเมล",
    'ucm_enterFacebookRecipientId': "กรอก Facebook Recipient ID",
    'ucm_enterFirstName': "กรอกชื่อจริง",
    'ucm_enterInstagramRecipientId': "กรอก Instagram Recipient ID",
    'ucm_enterLastName': "กรอกนามสกุล",
    'ucm_enterNewPassword': "กรอกรหัสผ่านใหม่",
    'ucm_enterPassword': "กรอกรหัสผ่าน",
    'ucm_enterPhoneNumber': "กรอกเบอร์โทรศัพท์",
    'ucm_enterSocialUserId': "กรอก Social User ID",
    'ucm_enterUsername': "กรอกชื่อผู้ใช้",
    'ucm_error': "ข้อผิดพลาด",
    'ucm_export': "ส่งออก",
    'ucm_exportToExcel': "ส่งออกเป็น Excel",
    'ucm_failedToProcessExcelFile': "ไม่สามารถประมวลผลไฟล์ Excel ได้",
    'ucm_firstNameRequired': "ชื่อจริง *",
    'ucm_howToUseTemplates': "วิธีใช้งานเทมเพลต:",
    'ucm_import': "นำเข้า",
    'ucm_importFile': "นำเข้าไฟล์",
    'ucm_integrationSocial': "การเชื่อมต่อโซเชียล",
    'ucm_invalidFileType': "ประเภทไฟล์ไม่ถูกต้อง",
    'ucm_lastNameRequired': "นามสกุล *",
    'ucm_loading': "กำลังโหลด...",
    'ucm_lowercaseLetter': "ตัวพิมพ์เล็ก",
    'ucm_missingColumns': "คอลัมน์ที่ขาดหายไป",
    'ucm_missingColumnsText': "คอลัมน์ที่จำเป็นต่อไปนี้ขาดหายไป: {columns}",
    'ucm_model': "โมเดล",
    'ucm_modelConfiguration': "การตั้งค่าโมเดล",
    'ucm_modelGrouping': "การจัดกลุ่มโมเดล",
    'ucm_modelShortcut': "ทางลัดโมเดล",
    'ucm_name': "ชื่อ",
    'ucm_newAccountLockedDesc': "บัญชีใหม่จะถูกล็อกและไม่สามารถเข้าใช้งานระบบได้",
    'ucm_newAccountUnlockedDesc': "บัญชีใหม่จะถูกปลดล็อกและสามารถเข้าใช้งานระบบได้",
    'ucm_newPasswordRequired': "รหัสผ่านใหม่ *",
    'ucm_noPassword': "ไม่มีรหัสผ่าน",
    'ucm_number': "ตัวเลข",
    'ucm_pageTitle': "การจัดการผู้ใช้แชท",
    'ucm_passwordRequired': "รหัสผ่าน *",
    'ucm_passwordRequirements': "ข้อกำหนดรหัสผ่าน",
    'ucm_passwordSetup': "ตั้งค่ารหัสผ่าน",
    'ucm_passwordStrength': "ความปลอดภัยของรหัสผ่าน",
    'ucm_passwordsMatch': "รหัสผ่านตรงกัน",
    'ucm_phoneNumber': "เบอร์โทรศัพท์",
    'ucm_pleaseUploadExcelOrCsv': "กรุณาอัปโหลดไฟล์ Excel (.xlsx) หรือ CSV (.csv)",
    'ucm_pleaseWait': "กรุณารอสักครู่",
    'ucm_readOnly': "อ่านอย่างเดียว",
    'ucm_recipientIdFacebook': "รหัสผู้รับ (Facebook)",
    'ucm_recipientIdInstagram': "รหัสผู้รับ (Instagram)",
    'ucm_securityTips': "เคล็ดลับความปลอดภัย:",
    'ucm_selectAvailableModels': "เลือกโมเดลที่ใช้งานได้",
    'ucm_selectModelGrouping': "เลือกกลุ่มโมเดล",
    'ucm_selectModelShortcut': "เลือกโมเดลตอบกลับด่วน",
    'ucm_socialUserId': "รหัสผู้ใช้โซเชียล (Social User ID)",
    'ucm_specialCharacter': "อักขระพิเศษ",
    'ucm_strengthFair': "พอใช้",
    'ucm_strengthGood': "ดี",
    'ucm_strengthStrong': "แข็งแรง",
    'ucm_strengthWeak': "อ่อน",
    'ucm_syncUsers': "ซิงค์ผู้ใช้",
    'ucm_template': "เทมเพลต",
    'ucm_templateStepDownload': "ดาวน์โหลดไฟล์เทมเพลต",
    'ucm_templateStepFillData': "กรอกข้อมูลผู้ใช้ตามโครงสร้างเทมเพลต",
    'ucm_templateStepSelectFormat': "เลือกรูปแบบเทมเพลตที่เหมาะสมกับความต้องการของคุณ",
    'ucm_templateStepUpload': "อัปโหลดไฟล์ที่กรอกเสร็จแล้วในส่วนนำเข้า",
    'ucm_templateUser': "เทมเพลตผู้ใช้",
    'ucm_tipAvoidPersonalInfo': "หลีกเลี่ยงข้อมูลส่วนตัว เช่น ชื่อ วันเกิด หรือคำที่ใช้กันทั่วไป",
    'ucm_tipChangeRegularly': "เปลี่ยนรหัสผ่านเป็นประจำเพื่อความปลอดภัยที่ดีขึ้น",
    'ucm_tipPassphrase': "ควรใช้วลีรหัสผ่านที่ผสมตัวพิมพ์ใหญ่-เล็ก ตัวเลข และสัญลักษณ์",
    'ucm_tipUniquePassword': "ใช้รหัสผ่านที่ไม่ซ้ำกับที่อื่น",
    'ucm_uppercaseLetter': "ตัวพิมพ์ใหญ่",
    'ucm_usernameReadOnly': "ชื่อผู้ใช้ (อ่านอย่างเดียว)",
    'ucm_usernameRequired': "ชื่อผู้ใช้ *",
    'umgt_template': "เทมเพลต",
    'umgt_downloadTemplate': "ดาวน์โหลดเทมเพลต",
    'umgt_import': "นำเข้า",
    'umgt_importFile': "นำเข้าไฟล์",
    'umgt_export': "ส่งออก",
    'umgt_exportToExcel': "ส่งออกเป็น Excel",
    'umgt_addNewUser': "เพิ่มผู้ใช้ใหม่",
    'umgt_editUserSubtitle': "แก้ไขข้อมูลบัญชีผู้ใช้",
    'umgt_changePassword': "เปลี่ยนรหัสผ่าน",
    'umgt_basicInformation': "ข้อมูลพื้นฐาน",
    'umgt_usernameReadOnly': "ชื่อผู้ใช้ (อ่านอย่างเดียว)",
    'umgt_firstNameRequired': "ชื่อจริง *",
    'umgt_enterFirstName': "กรอกชื่อจริง",
    'umgt_lastNameRequired': "นามสกุล *",
    'umgt_enterLastName': "กรอกนามสกุล",
    'umgt_emailReadOnly': "อีเมล (อ่านอย่างเดียว)",
    'umgt_enterPhoneNumber': "กรอกเบอร์โทรศัพท์",
    'umgt_rolePermissions': "บทบาทและสิทธิ์การใช้งาน",
    'umgt_userRoleRequired': "บทบาทผู้ใช้ *",
    'umgt_userRoleUser': "ผู้ใช้งาน",
    'umgt_availableModels': "โมเดลที่ใช้งานได้",
    'umgt_model': "โมเดล",
    'umgt_selectAvailableModels': "เลือกโมเดลที่ใช้งานได้",
    'umgt_document': "เอกสาร",
    'umgt_selectDocument': "เลือกเอกสาร",
    'umgt_databaseIntegration': "การเชื่อมต่อฐานข้อมูล",
    'umgt_selectDatabaseIntegration': "เลือกการเชื่อมต่อฐานข้อมูล",
    'umgt_productGroupName': "ชื่อกลุ่มผลิตภัณฑ์",
    'umgt_selectProductGroupName': "เลือกชื่อกลุ่มผลิตภัณฑ์",
    'umgt_intentGroupName': "ชื่อกลุ่มอินเทนต์",
    'umgt_selectIntentGroupName': "เลือกชื่อกลุ่มอินเทนต์",
    'umgt_flows': "โฟลว์",
    'umgt_accountLockedSubtitle': "บัญชีถูกล็อก - ผู้ใช้ไม่สามารถเข้าใช้งานระบบได้",
    'umgt_accountUnlockedSubtitle': "บัญชีปลดล็อกแล้ว - ผู้ใช้สามารถเข้าใช้งานระบบได้",
    'umgt_addUserSubtitle': "สร้างบัญชีผู้ใช้ใหม่พร้อมข้อมูลที่จำเป็น",
    'umgt_usernameRequired': "ชื่อผู้ใช้ *",
    'umgt_enterUsername': "กรอกชื่อผู้ใช้",
    'umgt_emailRequired': "อีเมล *",
    'umgt_enterEmailAddress': "กรอกที่อยู่อีเมล",
    'umgt_passwordSetup': "ตั้งค่ารหัสผ่าน",
    'umgt_passwordRequired': "รหัสผ่าน *",
    'umgt_enterPassword': "กรอกรหัสผ่าน",
    'umgt_confirmPasswordRequired': "ยืนยันรหัสผ่าน *",
    'umgt_confirmPasswordPlaceholder': "ยืนยันรหัสผ่าน",
    'umgt_passwordsMatch': "รหัสผ่านตรงกัน",
    'umgt_accountStatus': "สถานะบัญชี",
    'umgt_changePasswordSubtitle': "สร้างรหัสผ่านใหม่ที่ปลอดภัยสำหรับบัญชีของคุณ",
    'umgt_passwordRequirements': "ข้อกำหนดรหัสผ่าน",
    'umgt_newPasswordRequired': "รหัสผ่านใหม่ *",
    'umgt_enterNewPassword': "กรอกรหัสผ่านใหม่",
    'umgt_confirmNewPasswordRequired': "ยืนยันรหัสผ่านใหม่ *",
    'umgt_confirmNewPasswordPlaceholder': "ยืนยันรหัสผ่านใหม่",
    'umgt_passwordStrength': "ความปลอดภัยของรหัสผ่าน:",
    'umgt_securityTips': "เคล็ดลับความปลอดภัย:",
    'umgt_tipUniquePassword': "ใช้รหัสผ่านที่ไม่ซ้ำกับที่อื่น",
    'umgt_tipPassphrase': "พิจารณาใช้วลีรหัสผ่านที่ผสมตัวพิมพ์ใหญ่-เล็ก ตัวเลข และสัญลักษณ์",
    'umgt_tipAvoidPersonalInfo': "หลีกเลี่ยงข้อมูลส่วนตัว เช่น ชื่อ วันเกิด หรือคำทั่วไป",
    'umgt_tipChangeRegularly': "เปลี่ยนรหัสผ่านเป็นประจำเพื่อความปลอดภัยที่ดีขึ้น",
    'umgt_loading': "กำลังโหลด...",
    'umgt_pleaseWait': "กรุณารอสักครู่",
        'lmsg_graphId': "รหัสกราฟ",
    'lmsg_status': "สถานะ",
    'lmsg_mode': "โหมด",
    'lmsg_time': "เวลา",
    'lmsg_nodes': "โหนด",
    'lmsg_edges': "เส้นเชื่อม",
    'lmsg_anchors': "จุดยึด",
    'lmsg_sources': "แหล่งที่มา",
    'lmsg_context': "บริบท",
    'lmsg_notes': "หมายเหตุ",
    'lmsg_noMatchingEntities': "ไม่พบเอนทิตีที่ตรงกัน",
    'lmsg_contextAppended': "เพิ่มบริบทแล้ว",
    'lmsg_anchorMatches': "จุดยึดที่ตรงกัน ({n})",
    'lmsg_id': "รหัส",
    'lmsg_label': "ป้ายชื่อ",
    'lmsg_type': "ประเภท",
    'lmsg_score': "คะแนน",
    'lmsg_contextTextChars': "ข้อความบริบท ({n} ตัวอักษร)",
    'lmsg_copyFullContext': "คัดลอกบริบททั้งหมด",
    'lmsg_nexaNoAnchorsFound': "NEXA ไม่พบจุดยึดและไม่ได้ส่งคืนบริบทสำหรับคำค้นหานี้",
    'lmsg_skipped': "ข้ามแล้ว",
    'lmsg_hitAtLayer': "พบข้อมูล {'@'} {layer}",
    'lmsg_noHit': "ไม่พบข้อมูล",
    'lmsg_typeLabel': "ประเภท: {type}",
    'lmsg_scoreLabel': "คะแนน: {score}",
    'lmsg_layersAttempted': "พยายามแล้ว {n} เลเยอร์",
    'lmsg_miniappStatus': "มินิแอป: {status}",
    'lmsg_on': "เปิด",
    'lmsg_off': "ปิด",
    'lmsg_logReferencesLayerWalk': "การอ้างอิงบันทึก — การไล่เลเยอร์ ({n})",
    'lmsg_layer': "เลเยอร์",
    'lmsg_outcome': "ผลลัพธ์",
    'lmsg_http': "HTTP",
    'lmsg_winner': "ผู้ชนะ",
    'lmsg_winningLayer': "เลเยอร์ที่ชนะ",
    'lmsg_noResult': "ไม่มีผลลัพธ์",
    'lmsg_resultItems': "รายการผลลัพธ์ ({n})",
    'lmsg_title': "ชื่อเรื่อง",
    'lmsg_injectedContextChars': "บริบทที่แทรก ({n} ตัวอักษร)",
    'lmsg_summary': "สรุป",
    'lmsg_fallbackReason': "เหตุผลฟอลแบ็ก",
    'lmsg_detail': "รายละเอียด",
    'lmsg_layerNoUsableResult': "เลเยอร์ไม่ได้ส่งคืนผลลัพธ์ที่ใช้ได้ — waterfall ย้ายไปยังระดับถัดไป",
    'lmsg_layerOutcome': "ผลลัพธ์เลเยอร์: {outcome}",
    'lmsg_unknown': "ไม่ทราบ",
    'lmsg_warnings': "คำเตือน",
    'lmsg_errors': "ข้อผิดพลาด",
    'lmsg_modeLabel': "โหมด: {mode}",
    'lmsg_toolCallsCount': "การเรียกใช้เครื่องมือ {n} ครั้ง",
    'lmsg_iterationsCount': "{n} รอบการทำงาน",
    'lmsg_toolsAvailableCount': "มีเครื่องมือให้ใช้งาน {n} รายการ",
    'lmsg_toolCallsHeader': "การเรียกใช้เครื่องมือ ({n})",
    'lmsg_tool': "เครื่องมือ",
    'lmsg_arguments': "อาร์กิวเมนต์",
    'lmsg_result': "ผลลัพธ์",
    'lmsg_success': "สำเร็จ",
    'lmsg_failed': "ล้มเหลว",
    'lmsg_modelDidNotCallMcpTools': "โมเดลไม่ได้เรียกใช้เครื่องมือ MCP สำหรับข้อความนี้",
    'lmsg_error': "ข้อผิดพลาด",
    'lmsg_logReferencesHeader': "การอ้างอิงบันทึก ({n})",
    'lmsg_loadingReferenceData': "กำลังโหลดข้อมูลอ้างอิง...",
    'lmsg_monitor': "ตรวจสอบ",
    'lmsg_intent': "อินเทนต์",
    'lmsg_message': "ข้อความ",
    'lmsg_reply': "การตอบกลับ",
    'lmsg_tokens': "โทเค็น",
    'lmsg_responseTime': "เวลาตอบสนอง",
    'lmsg_endpoint': "เอนด์พอยต์",
    'lmsg_used': "ใช้แล้ว",
    'lmsg_viewMonitor': "ดูการตรวจสอบ",
    'lmsg_promptLabel': "พรอมต์",
    'lmsg_completionLabel': "การตอบสำเร็จ",
    'lmsg_embedLabel': "ฝังคำถาม",
    'lmsg_totalLabel': "รวม",
    'lmsg_cachedLabel': "แคช",
    'lmsg_notUsed': "ไม่ได้ใช้งาน",
    'lmsg_method': "เมธอด",
    'lmsg_apiEndpoint': "เอนด์พอยต์ API",
    'lmsg_requestBody': "เนื้อหาคำขอ",
    'lmsg_jsonResponse': "การตอบกลับ JSON",
    'lmsg_statusCode': "รหัสสถานะ",
    'lmsg_statusName': "ชื่อสถานะ",
    'lmsg_documentName': "ชื่อเอกสาร",
    'lmsg_textOrg': "ข้อความต้นฉบับ",
    'lmsg_idLabel': "รหัส: {id}",
    'lmsg_timing': "จับเวลา",
    'lmsg_start': "เริ่มต้น",
    'lmsg_end': "สิ้นสุด",
    'lmsg_duration': "ระยะเวลา",
    'lmsg_noFlowDataAvailable': "ไม่มีข้อมูลโฟลว์",
    'lmsg_exportLogToQuestionSet': "ส่งออกบันทึกไปยังชุดคำถาม",
    'lmsg_condition': "เงื่อนไข",
    'lmsg_startDateLabel': "วันที่เริ่มต้น",
    'lmsg_endDateLabel': "วันที่สิ้นสุด",
    'lmsg_typeLabelPlain': "ประเภท",
    'lmsg_userChannelLabel': "ช่องทางผู้ใช้",
    'lmsg_sessionIdLabel': "รหัสเซสชัน",
    'lmsg_exportFile': "ส่งออกไฟล์",
    'lmsg_chatLog': "บันทึกการสนทนา",
    'lmsg_monitorDetails': "รายละเอียดการตรวจสอบ",
    'lmsg_loadingMonitorData': "กำลังโหลดข้อมูลการตรวจสอบ...",
    'lmsg_userQuery': "คำถามของผู้ใช้",
    'lmsg_model': "โมเดล",
    'lmsg_systemAndPrompts': "ระบบและพรอมต์",
    'lmsg_systemMessageAndWorkflowConfig': "ข้อความระบบและการตั้งค่าเวิร์กโฟลว์",
    'lmsg_systemMessage': "ข้อความระบบ",
    'lmsg_copy': "คัดลอก",
    'lmsg_workFlow': "เวิร์กโฟลว์",
    'lmsg_knowledgeAndVectors': "ความรู้และเวกเตอร์",
    'lmsg_vectorDbAndSimilaritySearchResults': "ฐานข้อมูลเวกเตอร์และผลการค้นหาความคล้ายคลึง",
    'lmsg_knowledge': "ความรู้",
    'mdata_pricePerImageHint': "ราคาต่อการสร้างรูปภาพหนึ่งรูป",
    'mdata_chooseImageQualityHint': "เลือกคุณภาพของรูปภาพ",
    'mdata_selectImageResolutionHint': "เลือกความละเอียดของรูปภาพ",
    'mdata_requiredField': "จำเป็นต้องกรอก",
    'mdata_mustBeANumber': "ต้องเป็นตัวเลข",
    'mdata_qualityHd': "HD",
    'mdata_qualityStandard': "มาตรฐาน",
    'mdata_columnId': "ลำดับ",
    'mdata_columnApiVersion': "เวอร์ชัน API",
    'mdata_columnModelType': "ประเภทโมเดล",
    'mdata_columnPrice': "ราคา",
    'mdata_dataIsDuplicate': "ข้อมูลซ้ำ",
    'saPersona_agencyConfigLabel': "การตั้งค่าหน่วยงาน",
    'saPersona_agencyCodeLabel': "รหัสหน่วยงาน",
    'saPersona_agencyParamLabel': "พารามิเตอร์หน่วยงาน",
    'saPersona_endpointPathsLabel': "เส้นทางเอนด์พอยต์ (JSON object)",
    'saPersona_coverageListLabel': "รายการความครอบคลุม (JSON array)",
    'saPersona_fieldMappingLabel': "การแมปฟิลด์ (JSON object: contractKey → ฟิลด์ GDX)",
    'saPersona_cacheTtlHoursLabel': "อายุแคช (TTL) (ชม.)",
    'saPersona_serviceCodeLabel': "รหัสบริการ",
    'saPersona_agencyParamCasingHint': "casing ของ ?Agency=",
    'saPersona_providerFieldLabel': "ผู้ให้บริการ",
    'saPersona_baseUrlFieldLabel': "Base URL",
    'saPersona_cacheTtlSecondsLabel': "อายุแคช (TTL) (วินาที)",
    'saPersona_keyVaultPrefixLabel': "คำนำหน้า Key Vault",
    'saPersona_extrasJsonLabel': "ข้อมูลเพิ่มเติม (JSON object)",
    'saPersona_agencyHeader': "หน่วยงาน",
    'saPersona_paramHeader': "พารามิเตอร์",
    'saPersona_ttlHoursHeader': "อายุแคช (ชม.)",
    'saPersona_serviceCodeHeader': "รหัสบริการ",
    'saPersona_cacheHeader': "แคช",
    'saPersona_ownerHeader': "เจ้าของ",
    'saPersona_personaHeader': "เพอร์โซนา",
    'saPersona_piiHeader': "PII",
    'saPersona_gdxSettingsSavedTitle': "บันทึกการตั้งค่า GDX แล้ว",
    'saPersona_hotReloadNoRestartText': "มีผลทันที (hot-reload) ไม่ต้อง restart",
    'saPersona_saveFailedTitle': "บันทึกไม่สำเร็จ",
    'saPersona_unknownErrorText': "ข้อผิดพลาดที่ไม่ทราบสาเหตุ",
    'saPersona_requestErrorText': "เกิดข้อผิดพลาดในการร้องขอ",
    'saPersona_companyFallbackLabel': "บริษัท {id}",
    'saPersona_invalidJsonError': "JSON ไม่ถูกต้อง",
    'saPersona_mustBeJsonArrayError': "ต้องเป็น JSON array เช่น [\"MSH001\"]",
    'saPersona_mustBeJsonObjectError': "ต้องเป็น JSON object เช่น {'{'}\"welfare\":\"WelfareType\"{'}'}",
    'saPersona_agencyCodeRequiredError': "ต้องระบุ Agency Code",
    'saPersona_agencyConfigSavedTitle': "บันทึก Agency config แล้ว",
    'saPersona_effectiveNextCallText': "มีผลรอบเรียกถัดไป (config-driven)",
    'saPersona_deleteAgencyConfigTitle': "ลบ Agency config?",
    'saPersona_deleteAgencyConfigDetail': "หลังลบจะกลับไปใช้ค่า default (built-in) ของ agency นี้",
    'saPersona_deleteConfirmButton': "ลบ",
    'saPersona_cancelButton': "ยกเลิก",
    'saPersona_deletedTitle': "ลบแล้ว",
    'saPersona_revertedToDefaultText': "{code} กลับไปใช้ค่า default",
    'saPersona_deleteFailedTitle': "ลบไม่สำเร็จ",
    'saPersona_serviceCodeRequiredError': "ต้องระบุ Service Code",
    'saPersona_agencyParamRequiredError': "ต้องระบุ Agency Param ที่จะส่งใน ?Agency=",
    'saPersona_savedTitle': "บันทึกแล้ว",
    'saPersona_effectiveNextCallSuffixText': "{code} — มีผลรอบเรียกถัดไป",
    'saPersona_serviceEditedTitle': "แก้ไข service แล้ว",
    'saPersona_serviceSavedTitle': "บันทึก service แล้ว",
    'saPersona_deleteServiceTitle': "ลบ Service?",
    'saPersona_deleteServiceDetail': "ถ้าลบหมดทุก service ระบบจะกลับไปใช้ coverage built-in",
    'saPersona_companyIdNotFoundTitle': "ไม่พบ Company ID",
    'saPersona_reloadCompanyListText': "โหลดรายชื่อบริษัทใหม่แล้วลองอีกครั้ง",
    'saPersona_personaEnabledTitle': "เปิดเพอร์โซนาแล้ว",
    'saPersona_personaDisabledTitle': "ปิดเพอร์โซนาแล้ว",
    'saPersona_sourceDisabledTitle': "แหล่งข้อมูลถูกปิดอยู่",
    'saPersona_enableBeforeTestText': "เปิด Enabled ก่อนจึงจะทดสอบได้",
    'saPersona_testFailedTitle': "ทดสอบไม่สำเร็จ",
    'saPersona_locationRequired': "กรุณาอนุญาตการเข้าถึงตำแหน่งเพื่อใช้งานข้อมูลสภาพอากาศและคุณภาพอากาศ",
    'saPersona_testNotAvailableTitle': "ยังไม่เปิดให้ทดสอบ",
    'saPersona_piiSourceCannotTestText': "แหล่งนี้เป็นข้อมูลส่วนบุคคล ทดสอบกับข้อมูลจริงไม่ได้",
    'saPersona_dataSourceSavedTitle': "บันทึกแหล่งข้อมูลแล้ว",
    'saPersona_extrasMustBeJsonObjectError': "Extras: ต้องเป็น JSON object เช่น {'{'}\"province\":\"bangkok\"{'}'}",
    'saSet_answers': "คำตอบ",
    'saSet_apiScope': "APIScope",
    'saSet_applyChange': "นำการเปลี่ยนแปลงไปใช้",
    'saSet_clickForSyncSSO': "คลิกเพื่อซิงค์การตั้งค่า Single Sign-On",
    'saSet_clientSecret': "Client Secret",
    'saSet_failedToReadFile': "อ่านไฟล์ไม่สำเร็จ!",
    'saSet_gmailAppPasswordOption': "Gmail (รหัสผ่านแอป)",
    'saSet_minTenNumbers': "อย่างน้อย 10 ตัวเลข",
    'saSet_msEntraGroupConfig': "การตั้งค่ากลุ่ม Microsoft Entra ID",
    'saSet_office365OAuth2RequiredOption': "Office 365 (จำเป็นต้องใช้ OAuth2)",
    'saSet_otherOption': "อื่นๆ",
    'saSet_required': "จำเป็นต้องกรอก",
    'saSet_responseTimeMs': "เวลาตอบสนอง (มิลลิวินาที)",
    'saSet_syncSSO': "ซิงค์ SSO",
    'saSet_syncSingleSignOn': "ซิงค์ Single Sign-On",
    'saSet_urlConfig': "URLConfig",
    'ssoc_apiConfiguration': "การตั้งค่า API",
    'ssoc_apiVersion': "เวอร์ชัน API",
    'ssoc_configurationDetails': "รายละเอียดการตั้งค่า",
    'ssoc_createNewSnippetConfig': "สร้างการตั้งค่าสนิปเพ็ตใหม่",
    'ssoc_domainName': "ชื่อโดเมน",
    'ssoc_enterAccessToken': "กรอก Access Token",
    'ssoc_enterApiVersionExample': "กรอกเวอร์ชัน API (เช่น v18.0)",
    'ssoc_enterDefaultUserId': "กรอกรหัสผู้ใช้เริ่มต้น",
    'ssoc_enterDomainName': "กรอกชื่อโดเมน",
    'ssoc_enterFacebookPageId': "กรอก Facebook Page ID",
    'ssoc_enterInstagramPageId': "กรอก Instagram Page ID",
    'ssoc_enterTokenOptional': "กรอกโทเค็น (ไม่บังคับ)",
    'ssoc_enterVerifyToken': "กรอก Verify Token",
    'ssoc_facebookAccessToken': "Facebook Access Token (โทเค็นการเข้าถึง Facebook)",
    'ssoc_facebookVerifyToken': "Facebook Verify Token (โทเค็นยืนยันตัวตน Facebook)",
    'ssoc_generatedIntegrationLink': "ลิงก์เชื่อมต่อที่สร้างขึ้น",
    'ssoc_generatedLink': "ลิงก์ที่สร้างขึ้น",
    'ssoc_generatedResources': "ทรัพยากรที่สร้างขึ้น",
    'ssoc_instagramAccessToken': "Instagram Access Token (โทเค็นการเข้าถึง Instagram)",
    'ssoc_instagramVerifyToken': "Instagram Verify Token (โทเค็นยืนยันตัวตน Instagram)",
    'ssoc_integrationLink': "ลิงก์เชื่อมต่อ",
    'ssoc_loading': "กำลังโหลด...",
    'ssoc_max100Characters': "สูงสุด 100 ตัวอักษร",
    'ssoc_modelDisplay': "โมเดลที่แสดง",
    'ssoc_modelShortcut': "ทางลัดโมเดล",
    'ssoc_nameMustBeLessThan100Characters': "ชื่อต้องมีความยาวน้อยกว่า 100 ตัวอักษร",
    'ssoc_pageId': "Page ID (รหัสเพจ)",
    'ssoc_platformNameFacebook': "Facebook",
    'ssoc_platformNameInstagram': "Instagram",
    'ssoc_platformNameLine': "LINE",
    'ssoc_platformNameSnippet': "สนิปเพ็ต",
    'ssoc_platformNameTeams': "Teams",
    'ssoc_requiredField': "จำเป็นต้องกรอก",
    'ssoc_selectModelDisplay': "เลือกโมเดลที่แสดง",
    'ssoc_selectQuickGroupModel': "เลือกกลุ่มโมเดลด่วน",
    'ssoc_selectShortcutMenu': "เลือกเมนูทางลัด",
    'ssoc_shortcutMenu': "เมนูทางลัด",
    'ssoc_teamsConfiguration': "การตั้งค่า Teams",
    'ssoc_token': "โทเค็น",
    'ssoc_userDefault': "ผู้ใช้เริ่มต้น",
    'ucm_close': "ปิด",
    'ucm_csvFormat': "CSV",
    'ucm_duplicateEmail': "อีเมลซ้ำ",
    'ucm_duplicateEmails': "อีเมลซ้ำ",
    'ucm_duplicateSocialUserId': "Social User ID ซ้ำ",
    'ucm_duplicateUsername': "ชื่อผู้ใช้ซ้ำ",
    'ucm_duplicateUsernames': "ชื่อผู้ใช้ซ้ำ",
    'ucm_emailNotFormattedCorrectly': "รูปแบบอีเมลไม่ถูกต้อง",
    'ucm_excelFormat': "Excel",
    'ucm_invalidEmail': "อีเมลไม่ถูกต้อง",
    'ucm_invalidPhoneFormat': "รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง",
    'ucm_min10Numbers': "อย่างน้อย 10 ตัวเลข",
    'ucm_modelNotFormattedCorrectly': "รูปแบบโมเดลไม่ถูกต้อง",
    'ucm_pleaseFillAllFieldsExclaim': "กรุณากรอกข้อมูลให้ครบทุกช่อง!!!",
    'ucm_pleaseFillCorrectFormat': "กรุณากรอกข้อมูลให้ถูกต้องตามรูปแบบ",
    'ucm_pleaseFillCorrectFormatExclaim': "กรุณากรอกข้อมูลให้ถูกต้องตามรูปแบบ!",
    'ucm_pleaseFillRequiredFields': "กรุณากรอกข้อมูลในช่องที่จำเป็น",
    'ucm_pleaseFillPassword': "กรุณากรอกรหัสผ่าน",
    'ucm_pleaseFillConfirmPassword': "กรุณากรอกยืนยันรหัสผ่าน",
    'ucm_pleaseFillPasswordAndConfirmPassword': "กรุณากรอกรหัสผ่านและยืนยันรหัสผ่าน",
    'ucm_passwordConfirmMismatch': "รหัสผ่านและยืนยันรหัสผ่านไม่ตรงกัน กรุณากรอกให้ถูกต้อง",
    'ucm_requiredField': "จำเป็นต้องกรอก",
    'ucm_warningExclaim': "คำเตือน!",
    'umgt_templateUserTitle': "เทมเพลตผู้ใช้",
    'umgt_templateUserSubtitle': "ดาวน์โหลดไฟล์เทมเพลตสำหรับนำเข้าผู้ใช้งาน",
    'umgt_howToUseTemplates': "วิธีใช้งานเทมเพลต:",
    'umgt_templateStepSelectFormat': "เลือกรูปแบบเทมเพลตที่เหมาะสมกับความต้องการของคุณ",
    'umgt_templateStepDownload': "ดาวน์โหลดไฟล์เทมเพลต",
    'umgt_templateStepFillData': "กรอกข้อมูลผู้ใช้งานตามโครงสร้างของเทมเพลต",
    'umgt_templateStepUpload': "อัปโหลดไฟล์ที่กรอกเสร็จแล้วในส่วนนำเข้า",
    'umgt_loadingText': "กำลังโหลด...",
    'umgt_downloadUserCsvTemplate': "ดาวน์โหลดเทมเพลตผู้ใช้ - CSV",
    'umgt_downloadUserExcelTemplate': "ดาวน์โหลดเทมเพลตผู้ใช้ - Excel",
    'umgt_ruleRequired': "จำเป็นต้องกรอก",
    'umgt_ruleMin10Numbers': "อย่างน้อย 10 ตัวเลข",
    'umgt_fullName': "ชื่อ",
    'umgt_passwordStrengthWeak': "อ่อน",
    'umgt_passwordStrengthFair': "พอใช้",
    'umgt_passwordStrengthGood': "ดี",
    'umgt_passwordStrengthStrong': "แข็งแรง",
    'umgt_passwordStrengthNone': "ไม่มีรหัสผ่าน",
    'umgt_noWorksheetFound': "ไม่พบเวิร์กชีตในไฟล์ Excel",
    'umgt_invalidFileType': "ประเภทไฟล์ไม่ถูกต้อง กรุณาอัปโหลดไฟล์ Excel (.xlsx) หรือ CSV (.csv)",
    'umgt_missingColumns': "คอลัมน์ที่ขาดหายไป",
    'umgt_missingColumnsText': "คอลัมน์ที่จำเป็นต่อไปนี้ขาดหายไป: {columns}",
    'umgt_duplicateUsernames': "ชื่อผู้ใช้ซ้ำ",
    'umgt_duplicateEmails': "อีเมลซ้ำ",
    'umgt_duplicateUsernameLower': "ชื่อผู้ใช้ซ้ำ",
    'umgt_duplicateEmailLower': "อีเมลซ้ำ",
    'umgt_emailNotFormattedCorrectly': "รูปแบบอีเมลไม่ถูกต้อง",
    'umgt_pleaseFillRequiredFields': "กรุณากรอกข้อมูลในช่องที่จำเป็น",
    'umgt_modelNotFormattedCorrectly': "รูปแบบโมเดลไม่ถูกต้อง",
    'umgt_usernameNotAllowedSuperAdmin': "ชื่อผู้ใช้งานนี้ไม่สามารถกำหนดเป็นบทบาท SuperAdmin ได้",
    'umgt_warningExclaim': "คำเตือน!",
    'umgt_invalidPhoneFormat': "รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง",
    'umgt_invalidEmail': "อีเมลไม่ถูกต้อง",
    'umgt_ruleFillCorrectFormat': "กรุณากรอกข้อมูลให้ถูกต้องตามรูปแบบ",
    'umgt_ruleFillAllFields': "กรุณากรอกข้อมูลให้ครบทุกช่อง",
    'umgt_ruleFillPasswordAndConfirm': "กรุณากรอกรหัสผ่านและยืนยันรหัสผ่าน",
    'umgt_ruleFillPassword': "กรุณากรอกรหัสผ่าน",
    'umgt_ruleFillConfirmPassword': "กรุณากรอกยืนยันรหัสผ่าน",
    'umgt_passwordMismatchFillCorrectly': "รหัสผ่านและยืนยันรหัสผ่านไม่ตรงกัน กรุณากรอกให้ถูกต้อง",
        'isd_intentSessionDetail': "รายละเอียดเซสชันอินเทนต์",
    'isd_intentSessionName': "ชื่อเซสชันอินเทนต์*",
    'isd_score': "คะแนน",
    'isd_useMemory': "ใช้หน่วยความจำ",
    'isd_promptSession': "พรอมต์ของเซสชัน",
    'isd_enterThePrompt': "กรอกพรอมต์...",
    'isd_intent': "อินเทนต์",
    'isd_template': "เทมเพลต",
    'isd_enterTheMessageIntent': "กรอกข้อความอินเทนต์...",
    'isd_delete': "ลบ",
    'isd_action': "การดำเนินการ",
    'isd_actionAnswer': "การดำเนินการตอบกลับ",
    'isd_actionParallel': "การดำเนินการแบบขนาน",
    'isd_actionType': "ประเภทการดำเนินการ*",
    'isd_actionTypeInformation': "ข้อมูลประเภทการดำเนินการ",
    'isd_mergePrompt': "รวมพรอมต์",
    'isd_vectorName': "ชื่อเวกเตอร์*",
    'isd_loading': "กำลังโหลด...",
    'isd_selectedVectors': "เวกเตอร์ที่เลือก:",
    'isd_prompt': "พรอมต์",
    'isd_message': "ข้อความ",
    'isd_enterTheMessage': "กรอกข้อความ...",
    'isd_nextRouting': "เส้นทางถัดไป*",
    'isd_botDisableTimeMinutes': "ระยะเวลาปิดใช้งานบอท (นาที)",
    'isd_enterTimeInMinutes': "กรอกระยะเวลาเป็นนาที",
    'isd_botDisableTimeHint': "ระบุระยะเวลาปิดใช้งานบอท (เป็นนาที) เมื่อโอนสายไปยังเจ้าหน้าที่ หากปล่อยว่างไว้ บอทจะยังคงทำงานอยู่",
    'isd_contactAgentMessage': "ข้อความติดต่อเจ้าหน้าที่",
    'isd_method': "เมธอด*",
    'isd_apiEndpoint': "เอนด์พอยต์ API*",
    'isd_headers': "เฮดเดอร์",
    'isd_key': "คีย์",
    'isd_value': "ค่า",
    'isd_addHeader': "เพิ่ม Header",
    'isd_jsonRequest': "คำขอ JSON",
    'isd_modelJson': "โมเดล JSON*",
    'isd_availableVariablesHint': "ตัวแปรที่ใช้ได้ (คลิกหรือลากเพื่อแทรก)",
    'isd_transactionId': "รหัสธุรกรรม",
    'isd_channel': "ช่องทาง",
    'isd_channelId': "รหัสช่องทาง",
    'isd_userChannel': "ช่องทางผู้ใช้",
    'isd_sessionId': "รหัสเซสชัน",
    'isd_validation': "การตรวจสอบ",
    'isd_typeValidate': "ประเภทการตรวจสอบ*",
    'isd_numberOfCharacter': "จำนวนตัวอักษร",
    'isd_regularExpression': "รูปแบบ Regular Expression",
    'isd_errorMessage': "ข้อความแจ้งข้อผิดพลาด",
    'isd_enterTheValidationErrorMessage': "กรอกข้อความแจ้งข้อผิดพลาดของการตรวจสอบ...",
    'isd_addValidation': "เพิ่มการตรวจสอบ",
    'isd_textResponse': "ข้อความตอบกลับ",
    'isd_responseMessage': "ข้อความตอบกลับ",
    'isd_enterTheResponseMessage': "กรอกข้อความตอบกลับ...",
    'isd_addNewAction': "เพิ่มการดำเนินการใหม่",
    'isd_close': "ปิด",
    'isd_save': "บันทึก",
    'isd_pleaseWait': "กรุณารอสักครู่",
    'isd_copiedToClipboard': "คัดลอกไปยังคลิปบอร์ดแล้ว!",
    'isd_required': "จำเป็นต้องกรอก",
    'isd_errorReadingExcelFile': "เกิดข้อผิดพลาดในการอ่านไฟล์ Excel",
    'isd_fileFormatNotSupported': "รูปแบบไฟล์ไม่รองรับ หรือไฟล์เสียหาย",
    'isd_textOrg': "ข้อความต้นฉบับ",
    'isd_textEn': "ข้อความภาษาอังกฤษ",
    'isd_actionTypeVector': "เวกเตอร์",
    'isd_actionTypeModelRouting': "การกำหนดเส้นทางโมเดล",
    'isd_actionTypeNextRouting': "เส้นทางถัดไป",
    'isd_actionTypeContactAgent': "ติดต่อเจ้าหน้าที่ (ปิดใช้งานบอท)",
    'isd_actionTypeApiTrigger': "ทริกเกอร์ API",
    'isd_validationPhone': "ตรวจสอบเบอร์โทรศัพท์",
    'isd_validationEmail': "ตรวจสอบอีเมล",
    'isd_validationMaxCharacter': "ตรวจสอบจำนวนตัวอักษรสูงสุด",
    'isd_validationRegularExpression': "ตรวจสอบรูปแบบ Regular Expression",
    'mqg_loading': "กำลังโหลด...",
    'mqg_pleaseWait': "กรุณารอสักครู่",
    'mqg_editShortcutGroup': "แก้ไขกลุ่มทางลัด",
    'mqg_modifyModelShortcutGroupConfiguration': "แก้ไขการตั้งค่ากลุ่มทางลัดโมเดล",
    'mqg_basicInformation': "ข้อมูลพื้นฐาน",
    'mqg_shortcutGroupName': "ชื่อกลุ่มทางลัด",
    'mqg_enterUniqueNameForShortcutGroup': "กรอกชื่อที่ไม่ซ้ำสำหรับกลุ่มทางลัดนี้",
    'mqg_enterGroupNamePlaceholder': "กรอกชื่อกลุ่ม...",
    'mqg_modelConfiguration': "การตั้งค่าโมเดล",
    'mqg_allModels': "ทุกโมเดล",
    'mqg_includeAllAvailableModelsInGroup': "รวมโมเดลที่มีทั้งหมดไว้ในกลุ่มนี้",
    'mqg_modelSetup': "ตั้งค่าโมเดล",
    'mqg_model': "โมเดล",
    'mqg_modelsPlural': "โมเดล",
    'mqg_modelNameHeader': "ชื่อโมเดล",
    'mqg_uploadImage': "อัปโหลดรูปภาพ",
    'mqg_imagePreview': "ตัวอย่างรูปภาพ",
    'mqg_actionsHeader': "การดำเนินการ",
    'mqg_selectModel': "เลือกโมเดล",
    'mqg_chooseModelForShortcut': "เลือกโมเดลสำหรับทางลัดนี้",
    'mqg_previewAlt': "ตัวอย่าง",
    'mqg_remove': "ลบ",
    'mqg_add': "เพิ่ม",
    'mqg_addMultipleModelsAndUploadCustomImages': "คุณสามารถเพิ่มโมเดลได้หลายรายการและอัปโหลดรูปภาพที่กำหนดเองสำหรับแต่ละโมเดลได้",
    'mqg_allModelsIncluded': "รวมโมเดลทั้งหมดแล้ว",
    'mqg_groupWillAutoIncludeAllModels': "กลุ่มนี้จะรวมโมเดลที่มีทั้งหมดโดยอัตโนมัติ",
    'mqg_modelsConfiguredCount': "ตั้งค่าแล้ว {n} {unit}",
    'mqg_close': "ปิด",
    'mqg_save': "บันทึก",
    'mqg_addShortcutGroup': "เพิ่มกลุ่มทางลัด",
    'mqg_createNewModelShortcutGroup': "สร้างกลุ่มทางลัดโมเดลใหม่",
    'mqg_modelDetailsAndInformation': "รายละเอียดและข้อมูลโมเดล",
    'mqg_noModelsFound': "ไม่พบโมเดล",
    'mqg_noModelDataAvailableToDisplay': "ไม่มีข้อมูลโมเดลให้แสดง",
    'mqg_view': "ดู",
    'mqg_modelsCount': "{n} โมเดล",
    'mqg_required': "จำเป็นต้องกรอก",
    'mqg_errorOccurred': "เกิดข้อผิดพลาด!",
    'mqg_somethingWentWrong': "เกิดข้อผิดพลาดบางอย่าง!",
    'mqg_onlyAcceptJpegOrPngFiles': "ลองรับไฟล์ jpeg หรือ png เท่านั้น",
    'sacomp_statusEnable': "เปิดใช้งาน",
    'sacomp_statusDisable': "ปิดใช้งาน",
    'sacomp_sectionCompany': "บริษัท",
    'sacomp_labelCompanyCodeRequired': "รหัสบริษัท *",
    'sacomp_labelCompanyNameRequired': "ชื่อบริษัท *",
    'sacomp_labelMobileNumber': "เบอร์มือถือ",
    'sacomp_labelProvince': "จังหวัด",
    'sacomp_labelDistrict': "อำเภอ",
    'sacomp_labelSubDistrict': "ตำบล",
    'sacomp_labelCountry': "ประเทศ",
    'sacomp_labelPostCode': "รหัสไปรษณีย์",
    'sacomp_labelAddress': "ที่อยู่",
    'sacomp_labelEmailRequired': "อีเมล *",
    'sacomp_labelEmail': "อีเมล",
    'sacomp_sectionPortalUserChatFramework': "ผู้ใช้พอร์ทัล Chat Framework",
    'sacomp_labelUsernameRequired': "ชื่อผู้ใช้ *",
    'sacomp_labelPasswordRequired': "รหัสผ่าน *",
    'sacomp_labelNameRequired': "ชื่อ *",
    'sacomp_labelLastNameRequired': "นามสกุล *",
    'sacomp_labelIdCard': "เลขบัตรประชาชน",
    'sacomp_labelLockStatus': "สถานะล็อก:",
    'sacomp_lockStatusLocked': "ล็อก",
    'sacomp_lockStatusUnlocked': "ไม่ล็อก",
    'sacomp_labelCompanyCode': "รหัสบริษัท",
    'sacomp_labelStatusPrefix': "สถานะ: ",
    'sacomp_labelUsername': "ชื่อผู้ใช้",
    'sacomp_titleChangePassword': "เปลี่ยนรหัสผ่าน",
    'sacomp_labelNewPasswordRequired': "รหัสผ่านใหม่ *",
    'sacomp_labelConfirmNewPasswordRequired': "ยืนยันรหัสผ่านใหม่ *",
    'sacomp_headerNo': "ลำดับ",
    'sacomp_headerCompanyCode': "รหัสบริษัท",
    'sacomp_headerCompanyName': "ชื่อบริษัท",
    'sacomp_headerEmail': "อีเมล",
    'sacomp_headerTelephone': "เบอร์โทรศัพท์",
    'sacomp_headerOwner': "เจ้าของ",
    'sacomp_headerStatus': "สถานะ",
    'sacomp_headerActions': "การดำเนินการ",
    'sacomp_headerManage': "จัดการ",
    'sacomp_validationCompanyCodeMaxLength': "ไม่เกิน 10 ตัวอักษร",
    'sacomp_confirmDeleteCompanyText': "ลบบริษัท \"{name}\" ({code}) ใช่หรือไม่?",
    'sacomp_companyDeletedSuccess': "ลบบริษัทสำเร็จ",
    'sacomp_deleteFailed': "ลบไม่สำเร็จ",
    'sacomp_switchCompanyFailed': "สลับบริษัทไม่สำเร็จ",
    'sacomp_networkError': "เกิดข้อผิดพลาดเครือข่าย",
    'strm_modelTopicLabel': "โมเดล {model} : {topic}",
    'strm_helpUserId': ":userid (ขอ MS Team ID)",
    'strm_helpClearMemory': ":clearmemory (ล้างความจำระยะสั้น)",
    'strm_helpMemory': ":memory (แสดงความจำระยะสั้น)",
    'strm_helpLastMemory': ":lastmemory (แสดงความจำล่าสุดของการสนทนาล่าสุด)",
    'strm_helpModel': ":model (แสดงโมเดลทั้งหมด)",
    'strm_fullStream': "สตรีมแบบเต็ม",
    'strm_parameters': "พารามิเตอร์",
    'strm_userId': "รหัสผู้ใช้",
    'strm_enterUserId': "กรอกรหัสผู้ใช้",
    'strm_timeDelay': "หน่วงเวลา",
    'strm_ms': "มิลลิวินาที",
    'strm_log': "บันทึกล็อก",
    'strm_systemMessage': "ข้อความระบบ",
    'strm_knowledge': "ความรู้",
    'strm_sqlQuery': "คำสั่ง SQL",
    'strm_sqlQueryResult': "ผลลัพธ์คำสั่ง SQL",
    'strm_workFlow': "เวิร์กโฟลว์",
    'strm_memory': "หน่วยความจำ",
    'strm_llmsModel': "โมเดล LLM",
    'strm_modelIdLabel': "รหัสโมเดล : {value}",
    'strm_modelNameLabel': "ชื่อโมเดล : {value}",
    'strm_providerLabel': "ผู้ให้บริการ : {value}",
    'strm_modelLabel': "โมเดล : {value}",
    'strm_systemMessageLabel': "ข้อความระบบ",
    'strm_knowledgeDocuments': "เอกสารความรู้",
    'strm_extensionLabel': "ส่วนขยาย : {value}",
    'strm_descriptionLabel': "คำอธิบาย : {value}",
    'strm_genderLabel': "เพศ : {value}",
    'strm_topNChunksLabel': "จำนวนกลุ่มข้อมูลสูงสุด : {value}",
    'strm_internetLabel': "อินเทอร์เน็ต : {value}",
    'strm_feedbackLabel': "ฟีดแบ็ก : {value}",
    'strm_historyCountLabel': "จำนวนประวัติ : {value}",
    'strm_historyMinuteLabel': "นาทีของประวัติ : {value}",
    'strm_temperatureLabel': "temperature : {value}",
    'strm_topPLabel': "Top P : {value}",
    'strm_frequencyPenaltyLabel': "ค่าปรับความถี่ : {value}",
    'strm_presencePenaltyLabel': "ค่าปรับการปรากฏ : {value}",
    'strm_stopSequenceLabel': "ลำดับหยุด : {value}",
    'strm_maxTokensResponseLabel': "โทเค็นสูงสุดของคำตอบ : {value}",
    'strm_isStreamLabel': "สตรีม : {value}",
    'strm_endpoint': "เอนด์พอยต์",
    'strm_vectorCosine': "Vector Cosine",
    'strm_privateMemory': "หน่วยความจำส่วนตัว",
    'strm_topicList': "รายการหัวข้อ",
    'strm_rename': "เปลี่ยนชื่อ",
    'strm_deleteChat': "ลบแชท",
    'strm_findingAnswer': "กำลังค้นหาคำตอบ ...",
    'strm_typeMessagePlaceholder': "พิมพ์ข้อความของคุณที่นี่... (Shift + Enter เพื่อขึ้นบรรทัดใหม่)",
    'strm_attachImages': "รูปภาพ",
    'strm_attachFiles': "ไฟล์",
    'strm_requiredField': "จำเป็นต้องกรอก",
    'strm_textOrg': "ข้อความต้นฉบับ",
    'strm_textEn': "ข้อความภาษาอังกฤษ",
    'strm_type': "ประเภท",
    'strm_csv': "CSV",
    'strm_excel': "Excel",
    'strm_pdf': "PDF",
    'strm_word': "Word",
    'strm_powerPoint': "PowerPoint",
    'strm_text': "ข้อความ",
    'strm_version': "เวอร์ชัน",
    'strm_modified': "แก้ไขล่าสุด",
    'strm_modifiedBy': "แก้ไขโดย",
    'strm_addReplaceHint': "ADD คือกระบวนการเพิ่มข้อมูลลงเวกเตอร์, Raplace คือกระบวนการแก้ไขคำตอบ",
    'strm_fileTooLargeLimit': "ไฟล์มีขนาดใหญ่เกิน {limit} KB",
    'strm_micPermissionDenied': "ไม่มีสิทธ์เข้าถึงไมค์",
    'strm_genericError': "เกิดข้อผิดพลาด",
    'strm_speaking': "พูด...",
    'strm_audioFile': "ไฟล์เสียง",
    'strm_noAudioDataInFile': "ไม่พบข้อมูลเสียงในไฟล์",
    'strm_audioConversionFailed': "แปลงไฟล์เสียงไม่ได้",
    'strm_audioFormatUnsupported': "รองรับไฟล์ MP3, WAV และ M4A เท่านั้น",
    'strm_allowPopupForFullStream': "กรุณาอนุญาต popup เพื่อเปิด FullStream ใน tab ใหม่",
    'strm_authNotFound': "ไม่พบ Auth",
    'usdd_pageTitle': "อัปโหลดเสียงเป็นเอกสาร",
    'usdd_currentDocument': "เอกสารปัจจุบัน",
    'usdd_noDocumentSelected': "ยังไม่ได้เลือกเอกสาร",
    'usdd_collapse': "ย่อ",
    'usdd_expand': "ขยาย",
    'usdd_edit': "แก้ไข",
    'usdd_importToKnowledgeBase': "นำเข้าสู่ฐานความรู้",
    'usdd_summarizeWithAiModel': "สรุปด้วยโมเดล AI",
    'usdd_delete': "ลบ",
    'usdd_close': "ปิด",
    'usdd_uploadSpeechFiles': "อัปโหลดไฟล์เสียง",
    'usdd_uploadSpeechFilesSubtitle': "อัปโหลดและประมวลผลไฟล์เสียงเพื่อถอดข้อความ",
    'usdd_uploadFiles': "อัปโหลดไฟล์",
    'usdd_filesSelected': "เลือกไฟล์แล้ว {n} ไฟล์",
    'usdd_documentNameRequired': "ชื่อเอกสาร *",
    'usdd_language': "ภาษา",
    'usdd_aiModelForSummation': "โมเดล AI (สำหรับสรุปความ)",
    'usdd_selectAiModelForSummation': "เลือกโมเดล AI สำหรับสรุปข้อความ",
    'usdd_required': "จำเป็นต้องกรอก",
    'usdd_botSummation': "สรุปความโดยบอท",
    'usdd_uploadAudioFiles': "อัปโหลดไฟล์เสียง",
    'usdd_supportedFormatsHint': "รูปแบบไฟล์ที่รองรับ: MP3, WAV, M4A, FLAC (ขนาดสูงสุด 100MB ต่อไฟล์)",
    'usdd_editTextSummarization': "แก้ไขข้อความสรุป",
    'usdd_editTextSummarizationSubtitle': "แก้ไขข้อความต้นฉบับและข้อความสรุป",
    'usdd_saveChanges': "บันทึกการเปลี่ยนแปลง",
    'usdd_originalTextRequired': "ข้อความต้นฉบับ *",
    'usdd_summarizedText': "ข้อความสรุป",
    'usdd_importToKnowledgeDocument': "นำเข้าสู่เอกสารความรู้",
    'usdd_importToKnowledgeDocumentSubtitle': "นำเข้าเนื้อหาที่ประมวลผลแล้วสู่ฐานความรู้",
    'usdd_import': "นำเข้า",
    'usdd_selectDocumentRequired': "เลือกเอกสาร *",
    'usdd_chooseKnowledgeDocument': "เลือกเอกสารความรู้",
    'usdd_maxSplitCharactersRequired': "จำนวนอักขระสูงสุดต่อการแบ่ง *",
    'usdd_importInformationTitle': "ข้อมูลการนำเข้า:",
    'usdd_importInformationText': "ระบบจะประมวลผลและแบ่งเนื้อหาเพื่อรวมเข้ากับฐานความรู้",
    'usdd_summarizeText': "สรุปข้อความ",
    'usdd_summarizeTextSubtitle': "สร้างข้อความสรุปด้วย AI",
    'usdd_generateSummary': "สร้างข้อความสรุป",
    'usdd_aiModelForSummarizationRequired': "โมเดล AI สำหรับการสรุปความ *",
    'usdd_chooseAiModel': "เลือกโมเดล AI",
    'usdd_summarizationProcessTitle': "กระบวนการสรุปความ:",
    'usdd_summarizationProcessText': "โมเดล AI ที่เลือกจะวิเคราะห์และสร้างข้อความสรุปแบบกระชับจากข้อความต้นฉบับ",
    'usdd_loadingPleaseWait': "กำลังโหลด กรุณารอสักครู่...",
    'usdd_headerNo': "ลำดับ",
    'usdd_headerOriginalText': "ข้อความต้นฉบับ",
    'usdd_headerSummarizedText': "ข้อความสรุป",
    'usdd_headerAction': "การดำเนินการ",
    'usdd_pleaseFillAllFields': "กรุณากรอกข้อมูลให้ครบทุกช่อง!",
    'usdd_pleaseAddSomeFile': "กรุณาเพิ่มไฟล์!",
    'uvec_basicInformation': "ข้อมูลพื้นฐาน",
    'uvec_documentName': "ชื่อเอกสาร",
    'uvec_enterUniqueDocumentName': "กรอกชื่อเอกสารที่ไม่ซ้ำกัน",
    'uvec_textReplacement': "การแทนที่ข้อความ",
    'uvec_selectReplacementRules': "เลือกกฎการแทนที่ข้อความ",
    'uvec_maxCharacterLimit': "จำนวนตัวอักษรสูงสุด",
    'uvec_maxCharacterLimitPlaceholder': "กรอกจำนวนตัวอักษรสูงสุด",
    'uvec_documentTypeAndProcessing': "ประเภทเอกสารและการประมวลผล",
    'uvec_processingMethod': "วิธีประมวลผล",
    'uvec_customCharacter': "ตัวอักษรที่กำหนดเอง",
    'uvec_enterCharacter': "กรอกตัวอักษร",
    'uvec_customCharacterHint': "กรอกตัวอักษรที่ใช้สำหรับแบ่งเนื้อหา",
    'uvec_languageDetection': "การตรวจจับภาษา",
    'uvec_autoDetection': "ตรวจจับอัตโนมัติ",
    'uvec_manualMode': "โหมดกำหนดเอง",
    'uvec_personalInformation': "ข้อมูลส่วนบุคคล",
    'uvec_detectionOn': "เปิดการตรวจจับ",
    'uvec_detectionOff': "ปิดการตรวจจับ",
    'uvec_enablePersonalInfoDetectionHint': "เปิดใช้งานการตรวจจับข้อมูลส่วนบุคคล",
    'uvec_template': "เทมเพลต",
    'uvec_searchInDocumentContent': "ค้นหาในเนื้อหาเอกสาร",
    'uvec_search': "ค้นหา",
    'uvec_reprocess': "ประมวลผลใหม่",
    'uvec_loading': "กำลังโหลด...",
    'uvec_collapseText': "ย่อข้อความ",
    'uvec_expandText': "ขยายข้อความ",
    'uvec_active': "เปิดใช้งาน",
    'uvec_inactive': "ไม่ใช้งาน",
    'uvec_editContent': "แก้ไขเนื้อหา",
    'uvec_deleteItem': "ลบรายการ",
    'uvec_close': "ปิด",
    'uvec_editVectorContent': "แก้ไขเนื้อหาเวกเตอร์",
    'uvec_modifyYourDocumentContent': "แก้ไขเนื้อหาเอกสารของคุณ",
    'uvec_content': "เนื้อหา",
    'uvec_enterYourContentHere': "กรอกเนื้อหาของคุณที่นี่...",
    'uvec_addVectorContent': "เพิ่มเนื้อหาเวกเตอร์",
    'uvec_createNewDocumentContent': "สร้างเนื้อหาเอกสารใหม่",
    'uvec_loadingPleaseWait': "กำลังโหลด กรุณารอสักครู่...",
    'uvec_templateVector': "เทมเพลตเวกเตอร์",
    'uvec_downloadTemplateFilesHint': "ดาวน์โหลดไฟล์เทมเพลตสำหรับประเภทเอกสารต่าง ๆ",
    'uvec_howToUseTemplates': "วิธีใช้งานเทมเพลต:",
    'uvec_selectAppropriateTemplateHint': "เลือกเทมเพลตที่เหมาะสมกับประเภทเอกสารของคุณ",
    'uvec_downloadTemplateFileFormatHint': "ดาวน์โหลดรูปแบบไฟล์เทมเพลตที่คุณต้องการ",
    'uvec_fillInDataHint': "กรอกข้อมูลของคุณตามโครงสร้างเทมเพลต",
    'uvec_uploadCompletedFileHint': "อัปโหลดไฟล์ที่กรอกเสร็จแล้วผ่านส่วนอัปโหลดด้านบน",
    'uvec_customSplitTemplateLabel': "เทมเพลตแบบแบ่งเอง (CustomSplit):",
    'uvec_useSeparatorHint': "กำหนดตัวคั่นเองได้ตามต้องการ (เช่น {'||!'})",
    'uvec_exampleSplitChunkContent': "ตัวอย่าง: SplitChunkContent",
    'uvec_csv': "CSV",
    'uvec_downloadTemplate': "ดาวน์โหลดเทมเพลต {modeType} - {format}",
    'uvec_excel': "Excel",
    'uvec_multiCol': "หลายคอลัมน์",
    'uvec_excelMultipleColumns': "Excel (หลายคอลัมน์)",
    'uvec_pdf': "PDF",
    'uvec_word': "Word",
    'uvec_ppt': "PPT",
    'uvec_powerPoint': "PowerPoint",
    'uvec_txt': "TXT",
    'uvec_text': "ข้อความ",
    'uvec_processingType': "ประเภทการประมวลผล",
    'vgu_generateQuestionSet': "สร้างชุดคำถาม",
    'vgu_pageSubtitle': "สร้างคำถามอัจฉริยะจากเอกสารความรู้ของคุณ",
    'vgu_questionSetName': "ชื่อชุดคำถาม",
    'vgu_knowledgeDocuments': "เอกสารความรู้",
    'vgu_documentName': "ชื่อเอกสาร",
    'vgu_questionsPerChunk': "จำนวนคำถามต่อชังก์",
    'vgu_parameters': "พารามิเตอร์",
    'vgu_temperature': "Temperature*",
    'vgu_topP': "Top P",
    'vgu_frequencyPenalty': "Frequency Penalty",
    'vgu_presencePenalty': "Presence Penalty",
    'vgu_maxTokensResponse': "จำนวนโทเค็นสูงสุดของคำตอบ",
    'vgu_stopSequence': "Stop Sequence",
    'vgu_tone': "โทนเสียง",
    'vgu_questionsPerTone': "จำนวนคำถามต่อโทนเสียง",
    'vgu_toneFirmTitle': "หนักแน่น",
    'vgu_toneFirmDescription': "สร้างคำถามด้วยภาษาที่เด็ดขาดและหนักแน่น ซึ่งต้องการคำตอบที่ชัดเจนและแน่นอน",
    'vgu_toneConfidentTitle': "มั่นใจ",
    'vgu_toneConfidentDescription': "สร้างคำถามด้วยความมั่นใจและความแน่วแน่ ที่กระตุ้นให้เกิดคำตอบอย่างมีน้ำหนัก",
    'vgu_tonePoeticTitle': "เชิงกวี",
    'vgu_tonePoeticDescription': "สร้างคำถามด้วยภาษาเชิงศิลปะและสื่ออารมณ์ ที่กระตุ้นความคิดสร้างสรรค์และจินตนาการ",
    'vgu_toneNarrativeTitle': "เชิงเล่าเรื่อง",
    'vgu_toneNarrativeDescription': "ออกแบบคำถามที่ส่งเสริมการเล่าเรื่องและคำอธิบายอย่างละเอียดพร้อมบริบท",
    'vgu_toneProfessionalTitle': "มืออาชีพ",
    'vgu_toneProfessionalDescription': "สร้างคำถามด้วยภาษาที่เหมาะสมกับธุรกิจ เหมาะสำหรับการสื่อสารในที่ทำงาน",
    'vgu_toneDescriptiveTitle': "เชิงอธิบาย",
    'vgu_toneDescriptiveDescription': "สร้างคำถามที่กระตุ้นให้เกิดคำอธิบายอย่างละเอียด ชัดเจน และคำตอบที่ครอบคลุม",
    'vgu_toneHumorousTitle': "ตลกขบขัน",
    'vgu_toneHumorousDescription': "สร้างคำถามด้วยองค์ประกอบที่สนุกสนานและเบาสมอง เพื่อดึงดูดผู้ใช้อย่างมีชีวิตชีวา",
    'vgu_toneAcademicTitle': "เชิงวิชาการ",
    'vgu_toneAcademicDescription': "พัฒนาคำถามด้วยภาษาเชิงวิชาการที่เหมาะสมกับบริบทด้านการศึกษาและงานวิจัย",
    'vgu_tonePersuasiveTitle': "โน้มน้าวใจ",
    'vgu_tonePersuasiveDescription': "สร้างคำถามที่กระตุ้นให้เกิดคำตอบที่มีอิทธิพลและน่าเชื่อถือด้วยเหตุผลที่หนักแน่น",
    'vgu_toneFormalTitle': "ทางการ",
    'vgu_toneFormalDescription': "สร้างคำถามด้วยภาษาที่ถูกต้องและมีโครงสร้าง เหมาะสำหรับการสื่อสารอย่างเป็นทางการ",
    'vgu_toneInformalTitle': "ไม่เป็นทางการ",
    'vgu_toneInformalDescription': "สร้างคำถามด้วยภาษาสบายๆ แบบสนทนา เหมาะกับการสื่อสารที่ผ่อนคลาย",
    'vgu_toneFriendlyTitle': "เป็นมิตร",
    'vgu_toneFriendlyDescription': "ออกแบบคำถามด้วยภาษาที่อบอุ่นและเข้าถึงง่าย เพื่อสร้างบทสนทนาที่สบายใจ",
    'vgu_promptConfiguration': "การตั้งค่าพรอมต์",
    'vgu_addMorePrompts': "เพิ่มพรอมต์เติม",
    'vgu_promptTemplate': "เทมเพลตพรอมต์",
    'vgu_copied': "คัดลอกแล้ว!",
    'vgu_copyPromptTemplate': "คัดลอกเทมเพลตพรอมต์",
    'vgu_back': "ย้อนกลับ",
    'vgu_process': "ประมวลผล",
    'vgu_loadingPleaseWait': "กำลังโหลด กรุณารอสักครู่...",
    'vgu_required': "จำเป็นต้องกรอก",
    'vgu_warning': "คำเตือน",
    'vgu_pleaseFillAllFields': "กรุณากรอกข้อมูลให้ครบทุกช่อง!",
    'vgu_invalidRange0To1': "กรุณาป้อนตัวเลขระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำแหน่ง",
    'vgu_invalidRange0To2': "กรุณาป้อนตัวเลขระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำแหน่ง",
        'dash_provider': "ผู้ให้บริการ",
    'dash_startDate': "วันที่เริ่มต้น",
    'dash_endDate': "วันที่สิ้นสุด",
    'dash_download': "ดาวน์โหลด",
    'dash_usdToThbRate': "1 USD = 35 บาท",
    'dash_showPrice': "แสดงราคา",
    'dash_totalTokensAll': "โทเค็นรวมทั้งหมด",
    'dash_chatNonCached': "แชท: ไม่แคช",
    'dash_chatCached': "แชท: แคช",
    'dash_chatCompletion': "แชท: Completion",
    'dash_embeddingInput': "Embedding: อินพุต",
    'dash_feedbackSummary': "สรุปความคิดเห็น",
    'dash_likeDislike': "ถูกใจ / ไม่ถูกใจ",
    'dash_like': "ชอบ",
    'dash_dislike': "ไม่ชอบ",
    'dash_total': "รวม",
    'dash_loading': "กำลังโหลด...",
    'dash_pleaseWait': "กรุณารอสักครู่",
    'dint_addNewTable': "เพิ่มตารางใหม่",
    'dint_configureDataIntegrationTable': "กำหนดค่าตารางสำหรับการเชื่อมโยงข้อมูล",
    'dint_internalConfiguration': "การตั้งค่าระบบภายใน",
    'dint_tableName': "ชื่อตาราง",
    'dint_tableNameInformation': "ข้อมูลเกี่ยวกับชื่อตาราง",
    'dint_uploadFile': "อัปโหลดไฟล์",
    'dint_selectExcelFileToUpload': "เลือกไฟล์ Excel (.xlsx) เพื่ออัปโหลด",
    'dint_supportedFormatExcelOnly': "รองรับเฉพาะไฟล์รูปแบบ Excel (.xlsx) เท่านั้น",
    'dint_columnConfiguration': "การตั้งค่าคอลัมน์",
    'dint_columnsCount': "{n} คอลัมน์",
    'dint_fuzzyMatching': "การจับคู่แบบฟัซซี่",
    'dint_personalInfoLabel': "ข้อมูลส่วนบุคคล:",
    'dint_statusOn': "เปิด",
    'dint_statusOff': "ปิด",
    'dint_externalConfiguration': "การตั้งค่าระบบภายนอก",
    'dint_databaseRequired': "ฐานข้อมูล*",
    'dint_databaseInformation': "ชนิดของฐานข้อมูลปลายทางที่จะเชื่อมต่อ (SQL Server, Oracle, PostgreSQL) — ระบบใช้ค่านี้เลือกรูปแบบคำสั่ง SQL ให้ตรงกับฐานข้อมูลนั้น",
    'dint_columnNameInformation': "ชื่อคอลัมน์ให้ตรงกับหัวตารางในไฟล์ Excel ที่อัปโหลด ระบบจะสร้างคอลัมน์ในตารางด้วยชื่อนี้และใช้อ้างอิงตอนค้นข้อมูล",
    'dint_connectionString': "สตริงการเชื่อมต่อ",
    'dint_schema': "โครงสร้างข้อมูล (Schema)",
    'dint_view': "มุมมอง (View)",
    'dint_viewInformation': "ชื่อตารางหรือ View ในฐานข้อมูลปลายทางที่ระบบจะดึงข้อมูล ใช้ต่อจาก Schema เป็น [Schema].[ชื่อนี้]",
    'dint_addColumn': "เพิ่มคอลัมน์",
    'dint_addOnlyNeededColumnsHint': "เพิ่มเฉพาะ Column ที่ต้องใช้ (ไม่จำเป็นต้องใช้ทุก Column ที่มีอยู่ใน Table)",
    'dint_column': "คอลัมน์",
    'dint_testConnection': "ทดสอบการเชื่อมต่อ",
    'dint_getAllColumns': "ดึงคอลัมน์ทั้งหมด",
    'dint_saveConfiguration': "บันทึกการตั้งค่า",
    'dint_loading': "กำลังโหลด...",
    'dint_pleaseWait': "กรุณารอสักครู่",
    'dint_required': "จำเป็นต้องกรอก",
    'dint_fuzzyOptionNone': "ไม่มี",
    'dint_fuzzyOptionNoneDescription': "ไม่มีการจับคู่แบบฟัซซี่",
    'dint_fuzzyOptionFuzzySearch': "ค้นหาแบบฟัซซี่",
    'dint_fuzzyOptionFuzzySearchDescription': "เปิดใช้งานการจับคู่ข้อความแบบใกล้เคียงสำหรับคอลัมน์นี้",
    'dint_fuzzyOptionFuzzyWithBot': "ฟัซซี่ด้วยบอท",
    'dint_fuzzyOptionFuzzyWithBotDescription': "การจับคู่อัจฉริยะด้วย AI ที่มีความแม่นยำสูงขึ้น",
    'dint_system': "ระบบ",
    'dint_createBy': "สร้างโดย",
    'dint_action': "การดำเนินการ",
    'dint_columnNameNoLeadingTrailingSpaces': "ชื่อคอลัมน์ต้องไม่มีช่องว่างนำหน้าหรือต่อท้าย!",
    'dint_noWorksheetFoundInExcelFile': "ไม่พบ worksheet ในไฟล์ Excel",
    'dint_columnDataExceedsCharacterLimit': "ข้อมูลในคอลัมน์ {column} แถวที่ {row} เกินขีดจำกัด 800 ตัวอักษร",
    'dint_pleaseFillInConnectionString': "กรุณากรอกข้อมูล Connection String!",
    'dint_pleaseFillInSchema': "กรุณากรอกข้อมูล Schema!",
    'dint_pleaseFillInView': "กรุณากรอกข้อมูล View!",
    'dint_pleaseFillInAllColumnNames': "กรุณากรอกชื่อคอลัมน์ให้ครบทุกช่อง!",
    'dint_okay': "ตกลง",
    'dint_pleaseFillAllFields': "กรุณากรอกข้อมูลให้ครบทุกช่อง!",
    'dintd_dataIntegrationDetail': "รายละเอียดการเชื่อมต่อข้อมูล",
    'dintd_dataIntegrationName': "ชื่อการเชื่อมต่อข้อมูล",
    'dintd_configuration': "การตั้งค่า",
    'dintd_columnIndex': "คอลัมน์ {n}",
    'dintd_fuzzyMatching': "การจับคู่แบบฟัซซี่",
    'dintd_validateColumn': "ตรวจสอบคอลัมน์",
    'dintd_personalInfoLabel': "ข้อมูลส่วนบุคคล:",
    'dintd_on': "เปิด",
    'dintd_off': "ปิด",
    'dintd_addColumn': "เพิ่มคอลัมน์",
    'dintd_addColumnHint': "เพิ่มเฉพาะ Column ที่ต้องการ (ไม่จำเป็นต้องใช้ทุก Column ที่มีอยู่ใน Table)",
    'dintd_data': "ข้อมูล",
    'dintd_search': "ค้นหา",
    'dintd_uploadExcel': "อัปโหลดไฟล์ Excel",
    'dintd_dataTable': "ตารางข้อมูล",
    'dintd_noDataAvailable': "ไม่มีข้อมูล",
    'dintd_tryDifferentSearch': "ลองค้นหาด้วยคำอื่น",
    'dintd_itemsPerPage': "รายการต่อหน้า:",
    'dintd_of': "จาก",
    'dintd_addNewDataSubtitle': "เพิ่มข้อมูลใหม่ให้กับการเชื่อมโยงข้อมูลของคุณ",
    'dintd_true': "จริง",
    'dintd_false': "เท็จ",
    'dintd_editDataSubtitle': "แก้ไขข้อมูลที่มีอยู่",
    'dintd_loadingPleaseWait': "กำลังโหลด กรุณารอสักครู่...",
    'dintd_fuzzyNone': "ไม่มี",
    'dintd_fuzzyNoneDescription': "ไม่มีการจับคู่แบบฟัซซี่",
    'dintd_fuzzySearch': "ค้นหาแบบฟัซซี่",
    'dintd_fuzzySearchDescription': "เปิดใช้การจับคู่ข้อความแบบใกล้เคียงสำหรับคอลัมน์นี้",
    'dintd_fuzzyWithBot': "ฟัซซี่ด้วยบอท",
    'dintd_fuzzyWithBotDescription': "การจับคู่อัจฉริยะด้วย AI ที่มีความแม่นยำสูงขึ้น",
    'dintd_requiredField': "จำเป็นต้องกรอก",
    'dintd_modeAdd': "เพิ่ม",
    'dintd_modeReplace': "แทนที่",
    'dintd_pleaseFillAllFields': "กรุณากรอกข้อมูลให้ครบทุกช่อง!",
    'dintd_columnDuplicate': "คอลัมน์ซ้ำกัน!",
    'dintd_columnNameRequired': "จำเป็นต้องระบุชื่อคอลัมน์!",
    'dintd_pleaseFillColumnName': "กรุณากรอกชื่อคอลัมน์",
    'dintd_okay': "ตกลง",
    'dintd_columnNameAlreadyExists': "ชื่อคอลัมน์นี้มีอยู่แล้ว!",
    'dintd_pleaseChooseDifferentColumnName': "กรุณาเลือกชื่อคอลัมน์อื่น",
    'dintd_columnValidationSuccess': "ตรวจสอบคอลัมน์สำเร็จ!",
    'dintd_columnValidationFailed': "ตรวจสอบคอลัมน์ไม่สำเร็จ!",
    'dintd_columnValidationErrorOccurred': "เกิดข้อผิดพลาดระหว่างตรวจสอบคอลัมน์!",
    'dintd_pleaseTryAgainLater': "กรุณาลองใหม่อีกครั้งในภายหลัง",
    'gmnm_nodeName': "ชื่อโหนด",
    'gmnm_prompt': "พรอมต์",
    'gmnm_charTokenHint': "4 ตัวอักษร = 1 โทเค็น",
    'gmnm_role1': "บทบาท 1",
    'gmnm_content1': "เนื้อหา 1",
    'gmnm_role2': "บทบาท 2",
    'gmnm_content2': "เนื้อหา 2",
    'gmnm_role3': "บทบาท 3",
    'gmnm_content3': "เนื้อหา 3",
    'gmnm_role4': "บทบาท 4",
    'gmnm_content4': "เนื้อหา 4",
    'gmnm_role5': "บทบาท 5",
    'gmnm_content5': "เนื้อหา 5",
    'gmnm_loadingPleaseWait': "กำลังโหลด กรุณารอสักครู่...",
    'gmnm_confirmDeleteData': "คุณแน่ใจที่จะลบข้อมูลนี้หรือไม่",
    'gmnm_modelName': "ชื่อโมเดล",
    'gum_noGroup': "ไม่มีกลุ่ม",
    'gum_viewDetails': "ดูรายละเอียด",
    'gum_synced': "ซิงค์แล้ว",
    'gum_notSynced': "ยังไม่ซิงค์",
    'gum_createOrManageGroupSettings': "สร้างหรือจัดการการตั้งค่ากลุ่ม",
    'gum_readyToSave': "พร้อมบันทึก",
    'gum_basicInformation': "ข้อมูลพื้นฐาน",
    'gum_modelConfiguration': "การตั้งค่าโมเดล",
    'gum_modelGrouping': "การจัดกลุ่มโมเดล",
    'gum_model': "โมเดล",
    'gum_modelsSelectedCount': "เลือกโมเดลแล้ว {n} รายการ",
    'gum_modelDetailsAndInformation': "รายละเอียดและข้อมูลโมเดล",
    'gum_noModelsFound': "ไม่พบโมเดล",
    'gum_noModelDataAvailable': "ไม่มีข้อมูลโมเดลให้แสดง",
    'gum_view': "ดู",
    'gum_modelsCount': "{n} โมเดล",
    'gum_loading': "กำลังโหลด...",
    'gum_pleaseWait': "กรุณารอสักครู่",
    'gum_templateUser': "เทมเพลตผู้ใช้",
    'gum_userCsv': "ผู้ใช้ - CSV",
    'gum_userExcel': "ผู้ใช้ - Excel",
    'gum_inputIsRequired': "กรุณากรอกข้อมูล!",
    'gum_required': "จำเป็นต้องกรอก",
    'gum_min10Numbers': "อย่างน้อย 10 ตัวเลข",
    'gum_csv': "CSV",
    'gum_excel': "Excel",
    'gum_pleaseFillRequiredFields': "กรุณากรอกข้อมูลในช่องที่จำเป็น!!!",
    'gum_pleaseSelectYourModel': "กรุณาเลือกโมเดลของคุณ!!!",
    'saevt_startDate': "วันที่เริ่มต้น",
    'saevt_endDate': "วันที่สิ้นสุด",
    'saevt_apiName': "ชื่อ API",
    'saevt_searchApiNamePlaceholder': "ค้นหาชื่อ API...",
    'saevt_createBy': "สร้างโดย",
    'saevt_searchCreateByPlaceholder': "ค้นหาผู้สร้าง...",
    'saevt_actionCreate': "สร้าง",
    'saevt_actionDelete': "ลบ",
    'saevt_actionUpdate': "อัปเดต",
    'saevt_statusCodeOk': "สำเร็จ",
    'saevt_statusCodeBadRequest': "คำขอไม่ถูกต้อง",
    'saevt_statusCodeInternalServerError': "เกิดข้อผิดพลาดภายในเซิร์ฟเวอร์",
    'saevt_statusApiSuccessful': "สำเร็จ",
    'saevt_statusApiError': "ข้อผิดพลาด",
    'saevt_statusApiSystemError': "ข้อผิดพลาดของระบบ",
    'saevt_statusApiDuplicate': "ข้อมูลซ้ำ",
    'saevt_statusApiLess': "ข้อมูลไม่ครบ",
    'saevt_statusApiException': "ข้อผิดพลาด",
    'saevt_colNo': "ลำดับ",
    'saevt_colApiName': "ชื่อ API",
    'saevt_colAction': "การดำเนินการ",
    'saevt_colStatusCode': "รหัสสถานะ",
    'saevt_colIpAddress': "ที่อยู่ IP",
    'saevt_colStatusApi': "สถานะ API",
    'saevt_colMessage': "ข้อความ",
    'saevt_colCreateBy': "สร้างโดย",
    'saevt_colCreateDate': "วันที่สร้าง",
    'sampkg_superAdmin': "ผู้ดูแลระบบสูงสุด",
    'sampkg_masterPackage': "แพ็กเกจหลัก",
    'sampkg_search': "ค้นหา",
    'sampkg_searchPlaceholder': "ชื่อบริษัท, แพ็กเกจ",
    'sampkg_addMasterPackage': "เพิ่มแพ็กเกจหลัก",
    'sampkg_loading': "กำลังโหลด...",
    'sampkg_statusActive': "เปิดใช้งาน",
    'sampkg_statusInactive': "ไม่ใช้งาน",
    'sampkg_colNo': "ลำดับ",
    'sampkg_colCompany': "บริษัท",
    'sampkg_colPackage': "แพ็กเกจ",
    'sampkg_colStartDate': "วันที่เริ่มต้น",
    'sampkg_colEndDate': "วันที่สิ้นสุด",
    'sampkg_colStatus': "สถานะ",
    'sampkg_colActions': "การดำเนินการ",
    'sampkg_companyRequired': "บริษัท*",
    'sampkg_packageRequired': "แพ็กเกจ*",
    'sampkg_startDate': "วันที่เริ่มต้น",
    'sampkg_endDate': "วันที่สิ้นสุด",
    'sampkg_status': "สถานะ",
    'sampkg_required': "จำเป็นต้องกรอก",
    'sampkg_mockModeTitle': "โหมดจำลอง",
    'sampkg_mockModeText': "ยังไม่ได้ต่อ backend",
    'scmenu_pageTitle': "เมนูทางลัด",
    'scmenu_loading': "กำลังโหลด...",
    'scmenu_pleaseWait': "กรุณารอสักครู่",
    'scmenu_editDialogTitle': "แก้ไขเมนูคำสั่งลัด",
    'scmenu_editDialogSubtitle': "แก้ไขการตั้งค่าเมนูคำสั่งลัด",
    'scmenu_basicInformation': "ข้อมูลพื้นฐาน",
    'scmenu_groupNameLabel': "ชื่อกลุ่มคำสั่งลัด",
    'scmenu_enterGroupNamePlaceholder': "กรอกชื่อกลุ่ม...",
    'scmenu_commandSingular': "คำสั่ง",
    'scmenu_commandPlural': "คำสั่ง",
    'scmenu_actions': "การดำเนินการ",
    'scmenu_quickReplyNamePlaceholder': "ชื่อข้อความตอบกลับด่วน",
    'scmenu_quickReplyDataPlaceholder': "ข้อมูลข้อความตอบกลับด่วน",
    'scmenu_quickReplyDataSentHint': "ข้อมูลข้อความตอบกลับด่วนที่จะถูกส่ง",
    'scmenu_previewAlt': "ตัวอย่าง",
    'scmenu_remove': "ลบ",
    'scmenu_configureShortcutCommandsHint': "ตั้งค่าคำสั่งลัดพร้อมป้ายชื่อ ข้อความ และไอคอนที่กำหนดเอง",
    'scmenu_commandsConfigured': "ตั้งค่าแล้ว {n} คำสั่ง{plural}",
    'scmenu_addDialogTitle': "เพิ่มเมนูคำสั่งลัด",
    'scmenu_addDialogSubtitle': "สร้างเมนูคำสั่งลัดใหม่",
    'scmenu_shortcutMenuNameTooltip': "ชื่อ Shortcut Menu",
    'scmenu_shortcutCommandsNamePlaceholder': "ชื่อคำสั่งลัด",
    'scmenu_shortcutCommandsDataPlaceholder': "ข้อมูลคำสั่งลัด",
    'scmenu_shortcutCommandsDataSentHint': "ข้อมูลคำสั่งลัดที่จะถูกส่ง",
    'scmenu_required': "จำเป็นต้องกรอก",
    'scmenu_duplicatedModelsError': "กลุ่มต้องไม่มีโมเดลที่ซ้ำกัน",
    'scmenu_fillRequiredFields': "กรุณากรอกข้อมูลในช่องที่จำเป็น!!!",
    'scmenu_errorOccurred': "เกิดข้อผิดพลาด!",
    'scmenu_somethingWentWrong': "เกิดข้อผิดพลาดบางอย่าง!",
    'scmenu_onlyJpegPngAllowed': "ลองรับไฟล์ jpeg หรือ png เท่านั้น",
    'ugd_syncUsers': "ซิงค์ผู้ใช้",
    'ugd_syncing': "กำลังซิงค์...",
    'ugd_setupUserGroup': "ตั้งค่ากลุ่มผู้ใช้",
    'ugd_search': "ค้นหา",
    'ugd_changePassword': "เปลี่ยนรหัสผ่าน",
    'ugd_createNewSecurePassword': "สร้างรหัสผ่านใหม่ที่ปลอดภัยสำหรับบัญชีของคุณ",
    'ugd_basicInformation': "ข้อมูลพื้นฐาน",
    'ugd_integrationSocial': "การเชื่อมต่อโซเชียล",
    'ugd_modelConfiguration': "การตั้งค่าโมเดล",
    'ugd_modelGrouping': "การจัดกลุ่มโมเดล",
    'ugd_model': "โมเดล",
    'ugd_modelShortcut': "ทางลัดโมเดล",
    'ugd_loading': "กำลังโหลด...",
    'ugd_pleaseWait': "กรุณารอสักครู่",
    'ugd_passwordRequirements': "ข้อกำหนดรหัสผ่าน",
    'ugd_newPassword': "รหัสผ่านใหม่",
    'ugd_confirmPasswordLabel': "ยืนยันรหัสผ่าน",
    'ugd_securityTips': "เคล็ดลับความปลอดภัย:",
    'ugd_tipUseCombination': "ใช้ตัวอักษร ตัวเลข และสัญลักษณ์ร่วมกัน",
    'ugd_tipAvoidPersonalInfo': "หลีกเลี่ยงการใช้ข้อมูลส่วนตัวในรหัสผ่าน",
    'ugd_tipDontReuse': "ไม่ควรใช้รหัสผ่านซ้ำกับบัญชีอื่น",
    'ugd_tipUsePasswordManager': "ควรพิจารณาใช้โปรแกรมจัดการรหัสผ่าน",
    'ugd_required': "จำเป็นต้องกรอก",
    'ugd_min10Numbers': "อย่างน้อย 10 ตัวเลข",
    'ugd_close': "ปิด",
    'ugd_invalidPhoneFormat': "รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง",
    'ugd_invalidEmail': "อีเมลไม่ถูกต้อง",
    'ugd_pleaseFillCorrectFormat': "กรุณากรอกข้อมูลให้ถูกต้องตามรูปแบบ",
    'ugd_pleaseFillAllFields': "กรุณากรอกข้อมูลให้ครบทุกช่อง",
    'usd_pageTitle': "อัปโหลดไฟล์เสียงไปยังเอกสาร",
    'usd_documentNameLabel': "ชื่อเอกสาร",
    'usd_editTooltip': "แก้ไข",
    'usd_importToKnowledgeBaseTooltip': "นำเข้าสู่ฐานความรู้",
    'usd_deleteTooltip': "ลบ",
    'usd_uploadSpeechFilesTitle': "อัปโหลดไฟล์เสียง",
    'usd_uploadSpeechFilesSubtitle': "อัปโหลดและประมวลผลไฟล์เสียงเพื่อถอดข้อความ",
    'usd_documentNameRequiredLabel': "ชื่อเอกสาร *",
    'usd_documentNamePlaceholder': "กรอกชื่อที่สื่อความหมายสำหรับเอกสารของคุณ",
    'usd_languageLabel': "ภาษา",
    'usd_aiModelForSummationLabel': "โมเดล AI (สำหรับสรุปความ)",
    'usd_selectAiModelPlaceholder': "เลือกโมเดล AI สำหรับสรุปข้อความ",
    'usd_requiredRule': "จำเป็นต้องกรอก",
    'usd_botSummationLabel': "สรุปความโดยบอท",
    'usd_uploadAudioFilesTitle': "อัปโหลดไฟล์เสียง",
    'usd_supportedFormatsHint': "รองรับไฟล์ประเภท MP3, WAV, M4A, FLAC (ขนาดไม่เกิน 100MB ต่อไฟล์)",
    'usd_filesSelectedCount': "เลือกไฟล์แล้ว {n} ไฟล์",
    'usd_cancelButton': "ยกเลิก",
    'usd_uploadFilesButton': "อัปโหลดไฟล์",
    'usd_importToKnowledgeDocumentTitle': "นำเข้าสู่เอกสารความรู้",
    'usd_importToKnowledgeBaseSubtitle': "นำเข้าข้อมูลที่ประมวลผลแล้วสู่ฐานความรู้",
    'usd_selectDocumentRequiredLabel': "เลือกเอกสาร *",
    'usd_chooseKnowledgeDocumentPlaceholder': "เลือกเอกสารความรู้",
    'usd_maxSplitCharactersRequiredLabel': "จำนวนอักขระสูงสุดต่อการแบ่ง *",
    'usd_importInformationLabel': "ข้อมูลการนำเข้า:",
    'usd_documentLabel': "เอกสาร:",
    'usd_importInformationDescription': "ระบบจะประมวลผลและแบ่งเนื้อหาเพื่อรวมเข้ากับฐานความรู้",
    'usd_importButton': "นำเข้า",
    'usd_loadingTitle': "กำลังโหลด...",
    'usd_pleaseWaitSubtitle': "กรุณารอสักครู่",
    'usd_pleaseFillAllFields': "กรุณากรอกข้อมูลให้ครบทุกช่อง",
    'usd_headerNo': "ลำดับ",
    'usd_headerDocument': "เอกสาร",
    'usd_headerCreateBy': "สร้างโดย",
    'usd_headerProcess': "ประมวลผล",
    'usd_headerAction': "การดำเนินการ",
    'vpd_uploadPositiveQuestionSet': "อัปโหลดชุดคำถามเชิงบวก",
    'vpd_questionSetName': "ชื่อชุดคำถาม",
    'vpd_template': "เทมเพลต",
    'vpd_normalQuestion': "คำถามทั่วไป",
    'vpd_chainQuestion': "คำถามแบบต่อเนื่อง",
    'vpd_process': "ประมวลผล",
    'vpd_back': "ย้อนกลับ",
    'vpd_loading': "กำลังโหลด...",
    'vpd_pleaseWait': "กรุณารอสักครู่",
    'vpd_addQuestionSet': "เพิ่มชุดคำถาม",
    'vpd_createNewQuestionAnswerPair': "สร้างคู่คำถามและคำตอบใหม่",
    'vpd_question': "คำถาม",
    'vpd_enterYourQuestionHere': "กรอกคำถามของคุณที่นี่...",
    'vpd_humanAnswer': "คำตอบของมนุษย์",
    'vpd_enterExpectedAnswerHere': "กรอกคำตอบที่คาดหวังที่นี่...",
    'vpd_questionType': "ประเภทคำถาม",
    'vpd_selectQuestionTypeHint': "เลือกประเภทของคำถาม: แบบทั่วไป หรือ แบบต่อเนื่อง",
    'vpd_editQuestionSet': "แก้ไขชุดคำถาม",
    'vpd_modifyExistingQuestionAnswerPair': "แก้ไขคู่คำถามและคำตอบที่มีอยู่",
    'vpd_required': "จำเป็นต้องกรอก",
    'vpd_pleaseFillAllFields': "กรุณากรอกข้อมูลให้ครบทุกช่อง",
    'vpd_invalidFileFormat': "รูปแบบไฟล์ไม่ถูกต้อง",
    'vpd_ensureFileCorrectFormat': "กรุณาตรวจสอบว่าไฟล์อยู่ในรูปแบบที่ถูกต้อง",
    'vpd_pleaseSpecifyQuestionType': "กรุณาระบุประเภทคำถามของคุณ",
    'vpd_type': "ประเภท",
    'vproc_refresh': "รีเฟรช",
    'vproc_testName': "ชื่อการทดสอบ",
    'vproc_reprocess': "ประมวลผลใหม่",
    'vproc_viewScoreDashboard': "ดูแดชบอร์ดคะแนน",
    'vproc_completeProcessToViewScores': "ดำเนินการให้เสร็จสิ้นเพื่อดูคะแนน",
    'vproc_editValidationProcess': "แก้ไขกระบวนการตรวจสอบ",
    'vproc_uploadQuestionSet': "อัปโหลดชุดคำถาม",
    'vproc_modifyExistingValidationConfig': "แก้ไขการตั้งค่าการตรวจสอบที่มีอยู่",
    'vproc_createNewValidationTestConfig': "สร้างการตั้งค่าการทดสอบตรวจสอบใหม่",
    'vproc_testNameRequired': "ชื่อการทดสอบ*",
    'vproc_modelName': "ชื่อโมเดล",
    'vproc_questionType': "ประเภทคำถาม",
    'vproc_positive': "เชิงบวก",
    'vproc_positiveValidationQuestions': "คำถามตรวจสอบเชิงบวก",
    'vproc_negative': "เชิงลบ",
    'vproc_negativeValidationQuestions': "คำถามตรวจสอบเชิงลบ",
    'vproc_processingType': "ประเภทการประมวลผล",
    'vproc_chain': "แบบต่อเนื่อง",
    'vproc_chainProcessingMode': "โหมดการประมวลผลแบบต่อเนื่อง",
    'vproc_questionSetName': "ชื่อชุดคำถาม",
    'vproc_chainQuestion': "คำถามแบบต่อเนื่อง",
    'vproc_questionPositiveName': "ชื่อคำถามเชิงบวก",
    'vproc_questionsNegativeName': "ชื่อคำถามเชิงลบ",
    'vproc_uploadFile': "อัปโหลดไฟล์",
    'vproc_template': "เทมเพลต",
    'vproc_sizeBytes': "{size} ไบต์",
    'vproc_prompt': "พรอมต์",
    'vproc_scoreModel': "โมเดลผู้ให้คะแนน",
    'vproc_pleaseSelectScoreModel': "กรุณาเลือกโมเดลผู้ให้คะแนน",
    'vproc_scoreModelEmpty': "ไม่มีโมเดลที่ใช้ให้คะแนนได้ในกลุ่ม LLM ของหน่วยงาน กรุณาติดต่อผู้ดูแลระบบ",
    'vproc_scoreModelLoadFailed': "โหลดรายชื่อโมเดลผู้ให้คะแนนไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
    'vproc_scoreModelNotAvailable': "โมเดลผู้ให้คะแนนที่เลือกใช้งานไม่ได้แล้ว กรุณาเลือกโมเดลใหม่",
    'vproc_scoreModelLoading': "กำลังโหลดรายชื่อโมเดล…",
    'vproc_scoreModelMissingOption': "โมเดลที่บันทึกไว้ถูกลบหรือปิดใช้งานแล้ว (รหัส {id})",
    'vproc_scoreModelUnnamed': "(ไม่ระบุชื่อโมเดล) รหัส {id}",
    'vproc_scoreModelRetry': "ลองโหลดรายชื่อโมเดลใหม่",
    'vproc_loading': "กำลังโหลด...",
    'vproc_pleaseWait': "กรุณารอสักครู่",
    'vproc_requiredField': "จำเป็นต้องกรอก",
    'vproc_process': "ประมวลผล",
    'vproc_status': "สถานะ",
    'vproc_createBy': "สร้างโดย",
    'vproc_dataProcessed': "ข้อมูลที่ประมวลผลแล้ว",
    'vproc_action': "การดำเนินการ",
    'vproc_result': "ผลลัพธ์",
    'vproc_pleaseFillAllFields': "กรุณากรอกข้อมูลให้ครบทุกช่อง!",
    'vproc_pleaseEnterCorrectFormat': "กรุณากรอกรูปแบบให้ถูกต้อง!",
    'vproc_confirmDeletionText': "คุณต้องการยืนยันการลบการตรวจสอบนี้หรือไม่",
    'vproc_somethingWentWrong': "เกิดข้อผิดพลาดบางอย่าง",
        'csvc_chatTitle': "แชท",
    'csvc_filterOptions': "ตัวเลือกการกรอง",
    'csvc_contactStatus': "สถานะการติดต่อ",
    'csvc_all': "ทั้งหมด",
    'csvc_contactAgent': "ติดต่อเจ้าหน้าที่",
    'csvc_contactBot': "ติดต่อบอท",
    'csvc_reset': "รีเซ็ต",
    'csvc_apply': "นำไปใช้",
    'csvc_noDataAvailable': "ไม่มีข้อมูล",
    'csvc_admin': "แอดมิน",
    'csvc_bot': "บอท",
    'csvc_toggleUserList': "สลับการแสดงรายชื่อผู้ใช้",
    'csvc_userNotSelected': "ยังไม่ได้เลือกผู้ใช้",
    'csvc_typeYourMessage': "พิมพ์ข้อความของคุณ...",
    'gmnd_update': "อัปเดต",
    'gmnd_create': "สร้าง",
    'gmnd_gptModelInternal': "โมเดล GPT ภายใน (GPT Model Internal)",
    'gmnd_nodeName': "ชื่อโหนด",
    'gmnd_prompt': "พรอมต์",
    'gmnd_charTokenHint': "4 ตัวอักษร = 1 โทเค็น",
    'gmnd_example1': "ตัวอย่างที่ 1",
    'gmnd_role1': "บทบาท 1",
    'gmnd_content1': "เนื้อหา 1",
    'gmnd_example2': "ตัวอย่างที่ 2",
    'gmnd_role2': "บทบาท 2",
    'gmnd_content2': "เนื้อหา 2",
    'gmnd_example3': "ตัวอย่างที่ 3",
    'gmnd_role3': "บทบาท 3",
    'gmnd_content3': "เนื้อหา 3",
    'gmnd_example4': "ตัวอย่างที่ 4",
    'gmnd_role4': "บทบาท 4",
    'gmnd_content4': "เนื้อหา 4",
    'gmnd_example5': "ตัวอย่างที่ 5",
    'gmnd_role5': "บทบาท 5",
    'gmnd_content5': "เนื้อหา 5",
    'gmnd_back': "ย้อนกลับ",
    'gmnd_save': "บันทึก",
    'gmnd_loadingPleaseWait': "กำลังโหลด กรุณารอสักครู่...",
    'lae_apiExternalLog': "บันทึก API ภายนอก",
    'lae_apiEndpointPlaceholder': "เอนด์พอยต์ API",
    'lae_search': "ค้นหา",
    'lae_export': "ส่งออก",
    'lae_filterTooltip': "ตัวกรอง",
    'lae_apiExternalLogRecords': "บันทึกการเรียก API ภายนอก ({count} รายการ)",
    'lae_notAvailable': "-",
    'lae_noDataAvailable': "ไม่มีข้อมูล",
    'lae_noApiLogsFound': "ไม่พบบันทึก API ที่ตรงกับเงื่อนไขที่ค้นหา",
    'lae_filterOptions': "ตัวเลือกการกรอง",
    'lae_transactionId': "รหัสธุรกรรม",
    'lae_method': "เมธอด",
    'lae_statusCode': "รหัสสถานะ",
    'lae_createBy': "สร้างโดย",
    'lae_startDate': "วันที่เริ่มต้น",
    'lae_selectStartDateHint': "เลือกวันที่เริ่มต้นสำหรับการกรอง",
    'lae_endDate': "วันที่สิ้นสุด",
    'lae_selectEndDateHint': "เลือกวันที่สิ้นสุดสำหรับการกรอง",
    'lae_clearAll': "ล้างทั้งหมด",
    'lae_applyFilter': "ใช้ตัวกรอง",
    'lae_apiExternalDetail': "รายละเอียดการเรียก API ภายนอก",
    'lae_transactionIdLabel': "รหัสธุรกรรม:",
    'lae_apiEndpointLabel': "เอนด์พอยต์ API:",
    'lae_methodLabel': "เมธอด:",
    'lae_statusCodeLabel': "รหัสสถานะ:",
    'lae_createByLabel': "สร้างโดย :",
    'lae_createDateLabel': "วันที่สร้าง :",
    'lae_requestBody': "เนื้อหาคำขอ",
    'lae_jsonResponse': "การตอบกลับ JSON",
    'lae_close': "ปิด",
    'lae_loading': "กำลังโหลด...",
    'lae_pleaseWait': "กรุณารอสักครู่",
    'lae_no': "ลำดับ",
    'lae_apiEndpoint': "เอนด์พอยต์ API",
    'lae_createDate': "วันที่สร้าง",
    'lae_details': "รายละเอียด",
    'mmgt_all': "ทั้งหมด",
    'mmgt_menuNameRequired': "ชื่อเมนู*",
    'mmgt_userGroupRequired': "กลุ่มผู้ใช้*",
    'mmgt_requiredFieldIndicator': "*หมายถึงช่องข้อมูลที่จำเป็นต้องกรอก",
    'mmgt_pleaseEnterMenuName': "กรุณากรอกชื่อเมนู",
    'mmgt_noChosenGroup': "เมนูนี้ยังไม่ได้เลือกกลุ่ม",
    'mmgt_pleaseSelectAllFields': "กรุณาเลือกข้อมูลให้ครบทุกช่อง",
    'mmgt_pleaseFillAllFields': "กรุณากรอกข้อมูลให้ครบทุกช่อง",
    'mmgt_pleaseFillAllFieldsAlt': "กรุณากรอกข้อมูลให้ครบทุกช่อง",
    'ptmpl_pageTitle': "รายละเอียดเทมเพลตพรอมต์",
    'ptmpl_addTemplate': "เพิ่มเทมเพลต",
    'ptmpl_textGroupName': "ชื่อกลุ่มข้อความ",
    'ptmpl_statusOn': "เปิด",
    'ptmpl_statusOff': "ปิด",
    'ptmpl_createSubtitle': "สร้างเทมเพลตพรอมต์ใหม่",
    'ptmpl_templateName': "ชื่อเทมเพลต",
    'ptmpl_templateNamePlaceholder': "กรอกชื่อเทมเพลต...",
    'ptmpl_active': "เปิดใช้งาน",
    'ptmpl_inactive': "ไม่ใช้งาน",
    'ptmpl_promptTemplateLabel': "เทมเพลตพรอมต์",
    'ptmpl_promptTemplatePlaceholder': "กรอกเทมเพลตพรอมต์ของคุณที่นี่...",
    'ptmpl_editSubtitle': "แก้ไขเทมเพลตพรอมต์ที่มีอยู่",
    'ptmpl_loading': "กำลังโหลด...",
    'ptmpl_pleaseWait': "กรุณารอสักครู่",
    'ptmpl_requiredField': "จำเป็นต้องกรอก",
    'ptmpl_promptColumnHeader': "พรอมต์",
    'ptmpl_statusColumnHeader': "สถานะ",
    'ptmpl_pleaseEnterTextGroupName': "กรุณากรอกชื่อกลุ่มข้อความ",
    'rfb_download': "ดาวน์โหลด",
    'rfb_feedbackReportManagement': "การจัดการรายงานความคิดเห็น",
    'rfb_dateRange': "ช่วงวันที่",
    'rfb_startDate': "วันที่เริ่มต้น",
    'rfb_endDate': "วันที่สิ้นสุด",
    'rfb_actions': "การดำเนินการ",
    'rfb_search': "ค้นหา",
    'rfb_feedbackAnalytics': "การวิเคราะห์ความคิดเห็น",
    'rfb_likeDislikeDistribution': "การกระจายชอบ/ไม่ชอบ",
    'rfb_feedbackByModel': "ความคิดเห็นแยกตามโมเดล",
    'rfb_loading': "กำลังโหลด...",
    'rfb_pleaseWait': "กรุณารอสักครู่",
    'rfb_like': "ชอบ",
    'rfb_dislike': "ไม่ชอบ",
    'rfb_fillStartEndDate': "กรุณากรอกวันที่เริ่มต้นและวันที่สิ้นสุด!",
    'rfb_fillRequiredFields': "กรุณากรอกข้อมูลในช่องที่จำเป็น",
    'sasub_email': "อีเมล",
    'sasub_phone': "โทร",
    'sasub_subscriptionPeriod': "ระยะเวลาการสมัครสมาชิก",
    'sasub_statusCancelled': "ยกเลิกแล้ว",
    'sasub_statusExpired': "หมดอายุ",
    'sasub_statusExpireSoon': "ใกล้หมดอายุ",
    'sasub_createDate': "วันที่สร้าง",
    'sasub_textTokenUsage': "การใช้งานโทเค็นข้อความ",
    'sasub_imageGenerationUsage': "การใช้งานสร้างรูปภาพ ($)",
    'sasub_itemsPerPage': "รายการต่อหน้า",
    'sasub_subscription': "การสมัครสมาชิก",
    'sasub_companyName': "ชื่อบริษัท",
    'sasub_packageName': "ชื่อแพ็กเกจ",
    'sasub_startDate': "วันที่เริ่มต้น",
    'sasub_expirationDate': "วันที่หมดอายุ",
    'sasub_expirationDateOptionalHint': "ไม่บังคับ — เว้นว่างไว้หากไม่มีวันหมดอายุ (∞)",
    'sasub_priceBaht': "ราคา (บาท)",
    'sasub_tokenLimit': "จำนวนโทเค็นสูงสุด",
    'sasub_unlimitedToken': "โทเค็นไม่จำกัด",
    'sasub_resetToken': "รีเซ็ตโทเค็น",
    'sasub_imageGenerationCreditLimit': "วงเงินเครดิตสร้างรูปภาพสูงสุด",
    'sasub_unlimitedImageCredit': "เครดิตรูปภาพไม่จำกัด",
    'sasub_resetImageCreditUsed': "รีเซ็ตเครดิตรูปภาพที่ใช้ไป",
    'sasub_imageCreditUsageKeptNote': "หมายเหตุ: ประวัติการใช้เครดิตรูปภาพจะยังคงถูกเก็บไว้ตามเดิม",
    'sasub_errorOccurred': "เกิดข้อผิดพลาด",
    'sasub_renewConfirmText': "ต่ออายุการสมัครสมาชิกของ \"{companyName}\" ใช่หรือไม่?",
    'sasub_cancelConfirmText': "ยกเลิกการสมัครสมาชิกของ \"{companyName}\" ใช่หรือไม่?",
    'sasub_testNotiConfirmTitle': "ทดสอบส่ง Notification",
    'sasub_testNotiConfirmText': "ส่ง notification ทดสอบของ \"{companyName}\" ตอนนี้เลยใช่หรือไม่? (ส่งอีเมลจริงถึงผู้ดูแล)",
    'sasub_testNotiSent': "ส่ง notification ทดสอบแล้ว",
    'saumgt_export': "ส่งออก",
    'saumgt_searchPlaceholder': "ค้นหาชื่อผู้ใช้, ชื่อ, อีเมล...",
    'saumgt_admin': "ผู้ดูแลระบบ",
    'saumgt_username': "ชื่อผู้ใช้",
    'saumgt_password': "รหัสผ่าน",
    'saumgt_firstName': "ชื่อจริง",
    'saumgt_lastName': "นามสกุล",
    'saumgt_email': "อีเมล",
    'saumgt_mobile': "เบอร์โทร",
    'saumgt_headerNo': "ลำดับ",
    'saumgt_fullName': "ชื่อ-นามสกุล",
    'saumgt_role': "บทบาท",
    'saumgt_actions': "การดำเนินการ",
    'sgm_modelGroup': "กลุ่มโมเดล",
    'sgm_viewDetails': "ดูรายละเอียด",
    'sgm_loading': "กำลังโหลด...",
    'sgm_pleaseWait': "กรุณารอสักครู่",
    'sgm_editModelGroup': "แก้ไขกลุ่มโมเดล",
    'sgm_modifyModelGroupConfig': "แก้ไขการตั้งค่ากลุ่มโมเดล",
    'sgm_basicInformation': "ข้อมูลพื้นฐาน",
    'sgm_enterGroupNamePlaceholder': "กรอกชื่อกลุ่ม...",
    'sgm_modelConfiguration': "การตั้งค่าโมเดล",
    'sgm_allModel': "ทุกโมเดล",
    'sgm_selectModelsPlaceholder': "เลือกโมเดล...",
    'sgm_allModelsIncludedInfo': "โมเดลที่มีทั้งหมดจะถูกรวมอยู่ในกลุ่มนี้",
    'sgm_allModelsIncluded': "รวมโมเดลทั้งหมดแล้ว",
    'sgm_modelsSelectedCount': "เลือกแล้ว {n} โมเดล",
    'sgm_addModelGroup': "เพิ่มกลุ่มโมเดล",
    'sgm_createNewModelGroupConfig': "สร้างการตั้งค่ากลุ่มโมเดลใหม่",
    'sgm_modelGroupName': "ชื่อกลุ่มโมเดล",
    'sgm_modelName': "ชื่อโมเดล",
    'sgm_modelDetailsAndInfo': "รายละเอียดและข้อมูลโมเดล",
    'sgm_noModelsFound': "ไม่พบโมเดล",
    'sgm_noModelDataAvailable': "ไม่มีข้อมูลโมเดลให้แสดง",
    'sgm_view': "ดู",
    'sgm_modelsCount': "{n} โมเดล",
    'sgm_requiredField': "จำเป็นต้องกรอก",
    'sug_formSubtitle': "กำหนดค่าการตั้งค่ากลุ่มและสิทธิ์การเข้าถึงโมเดล",
    'sug_basicInformation': "ข้อมูลพื้นฐาน",
    'sug_enterGroupNamePlaceholder': "กรอกชื่อกลุ่ม",
    'sug_groupNameRequired': "กรุณากรอกชื่อกลุ่ม",
    'sug_groupNameHint': "กรอกชื่อที่สื่อความหมายสำหรับกลุ่มผู้ใช้นี้",
    'sug_enterObjectIdPlaceholder': "กรอกรหัส Object ID (ไม่บังคับ)",
    'sug_groupObjectIdHint': "รหัส Object ID ของ Azure AD สำหรับการเชื่อมต่อ (ไม่บังคับ)",
    'sug_modelConfiguration': "การตั้งค่าโมเดล",
    'sug_modelGrouping': "การจัดกลุ่มโมเดล",
    'sug_selectModelGroupingPlaceholder': "เลือกกลุ่มโมเดล",
    'sug_modelGroupingRequired': "กรุณาเลือกกลุ่มโมเดล",
    'sug_modelGroupingHint': "เลือกประเภทกลุ่มโมเดลสำหรับกลุ่มผู้ใช้นี้",
    'sug_availableModels': "โมเดลที่ใช้งานได้",
    'sug_selectModelsPlaceholder': "เลือกโมเดล",
    'sug_atLeastOneModelRequired': "กรุณาเลือกโมเดลอย่างน้อยหนึ่งรายการ",
    'sug_availableModelsHint': "เลือกโมเดล AI ที่กลุ่มนี้สามารถเข้าถึงได้",
    'sug_add': "เพิ่ม",
    'sug_loadingPleaseWait': "กำลังโหลด กรุณารอสักครู่...",
    'sug_name': "ชื่อ",
    'sug_pleaseSelectUserToAdd': "กรุณาเลือกผู้ใช้ที่ต้องการเพิ่มเข้ากลุ่ม",
    'sug_pleaseFillRequiredFields': "กรุณากรอกข้อมูลในช่องที่จำเป็น!!!",
    'sug_pleaseSelectYourModel': "กรุณาเลือกโมเดลของคุณ!!!",
    'sug_close': "ปิด",
        'bcum_noBlacklistedUsersFoundTitle': "ไม่พบผู้ใช้ในบัญชีดำ",
    'bcum_noBlacklistedUsersFoundSubtitle': "ขณะนี้ยังไม่มีผู้ใช้ในบัญชีดำ เพิ่มผู้ใช้เพื่อจัดการข้อจำกัดการแชท",
    'bcum_addToBlacklistTitle': "เพิ่มเข้าบัญชีดำ",
    'bcum_addToBlacklistSubtitle': "เลือกผู้ใช้ที่ต้องการเพิ่มเข้าบัญชีดำ",
    'bcum_selectLineUsers': "เลือกผู้ใช้ Line",
    'bcum_searchAndSelectUsers': "ค้นหาและเลือกผู้ใช้",
    'bcum_typeToSearchUsers': "พิมพ์เพื่อค้นหาผู้ใช้...",
    'bcum_pleaseSelectAtLeastOneUser': "กรุณาเลือกผู้ใช้อย่างน้อยหนึ่งคน",
    'bcum_noUsersFound': "ไม่พบผู้ใช้",
    'bcum_selectedUsersRestrictedNotice': "ผู้ใช้ที่เลือกจะถูกจำกัดการใช้งานฟังก์ชันแชท",
    'bcum_loading': "กำลังโหลด...",
    'bcum_pleaseWait': "กรุณารอสักครู่",
    'bcum_pleaseFillAllFields': "กรุณากรอกข้อมูลให้ครบทุกช่อง!!!",
    'cfgconsent_configurationPanel': "แผงตั้งค่าคอนฟิกูเรชัน",
    'cfgconsent_currentVersion': "เวอร์ชันปัจจุบัน",
    'cfgconsent_notAvailable': "ไม่มีข้อมูล",
    'cfgconsent_viewPreviousVersion': "ดูเวอร์ชันก่อนหน้า",
    'cfgconsent_selectVersionToPreview': "เลือกเวอร์ชันเพื่อดูตัวอย่าง",
    'cfgconsent_savingChanges': "กำลังบันทึกการเปลี่ยนแปลง...",
    'cfgconsent_consentThLabel': "ข้อตกลงยินยอม (ไทย)",
    'cfgconsent_consentEnLabel': "ข้อตกลงยินยอม (อังกฤษ)",
    'cfgt_login': "เข้าสู่ระบบ",
    'cfgt_logo': "โลโก้",
    'cfgt_chatPanel': "แผงแชท",
    'cfgt_chatbotName': "ชื่อแชทบอท",
    'cfgt_you': "คุณ",
    'cfgt_header': "ส่วนหัว",
    'cfgt_versionPlaceholder': "เวอร์ชัน R1.xx.x",
    'cfgt_username': "ชื่อผู้ใช้",
    'cfgt_buttonColor': "สีปุ่ม",
    'cfgt_textColor': "สีตัวอักษร",
    'cfgt_loadingPleaseWait': "กำลังโหลด กรุณารอสักครู่...",
    'cfgt_more': "เพิ่มเติม",
    'cfgt_previewMsgHi': "สวัสดี",
    'cfgt_previewMsgHello': "สวัสดีครับ/ค่ะ",
    'cfgt_previewMsgFoo': "ฟู",
    'cfgt_previewMsgBar': "บาร์",
    'cfgt_fileSizeExceeded': "ขนาดไฟล์เกิน {limitFile} MB",
    'cfgt_imageDimensionExceeded': "ขนาดรูปภาพต้องไม่เกิน {maxWidth}x{maxHeight} พิกเซล",
    'dscore_reprocess': "ประมวลผลใหม่",
    'dscore_validationProcess': "กระบวนการตรวจสอบ",
    'dscore_selectValidationProcessHint': "เลือกกระบวนการตรวจสอบเพื่อดูแดชบอร์ดคะแนน",
    'dscore_modelNameLabel': "ชื่อโมเดล : {name}",
    'dscore_versioningLabel': "เวอร์ชัน : {version}",
    'dscore_scoreModelNameLabel': "โมเดลผู้ให้คะแนน : {name} ({provider})",
    'dscore_scoreModelLegacy': "โมเดลผู้ให้คะแนน : ใช้โมเดลเดียวกับที่ตอบ (ข้อมูลเดิม)",
    'dscore_scoreModelMissing': "โมเดลผู้ให้คะแนน : ถูกลบหรือปิดใช้งานแล้ว (รหัส {id})",
    'dscore_scoreModelDisabled': "โมเดลผู้ให้คะแนน : {name} ({provider}) — ถูกปิดใช้งานแล้ว",
    'dscore_processingDateLabel': "วันที่ประมวลผล :  {date}",
    'dscore_modelName': "ชื่อโมเดล",
    'dscore_prompt': "พรอมต์",
    'dscore_close': "ปิด",
    'dscore_save': "บันทึก",
    'dscore_loadingPleaseWait': "กำลังโหลด กรุณารอสักครู่...",
    'dscore_chatWorkFlow': "ขั้นตอนการสนทนา",
    'dscore_required': "จำเป็นต้องกรอก",
    'dscore_pleaseSelectModel': "กรุณาเลือกโมเดล",
    'dscore_pleaseEnterPrompt': "กรุณากรอกพรอมต์",
    'dscore_reprocessTitle': "ประมวลผลใหม่",
    'dscore_infoModelName': "เลือกโมเดลที่ต้องการใช้ประมวลผลใหม่",
    'dscore_scoreModel': "โมเดลผู้ให้คะแนน",
    'dscore_pleaseSelectScoreModel': "กรุณาเลือกโมเดลผู้ให้คะแนน",
    'dscore_infoScoreModel': "เลือก base model ที่จะใช้เป็นกรรมการให้คะแนนในรอบประมวลผลใหม่",
    'fmgt_startDate': "วันที่เริ่มต้น",
    'fmgt_endDate': "วันที่สิ้นสุด",
    'fmgt_fileNamePlaceholder': "ชื่อไฟล์",
    'fmgt_deleteAll': "ลบทั้งหมด",
    'fmgt_infoForDeleteAllFile': "ลบไฟล์ทั้งหมด",
    'fmgt_view': "ดู",
    'fmgt_delete': "ลบ",
    'fmgt_confirmDeleteConfirmation': "ยืนยันการลบ",
    'fmgt_deleteAllConfirmPrefix': "การดำเนินการนี้จะลบ ",
    'fmgt_deleteAllConfirmSuffix': " รายการ",
    'fmgt_deleteAllTypeToConfirm': "กรุณากรอก \"delete\" หรือ \"Delete\" หากต้องการลบไฟล์ทั้งหมด",
    'fmgt_viewDetail': "ดูรายละเอียด",
    'fmgt_fileName': "ชื่อไฟล์",
    'fmgt_fileType': "ประเภทไฟล์",
    'fmgt_sizeKB': "ขนาด (KB)",
    'fmgt_fileUrl': "URL ไฟล์",
    'fmgt_container': "คอนเทนเนอร์",
    'fmgt_fileImageAlt': "รูปภาพไฟล์",
    'fmgt_noImageAvailable': "ไม่มีรูปภาพ",
    'fmgt_close': "ปิด",
    'fmgt_loadingPleaseWait': "กำลังโหลด กรุณารอสักครู่...",
    'fmgt_headerNo': "ลำดับ",
    'fmgt_headerFileName': "ชื่อไฟล์",
    'fmgt_headerCreateDate': "วันที่สร้าง",
    'fmgt_headerCreateBy': "สร้างโดย",
    'fmgt_headerAction': "การดำเนินการ",
    'fmgt_requiredField': "จำเป็นต้องกรอก",
    'isess_pageTitle': "เซสชันอินเทนต์",
    'isess_intentGroupName': "ชื่อกลุ่มอินเทนต์",
    'isess_intentSessionNamePlaceholder': "ชื่อเซสชันอินเทนต์",
    'isess_search': "ค้นหา",
    'isess_loadingTitle': "กำลังโหลด...",
    'isess_loadingSubtitle': "กรุณารอสักครู่",
    'isess_ruleRequired': "จำเป็นต้องกรอก",
    'isess_intentSessionNameHeader': "ชื่อเซสชันอินเทนต์",
    'isess_createByHeader': "สร้างโดย",
    'isess_warningFillIntentGroupNameCorrectly': "กรุณากรอกชื่อกลุ่มอินเทนต์ให้ถูกต้อง",
    'mvm_modelName': "ชื่อโมเดล",
    'mvm_vectorDBName': "ชื่อ Vector DB",
    'mvm_loadingPleaseWait': "กำลังโหลด กรุณารอสักครู่",
    'mvm_requiredField': "กรุณากรอกข้อมูลในช่องนี้",
    'mvm_pleaseFillAllFields': "กรุณากรอกข้อมูลให้ครบทุกช่อง",
    'mvm_noConnectedModels': "ไม่มีโมเดลที่เชื่อมต่ออยู่",
    'mvm_confirmDeleteData': "คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูลนี้?",
    'mvm_webSearchDomains': "Web Search Domains",
    'mvm_webSearchNotSupported': "โมเดลที่เลือกไม่รองรับ Web Search (ต้องเป็นโมเดลข้อความบน Azure) — บันทึกได้แต่จะยังไม่มีผลจนกว่าจะใช้โมเดลที่รองรับ",
    'mvm_webSearchInvalidDomain': "รูปแบบโดเมนไม่ถูกต้อง (เช่น dga.or.th — ไม่ต้องมี https:// หรือ path)",
    'mvm_webSearchMaxDomains': "ระบุได้สูงสุด 20 โดเมน",
    'mvm_webSearchColumn': "Web Search",
    'mvm_webSearchOn': "เปิด ({n})",
    'mvm_webSearchLoadFailed': "โหลดค่า Web Search Domains ไม่สำเร็จ — แก้ไขช่องนี้ไม่ได้ชั่วคราว ค่าที่ตั้งไว้เดิมจะไม่ถูกเปลี่ยน (ปิดแล้วเปิดหน้าต่างนี้ใหม่เพื่อลองอีกครั้ง)",
    'mvm_webSearchSaveFailed': "บันทึกการเชื่อมโมเดลกับ Vector สำเร็จ แต่บันทึก Web Search Domains ไม่สำเร็จ — กดบันทึกอีกครั้งเพื่อลองใหม่",
    'rqt_process': "ประมวลผล",
    'rqt_refresh': "รีเฟรช",
    'rqt_questionReportManagement': "การจัดการรายงานคำถาม",
    'rqt_dateRange': "ช่วงวันที่",
    'rqt_startDate': "วันที่เริ่มต้น",
    'rqt_selectStartDateForReport': "เลือกวันที่เริ่มต้นสำหรับรายงาน",
    'rqt_endDate': "วันที่สิ้นสุด",
    'rqt_selectEndDateForReport': "เลือกวันที่สิ้นสุดสำหรับรายงาน",
    'rqt_processingStatus': "สถานะการประมวลผล",
    'rqt_promptTemplate': "เทมเพลตพรอมต์",
    'rqt_enterYourPromptTemplateForQuestionGeneration': "กรอกเทมเพลตพรอมต์สำหรับสร้างคำถามของคุณ",
    'rqt_questionReportDataRecords': "ข้อมูลรายงานคำถาม ({count} รายการ)",
    'rqt_loadingPleaseWait': "กำลังโหลด กรุณารอสักครู่...",
    'rqt_questionCategory': "หมวดหมู่คำถาม",
    'rqt_total': "รวม",
    'rqt_pleaseEnterNoMoreThanCharacters': "กรุณากรอกข้อมูลตัวอักษรไม่เกิน {n}",
    'rqt_pleaseFillTheRequiredFields': "กรุณากรอกข้อมูลในช่องที่จำเป็น",
    'rtext_addTextGroup': "เพิ่มกลุ่มข้อความ",
    'rtext_uploadCsv': "อัปโหลด CSV",
    'rtext_textGroupName': "ชื่อกลุ่มข้อความ",
    'rtext_template': "เทมเพลต",
    'rtext_loadingPleaseWait': "กำลังโหลด กรุณารอสักครู่...",
    'rtext_modifyTheReplacementText': "แก้ไขข้อความที่ใช้แทนที่",
    'rtext_addNewReplacementText': "เพิ่มข้อความที่ใช้แทนที่ใหม่",
    'rtext_originalText': "ข้อความต้นฉบับ",
    'rtext_replacementText': "ข้อความที่ใช้แทนที่",
    'rtext_action': "การดำเนินการ",
    'rtext_required': "จำเป็นต้องกรอก",
    'rtext_pleaseFillTextGroupNameFields': "กรุณากรอกชื่อกลุ่มข้อความให้ครบถ้วน!",
    'rtext_groupNameIsDuplicate': "ชื่อกลุ่มซ้ำกับที่มีอยู่แล้ว",
    'rtext_pleaseFillTextGroupName': "กรุณากรอกชื่อกลุ่มข้อความ!",
    'rtext_formatExcelCsvIncorrect': "รูปแบบไฟล์ Excel/CSV ไม่ถูกต้อง",
    'saconsent_audience': "กลุ่มผู้ใช้งาน",
    'saconsent_currentVersion': "เวอร์ชันปัจจุบัน",
    'saconsent_notAvailable': "ไม่มีข้อมูล",
    'saconsent_viewVersion': "ดูเวอร์ชัน",
    'saconsent_termsConditionsTH': "ข้อกำหนดและเงื่อนไขการขอใช้บริการ (TH)",
    'saconsent_termsConditionsEN': "ข้อกำหนดและเงื่อนไขการขอใช้บริการ (EN)",
    'saconsent_privacyNoticeTH': "นโยบายความเป็นส่วนตัว (TH)",
    'saconsent_privacyNoticeEN': "นโยบายความเป็นส่วนตัว (EN)",
    'saconsent_consentRequired': "จำเป็นต้องระบุ Consent",
    'saconsent_ok': "ตกลง",
    'saconsent_fillBothRequired': "กรุณากรอก Consent(TH) และ Consent(EN)",
    'saconsent_fillThRequired': "กรุณากรอก Consent(TH)",
    'saconsent_fillEnRequired': "กรุณากรอก Consent(EN)",
    'sallm_textBased': "ข้อความ",
    'sallm_textToImage': "ข้อความเป็นรูปภาพ",
    'sallm_jsonConfiguration': "การตั้งค่า JSON",
    'sallm_systemPromptFormat': "รูปแบบ System Prompt (OpenAI o1+)",
    'sallm_roleNote': "ระบุบทบาทของระบบเพื่อบริบทที่ดีขึ้น",
    'sallm_maxCompletionTokensNote': "ความยาวสูงสุดของคำตอบ",
    'sallm_streamNote': "เปิดใช้งานการตอบกลับแบบสตรีม",
    'sallm_addValue': "เพิ่มค่า",
    'sallm_loadingFallback': "กำลังโหลด...",
    'sallm_pleaseWaitFallback': "กรุณารอสักครู่",
    'sallm_ruleRequired': "จำเป็นต้องกรอก",
    'sallm_ruleMustBeNumber': "ต้องเป็นตัวเลข",
    'sallm_qualityHD': "HD",
    'sallm_qualityStandard': "มาตรฐาน",
    'sallm_no': "ลำดับ",
    'sapkg_searchPlaceholder': "ค้นหาชื่อแพ็กเกจ...",
    'sapkg_unlimited': "ไม่จำกัด",
    'sapkg_packageNameLabel': "ชื่อแพ็กเกจ *",
    'sapkg_detailLabel': "รายละเอียด",
    'sapkg_limitTokenLabel': "จำกัดโทเค็น",
    'sapkg_limitTokenPlaceholder': "ว่าง = ไม่จำกัด",
    'sapkg_headerNo': "ลำดับ",
    'sapkg_headerPackageName': "ชื่อแพ็กเกจ",
    'sapkg_headerDetail': "รายละเอียด",
    'sapkg_headerLimitToken': "จำกัดโทเค็น",
    'sapkg_headerActions': "การดำเนินการ",
    'sapkg_fillRequiredFields': "กรุณากรอกข้อมูลให้ครบ",
    'sapkg_genericError': "เกิดข้อผิดพลาด",
    'sapkg_confirmDeleteText': "ลบ Package \"{name}\" ?",
    'ugrp_loadingPleaseWait': "กำลังโหลด กรุณารอสักครู่...",
    'ugrp_pleaseEnterGroupName': "กรุณากรอกชื่อกลุ่ม",
    'ugrp_confirmDeleteData': "คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูลนี้?",
    'ugrp_groupNameAlreadyExists': "ชื่อกลุ่มนี้มีอยู่ในระบบแล้ว",
    'ugrp_pleaseFillAllFields': "กรุณากรอกข้อมูลให้ครบทุกช่อง",
    'uprof_fusionFusion': "ฟิวชั่น ฟิวชั่น",
    'uprof_required': "จำเป็นต้องกรอก",
    'uprof_changePassword': "เปลี่ยนรหัสผ่าน",
    'uprof_loadingPleaseWait': "กำลังโหลด กรุณารอสักครู่...",
    'uprof_pleaseEnterCorrectPhoneNumber': "กรุณากรอกหมายเลขโทรศัพท์ให้ถูกต้อง",
    'uprof_pleaseEnterCorrectEmail': "กรุณากรอกอีเมลให้ถูกต้อง",
    'uprof_pleaseEnterCorrectFormat': "กรุณากรอกข้อมูลให้ถูกต้องตามรูปแบบ!",
    'uprof_pleaseFillAllTheFields': "กรุณากรอกข้อมูลให้ครบทุกช่อง!",
    'uprof_pleaseFillPassword': "กรุณากรอกรหัสผ่าน!",
    'uprof_pleaseFillConfirmPassword': "กรุณากรอกยืนยันรหัสผ่าน!",
    'uprof_pleaseFillPasswordAndConfirmPassword': "กรุณากรอกรหัสผ่านและยืนยันรหัสผ่าน",
    'uprof_pleaseFillCorrectFormat': "กรุณากรอกข้อมูลให้ถูกต้องตามรูปแบบ!",
    'uprof_passwordConfirmMismatch': "รหัสผ่านและยืนยันรหัสผ่านไม่ตรงกัน กรุณากรอกให้ถูกต้อง",
    'uprof_pleaseFillAllTheFieldsExclaim': "กรุณากรอกข้อมูลให้ครบทุกช่อง!!!",
    'vgen_refresh': "รีเฟรช",
    'vgen_questionSet': "ชุดคำถาม",
    'vgen_reprocess': "ประมวลผลใหม่",
    'vgen_loadingText': "กำลังโหลด...",
    'vgen_pleaseWait': "กรุณารอสักครู่",
    'vgen_process': "ประมวลผล",
    'vgen_status': "สถานะ",
    'vgen_createBy': "สร้างโดย",
    'vgen_action': "การดำเนินการ",
    'vgen_pleaseEnterCorrectFormat': "กรุณากรอกรูปแบบให้ถูกต้อง!",
    'vnd_questionSetName': "ชื่อชุดคำถาม",
    'vnd_template': "เทมเพลต",
    'vnd_upload': "อัปโหลด",
    'vnd_process': "ประมวลผล",
    'vnd_back': "ย้อนกลับ",
    'vnd_loading': "กำลังโหลด...",
    'vnd_pleaseWait': "กรุณารอสักครู่",
    'vnd_required': "จำเป็นต้องกรอก",
    'vnd_zeroBytes': "0 ไบต์",
    'vnd_unitBytes': "ไบต์",
    'vnd_unitKB': "กิโลไบต์",
    'vnd_unitMB': "เมกะไบต์",
    'vnd_unitGB': "กิกะไบต์",
    'vnd_pleaseFillAllFields': "กรุณากรอกข้อมูลให้ครบทุกช่อง",
    'vnd_question': "คำถาม",
    'consentpg_pageTitle': "ข้อกำหนดและเงื่อนไขการขอใช้บริการ",
    'consentpg_pageSubtitle': "นโยบายความเป็นส่วนตัว & การยินยอม",
    'consentpg_versionLabel': "เวอร์ชัน {version}",
    'consentpg_versionNotAvailable': "ไม่มีข้อมูล",
    'consentpg_languageThai': "ภาษาไทย",
    'consentpg_languageEnglish': "อังกฤษ",
    'consentpg_noContentAvailable': "ไม่มีเนื้อหาการยินยอม",
    'flowpg_back': "ย้อนกลับ",
    'flowpg_undo': "ย้อนกลับการทำ",
    'flowpg_unknown': "ไม่ทราบ",
    'flowpg_none': "ไม่มี",
    'flowpg_redo': "ทำซ้ำ",
    'flowpg_flowName': "ชื่อโฟลว์",
    'flowpg_chatAiModelConfiguration': "การตั้งค่าโมเดล AI สำหรับแชท",
    'flowpg_flowAiModel': "โมเดล AI ของโฟลว์",
    'flowpg_aiModelConfiguration': "การตั้งค่าโมเดล AI",
    'flowpg_basicInformation': "ข้อมูลพื้นฐาน",
    'flowpg_providerModelAndBasicSettings': "ผู้ให้บริการ โมเดล และการตั้งค่าพื้นฐาน",
    'flowpg_serviceConfiguration': "การตั้งค่าบริการ",
    'flowpg_providerRequired': "ผู้ให้บริการ*",
    'flowpg_selectAiServiceProvider': "เลือกผู้ให้บริการ AI",
    'flowpg_modelRequired': "โมเดล*",
    'flowpg_selectSpecificModelVersion': "เลือกเวอร์ชันโมเดลที่ต้องการ",
    'flowpg_behaviorSettings': "การตั้งค่าพฤติกรรม",
    'flowpg_male': "ชาย",
    'flowpg_female': "หญิง",
    'flowpg_gender': "เพศ",
    'flowpg_voicePersonaGenderPreference': "เพศของบุคลิก/เสียงที่ต้องการ",
    'flowpg_typingSpeed': "ความเร็วในการพิมพ์",
    'flowpg_charactersPerSecond': "ตัวอักษรต่อวินาที (0 = แสดงผลทันที)",
    'flowpg_maxInputLength': "ความยาวข้อมูลนำเข้าสูงสุด",
    'flowpg_maximumCharactersAllowedInInput': "จำนวนตัวอักษรสูงสุดที่อนุญาตในข้อมูลนำเข้า",
    'flowpg_turnCount': "จำนวนรอบสนทนา",
    'flowpg_numberOfConversationTurnsToRemember': "จำนวนรอบสนทนาที่จะจดจำ",
    'flowpg_durationMinutes': "ระยะเวลา (นาที)",
    'flowpg_howLongToKeepMemoryActive': "ระยะเวลาที่จะเก็บหน่วยความจำไว้",
    'flowpg_shortTermMemory': "หน่วยความจำระยะสั้น",
    'flowpg_recentContextWindowSize': "ขนาดหน้าต่างบริบทล่าสุด",
    'flowpg_sequence': "ลำดับ",
    'flowpg_numberOfConversationTurnsInSequence': "จำนวนรอบสนทนาในลำดับ",
    'flowpg_durationSeconds': "ระยะเวลา (วินาที)",
    'flowpg_timeDurationForMultiTurnSession': "ระยะเวลาสำหรับเซสชันสนทนาแบบหลายรอบ",
    'flowpg_temperatureRequired': "Temperature*",
    'flowpg_creativityLevel': "ระดับความคิดสร้างสรรค์ (0 = เน้นความแม่นยำ, 1 = สร้างสรรค์)",
    'flowpg_topP': "Top P",
    'flowpg_tokenSelectionProbabilityThreshold': "เกณฑ์ความน่าจะเป็นในการเลือกโทเค็น",
    'flowpg_frequencyPenalty': "Frequency Penalty",
    'flowpg_reduceRepetitionOfFrequentTokens': "ลดการซ้ำของโทเค็นที่ใช้บ่อย",
    'flowpg_presencePenalty': "Presence Penalty",
    'flowpg_reduceRepetitionOfAnyTokens': "ลดการซ้ำของโทเค็นใด ๆ",
    'flowpg_maxTokensResponse': "จำนวนโทเค็นสูงสุดของคำตอบ",
    'flowpg_maximumResponseLengthInTokens': "ความยาวสูงสุดของการตอบกลับเป็นโทเค็น",
    'flowpg_stopSequence': "Stop Sequence",
    'flowpg_textSequenceToStopGeneration': "ลำดับข้อความที่ใช้หยุดการสร้างคำตอบ",
    'flowpg_cacheTtlMinutes': "อายุแคช (นาที)",
    'flowpg_howLongToKeepCachedResponses': "ระยะเวลาที่เก็บคำตอบที่แคชไว้ (1-10080 นาที)",
    'flowpg_cacheScope': "ขอบเขตของแคช",
    'flowpg_whoCanUseCachedResponses': "ใครสามารถใช้คำตอบที่แคชไว้ได้",
    'flowpg_loadingDurationSeconds': "ระยะเวลาโหลด (วินาที)",
    'flowpg_durationForLoadingAnimation': "ระยะเวลาแสดงแอนิเมชันกำลังโหลด",
    'flowpg_monitorLineUserId': "LINE User ID สำหรับตรวจสอบ",
    'flowpg_lineUserIdForMonitoringNotifications': "LINE User ID สำหรับรับการแจ้งเตือนตรวจสอบ",
    'flowpg_monitorLineName': "ชื่อ LINE สำหรับตรวจสอบ",
    'flowpg_selectMonitorLineName': "เลือกชื่อ LINE สำหรับตรวจสอบ",
    'flowpg_enterWordOrPhrase': "กรอกคำหรือวลี",
    'flowpg_messageShownOnFirstInteraction': "ข้อความที่แสดงให้ผู้ใช้เห็นในการโต้ตอบครั้งแรก",
    'flowpg_timeZone': "เขตเวลา",
    'flowpg_selectYourTimezoneForTimeAware': "เลือกเขตเวลาของคุณเพื่อให้คำตอบรับรู้เรื่องเวลา",
    'flowpg_selectYourTimezone': "เลือกเขตเวลาของคุณ",
    'flowpg_enterSystemMessageHere': "กรอกข้อความระบบของคุณที่นี่...",
    'flowpg_searchTemplates': "ค้นหาเทมเพลต",
    'flowpg_selectTemplateGroup': "เลือกกลุ่มเทมเพลต",
    'flowpg_intentAiModelConfiguration': "การตั้งค่าโมเดล AI สำหรับอินเทนต์",
    'flowpg_intentConfiguration': "การตั้งค่าอินเทนต์",
    'flowpg_intentHandlerName': "ชื่อตัวจัดการอินเทนต์",
    'flowpg_intents': "Intent ทั้งหมด",
    'flowpg_addIntent': "เพิ่มอินเทนต์",
    'flowpg_intentDefaultName': "อินเทนต์",
    'flowpg_priority': "ลำดับความสำคัญ",
    'flowpg_enterPriority': "ป้อนลำดับความสำคัญ",
    'flowpg_priorityZeroIsHighest': "ลำดับความสำคัญ 0 คือสำคัญที่สุด",
    'flowpg_intentName': "ชื่ออินเทนต์",
    'flowpg_useMemory': "ใช้ความจำ",
    'flowpg_editBasePrompt': "แก้ไข Base Prompt",
    'flowpg_basePrompt': "Base Prompt",
    'flowpg_findIntentBasePromptHint': "ค้นหาอินเทนต์จากข้อความของผู้ใช้\n#เงื่อนไขการตอบกลับ\n1. หากผู้ใช้ถามคำถามที่เกี่ยวข้องหรือมีความหมายใกล้เคียงกับ #Group Intent ด้านล่างนี้ ให้ตอบกลับด้วย 1 มิฉะนั้นให้ตอบกลับด้วย 0",
    'flowpg_intentPrompt': "พรอมต์อินเทนต์",
    'flowpg_exampleMessages': "ตัวอย่างข้อความ",
    'flowpg_exampleUserMessage': "ตัวอย่างข้อความของผู้ใช้...",
    'flowpg_mainAction': "การกระทำหลัก",
    'flowpg_mainActionLabelPlaceholder': "ป้ายกำกับการกระทำหลัก...",
    'flowpg_parallelActions': "การกระทำแบบขนาน",
    'flowpg_parallelActionLabelPlaceholder': "ป้ายกำกับการกระทำแบบขนาน...",
    'flowpg_smartIntentConfiguration': "การตั้งค่าสมาร์ทอินเทนต์",
    'flowpg_smartIntentHandlerName': "ชื่อตัวจัดการสมาร์ทอินเทนต์",
    'flowpg_smartIntents': "Smart Intent ทั้งหมด",
    'flowpg_addSmartIntent': "เพิ่มสมาร์ทอินเทนต์",
    'flowpg_smartIntentDefaultName': "สมาร์ทอินเทนต์",
    'flowpg_smartIntentName': "ชื่อสมาร์ทอินเทนต์",
    'flowpg_smartIntentPrompt': "พรอมต์สมาร์ทอินเทนต์",
    'flowpg_actionLabel': "ป้ายกำกับการกระทำ",
    'flowpg_useAiModel': "ใช้โมเดล AI",
    'flowpg_loadConfig': "โหลดการตั้งค่า",
    'flowpg_providerParametersAndBehaviorSettings': "ผู้ให้บริการ พารามิเตอร์ และการตั้งค่าพฤติกรรม",
    'flowpg_timeContext': "บริบทเวลา",
    'flowpg_enableTimeAwareness': "เปิดใช้งานการรับรู้เวลาสำหรับการตอบกลับของ AI",
    'flowpg_transactionIdContext': "บริบท TransactionID",
    'flowpg_addTransactionIdToPrompt': "เพิ่ม TransactionID ลงในพรอมต์",
    'flowpg_includeTransactionIdentifier': "รวมรหัสอ้างอิงธุรกรรมไว้ในบริบทของ AI",
    'flowpg_configureSystemMessage': "กำหนดค่าข้อความระบบสำหรับ AI ของคุณ",
    'flowpg_configureAdditionalPromptsAndTemplates': "กำหนดค่าพรอมต์และเทมเพลตเพิ่มเติม",
    'flowpg_showTemplates': "แสดงเทมเพลต",
    'flowpg_tipsForBetterPrompts': "เคล็ดลับสำหรับพรอมต์ที่ดีขึ้น:",
    'flowpg_tipBeSpecificAboutRole': "ระบุบทบาทและความเชี่ยวชาญของ AI ให้ชัดเจน",
    'flowpg_tipDefineToneAndStyle': "กำหนดโทนและรูปแบบการสื่อสาร",
    'flowpg_tipIncludeRestrictions': "ระบุข้อจำกัดหรือแนวทางที่ต้องปฏิบัติตาม",
    'flowpg_tipSpecifyHandleUnknown': "ระบุวิธีจัดการเมื่อไม่ทราบข้อมูล",
    'flowpg_knowledgeSources': "แหล่งความรู้",
    'flowpg_configureKnowledgeIntegrationForContext': "กำหนดค่าการเชื่อมต่อแหล่งความรู้สำหรับบริบท",
    'flowpg_enableKnowledgeSources': "เปิดใช้งานแหล่งความรู้",
    'flowpg_documents': "เอกสาร",
    'flowpg_vectorBasedDocumentSearch': "ค้นหาเอกสารด้วยเวกเตอร์",
    'flowpg_documentsConfiguration': "ตั้งค่าเอกสาร",
    'flowpg_document': "เอกสาร",
    'flowpg_selectDocuments': "เลือกเอกสาร",
    'flowpg_topNChunks': "จำนวน Chunk สูงสุด (Top-N)",
    'flowpg_numberOfDocumentChunksToRetrieve': "จำนวน Chunk ของเอกสารที่จะดึงมาใช้",
    'flowpg_databaseIntegration': "การเชื่อมต่อฐานข้อมูล",
    'flowpg_sqlDatabaseQueries': "คิวรี SQL ฐานข้อมูล",
    'flowpg_databaseIntegrationConfiguration': "การตั้งค่า Database Integration",
    'flowpg_tableName': "ชื่อตาราง",
    'flowpg_selectDatabaseTable': "เลือกตารางฐานข้อมูล",
    'flowpg_sqlExtractionModel': "โมเดลสำหรับสกัด SQL",
    'flowpg_selectAiModelForSqlGeneration': "เลือกโมเดล AI สำหรับสร้าง SQL",
    'flowpg_promptForNoData': "ข้อความเมื่อไม่พบข้อมูล",
    'flowpg_enterMessageWhenNoDataFound': "กรอกข้อความที่จะแสดงเมื่อไม่พบข้อมูลในฐานข้อมูล...",
    'flowpg_messageShownWhenNoResults': "ข้อความที่แสดงเมื่อคิวรีฐานข้อมูลไม่พบผลลัพธ์",
    'flowpg_products': "สินค้า",
    'flowpg_productCatalogSearch': "การค้นหาแคตตาล็อกสินค้า",
    'flowpg_productsConfiguration': "การตั้งค่าสินค้า",
    'flowpg_productGroupList': "รายการกลุ่มสินค้า",
    'flowpg_selectProductGroup': "เลือกกลุ่มสินค้า",
    'flowpg_enterNumberOfChunks': "กรอกจำนวน Chunk",
    'flowpg_numberOfProductChunksToRetrieve': "จำนวนชิ้นข้อมูลสินค้าที่ต้องการดึงมา",
    'flowpg_cosineSimilarity': "ค่าความคล้ายคลึง Cosine",
    'flowpg_enterSimilarityThreshold': "กรอกเกณฑ์ความคล้าย (0.0001 - 1.0)",
    'flowpg_similarityThresholdForProductMatching': "ค่าขีดจำกัดความคล้ายคลึงสำหรับการจับคู่สินค้า",
    'flowpg_apiKnowledge': "ความรู้จาก API",
    'flowpg_externalApiIntegration': "การเชื่อมต่อ API ภายนอก",
    'flowpg_apiKnowledgeConfiguration': "การตั้งค่าความรู้จาก API",
    'flowpg_apiUrl': "API URL",
    'flowpg_httpMethod': "HTTP Method",
    'flowpg_requestHeaders': "Request Headers (ส่วนหัวคำขอ)",
    'flowpg_addHeader': "เพิ่ม Header",
    'flowpg_headerName': "ชื่อ Header",
    'flowpg_headerValue': "ค่า Header",
    'flowpg_noHeadersConfigured': "ยังไม่ได้ตั้งค่า Header",
    'flowpg_requestBody': "เนื้อหาคำขอ",
    'flowpg_requestBodyJson': "Request Body JSON",
    'flowpg_jsonPayloadForApiRequest': "ข้อมูล JSON สำหรับคำขอ API (ใช้ {'{{'} variables {'}}'} สำหรับค่าที่เปลี่ยนแปลงได้)",
    'flowpg_responseDataPath': "เส้นทางข้อมูลใน Response",
    'flowpg_jsonPathToExtractKnowledgeData': "เส้นทาง JSON สำหรับดึงข้อมูลความรู้จากคำตอบของ API",
    'flowpg_knowledgeIntegrationTips': "เคล็ดลับการเชื่อมต่อแหล่งความรู้:",
    'flowpg_tipEnableMultipleKnowledgeSources': "คุณสามารถเปิดใช้งานแหล่งความรู้หลายแหล่งพร้อมกันได้",
    'flowpg_tipConfigureSimilarityThresholds': "กำหนดค่าขีดจำกัดความคล้ายคลึงเพื่อการจับคู่เนื้อหาที่ดีขึ้น",
    'flowpg_tipUseMultipleDocumentsOrGroups': "ใช้เอกสารหรือกลุ่มสินค้าหลายรายการเพื่อครอบคลุมเนื้อหามากขึ้น",
    'flowpg_tipTestApiEndpoints': "ทดสอบ API endpoint ก่อนนำไปใช้งานจริง",
    'flowpg_tipKnowledgeSourcesQueriedInOrder': "แหล่งความรู้จะถูกสืบค้นตามลำดับและรวมกันเป็นบริบท",
    'flowpg_fallbackConfiguration': "การตั้งค่าฟอลแบ็ก",
    'flowpg_useAiModelForFallback': "ใช้โมเดล AI สำหรับการตอบฟอลแบ็ก",
    'flowpg_fallbackAiConfiguration': "การตั้งค่า AI ฟอลแบ็ก",
    'flowpg_backupAiSettingsWhenFails': "การตั้งค่า AI สำรองเมื่อ AI หลักทำงานล้มเหลว",
    'flowpg_responseOptions': "ตัวเลือกการตอบกลับ",
    'flowpg_configureHowResponsesGenerated': "กำหนดค่าวิธีการสร้างคำตอบ",
    'flowpg_streamResponse': "สตรีมการตอบกลับ",
    'flowpg_progressiveTextGeneration': "สร้างข้อความแบบต่อเนื่อง",
    'flowpg_memorySettings': "การตั้งค่าหน่วยความจำ",
    'flowpg_configureConversationMemory': "กำหนดค่าหน่วยความจำและบริบทของบทสนทนา",
    'flowpg_conversationMemory': "หน่วยความจำบทสนทนา",
    'flowpg_memoryTypes': "ประเภทหน่วยความจำ",
    'flowpg_longTermMemory': "หน่วยความจำระยะยาว",
    'flowpg_persistentStorage': "การจัดเก็บข้อมูลถาวร",
    'flowpg_aiParameters': "พารามิเตอร์ AI",
    'flowpg_fineTuneModelBehavior': "ปรับแต่งพฤติกรรมและผลลัพธ์ของโมเดล",
    'flowpg_coreParameters': "พารามิเตอร์หลัก",
    'flowpg_penaltySettings': "ตั้งค่าบทลงโทษ",
    'flowpg_outputControl': "การควบคุมผลลัพธ์",
    'flowpg_lineConfiguration': "การตั้งค่า LINE",
    'flowpg_lineMessagingPlatformSettings': "ตั้งค่าแพลตฟอร์มการส่งข้อความ LINE",
    'flowpg_displayOptions': "ตัวเลือกการแสดงผล",
    'flowpg_showName': "แสดงชื่อ",
    'flowpg_displayUserName': "แสดงชื่อผู้ใช้",
    'flowpg_loadingIndicator': "ตัวแสดงสถานะกำลังโหลด",
    'flowpg_showTypingAnimation': "แสดงแอนิเมชันกำลังพิมพ์",
    'flowpg_loadingAndDuration': "การโหลดและระยะเวลา",
    'flowpg_monitoring': "การตรวจสอบ",
    'flowpg_contentFiltering': "การกรองเนื้อหา",
    'flowpg_forbiddenWord': "คำต้องห้าม",
    'flowpg_delete': "ลบ",
    'flowpg_systemPrompt': "System Prompt (คำสั่งระบบ)",
    'flowpg_defineAiBehaviorAndPersonality': "กำหนดพฤติกรรมและบุคลิกของ AI",
    'flowpg_aiPersonalityAndInstructions': "บุคลิกและคำสั่งของ AI",
    'flowpg_defineHowAiShouldBehave': "กำหนดวิธีที่ AI ของคุณควรมีพฤติกรรม ตอบกลับ และโต้ตอบกับผู้ใช้",
    'flowpg_configureKnowledgeIntegrationForFallback': "กำหนดค่าการเชื่อมต่อแหล่งความรู้สำหรับฟอลแบ็ก",
    'flowpg_similarityThresholdForDocumentMatching': "เกณฑ์ความคล้ายคลึงสำหรับการจับคู่เอกสาร",
    'flowpg_jsonPayloadHint': "JSON payload สำหรับคำขอ API (ใช้ {'{{'} variables {'}}'} สำหรับค่าที่เปลี่ยนแปลงได้)",
    'flowpg_jsonPathExtractHint': "JSON path สำหรับดึงข้อมูลความรู้จากผลลัพธ์ API",
    'flowpg_fallbackKnowledgeTipsTitle': "เคล็ดลับการเชื่อมต่อแหล่งความรู้สำหรับฟอลแบ็ก:",
    'flowpg_fallbackTip1': "ความรู้ฟอลแบ็กจะถูกใช้เมื่อไม่มีสมาร์ทอินเทนต์ใดตรงกัน",
    'flowpg_fallbackTip2': "กำหนดค่าแหล่งความรู้ที่ครอบคลุมมากขึ้นเพื่อความครบถ้วน",
    'flowpg_fallbackTip3': "ควรพิจารณาใช้เอกสารทั่วไปหรือข้อมูล FAQ",
    'flowpg_fallbackTip4': "ทดสอบการตอบกลับฟอลแบ็กเพื่อให้แน่ใจว่าคำตอบมีประโยชน์",
    'flowpg_smartIntentPromptTemplates': "เทมเพลตพรอมต์สมาร์ทอินเทนต์",
    'flowpg_noTemplatesFound': "ไม่พบเทมเพลต",
    'flowpg_close': "ปิด",
    'flowpg_fallbackPromptTemplates': "เทมเพลตพรอมต์ฟอลแบ็ก",
    'flowpg_apiConfiguration': "การตั้งค่า API",
    'flowpg_jsonRequestBody': "JSON Request Body",
    'flowpg_jsonValidatorModel': "โมเดลตรวจสอบ JSON",
    'flowpg_availableVariablesCount': "มีตัวแปรให้ใช้ {n} รายการ",
    'flowpg_jsonValidationSchema': "JSON Validation Schema",
    'flowpg_clickOrDragVariableHint': "คลิกตัวแปรเพื่อแทรก หรือลากแล้ววางลงในตัวแก้ไข",
    'flowpg_headersConfiguration': "ตั้งค่า Headers",
    'flowpg_key': "คีย์",
    'flowpg_value': "ค่า",
    'flowpg_validationConfiguration': "ตั้งค่าการตรวจสอบข้อมูล",
    'flowpg_validationType': "ประเภทการตรวจสอบ",
    'flowpg_numberOfCharacters': "จำนวนตัวอักษร",
    'flowpg_regularExpression': "รูปแบบ Regular Expression",
    'flowpg_errorMessage': "ข้อความแจ้งข้อผิดพลาด",
    'flowpg_errorMessagePlaceholder': "ข้อความที่จะแสดงเมื่อการตรวจสอบไม่ผ่าน",
    'flowpg_addValidation': "เพิ่มการตรวจสอบ",
    'flowpg_textResponse': "ข้อความตอบกลับ",
    'flowpg_responseMessage': "ข้อความตอบกลับ",
    'flowpg_enterResponseMessagePlaceholder': "กรอกข้อความตอบกลับ...",
    'flowpg_configuration': "การตั้งค่า",
    'flowpg_contactAgentMessage': "ข้อความติดต่อเจ้าหน้าที่",
    'flowpg_agentHandoffMessagePlaceholder': "กรอกข้อความสำหรับการโอนสายไปยังเจ้าหน้าที่...",
    'flowpg_botDisableTimeMinutes': "ระยะเวลาปิดใช้งานบอท (นาที)",
    'flowpg_enterTimeInMinutes': "กรอกระยะเวลาเป็นนาที",
    'flowpg_botDisableTimeHint': "ระบุระยะเวลาปิดการทำงานของบอท (เป็นนาที) เมื่อโอนสายไปยังเจ้าหน้าที่ ค่าต่ำสุดคือ 1 นาที หากเว้นว่างไว้ บอทจะยังคงทำงานต่อไป",
    'flowpg_emailConfiguration': "ตั้งค่าอีเมล",
    'flowpg_emailProvider': "ผู้ให้บริการอีเมล",
    'flowpg_recipientConfiguration': "ตั้งค่าผู้รับ",
    'flowpg_toEmailRequired': "ถึงอีเมล *",
    'flowpg_ccEmailsOptional': "อีเมลสำเนา CC (ไม่บังคับ)",
    'flowpg_bccEmailsOptional': "อีเมลสำเนาลับ BCC (ไม่บังคับ)",
    'flowpg_emailContent': "เนื้อหาอีเมล",
    'flowpg_subject': "หัวเรื่อง",
    'flowpg_emailSubjectPlaceholder': "หัวเรื่องอีเมล",
    'flowpg_emailTemplateCustom': "กำหนดเอง (กรอกเนื้อหาเอง)",
    'flowpg_emailTemplateRegistration': "การลงทะเบียน",
    'flowpg_emailTemplateResetPassword': "รีเซ็ตรหัสผ่าน",
    'flowpg_emailTemplate': "เทมเพลตอีเมล",
    'flowpg_emailBody': "เนื้อหาอีเมล",
    'flowpg_emailBodyPlaceholder': "กรอกเนื้อหาอีเมลที่นี่...",
    'flowpg_templateSelected': "เทมเพลตที่เลือก:",
    'flowpg_templateAutoGenerateHint': "เทมเพลตนี้จะสร้างเนื้อหาอีเมลโดยอัตโนมัติตามตัวแปรบริบท",
    'flowpg_advancedRouterConfiguration': "ตั้งค่า Advanced Router",
    'flowpg_advancedRouterName': "ชื่อ Advanced Router",
    'flowpg_routingPrompt': "พรอมต์การกำหนดเส้นทาง",
    'flowpg_routingPromptPlaceholder': "คำแนะนำเพิ่มเติมสำหรับการกำหนดเส้นทางอินเทนต์แบบลำดับชั้น...",
    'flowpg_confidenceThreshold': "เกณฑ์ความเชื่อมั่น",
    'flowpg_maximumIntentDepth': "ความลึกสูงสุดของอินเทนต์",
    'flowpg_levelsCount': "{n} ระดับ",
    'flowpg_intentDepthHint': "จำนวนระดับความลึกสูงสุดของลำดับชั้นอินเทนต์ (1-4)",
    'flowpg_responseSchemaGoogleProvider': "รูปแบบการตอบกลับ (ผู้ให้บริการ Google)",
    'flowpg_enableCustomResponseSchema': "เปิดใช้งานรูปแบบการตอบกลับที่กำหนดเอง",
    'flowpg_customSchemaGoogleHint': "ใช้ schema ที่กำหนดในโหนดสำหรับผลลัพธ์แบบมีโครงสร้างของ Google",
    'flowpg_customSchemaGoogleOnlyNotice': "รูปแบบที่กำหนดเองจะถูกใช้เฉพาะเมื่อผู้ให้บริการ IntentAI เป็น Google เท่านั้น",
    'flowpg_intentField': "ฟิลด์อินเทนต์",
    'flowpg_confidenceField': "ฟิลด์ความเชื่อมั่น",
    'flowpg_subIntentsField': "ฟิลด์เจตนาย่อย",
    'flowpg_customSchemaJson': "JSON รูปแบบที่กำหนดเอง",
    'flowpg_resetDefaultSchema': "รีเซ็ตเป็นรูปแบบเริ่มต้น",
    'flowpg_intentHierarchyLevel1': "ลำดับชั้นอินเทนต์ (ระดับ 1)",
    'flowpg_intentNumbered': "อินเทนต์ {n}",
    'flowpg_subIntentsCount': "{n} เจตนาย่อย",
    'flowpg_leafOutput': "ปลายทาง (Output)",
    'flowpg_intentNameExamplePlaceholder': "เช่น สินค้า, ซัพพอร์ต, การเรียกเก็บเงิน",
    'flowpg_subIntentsLevel2': "เจตนาย่อย (ระดับ 2)",
    'flowpg_addSubIntent': "เพิ่มอินเทนต์ย่อย",
    'flowpg_subIntentName': "ชื่ออินเทนต์ย่อย",
    'flowpg_level3Intents': "เจตนาระดับ 3",
    'flowpg_level3IntentNamePlaceholder': "ชื่ออินเทนต์ระดับ 3",
    'flowpg_level4Abbrev': "ระดับ 4:",
    'flowpg_level4IntentPlaceholder': "อินเทนต์ระดับ 4",
    'flowpg_cacheSettings': "การตั้งค่าแคช",
    'flowpg_enableCache': "เปิดใช้งานแคช",
    'flowpg_enableCacheHint': "แคชผลลัพธ์การกำหนดเส้นทางอินเทนต์เพื่อลดการเรียกใช้ LLM",
    'flowpg_cacheTtlHint': "ระยะเวลาที่เก็บผลลัพธ์การกำหนดเส้นทางในแคช (1-10080 นาที)",
    'flowpg_semanticCache': "แคชเชิงความหมาย",
    'flowpg_semanticMatch': "การจับคู่เชิงความหมาย",
    'flowpg_semanticMatchHint': "จับคู่คำถามที่คล้ายกันโดยใช้ AI embeddings ของ BGE-M3",
    'flowpg_similarityThreshold': "เกณฑ์ความคล้ายคลึง",
    'flowpg_similarityThresholdHint': "ค่าสูง = เข้มงวดมากขึ้น (ตรงกันเป๊ะ), ค่าต่ำ = ยืดหยุ่นมากขึ้น",
    'flowpg_hierarchicalIntentDetection': "การตรวจจับอินเทนต์แบบลำดับชั้น:",
    'flowpg_hierarchicalIntentDetectionDesc1': "ตรวจจับเจตนาในหลายระดับ กำหนดเส้นทางไปยัง",
    'flowpg_deepestMatchingLeaf': "ปลายทางที่ลึกที่สุดที่ตรงกัน",
    'flowpg_hierarchicalIntentDetectionDesc2': "อินเทนต์",
    'flowpg_hierarchicalIntentDetectionExample': "ตัวอย่าง: ผู้ใช้พิมพ์ \"ประกันชีวิต\" → สินค้า > ประกันชีวิต",
    'flowpg_hierarchicalIntentDetectionLeafNote': "เฉพาะโหนดปลายทาง (ที่ไม่มีเจตนาย่อย) เท่านั้นที่มีจุดเชื่อมต่อ output",
    'flowpg_switchConfiguration': "ตั้งค่า Switch",
    'flowpg_switchName': "ชื่อ Switch",
    'flowpg_conditionalSwitchPlaceholder': "Switch แบบมีเงื่อนไข",
    'flowpg_outputPaths': "เส้นทางผลลัพธ์",
    'flowpg_addOutput': "เพิ่มผลลัพธ์",
    'flowpg_outputNumbered': "ผลลัพธ์ {n}",
    'flowpg_outputName': "ชื่อผลลัพธ์",
    'flowpg_conditionBuilder': "ตัวสร้างเงื่อนไข",
    'flowpg_simple': "แบบง่าย",
    'flowpg_advanced': "ขั้นสูง",
    'flowpg_conditionTypeTextContains': "ข้อความมีคำว่า",
    'flowpg_conditionTypeTextEquals': "ข้อความตรงกับ",
    'flowpg_conditionTypeNumberComparison': "เปรียบเทียบตัวเลข",
    'flowpg_conditionTypeBooleanCheck': "ตรวจสอบค่าบูลีน",
    'flowpg_conditionTypeRegexMatch': "จับคู่ Regex",
    'flowpg_conditionTypeLengthCheck': "ตรวจสอบความยาว",
    'flowpg_conditionType': "ประเภทเงื่อนไข",
    'flowpg_sourceField': "ฟิลด์ต้นทาง",
    'flowpg_containsText': "มีข้อความ",
    'flowpg_keywordPlaceholder': "คำสำคัญ",
    'flowpg_caseSensitive': "ตัวพิมพ์เล็ก-ใหญ่",
    'flowpg_equalsTo': "เท่ากับ",
    'flowpg_exactTextPlaceholder': "ข้อความที่ตรงกันเป๊ะ",
    'flowpg_numberSource': "ต้นทางตัวเลข",
    'flowpg_operatorGreaterThan': "มากกว่า (>)",
    'flowpg_operatorLessThan': "น้อยกว่า (<)",
    'flowpg_operatorEqual': "เท่ากับ (=)",
    'flowpg_operatorGreaterOrEqual': "มากกว่าหรือเท่ากับ (>=)",
    'flowpg_operatorLessOrEqual': "น้อยกว่าหรือเท่ากับ (<=)",
    'flowpg_operatorNotEqual': "ไม่เท่ากับ (!=)",
    'flowpg_operator': "ตัวดำเนินการ",
    'flowpg_compareValue': "ค่าที่เปรียบเทียบ",
    'flowpg_booleanSource': "ต้นทางค่าบูลีน",
    'flowpg_true': "จริง",
    'flowpg_false': "เท็จ",
    'flowpg_expectedValue': "ค่าที่คาดหวัง",
    'flowpg_regexPattern': "รูปแบบ Regex",
    'flowpg_regexFlagsOptional': "แฟล็ก Regex (ไม่บังคับ)",
    'flowpg_lengthOperatorEqualTo': "เท่ากับ",
    'flowpg_lengthOperatorBetween': "ระหว่าง",
    'flowpg_lengthOperator': "ตัวดำเนินการความยาว",
    'flowpg_lengthValue': "ค่าความยาว",
    'flowpg_maxLength': "ความยาวสูงสุด",
    'flowpg_generatedCondition': "เงื่อนไขที่สร้างขึ้น:",
    'flowpg_customConditionExpression': "นิพจน์เงื่อนไขที่กำหนดเอง",
    'flowpg_description': "คำอธิบาย",
    'flowpg_optionalDescriptionPlaceholder': "คำอธิบายเพิ่มเติม (ไม่บังคับ)...",
    'flowpg_conditionConfiguration': "ตั้งค่าเงื่อนไข",
    'flowpg_conditionTypeValueComparison': "เปรียบเทียบค่า",
    'flowpg_conditionTypeNumberRange': "ช่วงตัวเลข",
    'flowpg_conditionTypeCustomExpression': "นิพจน์ที่กำหนดเอง",
    'flowpg_leftValue': "ค่าซ้าย",
    'flowpg_inputTextExamplePlaceholder': "เช่น input.text",
    'flowpg_operatorEquals': "เท่ากับ",
    'flowpg_operatorNotEquals': "ไม่เท่ากับ",
    'flowpg_rightValue': "ค่าขวา",
    'flowpg_helloExamplePlaceholder': "เช่น 'hello'",
    'flowpg_textSource': "ต้นทางข้อความ",
    'flowpg_keywordExamplePlaceholder': "เช่น 'keyword'",
    'flowpg_minValue': "ค่าต่ำสุด",
    'flowpg_maxValue': "ค่าสูงสุด",
    'flowpg_customExpression': "นิพจน์ที่กำหนดเอง",
    'flowpg_customExpressionPlaceholder': "เช่น input.text.length > 5 && input.text.includes('hello')",
    'flowpg_outputLabels': "ป้ายชื่อผลลัพธ์",
    'flowpg_trueOutputLabel': "เอาต์พุต True",
    'flowpg_falseOutputLabel': "เอาต์พุต False",
    'flowpg_optionalConditionDescriptionPlaceholder': "คำอธิบายเพิ่มเติมของเงื่อนไขนี้ (ไม่บังคับ)...",
    'flowpg_delayConfiguration': "ตั้งค่าการหน่วงเวลา",
    'flowpg_delayTypeFixedDuration': "ระยะเวลาคงที่",
    'flowpg_delayTypeRandomRange': "ช่วงเวลาแบบสุ่ม",
    'flowpg_delayTypeVariableDelay': "หน่วงเวลาแบบตัวแปร",
    'flowpg_delayType': "ประเภทการหน่วงเวลา",
    'flowpg_duration': "ระยะเวลา",
    'flowpg_unitSeconds': "วินาที",
    'flowpg_unitMinutes': "นาที",
    'flowpg_unitHours': "ชั่วโมง",
    'flowpg_unit': "หน่วย",
    'flowpg_minDuration': "ระยะเวลาต่ำสุด",
    'flowpg_maxDuration': "ระยะเวลาสูงสุด",
    'flowpg_delayExpression': "นิพจน์การหน่วงเวลา",
    'flowpg_delayMessageOptional': "ข้อความระหว่างหน่วงเวลา (ไม่บังคับ)",
    'flowpg_pleaseWaitPlaceholder': "กรุณารอสักครู่ระหว่างดำเนินการ...",
    'flowpg_showProgressIndicator': "แสดงตัวบ่งชี้ความคืบหน้า",
    'flowpg_durationPreview': "ตัวอย่างระยะเวลา:",
    'flowpg_variableBasedOnExpression': "ตัวแปรตามนิพจน์ที่กำหนด",
    'flowpg_optionalDelayDescriptionPlaceholder': "คำอธิบายเพิ่มเติมของการหน่วงเวลานี้ (ไม่บังคับ)...",
    'flowpg_selectDocumentsPlaceholder': "เลือกเอกสาร",
    'flowpg_useSpecificDataSelection': "ใช้การเลือกข้อมูลเฉพาะ",
    'flowpg_selectDocumentData': "เลือกข้อมูลเอกสาร",
    'flowpg_selectDocumentForData': "เลือกเอกสารสำหรับข้อมูล",
    'flowpg_selectDocumentToViewDataHint': "เลือกเอกสารเพื่อดูข้อมูล",
    'flowpg_selectedDocumentData': "ข้อมูลเอกสารที่เลือก:",
    'flowpg_loadingDocumentData': "กำลังโหลดข้อมูลเอกสาร...",
    'flowpg_textReplacement': "การแทนที่ข้อความ",
    'flowpg_selectTextReplacementGroups': "เลือกกลุ่มการแทนที่ข้อความ",
    'flowpg_summaryMemoryEmbedding': "หน่วยความจำสรุป (Embedding)",
    'flowpg_summaryMemoryDocSearchHint': "เมื่อเปิดใช้งาน LLM จะสรุปบทสนทนาล่าสุดรวมกับข้อความล่าสุดเป็นคำค้นหา เพื่อให้คำถามต่อเนื่องดึงเอกสารที่ถูกต้อง มีผลเฉพาะการค้นหาเอกสารเท่านั้น ไม่กระทบคำตอบสุดท้าย หาก Memory Turns = 0 จะใช้ข้อความล่าสุดในการค้นหาโดยตรง",
    'flowpg_enableSummaryMemory': "เปิดใช้งานหน่วยความจำสรุป",
    'flowpg_provider': "ผู้ให้บริการ",
    'flowpg_model': "โมเดล",
    'flowpg_apiVersion': "เวอร์ชัน API",
    'flowpg_memoryTurns': "จำนวนรอบความจำ",
    'flowpg_memoryTurnsEmbedHint': "0 = ใช้เฉพาะข้อความล่าสุดในการค้นหา",
    'flowpg_memoryDurationMin': "ระยะเวลาความจำ (นาที)",
    'flowpg_temperature': "Temperature",
    'flowpg_maxTokens': "Max Tokens (จำนวนโทเค็นสูงสุด)",
    'flowpg_summarizerSystemPromptPlaceholder': "คุณเป็นผู้สรุปบทสนทนา จากประวัติการสนทนาและข้อความล่าสุดของผู้ใช้ ให้เขียนคำค้นหาแบบสรุปที่กระชับและครอบคลุมบริบททั้งหมด",
    'flowpg_llmTimeoutSeconds': "ระยะเวลารอ LLM (วินาที)",
    'flowpg_overrideGlobalTimeoutHint': "กำหนดระยะเวลารอเฉพาะสำหรับการเรียก LLM สรุปข้อมูล (0 = ใช้ค่ากลาง)",
    'flowpg_knowledgeGraphConfiguration': "การตั้งค่า Knowledge Graph",
    'flowpg_knowledgeGraphs': "กราฟความรู้",
    'flowpg_selectOneOrMoreGraphs': "เลือกกราฟหนึ่งรายการขึ้นไป",
    'flowpg_nexaDefaultsHint': "ค่าเริ่มต้นที่แสดงตรงกับค่าที่ NEXA แนะนำ ปล่อยไว้ตามเดิมหากโฟลว์นี้ไม่ต้องการปรับแต่งเฉพาะโหนด",
    'flowpg_maxHops': "จำนวน Hop สูงสุด",
    'flowpg_bfsDepthDefault3': "ความลึกของ BFS (ค่าเริ่มต้น 3)",
    'flowpg_searchMode': "โหมดการค้นหา",
    'flowpg_anchorMatchingDefaultFuzzyFirst': "การจับคู่ Anchor (ค่าเริ่มต้น fuzzy-first)",
    'flowpg_fuzzyThreshold': "เกณฑ์ Fuzzy",
    'flowpg_range0to100Default70': "0-100 (ค่าเริ่มต้น 70)",
    'flowpg_semanticThreshold': "เกณฑ์ Semantic",
    'flowpg_range0to1Default065': "0-1 (ค่าเริ่มต้น 0.65)",
    'flowpg_maxContextNodes': "จำนวนโหนดบริบทสูงสุด",
    'flowpg_default30': "ค่าเริ่มต้น 30",
    'flowpg_maxContextEdges': "จำนวนเส้นเชื่อมบริบทสูงสุด",
    'flowpg_default60': "ค่าเริ่มต้น 60",
    'flowpg_baselineTopK': "Baseline Top K",
    'flowpg_forBaselineVectorOnlyMode1to100': "สำหรับโหมด baseline-vector-only (1-100)",
    'flowpg_baselineMinSimilarity': "ค่าความคล้ายขั้นต่ำของ Baseline",
    'flowpg_forBaselineVectorOnlyMode0to1': "สำหรับโหมด baseline-vector-only (0-1)",
    'flowpg_waterfallSearchConfiguration': "การตั้งค่า Waterfall Search",
    'flowpg_waterfallSearchTierHint': "การค้นหาจะทำงานทีละระดับจากบนลงล่าง และหยุดที่ระดับแรกที่พบผลลัพธ์ (ขั้นบันได)",
    'flowpg_includeMiniappTierBeforeGraphs': "รวมระดับ MiniApp (DGA Czp) ก่อนกราฟ",
    'flowpg_graphTiers': "ระดับกราฟ",
    'flowpg_addTier': "เพิ่มระดับ",
    'flowpg_noGraphTiersYet': "ยังไม่มีระดับกราฟ คลิก \"เพิ่มระดับ\" เพื่อสร้างลำดับขั้น",
    'flowpg_tierNumber': "ระดับ {n}",
    'flowpg_graph': "กราฟ",
    'flowpg_selectAGraph': "เลือกกราฟ",
    'flowpg_advancedOptional': "ขั้นสูง (ไม่บังคับ)",
    'flowpg_leaveBlankNexaDefaultsTier': "เว้นว่างไว้เพื่อใช้ค่าเริ่มต้นของ NEXA สำหรับระดับนี้",
    'flowpg_anchorFinalTopK': "Anchor Final Top K",
    'flowpg_summaryMemoryWaterfallHint': "เมื่อเปิดใช้งาน LLM จะสรุปบทสนทนาล่าสุดรวมกับข้อความล่าสุดให้เป็นคำค้นหาสำหรับ waterfall search เพื่อให้คำถามต่อเนื่องค้นหาด้วยบริบทที่ถูกต้อง มีผลเฉพาะคำค้นหาของ waterfall search เท่านั้น ไม่กระทบคำตอบสุดท้าย หากตั้ง Memory Turns = 0 จะค้นหาด้วยข้อความล่าสุดโดยตรง",
    'flowpg_memoryTurnsSearchHint': "0 = ค้นหาด้วยข้อความล่าสุดเท่านั้น",
    'flowpg_enterNoDataMessagePlaceholder': "กรอกข้อความที่จะแสดงเมื่อไม่พบข้อมูลในฐานข้อมูล...",
    'flowpg_knowledgeApiConfiguration': "การตั้งค่า Knowledge API",
    'flowpg_requestBodyJsonLabel': "เนื้อหาคำขอ (JSON)",
    'flowpg_clickVariablesToInsertOrDrag': "คลิกตัวแปรเพื่อแทรก หรือลากแล้ววางลงในตัวแก้ไข",
    'flowpg_dataResultsJsonPathPlaceholder': "data.results (เส้นทาง JSON สำหรับดึงข้อมูลความรู้)",
    'flowpg_jsonPathExtractKnowledgeHint': "เส้นทาง JSON สำหรับดึงข้อมูลความรู้จากการตอบกลับของ API",
    'flowpg_sharePointConfiguration': "การตั้งค่า SharePoint",
    'flowpg_fileLocation': "ตำแหน่งไฟล์",
    'flowpg_filename': "ชื่อไฟล์",
    'flowpg_subfolderPath': "เส้นทางโฟลเดอร์ย่อย",
    'flowpg_subfolderNameOptionalPlaceholder': "/ชื่อโฟลเดอร์ย่อย (ไม่บังคับ)",
    'flowpg_subfolderPathHint': "เส้นทางโฟลเดอร์ย่อยภายในไซต์ SharePoint<br><strong>ราก: /Documents</strong><br>ตัวอย่าง: /Data จะกลายเป็น /Documents/Data",
    'flowpg_connectionSettings': "การตั้งค่าการเชื่อมต่อ",
    'flowpg_siteUrl': "Site URL (URL เว็บไซต์)",
    'flowpg_tenantId': "Tenant ID",
    'flowpg_authentication': "การยืนยันตัวตน",
    'flowpg_clientId': "Client ID",
    'flowpg_applicationClientIdPlaceholder': "Application (client) ID",
    'flowpg_clientSecret': "Client Secret",
    'flowpg_enterClientSecret': "กรอก Client Secret",
    'flowpg_mcpServerConfiguration': "การตั้งค่า MCP Server",
    'flowpg_serverUrl': "Server URL (URL เซิร์ฟเวอร์)",
    'flowpg_authHeaderName': "ชื่อ Header สำหรับยืนยันตัวตน",
    'flowpg_authTokenOptional': "Auth Token (ไม่บังคับ)",
    'flowpg_bearerTokenApiKeyPlaceholder': "Bearer token / API key",
    'flowpg_connectTimeoutSeconds': "ระยะเวลารอเชื่อมต่อ (วินาที)",
    'flowpg_agenticLlmPicksTools': "Agentic (LLM เลือกเครื่องมือเอง)",
    'flowpg_singleTool': "เครื่องมือเดียว",
    'flowpg_mode': "โหมด",
    'flowpg_maxToolIterations': "จำนวนรอบเครื่องมือสูงสุด",
    'flowpg_toolChoice': "การเลือกเครื่องมือ",
    'flowpg_tools': "เครื่องมือ",
    'flowpg_discoverTools': "ค้นหาเครื่องมือ",
    'flowpg_selectedTools': "เครื่องมือที่เลือก",
    'flowpg_leaveEmptyExposeAllToolsHint': "เว้นว่างไว้เพื่อเปิดใช้เครื่องมือที่พบทั้งหมด (โหมด agentic)",
    'flowpg_loadingPleaseWait': "กำลังโหลด กรุณารอสักครู่...",
    'flowpg_updateFlow': "อัปเดตโฟลว์",
    'flowpg_saveFlow': "บันทึกโฟลว์",
    'flowpg_untitledFlow': "โฟลว์ที่ยังไม่มีชื่อ",
    'flowpg_updateThisFlow': "ต้องการอัปเดตโฟลว์นี้หรือไม่?",
    'flowpg_saveThisFlow': "ต้องการบันทึกโฟลว์นี้หรือไม่?",
    'flowpg_warning': "คำเตือน",
    'flowpg_flowHasValidationIssues': "โฟลว์มีปัญหาการตรวจสอบ {n} รายการ",
    'flowpg_canStillSaveMayNotWork': "คุณยังสามารถบันทึกได้ แต่โฟลว์อาจทำงานไม่ถูกต้อง",
    'flowpg_readyToSave': "พร้อมบันทึก",
    'flowpg_flowValidationPassed': "ตรวจสอบโฟลว์ผ่านเรียบร้อยแล้ว",
    'flowpg_versionNoteOptional': "หมายเหตุเวอร์ชัน (ไม่บังคับ)",
    'flowpg_describeWhatChangedPlaceholder': "อธิบายสิ่งที่เปลี่ยนแปลงในเวอร์ชันนี้...",
    'flowpg_cancel': "ยกเลิก",
    'flowpg_loadFromExistingModel': "โหลดจากโมเดลที่มีอยู่",
    'flowpg_selectModelToLoad': "เลือกโมเดลที่จะโหลด",
    'flowpg_selectModel': "เลือกโมเดล",
    'flowpg_chooseModelToLoadConfigFrom': "เลือกโมเดลที่จะโหลดการตั้งค่ามาใช้",
    'flowpg_configurationPreview': "ตัวอย่างการตั้งค่า",
    'flowpg_providerLabel': "ผู้ให้บริการ:",
    'flowpg_modelLabel': "โมเดล:",
    'flowpg_temperatureLabel': "Temperature:",
    'flowpg_maxTokensLabel': "Max Tokens (จำนวนโทเค็นสูงสุด):",
    'flowpg_topPLabel': "Top P:",
    'flowpg_frequencyPenaltyLabel': "Frequency Penalty:",
    'flowpg_note': "หมายเหตุ",
    'flowpg_loadingConfigWillOverwriteNodeSettings': "การโหลดการตั้งค่าจะเขียนทับการตั้งค่าโมเดล AI ปัจจุบันในโหนดนี้",
    'flowpg_loadConfiguration': "โหลดการตั้งค่า",
    'flowpg_loadConfigFor': "โหลดการตั้งค่าสำหรับ {n}",
    'flowpg_loadingConfigWillOverwriteAiSettingsFor': "การโหลดการตั้งค่าจะเขียนทับการตั้งค่า AI ปัจจุบันสำหรับ {n}",
    'flowpg_successExclaim': "สำเร็จ!",
    'flowpg_flowLabel': "โฟลว์: {n}",
    'flowpg_ok': "ตกลง",
    'flowpg_confirmNavigation': "ยืนยันการออกจากหน้า",
    'flowpg_areYouSureYouWantToLeave': "คุณแน่ใจหรือไม่ว่าต้องการออกจากหน้านี้?",
    'flowpg_anyUnsavedChangesWillBeLost': "การเปลี่ยนแปลงที่ยังไม่ได้บันทึกจะสูญหาย",
    'flowpg_unsavedChanges': "การเปลี่ยนแปลงที่ยังไม่บันทึก",
    'flowpg_currentFlowModificationsNotSaved': "การแก้ไขโฟลว์ปัจจุบันของคุณยังไม่ได้บันทึก",
    'flowpg_leaveAnyway': "ออกจากหน้านี้",
    'flowpg_stayHere': "อยู่ที่หน้านี้ต่อ",
    'flowpg_copiedToClipboard': "คัดลอกไปยังคลิปบอร์ดแล้ว!",
    'flowpg_undoneAction': "เลิกทำแล้ว: {action}",
    'flowpg_redoneAction': "ทำซ้ำแล้ว: {action}",
    'flowpg_modelsReloadedSuccess': "โหลดโมเดลใหม่สำเร็จ",
    'flowpg_modelsReloadFailed': "โหลดโมเดลใหม่ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
    'flowpg_undoRedoHistoryCleared': "ล้างประวัติ Undo/Redo แล้ว",
    'flowpg_botDisableTimeMinWarning': "เวลาปิดใช้งานบอทต้องมีค่าอย่างน้อย 1 นาที",
    'flowpg_mcpServerUrlRequired': "กรุณาระบุ URL ของ MCP server",
    'flowpg_mcpToolsDiscovered': "ค้นพบ MCP tool จำนวน {count} รายการ",
    'flowpg_mcpToolsDiscoverFailed': "ไม่สามารถค้นหา MCP tools ได้",
    'flowpg_mcpServerConnectFailed': "ไม่สามารถเชื่อมต่อกับ MCP server ได้",
    'flowpg_nodeTypeMessageInput': "ข้อความอินพุต",
    'flowpg_nodeTypeAiModel': "โมเดล AI",
    'flowpg_nodeTypeGuardrailAi': "Guardrail AI (ระบบป้องกัน AI)",
    'flowpg_nodeTypeIntentAiModel': "โมเดล AI อินเทนต์",
    'flowpg_nodeTypeIntentClassifier': "ตัวจำแนกอินเทนต์",
    'flowpg_nodeTypeIntent': "อินเทนต์",
    'flowpg_nodeTypeAdvancedRouter': "ตัวจัดเส้นทางขั้นสูง",
    'flowpg_nodeTypeApiTrigger': "ทริกเกอร์ API",
    'flowpg_nodeTypeContactAgent': "ติดต่อเจ้าหน้าที่",
    'flowpg_nodeTypeInterestOptimizer': "ตัวเพิ่มประสิทธิภาพความสนใจ",
    'flowpg_nodeTypeLoanInterest': "ดอกเบี้ยเงินกู้",
    'flowpg_nodeTypeSwitch': "สวิตช์",
    'flowpg_nodeTypeCondition': "เงื่อนไข",
    'flowpg_nodeTypeDelay': "หน่วงเวลา",
    'flowpg_nodeTypeDocuments': "เอกสาร",
    'flowpg_nodeTypeKnowledgeGraph': "กราฟความรู้",
    'flowpg_nodeTypeWaterfallSearch': "ค้นหาแบบขั้นบันได",
    'flowpg_nodeTypeDatabaseIntegration': "การเชื่อมต่อฐานข้อมูล",
    'flowpg_nodeTypeKnowledgeApi': "Knowledge API",
    'flowpg_nodeTypeMcp': "MCP",
    'flowpg_nodeTypeProducts': "สินค้า",
    'flowpg_connectionAlreadyExists': "มีการเชื่อมต่อระหว่างโหนดเหล่านี้อยู่แล้ว",
    'flowpg_sourceOrTargetNodeNotFound': "ไม่พบโหนดต้นทางหรือปลายทาง",
    'flowpg_cannotConnectNodeToItself': "ไม่สามารถเชื่อมต่อโหนดกับตัวมันเองได้",
    'flowpg_cannotDragFromInputHandle': "ไม่สามารถลากจากจุดเชื่อมต่ออินพุตได้ จุดเชื่อมต่ออินพุตรับการเชื่อมต่อได้เท่านั้น",
    'flowpg_cannotConnectToOutputHandle': "ไม่สามารถเชื่อมต่อไปยังจุดเชื่อมต่อเอาต์พุตได้ จุดเชื่อมต่อเอาต์พุตส่งการเชื่อมต่อได้เท่านั้น",
    'flowpg_messageInputCannotReceiveConnections': "โหนดข้อความอินพุตไม่สามารถรับการเชื่อมต่อได้ เนื่องจากเป็นโหนดเริ่มต้น",
    'flowpg_responseNodeCannotSendConnections': "โหนดตอบกลับไม่สามารถส่งการเชื่อมต่อได้ เนื่องจากเป็นโหนดสิ้นสุด",
    'flowpg_messageInputOnlyConnectsToModelOrIntent': "โหนดข้อความอินพุตเชื่อมต่อได้เฉพาะโหนดโมเดล AI หรือโหนดจัดการอินเทนต์เท่านั้น",
    'flowpg_apiCallOnlyConnectsToModelOrIntent': "โหนดอินพุต API Call เชื่อมต่อได้เฉพาะโหนดโมเดล AI หรือโหนดจัดการอินเทนต์เท่านั้น",
    'flowpg_sourceModelOfIntentOnlyConnectsToIntentAI': "โมเดลต้นทางของโหนดอินเทนต์เชื่อมต่อได้เฉพาะโหนดอินเทนต์ AI เท่านั้น",
    'flowpg_intentOnlyConnectsToIntentModelApiContactResponse': "โหนดอินเทนต์เชื่อมต่อได้เฉพาะโหนดอินเทนต์, โมเดล AI, API ทริกเกอร์, ติดต่อเจ้าหน้าที่ หรือ Response เท่านั้น",
    'flowpg_smartIntentOnlyConnectsToIntentModelApiContactResponse': "โหนดสมาร์ทอินเทนต์เชื่อมต่อได้เฉพาะโหนดอินเทนต์, โมเดล AI, API ทริกเกอร์, ติดต่อเจ้าหน้าที่ หรือ Response เท่านั้น",
    'flowpg_advancedRouterBottomOnlyConnectsToIntentAI': "output-bottom ของ Advanced Router เชื่อมต่อได้เฉพาะโหนดอินเทนต์ AI เท่านั้น",
    'flowpg_advancedRouterOutputOnlyConnectsToFlowNodes': "เอาต์พุตของ Advanced Router เชื่อมต่อได้เฉพาะโหนดในโฟลว์ (โมเดล, อินเทนต์, Response ฯลฯ) เท่านั้น",
    'flowpg_interestOptimizerCannotConnectToThisType': "โหนด Interest Optimizer ไม่สามารถเชื่อมต่อกับโหนดประเภทนี้ได้",
    'flowpg_loanInterestCannotConnectToThisType': "โหนดดอกเบี้ยเงินกู้ไม่สามารถเชื่อมต่อกับโหนดประเภทนี้ได้",
    'flowpg_modelKnowledgeSourceOnlyConnectsToKnowledgeNodes': "แหล่งความรู้ของโหนดโมเดล AI เชื่อมต่อได้เฉพาะโหนดความรู้เท่านั้น",
    'flowpg_modelOnlyConnectsToModelIntentResponse': "โหนดโมเดล AI เชื่อมต่อได้เฉพาะโหนดโมเดล AI, อินเทนต์หรือ Response เท่านั้น",
    'flowpg_emailNodeCannotConnectToThisType': "โหนดอีเมลไม่สามารถเชื่อมต่อกับโหนดประเภทนี้ได้",
    'flowpg_apiTriggerOnlyConnectsToModelResponseApiContact': "โหนด API ทริกเกอร์เชื่อมต่อได้เฉพาะโหนดโมเดล AI, Response, API ทริกเกอร์หรือติดต่อเจ้าหน้าที่เท่านั้น",
    'flowpg_contactAgentOnlyConnectsToModelResponseApiContact': "โหนดติดต่อเจ้าหน้าที่เชื่อมต่อได้เฉพาะโหนดโมเดล AI, Response, API ทริกเกอร์หรือติดต่อเจ้าหน้าที่เท่านั้น",
    'flowpg_invalidOutputHandleForCondition': "จุดเชื่อมต่อเอาต์พุตของโหนดเงื่อนไขไม่ถูกต้อง",
    'flowpg_knowledgeNodeOnlyConnectsToModel': "{nodeType} เชื่อมต่อได้เฉพาะโหนดโมเดล AI เท่านั้น",
    'flowpg_connectionWouldCreateCircularReference': "การเชื่อมต่อนี้จะทำให้เกิดการอ้างอิงแบบวนซ้ำในโฟลว์",
    'flowpg_modelCanOnlyConnectToOneKnowledgeNode': "โมเดล AI เชื่อมต่อได้เพียงโหนด {nodeType} เดียวจากจุดเชื่อมต่อ output-bottom",
    'flowpg_nodeCanOnlyHaveOneInputConnection': "โหนด {nodeType} มีการเชื่อมต่ออินพุตได้เพียงหนึ่งเดียว",
    'flowpg_switchNodeMaxThreeInputs': "โหนด Switch มีการเชื่อมต่ออินพุตได้สูงสุด 3 การเชื่อมต่อ",
    'flowpg_conditionNodeMaxTwoInputs': "โหนดเงื่อนไขมีการเชื่อมต่ออินพุตได้สูงสุด 2 การเชื่อมต่อ",
    'flowpg_messageInputCanOnlyHaveOneOutput': "โหนดข้อความอินพุตมีการเชื่อมต่อเอาต์พุตได้เพียงหนึ่งเดียว",
    'flowpg_intentFallbackCanOnlyHaveOneOutput': "ฟอลแบ็กของอินเทนต์มีการเชื่อมต่อเอาต์พุตได้เพียงหนึ่งเดียว",
    'flowpg_eachIntentActionCanOnlyHaveOneOutput': "แต่ละ action ของอินเทนต์มีการเชื่อมต่อเอาต์พุตได้เพียงหนึ่งเดียว",
    'flowpg_intentCanOnlyHaveOneIntentAIConnection': "อินเทนต์มีการเชื่อมต่ออินเทนต์ AI ได้เพียงหนึ่งเดียว",
    'flowpg_smartIntentFallbackCanOnlyHaveOneOutput': "ฟอลแบ็กของสมาร์ทอินเทนต์มีการเชื่อมต่อเอาต์พุตได้เพียงหนึ่งเดียว",
    'flowpg_smartIntentCanOnlyHaveOneIntentAIConnection': "สมาร์ทอินเทนต์มีการเชื่อมต่ออินเทนต์ AI ได้เพียงหนึ่งเดียว",
    'flowpg_intentAIConnectionLabel': "การเชื่อมต่ออินเทนต์ AI",
    'flowpg_fallbackOutputLabel': "เอาต์พุตฟอลแบ็ก",
    'flowpg_intentOutputLabel': "เอาต์พุตอินเทนต์",
    'flowpg_advancedRouterHandleOnlyOneConnection': "Advanced Router {handleLabel} มีการเชื่อมต่อได้เพียงหนึ่งเดียว",
    'flowpg_switchOutputLabel': "เอาต์พุต Switch",
    'flowpg_defaultOutputLabel': "เอาต์พุตเริ่มต้น",
    'flowpg_outputLabel': "เอาต์พุต",
    'flowpg_nodeHandleOnlyOneOutputConnection': "{nodeName} {handleName} มีการเชื่อมต่อเอาต์พุตได้เพียงหนึ่งเดียว",
    'flowpg_messageInputAlreadyExists': "มีโหนดข้อความอินพุตอยู่แล้ว อนุญาตให้มีโหนดข้อความอินพุตได้เพียงหนึ่งเดียวต่อโฟลว์",
    'flowpg_addedNodeToFlow': "เพิ่ม {label} เข้าสู่โฟลว์แล้ว",
    'flowpg_nodeDeletedSuccessfully': "ลบโหนดสำเร็จ",
    'flowpg_nNodesDeletedSuccessfully': "ลบโหนดจำนวน {n} รายการสำเร็จ",
    'flowpg_cannotDuplicateMessageInput': "ไม่สามารถทำสำเนาโหนดข้อความอินพุตได้ อนุญาตให้มีโหนดข้อความอินพุตได้เพียงหนึ่งเดียวต่อโฟลว์",
    'flowpg_nNodesDuplicatedSuccessfully': "ทำสำเนาโหนดจำนวน {n} รายการสำเร็จ",
    'flowpg_nNodesCopiedToClipboard': "คัดลอกโหนดจำนวน {n} รายการไปยังคลิปบอร์ดแล้ว",
    'flowpg_cannotPasteMessageInput': "ไม่สามารถวางโหนดข้อความอินพุตได้ อนุญาตให้มีโหนดข้อความอินพุตได้เพียงหนึ่งเดียวต่อโฟลว์",
    'flowpg_nNodesPastedSuccessfully': "วางโหนดจำนวน {n} รายการสำเร็จ",
    'flowpg_cannotSaveEmptyFlow': "ไม่สามารถบันทึกโฟลว์ที่ว่างเปล่าได้",
    'flowpg_flowValidationFailed': "การตรวจสอบโฟลว์ล้มเหลว: {errors}",
    'flowpg_flowUpdatedSuccessfully': "อัปเดตโฟลว์สำเร็จ",
    'flowpg_flowSavedSuccessfully': "บันทึกโฟลว์สำเร็จ",
    'flowpg_failedToSaveFlow': "บันทึกโฟลว์ไม่สำเร็จ",
    'flowpg_failedToSaveFlowWithReason': "บันทึกโฟลว์ไม่สำเร็จ: {reason}",
    'flowpg_flowNameRequired': "กรุณาระบุชื่อโฟลว์",
    'flowpg_flowMustContainRootNode': "โฟลว์ต้องมีโหนดเริ่มต้นอย่างน้อยหนึ่งโหนด",
    'flowpg_nodeAtPathMissingId': "โหนดที่ตำแหน่ง {path} ไม่มี ID",
    'flowpg_duplicateNodeIdFound': "พบ ID โหนดซ้ำ: {id} ที่ตำแหน่ง {path}",
    'flowpg_nodeMissingNodeType': "โหนด {id} ไม่มี nodeType",
    'flowpg_messageInputRequiresModel': "โหนด Message Input ({id}) ต้องเลือกโมเดลอย่างน้อยหนึ่งรายการ",
    'flowpg_aiModelRequiresSelectedModel': "โหนด AI Model ({id}) ต้องเลือกโมเดล",
    'flowpg_intentAIRequiresModelAndProvider': "โหนดอินเทนต์ AI ({id}) ต้องระบุโมเดลและผู้ให้บริการ",
    'flowpg_intentRequiresAtLeastOneIntent': "โหนดอินเทนต์ ({id}) ต้องมีอินเทนต์อย่างน้อยหนึ่งรายการ",
    'flowpg_switchRequiresAtLeastTwoOutputs': "โหนด Switch ({id}) ต้องมีเส้นทางผลลัพธ์อย่างน้อยสองเส้นทาง",
    'flowpg_apiTriggerRequiresApiUrl': "โหนด API ทริกเกอร์ ({id}) ต้องระบุ API URL",
    'flowpg_knowledgeApiRequiresApiUrl': "โหนด Knowledge API ({id}) ต้องระบุ API URL",
    'flowpg_mcpRequiresServerUrl': "โหนด MCP ({id}) ต้องระบุ server URL",
    'flowpg_mcpSingleToolRequiresOneTool': "โหนด MCP ({id}) ในโหมด single-tool ต้องเลือกเครื่องมือเพียงหนึ่งรายการ",
    'flowpg_emailRequiresRecipient': "โหนด Email ({id}) ต้องระบุอีเมลผู้รับ",
    'flowpg_emailInvalidRecipientFormat': "โหนด Email ({id}) มีรูปแบบอีเมลผู้รับไม่ถูกต้อง",
    'flowpg_emailRequiresSubject': "โหนด Email ({id}) ต้องระบุหัวข้อ",
    'flowpg_emailRequiresContentForCustomTemplate': "โหนด Email ({id}) ต้องระบุเนื้อหาอีเมลเมื่อใช้เทมเพลตแบบกำหนดเอง",
    'flowpg_sharepointRequiresAllFields': "โหนด SharePoint ({id}) ต้องกรอกข้อมูลให้ครบทุกฟิลด์: Site URL, Tenant ID, Client ID, Client Secret, Folder Path และ Filename",
    'flowpg_flowMustContainAtLeastOneNode': "โฟลว์ต้องมีโหนดอย่างน้อยหนึ่งโหนด",
    'flowpg_nodeNumberMissingId': "โหนดที่ {n} ไม่มี ID",
    'flowpg_duplicateNodeIdFoundSimple': "พบ ID โหนดซ้ำ: {n}",
    'flowpg_nodeMissingNodeTypeSimple': "โหนด {n} ไม่มี nodeType",
    'flowpg_waterfallNodeInvalidGraphTiers': "โหนด Waterfall Search {n} มี graph tiers ที่ไม่ถูกต้องหรือไม่ครบถ้วน",
    'flowpg_nodeMissingPosition': "โหนด {n} ไม่มีตำแหน่ง",
    'flowpg_nodeTargetMissingNodeId': "เป้าหมายที่ {idx} ของโหนด {n} ไม่มี nodeId",
    'flowpg_nodeReferencesNonExistentTarget': "โหนด {n} อ้างอิงถึงโหนดเป้าหมายที่ไม่มีอยู่จริง: {target}",
    'flowpg_unknownErrorOccurred': "เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ",
    'flowpg_apiCallFailed': "เรียก API ไม่สำเร็จ",
    'flowpg_flowLoadedSuccess': "โหลดโฟลว์ \"{n}\" สำเร็จ",
    'flowpg_failedLoadFlow': "โหลดโฟลว์ไม่สำเร็จ",
    'flowpg_failedLoadFlowColon': "โหลดโฟลว์ไม่สำเร็จ: {n}",
    'flowpg_flowImportedSuccessNamed': "นำเข้าโฟลว์ \"{n}\" สำเร็จ",
    'flowpg_failedImportFlowData': "นำเข้าข้อมูลโฟลว์ไม่สำเร็จ",
    'flowpg_flowLoadedSuccessGeneric': "โหลดโฟลว์สำเร็จ",
    'flowpg_flowCleared': "ล้างโฟลว์เรียบร้อยแล้ว",
    'flowpg_failedLoadModelConfig': "โหลดการตั้งค่าโมเดลไม่สำเร็จ",
    'flowpg_errorLoadModelConfig': "เกิดข้อผิดพลาดขณะโหลดการตั้งค่าโมเดล",
    'flowpg_successLoadedConfigFrom': "โหลดการตั้งค่าจาก {n} สำเร็จ",
    'flowpg_selectedModel': "โมเดลที่เลือก",
    'flowpg_failedLoadModelConfigColon': "โหลดการตั้งค่าโมเดลไม่สำเร็จ: ",
    'flowpg_failedLoadModelConfigRetry': "โหลดการตั้งค่าโมเดลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
    'flowpg_noModelConfigToLoad': "ไม่มีการตั้งค่าโมเดลให้โหลด",
    'flowpg_successLoadedConfigFromTo': "โหลดการตั้งค่าจาก {n} ไปยัง {target} สำเร็จ",
    'flowpg_fallback': "ฟอลแบ็ก",
    'flowpg_smartIntent': "สมาร์ทอินเทนต์",
    'flowpg_noTargetSelectedForConfig': "ยังไม่ได้เลือกเป้าหมายสำหรับโหลดการตั้งค่า",
    'flowpg_smartIntentNumbered': "สมาร์ทอินเทนต์ {n}",
    'flowpg_flowExportedSuccess': "ส่งออกโฟลว์สำเร็จ",
    'flowpg_failedExportFlow': "ส่งออกโฟลว์ไม่สำเร็จ",
    'flowpg_importedFlow': "โฟลว์ที่นำเข้า",
    'flowpg_flowImportedSuccess': "นำเข้าโฟลว์สำเร็จ",
    'flowpg_failedImportFlowInvalidFormat': "นำเข้าโฟลว์ไม่สำเร็จ: รูปแบบไฟล์ไม่ถูกต้อง",
    'flowpg_isolatedNodeFound': "พบโหนดที่แยกเดี่ยว {n}",
    'flowpg_today': "วันนี้",
    'flowpg_yesterday': "เมื่อวาน",
    'flowpg_daysAgo': "{n} วันที่แล้ว",
    'flowpg_confirmLeaveUnsavedChanges': "คุณแน่ใจหรือไม่ว่าต้องการออก? การเปลี่ยนแปลงที่ยังไม่ได้บันทึกจะสูญหาย",
    'flowpg_failedLoadAiModelsRefresh': "โหลดโมเดล AI ไม่สำเร็จ กรุณารีเฟรชหน้าเว็บ",
    'entra_guidPlaceholder': "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
    'entra_secretMaskedPlaceholder': "••••••••",
    'entra_scopesPlaceholder': "openid profile email",
    'entra_requiredField': "จำเป็นต้องกรอก",
    'flowpg_cacheScopeFlowLevel': "ระดับโฟลว์ (ผู้ใช้ทุกคน)",
    'flowpg_cacheScopeUserLevel': "ระดับผู้ใช้ (แยกตามผู้ใช้)",
    'flowpg_documentDataHeaderTextEnglish': "ข้อความภาษาอังกฤษ",
    'flowpg_documentDataHeaderTextOriginal': "ข้อความต้นฉบับ",
    'gmd_createModelTitle': "สร้างโมเดล",
    'gmd_loadingPleaseWait': "กำลังโหลด กรุณารอสักครู่...",
    'gptmpl_addTemplate': "เทมเพลต",
    'gptmpl_groupNamePlaceholder': "ชื่อกลุ่ม",
    'gptmpl_loading': "กำลังโหลด...",
    'gptmpl_pleaseWait': "กรุณารอสักครู่",
    'gptmpl_requiredField': "จำเป็นต้องกรอก",
    'grtext_textGroup': "กลุ่มข้อความ",
    'grtext_action': "การดำเนินการ",
    'grtext_requiredField': "จำเป็นต้องกรอก",
    'grtext_loading': "กำลังโหลด...",
    'grtext_pleaseWait': "กรุณารอสักครู่",
    'igrp_loadingTitle': "กำลังโหลด...",
    'igrp_loadingSubtitle': "กรุณารอสักครู่",
    'igrp_required': "จำเป็นต้องกรอก",
    'invm_addMultipleHint': "ได้หลายรายการ",
    'invm_roleAdmin': "แอดมิน",
    'invm_roleUser': "ผู้ใช้งาน",
    'invm_roleOperator': "ผู้ดำเนินการ",
    'invm_roleSuperAdmin': "ผู้ดูแลระบบสูงสุด",
    'kgde_backToList': "กลับไปยังรายการ",
    'mquick_company': "บริษัท",
    'mquick_name': "ชื่อ",
    'mquick_channelSecret': "Channel Secret (รหัสลับช่องทาง)",
    'mquick_channelToken': "Channel Token (โทเค็นช่องทาง)",
    'mquick_loadingPleaseWait': "กำลังโหลด กรุณารอสักครู่...",
    'mquick_required': "จำเป็นต้องกรอก",
    'relnotes_whatsNew': "มีอะไรใหม่?",
    'relnotes_feature': "ฟีเจอร์",
    'relnotes_bugfix': "แก้ไขข้อผิดพลาด",
    'relnotes_improvement': "ปรับปรุง",
    'relnotes_externalApi': "API ภายนอก",
    'sadash_usersLabel': "ผู้ใช้งาน",
    'sadash_toggle': "สลับการแสดง",
    'sadash_loadingTitle': "กำลังโหลด...",
    'sadash_pleaseWaitText': "กรุณารอสักครู่",
    'sasales_columnNo': "ลำดับ",
    'sasales_columnFullName': "ชื่อ-นามสกุล",
    'sasales_columnEmail': "อีเมล",
    'sasales_columnPhone': "เบอร์โทร",
    'sasales_columnActions': "การดำเนินการ",
    'sawg_companyLabel': "บริษัท",
    'sawg_typeLabel': "ประเภท {type}",
    'sawg_maxLength10': "ไม่เกิน 10 ตัวอักษร",
    'sawg_genericError': "เกิดข้อผิดพลาด",
    'vneg_negativeNamePlaceholder': "ชื่อชุดคำถามเชิงลบ",
    'vneg_loadingTitle': "กำลังโหลด...",
    'vneg_pleaseWait': "กรุณารอสักครู่",
    'vneg_negativeQuestionSet': "ชุดคำถามเชิงลบ",
    'vneg_createBy': "สร้างโดย",
        'mqr_quickReply': "ข้อความตอบกลับด่วน",
    'mqr_quickReplyGroup': "กลุ่มข้อความตอบกลับด่วน",
    'Quick reply Group': "กลุ่มข้อความตอบกลับด่วน",
    'Add Quick Reply group': "เพิ่มกลุ่มข้อความตอบกลับด่วน",
    'mqr_dash': "-",
    'mqr_loading': "กำลังโหลด...",
    'mqr_pleaseWait': "กรุณารอสักครู่",
    'mqr_editQuickReplyGroup': "แก้ไขกลุ่มข้อความตอบกลับด่วน",
    'mqr_modifyQuickReplyGroupConfiguration': "แก้ไขการตั้งค่ากลุ่มข้อความตอบกลับด่วน",
    'mqr_basicInformation': "ข้อมูลพื้นฐาน",
    'mqr_quickReplyGroupName': "ชื่อกลุ่มข้อความตอบกลับด่วน",
    'mqr_enterGroupNamePlaceholder': "กรอกชื่อกลุ่ม...",
    'mqr_importFromShortcut': "นำเข้าจากชอร์ตคัต",
    'mqr_shortcutGroup': "กลุ่มชอร์ตคัต",
    'mqr_importGroupFromShortcutGroup': "นำเข้ากลุ่มจากกลุ่มชอร์ตคัต",
    'mqr_modelConfiguration': "การตั้งค่าโมเดล",
    'mqr_allModels': "ทุกโมเดล",
    'mqr_allModel': "ทุกโมเดล",
    'mqr_modelSetup': "ตั้งค่าโมเดล",
    'mqr_model': "โมเดล",
    'mqr_models': "โมเดล",
    'mqr_modelName': "ชื่อโมเดล",
    'mqr_actions': "การดำเนินการ",
    'mqr_selectModel': "เลือกโมเดล",
    'mqr_remove': "ลบ",
    'mqr_add': "เพิ่ม",
    'mqr_allModelsIncluded': "รวมโมเดลทั้งหมดแล้ว",
    'mqr_allModelsIncludedDescription': "กลุ่มนี้จะรวมโมเดลที่มีทั้งหมดโดยอัตโนมัติ",
    'mqr_command': "คำสั่ง",
    'mqr_commands': "คำสั่ง",
    'mqr_quickReplyNamePlaceholder': "ชื่อข้อความตอบกลับด่วน",
    'mqr_quickReplyDataPlaceholder': "ข้อมูลข้อความตอบกลับด่วน",
    'mqr_postbackMessageTypeExplanation': "Postback คือประเภทที่ผู้ใช้จะไม่เห็นข้อมูลที่ถูกส่ง <br />Message คือประเภทที่ผู้ใช้จะเห็นข้อมูลที่ถูกส่ง",
    'mqr_previewAlt': "ตัวอย่าง",
    'mqr_configureQuickReplyCommandsHint': "ตั้งค่าคำสั่งข้อความตอบกลับด่วนพร้อมป้ายชื่อ ข้อความ และไอคอนที่กำหนดเอง",
    'mqr_commandsConfigured': "ตั้งค่าคำสั่งแล้ว {n} รายการ",
    'mqr_createNewQuickReplyGroup': "สร้างกลุ่มข้อความตอบกลับด่วนใหม่",
    'mqr_quickModelNameTooltip': "ชื่อ Quick model",
    'mqr_modelDetailsAndInformation': "รายละเอียดและข้อมูลของโมเดล",
    'mqr_noModelsFound': "ไม่พบโมเดล",
    'mqr_noModelDataAvailable': "ไม่มีข้อมูลโมเดลให้แสดง",
    'mqr_view': "ดู",
    'mqr_modelsCount': "{n} โมเดล",
    'mqr_importShortcutGroup': "นำเข้ากลุ่มชอร์ตคัต",
    'mqr_selectShortcutGroupToImport': "เลือกกลุ่มชอร์ตคัตที่ต้องการนำเข้า",
    'mqr_selectShortcutGroup': "เลือกกลุ่มชอร์ตคัต",
    'mqr_availableShortcutGroups': "กลุ่มชอร์ตคัตที่มีอยู่",
    'mqr_chooseShortcutGroupToImportModels': "เลือกกลุ่มชอร์ตคัตเพื่อนำเข้าโมเดล",
    'mqr_selectShortcutGroupLabel': "เลือกกลุ่มชอร์ตคัต",
    'mqr_chooseShortcutGroupPlaceholder': "เลือกกลุ่มชอร์ตคัต...",
    'mqr_importingWillAddModelsHint': "การนำเข้าจะเพิ่มโมเดลของกลุ่มที่เลือกเข้าไปในการตั้งค่าปัจจุบันของคุณ",
    'mqr_availableGroupsCount': "มีกลุ่มที่ใช้ได้ {n} กลุ่ม",
    'mqr_cancel': "ยกเลิก",
    'mqr_import': "นำเข้า",
    'mqr_required': "จำเป็นต้องกรอก",
    'mqr_allModelCannotImportMoreGroup': "โมเดลทั้งหมดไม่สามารถนำเข้ากลุ่มเพิ่มเติมได้",
    'mqr_groupMustNotHaveDuplicatedModels': "กลุ่มต้องไม่มีโมเดลซ้ำกัน",
    'mqr_errorOccurred': "เกิดข้อผิดพลาด!",
    'mqr_somethingWentWrong': "เกิดข้อผิดพลาดบางอย่าง!",
    'mqr_onlyJpegPngAllowed': "ลองรับไฟล์ jpeg หรือ png เท่านั้น",
    'pdet_productGroupInformation': "ข้อมูลกลุ่มสินค้า",
    'pdet_productGroupName': "ชื่อกลุ่มสินค้า",
    'pdet_productGroupNameRequired': "กรุณากรอกชื่อกลุ่มสินค้า",
    'pdet_products': "สินค้า",
    'pdet_productCount': "{n} สินค้า",
    'pdet_reprocess': "ประมวลผลใหม่",
    'pdet_categories': "หมวดหมู่",
    'pdet_addProduct': "เพิ่มสินค้า",
    'pdet_searchProductsPlaceholder': "ค้นหาสินค้า...",
    'pdet_allCategories': "ทุกหมวดหมู่",
    'pdet_filterByCategory': "กรองตามหมวดหมู่",
    'pdet_resultCount': "{n} รายการ",
    'pdet_clearFilters': "ล้างตัวกรอง",
    'pdet_noProductsYet': "ยังไม่มีสินค้า",
    'pdet_addFirstProduct': "เพิ่มสินค้าแรกของคุณเพื่อเริ่มต้นใช้งาน",
    'pdet_noResultsFound': "ไม่พบผลลัพธ์",
    'pdet_tryAdjustingFilters': "ลองปรับคำค้นหาหรือตัวกรองของคุณ",
    'pdet_noPrice': "ไม่มีราคา",
    'pdet_rec': "แนะนำ",
    'pdet_notRec': "ไม่แนะนำ",
    'pdet_visible': "แสดงผล",
    'pdet_hidden': "ซ่อนอยู่",
    'pdet_editProduct': "แก้ไขสินค้า",
    'pdet_addNewProduct': "เพิ่มสินค้าใหม่",
    'pdet_update': "อัปเดต",
    'pdet_save': "บันทึก",
    'pdet_productName': "ชื่อสินค้า",
    'pdet_price': "ราคา",
    'pdet_categoryOptional': "หมวดหมู่ (ไม่บังคับ)",
    'pdet_changeImage': "เปลี่ยนรูปภาพ",
    'pdet_uploadImage': "อัปโหลดรูปภาพ",
    'pdet_recommendThisProduct': "แนะนำสินค้านี้",
    'pdet_productDetails': "รายละเอียดสินค้า",
    'pdet_imagePreview': "ตัวอย่างรูปภาพ",
    'pdet_categoryManagement': "จัดการหมวดหมู่",
    'pdet_categoryName': "ชื่อหมวดหมู่",
    'pdet_currentCategories': "หมวดหมู่ปัจจุบัน",
    'pdet_noCategoriesYet': "ยังไม่มีการเพิ่มหมวดหมู่",
    'pdet_addFirstCategory': "เพิ่มหมวดหมู่แรกของคุณด้านบน",
    'pdet_close': "ปิด",
    'pdet_saveChanges': "บันทึกการเปลี่ยนแปลง",
    'pdet_loading': "กำลังโหลด...",
    'pdet_pleaseWait': "กรุณารอสักครู่",
    'pdet_requiredField': "จำเป็นต้องกรอก",
    'pdet_pricePositiveError': "ราคาต้องเป็นค่าบวก",
    'pdet_maxTwoDecimalsError': "อนุญาตทศนิยมได้ไม่เกิน 2 ตำแหน่ง",
    'pdet_noCategory': "ไม่มีหมวดหมู่",
    'pdet_productGroupNameRequiredTitle': "จำเป็นต้องกรอกชื่อกลุ่มสินค้า",
    'pdet_productGroupNameRequiredBeforeAddText': "กรุณากรอกชื่อกลุ่มสินค้าก่อนเพิ่มสินค้า",
    'pdet_duplicateCategoryTitle': "หมวดหมู่ซ้ำ",
    'pdet_duplicateCategoryText': "หมวดหมู่ \"{name}\" มีอยู่แล้ว",
    'pdet_cannotRemoveCategoryTitle': "ไม่สามารถลบหมวดหมู่ได้",
    'pdet_cannotRemoveCategoryText': "หมวดหมู่นี้ถูกใช้งานโดยสินค้าอย่างน้อยหนึ่งรายการ",
    'pdet_categoryNameRequiredTitle': "จำเป็นต้องกรอกชื่อหมวดหมู่",
    'pdet_categoryNameRequiredText': "ชื่อหมวดหมู่ต้องไม่ว่างเปล่า",
    'pdet_deleteProductTitle': "ลบสินค้า",
    'pdet_deleteProductText': "คุณแน่ใจหรือไม่ว่าต้องการลบสินค้านี้ การดำเนินการนี้ไม่สามารถย้อนกลับได้",
    'pdet_productDeletedSuccess': "ลบสินค้าเรียบร้อยแล้ว",
    'pdet_reprocessProductTitle': "ประมวลผลสินค้าใหม่",
    'pdet_reprocessProductText': "คุณแน่ใจหรือไม่ว่าต้องการประมวลผลกลุ่มสินค้านี้ใหม่ การดำเนินการนี้ไม่สามารถย้อนกลับได้",
    'pdet_productReprocessSuccess': "ประมวลผลสินค้าใหม่เรียบร้อยแล้ว",
    'pdet_success': "สำเร็จ",
    'setpg_settingTitle': "ตั้งค่า",
    'setpg_generalSection': "ตั้งค่าทั่วไป",
    'setpg_generalSectionHint': "ส่วนนี้กำลังพัฒนา — จะเปิดให้ตั้งค่าเร็ว ๆ นี้",
    'setpg_comingSoon': "เร็ว ๆ นี้",
    'setpg_userColorCode': "รหัสสีผู้ใช้",
    'setpg_logo': "โลโก้",
    'setpg_selectImage': "เลือกรูปภาพ",
    'setpg_uploadLogoTitle': "คลิกเพื่ออัปโหลดโลโก้",
    'setpg_uploadLogoHint': "รองรับ PNG, JPG (แนะนำ 350×250 px)",
    'setpg_changeLogo': "เปลี่ยนรูป",
    'setpg_langThai': "ไทย",
    'setpg_langEnglish': "อังกฤษ",
    'setpg_defaultLanguageForMobileUsers': "ภาษาเริ่มต้นสำหรับผู้ใช้มือถือ",
    'setpg_english': "อังกฤษ",
    'setpg_save': "บันทึก",
    'setpg_cancel': "ยกเลิก",
    'setpg_snippetIconCropTitle': "ปรับรูปไอคอน Bubble",
    'setpg_snippetIconCropHint': "ลากเพื่อเลื่อน · สกรอลล์/นิ้วเพื่อซูม (ซูมออกให้เห็นทั้งภาพได้) — เฉพาะส่วนในวงกลมจะถูกใช้ พื้นที่ที่เลยขอบรูปจะกลายเป็นพื้นโปร่งใส",
    'setpg_snippetIconCropConfirm': "ใช้รูปนี้",
    'setpg_snippetSection': "ปรับแต่ง Snippet (Chat Widget)",
    'setpg_snippetNavbarColor': "สี Navbar",
    'setpg_snippetNavbarColorStart': "สี Navbar (เริ่ม)",
    'setpg_snippetNavbarColorEnd': "สี Navbar (จบ)",
    'setpg_snippetNavbarTextColor': "สีตัวอักษรหัวข้อ Navbar",
    'setpg_snippetFontColorHint': "ระบบไม่ได้ตรวจว่าสีตัวอักษรอ่านออกบนพื้นหลังที่เลือกหรือไม่ — ดูตัวอย่างทางขวาก่อนบันทึก",
    'setpg_snippetBubbleIcon': "ไอคอน Bubble",
    'setpg_snippetBubbleColor': "สีพื้น Bubble",
    'setpg_snippetText': "ข้อความ",
    'setpg_snippetNavbarTitle': "หัวข้อ Navbar",
    'setpg_snippetGreetingTh': "ข้อความทักทาย (ไทย)",
    'setpg_snippetGreetingEn': "ข้อความทักทาย (อังกฤษ)",
    'setpg_snippetDefaultLanguage': "ภาษาเริ่มต้น",
    'setpg_snippetGreetingUserTh': "ข้อความทักทาย (ล็อกอิน, ไทย)",
    'setpg_snippetGreetingUserEn': "ข้อความทักทาย (ล็อกอิน, อังกฤษ)",
    'setpg_snippetGreetingUserHint': "ใช้ {'{'}name{'}'} แทนชื่อผู้ใช้ เช่น สวัสดีคุณ {'{'}name{'}'}",
    'setpg_snippetSuggestionKeywords': "เมนูบริการของเรา",
    'setpg_snippetSuggestionKeywordsTh': "คำแนะนำบริการ (ไทย)",
    'setpg_snippetSuggestionKeywordsEn': "คำแนะนำบริการ (อังกฤษ)",
    'setpg_snippetSuggestionKeywordsHint': "พิมพ์แล้วกด Enter เพื่อเพิ่ม · เว้นว่าง = ใช้ค่าเริ่มต้น",
    'setpg_snippetChipColor': "สี Chip",
    'setpg_snippetShowLogin': "แสดงปุ่ม Login ใน widget",
    'setpg_snippetShowTranslate': "แสดงปุ่มแปลภาษาใน widget",
    'setpg_snippetShowHistory': "แสดงแถบประวัติแชทใน widget",
    'setpg_snippetShowMic': "แสดงปุ่มไมโครโฟน (พูดเพื่อพิมพ์) ใน widget",
    'setpg_snippetWelcomeSection': "ข้อความหน้าต้อนรับใน Widget",
    'setpg_snippetQuickChips': "คำถามแนะนำ (Quick Chips)",
    'setpg_snippetWelcomeTaglineTh': "หัวข้อต้อนรับ (ไทย)",
    'setpg_snippetWelcomeTaglineEn': "หัวข้อต้อนรับ (อังกฤษ)",
    'setpg_snippetWelcomeSubtitle1Th': "คำบรรยายบรรทัดที่ 1 (ไทย)",
    'setpg_snippetWelcomeSubtitle1En': "คำบรรยายบรรทัดที่ 1 (อังกฤษ)",
    'setpg_snippetWelcomeSubtitle2Th': "คำบรรยายบรรทัดที่ 2 (ไทย)",
    'setpg_snippetWelcomeSubtitle2En': "คำบรรยายบรรทัดที่ 2 (อังกฤษ)",
    'setpg_snippetWelcomeBetaTh': "ข้อความ Beta (ไทย)",
    'setpg_snippetWelcomeBetaEn': "ข้อความ Beta (อังกฤษ)",
    'setpg_snippetQuickChipsTh': "คำถามแนะนำ (ไทย)",
    'setpg_snippetQuickChipsEn': "คำถามแนะนำ (อังกฤษ)",
    'setpg_snippetPreview': "ตัวอย่าง (Preview)",
    'setpg_snippetPreviewChip1': "คำถามแนะนำ 1",
    'setpg_snippetPreviewChip2': "คำถามแนะนำ 2",
    'setpg_snippetSaved': "บันทึกการตั้งค่า Snippet เรียบร้อยแล้ว",
    'setpg_snippetReset': "รีเซ็ตเป็นค่าเริ่มต้น",
    'setpg_snippetFullSection': "ปรับแต่ง Snippet เต็มจอ (Chat Widget เต็มจอ)",
    'setpg_snippetFullScopeHint': "การตั้งค่านี้มีผลเฉพาะ widget เต็มจอ (FullV2) ที่ฝังบนเว็บไซต์ — ไม่กระทบ widget ตัวเล็กและหน้าแชทเต็มจอในระบบ",
    'setpg_snippetShowUpload': "แสดงปุ่มแนบไฟล์/รูปใน widget",
    'setpg_snippetShowUploadHint': "ปิดแล้วปุ่มแนบเอกสารและแนบรูปจะถูกซ่อนทั้งคู่ แม้โมเดลที่ใช้จะรองรับการอัปโหลด",
    'wdt_dirtyStructureMessage': "มีการเปลี่ยนแปลงโครงสร้าง — กรุณาบันทึกเพื่อให้การเปลี่ยนแปลงมีผล",
    'wdt_cancel': "ยกเลิก",
    'wdt_save': "บันทึก",
    'wdt_noWorkgroupForCompany': "ยังไม่มี Workgroup สำหรับ Company นี้",
    'wdt_saveFailed': "บันทึกไม่สำเร็จ",
    'wdtn_addChild': "เพิ่มรายการย่อย",
    'wdtn_edit': "แก้ไข",
    'wdtn_delete': "ลบ",
        'calpg_today': "วันนี้",
    'calpg_week': "สัปดาห์",
    'calpg_month': "เดือน",
    'calpg_scheduleName': "ชื่อตารางนัดหมาย",
    'calpg_enterYourScheduleName': "กรอกชื่อตารางนัดหมายของคุณ",
    'calpg_startDate': "วันที่เริ่มต้น",
    'calpg_cancel': "ยกเลิก",
    'calpg_ok': "ตกลง",
    'calpg_endDate': "วันที่สิ้นสุด",
    'calpg_close': "ปิด",
    'calpg_save': "บันทึก",
    'calpg_updateCalendarEvent': "แก้ไขกำหนดการปฏิทิน",
    'calpg_update': "อัปเดต",
    'calpg_pleaseAddScheduleInformation': "กรุณาเพิ่มข้อมูลตารางนัดหมาย",
    'calpg_confirmDeleteData': "คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูลนี้?",
    'pgnd_hintClearMemory': ":clearmemory (ล้างความจำระยะสั้น)",
    'pgnd_hintMemory': ":memory (แสดงความจำระยะสั้น)",
    'pgnd_hintLastMemory': ":lastmemory (แสดงความจำล่าสุดของบทสนทนาก่อนหน้า)",
    'pgnd_parameters': "พารามิเตอร์",
    'pgnd_timeDelayModelA': "เวลาหน่วงของโมเดล A",
    'pgnd_timeDelayModelB': "เวลาหน่วงของโมเดล B",
    'pgnd_logModelA': "บันทึกของโมเดล A",
    'pgnd_expandLogModelA': "ขยายบันทึกของโมเดล A",
    'pgnd_collapseLogModelA': "ย่อบันทึกของโมเดล A",
    'pgnd_systemMessage': "ข้อความระบบ",
    'pgnd_knowledge': "ความรู้",
    'pgnd_sqlQuery': "คำสั่ง SQL",
    'pgnd_sqlQueryResult': "ผลลัพธ์คำสั่ง SQL",
    'pgnd_intentFlow': "โฟลว์อินเทนต์",
    'pgnd_memory': "หน่วยความจำ",
    'pgnd_llmsModel': "โมเดล LLM",
    'pgnd_modelIdLabel': "รหัสโมเดล",
    'pgnd_modelNameLabel': "ชื่อโมเดล",
    'pgnd_providerLabel': "ผู้ให้บริการ",
    'pgnd_modelLabel': "โมเดล",
    'pgnd_systemMessageNoSpace': "ข้อความระบบ",
    'pgnd_knowledgeDocuments': "เอกสารความรู้",
    'pgnd_extensionLabel': "ส่วนขยาย",
    'pgnd_descriptionLabel': "คำอธิบาย",
    'pgnd_genderLabel': "เพศ",
    'pgnd_topNChunksLabel': "จำนวนชิ้นข้อมูลสูงสุด (TopN_Chunks)",
    'pgnd_internetLabel': "อินเทอร์เน็ต",
    'pgnd_feedbackLabel': "ความคิดเห็น",
    'pgnd_historyCountLabel': "จำนวนประวัติการสนทนา",
    'pgnd_historyMinuteLabel': "ระยะเวลาประวัติการสนทนา (นาที)",
    'pgnd_temperatureLabel': "Temperature",
    'pgnd_topPLabel': "Top P (ค่าความน่าจะเป็นสะสม)",
    'pgnd_frequencyPenaltyLabel': "ค่าปรับความถี่ (Frequency_Penalty)",
    'pgnd_presencePenaltyLabel': "ค่าปรับการปรากฏ (Presence_Penalty)",
    'pgnd_stopSequenceLabel': "ลำดับหยุด (Stop_Sequence)",
    'pgnd_maxTokensResponseLabel': "จำนวนโทเค็นสูงสุดของคำตอบ",
    'pgnd_isStreamLabel': "การสตรีมข้อมูล (IsStream)",
    'pgnd_endpointLabel': "เอนด์พอยต์",
    'pgnd_vectorCosine': "Vector Cosine",
    'pgnd_privateMemory': "หน่วยความจำส่วนตัว",
    'pgnd_logModelB': "บันทึกของโมเดล B",
    'pgnd_expandLogModelB': "ขยายบันทึกของโมเดล B",
    'pgnd_collapseLogModelB': "ย่อบันทึกของโมเดล B",
    'pgnd_rename': "เปลี่ยนชื่อ",
    'pgnd_deleteChat': "ลบแชท",
    'pgnd_modelA': "โมเดล A",
    'pgnd_modelB': "โมเดล B",
    'pgnd_modelName': "ชื่อโมเดล",
    'pgnd_selectForCompareYourModel': "เลือกเพื่อเปรียบเทียบโมเดลของคุณ",
    'pgnd_create': "สร้าง",
    'pgnd_edit': "แก้ไข",
    'pgnd_save': "บันทึก",
    'pgnd_clearModel': "ล้างโมเดล",
    'pgnd_configurationA': "การตั้งค่า A",
    'pgnd_userId': "รหัสผู้ใช้",
    'pgnd_promptTemplate': "เทมเพลตพรอมต์",
    'pgnd_temperature': "Temperature*",
    'pgnd_temperatureHint': "ควบคุมความสุ่ม: 0 = เน้นความแม่นยำ, 1 = เน้นความคิดสร้างสรรค์",
    'pgnd_topP': "Top P*",
    'pgnd_topPHint': "พารามิเตอร์การสุ่มแบบ Nucleus Sampling",
    'pgnd_frequencyPenalty': "Frequency Penalty",
    'pgnd_frequencyPenaltyHint': "ลดการซ้ำของคำที่ปรากฏบ่อย",
    'pgnd_presencePenalty': "Presence Penalty",
    'pgnd_presencePenaltyHint': "ส่งเสริมหัวข้อและแนวคิดใหม่ๆ",
    'pgnd_you': "คุณ",
    'pgnd_findingAnswer': "กำลังค้นหาคำตอบ ...",
    'pgnd_configurationB': "การตั้งค่า B",
    'pgnd_messageInputPlaceholder': "พิมพ์ข้อความของคุณที่นี่... (Shift + Enter เพื่อขึ้นบรรทัดใหม่)",
    'pgnd_sendMessage': "ส่งข้อความ",
    'pgnd_stopGeneration': "หยุดการสร้างคำตอบ",
    'pgnd_clearConversation': "ล้างบทสนทนา",
    'pgnd_aiDisclaimer': "AI อาจเกิดข้อผิดพลาดได้ กรุณาตรวจสอบคำตอบอีกครั้ง",
    'rut_userReportManagement': "การจัดการรายงานผู้ใช้งาน",
    'rut_dateRange': "ช่วงวันที่",
    'rut_startDate': "วันที่เริ่มต้น",
    'rut_selectStartDateForReport': "เลือกวันที่เริ่มต้นสำหรับรายงาน",
    'rut_endDate': "วันที่สิ้นสุด",
    'rut_selectEndDateForReport': "เลือกวันที่สิ้นสุดสำหรับรายงาน",
    'rut_search': "ค้นหา",
    'rut_top3Users': "ผู้ใช้งาน 3 อันดับแรก",
    'rut_questionsCount': "{n} คำถาม",
    'rut_userReportDataRecords': "ข้อมูลรายงานผู้ใช้งาน ({n} รายการ)",
    'rut_loadingPleaseWait': "กำลังโหลด กรุณารอสักครู่...",
    'rut_userId': "รหัสผู้ใช้",
    'rut_channelHeader': "ช่องทาง",
    'rut_hideTestChannelLabel': "ซ่อนข้อมูลทดสอบ",
    'rut_hideTestChannelOn': "เปิด",
    'rut_hideTestChannelOff': "ปิด",
    'rut_unknownChannel': "อื่น ๆ (Traffic จริง ไม่แยกช่องทางย่อย)",
    // BUG3 fix: ตัวกรอง/ป้ายชื่อ ช่องทาง-หน้า (PageName) ของรายงานผู้ใช้
    'rut_channelFilterLabel': "ช่องทาง / หน้า",
    'rut_channelAll': "ทั้งหมด",
    'rut_channelSnippet': "Snippet",
    'rut_channelExternalAPI': "External API",
    'rut_channelChatPlayground': "แชท เพลย์กราวด์",
    'rut_channelDualChatPlayground': "แชท เพลย์กราวด์คู่",
    'rut_channelValidation': "การตรวจสอบ / Test Runner",
    'rut_channelOther': "อื่น ๆ",
    'rut_totalQuestions': "จำนวนคำถามทั้งหมด",
    'rut_pleaseFillRequiredFields': "กรุณากรอกข้อมูลในช่องที่จำเป็น",
    'ruu_downloadReport': "ดาวน์โหลดรายงาน",
    'ruu_userUsageReportManagement': "จัดการรายงานการใช้งานของผู้ใช้",
    'ruu_dateRange': "ช่วงวันที่",
    'ruu_startDate': "วันที่เริ่มต้น",
    'ruu_selectStartDateForReport': "เลือกวันที่เริ่มต้นสำหรับรายงาน",
    'ruu_endDate': "วันที่สิ้นสุด",
    'ruu_selectEndDateForReport': "เลือกวันที่สิ้นสุดสำหรับรายงาน",
    'ruu_reportStatistics': "สถิติรายงาน",
    'ruu_search': "ค้นหา",
    'ruu_userUsageDataRecords': "ข้อมูลการใช้งานของผู้ใช้ ({n} รายการ)",
    'ruu_loading': "กำลังโหลด...",
    'ruu_pleaseWait': "กรุณารอสักครู่",
    'ruu_pleaseFillRequiredFields': "กรุณากรอกข้อมูลในช่องที่จำเป็น",
    'ruu_userId': "รหัสผู้ใช้",
    'ruu_channelHeader': "ช่องทาง",
    'ruu_hideTestChannelLabel': "ซ่อนข้อมูลทดสอบ",
    'ruu_hideTestChannelOn': "เปิด",
    'ruu_hideTestChannelOff': "ปิด",
    'ruu_unknownChannel': "อื่น ๆ (Traffic จริง ไม่แยกช่องทางย่อย)",
    // BUG3 fix: ตัวกรอง/ป้ายชื่อ ช่องทาง-หน้า (PageName) ของรายงานการใช้งานผู้ใช้
    'ruu_channelFilterLabel': "ช่องทาง / หน้า",
    'ruu_channelAll': "ทั้งหมด",
    'ruu_channelSnippet': "Snippet",
    'ruu_channelExternalAPI': "External API",
    'ruu_channelChatPlayground': "แชท เพลย์กราวด์",
    'ruu_channelDualChatPlayground': "แชท เพลย์กราวด์คู่",
    'ruu_channelValidation': "การตรวจสอบ / Test Runner",
    'ruu_channelOther': "อื่น ๆ",
    'ruu_totalQuestions': "จำนวนคำถามทั้งหมด",
    'ruu_totalTokens': "โทเค็นทั้งหมด",
    'ruu_imageGeneration': "การสร้างภาพ",
    'ruu_cachedTokens': "โทเค็นแคช",
    'ruu_reasoningTokens': "โทเค็นการให้เหตุผล",
    'saprof_required': "จำเป็นต้องกรอก",
    'saprof_thaiId': "ไทยดี",
    'saprof_dgaDigitalId': "DGA Digital ID",
    'saprof_thaId': "ThaID",
    'saprof_breadcrumbSuperAdmin': "ผู้ดูแลระบบสูงสุด",
    'saprof_breadcrumbProfile': "โปรไฟล์",
    'saprof_pleaseFillCorrectFormat': "กรุณากรอกข้อมูลให้ถูกต้องตามรูปแบบ",
    'sarnm_emptyValueDash': "—",
    'sec_addToken': "เพิ่มโทเค็น",
    'sec_loadingPleaseWait': "กำลังโหลด... กรุณารอสักครู่",
    'sec_copiedIndicator': "คัดลอกแล้ว! ✓",
    'sec_statusActive': "เปิดใช้งาน",
    'sec_statusExpired': "หมดอายุ",
    'sec_updatedOn': "อัปเดตเมื่อ {date}",
    'sec_parameters': "พารามิเตอร์",
    'sec_request': "คำขอ",
    'sec_response': "การตอบกลับ",
    'sec_codeExamples': "ตัวอย่างโค้ด",
    'sec_responseExample': "ตัวอย่างการตอบกลับ",
    'sec_apiKeyDialogTitle': "API Key",
    'sec_apiKeyDialogSubtitle': "โทเค็นสำหรับเข้าถึงข้อมูลอย่างปลอดภัยของคุณ",
    'sec_apiKeyUsageHintPrefix': "ใช้คีย์นี้ในแอปพลิเคชันของคุณโดยส่งผ่านพารามิเตอร์",
    'sec_apiKeyUsageHintSuffix': "พารามิเตอร์",
    'sec_yourApiKey': "API Key ของคุณ",
    'sec_copyToClipboard': "คัดลอกไปยังคลิปบอร์ด",
    'sec_gotIt': "เข้าใจแล้ว",
    'sec_createNewTokenTitle': "สร้างโทเค็นใหม่",
    'sec_renewTokenTitle': "ต่ออายุโทเค็น",
    'sec_createNewTokenSubtitle': "สร้างโทเค็นสำหรับเข้าถึง API อย่างปลอดภัยให้กับแอปพลิเคชันของคุณ",
    'sec_renewTokenSubtitle': "อัปเดตวันหมดอายุและการตั้งค่าของโทเค็นที่มีอยู่",
    'sec_basicInformation': "ข้อมูลพื้นฐาน",
    'sec_tokenName': "ชื่อโทเค็น",
    'sec_enterTokenName': "กรอกชื่อโทเค็น",
    'sec_emailAddress': "ที่อยู่อีเมล",
    'sec_enterEmailAddress': "กรอกที่อยู่อีเมล",
    'sec_currentApiKey': "API Key ปัจจุบัน",
    'sec_expirationSettings': "การตั้งค่าวันหมดอายุ",
    'sec_presetDuration': "ระยะเวลาที่กำหนดไว้",
    'sec_presetDurationDescription': "เลือกจากระยะเวลาที่ใช้บ่อย",
    'sec_customDate': "กำหนดวันที่เอง",
    'sec_customDateDescription': "กำหนดวันหมดอายุที่ต้องการ",
    'sec_selectDate': "เลือกวันที่",
    'sec_modelConfiguration': "การตั้งค่าโมเดล",
    'sec_modelDisplay': "โมเดลที่แสดง",
    'sec_selectModel': "เลือกโมเดล",
    'sec_modelGroup': "กลุ่มโมเดล",
    'sec_selectGroup': "เลือกกลุ่ม",
    'sec_cancel': "ยกเลิก",
    'sec_createTokenAction': "สร้างโทเค็น",
    'sec_updateTokenAction': "อัปเดตโทเค็น",
    'sec_revokeTokenTitle': "เพิกถอนโทเค็น",
    'sec_revokeTokenSubtitle': "การลบไม่สามารถย้อนกลับได้",
    'sec_revokeWarningPrefix': "รายการ",
    'sec_revokeWarningApiKeyLabel': "API Key",
    'sec_revokeWarningSuffix': "จะถูกลบอย่างถาวรและไม่สามารถใช้เรียก API ได้อีกต่อไป",
    'sec_tokenNameLabel': "ชื่อโทเค็น:",
    'sec_keepToken': "เก็บโทเค็นไว้",
    'sec_revokeTokenAction': "เพิกถอนโทเค็น",
    'sec_loadingEllipsis': "กำลังโหลด...",
    'sec_headerKey': "คีย์",
    'sec_headerDescription': "คำอธิบาย",
    'sec_headerType': "ประเภท",
    'sec_headerExample': "ตัวอย่าง",
    'sec_headerNo': "ลำดับ",
    'sec_headerTokenName': "ชื่อโทเค็น",
    'sec_headerEmail': "อีเมล",
    'sec_headerEndDate': "วันที่สิ้นสุด",
    'sec_headerToken': "โทเค็น",
    'sec_headerStatus': "สถานะ",
    'sec_headerActions': "การดำเนินการ",
    'sec_menuRenew': "ต่ออายุ",
    'sec_menuRevoke': "เพิกถอน",
    'setuppg_configuration': "การตั้งค่า",
    'setuppg_gptConfiguration': "การตั้งค่า GPT",
    'setuppg_azureOpenAIEndpoints': "Azure OpenAI Endpoints",
    'setuppg_priority': "ลำดับความสำคัญ",
    'setuppg_azureOpenAIUrl': "URL Azure OpenAI",
    'setuppg_apiKey': "API Key",
    'setuppg_addEndpoint': "เพิ่มเอนด์พอยต์",
    'setuppg_embeddingConfiguration': "การตั้งค่า Embedding",
    'setuppg_embeddingUrl': "URL Embedding",
    'setuppg_embeddingApiKey': "Embedding API Key",
    'setuppg_embeddingApiVersion': "Embedding API Version",
    'setuppg_embeddingType': "ประเภท Embedding",
    'setuppg_gptModeConfiguration': "การตั้งค่าโหมด GPT",
    'setuppg_gptMode': "โหมด GPT",
    'setuppg_priorityMode': "ลำดับความสำคัญ",
    'setuppg_fastMode': "โหมดเร็ว",
    'setuppg_repeatTimeMinutes': "เวลาที่ทำซ้ำ (นาที)*",
    'setuppg_modelRequired': "โมเดล*",
    'setuppg_testOfQuestionsRequired': "คำถามทดสอบ*",
    'setuppg_storageConfiguration': "การกำหนดค่าพื้นที่จัดเก็บ",
    'setuppg_azureBlobStorage': "Azure Blob Storage",
    'setuppg_storageConnection': "การเชื่อมต่อ Storage",
    'setuppg_containerName': "ชื่อ Container",
    'setuppg_pdfVectorStorage': "PDF Vector Storage",
    'setuppg_imageStorage': "พื้นที่จัดเก็บรูปภาพ",
    'setuppg_speechDocumentStorage': "พื้นที่จัดเก็บเอกสารเสียง",
    'setuppg_quickReplyIconStorage': "พื้นที่จัดเก็บไอคอน Quick Reply",
    'setuppg_languageServices': "บริการด้านภาษา",
    'setuppg_translator': "ตัวแปลภาษา",
    'setuppg_languageService': "บริการภาษา",
    'setuppg_speechToText': "แปลงเสียงเป็นข้อความ",
    'setuppg_endpoint': "เอนด์พอยต์",
    'setuppg_location': "ตำแหน่งที่ตั้ง",
    'setuppg_languageEndpoint': "เอนด์พอยต์ภาษา",
    'setuppg_languageKey': "Language Key",
    'setuppg_speechToTextKey': "Speech to Text Key",
    'setuppg_speechToTextRegion': "ภูมิภาค Speech to Text",
    'setuppg_speechToTextLanguage': "ภาษา Speech to Text",
    'setuppg_ffmpegPath': "พาธ FFmpeg",
    'setuppg_ffmpegLocalPath': "พาธ FFmpeg ภายในเครื่อง",
    'setuppg_mailConfig': "การกำหนดค่าอีเมล",
    'setuppg_emailHost': "โฮสต์อีเมล",
    'setuppg_hostName': "ชื่อโฮสต์",
    'setuppg_password': "รหัสผ่าน",
    'setuppg_systemSettings': "การตั้งค่าระบบ",
    'setuppg_autoStream': "สตรีมอัตโนมัติ",
    'setuppg_enabled': "เปิดใช้งาน",
    'setuppg_disabled': "ปิดใช้งาน",
    'setuppg_anonymousMode': "โหมดไม่ระบุตัวตน",
    'setuppg_on': "เปิด",
    'setuppg_off': "ปิด",
    'setuppg_timeDelayMs': "เวลาหน่วง (มิลลิวินาที)",
    'setuppg_characterLimit': "จำนวนตัวอักษรสูงสุด",
    'setuppg_forceDisableGpt': "บังคับปิดใช้งาน GPT",
    'setuppg_autoDisableGpt': "ปิดใช้งาน GPT อัตโนมัติ",
    'setuppg_gptAutoDisableDatePeriod': "ช่วงวันที่ปิดใช้งาน GPT อัตโนมัติ",
    'setuppg_gptAutoDisableMessage': "ข้อความแจ้งเตือนเมื่อปิดใช้งาน GPT อัตโนมัติ",
    'setuppg_gptAutoDisablePricingUsd': "วงเงินปิดใช้งาน GPT อัตโนมัติ (USD)",
    'setuppg_otherConfig': "การกำหนดค่าอื่นๆ",
    'setuppg_googleConfig': "การกำหนดค่า Google",
    'setuppg_anthropicConfig': "การตั้งค่า Anthropic",
    'setuppg_projectId': "รหัสโปรเจกต์ (Project ID)",
    'setuppg_locationId': "รหัสตำแหน่งที่ตั้ง (Location ID)",
    'setuppg_jsonCredential': "JSON Credential",
    'setuppg_anthropicApiKey': "Anthropic APIKey",
    'setuppg_singleSignOn': "การเข้าสู่ระบบครั้งเดียว (Single Sign-On)",
    'setuppg_singleSignOnProviderStatus': "การเข้าสู่ระบบครั้งเดียว (Single Sign-On) {provider}: {status}",
    'setuppg_open': "เปิด",
    'setuppg_close': "ปิด",
    'setuppg_singleSignOnProviderChatStatus': "Single Sign-On {provider} ในแชท: {status}",
    'setuppg_instance': "อินสแตนซ์ (Instance)",
    'setuppg_issuerAuthorityUrl': "ผู้ออก (Issuer Authority URL)",
    'setuppg_domain': "โดเมน",
    'setuppg_tenantId': "Tenant ID",
    'setuppg_clientId': "Client ID",
    'setuppg_redirectUrl': "URL เปลี่ยนเส้นทาง (Redirect URL)",
    'setuppg_callbackPath': "เส้นทาง Callback (Callback Path)",
    'setuppg_clientSecret': "Client Secret",
    'setuppg_scope': "ขอบเขต (Scope)",
    'setuppg_apiScope': "ขอบเขต API (API Scope)",
    'setuppg_urlJwks': "URL JWKS",
    'setuppg_urlConfig': "URL Config",
    'setuppg_addDgaDigitalId': "เพิ่ม DGA Digital ID",
    'setuppg_microsoftEntraIdGroupConfiguration': "การกำหนดค่ากลุ่ม Microsoft Entra ID",
    'setuppg_syncSsoGroups': "ซิงค์กลุ่ม SSO",
    'setuppg_savingConfiguration': "กำลังบันทึกการกำหนดค่า...",
    'setuppg_azureOpenAIUrlColumn': "AzureOpenAIUrl",
    'setuppg_responseTimeMilliseconds': "เวลาตอบสนอง (มิลลิวินาที)",
    'setuppg_answers': "คำตอบ",
    'setuppg_applyChange': "นำการเปลี่ยนแปลงไปใช้",
    'setuppg_failedToReadFile': "อ่านไฟล์ไม่สำเร็จ!",
        'flowpg_exportFlow': "ส่งออกโฟลว์",
    'flowpg_importFlow': "นำเข้าโฟลว์",
    'flowpg_duplicateSelected': "ทำสำเนาที่เลือก",
    'flowpg_copySelected': "คัดลอกที่เลือก",
    'flowpg_pasteAction': "วาง",
    'flowpg_deleteSelected': "ลบที่เลือก",
    'flowpg_clearFlow': "ล้างโฟลว์",
    'flowpg_saveButtonText': "บันทึก",
    'flowpg_viewModeText': "โหมดดูอย่างเดียว",
    'flowpg_nodePropertiesTitle': "คุณสมบัติโหนด",
    'flowpg_streamResponseTitle': "สตรีมการตอบกลับ",
    'flowpg_jsonResponseTitle': "การตอบกลับ JSON",
    'flowpg_returnStructuredJsonFormat': "ส่งคืนผลลัพธ์เป็นรูปแบบ JSON ที่มีโครงสร้าง",
    'flowpg_memorySettingsTitle': "การตั้งค่าหน่วยความจำ",
    'flowpg_configureConversationMemoryContext': "กำหนดค่าหน่วยความจำและบริบทของการสนทนา",
    'flowpg_conversationMemoryLabel': "หน่วยความจำบทสนทนา",
    'flowpg_memoryTypesLabel': "ประเภทหน่วยความจำ",
    'flowpg_longTermMemoryTitle': "หน่วยความจำระยะยาว",
    'flowpg_multiTurnInputConfigLabel': "การตั้งค่าอินพุตแบบหลายรอบ",
    'flowpg_enableMultiTurnInputTitle': "เปิดใช้งานอินพุตหลายรอบ",
    'flowpg_allowContinuousConversation': "อนุญาตให้สนทนาต่อเนื่อง",
    'flowpg_aiParametersTitle': "พารามิเตอร์ AI",
    'flowpg_fineTuneModelBehaviorOutput': "ปรับแต่งพฤติกรรมและผลลัพธ์ของโมเดลอย่างละเอียด",
    'flowpg_cacheSettingsTitle': "การตั้งค่าแคช",
    'flowpg_configureResponseCachingPerformance': "กำหนดค่าการแคชการตอบกลับเพื่อประสิทธิภาพ",
    'flowpg_enableCacheTitle': "เปิดใช้งานแคช",
    'flowpg_cacheResponsesReduceLlmCalls': "แคชการตอบกลับเพื่อลดการเรียกใช้ LLM",
    'flowpg_semanticMatchTitle': "การจับคู่เชิงความหมาย",
    'flowpg_matchSimilarQuestionsUsingAi': "จับคู่คำถามที่คล้ายกันโดยใช้ AI",
    'flowpg_lineConfigurationTitle': "การตั้งค่า LINE",
    'flowpg_showNameTitle': "แสดงชื่อ",
    'flowpg_loadingIndicatorTitle': "ตัวแสดงสถานะกำลังโหลด",
    'flowpg_greetingMessageFirstInteraction': "ข้อความทักทายสำหรับการโต้ตอบครั้งแรก",
    'flowpg_systemPromptTitle': "System Prompt (คำสั่งระบบ)",
    'flowpg_defineAiBehaviorPersonality': "กำหนดพฤติกรรมและบุคลิกของ AI",
    'flowpg_timeContextTitle': "บริบทเวลา",
    'flowpg_enableTimeAwarenessAiResponses': "เปิดใช้งานการรับรู้เวลาสำหรับการตอบกลับของ AI",
    'flowpg_addTransactionIdToPromptTitle': "เพิ่มรหัสธุรกรรมลงในพรอมต์",
    'flowpg_includeTransactionIdentifierAiContext': "รวมรหัสระบุธุรกรรมไว้ในบริบทของ AI",
    'flowpg_closeButton': "ปิด",
    'flowpg_tipDefineToneStyle': "กำหนดโทนเสียงและรูปแบบการสื่อสาร",
    'flowpg_tipSpecifyUnknownHandling': "ระบุวิธีจัดการเมื่อไม่ทราบข้อมูล",
    'flowpg_authorizationPlaceholder': "Authorization (การอนุญาต)",
    'lmsg_clickToCopy': "คลิกเพื่อคัดลอก",
    'lmsg_nexaKnowledgeGraphWaterfall': "ความรู้ NEXA (กราฟ / วอเตอร์ฟอล)",
    'lmsg_noNexaGraphContext': "ไม่มีบริบทกราฟ / วอเตอร์ฟอล NEXA สำหรับรอบนี้",
    'lmsg_normalQuestion': "คำถามทั่วไป",
    'lmsg_chainQuestion': "คำถามแบบลูกโซ่",
    'lmsg_tokenUsage': "การใช้โทเค็น",
    'lmsg_chatLogOption': "บันทึกการสนทนา",
    'lmsg_rawLog': "บันทึกดิบ",
    'lmsg_sqlLog': "บันทึก SQL",
    'lmsg_intentLog': "บันทึกอินเทนต์",
    'lmsg_errorLog': "บันทึกข้อผิดพลาด",
    'lmsg_memoryDebugger': "ตัวดีบักหน่วยความจำ",
    'lmsg_flow': "โฟลว์",
    'lmsg_inputMessage': "ข้อความอินพุต",
    'lmsg_outputMessage': "ข้อความเอาต์พุต",
    'lmsg_logsId': "รหัสบันทึก",
    'lmsg_sessionIdHeader': "รหัสเซสชัน",
    'lmsg_userChannelHeader': "ช่องทางผู้ใช้",
    'lmsg_createDate': "วันที่สร้าง",
    'lmsg_responseTimeMs': "เวลาตอบสนอง (มิลลิวินาที)",
    'lmsg_copied': "คัดลอกแล้ว",
    'lmsg_copiedToClipboard': "คัดลอกไปยังคลิปบอร์ดแล้ว",
    'lmsg_pleaseSelectQuestionSetType': "กรุณาเลือกประเภทชุดคำถาม",
    'lmsg_nodeMessageInput': "ข้อความอินพุต",
    'lmsg_nodeIntentRouter': "อินเทนต์เราท์เตอร์",
    'lmsg_nodeAiModel': "โมเดล AI",
    'lmsg_nodeCache': "แคช",
    'lmsg_nodeAiModelProcessing': "การประมวลผลโมเดล AI",
    'lmsg_nodeInterestOptimizer': "ตัวเพิ่มประสิทธิภาพความสนใจ",
    'lmsg_nodeMessageOutput': "ข้อความเอาต์พุต",
    'lmsg_nodeApiKnowledge': "ความรู้จาก API",
    'lmsg_nodeDbIntegration': "การเชื่อมต่อฐานข้อมูล",
    'lmsg_nodeApiTrigger': "ทริกเกอร์ API",
    'lmsg_nodeContactAgent': "ติดต่อเจ้าหน้าที่",
    'lmsg_nodeLoanInterest': "ดอกเบี้ยเงินกู้",
    'lmsg_nodeDocuments': "เอกสาร",
    'lmsg_nodeVectorEmbedding': "การฝังเวกเตอร์",
    'lmsg_nodeSummaryDocumentsMemory': "หน่วยความจำสรุปเอกสาร",
    'lmsg_nodeKnowledgeGraph': "กราฟความรู้",
    'lmsg_nodeNexaWaterfall': "NEXA วอเตอร์ฟอล",
    'lmsg_nodeMcp': "MCP",
    'lmsg_nodeAdvancedRouter': "ตัวจัดเส้นทางขั้นสูง",
    'lmsg_failedToLoadMonitorData': "ไม่สามารถโหลดข้อมูลการตรวจสอบได้",
    'saCore_callbackPath': "CallbackPath",
    'saCore_clientSecret': "ClientSecret",
    'saCore_apiScope': "APIScope",
    'saCore_urlConfig': "URLConfig",
    'saCore_required': "จำเป็นต้องกรอก",
        'pgnd_allowPopupFullStream': "กรุณาอนุญาต popup เพื่อเปิด FullStream ใน tab ใหม่",
    'pgnd_errorOccurred': "เกิดข้อผิดพลาด",
    'pgnd_maxLengthCharError': "กรุณากรอกข้อมูลตัวอักษรไม่เกิน",
    'pgnd_enterNumberRange0_1': "กรุณาป้อนตัวเลขระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำแหน่ง",
        'FlowResponseFieldMode': "โหมดฟิลด์การตอบกลับ",
    'FlowResponseFields': "ฟิลด์การตอบกลับ",
    'FlowAddField': "เพิ่มฟิลด์",
    'FlowResponseFieldPath': "พาธของฟิลด์",
    'FlowApiTest': "ทดสอบ API",
    'FlowApiTestSubtitle': "ทดสอบการเรียก API เพื่อตรวจสอบการตอบกลับก่อนใช้งานจริง",
    'FlowUseTestMessage': "ใช้ข้อความทดสอบ",
    'FlowApiTestHowItWorksTitle': "วิธีการทำงาน",
    'FlowApiTestReplaceRule': "ระบบจะแทนที่ตัวแปรด้านล่างนี้ด้วยข้อความทดสอบที่คุณกำหนด",
    'FlowTestMessage': "ข้อความทดสอบ",
    'FlowTestMessagePlaceholder': "ระบุข้อความทดสอบ",
    'FlowTestApi': "ทดสอบ API",
    'FlowApiTestStatus': "สถานะ",
    'FlowApiTestResponseTime': "เวลาตอบสนอง",
    'FlowConfiguredResponseTitle': "การตอบกลับที่กำหนดค่าไว้",
    'FlowConfiguredResponseDescription': "ผลลัพธ์หลังผ่านการกรองฟิลด์ตามที่ตั้งค่าไว้",
    'FlowCollapseResponse': "ย่อการตอบกลับ",
    'FlowExpandResponse': "ขยายการตอบกลับ",
    'FlowCopyResponse': "คัดลอกการตอบกลับ",
    'FlowRawResponseTitle': "การตอบกลับดิบ",
    'FlowRawResponseDescription': "ข้อมูลต้นฉบับที่ได้รับจาก API โดยไม่ผ่านการกรอง",
    'FlowResponseFilterNone': "ไม่มี",
    'FlowResponseFilterInclude': "รวมเฉพาะฟิลด์ที่ระบุ",
    'FlowResponseFilterExclude': "ยกเว้นฟิลด์ที่ระบุ",
    'FlowApiUrlRequired': "กรุณาระบุ URL ของ API",
    'FlowApiTestSuccess': "ทดสอบ API สำเร็จ",
    'FlowApiTestFailed': "ทดสอบ API ไม่สำเร็จ",
    'FlowApiTestNoResponse': "ไม่มีข้อมูลตอบกลับ",
    'FlowCopyResponseSuccess': "คัดลอกการตอบกลับแล้ว",
    'FlowCopyResponseFailed': "คัดลอกการตอบกลับไม่สำเร็จ",
    'ConfirmDeletion': "ยืนยันการลบ",
    'Manage': "จัดการ",
    'Actions': "การดำเนินการ",
    'Type': "ประเภท",
    'SpecificText': "ข้อความจำเพาะ",
    'Upload': "อัปโหลด",
    'Action': "การดำเนินการ",
    'Error': "ข้อผิดพลาด",
    'default': "ค่าเริ่มต้น",
    'SystemUsageStat': "สถิติการใช้งานระบบ",
    'LoginUsersViaGov': "จำนวนผู้ใช้ที่เข้าสู่ระบบผ่านระบบยืนยันตัวตนภาครัฐ",
    'NonLoginUsersViaGov': "จำนวนผู้ใช้ที่ไม่ได้เข้าสู่ระบบผ่านระบบยืนยันตัวตนภาครัฐ",
    'TotalUsersViaGovLabel': "จำนวนผู้ใช้ทั้งหมดผ่านระบบยืนยันตัวตนภาครัฐ",
    'HumanAnswer': "คำตอบของมนุษย์",
    'records': "รายการ",
    'ImportDataIntegration': "นำเข้าข้อมูล Data Integration",
    'status': "สถานะ",
    'flowName': "ชื่อโฟลว์",
    'warningmaximumChatInput': "คุณกรอกข้อความเกินจำนวนตัวอักษรสูงสุดที่กำหนด",
    'Group': "กลุ่ม",
    'Label': "ป้ายชื่อ",
    'Message': "ข้อความ",
    'Rank': "อันดับ",
    'confirmDeletionAzureOpenAI': "ยืนยันการลบการตั้งค่า Azure OpenAI นี้หรือไม่",
    'modelType': "ประเภทโมเดล",
    'TenantId': "Tenant ID",
    'ClientId': "Client ID",
    'ClientSecret': "Client Secret",
    'setup': "ตั้งค่า",
    'Template': "เทมเพลต",
    'niframe_connectingToNexa': "กำลังเชื่อมต่อกับ NEXA...",
    'niframe_cannotOpenService': "ไม่สามารถเปิดบริการ NEXA ได้",
    'niframe_retry': "ลองใหม่",
    'niframe_iframeUrlNotSetYet': "ยังไม่ได้ตั้งค่า URL ของ iframe",
    'niframe_reload': "โหลดใหม่",
    'niframe_noPayloadInResponse': "ไม่มีข้อมูลในการตอบกลับ",
    'niframe_missingTokenOrBaseUrl': "ไม่พบ token หรือ baseUrl จากเซิร์ฟเวอร์",
    'niframe_getEmbedTokenFailed': "การดึง Embed Token ล้มเหลว",
    'npanel_nodes': "โหนด",
    'npanel_searchNodesPlaceholder': "ค้นหาโหนด...",
    'npanel_collapse': "ย่อ",
    'npanel_categoryInputOutput': "อินพุต/เอาต์พุต",
    'npanel_categoryAI': "AI",
    'npanel_categoryIntent': "อินเทนต์",
    'npanel_categoryKnowledge': "ความรู้",
    'npanel_categoryActions': "การดำเนินการ",
    'npanel_nodeMessageInput': "ข้อความขาเข้า",
    'npanel_nodeMessageInputDesc': "ข้อความจากผู้ใช้",
    'npanel_nodeResponse': "การตอบกลับ",
    'npanel_nodeResponseDesc': "ผลลัพธ์การตอบกลับของบอท",
    'npanel_nodeAIModel': "โมเดล AI",
    'npanel_nodeAIModelDesc': "ตัวประมวลผลโมเดลภาษา",
    'npanel_nodeIntentAIModel': "โมเดล AI ตรวจจับอินเทนต์",
    'npanel_nodeIntentAIModelDesc': "ตรวจจับอินเทนต์ด้วย AI",
    'npanel_nodeAdvancedRouter': "ตัวจัดเส้นทางขั้นสูง",
    'npanel_nodeAdvancedRouterDesc': "จัดเส้นทางอินเทนต์แบบหลายระดับ",
    'npanel_nodeIntentRouter': "เราท์เตอร์อินเทนต์",
    'npanel_nodeIntentRouterDesc': "จัดการอินเทนต์ที่ระบุ",
    'npanel_nodeSmartIntent': "สมาร์ทอินเทนต์",
    'npanel_nodeSmartIntentDesc': "ตัวจัดการอินเทนต์ที่เสริมด้วย AI พร้อมการตั้งค่า AI เฉพาะตัว",
    'npanel_nodeAPITrigger': "ทริกเกอร์ API",
    'npanel_nodeAPITriggerDesc': "เรียกใช้การทำงาน API ภายนอก",
    'npanel_nodeContactAgent': "ติดต่อเจ้าหน้าที่",
    'npanel_nodeContactAgentDesc': "โอนสายไปยังเจ้าหน้าที่",
    'npanel_nodeDocuments': "เอกสาร",
    'npanel_nodeDocumentsDesc': "การจัดการและค้นหาเอกสาร",
    'npanel_nodeKnowledgeGraph': "กราฟความรู้",
    'npanel_nodeKnowledgeGraphDesc': "ดึงบริบทจากกราฟ NEXA",
    'npanel_nodeWaterfallSearch': "ค้นหาแบบขั้นบันได",
    'npanel_nodeWaterfallSearchDesc': "ค้นหา NEXA แบบเป็นชั้น: หยุดที่ชั้นแรกที่พบผลลัพธ์",
    'npanel_nodeDatabaseIntegration': "การเชื่อมต่อฐานข้อมูล",
    'npanel_nodeDatabaseIntegrationDesc': "เชื่อมต่อกับฐานข้อมูลความรู้",
    'npanel_nodeAPIKnowledge': "ความรู้จาก API",
    'npanel_nodeAPIKnowledgeDesc': "ดึงข้อมูลความรู้จาก API ภายนอก",
    'npanel_nodeMCPServer': "เซิร์ฟเวอร์ MCP",
    'npanel_nodeMCPServerDesc': "เครื่องมือ Model Context Protocol สำหรับโมเดล AI",
    'npanel_nodeEmail': "อีเมล",
    'npanel_nodeEmailDesc': "ส่งอีเมลถึงผู้ใช้",
    'mmd_thinking': "กำลังคิด",
    'mmd_thinkingEllipsis': "กำลังคิด...",
    'mmd_codeCopiedToClipboard': "คัดลอกโค้ดไปยังคลิปบอร์ดแล้ว!",
    'mmd_failedToCopyCode': "คัดลอกโค้ดไม่สำเร็จ",
    'mmd_copyOperationFailed': "การคัดลอกล้มเหลว",
        'flist_version': "เวอร์ชัน",
    'flist_comment': "หมายเหตุ",
    'flist_date': "วันที่",
    'flist_createdBy': "สร้างโดย",
    'flist_name': "ชื่อ",
    'flist_createdDate': "วันที่สร้าง",
    'fnode_deleteNode': "ลบโหนด",
    'fnode_message': "ข้อความ",
    'fnode_userInput': "อินพุตจากผู้ใช้",
    'fnode_apiCall': "เรียก API",
    'fnode_externalService': "บริการภายนอก",
    'fnode_response': "การตอบกลับ",
    'fnode_botOutput': "ผลลัพธ์จากบอท",
    'fnode_aiModel': "โมเดล AI",
    'fnode_basePrompt': "พรอมต์พื้นฐาน",
    'fnode_intentAI': "AI วิเคราะห์อินเทนต์",
    'fnode_intentRouter': "เราท์เตอร์อินเทนต์",
    'fnode_newIntentGroup': "กลุ่มอินเทนต์ใหม่",
    'fnode_priority': "ลำดับความสำคัญ",
    'fnode_fallback': "ฟอลแบ็ก",
    'fnode_noIntentMatch': "ไม่พบอินเทนต์ที่ตรงกัน",
    'fnode_smartIntent': "สมาร์ทอินเทนต์",
    'fnode_newSmartIntentGroup': "กลุ่มสมาร์ทอินเทนต์ใหม่",
    'fnode_documentsKnowledge': "ฐานความรู้เอกสาร",
    'fnode_databaseIntegration': "การเชื่อมต่อฐานข้อมูล",
    'fnode_productsKnowledge': "ฐานความรู้สินค้า",
    'fnode_apiKnowledge': "ฐานความรู้จาก API",
    'fnode_databaseKnowledge': "ฐานความรู้ฐานข้อมูล",
    'fnode_if': "เงื่อนไข (If)",
    'fnode_logicCheck': "ตรวจสอบเงื่อนไข",
    'fnode_true': "จริง",
    'fnode_false': "เท็จ",
    'fnode_delay': "หน่วงเวลา",
    'fnode_seconds': "วินาที",
    'fnode_variableDelay': "หน่วงเวลาแบบตัวแปร",
    'fnode_timeWait': "รอตามเวลา",
    'fnode_switch': "สวิตช์",
    'fnode_multiPath': "หลายเส้นทาง",
    'fnode_defaultCase': "กรณีเริ่มต้น",
    'fnode_fallbackPath': "เส้นทางฟอลแบ็ก",
    'fnode_advancedRouter': "ตัวจัดเส้นทางขั้นสูง",
    'fnode_hierarchicalRouting': "การจัดเส้นทางแบบลำดับชั้น",
    'fnode_lowConfidenceOrNoMatch': "ความมั่นใจต่ำหรือไม่พบที่ตรงกัน",
    'fnode_webhook': "Webhook",
    'fnode_httpNotify': "แจ้งเตือนผ่าน HTTP",
    'fnode_action': "การดำเนินการ",
    'fnode_mailgun': "Mailgun",
    'fnode_smtp': "SMTP",
    'fnode_cc': "สำเนาถึง (CC)",
    'fnode_email': "อีเมล",
    'fnode_configureRecipient': "กำหนดค่าผู้รับ",
    'fnode_apiTrigger': "ทริกเกอร์ API",
    'fnode_externalAction': "การทำงานภายนอก",
    'fnode_contactAgent': "ติดต่อเจ้าหน้าที่",
    'fnode_toDisabledBot': "ไปยังบอทที่ปิดใช้งาน",
    'fnode_documents': "เอกสาร",
    'fnode_documentSearch': "ค้นหาเอกสาร",
    'fnode_mcp': "MCP",
    'fnode_notConfigured': "ยังไม่ได้ตั้งค่า",
    'fnode_knowledgeGraph': "กราฟความรู้",
    'fnode_citationReferences': "การอ้างอิงแหล่งที่มา",
    'fnode_waterfallSearch': "ค้นหาแบบขั้นบันได",
    'fnode_tieredNexa': "NEXA แบบหลายระดับ",
    'fnode_dbIntegration': "การเชื่อมต่อฐานข้อมูล",
    'fnode_knowledgeBase': "ฐานความรู้",
    'fnode_apiResponseKnowledge': "ฐานความรู้จากการตอบกลับ API",
    'fnode_products': "สินค้า",
    'fnode_productCatalog': "แคตตาล็อกสินค้า",
    'fnode_noModelSelected': "ยังไม่ได้เลือกโมเดล",
    'fnode_selectModel': "เลือกโมเดล",
    'fnode_noModel': "ไม่มีโมเดล",
    'fnode_fileAccess': "การเข้าถึงไฟล์",
    'fnode_unnamed': "ไม่มีชื่อ",
    'fnode_nexaRetrieval': "NEXA Retrieval",
    'fnode_graphSingular': "กราฟ",
    'fnode_graphsPlural': "กราฟ",
    'fnode_citationsOff': "ปิดการอ้างอิง",
    'fnode_citationsOn': "เปิดการอ้างอิง",
    'mm_additionalSettings': "การตั้งค่าเพิ่มเติม",
    'mm_adminOnly': "แอดมินเท่านั้น",
    'mm_allowUsersUploadImagesHint': "อนุญาตให้ผู้ใช้อัปโหลดรูปภาพเพื่อวิเคราะห์",
    'mm_availableTemplates': "เทมเพลตที่มีให้เลือก",
    'mm_baselineMinSimilarity': "ค่าความคล้ายคลึงขั้นต่ำของ Baseline",
    'mm_baselineMinSimilarityHint': "สำหรับโหมด baseline-vector-only (0-1)",
    'mm_baselineTopK': "Baseline Top K",
    'mm_baselineTopKHint': "สำหรับโหมด baseline-vector-only (1-100)",
    'mm_basicInformation': "ข้อมูลพื้นฐาน",
    'mm_bot': "บอท",
    'mm_briefDescriptionHint': "คำอธิบายโดยย่อว่าโมเดลนี้ทำหน้าที่อะไร",
    'mm_chooseAFlow': "เลือกโฟลว์...",
    'mm_chooseArtisticStyleHint': "เลือกสไตล์ทางศิลปะสำหรับภาพที่สร้างขึ้น",
    'mm_chooseImageStyle': "เลือกสไตล์ภาพ",
    'mm_chooseWorkflowIntegrationHint': "เลือกเวิร์กโฟลว์ที่จะเชื่อมต่อกับโมเดลนี้",
    'mm_close': "ปิด",
    'mm_configureAiImageParamsHint': "กำหนดค่าพารามิเตอร์การสร้างภาพด้วย AI",
    'mm_configureSystemMessageForYourAI': "กำหนดค่า System Message สำหรับ AI ของคุณ",
    'mm_configureWorkflowIntegrationHint': "กำหนดค่าการเชื่อมต่อเวิร์กโฟลว์สำหรับโมเดลนี้",
    'mm_controlModelVisibility': "ควบคุมการมองเห็นและความพร้อมใช้งานของโมเดลในทุกแพลตฟอร์ม",
    'mm_cosineSimilarity': "ค่าความคล้ายคลึงโคไซน์",
    'mm_createMode': "โหมดสร้างใหม่",
    'mm_database': "ฐานข้อมูล",
    'mm_defaultsMatchNexaRecommended': "ค่าเริ่มต้นที่แสดงตรงกับค่าที่ NEXA แนะนำ ควรคงไว้ตามเดิม เว้นแต่ต้องการปรับแต่งการค้นหาสำหรับโมเดลนี้โดยเฉพาะ",
    'mm_delete': "ลบ",
    'mm_describeModelPurpose': "อธิบายวัตถุประสงค์ของโมเดล",
    'mm_description': "คำอธิบาย",
    'mm_detection': "การตรวจจับ",
    'mm_displayLineNameInMonitorView': "แสดงชื่อ LINE ในหน้าจอติดตาม",
    'mm_documentName': "ชื่อเอกสาร",
    'mm_documents': "เอกสาร",
    'mm_draft': "แบบร่าง",
    'mm_draftUpper': "แบบร่าง",
    'mm_durationMin': "ระยะเวลา (นาที)",
    'mm_enableProgressiveTextGeneration': "เปิดใช้งานการสร้างข้อความแบบทยอยแสดงผล",
    'mm_enableTimeAwarenessHint': "เปิดใช้งานการรับรู้เวลาในการตอบกลับ",
    'mm_enterNumberBetween0And1': "กรุณาป้อนตัวเลขระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำแหน่ง",
    'mm_enterNumberBetween0And2': "กรุณาป้อนตัวเลขระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำแหน่ง",
    'mm_enterPromptWhenNoData': "กรอกข้อความที่จะใช้เมื่อไม่มีข้อมูล",
    'mm_enterTheMessage': "กรอกข้อความ",
    'mm_enterUniqueModelName': "กรอกชื่อโมเดลที่ไม่ซ้ำกัน",
    'mm_enterYourSystemMessageHere': "กรอกข้อความระบบของคุณที่นี่",
    'mm_extension': "ส่วนขยาย",
    'mm_flowConfiguration': "การตั้งค่าโฟลว์",
    'mm_flowConnected': "เชื่อมต่อโฟลว์แล้ว",
    'mm_flowIdLabel': "รหัสโฟลว์",
    'mm_flowStatus': "สถานะโฟลว์",
    'mm_forbiddenWord': "คำต้องห้าม",
    'mm_frequencyPenalty': "Frequency Penalty",
    'mm_fuzzyThreshold': "เกณฑ์ Fuzzy",
    'mm_fuzzyThresholdHint': "คะแนนจับคู่ Fuzzy ขั้นต่ำ 0-100 (ค่าเริ่มต้น 70)",
    'mm_gender': "เพศ",
    'mm_genderFemale': "หญิง",
    'mm_genderMale': "ชาย",
    'mm_graphsFromNexaHint': "กราฟจาก NEXA — ค้นหาอัตโนมัติระหว่างสนทนากับโมเดลนี้",
    'mm_groupIntent': "กลุ่มอินเทนต์",
    'mm_guardRail': "การ์ดเรล",
    'mm_guardRailModel': "โมเดล Guard Rail",
    'mm_imageGenerationSettings': "การตั้งค่าการสร้างภาพ",
    'mm_imageResolutionPixelsHint': "ความละเอียดภาพเป็นพิกเซล",
    'mm_imageSize': "ขนาดภาพ",
    'mm_imageStyle': "สไตล์ภาพ",
    'mm_imageUpload': "การอัปโหลดรูปภาพ",
    'mm_includeLineNameInMonitoringInterface': "รวมชื่อ LINE ไว้ในหน้าจอติดตาม",
    'mm_insertTemplate': "แทรกเทมเพลต",
    'mm_intent': "อินเทนต์",
    'mm_knowledge': "ฐานความรู้",
    'mm_lineConfiguration': "การตั้งค่า LINE",
    'mm_loading': "กำลังโหลด",
    'mm_loadingBar': "แถบโหลด",
    'mm_loadingDuration': "ระยะเวลาแสดงแถบโหลด",
    'mm_longTermMemory': "หน่วยความจำระยะยาว",
    'mm_maxCharacterExceeded': "กรุณากรอกข้อมูลตัวอักษรไม่เกิน ",
    'mm_maxContextEdges': "จำนวนเส้นเชื่อมบริบทสูงสุด",
    'mm_maxContextEdgesHint': "จำนวนเส้นเชื่อมที่ส่งคืนสูงสุด (ค่าเริ่มต้น 60)",
    'mm_maxContextNodes': "จำนวนโหนดบริบทสูงสุด",
    'mm_maxContextNodesHint': "จำนวนโหนดที่ส่งคืนสูงสุด (ค่าเริ่มต้น 30)",
    'mm_maxHops': "จำนวน Hop สูงสุด",
    'mm_maxHopsHint': "ความลึกของ BFS จากโหนดตั้งต้น (ค่าเริ่มต้น 3)",
    'mm_maxInputLength': "ความยาวข้อมูลนำเข้าสูงสุด",
    'mm_maxTokensExceedLimit': "จำนวน Token สูงสุดต้องไม่เกินขีดจำกัดรวม ",
    'mm_maxTokensResponse': "จำนวนโทเค็นสูงสุดของคำตอบ",
    'mm_maximumCharactersAllowedHint': "จำนวนตัวอักษรสูงสุดที่อนุญาต",
    'mm_maximumFileSize': "ขนาดไฟล์สูงสุด",
    'mm_mediaAndContext': "สื่อและบริบท",
    'mm_memorySettings': "การตั้งค่าหน่วยความจำ",
    'mm_model': "โมเดล",
    'mm_modelConfiguration': "การตั้งค่าโมเดล",
    'mm_modelIdExists': "รหัสโมเดลนี้มีอยู่แล้ว",
    'mm_modelIdLabel': "รหัสโมเดล",
    'mm_modelInfo': "ข้อมูลโมเดล",
    'mm_modelIntegratedWithWorkflow': "โมเดลนี้เชื่อมต่อกับเวิร์กโฟลว์ที่เลือกแล้ว",
    'mm_modelIsLiveAndAvailable': "โมเดลเผยแพร่แล้วและพร้อมให้ผู้ใช้งาน",
    'mm_modelNameRequired': "ชื่อโมเดล*",
    'mm_modelRequired': "โมเดล*",
    'mm_modelSavedNotAccessible': "บันทึกโมเดลแล้วแต่ผู้ใช้ยังเข้าถึงไม่ได้",
    'mm_modelType': "ประเภทโมเดล",
    'mm_monitor': "หน้าจอติดตาม",
    'mm_noFlowSelected': "ยังไม่ได้เลือกโฟลว์",
    'mm_noTemplatesAvailable': "ไม่มีเทมเพลตให้เลือก",
    'mm_notAvailable': "ไม่มีข้อมูล",
    'mm_optionalModelExtensionHint': "ส่วนขยายเพิ่มเติมของโมเดล (ไม่บังคับ)",
    'mm_parameters': "พารามิเตอร์",
    'mm_pleaseEnterCorrectFormat': "กรุณากรอกข้อมูลให้ถูกรูปแบบ!",
    'mm_pleaseSelectModel': "กรุณาเลือกโมเดล",
    'mm_pleaseSelectModelWarning': "กรุณาเลือกโมเดล",
    'mm_pleaseWait': "กรุณารอสักครู่",
    'mm_presencePenalty': "Presence Penalty",
    'mm_promptForNoData': "ข้อความเมื่อไม่พบข้อมูล",
    'mm_promptTemplate': "เทมเพลตพรอมต์",
    'mm_promptTemplates': "เทมเพลตพรอมต์",
    'mm_providerLabel': "ผู้ให้บริการ:",
    'mm_providerRequired': "ผู้ให้บริการ*",
    'mm_publicAccess': "เข้าถึงได้สาธารณะ",
    'mm_publicationControl': "การควบคุมการเผยแพร่",
    'mm_publicationStatus': "สถานะการเผยแพร่",
    'mm_published': "เผยแพร่แล้ว",
    'mm_quality': "คุณภาพ",
    'mm_qualityLevel': "ระดับคุณภาพ",
    'mm_realisticNaturalLooking': "สมจริงและเป็นธรรมชาติ",
    'mm_reasonHigh': "สูง",
    'mm_reasonLow': "ต่ำ",
    'mm_reasonMedium': "ปานกลาง",
    'mm_reasoningDepthHint': "ให้โมเดลใช้เวลาคิดวิเคราะห์ก่อนตอบมากขึ้น — ยิ่งสูงยิ่งแม่นกับคำถามซับซ้อน แต่ตอบช้าลงและใช้ Token มากขึ้น",
    'mm_reasoningEffort': "ระดับการให้เหตุผล",
    'mm_recommended1024kbHint': "แนะนำ: 1024KB สำหรับกรณีส่วนใหญ่",
    'mm_required': "จำเป็นต้องกรอก",
    'mm_resolution': "ความละเอียด",
    'mm_responseOptions': "ตัวเลือกการตอบกลับ",
    'mm_responseSpeed': "ความเร็วในการตอบ",
    'mm_samplingNotSupportedHint': "โมเดลตระกูล gpt-5.x ไม่รองรับค่านี้ ระบบจะไม่ส่งให้ผู้ให้บริการ",
    'mm_save': "บันทึก",
    'mm_saveAndClose': "บันทึกและปิด",
    'mm_searchMode': "โหมดการค้นหา",
    'mm_searchModeHint': "กลยุทธ์การจับคู่โหนดตั้งต้น (ค่าเริ่มต้น fuzzy-first)",
    'mm_searchTemplates': "ค้นหาเทมเพลต",
    'mm_selectAiProviderHint': "เลือกผู้ให้บริการ AI",
    'mm_selectFlow': "เลือกโฟลว์",
    'mm_selectFlowToEnableIntegration': "เลือกโฟลว์เพื่อเปิดใช้งานการเชื่อมต่อเวิร์กโฟลว์",
    'mm_selectLevel': "เลือกระดับ",
    'mm_selectModelVersionHint': "เลือกเวอร์ชันโมเดลที่ต้องการ",
    'mm_selectTemplateGroup': "เลือกกลุ่มเทมเพลต",
    'mm_selectYourTimezone': "เลือกเขตเวลาของคุณ",
    'mm_semanticThreshold': "เกณฑ์ Semantic",
    'mm_semanticThresholdHint': "ค่าความคล้ายคลึงโคไซน์ขั้นต่ำ 0-1 (ค่าเริ่มต้น 0.65)",
    'mm_shortTermMemory': "หน่วยความจำระยะสั้น",
    'mm_showLineName': "แสดงชื่อ LINE",
    'mm_speedFast': "เร็ว",
    'mm_speedMedium': "ปานกลาง",
    'mm_speedOfTextGenerationHint': "ความเร็วในการสร้างข้อความ",
    'mm_speedSlow': "ช้า",
    'mm_sqlExtractionModel': "โมเดลสำหรับดึงข้อมูลด้วย SQL",
    'mm_statusInfo': "ข้อมูลสถานะ",
    'mm_stopSequence': "Stop Sequence",
    'mm_streamResponse': "การตอบกลับแบบสตรีม",
    'mm_styleNatural': "เป็นธรรมชาติ",
    'mm_styleVivid': "สดใส",
    'mm_systemMessage': "ข้อความระบบ",
    'mm_tableName': "ชื่อตาราง",
    'mm_temperatureRequired': "Temperature*",
    'mm_templates': "เทมเพลต",
    'mm_testingMode': "โหมดทดสอบ",
    'mm_textReplacement': "การแทนที่ข้อความ",
    'mm_timeContext': "บริบทเวลา",
    'mm_timeZone': "เขตเวลา",
    'mm_topNChunks': "จำนวน Chunk สูงสุด (Top-N)",
    'mm_topP': "Top P",
    'mm_turn': "จำนวนรอบสนทนา",
    'mm_typeLabel': "ประเภท:",
    'mm_typingSpeed': "ความเร็วในการพิมพ์",
    'mm_tzAustralia': "ออสเตรเลีย",
    'mm_tzEngland': "อังกฤษ",
    'mm_tzHongKong': "ฮ่องกง",
    'mm_tzJapan': "ญี่ปุ่น",
    'mm_tzThailand': "ไทย",
    'mm_tzUsa': "สหรัฐอเมริกา",
    'mm_uniqueIdentifierHint': "ตัวระบุที่ไม่ซ้ำกันสำหรับโมเดลของคุณ",
    'mm_updateMode': "โหมดแก้ไข",
    'mm_usersCanAccess': "ผู้ใช้สามารถเข้าถึงได้",
    'mm_versionLabel': "เวอร์ชัน:",
    'mm_vibrantDramaticStyle': "สไตล์สดใสและดราม่าติก",
    'mm_viewMode': "โหมดดูข้อมูล",
    'mm_warningSelectStyleAndFormat': "กรุณาเลือกสไตล์ภาพและรูปแบบไฟล์ตอบกลับ",
    'navb_newChat': "แชทใหม่",
    'navb_settings': "ตั้งค่า",
    'navb_logout': "ออกจากระบบ",
    'navb_login': "เข้าสู่ระบบ",
    'navb_openSidebar': "เปิดแถบด้านข้าง",
    'navb_llmsDefault': "LLM (ค่าเริ่มต้น)",
    'navb_selectLlmModel': "เลือกโมเดล LLM",
    'navb_closeSidebar': "ปิดแถบด้านข้าง",
    'navb_version': "เวอร์ชัน",
        'dintd_fillAllDataType': "กรุณากรอกประเภทข้อมูลให้ครบทุกคอลัมน์!",
    'dintd_columnNameNoLeadingTrailingSpaces': "ชื่อคอลัมน์ต้องไม่มีช่องว่างนำหน้าหรือต่อท้าย!",
    'dintd_pleaseValidateAllColumnsBeforeSaving': "กรุณาตรวจสอบความถูกต้องของทุกคอลัมน์\nก่อนบันทึก",
    'dintd_errorOccurred': "เกิดข้อผิดพลาด",
    'dintd_noWorksheetFoundInExcelFile': "ไม่พบเวิร์กชีตในไฟล์ Excel",
    'dintd_dataInColumnRowExceedsLimit': "ข้อมูลในคอลัมน์ {column} แถวที่ {row} เกินขีดจำกัด 800 ตัวอักษร",
    'perm_pid': "รหัสสิทธิ์",
    'perm_loadingPleaseWait': "กำลังโหลด กรุณารอสักครู่...",
    'perm_permissionNameHeader': "ชื่อสิทธิ์",
    'perm_groupNameHeader': "ชื่อกลุ่ม",
    'perm_editHeader': "แก้ไข",
    'perm_pleaseEnterGroupName': "กรุณากรอกชื่อกลุ่ม!!",
    'perm_noGroup': "ไม่มีกลุ่ม",
    'perm_pleaseFillAllFields': "กรุณากรอกข้อมูลให้ครบทุกช่อง!!",
    'pdet_productNameRequiredTitle': "จำเป็นต้องกรอกชื่อสินค้า",
    'pdet_productNameRequiredBeforeSaveText': "กรุณากรอกชื่อสินค้าก่อนบันทึก",
    'pdet_productDetailRequiredTitle': "จำเป็นต้องกรอกรายละเอียดสินค้า",
    'pdet_productDetailRequiredBeforeSaveText': "กรุณากรอกรายละเอียดสินค้าก่อนบันทึก",
    'pdet_productGroupNameRequiredBeforeSaveText': "กรุณากรอกชื่อกลุ่มสินค้าก่อนบันทึก",
    'pdet_productAddedSuccess': "เพิ่มสินค้าเรียบร้อยแล้ว",
    'pdet_productUpdatedSuccess': "อัปเดตสินค้าเรียบร้อยแล้ว",
    'pdet_allDataSavedSuccess': "บันทึกข้อมูลทั้งหมดเรียบร้อยแล้ว",
    'pdet_unsavedChangesTitle': "มีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก",
    'pdet_unsavedChangesText': "คุณมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก ต้องการปิดโดยไม่บันทึกหรือไม่?",
    'pdet_yesClose': "ใช่ ปิดเลย",
    'pdet_noKeepEditing': "ไม่ แก้ไขต่อ",
    'pgrp_productGroupName': "ชื่อกลุ่มผลิตภัณฑ์",
    'pgrp_search': "ค้นหา",
    'pgrp_updateBy': "อัปเดตโดย",
    'pgrp_updateDate': "วันที่อัปเดต",
    'pgrp_deleteProductGroupTitle': "ลบกลุ่มผลิตภัณฑ์",
    'pgrp_deleteProductGroupText': "คุณแน่ใจหรือไม่ว่าต้องการลบกลุ่มผลิตภัณฑ์นี้? การดำเนินการนี้ไม่สามารถย้อนกลับได้",
    'rfb_likeDislike': "ชอบ/ไม่ชอบ",
    'rfb_percentage': "เปอร์เซ็นต์",
    'rfb_numberOfFeedback': "จำนวนความคิดเห็น",
    'landingPageConfig.breadcrumbRoot': "ผู้ดูแลระบบสูงสุด",
    '_sa_role_user': "ผู้ใช้งาน",
    '_sa_role_snippet': "สนิปเพ็ต",
    '_sa_role_msTeams': "MS Teams",
    '_sa_role_operator': "ผู้ดำเนินการ",
    '_sa_excel_sheetUsers': "ผู้ใช้งาน",
    '_sa_excel_headerEmail': "อีเมล",
    'ugd_warning': "คำเตือน",
    'ugd_pleaseFillConfirmPassword': "กรุณากรอกยืนยันรหัสผ่าน",
    'ugd_pleaseFillPassword': "กรุณากรอกรหัสผ่าน",
    'ugd_pleaseFillPasswordAndConfirmPassword': "กรุณากรอกรหัสผ่านและยืนยันรหัสผ่าน",
    'ugd_passwordConfirmMismatch': "รหัสผ่านและยืนยันรหัสผ่านไม่ตรงกัน กรุณากรอกให้ถูกต้อง",
    'ugd_pleaseFillAllFieldsExclaim': "กรุณากรอกข้อมูลให้ครบทุกช่อง!!!",
        'flowpg_configureYourAiModelSettingsAndParameters': "กำหนดค่าการตั้งค่าและพารามิเตอร์ของโมเดล AI ของคุณ",
    'flowpg_loadFromModel': "โหลดจากโมเดล",
    'flowpg_useBaseModelPrompt': "ใช้พรอมต์พื้นฐานของโมเดล",
    'flowpg_combineWithDefaultModelPrompt': "รวมกับพรอมต์เริ่มต้นของโมเดล",
    'flowpg_responseCache': "แคชการตอบกลับ",
    'flowpg_cacheWillSkipWhenStreamingOrDataIntegrations': "แคชจะถูกข้ามเมื่อเปิดใช้งาน Streaming หรือมีการใช้ Data Integrations",
    'flowpg_configureYourIntentAiModelSettingsAndParameters': "กำหนดค่าการตั้งค่าและพารามิเตอร์ของโมเดลอินเทนต์ AI ของคุณ",
    'flowpg_webSearchDomains': "Web Search Domains",
    'flowpg_webSearchDomainsHint': "ใส่โดเมนที่อนุญาตให้ node นี้ค้นเว็บ (เช่น dga.or.th) — มี ≥ 1 = เปิด (ค้นทุกคำถาม ตอบช้าลง), ว่าง = ปิด; ไม่ดึงค่าจากหน้าจัดการโมเดลอัตโนมัติ (เฉพาะโมเดลบน Azure, สูงสุด 20)",
    'flowpg_webSearchNotSupported': "โมเดลของ node นี้ไม่รองรับ Web Search (ต้องเป็นโมเดลบน Azure) — ค่าจะถูกบันทึกแต่ไม่มีผลตอนรัน flow",
    'pgnd_imageDownloading': "กำลังดาวน์โหลดรูปภาพ...",
    'pgnd_update': "อัปเดต",
    'pgnd_yourModel': "โมเดลของคุณ",
    'pgnd_confirmTo': "กรุณายืนยันเพื่อ",
    'pgnd_loadingPleaseWait': "กำลังโหลด กรุณารอสักครู่...",
    'pgnd_commandNotSupported': "คำสั่งนี้ไม่รองรับสำหรับหน้านี้",
    'uvec_processTypeAdd': "เพิ่ม",
    'uvec_processTypeReplace': "แทนที่",
    'uvec_originalText': "ข้อความต้นฉบับ",
    'uvec_translatedText': "ข้อความภาษาอังกฤษ",
    'uvec_required': "จำเป็นต้องกรอก",
    'uvec_duplicate': "ข้อมูลซ้ำ",
    'uvec_pleaseFillAllFields': "กรุณากรอกข้อมูลให้ครบทุกช่อง!",
    'uvec_pleaseFillCustomMaxCharacter': "กรุณากรอกจำนวนอักขระสูงสุดที่กำหนดเอง",
        'invm_statusPending': "รอดำเนินการ",
    'invm_statusUsed': "ใช้แล้ว",
    'invm_statusExpired': "หมดอายุ",
    'invm_statusRevoked': "ถูกเพิกถอน",
    'invm_statusRejected': "ปฏิเสธ",
        'sec_doc1': "API เวอร์ชัน v0",
    'sec_doc2': "API เวอร์ชัน v1",
    'sec_doc3': "API เวอร์ชัน v2",
    'sec_doc4': "API เวอร์ชัน v3",
    'sec_doc5': "30 วัน",
    'sec_doc6': "60 วัน",
    'sec_doc7': "90 วัน",
    'sec_doc8': "120 วัน",
    'sec_doc9': "สคริปต์สำหรับฝัง standard chat, FullStream และ FullStream V2 ลงบนเว็บไซต์ภายนอก",
    'sec_doc10': "Domain token / การตั้งค่า snippet ที่สร้างขึ้น",
    'sec_doc11': "ยืนยันตัวตนผู้ใช้ภายนอกและคืนค่า JWT token สำหรับการเรียก ExternalAPI v0 แบบเดิม",
    'sec_doc12': "Username/Password แบบสาธารณะ",
    'sec_doc13': "สร้างหรือเพิ่มข้อความหนึ่งรายการลงใน vector database ที่ตั้งค่าไว้ สำหรับการนำเข้าความรู้จากภายนอก",
    'sec_doc14': "นำเข้าข้อความหลายชิ้นลงใน vector database ในคำขอเดียว",
    'sec_doc15': "เลือกหรือเปลี่ยนโมเดลที่ใช้งานอยู่สำหรับผู้ใช้แชทภายนอก โดยใช้ runtime เดียวกับคำสั่งแชท",
    'sec_doc16': "ส่งข้อความแชทภายนอกแบบปกติเข้าสู่ runtime ของ ChatFramework และคืนค่าคำตอบของบอท",
    'sec_doc17': "ส่งข้อความแชทพร้อม prompt context ที่กำหนดเอง สำหรับการค้นคืนหรือควบคุมการสร้างคำตอบ",
    'sec_doc18': "นำเข้าผู้ใช้พอร์ทัลจากระบบภายนอก และคืนค่ารายละเอียดข้อมูลซ้ำหรือผลการตรวจสอบ",
    'sec_doc19': "นำเข้าผู้ใช้แชทพร้อมการแมป social user, group model และฟิลด์ quick model group",
    'sec_doc20': "endpoint แชทแบบ agency พร้อม responseTime และโครงสร้างการตอบกลับ userMessage/botMessage",
    'sec_doc21': "Api-Key: <api-key จากหน้า Token Management>",
    'sec_doc22': "คืนค่าประวัติแชทภายนอกของผู้ใช้ หลังจากระบุ company context จาก Api-Key หรือ header ที่เกี่ยวข้อง",
    'sec_doc23': "ล้างประวัติแชทภายนอกของผู้ใช้ใน company context ที่ระบุ",
    'sec_doc24': "เอกสาร External API สำหรับการเชื่อมต่อ ChatFramework",
    'sec_doc25': "ดูหมายเหตุของ endpoint",
        'strm_aiDisclaimer': "AI อาจตอบผิดพลาดได้ กรุณาตรวจสอบคำตอบอีกครั้ง",
    'csvc_tabAll': "ทั้งหมด",
    cookieBannerTitle: 'เว็บไซต์นี้ใช้คุกกี้',
    cookieBannerDesc: 'เราใช้คุกกี้ที่จำเป็นเพื่อให้การเข้าสู่ระบบและความปลอดภัยทำงานได้ และคุกกี้เพื่อการทำงานเพื่อจดจำการตั้งค่าของคุณ',
    cookieBannerPolicyLink: 'อ่านนโยบายคุกกี้',
    cookieBannerAcceptAll: 'ยอมรับทั้งหมด',
    cookieBannerNecessaryOnly: 'เฉพาะที่จำเป็น',
    cookieBannerSettings: 'ตั้งค่าคุกกี้',
    cookieBannerAcknowledge: 'เข้าใจแล้ว',
    cookieSettingsTitle: 'ตั้งค่าความเป็นส่วนตัวของคุกกี้',
    cookieSettingsIntro: 'คุณสามารถเลือกประเภทคุกกี้ที่ยินยอมให้เราใช้ได้ ยกเว้นคุกกี้ที่จำเป็นซึ่งต้องเปิดไว้เสมอเพื่อให้เว็บไซต์ทำงานได้',
    cookieCatNecessaryTitle: 'คุกกี้ที่จำเป็นอย่างยิ่ง',
    cookieCatNecessaryDesc: 'จำเป็นต่อการเข้าสู่ระบบ ความปลอดภัย และการทำงานพื้นฐานของเว็บไซต์ จึงไม่สามารถปิดได้',
    cookieCatNecessaryAlways: 'จำเป็นเสมอ',
    cookieCatFunctionalTitle: 'คุกกี้เพื่อการทำงาน',
    cookieCatFunctionalDesc: 'ช่วยจดจำภาษาที่เลือก (ไทย/อังกฤษ) และการล็อกอินค้างไว้ เพื่อประสบการณ์ใช้งานที่สะดวกขึ้น',
    cookieSettingsSave: 'บันทึกการตั้งค่า',
    cookiePageTitle: 'นโยบายคุกกี้',
    cookiePageUpdatedLabel: 'อัปเดตล่าสุด',
    cookiePageUpdatedValue: '6 กรกฎาคม 2569',
    cookiePageIntro: 'นโยบายการใช้คุกกี้ฉบับนี้อธิบายว่าเว็บไซต์และบริการของสำนักงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน) หรือ DGA มีการใช้คุกกี้และเทคโนโลยีที่คล้ายกันอย่างไร เพื่อให้คุณเข้าใจวัตถุประสงค์ในการใช้งานและสามารถเลือกตั้งค่าความยินยอมได้ โดยนโยบายนี้ใช้ควบคู่กับนโยบายความเป็นส่วนตัวของ DGA',
    cookiePageWhatTitle: 'คุกกี้คืออะไร',
    cookiePageWhatBody: 'คุกกี้ (Cookies) คือไฟล์ข้อความขนาดเล็กที่เว็บไซต์จัดเก็บไว้บนอุปกรณ์ของคุณเมื่อคุณเข้าใช้งาน เพื่อจดจำข้อมูลบางอย่าง เช่น สถานะการเข้าสู่ระบบหรือภาษาที่เลือก นอกจากคุกกี้แล้ว เรายังใช้พื้นที่จัดเก็บข้อมูลในเบราว์เซอร์ (เช่น Local Storage และ Session Storage) ในลักษณะเดียวกัน ซึ่งในนโยบายนี้จะเรียกรวมกันว่า "คุกกี้"',
    cookiePageTypesTitle: 'ประเภทของคุกกี้ที่เราใช้',
    cookiePageTypesIntro: 'เราแบ่งคุกกี้ตามวัตถุประสงค์การใช้งานออกเป็น 2 ประเภท ดังนี้',
    cookiePageNecessaryBody: 'เป็นคุกกี้ที่จำเป็นต่อการทำงานพื้นฐานของเว็บไซต์ เช่น การรักษาสถานะการเข้าสู่ระบบ การยืนยันตัวตน และการรักษาความปลอดภัย หากไม่มีคุกกี้เหล่านี้ เว็บไซต์จะไม่สามารถทำงานได้อย่างถูกต้อง คุกกี้ประเภทนี้จึงไม่สามารถปิดการใช้งานได้ และไม่จำเป็นต้องขอความยินยอมตามกฎหมาย แต่เราจะแจ้งให้คุณทราบเสมอ',
    cookiePageFunctionalBody: 'เป็นคุกกี้ที่ช่วยเพิ่มความสะดวกในการใช้งาน เช่น การจดจำภาษาที่คุณเลือก (ไทย/อังกฤษ) และการจดจำการเข้าสู่ระบบ คุณสามารถเลือกยินยอมหรือปฏิเสธคุกกี้ประเภทนี้ได้ โดยการปฏิเสธอาจทำให้บางฟังก์ชันไม่สะดวกเท่าที่ควร แต่ยังสามารถใช้งานเว็บไซต์ได้ตามปกติ',
    cookiePageNoTrackingNote: 'ปัจจุบันเว็บไซต์นี้ไม่ได้ใช้คุกกี้เพื่อการวิเคราะห์ (Analytics) หรือคุกกี้เพื่อการโฆษณา/การตลาด และไม่มีการแบ่งปันข้อมูลคุกกี้ให้แก่บุคคลที่สามเพื่อวัตถุประสงค์ดังกล่าว',
    cookiePageTableTitle: 'รายละเอียดคุกกี้ที่ใช้',
    cookiePageColName: 'ชื่อ',
    cookiePageColPurpose: 'วัตถุประสงค์',
    cookiePageColType: 'ประเภท',
    cookiePageColRetention: 'ระยะเวลาจัดเก็บ',
    cookiePurposeAuth: 'รักษาสถานะการเข้าสู่ระบบและยืนยันตัวตนของผู้ใช้',
    cookiePurposeCsrf: 'ป้องกันการปลอมแปลงคำขอข้ามเว็บไซต์ (CSRF)',
    cookiePurposeSession: 'เก็บสถานะการใช้งานชั่วคราวระหว่างเซสชัน',
    cookiePurposeConsent: 'บันทึกตัวเลือกความยินยอมคุกกี้ของคุณ',
    cookiePurposeLocale: 'จดจำภาษาที่คุณเลือก (ไทย/อังกฤษ)',
    cookiePurposeRemember: 'จดจำการเข้าสู่ระบบเพื่อความสะดวกในการใช้งานครั้งถัดไป',
    cookieRetentionSession: 'ตามอายุเซสชัน',
    cookieRetentionUntilClosed: 'จนกว่าจะปิดแท็บ/เบราว์เซอร์',
    cookieRetentionPersistent: 'จนกว่าจะลบข้อมูลเบราว์เซอร์',
    cookiePageManageTitle: 'การจัดการคุกกี้ของคุณ',
    cookiePageManageBody: 'คุณสามารถจัดการหรือลบคุกกี้ได้ผ่านการตั้งค่าของเบราว์เซอร์ที่คุณใช้งาน ทั้งนี้ การลบคุกกี้ที่จำเป็นอาจทำให้ไม่สามารถเข้าสู่ระบบหรือใช้งานบางส่วนของเว็บไซต์ได้',
    cookiePageChangesTitle: 'การเปลี่ยนแปลงนโยบาย',
    cookiePageChangesBody: 'เราอาจปรับปรุงนโยบายการใช้คุกกี้นี้เป็นครั้งคราว เพื่อให้สอดคล้องกับการเปลี่ยนแปลงของบริการหรือข้อกำหนดทางกฎหมาย หากมีการเปลี่ยนแปลงที่มีนัยสำคัญ เราจะแสดงแบนเนอร์ขอความยินยอมใหม่อีกครั้ง และระบุวันที่ปรับปรุงล่าสุดไว้ที่ด้านบนของหน้านี้',
    cookiePageContactTitle: 'ติดต่อเรา',
    cookiePageContactBody: 'หากคุณมีข้อสงสัยเกี่ยวกับนโยบายการใช้คุกกี้นี้ หรือต้องการใช้สิทธิเกี่ยวกับข้อมูลส่วนบุคคลตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (PDPA) สามารถติดต่อสำนักงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน) ได้ที่',
    ugrp_editGroup: 'แก้ไขกลุ่ม',
    ugrp_deleteGroup: 'ลบกลุ่ม',
    gum_editGroupTooltip: 'จัดการผู้ใช้ในกลุ่ม',
    gum_deleteGroupTooltip: 'ลบกลุ่มความปลอดภัย',
    ugd_editUserTooltip: 'แก้ไขผู้ใช้',
    ugd_deleteUserTooltip: 'ลบผู้ใช้ออกจากกลุ่ม',
    umgt_togglePasswordVisibility: 'แสดง/ซ่อนรหัสผ่าน',
    umgt_editUser: 'แก้ไขผู้ใช้',
    umgt_deleteUser: 'ลบผู้ใช้',
    ucm_togglePasswordVisibility: 'แสดง/ซ่อนรหัสผ่าน',
    ucm_editUser: 'แก้ไขผู้ใช้',
    ucm_deleteUser: 'ลบผู้ใช้',
    uprof_toggleIdCardVisibility: 'แสดง/ซ่อนเลขบัตรประชาชน',
    uprof_togglePasswordVisibility: 'แสดง/ซ่อนรหัสผ่าน',
    uprof_changeAvatar: 'เปลี่ยนรูปโปรไฟล์',
    perm_editPermission: 'แก้ไขสิทธิ์และกลุ่มของบทบาทนี้',
    bcum_removeFromBlacklist: 'ลบผู้ใช้ออกจากบัญชีดำ (คืนสิทธิ์แชท)',
    invm_resendInvite: 'ส่งอีเมลคำเชิญนี้อีกครั้ง',
    invm_revokeInvite: 'ยกเลิกคำเชิญนี้ (ลิงก์จะใช้ไม่ได้อีก)',
    mdata_toggleApiKeyVisibility: 'แสดง/ซ่อน API Key',
    mdata_copyPlaceholderHint: 'คลิกเพื่อคัดลอก / ลากไปวาง',
    mdata_maxTokenHint: 'จำนวนโทเคนสูงสุดต่อคำขอ',
    mquick_removeChannel: 'ลบช่องทางนี้',
    mquick_addChannel: 'เพิ่มช่องทาง',
    gmnm_fewShotExampleHint: 'คู่ตัวอย่างสนทนา: role = ผู้พูด (user/assistant), content = ข้อความตัวอย่าง',
    gmnd_fewShotExampleHint: 'คู่ตัวอย่างสนทนา: role = ผู้พูด (user/assistant), content = ข้อความตัวอย่าง',
    mqg_viewGroupModels: 'ดูโมเดลในกลุ่ม',
    mqr_viewGroupModels: 'ดูโมเดลในกลุ่ม',
    mqg_viewModelNewTab: 'เปิดรายละเอียดโมเดลในแท็บใหม่',
    mqr_viewModelNewTab: 'เปิดรายละเอียดโมเดลในแท็บใหม่',
    gmm_moreActions: 'ตัวเลือกเพิ่มเติม',
    gmm_editModelConfig: 'แก้ไขการตั้งค่าโมเดล',
    flowpg_moreActionsTooltip: 'ตัวเลือกเพิ่มเติม',
    flowpg_toggleInspectorSizeTooltip: 'ขยาย/ย่อแผงคุณสมบัติ',
    flowpg_closeInspectorTooltip: 'ปิดแผงคุณสมบัติ',
    flowpg_moveTierUpTooltip: 'เลื่อนลำดับขึ้น',
    flowpg_moveTierDownTooltip: 'เลื่อนลำดับลง',
    flowpg_removeTierTooltip: 'ลบลำดับการค้นหา',
    flowpg_toggleVariablesTooltip: 'แสดง/ซ่อนตัวแปร',
    flowpg_toggleDocumentDataTooltip: 'ขยาย/ย่อการเลือกข้อมูลเอกสาร',
    flowpg_usePromptTemplateTooltip: 'ใช้เทมเพลตนี้',
    flowpg_addRowTooltip: 'เพิ่มรายการ',
    flowpg_removeRowTooltip: 'ลบรายการ',
    flowpg_deleteEntryTooltip: 'ลบรายการ',
    fedge_removeConnection: 'ลบการเชื่อมต่อ',
    fnode_toggleBranchTooltip: 'ขยาย/ย่อกิ่งย่อย',
    npanel_togglePanelTooltip: 'ย่อ/ขยายแผงโหนด',
    fnode_handleInputTooltip: 'จุดเชื่อมต่อขาเข้า',
    fnode_handleOutputTooltip: 'จุดเชื่อมต่อขาออก',
    fnode_handleTrueTooltip: 'เงื่อนไขจริง',
    fnode_handleFalseTooltip: 'เงื่อนไขเท็จ',
    fnode_handleFallbackTooltip: 'กรณีสำรอง',
    fnode_handleModelAttachTooltip: 'จุดต่อโมเดล',
    dint_editTableTooltip: 'แก้ไขการตั้งค่าตารางเชื่อมต่อข้อมูล',
    dint_deleteTableTooltip: 'ลบตารางเชื่อมต่อข้อมูลนี้ทั้งหมด',
    dint_removeColumn: 'ลบคอลัมน์นี้',
    uvec_embeddingProgressTooltip: 'จำนวน chunk ที่ฝังลงคลังเวกเตอร์แล้ว / ทั้งหมด — คลิกเพื่อรีเฟรชสถานะ',
    uvec_reprocessNeededBadge: 'มีการเปลี่ยนแปลงที่ยังไม่ได้ประมวลผล — โปรดกดประมวลผลใหม่',
    uvec_vectorToggleTooltip: 'เปิด/ปิดการใช้ chunk นี้ในการค้นหาเชิงความหมาย (RAG)',
    ucsv_moreActionsTooltip: 'ตัวเลือกเพิ่มเติม (แชร์ / ทำสำเนา / แทนที่ / ประวัติเวอร์ชัน)',
    ucsv_versionActionsTooltip: 'ตัวเลือกเวอร์ชัน (กู้คืน / ดูเนื้อหา)',
    ucsv_downloadExcelTooltip: 'ดาวน์โหลดเอกสารเป็นไฟล์ Excel (.xlsx)',
    ucsv_deleteDocumentTooltip: 'ลบเอกสารนี้และ chunk ทั้งหมดในคลังเวกเตอร์',
    dintd_paginationFirstPage: 'ไปยังหน้าแรก',
    dintd_paginationPreviousPage: 'ไปยังหน้าก่อนหน้า',
    dintd_paginationNextPage: 'ไปยังหน้าถัดไป',
    dintd_paginationLastPage: 'ไปยังหน้าสุดท้าย',
    dintd_validateColumnTooltip: 'ตรวจสอบและตรวจจับชนิดข้อมูลของคอลัมน์จากแหล่งข้อมูลภายนอก',
    dintd_removeColumnTooltip: 'ลบคอลัมน์นี้ออกจากการตั้งค่า',
    dintd_uploadExcelTooltip: 'อัปโหลดไฟล์ Excel เพื่อนำเข้าข้อมูลจำนวนมากลงตาราง',
    kgl_editDescriptionTooltip: 'คลิกเพื่อแก้ไขชื่อและคำอธิบายกราฟความรู้',
    usdd_botSummationTooltip: 'เปิดเพื่อให้ AI สรุปเนื้อหาจากไฟล์เสียงที่อัปโหลด',
    usd_processStatusTooltip: 'จำนวนไฟล์เสียงที่ถอดความเสร็จ / ทั้งหมด',
    usdd_filesSelectedTooltip: 'จำนวนไฟล์ที่เลือก',
    rtext_downloadTemplateTooltip: 'ดาวน์โหลดไฟล์ CSV ตัวอย่างสำหรับนำเข้าคำแทนที่ (คอลัมน์ Text, Replace_Text)',
    rtext_uploadCsvTooltip: 'นำเข้าคู่คำแทนที่จากไฟล์ CSV หรือ Excel',
    scmenu_viewModelTooltip: 'เปิดรายละเอียดโมเดลในแท็บใหม่',
    scmenu_uploadImageTooltip: 'อัปโหลดไอคอนรูปภาพสำหรับคำสั่งลัดนี้ (ปรับขนาดอัตโนมัติ, .jpg/.png)',
    mmgt_editMenuTooltip: 'แก้ไข / กำหนดกลุ่มผู้ใช้ให้เมนูนี้',
    pdet_editCategoryTooltip: 'แก้ไขชื่อหมวดหมู่',
    pdet_confirmEditCategoryTooltip: 'ยืนยันการแก้ไขชื่อหมวดหมู่',
    pdet_removeCategoryTooltip: 'ลบหมวดหมู่',
    pdet_removeImageTooltip: 'ลบรูปภาพที่เลือก',
    pdet_addCategoryTooltip: 'เพิ่มหมวดหมู่ใหม่',
    pdet_reprocessTooltip: 'ประมวลผลข้อมูลสินค้าเป็นเวกเตอร์ใหม่สำหรับการค้นหา AI',
    igrp_editTooltip: 'จัดการเซสชันเจตนาในกลุ่มนี้',
    igrp_deleteTooltip: 'ลบกลุ่มเจตนานี้และเซสชันทั้งหมด',
    isess_editTooltip: 'แก้ไขรายละเอียดเซสชันเจตนา',
    isess_deleteTooltip: 'ลบเซสชันเจตนานี้',
    isd_toggleFullTextTooltip: 'แสดง/ย่อข้อความเต็ม',
    isd_deleteHeaderTooltip: 'ลบเฮดเดอร์นี้',
    isd_deleteValidationTooltip: 'ลบกฎการตรวจสอบนี้',
    isd_deleteActionTooltip: 'ลบการดำเนินการนี้',
    isd_insertVariableTooltip: 'คลิกหรือลากเพื่อแทรกตัวแปรลงใน JSON',
    vgen_editTooltip: 'แก้ไขการตั้งค่าชุดคำถาม',
    vgen_downloadTooltip: 'ดาวน์โหลดคำถามที่สร้างเป็น CSV',
    vgen_deleteTooltip: 'ลบชุดคำถามที่สร้างนี้',
    vgu_infoPromptMore: 'ข้อความคำสั่งเพิ่มเติมที่จะต่อท้ายพรอมต์ตัวสร้างคำถาม',
    vneg_editTooltip: 'แก้ไขชุดคำถามเชิงลบ',
    vneg_deleteTooltip: 'ลบชุดคำถามเชิงลบทั้งชุด',
    vnd_removeFileTooltip: 'นำไฟล์นี้ออก',
    vnd_deleteRowTooltip: 'ลบคำถามเชิงลบนี้',
    vpos_editTooltip: 'แก้ไขชุดคำถามเชิงบวก',
    vpos_deleteTooltip: 'ลบชุดคำถามเชิงบวกทั้งชุด',
    vpd_removeFileTooltip: 'นำไฟล์นี้ออก',
    vpd_editRowTooltip: 'แก้ไขคำถามและคำตอบนี้',
    vpd_deleteRowTooltip: 'ลบคำถามและคำตอบนี้',
    vpd_closeDialogTooltip: 'ปิด',
    vproc_editTooltip: 'แก้ไขการตั้งค่าการทดสอบ',
    vproc_downloadTooltip: 'ดาวน์โหลดคำตอบของการทดสอบ (CSV)',
    vproc_deleteTooltip: 'ลบการทดสอบนี้',
    chatinput_send: 'ส่งข้อความ',
    chatinput_skip: 'ข้ามขั้นตอนนี้',
    chatinput_suggestions: 'คำถามแนะนำ / เริ่มการสนทนาใหม่',
    chatinput_scrollBottom: 'เลื่อนไปข้อความล่าสุด',
    welcome_scrollLeft: 'เลื่อนซ้าย',
    welcome_scrollRight: 'เลื่อนขวา',
    pgnd_downloadImage: 'ดาวน์โหลดรูปภาพ',
    pgnd_closePreview: 'ปิดตัวอย่างรูปภาพ',
    strm_sendMessage: 'ส่งข้อความ',
    strm_stopGeneration: 'หยุดการตอบของโมเดล',
    strm_clearConversation: 'ล้างบทสนทนา',
    strm_voiceInput: 'ป้อนด้วยเสียง / อัดเสียง',
    strm_stopVoice: 'หยุดอัดเสียง',
    strm_uploadAudioFile: 'อัปโหลดไฟล์เสียง',
    strm_attach: 'แนบไฟล์',
    strm_topicOptions: 'ตัวเลือกหัวข้อ',
    strm_expandPanel: 'ขยาย',
    strm_collapsePanel: 'ย่อ',
    strm_removeAttachment: 'ลบไฟล์แนบ',
    csvc_sendMessage: 'ส่งข้อความ',
    csvc_attachFile: 'แนบไฟล์',
    csvc_filter: 'กรองรายการ',
    csvc_toggleAdminReply: 'สลับตอบโดยแอดมิน/บอท',
    csvc_removeFile: 'ลบไฟล์',
    csvc_addMoreFiles: 'เพิ่มไฟล์',
    fsdrawer_close: 'ปิดแผงด้านข้าง',
    fsdrawer_newChat: 'เริ่มแชทใหม่',
    fsdrawer_folderOptions: 'ตัวเลือกโฟลเดอร์',
    fsdrawer_topicOptions: 'ตัวเลือกหัวข้อ',
    fsdrawer_createFolder: 'สร้างโฟลเดอร์ใหม่',
    StreamSendMessage: 'ส่งข้อความ',
    StreamStopGeneration: 'หยุดการตอบ',
    StreamClearConversation: 'ล้างบทสนทนา',
    StreamVoiceInput: 'ป้อนด้วยเสียง',
    StreamStopVoice: 'หยุดอัดเสียง',
    StreamUploadAudio: 'อัปโหลดไฟล์เสียง',
    StreamAttachDocument: 'แนบเอกสาร (RAG)',
    StreamSelectModel: 'เลือกโมเดล',
    StreamEditDocument: 'แก้ไขเอกสาร',
    StreamDeleteDocument: 'ลบเอกสาร',
    StreamRemoveImagePreview: 'ลบรูปภาพที่เลือก',
    StreamRemoveFilePreview: 'ลบไฟล์ที่อัปโหลด',
    StreamPrivateMemoryFileMenu: 'ตัวเลือกเพิ่มเติม',
    StreamScrollToBottom: 'เลื่อนไปข้อความล่าสุด',
    StreamScrollShortcutsLeft: 'เลื่อนซ้าย',
    StreamScrollShortcutsRight: 'เลื่อนขวา',
    StreamTogglePrivateMemoryActive: 'เปิด/ปิดใช้ไฟล์ใน RAG',
    StreamToggleChunkActive: 'เปิด/ปิดใช้ส่วนข้อมูล',
    StreamToggleTextExpand: 'ขยาย/ย่อข้อความ',
    StreamCloseFeedbackDialog: 'ปิดกล่องข้อเสนอแนะ',
    StreamEditFile: 'แก้ไข',
    StreamDeleteFile: 'ลบ',
    StreamEditChunk: 'แก้ไข',
    StreamDeleteChunk: 'ลบ',
    fs2OpenUserMenu: 'เปิดเมนูบัญชีผู้ใช้',
    fs2FolderMenu: 'เมนูโฟลเดอร์',
    fs2TopicMenu: 'เมนูหัวข้อ',
    dash_exportAllTooltip: 'ดาวน์โหลดข้อมูลแดชบอร์ดทั้งหมด (ภาพรวม โทเคน การใช้งานระบบ ข้อเสนอแนะ) เป็น Excel',
    dash_totalUserTooltip: 'ยอดผู้ใช้ที่ล็อกอินผ่าน Government Gateway ของแต่ละวัน นำมาบวกรวมกันทั้งช่วง — เช่น คนเดิมที่เข้าใช้ 3 วัน จะถูกนับเป็น 3 ไม่ใช่ 1',
    dash_totalQueryTooltip: 'จำนวนคำถามทั้งหมดที่ส่งเข้าระบบในช่วงวันที่ (ผลรวมรายวัน)',
    dash_totalModelsTooltip: 'จำนวนโมเดล LLM ที่ถูกใช้งานแบบไม่ซ้ำในช่วงวันที่',
    dash_totalTokensAllTooltip: 'จำนวนโทเคนทั้งหมดที่ใช้ (รวม Chat cached/non-cached, Completion, Embedding, Intent)',
    dash_showPriceTooltip: 'เปิด: แสดงเป็นราคาบาท — ปิด: แสดงจำนวนโทเคนดิบ',
    dash_chatNonCachedTooltip: 'โทเคน Prompt ของแชทที่ไม่ได้มาจาก Prompt Cache',
    dash_chatCachedTooltip: 'โทเคน Prompt ของแชทที่ดึงมาจาก Prompt Cache',
    dash_chatCompletionTooltip: 'โทเคน Completion (ผลลัพธ์) ที่โมเดลแชทสร้าง',
    dash_embeddingInputTooltip: 'จำนวนโทเคนที่ใช้ในการสร้าง Embedding',
    dscore_reprocessTooltip: 'เปิดหน้าต่างเพื่อประมวลผลคะแนน Validation ใหม่ด้วยโมเดลและ Prompt ที่เลือก',
    dscore_calculateScoresTooltip: 'เลือกเพื่อใช้ Prompt กำหนดเองในการคำนวณคะแนน',
    rfb_downloadTooltip: 'ดาวน์โหลดรายงานข้อเสนอแนะเป็นไฟล์ Excel',
    rfb_searchTooltip: 'ค้นหาข้อมูลข้อเสนอแนะตามช่วงวันที่ที่เลือก',
    rfb_toggleReplyTooltip: 'แสดง/ซ่อนข้อความตอบกลับแบบเต็ม',
    rqt_processTooltip: 'ประมวลผลเพื่อสร้างคำถามยอดนิยม 10 อันดับจากข้อเสนอแนะ',
    rqt_refreshTooltip: 'รีเฟรชสถานะการประมวลผล (ประมวลผลแล้ว / ทั้งหมด)',
    rts_downloadTooltip: 'ดาวน์โหลดรายงานสรุปโทเคนเป็นไฟล์ Excel ตามเงื่อนไขที่กรอง',
    rts_modelsCountTooltip: 'จำนวนโมเดลทั้งหมดในรายงานที่กรอง',
    rts_searchTooltip: 'ค้นหารายงานสรุปโทเคนตามเงื่อนไขที่กรอง',
    rts_inputTokensTooltip: 'ผลรวมโทเคน Prompt (ขาเข้า) ที่ส่งให้ LLM',
    rts_outputTokensTooltip: 'ผลรวมโทเคน Completion (ขาออก)',
    rts_totalTokensTooltip: 'ผลรวมโทเคนทั้งหมด (ขาเข้า + ขาออก)',
    rts_imageGenTooltip: 'จำนวนคำขอสร้างรูปภาพของโมเดลนี้',
    rts_cachedTooltip: 'โทเคนที่ดึงมาจากแคช (นำกลับมาใช้ซ้ำ ต้นทุนต่ำกว่า)',
    rts_reasoningTooltip: 'โทเคนสำหรับการให้เหตุผลของโมเดลกลุ่ม reasoning (เช่น o1/o3)',
    rut_countTooltip: 'จำนวนคำถามทั้งหมดที่ผู้ใช้รายนี้ส่งในช่วงวันที่ที่เลือก',
    rut_totalQuestionsTooltip: 'จำนวนคำถามทั้งหมดของผู้ใช้แต่ละคนในช่วงวันที่',
    rut_hideTestChannelTooltip: 'เมื่อเปิดใช้งาน จะซ่อนข้อมูลจาก Chat Playground, Stream Preview และ Test Runner ออกจากรายงาน ข้อมูลเก่าที่ยังไม่มี Channel (Unknown) จะไม่ถูกซ่อน',
    rut_userIdTooltip: 'รหัสที่ขึ้นต้นด้วย DCP- มาจาก Dual Chat Playground, CP- มาจาก Chat Playground (Stream), ETR-/VG- มาจาก Test Runner (Validation) ส่วนรหัสที่ไม่มี prefix คือผู้ใช้งานจริงจากช่องทางต่าง ๆ เช่น Line, Facebook, Teams, External API',
    ruu_downloadTooltip: 'ดาวน์โหลดรายงานการใช้งานรายผู้ใช้เป็นไฟล์ Excel ไฟล์ที่ดาวน์โหลดจะรวมคอลัมน์ Channel และใช้ตัวกรอง \'ซ่อนข้อมูลทดสอบ\' ตามสถานะปัจจุบันบนหน้าจอ',
    ruu_hideTestChannelTooltip: 'เมื่อเปิดใช้งาน จะซ่อนข้อมูลจาก Chat Playground, Stream Preview และ Test Runner ออกจากรายงาน ข้อมูลเก่าที่ยังไม่มี Channel (Unknown) จะไม่ถูกซ่อน',
    ruu_userIdTooltip: 'รหัสที่ขึ้นต้นด้วย DCP- มาจาก Dual Chat Playground, CP- มาจาก Chat Playground (Stream), ETR-/VG- มาจาก Test Runner (Validation) ส่วนรหัสที่ไม่มี prefix คือผู้ใช้งานจริงจากช่องทางต่าง ๆ เช่น Line, Facebook, Teams, External API',
    ruu_usersCountTooltip: 'จำนวนผู้ใช้ที่มีการใช้งานในช่วงวันที่ที่เลือก',
    ruu_totalQuestionsTooltip: 'จำนวนคำถามทั้งหมดที่ผู้ใช้แต่ละคนส่งในช่วงวันที่',
    ruu_totalTokensTooltip: 'ผลรวมโทเคน (ขาเข้า + ขาออก) ที่ผู้ใช้แต่ละคนใช้',
    ruu_imageGenerationTooltip: 'จำนวนคำขอสร้างรูปภาพของผู้ใช้แต่ละคน',
    ruu_cachedTokensTooltip: 'โทเคนที่ดึงมาจากแคชของผู้ใช้แต่ละคน',
    ruu_reasoningTokensTooltip: 'โทเคนสำหรับการให้เหตุผลของผู้ใช้แต่ละคน',
    levt_expandDateRangeTooltip: 'ขยาย/ยุบช่วงวันที่',
    levt_expandFiltersTooltip: 'ขยาย/ยุบตัวกรอง',
    levt_clearFiltersTooltip: 'ล้างตัวกรองทั้งหมด',
    lmsg_toggleReplyTooltip: 'แสดง/ซ่อนข้อความตอบกลับทั้งหมด',
    lmsg_togglePromptTooltip: 'แสดง/ซ่อนข้อความ Prompt ทั้งหมด',
    lmsg_copyInputJsonTooltip: 'คัดลอกข้อมูลป้อนเข้าเป็น JSON',
    lmsg_copyOutputSummaryTooltip: 'คัดลอกสรุปผลลัพธ์',
    lmsg_copyContextTextTooltip: 'คัดลอกข้อความบริบททั้งหมด',
    lmsg_copyWfInputJsonTooltip: 'คัดลอกข้อมูลป้อนเข้า (waterfall) เป็น JSON',
    lmsg_copyWfOutputSummaryTooltip: 'คัดลอกสรุปผลลัพธ์ (waterfall)',
    lmsg_winningLayerTooltip: 'ชั้นที่ถูกเลือกใช้ (ตรงกับคำค้นมากที่สุด)',
    lmsg_copyWfContextTextTooltip: 'คัดลอกข้อความบริบท (waterfall) ทั้งหมด',
    lmsg_copyMcpInputJsonTooltip: 'คัดลอกข้อมูลป้อนเข้า MCP เป็น JSON',
    lmsg_copyMcpOutputSummaryTooltip: 'คัดลอกสรุปผลลัพธ์ MCP',
    lmsg_toolCallStatusTooltip: 'สถานะการเรียกใช้เครื่องมือ (สำเร็จ/ล้มเหลว)',
    lmsg_copyAiRequestJsonTooltip: 'คัดลอกคำขอ AI เป็น JSON',
    lmsg_copyAiResponseJsonTooltip: 'คัดลอกการตอบกลับ AI เป็น JSON',
    lmsg_copyIntentNameTooltip: 'คัดลอกชื่อ Intent',
    lmsg_copyIntentMessageTooltip: 'คัดลอกข้อความ Intent',
    lmsg_copyIntentReplyTooltip: 'คัดลอกการตอบกลับ Intent',
    lmsg_copyApiUrlTooltip: 'คัดลอก URL ของ API',
    lmsg_usageStatusTooltip: 'สถานะการใช้งาน (ใช้งาน/ข้าม)',
    lmsg_copyApiEndpointTooltip: 'คัดลอก Endpoint ของ API',
    lmsg_copyApiRequestBodyTooltip: 'คัดลอก Request Body ของ API',
    lmsg_copyApiResponseTooltip: 'คัดลอก Response (JSON) ของ API',
    lmsg_copyDocumentNameTooltip: 'คัดลอกชื่อเอกสาร',
    lmsg_copyDocumentTextTooltip: 'คัดลอกเนื้อหาเอกสาร',
    sec_toggleApiKeyVisibility: 'แสดง/ซ่อนค่า API Key ของโทเคนนี้',
    sec_copyApiKey: 'คัดลอก API Key ไปยังคลิปบอร์ด',
    sec_tokenActions: 'การกระทำกับโทเคน (ต่ออายุ / เพิกถอน)',
    sec_copyParameter: 'คัดลอกค่าพารามิเตอร์นี้',
    sec_copyCodeExample: 'คัดลอกโค้ดตัวอย่าง',
    setuppg_toggleSecretVisibility: 'แสดง/ซ่อนค่าที่เป็นความลับในช่องนี้',
    setuppg_removeEndpoint: 'ลบ Endpoint นี้ออกจากรายการ',
    setuppg_ssoToggleHint: 'เปิด/ปิดการเข้าสู่ระบบผ่าน {provider} สำหรับพอร์ทัล',
    setuppg_ssoChatToggleHint: 'เปิด/ปิดการเข้าสู่ระบบผ่าน {provider} สำหรับหน้าแชท',
    setuppg_syncSsoGroupsHint: 'เปิดใช้งานการซิงก์สมาชิกกลุ่มความปลอดภัยจาก Microsoft Entra',
    setuppg_jsonCredentialHint: 'อัปโหลดไฟล์ JSON ของ Service Account สำหรับเชื่อมต่อ Google (Vertex AI)',
    setuppg_callbackPathHint: 'URL ที่ผู้ให้บริการ (IdP) จะเรียกกลับหลังยืนยันตัวตน',
    setuppg_apiScopeHint: 'ขอบเขตสิทธิ์ (scope) ที่ร้องขอจากผู้ให้บริการ คั่นด้วยช่องว่าง',
    setuppg_urlConfigHint: 'URL สำหรับดึงค่าตั้งค่า OIDC (หรือ JWKS สำหรับ DGADigitalID)',
    setuppg_addDgaDigitalIdHint: 'เพิ่มการตั้งค่าผู้ให้บริการ DGA Digital ID',
    ssoc_copyIntegrationLink: 'คัดลอกลิงก์เชื่อมต่อเพื่อไปวางใน Microsoft Teams',
    ssoc_copySnippetLink: 'คัดลอกลิงก์สนิปเพ็ตสำหรับฝังบนเว็บไซต์',
    ssoc_deleteConfiguration: 'ลบการตั้งค่าช่องทางนี้',
    ssoc_toggleSecretVisibility: 'แสดง/ซ่อนค่าความลับ (Channel Secret / Token)',
    ssoc_entraVerificationToggleHint: 'เปิด/ปิดการบังคับยืนยันตัวตนผ่าน Microsoft Entra ก่อนใช้แชทช่องทางนี้',
    ssoc_liffIdHint: 'LIFF ID ของแอป LINE ที่ใช้สำหรับหน้ายืนยันตัวตน Entra',
    ssoc_channelSecretHint: 'Channel Secret ใช้ตรวจลายเซ็น webhook',
    ssoc_channelTokenHint: 'Channel Access Token ใช้เรียก Messaging API',
    ssoc_fbVerifyTokenHint: 'Verify Token ต้องตรงกับที่ตั้งไว้ในหน้า Webhook ของ Meta',
    ssoc_fbAccessTokenHint: 'Access Token ของเพจ',
    sug_searchUsers: 'ค้นหาผู้ใช้ตามชื่อผู้ใช้/อีเมล',
    sug_addSelectedUsersHint: 'เพิ่มผู้ใช้ที่เลือกไว้เข้าสู่กลุ่มนี้',
    cfgt_resetChatbotAppearance: 'รีเซ็ตไอคอน สี และชื่อแชทบอทกลับเป็นค่าเริ่มต้น',
    cfgt_chooseChatbotIcon: 'เลือกไอคอนแชทบอทหรืออัปโหลดรูปของคุณเอง',
    cfgt_resetToDefault: 'คืนค่ารูปนี้กลับเป็นค่าเริ่มต้น',
    cfgt_uploadImageHint: 'ลากวางหรือคลิกเพื่ออัปโหลดรูปสำหรับส่วนนี้',
    cfgt_colorPickerHint: 'เลือกสี (hex) สำหรับองค์ประกอบธีมนี้',
    entra_toggleSecretVisibility: 'แสดง/ซ่อนค่า Client Secret',
    entra_tenantIdHint: 'รหัส Tenant (Directory) ของ Microsoft Entra',
    entra_clientIdHint: 'รหัส Client (Application) ของแอปที่ลงทะเบียนไว้',
    entra_scopesHint: 'ขอบเขตสิทธิ์ที่ร้องขอ คั่นด้วยช่องว่าง',
    _showInactiveHint: 'แสดงรายการที่ถูกถอดการยืนยัน (inactive) ในตารางด้วย',
    _unlinkHint: 'ถอดการยืนยันตัวตน LINE↔Entra ของผู้ใช้รายนี้',
    calpg_previousPeriod: 'ไปยังช่วงเวลาก่อนหน้า',
    calpg_nextPeriod: 'ไปยังช่วงเวลาถัดไป',
    calpg_deleteEvent: 'ลบกิจกรรมนี้',
    calpg_closeDialog: 'ปิดหน้าต่างโดยไม่บันทึก',
    calpg_changeView: 'เปลี่ยนมุมมองปฏิทิน (สัปดาห์/เดือน)',
    setpg_selectImageHint: 'คลิกเพื่อเลือกไฟล์รูปโลโก้จากเครื่องของคุณ',
    setpg_snippetBubbleIconHint: 'คลิกหรือลากไฟล์รูป (PNG/JPG/GIF/WebP) หรือ PDF มาวางที่นี่',
    setpg_snippetIconConverting: 'กำลังแปลง PDF เป็นรูป...',
    setpg_snippetIconPdfFailed: 'อ่านไฟล์ PDF นี้ไม่ได้ (อาจเสียหายหรือมีรหัสผ่าน) — ลองไฟล์อื่นหรือแปลงเป็น PNG ก่อน',
    setpg_snippetShowLoginHint: 'ปิดแล้วผู้ใช้จะแชทได้แบบไม่ระบุตัวตนเท่านั้น (ไม่มีปุ่มหรือป็อปอัปชวน login)',
    setpg_snippetShowTranslateHint: 'ปิดแล้วผู้ใช้จะสลับภาษาในวิดเจ็ตไม่ได้ (ซ่อนปุ่มแปลภาษาบนแถบด้านบน)',
    setpg_snippetShowHistoryHint: 'ปิดแล้ววิดเจ็ตจะไม่มีแถบประวัติแชทด้านซ้าย (โหมดแชทเดี่ยว ไม่แสดงประวัติ)',
    setpg_snippetShowMicHint: 'ปิดแล้วกล่องพิมพ์ข้อความในวิดเจ็ตจะไม่มีปุ่มไมโครโฟน (ผู้ใช้พิมพ์ได้อย่างเดียว ไม่มีพูดเพื่อพิมพ์)',
    setpg_snippetQuickChipsHint: 'พิมพ์แล้วกด Enter เพื่อเพิ่ม · กด ✕ เพื่อลบ · เรียงลำดับด้วยการลากไม่ได้ ลำดับที่พิมพ์ = ลำดับที่แสดง · ข้อความบนชิป = คำถามที่จะถูกส่ง · เว้นว่างทั้งหมด = ใช้ชิปเริ่มต้น 9 อัน (ซ่อนชิปทั้งหมดไม่ได้) · สูงสุด 10 ชิป · ไม่เกิน 120 ตัวอักษรต่อชิป (แนะนำไม่เกิน 40 ตัวอักษรเพื่อไม่ให้ล้นบนมือถือ)',
    setpg_snippetWelcomeScopeHint: 'ข้อความและชิปนี้จะแสดงเฉพาะใน Chat Widget (snippet) ที่ฝังบนเว็บไซต์ ไม่มีผลกับหน้าแชทเต็มจอในระบบ',
    cfgconsent_saveHint: 'บันทึกข้อความยินยอมเวอร์ชันนี้',
    cfgconsent_viewPreviousVersionHint: 'ดูตัวอย่างข้อความยินยอมเวอร์ชันก่อนหน้า',
    sacomp_manageTooltip: 'เข้าจัดการบริษัทนี้ในฐานะแอดมินของบริษัท (สลับเซสชัน)',
    sacomp_editTooltip: 'แก้ไขข้อมูลบริษัทและผู้ดูแล',
    sacomp_deleteTooltip: 'ลบบริษัทนี้ถาวร',
    saumgt_editTooltip: 'แก้ไขชื่อและอีเมลผู้ใช้',
    saumgt_deleteTooltip: 'ลบผู้ใช้ซูเปอร์แอดมินนี้',
    _sa_wg_refresh_tooltip: 'โหลดผังองค์กรใหม่',
    _sa_wg_toggle_tooltip: 'ย่อ/ขยายหน่วยงานย่อย',
    wdtn_toggleTooltip: 'ย่อ/ขยายหน่วยงานย่อย',
    wdtn_menuTooltip: 'ตัวเลือกเพิ่มเติม (เพิ่ม/แก้ไข/ลบ)',
    wdtn_dragTooltip: 'ลากเพื่อย้าย/จัดลำดับหน่วยงาน',
    _sa_org_manage_tooltip: 'เข้าจัดการหน่วยงานนี้ในฐานะแอดมิน (สลับเซสชัน)',
    _sa_org_toggle_tooltip: 'ย่อ/ขยายหน่วยงานย่อย',
    _sa_org_edit_tooltip: 'แก้ไขข้อมูลหน่วยงาน',
    _sa_org_delete_tooltip: 'ลบหน่วยงานนี้',
    _sa_org_remove_child_tooltip: 'นำหน่วยงานย่อยนี้ออก',
    _sa_org_cancel_child_tooltip: 'ยกเลิกหน่วยงานย่อยที่เพิ่งเพิ่ม',
    saDashboardSearchTooltip: 'ค้นหาตามตัวกรองและโหลดข้อมูลใหม่',
    saDashboardManageTooltip: 'เข้าจัดการบริษัทนี้ในฐานะแอดมิน (สลับเซสชัน)',
    saDashboardViewDocsTooltip: 'ดูรายละเอียดเอกสารความรู้ของบริษัทนี้',
    saDashboardCloseTooltip: 'ปิด',
    saDashboardReviewStatusTooltip: 'เปลี่ยนสถานะการตรวจสอบเอกสาร',
    sasub_renewTooltip: 'ต่ออายุการสมัครสมาชิกนี้',
    sasub_cancelTooltip: 'ยกเลิกการสมัครสมาชิกนี้',
    sasub_editTooltip: 'แก้ไขรายละเอียดการสมัครสมาชิก',
    sasub_historyTooltip: 'ดูประวัติการเปลี่ยนแปลงของการสมัครสมาชิก',
    saCore_deleteEndpointTooltip: 'ลบปลายทาง Azure OpenAI นี้',
    saCore_gptModeTooltip: 'เลือกโหมดการเรียก GPT: ลำดับความสำคัญ หรือ ตอบเร็วที่สุด',
    saCore_embeddingLoadBalanceTooltip: 'กระจายโหลดการทำ embedding ข้ามหลายปลายทาง',
    saCore_streamTooltip: 'เปิด/ปิดการตอบกลับแบบสตรีมอัตโนมัติ',
    saCore_anonymousTooltip: 'อนุญาตให้ผู้ใช้ที่ไม่ได้ล็อกอินใช้งานแชท',
    saCore_forceDisableGptTooltip: 'บังคับปิดการตอบของ GPT ทั้งระบบทันที',
    saCore_autoDisableGptTooltip: 'ปิด GPT อัตโนมัติเมื่อถึงเกณฑ์ค่าใช้จ่าย/ระยะเวลา',
    saCore_enableLocalLoginTooltip: 'เปิด/ปิดการล็อกอินด้วยชื่อผู้ใช้และรหัสผ่าน',
    saCore_ssoProviderTooltip: 'เปิด/ปิด SSO ผู้ให้บริการนี้ (พอร์ทัล)',
    saCore_ssoChatTooltip: 'เปิด/ปิด SSO ผู้ให้บริการนี้ (ในแชท)',
    saSet_deleteEndpointTooltip: 'ลบปลายทาง Azure OpenAI นี้',
    saconsent_audienceToggleTooltip: 'สลับชุดข้อความที่แก้ไข (หลังบ้าน / หน้าบ้าน / นโยบายความเป็นส่วนตัว / เงื่อนไข Snippet)',
    saPersona_enabledTooltip: 'เปิด/ปิด Persona API ของบริษัทนี้ (บันทึกทันทีเมื่อสลับ)',
    saPersona_sourceEnabledTooltip: 'เปิด/ปิดแหล่งข้อมูล GDX นี้ (บันทึกทันทีเมื่อสลับ)',
    saPersona_serviceEnabledTooltip: 'เปิด/ปิดบริการนี้ (ต้องมี GDX API และกดบันทึกแถว)',
    saPersona_cacheEnabledTooltip: 'เปิด/ปิดการแคชผลลัพธ์ของบริการนี้',
    _sa_doc_more_menu: 'ตัวเลือกเพิ่มเติมของเอกสารนี้',
    _sa_doc_swap_file: 'เปลี่ยนไฟล์ที่จะอัปโหลด',
    _sa_doc_clear_file: 'ลบไฟล์ที่เลือก',
    _sa_doc_detect_pii_tooltip: 'ตรวจจับและปิดบังข้อมูลส่วนบุคคลระหว่างประมวลผล',
    _sa_doc_chunk_active_tooltip: 'เปิด/ปิดการใช้ชังก์นี้ในการค้นหา (ไม่ลบ)',
    _sa_doc_refresh_chunks: 'รีเฟรชรายการชังก์',
    _noti_navigate: 'ไปยังหน้าที่เกี่ยวข้องกับการแจ้งเตือนนี้',
    saprof_toggleIdcardTooltip: 'แสดง/ซ่อนเลขบัตรประชาชน',
    sapkg_editTooltip: 'แก้ไขแพ็กเกจนี้',
    sapkg_deleteTooltip: 'ลบแพ็กเกจนี้',
    sampkg_editTooltip: 'แก้ไขการมอบหมายแพ็กเกจ',
    sampkg_deleteTooltip: 'ลบการมอบหมายแพ็กเกจ',
    sasales_editTooltip: 'แก้ไขข้อมูลพนักงานขายนี้',
    sasales_deleteTooltip: 'ลบพนักงานขายนี้',
    navb_toggleSidebar: 'เปิด/ปิดแถบด้านข้าง',
    navb_toggleMenu: 'เปิด/ปิดเมนู',
    navb_language: 'เปลี่ยนภาษา (ไทย/อังกฤษ)',
    navb_toggleSound: 'เปิด/ปิดเสียงแจ้งเตือน',
    navb_accountMenu: 'เมนูบัญชีผู้ใช้',
    navb_clearModel: 'ล้างโมเดลที่เลือก',
    navb_createFolder: 'สร้างโฟลเดอร์ใหม่',
    navb_moreActions: 'ตัวเลือกเพิ่มเติม',
    _sa_notifications: 'การแจ้งเตือน',
    _sa_toggleLanguage: 'สลับภาษา (ไทย/อังกฤษ)',
    _sa_accountMenu: 'เมนูบัญชีผู้ใช้',
    _sa_toggleSidebar: 'ย่อ/ขยายแถบเมนู',
    _km_share_toggle_edit: 'เปิด/ปิดสิทธิ์แก้ไข',
    _km_share_toggle_delete: 'เปิด/ปิดสิทธิ์ลบ',
    termsDialogLangToggle: 'ภาษาของเอกสารนี้',
    ddfile_removeFile: 'ลบไฟล์นี้',
    ddfile_attachFile: 'แนบไฟล์',
    mdad_removeFile: 'ลบไฟล์นี้',
    mdad_clearAll: 'ล้างไฟล์ทั้งหมด',
    _noti_open: 'เปิดการแจ้งเตือน',
    ttSendMessage: 'ส่งข้อความ',
    ttSkipTyping: 'แสดงคำตอบทั้งหมดทันที',
    ttScrollToBottom: 'เลื่อนลงไปข้อความล่าสุด',
    ttSuggestionMenu: 'คำถามแนะนำและบริการ',
    ttNewConversation: 'เริ่มการสนทนาใหม่ (ล้างประวัติแชท)',
    ttCopyMessage: 'คัดลอกข้อความนี้',
    ttFeedbackLike: 'ถูกใจคำตอบนี้',
    ttFeedbackUnlike: 'ยกเลิกการถูกใจคำตอบนี้',
    ttAttach: 'แนบรูปภาพหรือไฟล์',
    ttDownloadImage: 'ดาวน์โหลดรูปภาพ',
    ttClosePreview: 'ปิดหน้าต่างรูปภาพ',
    ttRemoveAttachment: 'ลบรูปภาพที่แนบ / ลบไฟล์ที่แนบ',
    ttCarouselPrev: 'เลื่อนซ้าย',
    ttCarouselNext: 'เลื่อนขวา',
    ttTogglePassword: 'แสดง/ซ่อนรหัสผ่าน',
    flowpg_expandTextTooltip: "ขยายข้อความ",
    flowpg_collapseTextTooltip: "ย่อข้อความ",
    vproc_removeFileTooltip: "ลบไฟล์นี้ออกจากรายการที่อัปโหลด",
    pgnd_openFullStream: "เปิดหน้า Full Stream",
    pgnd_toggleSettings: "แสดง/ซ่อนแถบตั้งค่าพารามิเตอร์",
    pgnd_toggleLogPanel: "แสดง/ซ่อนแผง Debug Log (เบื้องหลังคำตอบของโมเดล A/B)",
    pgnd_logEmptyHint: "ยังไม่มีบันทึก — ส่งข้อความในแชท แล้วช่องด้านล่างจะแสดงเบื้องหลังคำตอบล่าสุดของโมเดลนี้",
    pgnd_logEmptyNoModelHint: "ยังไม่ได้เลือกโมเดลฝั่งนี้ — เลือกโมเดลแล้วส่งข้อความ ช่องด้านล่างจะแสดงเบื้องหลังคำตอบล่าสุด",
    pgnd_topicOptions: "ตัวเลือกหัวข้อ (เปลี่ยนชื่อ/ลบ)",
    strm_toggleSettings: "แสดง/ซ่อนแถบตั้งค่า",
    strm_downloadImage: "ดาวน์โหลดรูปภาพ",
    strm_closePreview: "ปิดตัวอย่างรูปภาพ",
    strm_fileOptions: "ตัวเลือกไฟล์ (ประวัติเวอร์ชัน)",
    strm_versionOptions: "ตัวเลือกเวอร์ชัน (คืนค่า/ดู)",
    strm_togglePrivateMemoryActive: "เปิด/ปิดการใช้งานไฟล์ความจำส่วนตัวนี้",
    strm_toggleChunkActive: "เปิด/ปิดการใช้งานข้อมูลส่วนนี้",
    strm_reprocessHint: "ประมวลผลเวกเตอร์ของไฟล์นี้ใหม่ทั้งหมด",
    strm_refreshProgress: "รีเฟรชสถานะความคืบหน้าการประมวลผล",
    StreamReprocessHint: "ประมวลผลเวกเตอร์ของไฟล์นี้ใหม่ทั้งหมด",
    StreamRefreshProgress: "รีเฟรชสถานะความคืบหน้าการประมวลผล",
    StreamTemplateHint: "ดาวน์โหลดไฟล์เทมเพลตสำหรับนำเข้าข้อมูล",
    fs2PmReupload: "อัปโหลดไฟล์เวอร์ชันใหม่",
    fs2PmChunkDelete: "ลบข้อมูลส่วนนี้",
    fs2ShowIdcard: "แสดงเลขบัตรประชาชน",
    fs2HideIdcard: "ซ่อนเลขบัตรประชาชน",
    lae_viewDetailTooltip: "ดูรายละเอียด",
    sgm_viewModelDetailHint: "เปิดรายละเอียดโมเดลในแท็บใหม่",
    setuppg_autoStreamHint: "เปิดใช้งานการสตรีมคำตอบแบบอัตโนมัติ (แสดงข้อความทีละส่วนขณะที่โมเดลกำลังตอบ)",
    setuppg_anonymousModeHint: "อนุญาตให้ผู้ใช้เข้าใช้งานแชทได้โดยไม่ต้องเข้าสู่ระบบ",
    setuppg_forceDisableGptHint: "บังคับปิดการตอบกลับด้วย GPT ทั้งระบบทันที",
    setuppg_autoDisableGptHint: "ปิดการตอบกลับด้วย GPT โดยอัตโนมัติเมื่อถึงเงื่อนไข (เช่น ครบระยะเวลาหรือถึงยอดค่าใช้จ่ายที่กำหนด)",
    saDashboardExportAllTooltip: "ดาวน์โหลดรายงานแดชบอร์ดทั้งหมดของช่วงวันที่ที่เลือกเป็นไฟล์ Excel",
    navb_scrollToTop: "เลื่อนขึ้นบนสุด",
    navb_clearInput: "ล้างข้อความ",
    umgt_help_rolePermissions: "กำหนดบทบาทของผู้ใช้: Super Admin ดูแลได้ทุกบริษัท, Admin จัดการเฉพาะบริษัทของตน, General User ใช้แชทได้อย่างเดียว, ส่วน Operator เป็นเจ้าหน้าที่ที่เข้ามารับช่วงสนทนาต่อจากบอท (human takeover) และเฝ้าดูบทสนทนาได้",
    umgt_help_document: "เลือกคลังความรู้ (RAG) ที่ผู้ช่วย AI ของผู้ใช้รายนี้จะค้นหาคำตอบได้ ระบบจะดึงเนื้อหาจากเอกสารในคลังที่เลือกไว้เท่านั้นมาใช้ตอบ",
    umgt_help_availableModels: "กำหนดว่าผู้ใช้รายนี้จะเลือกใช้โมเดล AI ตัวใดได้บ้างในหน้าแชท ถ้าเว้นว่างไว้ ผู้ใช้จะเห็นเฉพาะโมเดลเริ่มต้นของระบบ",
    umgt_help_databaseIntegration: "อนุญาตให้ผู้ช่วย AI ของผู้ใช้รายนี้ดึงข้อมูลจากฐานข้อมูลภายนอกที่เชื่อมต่อไว้ (Data Integration) มาประกอบคำตอบแบบเรียลไทม์",
    umgt_help_intentGroup: "เลือกชุดอินเทนต์ (คำถาม–คำตอบที่กำหนดไว้ล่วงหน้า) ที่ผู้ใช้รายนี้เรียกใช้ได้ ระบบจะจับคู่คำถามของผู้ใช้กับอินเทนต์เหล่านี้ก่อนตอบ",
    umgt_help_flows: "กำหนดโฟลว์แชทบอท (ขั้นตอนสนทนาอัตโนมัติที่ออกแบบไว้ล่วงหน้า) ที่ผู้ใช้รายนี้จะเรียกใช้งานได้",
    umgt_help_productGroup: "จำกัดขอบเขตคำตอบของผู้ช่วยให้อยู่เฉพาะกลุ่มสินค้า/บริการที่เลือก เหมาะกับการแยกผู้ช่วยตามสายผลิตภัณฑ์",
    ucm_help_modelConfiguration: "สามระดับของการกำหนดโมเดล: 'กลุ่มโมเดล' คือชุดโมเดลสำเร็จรูปที่เลือกได้ทั้งชุด, 'โมเดล' คือการเลือกโมเดลทีละตัวเพิ่มเอง, และ 'โมเดลลัด (Shortcut)' คือปุ่มลัดสลับโมเดลที่ผู้ใช้กดเปลี่ยนได้เร็วในหน้าแชท",
    ucm_help_integrationSocial: "ผูกบัญชีนี้เข้ากับตัวตนบนแพลตฟอร์มแชท: Social User ID คือ LINE User ID ส่วน Recipient ID คือรหัสผู้รับของ Facebook/Instagram เมื่อผูกแล้ว บทสนทนาจากช่องทางเหล่านั้นจะเชื่อมโยงมายังผู้ใช้รายนี้",
    ucm_help_sync: "ดึงรายชื่อผู้ใช้ล่าสุดจากระบบต้นทางที่เชื่อมต่อไว้ (เช่น SSO หรือช่องทางแชท) เข้ามาอัปเดตในตารางนี้ ผู้ใช้ที่เพิ่ม/ลบจากต้นทางจะถูกซิงค์ให้ตรงกัน",
    gum_help_statusSync: "แสดงว่ากลุ่มนี้เชื่อมและซิงค์สมาชิกกับ Microsoft Entra ID (Azure AD) แล้วหรือยัง เมื่อ 'ซิงค์แล้ว' รายชื่อสมาชิกจะอัปเดตตามกลุ่มใน Entra ID โดยอัตโนมัติ",
    gum_help_modelConfiguration: "กำหนดโมเดล AI ให้ทั้งกลุ่มผู้ใช้พร้อมกัน สมาชิกทุกคนในกลุ่มจะได้รับสิทธิ์ใช้กลุ่มโมเดลและโมเดลที่เลือกไว้ที่นี่โดยอัตโนมัติ",
    ugd_help_setup: "ตั้งค่าการเชื่อมกลุ่มนี้กับกลุ่มใน Entra ID/SSO เช่น เลือกกลุ่มต้นทางและกติกาการซิงค์สมาชิก ควรตั้งค่าที่นี่ก่อนกดปุ่มซิงค์",
    ugd_help_sync: "ดึงสมาชิกล่าสุดของกลุ่มนี้จากระบบต้นทาง (เช่น Microsoft Entra ID/SSO) เข้ามาอัปเดตรายชื่อในตาราง",
    perm_help_pageOverview: "หน้านี้ใช้ผูกบทบาท (Permission/Role) เข้ากับกลุ่มผู้ใช้ เพื่อกำหนดว่าบทบาทนั้นมีสิทธิ์ดูแลหรือเข้าถึงกลุ่มผู้ใช้กลุ่มใดบ้าง",
    perm_help_groupName: "เลือกกลุ่มผู้ใช้ที่จะให้บทบาทนี้ดูแล เลือกได้มากกว่าหนึ่งกลุ่ม",
    invm_help_pageOverview: "ส่งคำเชิญทางอีเมลให้บุคคลภายนอกมาสมัครเป็นผู้ใช้ในระบบ ผู้รับจะได้ลิงก์ลงทะเบียน เมื่อสมัครสำเร็จจะกลายเป็นผู้ใช้ตามบทบาทที่กำหนดไว้ในคำเชิญ",
    invm_help_status: "สถานะคำเชิญ: Pending = ส่งแล้วรอผู้รับสมัคร, Used = ผู้รับสมัครเรียบร้อยแล้ว, Expired = เลยกำหนดหมดอายุ, Revoked = ผู้ดูแลยกเลิกคำเชิญ, Rejected = ผู้รับปฏิเสธคำเชิญ",
    invm_help_expireIn: "กำหนดจำนวนวันที่ลิงก์คำเชิญยังใช้สมัครได้ เมื่อเลยกำหนด ลิงก์จะหมดอายุใช้ไม่ได้ และผู้รับต้องขอคำเชิญใหม่",
    invm_help_permissionUsage: "เลือกบทบาทที่ผู้รับจะได้รับหลังสมัครสำเร็จ (เช่น Admin, User, Operator) ซึ่งกำหนดสิทธิ์การใช้งานของบัญชีนั้น",
    invm_help_userDeleted: "ผู้ใช้ที่เคยสมัครผ่านคำเชิญนี้ถูกลบออกจากระบบไปแล้ว ระบบยังเก็บประวัติคำเชิญไว้เพื่ออ้างอิง",
    bcum_help_pageOverview: "รายชื่อผู้ใช้แชท (เช่น ผู้ใช้ LINE) ที่ถูกบล็อกไม่ให้ใช้งานบอท ผู้ใช้ในรายการนี้จะไม่ได้รับการตอบกลับจากผู้ช่วย AI จนกว่าจะถูกนำออกจากบัญชีดำ",
    usergroup_help_purpose: "สร้างกลุ่มผู้ใช้เพื่อรวมผู้ใช้หลายคนไว้ด้วยกัน ใช้สำหรับกำหนดสิทธิ์หรือจัดการค่าต่าง ๆ ให้ทั้งกลุ่มพร้อมกันในภายหลัง",
    mm_help_modelType: "เลือก Bot เมื่อสร้างผู้ช่วย AI ที่คุยกับผู้ใช้โดยตรง ส่วน Guard Rail คือโมเดลผู้คุมกฎที่ไม่ได้คุยกับผู้ใช้ แต่คอยตรวจ/กรองคำถามหรือคำตอบว่าเข้าข่ายผิดนโยบายหรือนอกขอบเขตหรือไม่ ก่อนปล่อยให้ Bot ตอบ",
    mm_help_guardRailModel: "เลือกโมเดลชนิด Guard Rail มาผูกกับ Bot ตัวนี้ ระบบจะส่งข้อความของผู้ใช้ให้โมเดลตัวนั้นตรวจก่อน หากพบเนื้อหาที่ผิดนโยบายหรือนอกขอบเขต จะบล็อกไว้ไม่ให้ Bot ตอบ เว้นว่างได้หากไม่ต้องการตัวกรอง",
    mm_help_groupIntent: "จับคู่ \"กลุ่มอินเทนต์ (Intent Group)\" เพื่อให้ระบบเดาว่าผู้ใช้ต้องการอะไรจากข้อความ (เช่น สอบถามสถานะ / ขอเอกสาร) แล้วเลือกเส้นทางตอบที่เหมาะสม เหมาะกับงานที่ต้องแยกประเภทคำถามก่อนตอบ",
    mm_help_promptForNoData: "ข้อความที่ให้ AI ใช้ตอบเมื่อค้นในฐานข้อมูล (SQL) แล้วไม่พบข้อมูลที่ตรงกับคำถาม เช่น \"ขออภัย ไม่พบข้อมูลที่ท่านต้องการในระบบ\" ป้องกันไม่ให้ AI เดาคำตอบเอง",
    mm_help_knowledge: "แหล่งความรู้ที่ AI จะดึงมาใช้ตอบ: เลือกคลังเอกสาร (Vector DB) เพื่อให้ตอบจากเอกสารของคุณ (RAG), กำหนด Top-N ว่าจะดึงกี่ท่อน, ตั้ง Cosine เป็นเกณฑ์ความใกล้เคียงขั้นต่ำ และเชื่อมฐานข้อมูล/Knowledge Graph เพิ่มได้ ยิ่งใส่แหล่งข้อมูลตรงประเด็น คำตอบยิ่งแม่น",
    mm_help_database: "เปิดให้ AI ตอบจากฐานข้อมูลตารางได้: เลือกตาราง (Table Name) ที่เชื่อมไว้ แล้วเลือกโมเดลที่ทำหน้าที่แปลงคำถามภาษาคนให้เป็นคำสั่ง SQL (SQL Extraction Model) ระบบจะ query ข้อมูลจริงมาตอบ ใช้เมื่อคำตอบต้องเป็นข้อมูลล่าสุด ณ ขณะนั้น เช่น ยอด/สถานะ",
    mm_help_memorySettings: "ควบคุมว่า AI จะ \"จำ\" บทสนทนาก่อนหน้าได้แค่ไหน: จำนวนรอบสนทนา = กี่รอบถาม-ตอบล่าสุดที่ส่งกลับเข้าโมเดล, ระยะเวลา (นาที) = ย้อนหลังกี่นาที, หน่วยความจำระยะสั้น = จำนวนตัวอักษรที่จำได้, หน่วยความจำระยะยาว = จดจำข้ามบทสนทนา · จำมากขึ้น = ต่อเนื่องขึ้นแต่ใช้โทเคนมากขึ้น",
    mm_help_detection: "ตั้งค่าการ \"อ่านเจตนา\" และ \"ป้องกันความปลอดภัย\" ของแชท: กลุ่มอินเทนต์ช่วยจัดหมวดคำถามก่อนตอบ ส่วนโมเดล Guard Rail ทำหน้าที่กรองเนื้อหาที่ไม่เหมาะสมหรือออกนอกขอบเขต ก่อนที่ Bot จะตอบ",
    mm_help_prefixMessage: "ข้อความนำที่จะ \"แปะไว้ต้นทุกคำตอบ\" ของ Bot (เช่น คำทักทายหรือคำเตือนว่าเป็นข้อมูล Beta) ต่างจาก System Message ที่เป็นคำสั่ง/บุคลิกเบื้องหลัง — Prefix จะแสดงให้ผู้ใช้เห็นเสมอ เปิด/ปิดได้ด้วยสวิตช์",
    mm_help_loadingBar: "เปิด Loading Bar เพื่อแสดงแอนิเมชัน \"กำลังพิมพ์…\" ในแชท LINE ระหว่างที่ AI กำลังคิดคำตอบ และตั้ง Loading Duration ว่าจะให้แสดงนานกี่วินาที ช่วยให้ผู้ใช้รู้ว่าระบบกำลังทำงานอยู่ ไม่ใช่ค้าง",
    mm_help_llmSelection: "อนุญาตให้ผู้ใช้เปลี่ยนโมเดล AI ได้เองระหว่างสนทนา หากปิดไว้ ผู้ใช้จะใช้ได้เฉพาะโมเดลที่ตั้งไว้ที่นี่เท่านั้น",
    mm_help_parameters: "พารามิเตอร์ปรับ \"สไตล์\" การตอบของโมเดล: Temperature/Top-P ต่ำ = ตอบตรง คงเส้นคงวา, สูง = สร้างสรรค์/หลากหลาย · Frequency/Presence penalty ลดการพูดซ้ำ · Max tokens จำกัดความยาวคำตอบ ค่ามาตรฐานที่ให้มามักใช้ได้ดีอยู่แล้ว",
    gmm_help_replace: "สลับให้ทุกช่องทางและกลุ่มที่กำลังใช้โมเดลนี้ ไปใช้โมเดลอีกตัวที่คุณเลือกแทน ใช้เมื่อต้องการเปลี่ยนโมเดลเบื้องหลังโดยไม่ต้องไปแก้ทีละช่องทาง ควรตรวจปลายทางให้ดีก่อนยืนยัน",
    gmm_help_publish: "เผยแพร่โมเดลให้ใช้งานจริง (สถานะเปลี่ยนจาก Draft → Publish) หลังเผยแพร่ ผู้ใช้ปลายทางจึงจะเรียกใช้โมเดลนี้ได้ ก่อนหน้านั้นจะเห็นเฉพาะผู้ดูแล",
    gmm_help_versionHistory: "ดูประวัติทุกเวอร์ชันที่เคยบันทึกของโมเดลนี้ พร้อมวันที่และผู้แก้ไข เปิดดูย้อนหลังหรือกู้คืนเวอร์ชันเก่ากลับมาใช้ได้",
    gmm_help_exportFileConfig: "ดาวน์โหลดการตั้งค่าทั้งหมดของโมเดลเป็นไฟล์ JSON ใช้สำรองข้อมูล หรือนำไป Import สร้างโมเดลเดียวกันในระบบ/บริษัทอื่น (คู่กับปุ่ม Import ด้านบน)",
    gmm_help_restore: "นำเวอร์ชันเก่านี้กลับมาเป็นเวอร์ชันที่ใช้งาน/เผยแพร่อยู่ปัจจุบัน แทนที่ค่าที่ใช้อยู่ตอนนี้ เหมาะเมื่อการแก้ไขล่าสุดมีปัญหาและต้องการย้อนกลับ",
    gmm_help_view: "เปิดดูรายละเอียดของเวอร์ชันนี้แบบอ่านอย่างเดียว โดยยังไม่นำมาใช้จริง เพื่อเทียบก่อนตัดสินใจกู้คืน",
    gmm_help_status: "Publish = โมเดลใช้งานจริง ผู้ใช้ปลายทางเรียกได้ · Draft = ยังเป็นฉบับร่าง เห็นเฉพาะผู้ดูแล ใช้ทดสอบก่อนเผยแพร่",
    gmnm_help_node: "\"โหนด (Node)\" คือชุดคำสั่งสำเร็จรูปที่นำกลับมาใช้ซ้ำได้ ประกอบด้วย Prompt หลัก + ตัวอย่างบทสนทนา (few-shot) สำหรับสอนให้ AI ตอบตามรูปแบบที่ต้องการ สร้างไว้ที่นี่แล้วเรียกไปใช้ในโมเดล/ฟีเจอร์อื่นได้",
    gmnm_help_fewShot: "แต่ละคู่คือ \"ตัวอย่างสอนโมเดล\" (few-shot): ช่อง Role ใส่บทบาทผู้พูด — user (คำถามตัวอย่างของผู้ใช้), assistant (คำตอบที่อยากให้ AI ตอบแบบนี้) หรือ system (คำสั่ง) — ช่อง Content ใส่ข้อความตัวอย่างจริง ยิ่งให้ตัวอย่างดี AI ยิ่งเลียนแบบรูปแบบได้แม่น",
    gmnd_help_fewShot: "แต่ละคู่คือ \"ตัวอย่างสอนโมเดล\" (few-shot): ช่อง Role ใส่บทบาทผู้พูด — user (คำถามตัวอย่างของผู้ใช้), assistant (คำตอบที่อยากให้ AI ตอบแบบนี้) หรือ system (คำสั่ง) — ช่อง Content ใส่ข้อความตัวอย่างจริง ยิ่งให้ตัวอย่างดี AI ยิ่งเลียนแบบรูปแบบได้แม่น",
    gmnd_help_prompt: "Prompt หลักคือคำสั่ง/บริบทตั้งต้นที่ AI ใช้เสมอ ส่วนพาเนล \"Example\" ด้านล่างคือตัวอย่างเสริมไว้สอนรูปแบบการตอบ (ไม่บังคับ)",
    mdata_help_jsonConfiguration: "เทมเพลตโครงสร้าง request (JSON) ที่ส่งไปยัง API ของโมเดล จำเป็นเฉพาะเมื่อเลือกผู้ให้บริการเป็น Other (ปลายทางที่กำหนดเอง) ตัวแปรในวงเล็บปีกกา เช่น {max_completion_tokens}, {stream} ระบบจะแทนค่าจริงให้อัตโนมัติตอนเรียกใช้ ถ้าใช้ผู้ให้บริการมาตรฐานไม่ต้องแก้ส่วนนี้",
    mdata_help_provider: "เลือกผู้ให้บริการมาตรฐาน (OpenAI, Google ฯลฯ) ได้เลย หรือเลือก Other เมื่อต้องการเชื่อมโมเดลจากปลายทางที่กำหนดเอง/โฮสต์เอง ซึ่งจะต้องกรอก Endpoint URL, ชื่อ Header สำหรับยืนยันตัวตน, API Key และเทมเพลต JSON เพิ่ม",
    mvm_help_page: "หน้านี้ใช้ผูกโมเดลเข้ากับคลังเวกเตอร์ (Vector DB) เพื่อให้โมเดลดึงเนื้อหาจากเอกสารในคลังนั้นมาตอบ (RAG) หนึ่งโมเดลผูกได้หลายคลัง เป็นการจับคู่แบบรวมศูนย์นอกเหนือจากที่ตั้งในหน้าแก้ไขโมเดล",
    mvm_help_vectorDBName: "คลังเวกเตอร์คือฐานข้อมูลที่เก็บเอกสารของคุณในรูปแบบที่ AI ค้นด้วยความหมายได้ (ไม่ใช่แค่คำตรงตัว) เลือกคลังที่มีเนื้อหาตรงกับงานของโมเดลนี้",
    mvm_help_webSearchDomains: "กำหนดรายชื่อโดเมนที่อนุญาตให้โมเดลค้นเว็บ (เช่น dga.or.th) — มีอย่างน้อย 1 โดเมน = เปิด Web Search จำกัดเฉพาะโดเมนใน list, ลบจนหมด = ปิด รองรับโมเดลข้อความทุกตัวบน Azure สูงสุด 20 โดเมน เมื่อเปิด ระบบจะค้นเว็บทุกคำถาม (ตอบช้าลงและใช้ token เพิ่มขึ้น) — แนะนำสั่งใน System Prompt ให้อ้างอิงแหล่งที่มา และให้แจ้งผู้ใช้เมื่อไม่พบข้อมูลจากแหล่งที่กำหนด; หากไม่แน่ใจเรื่อง subdomain ให้ใส่ทั้ง dga.or.th และ www.dga.or.th",
    mqg_help_shortcutGroup: "Shortcut Group คือชุดโมเดลที่จัดกลุ่มไว้ให้ผู้ใช้ \"เลือกใช้อย่างรวดเร็ว\" ในหน้าแชท ติ๊ก All Models เพื่อรวมทุกโมเดล หรือเลือกเฉพาะบางตัว พร้อมอัปโหลดไอคอนให้แต่ละโมเดลได้",
    mqr_help_command: "กำหนดปุ่มตอบด่วนที่จะโผล่ใต้ช่องแชท (LINE) ให้ผู้ใช้กดได้ทันที: Label คือข้อความบนปุ่ม, Message คือสิ่งที่ถูกส่ง/ทำงานเมื่อกด และเลือก Type ว่าเป็น message (ส่งเป็นข้อความ) หรือ postback (ส่งค่าเบื้องหลังให้ระบบประมวลผล)",
    mqr_help_labelMessage: "Label = ข้อความที่ผู้ใช้เห็นบนปุ่ม · Message = ค่าที่ระบบได้รับเมื่อผู้ใช้กดปุ่มนั้น",
    mquick_help_company: "แต่ละแถวคือการเชื่อม LINE Official Account หนึ่งบัญชี เข้ากับกลุ่มโมเดลหนึ่งกลุ่ม เมื่อผู้ใช้ทักผ่าน LINE นั้น ระบบจะตอบด้วยโมเดลในกลุ่มที่เลือก กด + เพื่อเพิ่มช่องทาง",
    mquick_help_channelCredentials: "Channel Secret และ Channel Access Token คือกุญแจยืนยันตัวตนของ LINE Official Account นำมาจากหน้า LINE Developers Console (เมนู Messaging API) ต้องกรอกให้ถูกต้อง ระบบจึงจะรับ-ส่งข้อความผ่าน LINE นี้ได้",
    mquick_help_groupModelName: "เลือกกลุ่มโมเดล (Shortcut Group) ที่ช่องทาง LINE นี้จะใช้ตอบ ผู้ใช้จะสลับเลือกได้เฉพาะโมเดลในกลุ่มนี้",
    npanel_help_nodes: "แผงนี้รวม \"บล็อก\" ที่ใช้ประกอบ Flow ลากหรือคลิกเพื่อวางลงบนผัง จัดกลุ่มเป็นหมวด: Input/Output (รับ-ส่งข้อความ), AI (โมเดล), Intent (จำแนกเจตนา), Knowledge (แหล่งความรู้), Actions (การกระทำ)",
    flst_help_versionHistory: "ประวัติเวอร์ชันเก็บ Flow ทุกครั้งที่บันทึก คุณย้อนดูหรือกู้คืนเวอร์ชันเก่าได้ตลอด การกู้คืนไม่ลบเวอร์ชันปัจจุบัน แต่สร้างเวอร์ชันใหม่จากของเดิม",
    flst_help_current: "ป้าย \"ปัจจุบัน\" (สีเขียว) ระบุเวอร์ชันที่กำลังใช้งานจริงกับบอทอยู่ตอนนี้ เวอร์ชันอื่นเป็นประวัติที่กู้คืนได้",
    flst_help_restoreThisVersion: "กู้คืนเวอร์ชันนี้ให้กลับมาเป็นเวอร์ชันปัจจุบันที่ใช้งานจริง เนื้อหาผังจะถูกแทนที่ด้วยของเวอร์ชันนี้ และระบบจะบันทึกเป็นเวอร์ชันใหม่",
    flst_help_exportFlow: "ดาวน์โหลด Flow นี้เป็นไฟล์ JSON เพื่อสำรองข้อมูลหรือนำไปนำเข้า (Import) ในระบบอื่น",
    fnode_help_advancedRouterChips: "ป้ายบนโหนด: เปอร์เซ็นต์ = เกณฑ์ความมั่นใจขั้นต่ำในการจับเจตนา, Ln = จำนวนชั้นสูงสุดของลำดับชั้นเจตนา (เช่น L2 = 2 ชั้น)",
    fnode_help_fallback: "ทางออก Fallback (F) คือเส้นทางสำรองเมื่อข้อความผู้ใช้ไม่ตรงกับเจตนาใด หรือความมั่นใจต่ำเกินไป ต่อโหนดนี้ไปยังคำตอบเริ่มต้น/ขอข้อมูลเพิ่ม",
    fnode_help_basePrompt: "ป้าย \"Base Prompt\" แสดงว่าโหนดนี้เปิดใช้การรวมพรอมต์กลางของบริษัทเข้ากับพรอมต์ของโหนด",
    fnode_help_delaySubtitle: "ข้อความใต้โหนดสรุปรูปแบบหน่วงเวลา: ค่าคงที่, ช่วงสุ่ม, หรือคำนวณจากตัวแปร",
    flow_help_aiModelNode: "โหนด AI Model คือสมองหลักที่ใช้ LLM สร้างคำตอบให้ผู้ใช้ ตั้งค่าผู้ให้บริการ (Provider) รุ่นโมเดล พฤติกรรม และพารามิเตอร์ต่าง ๆ ที่นี่ ใช้เมื่อต้องการให้บอทตอบแบบสนทนาอิสระ",
    flow_help_intentAiModelNode: "Intent AI Model คือโมเดลที่ทำหน้าที่ \"จำแนกเจตนา\" ของข้อความผู้ใช้ ว่าตรงกับ Intent ใดในโหนด Intent Router/Advanced Router โดยไม่ได้สร้างคำตอบเอง มักตั้งค่าให้แม่นยำ (temperature ต่ำ)",
    flow_help_intentRouterNode: "Intent Router แยกบทสนทนาออกเป็นหลายเส้นทางตาม \"เจตนา\" ของผู้ใช้ แต่ละ Intent มีทางออกของตัวเอง และมีทางออก Fallback เมื่อไม่ตรงกับ Intent ใดเลย เหมาะกับเมนู/หัวข้อที่กำหนดไว้ล่วงหน้า",
    flow_help_smartIntentNode: "Smart Intent ต่างจาก Intent Router ตรงที่แต่ละเจตนา \"ตอบได้เอง\" — มีโมเดล AI, พรอมต์ และแหล่งความรู้ (เอกสาร/ฐานข้อมูล/API) ของตัวเอง ใช้เมื่อแต่ละหัวข้อต้องการบุคลิกหรือความรู้เฉพาะทางต่างกัน",
    flow_help_advancedRouterNode: "Advanced Router จัดเส้นทางแบบหลายชั้น (ลำดับชั้นของเจตนา) เช่น หมวดใหญ่ → หมวดย่อย โมเดลจะเลือกกิ่งที่มั่นใจที่สุด ถ้าความมั่นใจต่ำกว่าเกณฑ์จะไปทาง Fallback เหมาะกับเมนูที่ซับซ้อนหลายระดับ",
    flow_help_knowledgeGraphNode: "Knowledge Graph ค้นความรู้จาก \"กราฟความสัมพันธ์\" ของเอนทิตี (โหนด-เส้นเชื่อม) ต่างจากการค้นเอกสารแบบเวกเตอร์ตรงที่ตามความสัมพันธ์ต่อกันได้หลายชั้น เหมาะกับคำถามที่ต้องเชื่อมโยงข้อมูลหลายจุด",
    flow_help_waterfallSearchNode: "Waterfall Search ค้นหาเป็นลำดับชั้น (Tier): เริ่มจาก Tier แรก ถ้าไม่พบคำตอบจึงไล่ลง Tier ถัดไปเรื่อย ๆ จนกว่าจะเจอ ช่วยให้ลองแหล่ง/กราฟที่แม่นยำก่อน แล้วค่อยขยายวงกว้างขึ้น",
    flow_help_databaseIntegrationNode: "Database Integration ให้ AI แปลงคำถามภาษาคนของผู้ใช้ให้เป็นคำสั่ง SQL แล้วดึงข้อมูลจริงจากตารางฐานข้อมูลมาตอบ เลือกตารางและโมเดลที่ใช้สร้าง SQL ได้ที่นี่",
    flow_help_mcpServerNode: "MCP Server เชื่อมต่อ \"เครื่องมือ/ฟังก์ชันภายนอก\" (ผ่านมาตรฐาน Model Context Protocol) ที่ AI สามารถเรียกใช้ระหว่างสนทนาได้ เช่น ดึงข้อมูลหรือทำงานในระบบอื่น กรอก URL ของเซิร์ฟเวอร์และเลือกเครื่องมือที่อนุญาต",
    flow_help_knowledgeApiNode: "Knowledge API เรียก API ภายนอกของคุณ แล้วนำ \"ผลลัพธ์ที่ได้\" มาเป็นความรู้เพิ่มเติมให้ AI ใช้ตอบ กำหนด URL, เมธอด, Header และ Body (แทรกตัวแปรจากบทสนทนาได้)",
    flow_help_documentsNode: "โหนด Documents ค้นหาส่วนของเอกสาร (chunk) ที่เกี่ยวข้องกับคำถาม แล้วส่งให้ AI ใช้อ้างอิงในการตอบ (เทคนิค RAG) เลือกชุดเอกสารและจำนวน chunk ที่จะดึงได้",
    flow_help_switchNode: "Switch แยกบทสนทนาได้หลายเส้นทางตามเงื่อนไข (ต่างจากโหนด If ที่มีแค่ จริง/เท็จ) แต่ละทางออกมีเงื่อนไขของตัวเอง และมีทางออก Default เมื่อไม่ตรงเงื่อนไขใดเลย",
    flow_help_conditionNode: "โหนด If ตรวจเงื่อนไขเดียวแล้วแยกเป็น 2 ทาง: จริง (True) และ เท็จ (False) ใช้ตัดสินใจง่าย ๆ เช่น ตรวจค่าหรือข้อความ ก่อนเดินต่อในเส้นทางที่เหมาะสม",
    flow_help_contactAgentNode: "Contact Agent ส่งต่อบทสนทนาให้เจ้าหน้าที่ที่เป็นคนจริง และ \"ปิดบอทชั่วคราว\" สำหรับผู้ใช้รายนั้น ใช้เป็นปลายทางเมื่อบอทตอบไม่ได้หรือผู้ใช้ขอคุยกับคน",
    flow_help_delayNode: "โหนด Delay หน่วงเวลาก่อนไปขั้นต่อไป: Fixed = เวลาคงที่, Random = สุ่มช่วงเวลา (ให้ดูเป็นธรรมชาติ), Variable = คำนวณจากสูตร/ตัวแปร",
    flow_help_temperature: "Temperature คุมความสร้างสรรค์/สุ่มของคำตอบ: ค่าต่ำ (0–0.3) ตอบตรง คงเส้นคงวา เหมาะงานที่ต้องแม่นยำ; ค่าสูง (0.7–1) หลากหลายและสร้างสรรค์ขึ้นแต่คุมยาก ค่าแนะนำทั่วไป 0.2–0.7",
    flow_help_topP: "Top P (nucleus sampling) จำกัดให้โมเดลเลือกคำจากกลุ่มความน่าจะเป็นสะสมสูงสุดเท่านั้น เช่น 0.9 = พิจารณาเฉพาะคำที่รวมกันได้ 90% ค่าต่ำลง = คำตอบแคบ/ปลอดภัยขึ้น โดยทั่วไปตั้ง 1 แล้วปรับ Temperature แทน",
    flow_help_frequencyPenalty: "Frequency Penalty ลดการพูดคำเดิม \"ซ้ำ ๆ บ่อย ๆ\" ยิ่งค่าสูง (0–2) ยิ่งเลี่ยงคำที่ใช้ไปแล้วมาก เหมาะเมื่อคำตอบวนซ้ำคำเดิม ค่าปกติ 0",
    flow_help_presencePenalty: "Presence Penalty กระตุ้นให้พูดถึง \"หัวข้อ/คำใหม่ ๆ\" ต่างจาก Frequency Penalty ที่นับจำนวนครั้ง — Presence สนใจแค่ว่าคำนั้นเคยปรากฏหรือยัง ค่าสูงทำให้คำตอบกระจายหัวข้อมากขึ้น ค่าปกติ 0",
    flow_help_maxTokens: "Max Tokens จำกัดความยาวสูงสุดของคำตอบ (1 token ≈ ครึ่งคำภาษาไทย/1 คำสั้นภาษาอังกฤษ) ตั้งต่ำเกินไปคำตอบอาจถูกตัดกลางประโยค ตั้งสูงขึ้นได้คำตอบยาวขึ้นแต่ช้าและมีค่าใช้จ่ายมากขึ้น",
    flow_help_stopSequence: "Stop Sequence คือข้อความที่เมื่อโมเดลสร้างถึงตรงนี้จะ \"หยุดทันที\" ใช้ตัดคำตอบไม่ให้เกินจุดที่กำหนด เช่น หยุดก่อนขึ้นหัวข้อใหม่ ปล่อยว่างได้ถ้าไม่ต้องการ",
    flow_help_useBaseModelPrompt: "เมื่อเปิด ระบบจะรวม \"พรอมต์กลางของบริษัท\" (Base Prompt) เข้ากับพรอมต์ของโหนดนี้ ทำให้บอททุกโหนดมีบุคลิก/กติกาพื้นฐานเหมือนกันโดยไม่ต้องพิมพ์ซ้ำ ปิดถ้าต้องการให้โหนดนี้ใช้พรอมต์เฉพาะของตัวเองล้วน ๆ",
    flow_help_streamResponse: "เปิด = แสดงคำตอบทีละคำแบบพิมพ์สด ผู้ใช้เห็นผลเร็วขึ้น (เหมาะกับคำตอบยาว); ปิด = รอจนตอบเสร็จแล้วส่งทีเดียว หมายเหตุ: การสตรีมจะทำให้แคช (Cache) ไม่ทำงาน",
    flow_help_jsonResponse: "เปิดเมื่อต้องการให้ AI ตอบเป็นโครงสร้าง JSON แทนข้อความปกติ เพื่อให้โหนดถัดไป (เช่น API/เงื่อนไข) นำไปแยกค่าใช้งานต่อได้ ต้องระบุรูปแบบ JSON ที่ต้องการในพรอมต์ด้วย",
    flow_help_memorySettings: "ตั้งค่าความจำบทสนทนา: Turn Count = จำกี่รอบถาม-ตอบล่าสุด, Duration = จำนานกี่นาที, Short-Term = ขนาดบริบทที่ส่งให้โมเดลรอบนี้, Long-Term = บันทึกถาวรข้ามเซสชัน เปิดเมื่อบอทต้องจำสิ่งที่คุยไปแล้ว",
    flow_help_longTermMemory: "เปิดเพื่อบันทึกความจำแบบถาวร ผู้ใช้กลับมาคุยใหม่ภายหลังบอทยังจำข้อมูลเดิมได้ (ต่างจากความจำระยะสั้นที่หายเมื่อจบบทสนทนา)",
    flow_help_cacheSettings: "แคชเก็บคำตอบที่เคยสร้างไว้ เพื่อตอบคำถามซ้ำได้ทันทีโดยไม่เรียก LLM ใหม่ ช่วยลดเวลาและค่าใช้จ่าย หมายเหตุ: แคชจะข้ามการทำงานเมื่อเปิดสตรีมหรือมีการต่อฐานข้อมูล/เชื่อมข้อมูลแบบทันที",
    flow_help_semanticCache: "เปิดเพื่อให้แคชจับคู่คำถามที่ \"ความหมายคล้ายกัน\" ไม่ใช่ต้องพิมพ์เหมือนเป๊ะ เช่น \"เปิดกี่โมง\" กับ \"เวลาทำการ\" ถือว่าเหมือนกัน เพิ่มโอกาสใช้แคชได้มากขึ้น",
    flow_help_similarityThreshold: "เกณฑ์ความคล้ายที่ถือว่าคำถาม \"เหมือนกันพอ\" ที่จะใช้คำตอบจากแคช ค่าสูง (เช่น 95%) = เข้มงวด ตรงมากถึงใช้ซ้ำ; ค่าต่ำ = ยืดหยุ่นแต่เสี่ยงตอบผิดบริบท แนะนำ 85–95%",
    flow_help_cacheScope: "เลือกว่าใครใช้คำตอบจากแคชร่วมกันได้: ทั้งบริษัท (ทุกคนใช้ร่วมกัน ประหยัดสุด) หรือ เฉพาะผู้ใช้รายนั้น (กันไม่ให้ปนข้อมูลเฉพาะบุคคล) เลือกให้เหมาะกับความเป็นส่วนตัวของคำตอบ",
    flow_help_cacheTtl: "ระยะเวลาที่เก็บคำตอบไว้ในแคช (นาที) ก่อนถือว่าหมดอายุและต้องสร้างใหม่ ตั้งสั้นถ้าข้อมูลเปลี่ยนบ่อย ตั้งยาวถ้าคำตอบค่อนข้างคงที่",
    flow_help_confidenceThreshold: "เกณฑ์ความมั่นใจขั้นต่ำที่จะยอมรับว่าโมเดลจับเจตนาถูก ถ้าความมั่นใจต่ำกว่านี้จะส่งไปทาง Fallback ตั้งสูง = ปลอดภัย แต่ตกไป Fallback บ่อย; ตั้งต่ำ = จับคู่ง่ายแต่เสี่ยงผิด แนะนำ 60–80%",
    flow_help_maximumIntentDepth: "จำนวนชั้นสูงสุดของเจตนาที่ให้โมเดลไล่ลึกลงไป เช่น 2 ชั้น = หมวดใหญ่ → หมวดย่อย ยิ่งลึกยิ่งจำแนกละเอียดแต่ต้องตั้งค่าเจตนาย่อยมากขึ้นและช้าลง",
    flow_help_customResponseSchema: "สำหรับผู้ให้บริการ Google เท่านั้น: กำหนดรูปแบบ JSON ที่บังคับให้โมเดลตอบกลับ เพื่อระบุชื่อฟิลด์ของเจตนา/ความมั่นใจ/เจตนาย่อยเอง ใช้เมื่อโครงสร้างเริ่มต้นไม่ตรงกับที่ต้องการ",
    flow_help_searchMode: "วิธีค้นหาในกราฟ: fuzzy-first เน้นจับชื่อที่พิมพ์คล้าย, semantic-first เน้นความหมาย, bm25-node-name จับคำตรงตัวในชื่อโหนด, hybrid-union รวมผลหลายวิธี, hybrid-rerank รวมแล้วจัดอันดับใหม่ให้แม่นขึ้น, baseline-vector-only ค้นด้วยเวกเตอร์ล้วน เริ่มจาก fuzzy-first ถ้าไม่แน่ใจ",
    flow_help_maxHops: "จำนวนชั้นความสัมพันธ์สูงสุดที่จะเดินตามในกราฟจากจุดเริ่ม เช่น 2 hops = ตามความเชื่อมโยงได้ 2 ต่อ ยิ่งมากยิ่งได้บริบทกว้างแต่ช้าและอาจมีข้อมูลไม่เกี่ยวปน (ค่าเริ่มต้น 3)",
    flow_help_fuzzySemanticThreshold: "Fuzzy Threshold (0–100) = ความเข้มงวดในการจับชื่อที่สะกดคล้าย ยิ่งสูงยิ่งต้องเหมือน; Semantic Threshold (0–1) = ความเข้มงวดในการจับความหมายใกล้เคียง ยิ่งสูงยิ่งต้องตรงความหมาย ตั้งสูงเกินไปอาจหาไม่เจอ",
    flow_help_maxContextNodesEdges: "จำกัดจำนวนโหนด/เส้นเชื่อมจากกราฟที่จะส่งเป็นบริบทให้ AI ยิ่งมากยิ่งครบถ้วนแต่ใช้ token มากและช้าลง ลดลงถ้าคำตอบยาว/ช้าเกินไป (ค่าเริ่มต้น 30 โหนด / 60 เส้น)",
    flow_help_baselineTopKMinSimilarity: "ใช้เฉพาะโหมด baseline-vector-only: Top-K = จำนวนผลลัพธ์ใกล้เคียงที่สุดที่ดึงมา, Min Similarity = คะแนนความคล้ายขั้นต่ำ (0–1) ที่ยอมรับ ผลที่ต่ำกว่านี้จะถูกตัดทิ้ง",
    flow_help_includeMiniappTier: "เปิดเพื่อเพิ่มการค้นจากแหล่ง MiniApp เป็น Tier แรกก่อนไล่ค้นในกราฟความรู้ ใช้เมื่อคำตอบส่วนใหญ่อยู่ใน MiniApp และอยากให้ลองที่นั่นก่อน",
    flow_help_citationContext: "เปิดเพื่อให้คำตอบแนบ \"แหล่งอ้างอิง\" ที่ดึงมาจากกราฟ ผู้ใช้เห็นได้ว่าข้อมูลมาจากไหน เพิ่มความน่าเชื่อถือ Citation Prompt ใช้กำหนดรูปแบบการอ้างอิง",
    flow_help_mcpMode: "โหมดการใช้เครื่องมือ: Agentic = ให้ AI เลือกและเรียกเครื่องมือเองหลายครั้งจนได้คำตอบ (ยืดหยุ่นสุด); Single Tool = เรียกเครื่องมือเดียวที่กำหนดไว้แบบตายตัว (คาดเดาผลได้และควบคุมง่ายกว่า)",
    flow_help_toolChoice: "บังคับการเรียกเครื่องมือ: auto = ให้ AI ตัดสินใจเองว่าจะใช้เครื่องมือหรือไม่, required = ต้องเรียกเครื่องมืออย่างน้อยหนึ่งครั้งเสมอ, none = ห้ามใช้เครื่องมือ (ตอบด้วยความรู้ของโมเดลล้วน)",
    flow_help_maxToolIterations: "จำนวนรอบสูงสุดที่ AI เรียกเครื่องมือซ้ำได้ในโหมด Agentic ก่อนต้องสรุปคำตอบ ป้องกันการวนไม่รู้จบ ตั้งสูงขึ้นได้งานซับซ้อนแต่ช้าและมีค่าใช้จ่ายมากขึ้น",
    flow_help_connectTimeout: "เวลารอเชื่อมต่อเซิร์ฟเวอร์ MCP สูงสุด (วินาที) ถ้าเกินนี้ถือว่าเชื่อมต่อไม่สำเร็จ ตั้งสูงขึ้นถ้าเซิร์ฟเวอร์ตอบช้า",
    flow_help_selectedTools: "เลือกเฉพาะเครื่องมือที่อนุญาตให้ AI ใช้ ปล่อยว่างไว้ = อนุญาตทุกเครื่องมือที่เซิร์ฟเวอร์มี กด \"ค้นหาเครื่องมือ\" เพื่อดึงรายการจากเซิร์ฟเวอร์ก่อน",
    flow_help_knowledgeSources: "เลือกแหล่งความรู้ที่ให้เจตนานี้ใช้ประกอบการตอบ: Documents (ค้นเอกสาร), Database Integration (ดึงข้อมูลจากฐานข้อมูลด้วย SQL), Products (แคตตาล็อกสินค้า), Knowledge API (เรียก API ภายนอก) เปิดเฉพาะที่จำเป็นเพื่อให้ตอบตรงและเร็ว",
    flow_help_topNChunks: "จำนวน \"ส่วนของเอกสาร\" (chunk) ที่ดึงมาให้ AI อ้างอิงต่อคำถาม มากขึ้น = ครอบคลุมข้อมูลกว้างแต่ใช้ token มากและอาจมีเนื้อหาไม่เกี่ยวปน น้อยไปอาจได้ข้อมูลไม่พอ แนะนำเริ่มที่ 3–5",
    flow_help_timeContext: "เปิดเพื่อแทรก \"วันเวลาปัจจุบัน\" ตามโซนเวลาที่เลือกเข้าไปในพรอมต์ ทำให้บอทตอบเรื่องเวลาได้ถูก เช่น \"วันนี้วันอะไร\" หรือ \"ตอนนี้เปิดอยู่ไหม\"",
    flow_help_addTransactionId: "เปิดเพื่อแนบรหัสอ้างอิงธุรกรรม (Transaction ID) ของบทสนทนาเข้าไปในพรอมต์ ใช้เมื่อต้องการให้บอทอ้างอิงหรือติดตามรายการเฉพาะของผู้ใช้",
    flow_help_useMemory: "เปิดเพื่อให้เจตนานี้ใช้ประวัติบทสนทนาก่อนหน้าประกอบการตอบ ปิดถ้าต้องการให้ตอบแบบเริ่มใหม่ทุกครั้งโดยไม่อิงบริบทเดิม (เช่น คำสั่งที่เป็นอิสระต่อกัน)",
    flow_help_editBasePrompt: "เปิดเพื่อแก้ \"พรอมต์พื้นฐาน\" เฉพาะของเจตนานี้ (บุคลิก/กติกากว้าง ๆ) แยกจากช่อง Intent Prompt ที่ใช้บอกวิธีจับคู่เจตนา ปิดไว้จะใช้พรอมต์พื้นฐานเดิมของกลุ่ม",
    flow_help_exampleMessages: "ใส่ตัวอย่างข้อความที่ผู้ใช้มักพิมพ์สำหรับเจตนานี้ ระบบใช้เป็นตัวอย่าง (few-shot) ให้โมเดลจับคู่เจตนาแม่นขึ้น ยิ่งตัวอย่างหลากหลายยิ่งแม่น",
    flow_help_sqlExtractionModel: "เลือกโมเดล AI ที่ทำหน้าที่ \"แปลงคำถามของผู้ใช้ให้เป็นคำสั่ง SQL\" เพื่อดึงข้อมูลจากตาราง ควรใช้โมเดลที่เก่งด้านโค้ด/เหตุผลเพื่อให้ SQL ถูกต้อง",
    flow_help_promptForNoData: "ข้อความที่บอทจะตอบเมื่อ SQL ค้นแล้วไม่พบข้อมูลที่ตรงคำถาม ตั้งให้สุภาพและแนะแนวทางต่อ เช่น ให้ลองถามใหม่หรือให้ข้อมูลเพิ่ม",
    flow_help_simpleAdvancedCondition: "Simple = สร้างเงื่อนไขจากแบบฟอร์มสำเร็จรูป (เลือกฟิลด์/ตัวดำเนินการ/ค่า) เหมาะกับผู้เริ่มต้น; Advanced = เขียนนิพจน์เงื่อนไขเอง (เช่น input.confidence > 0.8) ยืดหยุ่นกว่าแต่ต้องรู้ไวยากรณ์",
    flow_help_expectedValue: "เลือกค่าที่ต้องการให้เป็น \"จริง\" สำหรับเงื่อนไขนี้ ระบบจะเทียบค่าจากฟิลด์ต้นทาง (เช่น user.isLoggedIn) กับค่านี้ ถ้าตรงกันจึงไปทาง True",
    flow_help_exportImportFlow: "Export = บันทึกทั้ง Flow เป็นไฟล์ JSON เพื่อสำรองหรือย้ายไปใช้ที่อื่น; Import = โหลด Flow จากไฟล์ JSON เข้ามาแทนที่ผังปัจจุบัน",
    flow_help_clearFlow: "ลบทุกโหนดและเส้นเชื่อมออกจากผังทั้งหมด เพื่อเริ่มสร้าง Flow ใหม่ตั้งแต่ต้น (ยกเลิกได้ด้วย Ctrl+Z ก่อนบันทึก)",
    dint_help_section: "เมนูนี้ใช้เชื่อมข้อมูลแบบตาราง (Excel ที่อัปโหลด หรือฐานข้อมูลภายนอก เช่น SQL Server/Oracle) เพื่อให้บอทค้นและตอบจากข้อมูลที่มีโครงสร้าง เช่น ราคา สต๊อก หรือรายการต่าง ๆ ต่างจากคลังความรู้แบบเอกสาร (vector) ที่ใช้กับเนื้อหาแบบข้อความยาว",
    dint_help_systemType: "เลือก \"ภายใน (Internal)\" เมื่อจะอัปโหลดไฟล์ Excel ให้ระบบเก็บข้อมูลไว้เอง หรือเลือก \"ภายนอก (External)\" เมื่อจะเชื่อมต่อฐานข้อมูลจริงของคุณผ่าน Connection String โดยระบบจะดึงข้อมูลล่าสุดทุกครั้งที่ถาม",
    dint_help_getAllColumns: "เมื่อเปิด ระบบจะดึงทุกคอลัมน์จากตาราง/วิว (View) ที่เชื่อมต่อโดยอัตโนมัติ ไม่ต้องเพิ่มทีละคอลัมน์เอง ปิดไว้ถ้าต้องการเลือกเฉพาะคอลัมน์ที่จำเป็น",
    dint_help_fuzzyMatching: "การจับคู่แบบยืดหยุ่น (Fuzzy) ช่วยให้ค้นเจอแม้ผู้ใช้พิมพ์ไม่ตรงเป๊ะ (สะกดผิด/เว้นวรรคต่าง): \"None\" = ต้องตรงทุกตัวอักษร, \"Fuzzy Search\" = ยอมให้คลาดเคลื่อนเล็กน้อย, \"Fuzzy with Bot\" = ให้บอท/LLM ช่วยตีความคำถามก่อนจับคู่ เหมาะกับคำถามที่เป็นประโยคยาว",
    dint_help_columnType: "เลือกชนิดข้อมูลของคอลัมน์: nvarchar = ข้อความ, int = จำนวนเต็ม, float = ทศนิยม, datetime = วันที่-เวลา, bit = ใช่/ไม่ใช่ ชนิดนี้กำหนดวิธีเก็บและค้นหา และมีเฉพาะคอลัมน์ข้อความเท่านั้นที่เปิด Fuzzy/ข้อมูลส่วนบุคคลได้",
    dintd_help_panels: "แผง \"Configuration\" ใช้กำหนดโครงสร้าง เช่น ชื่อคอลัมน์ ชนิดข้อมูล การจับคู่ Fuzzy และธงข้อมูลส่วนบุคคล ส่วนแผง \"Data\" คือที่ดู/ค้นหา/เพิ่ม/อัปโหลด (Excel) ข้อมูลจริงในตาราง — ปรับโครงสร้างก่อน แล้วค่อยจัดการข้อมูล",
    uvec_help_processingMethod: "วิธีนี้กำหนด \"การตัดแบ่งเนื้อหาเป็นชิ้น (chunk)\" ก่อนสร้างเวกเตอร์: General = ตัดอัตโนมัติตามค่ามาตรฐาน · MaxCharacter = ตัดตามจำนวนตัวอักษรสูงสุดที่กำหนด · CustomSplit = ใส่ตัวคั่นเองเพื่อคุมจุดตัดแม่นยำ · Article = เก็บทั้งบทความเป็นชิ้นเดียว (เนื้อหายาวต่อเนื่อง) · HeaderAllChunk = ใส่หัวข้อซ้ำในทุกชิ้นเพื่อคงบริบท · HeaderFirstChunk = ใส่หัวข้อเฉพาะชิ้นแรก · WordImage/PDFImage = ดึงทั้งข้อความและรูปจากไฟล์ Word/PDF",
    uvec_help_vectorType: "เลือกให้เข้ากับรูปแบบเนื้อหา: General = เนื้อหาความรู้ทั่วไป · Article = บทความ/ข้อความยาว · PriceList = ตารางราคา/สินค้า ระบบจะปรับวิธีตัดชิ้นและค้นคืนให้เหมาะกับชนิดที่เลือก",
    ucsv_help_shareAction: "แชร์ (Share): ให้บริษัทอื่นเข้าถึงเอกสารนี้ (ดู/แก้/ลบ ตามสิทธิ์ที่กำหนด)",
    ucsv_help_duplicateAction: "ทำสำเนา (Duplicate): คัดลอกเอกสารนี้เป็นชื่อใหม่ โดยต้นฉบับไม่เปลี่ยนแปลง",
    ucsv_help_replaceAction: "แทนที่ (Replace): นำเนื้อหาของเอกสารนี้ไปทับเอกสารอีกตัวที่เลือก",
    ucsv_help_versionHistoryAction: "ประวัติเวอร์ชัน (Version history): ดูและกู้คืนเวอร์ชันก่อนหน้าของเอกสาร",
    ucsv_help_restoreVersion: "กู้คืน (Restore): นำเวอร์ชันนี้กลับมาเป็นเวอร์ชันปัจจุบัน (แทนที่ของเดิม)",
    ucsv_help_viewVersion: "ดู (View): เปิดดูเนื้อหาของเวอร์ชันนั้นแบบอ่านอย่างเดียว โดยไม่เปลี่ยนเวอร์ชันปัจจุบัน",
    ucsv_help_processStatus: "ตัวเลขนี้แสดงความคืบหน้าการสร้างเวกเตอร์: จำนวนชิ้น (chunk) ที่ฝัง (embed) เสร็จ / จำนวนทั้งหมด สีเทา = ยังไม่เริ่ม, สีส้ม = กำลังประมวลผล, สีเขียว = เสร็จครบพร้อมใช้งานกับบอท",
    ucsv_help_personalInfoDetection: "เมื่อเปิด ระบบจะตรวจจับและปิดบังข้อมูลส่วนบุคคล (PII) เช่น ชื่อ เบอร์โทร เลขบัตรประชาชน ในเนื้อหาก่อนส่งให้ AI ประมวลผล เพื่อลดความเสี่ยงข้อมูลรั่วไหล",
    pdf_help_toolPurpose: "เครื่องมือนี้แปลงไฟล์ PDF ให้เป็นข้อความรูปแบบ Markdown ที่สะอาดและมีโครงสร้าง เหมาะสำหรับนำไปอัปโหลดเข้าคลังความรู้ (vector) ต่อ ช่วยให้บอทอ่านเนื้อหาจาก PDF ได้แม่นยำกว่าการอัปโหลด PDF ดิบ",
    pdf_help_testCasePurpose: "หน้านี้ใช้สร้างชุด test case สำหรับทดสอบโมเดลจากไฟล์เอกสารที่อัปโหลด โดยให้ AI อ่านเนื้อหาแล้วร่างคำถามและคำตอบที่คาดหวังให้อัตโนมัติ จากนั้นดาวน์โหลดไปใช้ในการทดสอบต่อได้",
    kgl_help_concept: "Knowledge Graph คือการจัดเก็บความรู้เป็น \"โหนด (สิ่งของ/บุคคล/แนวคิด)\" และ \"ความสัมพันธ์\" ที่เชื่อมโยงกัน ช่วยให้บอทเข้าใจบริบทและตอบคำถามที่ต้องเชื่อมโยงหลายข้อมูลได้ดีกว่าการค้นแบบข้อความล้วน สร้างกราฟใหม่แล้วเพิ่มโหนดจากไฟล์/โฟลเดอร์เพื่อเริ่มใช้งาน",
    kgde_help_editor: "หน้านี้คือพื้นที่แก้ไข Knowledge Graph: เพิ่มโหนดจากไฟล์หรือโฟลเดอร์ เชื่อมความสัมพันธ์ระหว่างโหนด และดูผังกราฟแบบเห็นภาพ เมื่อกราฟยังว่าง ระบบจะเปิดหน้าต่าง \"เพิ่มโหนดจากไฟล์\" ให้อัตโนมัติ",
    usd_help_pagePurpose: "หน้านี้ใช้ถอดเสียง (speech-to-text) จากไฟล์เสียงที่อัปโหลดให้เป็นข้อความ และเลือกให้ AI สรุปย่อได้ จากนั้นนำเข้าไปเก็บในคลังความรู้เพื่อให้บอทนำไปตอบได้",
    usd_help_botSummation: "เมื่อเปิด ระบบจะให้โมเดล AI ที่เลือกช่วยสรุปย่อข้อความที่ถอดจากเสียงก่อนบันทึก ช่วยตัดส่วนที่ไม่จำเป็นและได้เนื้อหากระชับ ถ้าปิดจะเก็บข้อความถอดเสียงเต็มตามต้นฉบับ",
    usd_help_language: "เลือกภาษาที่พูดในไฟล์เสียง เพื่อให้ระบบถอดเสียงได้ถูกต้อง (เช่น ไทย หรือ อังกฤษ) — ไม่ใช่ภาษาของหน้าจอ",
    usd_help_maxSplitCharacters: "กำหนดจำนวนตัวอักษรสูงสุดต่อหนึ่งชิ้น (chunk) เมื่อนำข้อความเข้าคลังความรู้ ค่าน้อย = ชิ้นสั้นและเจาะจงขึ้น, ค่ามาก = ชิ้นยาวเก็บบริบทได้มากขึ้น (ค่าเริ่มต้น 5000)",
    usdd_help_textColumns: "\"ข้อความต้นฉบับ (Original Text)\" คือคำที่ถอดจากเสียงแบบเต็ม ส่วน \"ข้อความสรุป (Summarized Text)\" คือฉบับที่โมเดล AI ย่อให้กระชับ (เครื่องหมาย \"-\" หมายถึงยังไม่ได้สรุป) เวลานำเข้าคลังความรู้ ระบบจะใช้ฉบับสรุปก่อนถ้ามี",
    ptmpl_help_statusToggle: "เปิดสวิตช์เพื่อ \"ใช้งาน\" พรอมต์เทมเพลตนี้ ระบบจะนำข้อความพรอมต์ไปกำหนดพฤติกรรมและคำตอบของ AI ทันที ส่วนเทมเพลตที่ปิดอยู่จะถูกบันทึกไว้เฉย ๆ โดยไม่ถูกนำไปใช้",
    ptmpl_help_promptText: "ช่องนี้คือชุดคำสั่ง (พรอมต์) ที่ส่งให้ AI เพื่อกำหนดบทบาท น้ำเสียง และกติกาการตอบ เช่น \"คุณเป็นเจ้าหน้าที่ประชาสัมพันธ์ ตอบสุภาพและกระชับ\" ยิ่งเขียนชัดเจน คำตอบยิ่งตรงตามต้องการ",
    ptmpl_help_groupName: "ชื่อกลุ่มใช้จัดกลุ่มพรอมต์เทมเพลตหลายรายการไว้ด้วยกัน เมื่อสร้างกลุ่มแล้วชื่อจะถูกล็อก และสามารถเพิ่มเทมเพลตย่อยเข้าไปในกลุ่มนี้ได้",
    gptmpl_help_pageOverview: "หน้านี้คือรายการ \"กลุ่มพรอมต์เทมเพลต\" แต่ละกลุ่มรวมชุดคำสั่งที่ใช้กำหนดบุคลิกและวิธีตอบของ AI คลิกแก้ไขเพื่อเข้าไปจัดการเทมเพลตย่อยภายในกลุ่ม",
    rtext_help_pageOverview: "ฟีเจอร์แทนที่คำ (Replace Text) จะค้นหา \"ข้อความต้นฉบับ\" ที่กำหนดในบทสนทนา แล้วเปลี่ยนเป็น \"ข้อความแทนที่\" โดยอัตโนมัติ เหมาะกับการปรับคำให้เป็นมาตรฐาน แก้คำเฉพาะ หรือแปลงคำเรียกสินค้า/หน่วยงานให้ตรงกัน",
    rtext_help_replaceFields: "ข้อความต้นฉบับ = คำที่ระบบจะค้นหา, ข้อความแทนที่ = คำที่จะนำไปใส่แทน ตัวอย่าง ต้นฉบับ \"ฟุตบอล\" แทนที่ด้วย \"Football\" ทุกครั้งที่พบคำว่า \"ฟุตบอล\" จะถูกเปลี่ยนเป็น \"Football\"",
    grtext_help_pageOverview: "หน้านี้คือรายการ \"กลุ่มการแทนที่คำ\" แต่ละกลุ่มรวมคู่คำ (ต้นฉบับ → แทนที่) ไว้ด้วยกัน คลิกแก้ไขเพื่อเข้าไปจัดการคู่คำภายในกลุ่ม",
    grtext_help_totalNumber: "จำนวนคู่คำที่ตั้งค่าไว้ในกลุ่มนี้ (รวมรายการต้นฉบับ→แทนที่ทั้งหมด)",
    scmenu_help_pageOverview: "เมนูลัด (Shortcut) คือปุ่มคำสั่งสำเร็จรูปที่แสดงในหน้าแชท เมื่อผู้ใช้กดปุ่ม ระบบจะส่งข้อความที่ตั้งไว้ให้อัตโนมัติ ช่วยให้ผู้ใช้เริ่มบทสนทนายอดนิยมได้เร็วขึ้น",
    scmenu_help_labelVsMessage: "Label = ข้อความที่แสดงบนปุ่มให้ผู้ใช้เห็น, Message = ข้อความจริงที่ถูกส่งเข้าแชทเมื่อกดปุ่มนั้น ทั้งสองค่าตั้งให้ต่างกันได้",
    scmenu_help_uploadVsPreview: "คอลัมน์ \"อัปโหลดรูป\" ใช้เลือกไฟล์ไอคอนของปุ่มลัด ส่วนคอลัมน์ตัวอย่างจะแสดงรูปที่อัปโหลดแล้วเพื่อยืนยันความถูกต้อง",
    mmgt_help_pageOverview: "หน้าจัดการเมนูใช้กำหนดว่ากลุ่มผู้ใช้ (User Group) ใดมองเห็นและเข้าถึงเมนู/เมนูย่อยใดได้บ้าง เลือกเมนูที่ต้องการ เลือกกลุ่มผู้ใช้ แล้วบันทึกเพื่อผูกสิทธิ์การเข้าถึง",
    mmgt_help_allCheckbox: "ติ๊ก \"ทั้งหมด\" เพื่อให้สิทธิ์ครอบคลุมทุกเมนูย่อยของเมนูนี้พร้อมกัน (เมื่อเลือกแล้วช่องเลือกเมนูย่อยจะถูกปิด เพราะถือว่าเลือกครบทุกอันแล้ว)",
    pgrp_help_pageOverview: "กลุ่มสินค้า (Product Group) คือชุดข้อมูลสินค้าที่ AI ใช้ค้นหาเพื่อตอบคำถามและแนะนำสินค้าให้ลูกค้าในแชท คลิกแก้ไขเพื่อเพิ่ม/จัดการรายการสินค้าและหมวดหมู่ภายในกลุ่ม",
    pgrp_help_deleteDisabled: "ปุ่มลบถูกปิดเพราะบัญชีของคุณ (สิทธิ์ User) ลบได้เฉพาะกลุ่มสินค้าที่ตนเองสร้างเท่านั้น หากต้องการลบรายการของผู้อื่นต้องให้ผู้ดูแล (Admin) ดำเนินการ",
    pdet_help_reprocess: "ปุ่ม \"ประมวลผลใหม่\" จะแปลงข้อมูลสินค้าเป็นเวกเตอร์ (Vector/Embedding) เพื่อให้ AI ค้นหาและแนะนำสินค้าได้แม่นยำ หลังจากเพิ่ม/แก้ไข/ลบสินค้า ควรกดปุ่มนี้เพื่ออัปเดตดัชนีค้นหา สัญลักษณ์ \"!\" สีแดงหมายถึงข้อมูลมีการเปลี่ยนแปลงและยังไม่ได้ประมวลผลใหม่",
    pdet_help_recommendSwitch: "เปิดเพื่อทำเครื่องหมายว่าสินค้านี้เป็น \"สินค้าแนะนำ\" AI จะให้ความสำคัญและหยิบยกสินค้านี้ขึ้นมาเสนอลูกค้าก่อนเมื่อเข้าเงื่อนไข",
    pdet_help_visibleSwitch: "เปิด = แสดงสินค้า (Visible) ลูกค้าและ AI จะเห็นและนำไปใช้ตอบได้, ปิด = ซ่อน (Hidden) สินค้าจะถูกเก็บไว้แต่ไม่ถูกนำไปแสดงหรือใช้แนะนำในแชท",
    pdet_help_statusChips: "ป้ายสถานะบนการ์ดสินค้า: \"แนะนำ/ไม่แนะนำ\" บอกว่าสินค้าถูกตั้งเป็นสินค้าแนะนำหรือไม่ และ \"แสดง/ซ่อน\" บอกว่าสินค้าเปิดใช้งานให้ลูกค้าเห็นหรือถูกซ่อนอยู่",
    pdet_help_productsSection: "ส่วนสินค้า: เพิ่มและจัดการรายการสินค้าที่ AI จะใช้ตอบลูกค้า จัดกลุ่มด้วยหมวดหมู่ ตั้งสถานะแนะนำ/แสดงผล และอย่าลืมกด \"ประมวลผลใหม่\" ทุกครั้งหลังแก้ไขเพื่อให้ AI ใช้ข้อมูลล่าสุด",
    igrp_help_intentGroup: "กลุ่มอินเทนต์ (Intent Group) คือชุดของอินเทนต์เซสชันที่จัดรวมกันเพื่อให้บอทใช้จับเจตนาของผู้ใช้ ระบบจะไล่ตรวจทุกเซสชันในกลุ่มเพื่อหาว่าข้อความผู้ใช้ตรงกับเจตนาใด แล้วทำงานตาม Action ที่ตั้งไว้ ลำดับการตั้งค่า: สร้างกลุ่ม → เพิ่มเซสชัน → กำหนด Intent และ Action",
    isess_help_intentSession: "อินเทนต์เซสชัน (Intent Session) คือหน่วยจับเจตนา 1 อย่างภายในกลุ่ม เช่น \"ถามเรื่องการลงทะเบียน\" แต่ละเซสชันมีตัวอย่างประโยค (Intent) และการกระทำ (Action) ที่บอทจะทำเมื่อจับเจตนานั้นได้ หนึ่งกลุ่มมีได้หลายเซสชัน",
    isd_help_useMemory: "เปิดใช้หน่วยความจำ: ให้บอทนำบริบทของบทสนทนาก่อนหน้ามาร่วมพิจารณาในการจับเจตนาและตอบ เหมาะกับบทสนทนาต่อเนื่องหลายรอบ หากปิด บอทจะพิจารณาเฉพาะข้อความล่าสุด",
    isd_help_promptSession: "พรอมต์เซสชัน คือคำสั่งที่ส่งให้ LLM เพื่อบอกวิธีตัดสินว่าข้อความผู้ใช้ตรงกับเจตนาในกลุ่มนี้หรือไม่ (คืนค่า 1 = ตรง, 0 = ไม่ตรง) โดยทั่วไปใช้ค่าเริ่มต้นได้ ปรับเมื่อต้องการเงื่อนไขการจับเจตนาที่เฉพาะเจาะจงขึ้น",
    isd_help_intent: "อินเทนต์ (Intent) คือรายการตัวอย่างประโยคที่แทนเจตนาเดียวกัน เช่น \"ลงทะเบียนยังไง\" \"สมัครสมาชิกทำอย่างไร\" ระบบใช้ประโยคเหล่านี้เทียบกับข้อความผู้ใช้เพื่อจับเจตนา ยิ่งใส่ตัวอย่างหลากหลายยิ่งจับได้แม่นขึ้น (อัปโหลดเป็นไฟล์ Excel ได้)",
    isd_help_action: "Action คือสิ่งที่บอททำเมื่อจับเจตนานี้ได้ Action แรก (Action Answer สีม่วง) คือการตอบหลักที่ส่งให้ผู้ใช้ ส่วน Action Parallel คือการทำงานเสริมที่รันควบคู่ เช่น เรียก API หรือส่งต่อเจ้าหน้าที่ แต่ละ Action เลือกประเภทได้",
    isd_help_actionType: "ประเภทของ Action: Vector = ตอบจากคลังความรู้ (RAG) · Text Response = ตอบด้วยข้อความคงที่ · Model Routing = ส่งต่อไปยังโมเดล GPT อื่น · Next Routing = ส่งต่อไปยังกลุ่มอินเทนต์อื่น · Contact Agent = ส่งต่อให้เจ้าหน้าที่ (ปิดบอทชั่วคราว) · API Trigger = เรียก API ภายนอกแล้วนำผลมาตอบ",
    isd_help_mergePrompt: "รวมพรอมต์: เมื่อเปิด ระบบจะนำพรอมต์ของ Action นี้ไปต่อรวมกับพรอมต์เซสชัน/Action ก่อนหน้า เพื่อให้บอทตอบโดยใช้บริบทต่อเนื่องกัน หากปิด Action นี้จะใช้เฉพาะพรอมต์ของตัวเอง",
    isd_help_vectorName: "ชื่อเวกเตอร์ (คลังความรู้): เลือกฐานความรู้ที่ให้บอทค้นหาข้อมูลมาตอบ ระบบจะดึงชิ้นความรู้ (chunk) ที่เกี่ยวข้องที่สุดมาสร้างคำตอบ ติ๊กเลือกได้หลายชิ้นจากตารางด้านล่าง",
    isd_help_modelRouting: "Model Routing: ส่งต่อการตอบไปยังโมเดล GPT อื่นที่ตั้งค่าไว้ ใช้เมื่อต้องการให้เจตนานี้ตอบด้วยโมเดลที่ต่างจากปกติ",
    isd_help_nextRouting: "Next Routing: ส่งต่อไปยังกลุ่มอินเทนต์อื่นเพื่อจับเจตนาต่อในขั้นถัดไป ใช้ต่อบทสนทนาหลายชั้น",
    isd_help_jsonVariables: "ตัวแปรเหล่านี้เป็นค่าที่ระบบจะแทนที่อัตโนมัติตอนเรียก API จริง เช่น {sessionID} = รหัสเซสชันของบทสนทนา, {channel} = ช่องทางที่ผู้ใช้ติดต่อ ลากหรือคลิกเพื่อแทรกลงใน JSON ที่จะส่งไปยัง API",
    isd_help_typeValidate: "ประเภทการตรวจสอบค่าที่ได้จาก API: Phone = ต้องเป็นเบอร์โทร · Email = ต้องเป็นอีเมล · Max Character = จำกัดจำนวนตัวอักษร · Regular Expression = ตรวจตามรูปแบบ regex ที่กำหนด หากไม่ผ่านจะแสดงข้อความ Error ที่ตั้งไว้",
    vgen_help_pageTitle: "หน้านี้ใช้สร้างชุดคำถามทดสอบอัตโนมัติจากเอกสารความรู้ (คลังเวกเตอร์) ด้วย LLM เพื่อนำไปทดสอบว่าแชทบอทตอบได้ถูกต้องหรือไม่ในหน้า Execute Test Runs",
    vgen_help_status: "สถานะการสร้างชุดคำถาม: Processing = กำลังสร้าง · success = สร้างเสร็จ พร้อมดาวน์โหลด · Reprocess = กำลังสร้างใหม่ · error = เกิดข้อผิดพลาด กดปุ่ม \"สร้างใหม่\" เพื่อลองอีกครั้ง",
    vgen_help_process: "ความคืบหน้า: จำนวนชิ้นความรู้ที่สร้างคำถามเสร็จแล้ว เทียบกับทั้งหมด (เช่น 3/10 = เสร็จ 3 จาก 10)",
    vgen_help_reprocess: "สร้างใหม่: สั่งสร้างชุดคำถามจากเอกสารเดิมอีกครั้ง ใช้เมื่อการสร้างครั้งก่อนไม่สมบูรณ์หรือมีข้อผิดพลาด",
    vgu_help_tone: "โทน (Tone): เลือกสไตล์ภาษาเพื่อให้ระบบสร้างคำถามทดสอบหลายรูปแบบ เช่น ทางการ เป็นกันเอง วิชาการ ช่วยทดสอบว่าบอทเข้าใจคำถามที่เขียนต่างสไตล์ได้หรือไม่ \"จำนวนคำถามต่อโทน\" คือจำนวนคำถามที่จะสร้างเพิ่มสำหรับแต่ละโทนที่เลือก",
    vgu_help_promptTemplate: "เทมเพลตพรอมต์: คำสั่งที่ระบบประกอบให้อัตโนมัติจากค่าที่คุณเลือก (จำนวนคำถาม/โทน/พรอมต์เพิ่มเติม) เพื่อส่งให้ LLM สร้างคำถาม ช่องนี้แก้ไขไม่ได้ ปรับผลลัพธ์โดยเปลี่ยนค่าด้านซ้ายหรือช่อง \"เพิ่มพรอมต์\"",
    vneg_help_pageTitle: "ชุดคำถามเชิงลบ (Negative) คือคำถามที่อยู่นอกขอบเขตความรู้ของบอท ซึ่งบอทควร \"ปฏิเสธ\" หรือไม่ตอบ ใช้ทดสอบว่าบอทไม่มั่วตอบคำถามที่ไม่ควรตอบ (ต่างจากชุดเชิงบวกที่บอทควรตอบได้ถูกต้อง)",
    vnd_help_pageTitle: "อัปโหลดชุดคำถามเชิงลบ: นำเข้าไฟล์คำถามที่บอทไม่ควรตอบ (นอกขอบเขต) เพื่อทดสอบการปฏิเสธของบอท ตั้งชื่อชุด แล้วอัปโหลดไฟล์ตามเทมเพลต",
    vpos_help_pageTitle: "ชุดคำถามเชิงบวก (Positive) คือคำถามที่อยู่ในขอบเขตความรู้ของบอท ซึ่งบอทควรตอบได้ถูกต้อง มักแนบ \"คำตอบอ้างอิง (Human Answer)\" ไว้เทียบคะแนน ใช้ทดสอบความแม่นยำของบอท",
    vpd_help_template: "เทมเพลต: \"Normal Question\" = คำถาม–คำตอบเดี่ยว 1 คู่ต่อแถว · \"Chain Question\" = บทสนทนาต่อเนื่องหลายรอบ (multi-turn) โดยใช้ #End# คั่นแต่ละบทสนทนา เลือกให้ตรงกับชนิดข้อมูลที่จะอัปโหลด",
    vpd_help_questionType: "ชนิดคำถาม: Normal Question = คำถาม–คำตอบเดี่ยว · Chain Question = ส่วนหนึ่งของบทสนทนาต่อเนื่องหลายรอบ เลือกให้ตรงกับลักษณะคำถามที่บันทึก",
    vpd_help_humanAnswer: "คำตอบอ้างอิง (Human Answer): คำตอบที่ถูกต้องซึ่งกำหนดโดยคน ระบบใช้เทียบกับคำตอบของบอทเพื่อให้คะแนนความถูกต้องตอนรันทดสอบ (ไม่บังคับ)",
    vproc_help_pageTitle: "หน้านี้ใช้รันทดสอบแชทบอท: เลือกโมเดลและชุดคำถาม เชิงบวก/เชิงลบ/คำถามต่อเนื่องหลายรอบ (Chain) ระบบจะส่งคำถามให้บอทตอบทั้งชุด แล้ว (ถ้าเปิดให้คะแนน) ใช้ LLM ประเมินคะแนนคำตอบ ดูผลได้ที่แดชบอร์ดคะแนน",
    vproc_help_calculateScores: "คำนวณคะแนน: เมื่อเปิด ระบบจะใช้ LLM เป็นผู้ตัดสินให้คะแนนความเกี่ยวข้องของคำตอบบอทแต่ละข้อ (0 = ไม่เกี่ยว, 1 = พอเกี่ยว, 2 = เกี่ยวมาก) และจะแสดงช่องพรอมต์การให้คะแนนด้านล่าง หากปิด จะได้เฉพาะคำตอบบอทโดยไม่มีคะแนน",
    vproc_help_scoringPrompt: "พรอมต์การให้คะแนน: คำสั่งที่ส่งให้ LLM ผู้ตัดสิน เพื่อบอกวิธีให้คะแนนคำตอบของบอท (ค่าเริ่มต้นให้คะแนน 0–2 ตามความเกี่ยวข้อง) แก้ไขได้หากต้องการเกณฑ์อื่น ใช้ตัวแปร {'{'}Question{'}'}, {'{'}Bot's Response{'}'}, {'{'}Human's Response{'}'}",
    vproc_help_scoreModel: "โมเดลผู้ให้คะแนน: LLM พื้นฐาน (base model) ที่ทำหน้าที่เป็นกรรมการให้คะแนนคำตอบของบอท — เป็นโมเดลเปล่าที่ไม่มีคลังความรู้ (RAG), ไม่มี Flow, ไม่มีความจำ จึงตอบเป็นตัวเลขตามพรอมต์ได้แม่นกว่าการใช้โมเดลตัวเดียวกับที่ตอบคำถาม จำเป็นต้องเลือกเมื่อเปิด \"คำนวณคะแนน\"",
    vproc_help_status: "สถานะการทดสอบ: Processing = กำลังส่งคำถามให้บอท · Processing score = กำลังให้คะแนน · success = เสร็จ ดูคะแนนได้ · Reprocess = กำลังรันใหม่ · error:score = ให้คะแนนไม่สำเร็จ กด \"สร้างใหม่\" เพื่อลองให้คะแนนอีกครั้ง",
    csvc_help_adminBotTakeover: "เมื่อสลับเป็น \"แอดมิน\" เจ้าหน้าที่จะเข้ามาตอบแชทนี้ด้วยตนเอง และบอท AI จะหยุดตอบอัตโนมัติทันที สลับกลับเป็น \"บอท\" เพื่อให้ AI กลับมาตอบเองอีกครั้ง",
    csvc_help_contactStatusFilter: "กรองรายการแชทตามผู้ที่กำลังดูแลอยู่: \"ติดต่อเจ้าหน้าที่\" = แชทที่มีเจ้าหน้าที่รับช่วงต่อแล้ว, \"ติดต่อบอท\" = แชทที่ยังให้บอท AI ตอบอยู่, \"ทั้งหมด\" = แสดงทุกแชท",
    pgnd_help_compareWorkflow: "หน้าทดสอบนี้ให้คุณตั้งค่าโมเดล 2 ชุด (A และ B) แล้วส่งข้อความเดียวกันพร้อมกัน เพื่อเปรียบเทียบคำตอบ ปรับพรอมต์และพารามิเตอร์ ก่อนบันทึกโมเดลไปใช้งานจริง",
    pgnd_help_typingDelay: "หน่วงเวลาการพิมพ์ข้อความตอบ (มิลลิวินาทีต่อตัวอักษร) เพื่อจำลองการพิมพ์แบบมนุษย์ ค่าน้อยลง = ตอบเร็วขึ้น, 0 = แสดงคำตอบทันที",
    pgnd_help_logPanel: "แผงนี้แสดงเบื้องหลังคำตอบล่าสุดของโมเดล เช่น ความรู้ที่ดึงมา (RAG), คำสั่ง SQL, อินเทนต์/โฟลว์ที่จับคู่ได้, ความจำ และคะแนนความคล้าย เพื่อช่วยตรวจสอบว่าทำไมบอทตอบแบบนั้น",
    pgnd_help_vectorCosine: "คะแนนความคล้าย (0-1) ระหว่างคำถามกับเนื้อหาความรู้แต่ละชิ้นที่ระบบดึงมา ยิ่งใกล้ 1 ยิ่งเกี่ยวข้องมาก ใช้ตรวจว่าบอทหยิบข้อมูลที่ตรงจริงหรือไม่",
    pgnd_help_intentFlow: "แสดงอินเทนต์หรือขั้นตอนใน Flow ที่ข้อความนี้จับคู่ได้ ช่วยดูว่าบอทเดินไปตามเส้นทางสนทนาที่ตั้งไว้หรือไม่",
    strm_help_privateMemory: "\"ความจำส่วนตัว\" คือคลังเอกสารเฉพาะของแชทบอทนี้ ไฟล์ที่อัปโหลดจะถูกแบ่งเป็นชิ้นและทำดัชนีเวกเตอร์ เวลาผู้ใช้ถาม บอทจะค้นเนื้อหาที่เกี่ยวข้องมาช่วยตอบ (RAG)",
    strm_help_processType: "เลือกวิธีประมวลผลไฟล์: \"เพิ่ม\" จะนำข้อมูลใหม่ไปต่อท้ายของเดิม ส่วน \"แทนที่\" จะลบชิ้นข้อมูลเดิมทั้งหมดของไฟล์นี้ก่อนแล้วสร้างใหม่",
    strm_help_detectLanguage: "เปิดไว้เพื่อให้ระบบตรวจจับภาษาของเอกสารและแปลก่อนสร้างเวกเตอร์ ช่วยให้ค้นหาข้ามภาษาได้ดีขึ้น ปิดหากเอกสารเป็นภาษาเดียวและไม่ต้องการให้แปล",
    strm_help_versionRestoreView: "\"Restore\" = ย้อนไฟล์ความจำนี้กลับไปใช้เนื้อหาของเวอร์ชันที่เลือก (ทับข้อมูลปัจจุบัน) · \"View\" = เปิดดูเนื้อหาเวอร์ชันนั้นแบบอ่านอย่างเดียวโดยไม่เปลี่ยนแปลงข้อมูลปัจจุบัน",
    strm_help_showAllText: "แสดงข้อความเต็มของแต่ละชิ้น (ทั้งต้นฉบับและที่แปล) ในตารางแทนการตัดย่อ ใช้เพื่อตรวจเนื้อหา ไม่กระทบข้อมูลจริง",
    strm_help_intentFlow: "แสดงอินเทนต์หรือขั้นตอนใน Flow ที่ข้อความนี้จับคู่ได้ ช่วยดูว่าบอทเดินไปตามเส้นทางสนทนาที่ตั้งไว้หรือไม่",
    strm_help_vectorCosine: "คะแนนความคล้าย (0-1) ระหว่างคำถามกับเนื้อหาความรู้แต่ละชิ้นที่ระบบดึงมา ยิ่งใกล้ 1 ยิ่งเกี่ยวข้องมาก ใช้ตรวจว่าบอทหยิบข้อมูลที่ตรงจริงหรือไม่",
    fs_help_privateMemory: "\"ความจำส่วนตัว\" คือคลังเอกสารเฉพาะของแชทบอทนี้ ไฟล์ที่อัปโหลดจะถูกแบ่งเป็นชิ้นและทำดัชนีเวกเตอร์ เวลาผู้ใช้ถาม บอทจะค้นเนื้อหาที่เกี่ยวข้องมาช่วยตอบ (RAG)",
    fs_help_processType: "\"เพิ่ม\" ต่อท้ายข้อมูลเดิม; \"แทนที่\" ลบชิ้นข้อมูลเดิมของไฟล์นี้ทั้งหมดก่อนสร้างใหม่",
    fs_help_detectLanguage: "เปิดไว้ให้ระบบตรวจจับและแปลภาษาของเอกสารก่อนสร้างเวกเตอร์ เพื่อค้นหาข้ามภาษาได้ดีขึ้น ปิดหากไม่ต้องการให้แปล",
    fsrd_help_versionRestoreView: "\"Restore\" = ย้อนไฟล์กลับไปใช้เนื้อหาเวอร์ชันที่เลือก (ทับของปัจจุบัน) · \"View\" = ดูเนื้อหาเวอร์ชันนั้นแบบอ่านอย่างเดียว",
    fsrd_help_detectLanguage: "เปิดไว้ให้ระบบตรวจจับและแปลภาษาเอกสารก่อนสร้างเวกเตอร์ เพื่อค้นข้ามภาษาได้ดีขึ้น ปิดถ้าไม่ต้องการแปล",
    fsrd_help_showAllModels: "เปิดเพื่อแสดงโมเดลทั้งหมดที่ใช้ได้ แทนการแสดงเฉพาะกลุ่มโมเดลที่แนะนำไว้",
    fs2_help_topVdb: "จำนวนชิ้นความรู้ที่ใกล้เคียงที่สุดที่ระบบจะดึงมาป้อนให้โมเดลต่อ 1 คำถาม (ค่าทั่วไป 3-5) ยิ่งมากยิ่งได้บริบทกว้างขึ้นแต่อาจมีข้อมูลรบกวนและต้นทุนสูงขึ้น",
    fs2_help_cosine: "เกณฑ์คะแนนความคล้ายขั้นต่ำ (0-1) ที่ชิ้นความรู้ต้องผ่านจึงจะถูกนำมาใช้ ยิ่งสูงยิ่งเข้มงวด (เอาเฉพาะที่ตรงมาก) ตั้ง -1 เพื่อปิดการกรองนี้",
    fs2_help_replaceExisting: "เปิดไว้เพื่อ \"ลบข้อมูลเดิมทั้งหมดของไฟล์นี้แล้วแทนที่ด้วยไฟล์ใหม่\" ปิดไว้เพื่อเพิ่มเนื้อหาต่อจากของเดิม (การแทนที่กู้คืนไม่ได้)",
    fs2_help_detectLanguage: "เปิดไว้ให้ระบบตรวจจับและแปลภาษาของไฟล์ก่อนสร้างเวกเตอร์ เพื่อค้นหาข้ามภาษาได้ดีขึ้น",
    fs2_help_activeStatus: "\"Active\" = ไฟล์นี้ถูกใช้ค้นหาเพื่อช่วยบอทตอบ · \"Inactive\" = ยังเก็บไฟล์ไว้แต่ไม่ถูกนำมาค้นหา (ปิดใช้ชั่วคราวโดยไม่ต้องลบ)",
    fs2_help_digitalId: "เชื่อมบัญชีของคุณกับ DGA Connect หรือ ThaID เพื่อให้เข้าสู่ระบบด้วยข้อมูลระบุตัวตนดังกล่าวได้และยืนยันตัวตนของคุณ ปิดสวิตช์เพื่อยกเลิกการเชื่อม",
    fs2_help_ourService: "เมนูลัดสำหรับเลือกคำถามหรือบริการยอดนิยมที่กดถามได้ทันที และเริ่มการสนทนาใหม่",
    dash_help_categoryQuestions: "คำถามหมวดหมู่ = คำถามที่ระบบจับคู่เข้ากับหัวข้อ/อินเทนต์ที่เตรียมไว้ล่วงหน้าได้ ส่วนคำถามอื่น ๆ = คำถามอิสระที่ไม่ตรงกับหมวดใด ใช้เทียบดูว่าผู้ใช้ถามตรงกับที่เตรียมไว้ และถามนอกเหนือจากนั้นเรื่องอะไรบ้าง",
    dash_help_systemUsageCounters: "ผู้ใช้ที่ไม่ได้ล็อกอิน = ผู้ที่ใช้แชทบอทผ่านช่องทางภาครัฐโดยไม่เข้าสู่ระบบ (ไม่ระบุตัวตน) ส่วนรวมทั้งหมด = ล็อกอิน + ไม่ล็อกอิน นับแบบไม่ซ้ำต่อวัน",
    dash_help_tokenModelBreakdown: "รายละเอียดโทเคนแยกตามโมเดล: Prompt = ข้อความที่ส่งเข้าโมเดล, Completion = คำตอบที่โมเดลสร้าง, Cached = โทเคนที่นำกลับมาใช้ซ้ำจากแคช (ราคาถูกกว่า) ใช้เทียบต้นทุนของแต่ละโมเดล",
    dash_unknownModel: 'ไม่ทราบโมเดล', // label การ์ด token ราย model เมื่อ SP resolve ชื่อ model ไม่ได้ (คืน 'Unknown')
    dash_help_feedbackSummary: "สรุปฟีดแบ็ก: จำนวนครั้งที่ผู้ใช้กด \"ถูกใจ/ไม่ถูกใจ\" ต่อคำตอบของบอทในช่วงวันที่เลือก ใช้วัดความพึงพอใจโดยรวมของผู้ใช้",
    dash_help_imageGenDetail: "รายละเอียดการสร้างภาพ: จำนวนภาพที่บอทสร้างด้วย AI และต้นทุน แยกตามโมเดล คิดค่าใช้จ่ายต่อภาพ (ไม่ใช่ต่อโทเคน)",
    dscore_help_validationScore: "แดชบอร์ดคะแนนตรวจสอบ: เปรียบเทียบคำตอบของบอทกับคำตอบอ้างอิงของมนุษย์ในชุดตรวจสอบ (Validation Process) แล้วให้คะแนนคุณภาพ ใช้ดูว่าบอทตอบได้ดีแค่ไหนก่อนนำไปใช้จริง",
    dscore_help_scorePrompt: "พรอมต์สำหรับให้ AI ใช้ตรวจให้คะแนน: กำหนดเกณฑ์ว่าจะเทียบคำตอบของบอทกับคำตอบอ้างอิงอย่างไรและให้คะแนนแบบไหน จะมีผลเมื่อเปิด \"คำนวณคะแนน\" เท่านั้น",
    dscore_help_scoreModel: "โมเดลผู้ให้คะแนน: LLM ที่ให้คะแนนคำตอบในรอบนี้ ถ้าขึ้นว่า \"ใช้โมเดลเดียวกับที่ตอบ (ข้อมูลเดิม)\" แปลว่าชุดทดสอบนี้ถูกสร้างก่อนที่ระบบจะรองรับการเลือกโมเดลผู้ให้คะแนนแยก — กด \"ประมวลผลใหม่\" แล้วเลือกโมเดลเพื่อให้คะแนนรอบถัดไปแม่นยำขึ้น",
    dscore_help_averageScore: "คะแนนเฉลี่ยของทุกคำถามในชุดตรวจสอบนี้ คะแนนยิ่งสูงยิ่งใกล้เคียงคำตอบอ้างอิงของมนุษย์ (ดูเกณฑ์ช่วงคะแนนได้จากการ์ดเงื่อนไขด้านล่าง)",
    dscore_help_scoreColumn: "คะแนนของคำตอบบอทในแถวนี้เมื่อเทียบกับคำตอบของมนุษย์ (Human Answer) ตามพรอมต์การให้คะแนนที่ตั้งไว้",
    rfb_help_showAllText: "เปิดเพื่อแสดงข้อความคำตอบแบบเต็มทุกแถวพร้อมกัน (ปิดไว้จะย่อข้อความยาวให้อ่านง่าย)",
    rfb_help_feedbackByModel: "ฟีดแบ็กแยกตามโมเดล: เทียบจำนวนถูกใจ/ไม่ถูกใจของแต่ละโมเดล AI เพื่อดูว่าโมเดลไหนให้คำตอบที่ผู้ใช้พอใจมากกว่ากัน",
    rqt_help_reportOverview: "รายงานหมวดคำถาม: ระบบนำคำถามจริงของผู้ใช้ในช่วงวันที่เลือกมาจัดกลุ่มเป็นหมวดหมู่ด้วย AI ตามพรอมต์ที่กำหนด กด \"ประมวลผล\" เพื่อเริ่ม แล้วรอตัวนับให้ครบ จึงเห็นอันดับหมวดคำถาม",
    rqt_help_processingStatus: "ความคืบหน้าการประมวลผล: จำนวนคำถามที่จัดหมวดเสร็จแล้ว / จำนวนทั้งหมด เมื่อเท่ากันแปลว่าประมวลผลครบและผลลัพธ์เป็นปัจจุบัน",
    rts_help_modelIdentity: "ชื่อโมเดล = ชื่อที่ตั้งให้ใช้ภายในระบบ, โมเดล = รหัสรุ่นจริงของผู้ให้บริการ (เช่น gpt-4o), LLM = ผู้ให้บริการ/ตระกูลโมเดล (เช่น OpenAI, Vertex)",
    logv_help_pageOverview: "บันทึกระบบสำหรับนักพัฒนา: เก็บข้อผิดพลาด (Exception), ชื่อเมทอดที่ทำงาน และ Log Trace ไว้ช่วยตรวจสอบปัญหาเชิงเทคนิค ไม่ใช่รายงานการใช้งานทั่วไป",
    logevt_help_statusApi: "สถานะการทำงานภายในของ API (คนละอย่างกับ Status Code แบบ HTTP): 0=สำเร็จ, 1=ผิดพลาดเชิงธุรกิจ, 2=ข้อผิดพลาดระบบ, 3=ข้อมูลซ้ำ, 4=ข้อมูลไม่ครบ, 5=Exception ใช้กรองว่าคำขอสำเร็จหรือพลาดเพราะสาเหตุใด",
    logevt_help_statusCode: "รหัสสถานะ HTTP ของคำขอ: 200=สำเร็จ, 400=คำขอไม่ถูกต้อง, 500=ข้อผิดพลาดฝั่งเซิร์ฟเวอร์ ใช้กรองผลลัพธ์ของการเรียก API",
    logevt_help_eventLogOverview: "บันทึกเหตุการณ์: ประวัติการกระทำในระบบ (สร้าง/แก้ไข/ลบ/ล็อกอิน) และการเรียก API ว่าใครทำ เมื่อไร ผลเป็นอย่างไร ใช้ตรวจสอบย้อนหลังและหาสาเหตุปัญหา",
    lmsg_help_exportLogMessage: "ส่งออกบันทึกแชท: บันทึกแชททั้งหมด (คำถาม-คำตอบ, System Message, Knowledge) เป็น Excel ตามตัวกรองปัจจุบัน",
    lmsg_help_exportLogMonitoring: "ส่งออกบันทึกมอนิเตอร์: ข้อมูลเชิงประสิทธิภาพ (เวลาตอบสนอง/สถานะแต่ละขั้นของ flow) ไว้วิเคราะห์ความเร็ว/ปัญหา",
    lmsg_help_exportToQuestionSet: "ส่งออกเป็นชุดคำถาม: นำคำถามจริงของผู้ใช้ไปสร้างเป็น Question Set เพื่อฝึก/ทดสอบหรือปรับปรุงบอท",
    lmsg_help_knowledge: "ความรู้ที่ระบบดึงมาใช้ (RAG): เนื้อหาที่ค้นจากฐานความรู้/เวกเตอร์แล้วแนบเข้าไปในพรอมต์ เพื่อให้บอทตอบโดยอ้างอิงข้อมูลจริง ใช้ตรวจว่าบอทดึงข้อมูลถูกต้องหรือไม่",
    lmsg_help_flowVisualization: "ผังการทำงาน (Flow): แสดงทีละขั้นว่าข้อความถูกประมวลผลผ่านโหนดใดบ้าง (เช่น จับอินเทนต์ → ค้นความรู้ → เรียกโมเดล → ตอบกลับ) สีบอกสถานะ (สำเร็จ/ล้มเหลว/ข้าม) และตัวเลข ms คือเวลาที่ใช้ในขั้นนั้น คลิกโหนดเพื่อดูข้อมูลเข้า-ออก",
    lmsg_help_flowNodeTypes: "ประเภทโหนดใน Flow: Intent/Smart Intent = จับว่าผู้ใช้ต้องการอะไร, Cache = ใช้คำตอบเดิมที่เก็บไว้เพื่อความเร็ว/ประหยัด, Knowledge Graph = ค้นความสัมพันธ์ในกราฟความรู้, NEXA Waterfall = ค้นข้อมูลเป็นชั้น ๆ จนกว่าจะเจอ, MCP = เรียกเครื่องมือภายนอกผ่านโปรโตคอล MCP, Advanced Router = เลือกเส้นทาง/โมเดลตามเงื่อนไข, Interest Optimizer = ปรับผลลัพธ์ตามความสนใจผู้ใช้",
    lmsg_help_systemMessage: "ข้อความระบบ (System Prompt): คำสั่ง/บริบทที่ส่งให้โมเดลก่อนคำถามผู้ใช้ กำหนดบุคลิกและกติกาการตอบของบอทในครั้งนั้น",
    lmsg_help_flowColorCoding: "สีของโหนด: เขียว=สำเร็จ, แดง=ล้มเหลว, เหลือง=ข้ามขั้นนั้น ส่วนสีของเวลา (ms): เขียว=เร็ว, เหลือง=ปานกลาง, แดง=ช้า ใช้ไล่หาขั้นตอนที่เป็นคอขวด",
    lmsg_help_userChannel: "ช่องทางผู้ใช้: แพลตฟอร์มที่ข้อความเข้ามา เช่น เว็บ, LINE, Facebook, MS Teams ใช้กรองดูบทสนทนาแยกตามช่องทาง",
    lmsg_help_sessionId: "รหัสเซสชัน: ใช้จัดกลุ่มข้อความที่อยู่ในบทสนทนาเดียวกันของผู้ใช้คนหนึ่ง ใช้ไล่ดูบริบทก่อนหน้าของคำถามได้",
    lae_help_apiExternalOverview: "บันทึก API ภายนอก: ประวัติการที่ระบบเรียกไปยัง API ภายนอก/บุคคลที่สาม (เช่น การเชื่อมต่อข้อมูลหรือบริการอื่น) พร้อม Request/Response ไว้ตรวจสอบว่าการเชื่อมต่อทำงานหรือมีปัญหาตรงไหน",
    lae_help_transactionId: "รหัสอ้างอิงรายการ (Transaction ID): ใช้ไล่ตามการเรียก API หนึ่งครั้งแบบครบวงจร และจับคู่กับบันทึกฝั่งปลายทางเมื่อต้องตรวจสอบปัญหา",
    setup_help_gptConfiguration: "ตั้งค่าการเชื่อมต่อ AI ที่ใช้ตอบแชท ระบบจะเรียก Azure OpenAI ตามลำดับความสำคัญ (Priority) ถ้าตัวแรกล่มจะไปใช้ตัวถัดไป และตั้งค่า Embedding ที่ใช้แปลงเอกสารเป็นเวกเตอร์สำหรับการค้นหาข้อมูล (RAG)",
    setup_help_priority: "ลำดับการเรียกใช้งาน Endpoint — ตัวเลขยิ่งน้อยยิ่งถูกเรียกก่อน ถ้า Endpoint ลำดับแรกใช้งานไม่ได้ ระบบจะข้ามไปใช้ลำดับถัดไปโดยอัตโนมัติ",
    setup_help_embeddingType: "โมเดลที่ใช้แปลงข้อความเป็นเวกเตอร์เพื่อค้นหาข้อมูลใน RAG ต้องเลือกให้ตรงกับโมเดลที่ใช้ตอนสร้างฐานเวกเตอร์ ถ้าเปลี่ยนทีหลังผลการค้นหาจะคลาดเคลื่อน (large = แม่นกว่าแต่ช้า/แพงกว่า, small = เร็ว/ถูกกว่า)",
    setup_help_gptMode: "เลือกวิธีเลือก Endpoint: Priority Mode = ใช้ Endpoint ตามลำดับความสำคัญที่ตั้งไว้เสมอ · Fast Mode = ระบบยิงคำถามทดสอบไปทุก Endpoint เป็นระยะ แล้วส่งงานจริงไปยังตัวที่ตอบเร็วที่สุด",
    setup_help_repeatTimeMinutes: "ความถี่ (นาที) ที่ระบบจะยิงคำถามทดสอบไปวัดความเร็วของแต่ละ Endpoint ใหม่ ยิ่งถี่ยิ่งปรับตามสภาพจริงเร็ว แต่จะเปลืองการเรียก API มากขึ้น",
    setup_help_testQuestions: "รายการคำถามตัวอย่างที่ระบบใช้ยิงทดสอบแต่ละ Endpoint เพื่อวัดเวลาตอบสนอง (ไม่ใช่คำตอบที่ส่งให้ผู้ใช้) ควรใส่คำถามที่ใกล้เคียงการใช้งานจริง",
    setup_help_timeDelayMs: "ระยะเวลาหน่วง (มิลลิวินาที) ระหว่างการพิมพ์แต่ละตัวอักษรตอนสตรีมคำตอบ ค่าน้อย = ข้อความไหลเร็ว, ค่ามาก = ทยอยพิมพ์ช้าลงเหมือนคนพิมพ์",
    setup_help_characterLimit: "จำนวนตัวอักษรสูงสุดที่ผู้ใช้พิมพ์ส่งได้ต่อหนึ่งข้อความ ข้อความที่ยาวเกินกำหนดจะถูกปฏิเสธ ตั้งไว้เพื่อคุมต้นทุนและกันข้อความยาวผิดปกติ",
    setup_help_gptAutoDisablePricing: "เพดานค่าใช้จ่าย (USD) เมื่อยอดใช้จ่าย GPT ถึงจำนวนนี้ภายในรอบที่กำหนด ระบบจะปิดการใช้ GPT อัตโนมัติเพื่อกันบิลบานปลาย (ใช้ร่วมกับสวิตช์ \"ปิด GPT อัตโนมัติ\")",
    setup_help_gptAutoDisablePeriod: "จำนวนวันย้อนหลังที่ใช้รวมยอดค่าใช้จ่าย GPT เป็นช่วงเวลาแบบเลื่อน ไม่ใช่รอบบิล เช่น ตั้ง 30 = รวมยอด 30 วันล่าสุดเสมอ เมื่อยอดถึงเพดานราคาระบบจะปิด GPT และเมื่อยอดของวันเก่าหลุดออกจากช่วง GPT จะกลับมาใช้ได้เองโดยไม่ต้องกดอะไร · ยอดนี้นับรวมทุกบริษัทในระบบ และตัดขอบวันตามเวลา UTC",
    setup_help_gptAutoDisableMessage: "ข้อความที่จะแสดงให้ผู้ใช้เห็นแทนคำตอบ AI เมื่อ GPT ถูกปิดอัตโนมัติเพราะถึงเพดานค่าใช้จ่าย",
    setup_help_entraGroupConfig: "ตั้งค่าแอป Microsoft Entra (Tenant/Client ID/Secret) เพื่อดึงสมาชิก Security Group จาก Entra มาผูกกับ User Group ในระบบโดยอัตโนมัติ ทำให้ไม่ต้องเพิ่มผู้ใช้ทีละคน เมื่อเปิดสวิตช์ Sync",
    ssoc_help_groupModel: "เลือกกลุ่มโมเดล (Group Model) ที่จำกัดว่าช่องทางนี้ใช้โมเดล AI ตัวใดได้บ้าง ถ้าไม่เลือกจะใช้ได้ทุกโมเดลตามค่าเริ่มต้น",
    ssoc_help_modelShortcut: "ชุดโมเดลด่วนที่ผู้ใช้ Teams สลับใช้ได้เร็ว",
    ssoc_help_shortcutMenu: "เมนูคำสั่งลัดที่แสดงในหน้าแชท Teams เพื่อให้ผู้ใช้กดเรียกใช้งานบ่อย ๆ ได้ทันที",
    ssoc_help_webSnippet: "สร้างวิดเจ็ตแชทสำหรับฝังในเว็บไซต์ ระบุโดเมนของเว็บที่จะฝัง เลือกโมเดล แล้วคัดลอกลิงก์/สคริปต์ที่ระบบสร้างให้ไปวางในหน้าเว็บ (แต่ละโดเมนจะได้ token เฉพาะของตัวเอง)",
    ssoc_help_domainName: "ชื่อโดเมนของเว็บไซต์ที่จะฝังวิดเจ็ตแชท (เช่น www.example.com) ระบบใช้ผูกกับ token และอนุญาตให้แสดงแชทเฉพาะบนโดเมนนี้",
    ssoc_help_userDefault: "รหัสผู้ใช้เริ่มต้นสำหรับผู้เข้าชมเว็บที่ไม่ได้ล็อกอิน ระบบจะใช้ค่านี้เป็นตัวตนอ้างอิงเมื่อไม่มีข้อมูลผู้ใช้จริง (เว้นว่างได้)",
    ssoc_help_entraVerification: "เปิดเพื่อบังคับให้ผู้ใช้ LINE ยืนยันตัวตนด้วยบัญชีองค์กร (Microsoft Entra) ผ่านหน้า LIFF ก่อนใช้แชท เหมาะกับงานที่ต้องรู้ว่าใครเป็นใคร ปิดสวิตช์ = ยังเก็บค่า Entra App/LIFF ไว้แต่ไม่บังคับยืนยัน",
    sec_help_menuRenew: "ต่ออายุ token โดยออกกุญแจ (API key) ใหม่และกำหนดวันหมดอายุใหม่ ของเดิมจะใช้ไม่ได้",
    sec_help_menuRevoke: "ยกเลิก token ถาวร ระบบภายนอกที่ใช้กุญแจนี้จะเรียก API ไม่ได้ทันที",
    sec_help_statusBadge: "Active = token ยังใช้เรียก API ได้ · Expired = เลยวันหมดอายุแล้ว เรียก API ไม่ได้ ต้องกด Renew เพื่อออกกุญแจใหม่",
    sec_help_modelDisplay: "โมเดลที่ token นี้เรียกใช้ได้ ใช้คุมว่าระบบภายนอกที่ถือ token นี้เข้าถึงโมเดลใดได้บ้าง",
    sec_help_modelGroup: "กลุ่มโมเดลที่อนุญาตให้ token นี้เรียกใช้ ใช้จำกัดขอบเขตโมเดลที่ระบบภายนอกเข้าถึงได้",
    sec_help_vectorInsert: "แท็บนี้อธิบาย API สำหรับเพิ่มข้อความเข้าฐานความรู้แบบเวกเตอร์ (RAG) จากภายนอก ข้อความที่ส่งเข้ามาจะถูกแปลงเป็นเวกเตอร์และนำไปใช้ค้นหา/อ้างอิงตอน AI ตอบคำถาม (List = ส่งหลายรายการพร้อมกัน)",
    sec_help_selectorModel: "แท็บนี้อธิบาย API ที่รับข้อความเข้ามาแล้วให้ระบบเลือก/จัดเส้นทางไปยังโมเดลที่เหมาะสมกับเจตนา (intent) ของข้อความนั้นโดยอัตโนมัติ",
    sgm_help_modelGroup: "Model Group คือชุดโมเดล AI ที่ตั้งชื่อรวมไว้เป็นกลุ่ม เพื่อนำไปกำหนดให้ช่องทาง (LINE/Teams/เว็บ) หรือกลุ่มผู้ใช้ ว่าให้เลือกใช้ได้เฉพาะโมเดลในกลุ่มนี้ — จัดครั้งเดียวใช้ซ้ำได้หลายที่",
    sug_help_userGroup: "หน้านี้กำหนดว่ากลุ่มผู้ใช้นี้ใช้โมเดล AI ตัวใดได้ และมีสมาชิกใครบ้าง — เพิ่มสมาชิกเองจากตารางด้านล่าง หรือใส่ Group Object ID เพื่อให้ระบบดึงสมาชิกจาก Microsoft Entra มาให้อัตโนมัติเมื่อกด Save",
    entra_help_appManagement: "ที่นี่คือคลังแอป Microsoft Entra สำหรับใช้ยืนยันตัวตนผู้ใช้ด้วยบัญชีองค์กร เมื่อสร้างแอปแล้วจะนำไปเลือกใช้ในหน้า Setup Social (LINE Entra Verification) เพื่อบังคับให้ผู้ใช้ล็อกอินองค์กรก่อนใช้แชท",
    entra_help_statusChip: "Active = แอป Entra นี้พร้อมใช้ยืนยันตัวตน · Inactive = ถูกปิดไว้ ช่องทางที่อ้างอิงแอปนี้จะยืนยันตัวตนผู้ใช้ไม่ได้",
    lel_help_linkManagement: "หน้านี้แสดงรายชื่อผู้ใช้ LINE ที่ยืนยันตัวตนกับบัญชีองค์กร (Microsoft Entra) แล้ว — บอกว่า LINE คนไหนผูกกับ UPN/ชื่อองค์กรใด กด Unlink เพื่อยกเลิกการผูก ผู้ใช้จะต้องยืนยันตัวตนใหม่ในครั้งถัดไป",
    cfgconsent_help_configurationPanel: "แก้ไขข้อความ Consent (นโยบายความยินยอม) ทั้งภาษาไทยและอังกฤษ เมื่อกด Save ระบบจะสร้าง \"เวอร์ชันใหม่\" และผู้ใช้ทุกคนจะต้องกดยอมรับใหม่อีกครั้ง ดูเวอร์ชันเก่าย้อนหลังได้จากช่องเลือกเวอร์ชัน",
    cfgconsent_help_currentVersion: "หมายเลขเวอร์ชันของ Consent ที่ผู้ใช้เห็นและต้องยอมรับอยู่ในปัจจุบัน จะเพิ่มขึ้นทุกครั้งที่บันทึกการแก้ไข",
    theme_help_configTheme: "ปรับแต่งหน้าตาระบบ ได้แก่ โลโก้/พื้นหลังหน้าล็อกอิน, ชื่อ-ไอคอน-สีของหน้าต่างแชท และสี/โลโก้/พื้นหลังของแถบหัวข้อด้านบน ตัวอย่างทางขวาจะเปลี่ยนตามที่ปรับทันที เมื่อกด Save ระบบจะรีโหลดเพื่อใช้ธีมใหม่",
    sacomp_help_portalUserSection: "ส่วนนี้ใช้สร้างบัญชีผู้ดูแล (เจ้าของ) คนแรกของหน่วยงาน โดยชื่อผู้ใช้และรหัสผ่านนี้คือข้อมูลที่หน่วยงานนั้นใช้เข้าสู่ระบบ Admin Portal ของตนเอง",
    sacomp_help_lockStatus: "เมื่อ \"ล็อก\" บัญชีเจ้าของจะถูกระงับไม่ให้เข้าสู่ระบบชั่วคราวโดยไม่ต้องลบบัญชี เหมาะกับกรณีต้องการพักการใช้งานหน่วยงานนี้ไว้ก่อน",
    sacomp_help_status: "สถานะ \"ปิดใช้งาน\" จะระงับหน่วยงานนี้ไม่ให้ใช้งานระบบ (เข้าสู่ระบบ/แชท) แต่ข้อมูลยังอยู่ครบ ต่างจากการลบที่นำข้อมูลออกอย่างถาวร",
    sacomp_help_manage: "เข้าจัดการหน่วยงานนี้: ระบบจะสลับบริบทของคุณไปเป็นผู้ดูแลของหน่วยงานนั้นชั่วคราวเพื่อตั้งค่า/ดูข้อมูลภายใน แล้วกดกลับมาหน้า SuperAdmin ได้",
    sacomp_help_companyCode: "รหัสย่อไม่เกิน 10 ตัวอักษรสำหรับอ้างอิงหน่วยงาน กำหนดได้ครั้งเดียวและแก้ไขภายหลังไม่ได้ ควรตั้งให้สื่อความหมายและไม่ซ้ำกับหน่วยงานอื่น",
    sawg_help_orgHierarchy: "ผังนี้ใช้จัดกลุ่มหน่วยงานให้อยู่ใต้หน่วยงานแม่แบบต้นไม้ (เช่น กระทรวง → กรม → กอง) โดย \"เวิร์กกรุ๊ป\" คือการเชื่อมหน่วยงานที่มีอยู่แล้วเข้ามาเป็นลูกของอีกหน่วยงานหนึ่ง ไม่ใช่กลุ่มผู้ใช้",
    sawg_help_childCompany: "เลือกหน่วยงานที่มีอยู่แล้วในระบบเพื่อนำมาเป็นหน่วยงานลูกใต้หน่วยงานนี้ หากยังไม่มีหน่วยงานที่ต้องการ ให้สร้างหน่วยงานก่อนแล้วจึงกลับมาเพิ่มเป็นลูก",
    sawg_help_type: "ประเภทของหน่วยงานลูก (เช่น กรม/กอง/ฝ่าย) ใช้กำหนดระดับชั้นและป้ายกำกับที่แสดงในผังองค์กร",
    saorg_help_type: "ประเภทหน่วยงานกำหนด \"ระดับชั้น\" ในผังองค์กร ซึ่งจะจำกัดว่าหน่วยงานย่อยที่เพิ่มได้ต้องเป็นระดับถัดไปเท่านั้น (เช่น กรมมีลูกเป็นกองได้ แต่ข้ามระดับไปเป็นฝ่ายไม่ได้)",
    saorg_help_subUnits: "รายการหน่วยงานย่อยที่อยู่ใต้หน่วยงานนี้ กด \"เพิ่มหน่วยงานย่อย\" เพื่อนำหน่วยงานที่มีอยู่แล้วมาจัดกลุ่มเป็นลูก การเพิ่ม/ลบจะมีผลเมื่อกดบันทึกเท่านั้น",
    saorg_help_colType: "ประเภทของหน่วยงานตามที่ตั้งไว้ในระบบ (กระทรวง / กรม / กอง / ฝ่าย ฯลฯ) · ป้ายสีเทาคือหน่วยงานที่เป็นรากของผัง ไม่มีหน่วยงานแม่ · ป้ายสีน้ำเงินคือหน่วยงานย่อยที่ถูกจัดไว้ใต้หน่วยงานแม่",
    saorg_help_lockStatus: "เปิด \"ล็อก\" เพื่อระงับบัญชีเจ้าของไม่ให้เข้าสู่ระบบชั่วคราวโดยไม่ลบบัญชี ปลดล็อกเพื่อให้กลับมาเข้าสู่ระบบได้",
    saorg_help_enableStatus: "ปิดสวิตช์เพื่อระงับการใช้งานหน่วยงานนี้ชั่วคราวโดยยังเก็บข้อมูลไว้ครบ และเปิดกลับมาใช้งานได้ภายหลัง",
    saumgt_help_role: "ระดับสิทธิ์ของผู้ใช้: SuperAdmin เข้าถึงและจัดการได้ทุกหน่วยงานทั่วทั้งระบบ ส่วน Admin จัดการได้เฉพาะภายในหน่วยงานของตนเองเท่านั้น",
    saumgt_help_page: "หน้านี้จัดการเฉพาะบัญชีผู้ดูแลระดับระบบ (SuperAdmin/Admin) เท่านั้น ไม่ใช่ผู้ใช้ทั่วไปของแต่ละหน่วยงาน",
    sainv_help_status: "สถานะคำเชิญ — รอดำเนินการ: ส่งแล้วยังไม่ได้ใช้ · ใช้แล้ว: สมัครสำเร็จ · หมดอายุ: เลยกำหนดวัน · ถูกเพิกถอน: ผู้ดูแลยกเลิกลิงก์ · ใช้แล้ว (ผู้ใช้ถูกลบ): บัญชีที่สมัครถูกลบไปแล้ว · ต้องเชื่อมเอสเอสโอใหม่: การเชื่อม SSO ขาด · ใช้แล้ว (ดีจีเอถูกใช้กับบัญชีอื่น): บัญชี DGA นั้นผูกกับผู้ใช้รายอื่นไปแล้ว",
    sainv_help_send: "ส่งลิงก์เชิญทางอีเมลเพื่อให้ผู้รับสมัครเป็นผู้ดูแลระดับ SuperAdmin ลิงก์ใช้ได้ครั้งเดียวและจะหมดอายุตามจำนวนวันที่กำหนดไว้",
    sainv_help_expireDays: "จำนวนวันที่ลิงก์เชิญยังใช้ได้ หากผู้รับไม่สมัครภายในกำหนด ลิงก์จะหมดอายุและต้องส่งคำเชิญใหม่",
    sainv_help_reinvite: "สร้างคำเชิญใหม่ให้อีเมลนี้อีกครั้ง ใช้เมื่อบัญชีเดิมหลุดการเชื่อมต่อ SSO เพื่อให้ผู้ใช้ลงทะเบียนและเชื่อมบัญชีใหม่ (ต่างจาก \"ส่งอีกครั้ง\" ที่ส่งลิงก์เดิมซ้ำ)",
    sainv_help_registeredBy: "บัญชีที่ใช้ลิงก์เชิญนี้สมัครจริง ซึ่งอาจต่างจากอีเมลผู้รับหากมีการส่งต่อลิงก์",
    sadash_help_embeddingTokens: "โทเคนที่ใช้แปลงเอกสาร/ข้อความเป็นเวกเตอร์สำหรับค้นหาความรู้ (RAG) จะเกิดขึ้นทั้งตอนอัปโหลดเอกสารและตอนระบบค้นข้อมูลมาประกอบคำตอบ",
    sadash_help_reviewStatus: "สถานะตรวจทานเอกสารความรู้ — ฉบับร่าง: ยังไม่พร้อมใช้ · กำลังทดสอบ: อยู่ระหว่างตรวจสอบคำตอบ · พร้อมใช้: ยืนยันแล้วให้บอทนำไปตอบได้ · มีปัญหา: พบข้อผิดพลาดต้องแก้ไข",
    sadash_help_provider: "กรองข้อมูลการใช้งานตามผู้ให้บริการโมเดล AI (เช่น OpenAI, Azure OpenAI, Vertex AI) เว้นว่างไว้เพื่อรวมทุกผู้ให้บริการ",
    sadash_help_promptTokens: "จำนวนโทเคนของข้อความ \"ขาเข้า\" ที่ส่งให้โมเดล (คำถามผู้ใช้ + บริบท/เอกสารที่แนบไป) ยิ่งบริบทยาว โทเคนยิ่งมาก",
    sadash_help_cachedTokens: "ส่วนของ Prompt Token ที่นำกลับมาใช้ซ้ำจากแคชของผู้ให้บริการ ซึ่งคิดราคาถูกกว่าโทเคนปกติ ช่วยลดต้นทุนเมื่อบริบทซ้ำเดิม",
    sadash_help_completionTokens: "จำนวนโทเคนของคำตอบ \"ขาออก\" ที่โมเดลสร้างขึ้น คำตอบยิ่งยาวยิ่งใช้โทเคนมาก",
    sadash_help_subscriptionTiers: "ระดับแพ็กเกจ — \"โครงการ\": โควตาโทเคนรวมของทั้งระบบ · \"กระทรวง/หน่วยงาน\": โควตาที่จัดสรรให้แต่ละหน่วยงานแยกกัน",
    saDashboardCompanyTypeBreakdownTitle: "รายละเอียดตามประเภทองค์กร",
    saDashboardCompanyTypeBreakdownColType: "ประเภท",
    saDashboardCompanyTypeBreakdownColTotal: "จำนวนบริษัท",
    saDashboardCompanyTypeBreakdownColSubscribed: "มี Subscription ใช้งานอยู่",
    saDashboardCompanyTypeBreakdownGrandTotal: "รวมทั้งหมด",
    saDashboardCompanyTypeUnassigned: "ไม่ระบุประเภท",
    sadash_help_companyTypeBreakdown: "ประเภทเป็นการจัดหมวดตามชื่อ ไม่ใช่ตำแหน่งใน org-chart เช่น DGA ถูกกำหนดเป็น \"สำนักงาน\" (ระดับ 3) ทั้งที่เป็น tenant ระดับบนสุด",
    saDashboardCompanyTypeBreakdownEmpty: "ไม่พบข้อมูลประเภทองค์กร",
    sadash_help_priceMode: "สลับหน่วยแสดงผลระหว่างจำนวนโทเคนกับค่าใช้จ่ายโดยประมาณ (USD/THB) โดยใช้อัตราแปลงคงที่ ~1 USD = 35 THB จึงเป็นค่าอ้างอิงคร่าว ๆ เท่านั้น",
    sadash_help_noSubscription: "หน่วยงานนี้ยังไม่ได้ผูกแพ็กเกจโควตาโทเคน จึงอาจใช้งานโมเดลไม่ได้จนกว่าจะกำหนดโควตาให้",
    saCore_help_priority: "ลำดับความสำคัญของ Endpoint — ระบบจะเรียกใช้ Endpoint ที่มีเลขน้อยที่สุดก่อน ถ้า Endpoint นั้นล่มหรือเต็มโควตา จึงค่อยไล่ไปเลขถัดไป ใช้ตั้งลำดับสำรอง (failover) เมื่อมีหลาย Endpoint",
    saCore_help_gptMode: "โหมดการเลือก Endpoint: \"Priority\" = ใช้ตามลำดับที่ตั้งไว้เสมอ ส่วน \"Fast\" = ระบบยิงคำถามตัวอย่างไปทุก Endpoint ตามรอบเวลาที่กำหนด แล้วเลือกตัวที่ตอบเร็วที่สุดให้อัตโนมัติ เหมาะเมื่อต้องการความเร็วมากกว่าลำดับคงที่",
    saCore_help_repeatTime: "ระยะเวลา (นาที) ที่ระบบจะวนกลับมาทดสอบความเร็วของทุก Endpoint อีกครั้ง ค่าน้อย = อัปเดตความเร็วบ่อยแต่ใช้ทรัพยากรมากขึ้น (เช่น 30–60 นาที)",
    saCore_help_testQuestions: "ชุดคำถามตัวอย่างที่ระบบใช้ \"ยิงทดสอบ\" แต่ละ Endpoint เพื่อจับเวลาตอบกลับ ไม่ใช่คำถามที่ผู้ใช้เห็น ควรใส่คำถามที่ใกล้เคียงการใช้งานจริงเพื่อวัดความเร็วได้แม่นยำ",
    saCore_help_embeddingType: "ชนิด/รุ่นของโมเดล Embedding ที่ใช้แปลงข้อความเป็นเวกเตอร์ ต้องตรงกับรุ่นที่ใช้ตอนประมวลผลเอกสารเดิม ไม่เช่นนั้นการค้นหา (RAG) จะผิดเพี้ยนเพราะมิติเวกเตอร์ไม่ตรงกัน",
    saCore_help_autoDisablePricing: "เพดานค่าใช้จ่าย (USD) เมื่อยอดใช้ GPT สะสมในช่วงเวลาที่กำหนดเกินค่านี้ ระบบจะปิด GPT อัตโนมัติ (ทำงานคู่กับสวิตช์ \"ปิด GPT อัตโนมัติ\")",
    saCore_help_autoDisablePeriod: "จำนวนวันย้อนหลังที่ใช้รวมยอดค่าใช้จ่าย GPT เป็นช่วงเวลาแบบเลื่อน ไม่ใช่รอบบิล เช่น ตั้ง 30 = รวมยอด 30 วันล่าสุดเสมอ เมื่อยอดถึงเพดานราคาระบบจะปิด GPT และเมื่อยอดของวันเก่าหลุดออกจากช่วง GPT จะกลับมาใช้ได้เองโดยไม่ต้องกดอะไร · ยอดนี้นับรวมทุกบริษัทในระบบ และตัดขอบวันตามเวลา UTC",
    saCore_help_timeDelay: "หน่วงเวลา (มิลลิวินาที) ระหว่างการพิมพ์แต่ละตัวอักษรในคำตอบของบอท ใช้ปรับความเร็วเอฟเฟกต์ \"กำลังพิมพ์\" ค่าสูง = พิมพ์ช้าลง",
    saCore_help_limitedCharacters: "จำนวนตัวอักษรสูงสุดที่ผู้ใช้พิมพ์ได้ในหนึ่งข้อความ ใช้กันข้อความยาวเกินไปที่ทำให้เปลือง Token และตอบช้า",
    saCore_help_autoDisableMessage: "ข้อความที่จะแสดงให้ผู้ใช้เห็นเมื่อ GPT ถูกปิดอัตโนมัติ (เช่น \"ระบบปิดชั่วคราว โปรดลองใหม่ภายหลัง\")",
    saCore_help_nexaService: "บริการ NEXA Knowledge Graph คือแหล่งความรู้ภายนอกที่ระบบเชื่อมต่อผ่าน SSO เพื่อดึงข้อมูลกราฟความรู้มาช่วยตอบ ตั้งค่า URL, อายุโทเคน SSO และ Shared Secret ที่นี่",
    saCore_help_ssoChatVsPortal: "มีสวิตช์ SSO สองแบบต่อผู้ให้บริการ: อันบนคือเปิด SSO สำหรับ \"หน้าเข้าสู่ระบบของ Portal\" ส่วน \"ในแชท\" คือเปิดให้ผู้ใช้ล็อกอินด้วยผู้ให้บริการนี้ผ่านหน้าต่างแชท/Snippet โดยตรง",
    sallm_help_maxToken: "จำนวน Token สูงสุดของ \"คำตอบ\" ที่โมเดลจะสร้างได้ต่อครั้ง ค่ามาก = ตอบได้ยาวขึ้นแต่ช้าและแพงขึ้น ถ้าเว้นว่างระบบจะใช้ค่าเริ่มต้น 4096",
    sallm_help_modelNameVsDisplay: "\"ชื่อที่แสดง\" (Model Display) คือชื่อเรียกที่มนุษย์อ่านง่ายและเห็นในเมนูของแอดมิน ส่วน \"Model Name\" ต้องเป็นรหัสรุ่นจริงที่ผู้ให้บริการกำหนด (เช่น gpt-4o) ซึ่งถูกส่งไปเรียก API ต้องสะกดให้ตรงเป๊ะ",
    sallm_help_authHeaderName: "ชื่อ HTTP Header ที่จะใช้ส่ง API Key ไปยังผู้ให้บริการภายนอก (เช่น \"Authorization\" หรือ \"api-key\") ต้องดูจากเอกสารของ API ปลายทางว่ารับ Key ผ่าน Header ชื่ออะไร",
    sallm_help_reasoningEffort: "เปิดใช้เฉพาะโมเดลตระกูล \"reasoning\" — ให้โมเดลใช้เวลาคิดวิเคราะห์ภายในมากขึ้นก่อนตอบ ได้คำตอบที่ซับซ้อนแม่นยำขึ้นแต่ช้าและใช้ Token มากขึ้น",
    saconsent_help_versionOnSave: "ทุกครั้งที่กด \"บันทึก\" ระบบจะสร้างเวอร์ชันเงื่อนไขใหม่ และผู้ใช้ทุกคนจะต้องกดยอมรับเงื่อนไขใหม่อีกครั้งก่อนใช้งาน จึงควรแก้ให้เรียบร้อยก่อนบันทึก",
    saconsent_help_viewVersion: "เลือกเพื่อเปิดดูเนื้อหาเงื่อนไข \"เวอร์ชันย้อนหลัง\" แบบอ่านอย่างเดียว ใช้เปรียบเทียบกับฉบับปัจจุบัน ไม่ได้เปลี่ยนเวอร์ชันที่ใช้จริง",
    saconsent_help_audience: "เลือกกลุ่มผู้ใช้ที่เงื่อนไขนี้บังคับใช้: \"สำหรับหน่วยงาน (Back Office)\" = ผู้ดูแล/แอดมินที่เข้าหลังบ้าน, \"สำหรับผู้ใช้บริการ\" = ผู้ใช้ทั่วไปที่ใช้แชท/หน้าเว็บสาธารณะ, \"นโยบายความเป็นส่วนตัว\" = เนื้อหาหน้า Privacy Notice บนหน้าเว็บสาธารณะ, \"เงื่อนไขให้บริการ (Snippet)\" = เงื่อนไขให้บริการบนหน้า /Landing/Terms (เปิดจากเมนูในแชท Snippet ด้วย)",
    sapkg_help_limitToken: "โควตา Token สูงสุดที่แพ็กเกจนี้ให้ต่อรอบ (จำนวนการใช้งาน AI ที่ซื้อได้) เมื่อองค์กรสมัครแพ็กเกจนี้ ถ้าเว้นว่างจะถือว่าไม่จำกัด",
    sasub_help_tierModel: "ระบบสมัครใช้งานมี 2 ระดับ: \"โครงการ (Project)\" คือเพดานรวมของทั้งโครงการ ส่วน \"กระทรวง (Ministry)\" คือโควตาแยกของแต่ละหน่วยงานภายใต้เพดานนั้น ยอดใช้ของทุกกระทรวงรวมกันต้องไม่เกินเพดานโครงการ",
    sasub_help_imageCredit: "เพดานค่าใช้จ่ายการสร้างภาพ นับแยกจาก Token ข้อความ หักตามต้นทุนจริงของโมเดลต่อภาพ (ไม่ใช่นับเป็นจำนวนภาพ) ระบบยังให้สร้างต่อได้อีก 20% เกินเพดานก่อนจะบล็อก เช่น ตั้ง 100 จะบล็อกเมื่อใช้เกิน 120 · เว้นว่าง/ติ๊กไม่จำกัด = สร้างภาพได้ไม่จำกัด",
    sasub_help_renew: "ปุ่มต่ออายุจะกดได้เฉพาะเมื่อการสมัครหมดอายุหรือถูกยกเลิกแล้วเท่านั้น การต่ออายุจะขยายวันหมดอายุออกไปอีก 30 วันจากวันปัจจุบัน",
    sasub_help_statusChips: "สถานะการสมัคร: \"ใกล้หมดอายุ\" = เหลือเวลาน้อยก่อนถึงวันหมดอายุ, \"หมดอายุ\" = เลยวันสิ้นสุดแล้ว, \"ยกเลิก\" = ถูกยกเลิกก่อนกำหนด",
    _sa_doc_help_ingestionCascade: "ลำดับการตั้งค่านำเข้าเอกสารเข้าคลังความรู้ (RAG): เลือก \"ประเภทเอกสาร\" → \"ประเภทโครงสร้าง\" (รูปแบบเนื้อหา) → \"วิธีประมวลผล\" (วิธีตัดแบ่งเอกสารเป็นชิ้นย่อยก่อนแปลงเป็นเวกเตอร์เพื่อค้นหา) แต่ละตัวเลือกจะจำกัดตัวเลือกถัดไป",
    _sa_doc_help_vectorType: "รูปแบบเนื้อหาของเอกสาร: \"General\" = เอกสารทั่วไป, \"Article\" = บทความ/เนื้อหายาวที่ต้องคงบริบททั้งเรื่อง, \"PriceList\" = ตารางราคา/ข้อมูลเชิงแถว (เฉพาะ CSV/Excel) มีผลต่อวิธีจับกลุ่มข้อความ",
    _sa_doc_help_processType: "วิธีตัดเอกสารเป็น \"ชิ้น (chunk)\" ก่อนทำเวกเตอร์: General = ตัดอัตโนมัติ, MaxCharacter = ตัดตามจำนวนตัวอักษรที่กำหนด, CustomSplit = ตัดตามตัวคั่นที่เราระบุ, HeaderAllChunk/FirstChunk = แนบหัวตารางไปทุกชิ้น/เฉพาะชิ้นแรก, WordImage/PDFImage = ดึงรูปในไฟล์มาประมวลผลด้วย",
    _sa_doc_help_maxChar: "ขนาดสูงสุดของแต่ละชิ้นข้อความ (chunk) เป็นจำนวนตัวอักษร ชิ้นใหญ่ = เก็บบริบทได้มากแต่ค้นหาแม่นยำน้อยลง, ชิ้นเล็ก = ค้นแม่นแต่บริบทสั้น (ค่าเริ่มต้น ~1000)",
    _sa_doc_help_detectLanguage: "เมื่อเปิด ระบบจะตรวจและแปลข้อความเป็นภาษาอังกฤษเก็บคู่ไว้ ทำให้ค้นหาข้ามภาษาได้ดีขึ้น (เช่น ถามอังกฤษเจอเอกสารไทย) แต่ใช้เวลาประมวลผลนานขึ้น",
    _sa_doc_help_personalInfo: "เปิดเมื่อเอกสารมีข้อมูลส่วนบุคคล (PII) ระบบจะจัดการข้อมูลอ่อนไหวเป็นพิเศษตามนโยบายความเป็นส่วนตัว ควรเปิดกับเอกสารที่มีชื่อ-เลขบัตร-ข้อมูลติดต่อของบุคคล",
    _sa_doc_help_processChip: "สถานะการประมวลผลเวกเตอร์: ตัวเลข = จำนวนชิ้นที่ทำเวกเตอร์เสร็จ / ทั้งหมด สีเทา=ยังไม่เริ่ม, เหลือง=กำลังทำ, เขียว=เสร็จครบพร้อมใช้ค้นหา",
    _sa_doc_help_reprocess: "ประมวลผลเอกสารใหม่ทั้งหมด — ตัดชิ้นและสร้างเวกเตอร์ใหม่จากไฟล์เดิม ใช้เมื่อเปลี่ยนวิธีประมวลผลหรือผลลัพธ์ค้นหาไม่ดี",
    _sa_doc_help_duplicate: "สร้างสำเนาเอกสารนี้ (พร้อมเวกเตอร์) ภายใต้ชื่อใหม่ ใช้เมื่อต้องการเวอร์ชันทดลองโดยไม่แตะต้นฉบับ",
    _sa_doc_help_replace: "นำข้อมูลเวกเตอร์ของเอกสารนี้ไป \"แทนที่\" เนื้อหาของอีกเอกสารหนึ่งที่เลือก (เขียนทับปลายทาง) ใช้สลับเนื้อหาเข้าเอกสารที่ถูกอ้างอิงอยู่แล้วโดยไม่ต้องเปลี่ยนชื่อที่ระบบอื่นใช้",
    _sa_doc_help_versionHistory: "ดูประวัติเวอร์ชันของเอกสาร ทุกครั้งที่ประมวลผล/แทนที่ ระบบจะเก็บสำเนาไว้ สามารถเปิดดูหรือกู้คืนเวอร์ชันเก่าได้",
    _sa_doc_help_download: "ส่งออกข้อมูลชิ้นข้อความ (chunks) ของเอกสารเป็นไฟล์ Excel เพื่อตรวจสอบหรือแก้ไขนอกระบบ (ไม่ใช่ไฟล์ต้นฉบับ)",
    _sa_doc_help_restore: "กู้คืนเอกสารกลับไปเป็นเวอร์ชันนี้ — จะเขียนทับเนื้อหาปัจจุบันด้วยเวอร์ชันที่เลือก (ใช้ \"ดู\" ก่อนถ้าต้องการตรวจสอบก่อนกู้คืน)",
    _sa_doc_help_enColumn: "คอลัมน์ \"ต้นฉบับ\" = ข้อความเดิมของชิ้น, \"EN\" = ฉบับแปลอังกฤษที่ระบบสร้างไว้ใช้ทำเวกเตอร์และค้นข้ามภาษา (มีเมื่อเปิด Detect Language)",
    _sa_doc_help_uploadMode: "โหมดอัปโหลด: \"เพิ่ม (Add)\" = นำชิ้นข้อความจากไฟล์ใหม่ไปต่อท้ายของเดิม, \"แทนที่ (Replace)\" = ลบชิ้นเดิมทั้งหมดก่อนแล้วสร้างใหม่จากไฟล์นี้ (ระวัง เขียนทับถาวร)",
    _sa_doc_help_processBanner: "จำนวนชิ้นข้อความที่ทำเวกเตอร์เสร็จแล้ว / จำนวนทั้งหมดของเอกสารนี้ เมื่อเท่ากันคือประมวลผลครบพร้อมใช้ค้นหา",
    _noti_help_type: "ประเภทการแจ้งเตือน: TOKEN_80/TOKEN_100 = ใช้ Token ถึง 80%/100%, SUB_EXPIRY_7/30 = เหลืออีก 7/30 วันจะหมดอายุ, SUB_EXPIRED = หมดอายุแล้ว, NEW_COMPANY/NEW_SUBSCRIPTION = มีหน่วยงาน/แพ็กเกจใหม่, SYSTEM = เหตุการณ์ระบบ",
    _noti_help_level: "ระดับความสำคัญ: info = แจ้งให้ทราบทั่วไป, warning = ควรจับตา (เช่น ใกล้หมดโควตา), critical = ต้องรีบจัดการ (เช่น โควตาเต็ม/หมดอายุ)",
    saPersona_help_pii: "แหล่งข้อมูลนี้มีข้อมูลส่วนบุคคล (PII เช่น ข้อมูลทะเบียนราษฎร DOPA) ระบบจะไม่ให้กดทดสอบกับข้อมูลจริงเพื่อป้องกันการเปิดเผยข้อมูลบุคคล",
    saPersona_help_credentialSource: "แหล่งเก็บกุญแจลับ GDX: \"Key Vault\" = ดึงจาก Azure Key Vault (แนะนำสำหรับ Production ปลอดภัยกว่า), \"Dbsettings\" = เก็บในฐานข้อมูลแก้ได้ทันทีไม่ต้องรีสตาร์ต (เหมาะกับ Dev)",
    saPersona_help_gdxProvider: "โหมดผู้ให้บริการ GDX: \"Mock\" = ใช้ข้อมูลจำลองสำหรับทดสอบ ไม่เรียก API จริง, \"Real\" = เรียก API หน่วยงานรัฐจริง (มีค่าใช้จ่าย/ผลต่อข้อมูลจริง) เปลี่ยนเป็น Real เฉพาะเมื่อพร้อมใช้งานจริง",
    saPersona_help_test: "ปุ่มทดสอบใช้ได้เฉพาะแหล่งข้อมูลที่ \"เปิดใช้งาน\" และ \"ไม่ใช่ PII\" เท่านั้น เพื่อดึงข้อมูลจริงมาแสดงตัวอย่าง (เช่น ค่าฝุ่น PM2.5) โดยไม่กระทบข้อมูลบุคคล",
    bannerPopup_help_targetPages: "เลือกหน้าที่จะแสดง Banner/Popup: login = หน้าเข้าสู่ระบบ, product_admin = หน้าหลังบ้านแอดมิน, portal = หน้าแดชบอร์ดผู้ใช้, fullsnippet = หน้าต่างแชทแบบเต็ม, landing = หน้าเว็บสาธารณะ",
    bannerPopup_help_useButton: "มี Banner ที่ \"ใช้งานอยู่\" ได้ครั้งละหนึ่งรูปเท่านั้น กด \"ใช้งาน\" เพื่อสลับให้รูปนี้เป็นรูปที่แสดงจริงบนหน้าเว็บแทนรูปเดิม",
    navb_help_timeDelay: "หน่วงเวลาระหว่างที่บอททยอยพิมพ์คำตอบทีละส่วน (หน่วยมิลลิวินาที) ค่ายิ่งมากคำตอบยิ่งไหลออกมาช้าเหมือนพิมพ์จริง ตั้งเป็น 0 เพื่อให้แสดงคำตอบทันที (ตั้งได้ 0–1000)",
    navb_help_llmSelector: "เลือกโมเดล AI ที่จะใช้ตอบเฉพาะแชทนี้ — \"LLM (ค่าเริ่มต้น)\" คือใช้โมเดลที่ผู้ดูแลระบบตั้งไว้ให้ เลือกโมเดลอื่นเพื่อลองเปรียบเทียบคำตอบ แล้วกดกากบาทเพื่อกลับไปใช้ค่าเริ่มต้น",
    navb_help_parameters: "ส่วนตั้งค่าพฤติกรรมของแชทนี้ เช่น ความเร็วการพิมพ์คำตอบ (Time Delay) และโมเดล AI (LLM) ที่ใช้ตอบ การตั้งค่าเหล่านี้มีผลเฉพาะห้องแชทที่เปิดอยู่",
    navb_help_topicMenuActions: "\"นำออกจากโฟลเดอร์\" เป็นการย้ายแชทกลับไปที่รายการแชทหลักโดยไม่ลบข้อมูล ส่วน \"ลบแชท\" เป็นการลบบทสนทนาทั้งหมดอย่างถาวรและกู้คืนไม่ได้",
    navb_help_folderDelete: "ลบโฟลเดอร์นี้พร้อมแชททั้งหมดที่อยู่ข้างในอย่างถาวร หากต้องการเก็บแชทไว้ ให้ย้ายแชทออกจากโฟลเดอร์ก่อนลบ",
    navb_help_clearModel: "กลับไปใช้โมเดล AI ค่าเริ่มต้นที่ผู้ดูแลระบบตั้งไว้สำหรับแชทนี้",
    _sa_help_coreConfig: "ตั้งค่ากลางของแพลตฟอร์มที่เป็นค่าเริ่มต้นให้ทุกบริษัท เช่น พารามิเตอร์ระบบและค่าตั้งต้นต่าง ๆ",
    _sa_help_personaApi: "ตั้งค่าบุคลิก (Persona) ของแชทบอทและการเชื่อมต่อ/คีย์ API ที่ระบบใช้เรียกใช้งานบริการภายนอก",
    _sa_help_consentConfig: "จัดการเวอร์ชันข้อกำหนดและเงื่อนไข (PDPA/Consent) ที่ผู้ใช้และผู้ดูแลต้องกดยอมรับก่อนใช้งาน เมื่อเผยแพร่เวอร์ชันใหม่ ระบบจะบังคับให้ทุกคนยอมรับอีกครั้ง",
    _sa_help_llmManagement: "ลงทะเบียนและจัดการผู้ให้บริการและโมเดล LLM (เช่น Azure, Google, Anthropic) ที่บริษัทต่าง ๆ นำไปใช้ตอบแชทได้",
    ddfile_help_templateType: "เลือกรูปแบบไฟล์ชุดคำถามที่จะอัปโหลด — \"คำถามทั่วไป\" คือคำถาม-คำตอบแบบเดี่ยวจบในตัว ส่วน \"คำถามแบบต่อเนื่อง\" คือชุดคำถามที่เชื่อมโยงกันเป็นลำดับ/มีคำถามตามหลัง",
    _km_help_share: "แชร์เอกสารฐานความรู้ชุดนี้ให้บริษัทลูก เพื่อให้แชทบอทของบริษัทนั้นดึงเนื้อหาไปใช้ตอบคำถามได้ เลือกบริษัทที่จะให้สิทธิ์ ดู/แก้ไข/ลบ แล้วกดบันทึก (การเอาเครื่องหมายถูกออกคือการถอนแชร์)",
    _km_help_permissions: "ดู/ถามตอบ = บริษัทนั้นอ่านและใช้เอกสารตอบคำถามได้ (ให้อัตโนมัติเมื่อเลือก) · แก้ไข = แก้ไขหรืออัปโหลดทับเอกสารได้ · ลบ = นำเอกสารออกจากฝั่งบริษัทนั้นได้",
    _km_help_currentShared: "ป้ายนี้หมายความว่าบริษัทดังกล่าวได้รับการแชร์เอกสารนี้อยู่แล้วก่อนหน้า หากเอาเครื่องหมายถูกออกแล้วบันทึก จะเป็นการถอนการแชร์จากบริษัทนั้น",
    termsDialog_help_decline: "หากปฏิเสธข้อกำหนดและเงื่อนไข จะไม่สามารถเข้าใช้งานระบบต่อได้ และระบบจะออกจากระบบ (Logout) ให้ทันที",
    snippet_help_privateMemoryDialog: "หน้านี้คือคลังความรู้ส่วนตัว (Private Memory / RAG) ของบอท เมื่ออัปโหลดเอกสาร ระบบจะตัดเนื้อหาออกเป็นชิ้นส่วนข้อความ (chunk) แล้วแปลงเป็นเวกเตอร์เพื่อให้ AI ค้นและใช้ตอบคำถาม เอกสารที่เพิ่มไว้ที่นี่จะกลายเป็นแหล่งข้อมูลที่บอทอ้างอิงเวลาตอบ",
    snippet_help_fileListDialog: "รายการนี้แสดงเอกสารทั้งหมดในคลังความรู้ของบอท แต่ละไฟล์สามารถแก้ไข ลบ ดูประวัติเวอร์ชัน หรือปิด/เปิดการใช้งานได้ ไฟล์ที่ปิดสวิตช์อยู่จะไม่ถูกนำไปใช้ตอบคำถาม",
    snippet_help_fileActiveSwitch: "เปิด/ปิดการใช้เอกสารทั้งไฟล์ในการตอบ เมื่อปิด ไฟล์ยังอยู่ในคลังแต่ AI จะไม่ดึงเนื้อหาจากไฟล์นี้มาตอบอีก เหมาะกับการพักใช้เอกสารชั่วคราวโดยไม่ต้องลบ",
    snippet_help_reprocess: "สร้างเวกเตอร์ของไฟล์นี้ใหม่ทั้งหมด โดยตัด chunk และแปลงเป็นเวกเตอร์อีกครั้งตามค่าที่ตั้งไว้ปัจจุบัน (Custom Max Character, Text Replacement, DetectLanguage) ใช้เมื่อเปลี่ยนค่าตัดข้อความแล้วต้องการให้มีผลกับทั้งเอกสาร — chunk เดิมจะถูกแทนที่",
    snippet_help_chunkActiveSwitch: "เปิด/ปิดเฉพาะ chunk (ชิ้นส่วนข้อความ) นี้ เมื่อปิด AI จะไม่ใช้ข้อความท่อนนี้ในการตอบ แต่ chunk อื่นในไฟล์เดียวกันยังใช้งานได้ตามปกติ เหมาะกับการตัดเนื้อหาที่ผิดหรือซ้ำออกโดยไม่ต้องลบ",
    snippet_help_restoreVersion: "ย้อนกลับไปใช้เวอร์ชันนี้ ระบบจะนำเนื้อหาของเวอร์ชันเก่ามาแทนที่เวอร์ชันปัจจุบันและใช้งานจริงทันที",
    snippet_help_viewVersion: "ดูเนื้อหาของเวอร์ชันเก่าเพื่อตรวจสอบ โดยไม่เปลี่ยนเวอร์ชันที่ใช้งานอยู่จริง (ถ้าต้องการนำกลับมาใช้ ให้กด Restore)",
    snippet_help_versionHistory: "ดูประวัติการอัปโหลดเอกสารนี้ ระบบเก็บทุกเวอร์ชันที่เคยอัปโหลดไว้ ทำให้ดูย้อนหลังหรือกู้คืนเวอร์ชันก่อนหน้าได้",
    snippet_help_refreshProgress: "ตัวเลขนี้คือความคืบหน้าการแปลงเวกเตอร์ (จำนวน chunk ที่ประมวลผลเสร็จ / ทั้งหมด) กดปุ่มเพื่อรีเฟรชสถานะล่าสุด โดยไม่สร้างเวกเตอร์ใหม่",
    snippet_help_customCharacter: "ตัวคั่นที่ใช้กำหนดจุดตัด chunk ในโหมด CustomSplit ระบบจะแบ่งเอกสารเป็นชิ้นส่วนทุกครั้งที่พบข้อความตัวคั่นนี้ (เช่น {'||!'}) ใช้เมื่อต้องการควบคุมจุดแบ่งเนื้อหาเอง",
    snippet_help_typeModes: "\"Type\" คือวิธีตัดเอกสารเป็น chunk ก่อนแปลงเวกเตอร์ — General ตัดอัตโนมัติ, MaxCharacter ตัดตามจำนวนตัวอักษรสูงสุด, CustomSplit ตัดตามตัวคั่นที่กำหนดเอง, Article เก็บทั้งบทความเป็นก้อนเดียว, HeaderAllChunk/HeaderFirstChunk ตัดตามหัวข้อ, WordImage/PDFImage ดึงรูปจากไฟล์ Word/PDF การเลือกวิธีตัดมีผลต่อความแม่นของคำตอบ",
    snippet_help_templateButton: "เปิดตัวอย่างไฟล์ต้นแบบสำหรับแต่ละวิธีตัด chunk (General, MaxCharacter, CustomSplit ฯลฯ) ดาวน์โหลดไปใช้เป็นแบบฟอร์ม เพื่อจัดรูปแบบเอกสารให้ระบบประมวลผลได้ถูกต้อง",
    snippet_help_showAllText: "แสดงข้อความเต็มของทุก chunk ในตาราง (ต้นฉบับ/แปล) แทนการตัดย่อ เป็นการปรับมุมมองเท่านั้น ไม่กระทบข้อมูลจริง",
    snippet_help_processTypeAddReplace: "Add = เพิ่มข้อมูลใหม่เข้าไปในเวกเตอร์เดิม; Replace = ลบเวกเตอร์เดิมของเอกสารนี้ทั้งหมดก่อนแล้วสร้างใหม่ (ระวัง: ข้อมูลเดิมจะถูกลบ)",
    // S24-P4 Agent Log View
    agentLog_expandToggle: "ขยาย/ย่อดู Hop",
    agentLog_statusOk: "สำเร็จ",
    agentLog_statusError: "ผิดพลาด",
    agentLog_statusPartial: "สำเร็จบางส่วน",
    agentLog_hopSeq: "ลำดับ",
    agentLog_hopTime: "เวลา",
    agentLog_hopQuestion: "คำถาม",
    agentLog_hopAnswer: "คำตอบ",
    agentLog_hopTokens: "โทเค็น",
    agentLog_hopStatus: "สถานะ",
    agentLog_hopResponseTime: "เวลาตอบสนอง (s)",
    agentLog_hopModel: "โมเดล",
    agentLog_hopUrlEndpoint: "URL ปลายทาง",
    agentLog_hopsTitle: "รายละเอียด Hop ({n})",
    agentLog_promptTokens: "พรอมต์",
    agentLog_completionTokens: "คำตอบ",
    agentLog_cachedTokens: "แคช",
    agentLog_totalTokens: "รวม",
    agentLog_contentMaskedHint: "เนื้อหาถูกซ่อนสำหรับบทบาทของท่าน (เห็นเฉพาะ SuperAdmin)",
    lmsg_agentRunBadge: "เอเจนต์",
    lmsg_agentClientUnknown: "ไม่ระบุ client",
    lmsg_agentFlowTitle: "โฟลว์ของเอเจนต์",
    lmsg_agentFlowMessage: "ข้อความ (Message)",
    lmsg_agentFlowReply: "คำตอบ (Reply)",
    lmsg_agentFlowToolCalls: "การเรียกใช้เครื่องมือ (Tool Calls)",
    lmsg_agentFlowNoToolCalls: "ไม่มีการเรียกใช้เครื่องมือ",
    lmsg_agentFlowEmpty: "ไม่มีข้อมูลโฟลว์สำหรับ Hop นี้ (บันทึกเก่าก่อนอัปเดตฟีเจอร์นี้)",
    lmsg_agentFlowLoadError: "โหลดข้อมูลโฟลว์ของเอเจนต์ไม่สำเร็จ",
    lmsg_noRecordsFound: "ไม่พบข้อมูล",
    /* @@AUTO_I18N_TH@@ */
  },
  en: {
    tokenUsageWarningTitle: 'Token Usage Notice',
    tokenUsageWarningText: 'This page uses AI features that will consume tokens during processing.',
    tokenUsageWarningConfirm: 'OK',
    thaillm_noticeTitle: 'ThaiLLM Family Model',
    thaillm_noticeText: 'This is a ThaiLLM family model. It supports a smaller token limit than mainstream models and its answers may be less accurate. Please keep prompts/input data short and review the answers before using them in production.',
    thaillm_noticeMaxToken: 'This model supports approximately {maxToken} tokens.',
    thaillm_noticeConfirm: 'OK',
    maintenancePageAlt: 'System under maintenance',
    textValidateGroupName: 'This group name already exists, please enter a new group name',
    _inv_recipient_email: 'Recipient Email',
    _inv_status: 'Status',
    _inv_send_date: 'Send Date',
    _inv_expire_date: 'Expiry',
    _inv_used_date: 'Used Date',
    _inv_registered_by: 'Registered By',
    _inv_user_deleted: 'User Deleted',
    _inv_status_used_deleted: 'Used (User Deleted)',
    _inv_status_used_deleted_hint: 'This user registered with this invitation but was later deleted from the system — a new invitation can be sent.',
    _inv_status_used_unlinked: 'Needs Relink',
    _inv_status_used_unlinked_hint: 'The user still exists but has no ThaID/DGA link — please send a new invitation so the user can link SSO again.',
    _inv_status_used_dga_taken: 'Used (DGA Taken by Another)',
    _inv_status_used_dga_taken_hint: 'This user\'s DGA/ThaID is currently linked to another account ({email}) — the user cannot re-register until the current owner unlinks first.',
    _inv_status_pending: 'Pending',
    _inv_status_used: 'Used',
    _inv_status_expired: 'Expired',
    _inv_status_revoked: 'Revoked',
    _inv_reinvite_blocked_dga_taken: 'DGA is currently linked to another account — ask the current owner to unlink first.',
    _no_access_sso_owned_by_other_title: 'This DGA/ThaID is already in use',
    _no_access_sso_owned_by_other_msg: 'The DGA/ThaID you used to register is currently linked to another account. Please contact your Admin or ask the current owner to unlink it first.',
    _inv_reinvite: 'Send New Invitation',
    _inv_reinvite_short: 'Re-invite',
    _inv_reinvite_success: 'New invitation sent successfully',
    _inv_reinvite_pending_exists: 'A pending invitation already exists — please revoke the previous one first.',
    _inv_reinvite_fail: 'Unable to send new invitation',
    _inv_resend: 'Resend',
    _inv_revoke: 'Revoke',
    _inv_recipient_info: 'Recipient Information',
    _inv_permission_usage: 'Permission',
    _inv_expire_in: 'Expires In',
    _inv_email_hint: 'Type an email and press Enter to add. Multiple entries allowed.',
    _inv_invalid_emails: 'Invalid emails',
    _inv_dialog_subtitle: 'Send an invitation to a new user',
    _inv_send_success: 'Invitation sent successfully',
    _inv_items: 'items',
    _inv_send_mixed: 'Sent successfully',
    _inv_sent_label: 'Sent',
    _inv_pending_exists: 'Pending invitation exists',
    _inv_already_registered: 'Already registered',
    _inv_failed_label: 'Failed',
    _inv_send_fail: 'Unable to send invitation. Please try again.',
    _inv_resend_success: 'Email resent successfully',
    _inv_resend_fail: 'Unable to resend email',
    _inv_revoke_confirm: 'Confirm revoke invitation for',
    _inv_revoke_confirm_title: 'Revoke invitation',
    _inv_revoke_confirm_message: 'Are you sure you want to revoke the invitation for {email}?',
    _inv_revoke_confirm_button: 'OK',
    _inv_revoke_success: 'Invitation revoked successfully',
    _inv_revoke_fail: 'Unable to revoke invitation',
    _inv_load_fail: 'Unable to load list',
    _inv_days: 'Days',
    _inv_valid_min_email: 'Please enter at least 1 email',
    _register_invite_title: 'Register invitation',
    _register_invite_subtitle: 'Verify your identity to activate the account',
    _register_invite_loading: 'Checking invitation...',
    _register_back_login: 'Back to Login',
    _register_invited_email: 'Invited email',
    _register_invited_org: 'Organization',
    _register_invited_role: 'Permission',
    _register_invited_expire: 'Expires',
    _register_with_dga: 'Verify with DGA Digital ID',
    _register_with_thaid: 'Verify with ThaID',
    _register_no_sso: 'No identity provider is enabled. Please contact an administrator.',
    _register_invite_identity_hint: 'The verified identity will be linked to this invitation.',
    _register_invite_validate_error: 'Unable to validate invitation. Please try again.',
    _register_invite_expired: 'This registration link has expired. Please contact an admin for a new link.',
    _register_invite_used: 'This link has already been used. If you already registered, try logging in.',
    _register_invite_revoked: 'This link has been revoked. Please contact an admin.',
    _register_invite_not_found: 'Invitation link not found.',
    _register_invite_invalid: 'Invalid link. Please check the email invitation.',
    _register_invite_missing: 'Invitation token missing. Please check the email invitation.',
    _register_invite_unknown: 'Something went wrong. Please contact an admin.',
    refresh: 'Refresh',
    _LLMManagement_NAV: 'LLM Management',
    _sa_nav_dashboard: 'Dashboard',
    _sa_nav_companies: 'Companies',
    _sa_nav_workgroups: 'Workgroups',
    _sa_nav_org_structure: 'Organization Structure',
    _sa_nav_users: 'Users',
    _sa_nav_sales: 'Contact Point',
    _sa_nav_setting: 'Setting',
    _sa_nav_core_config: 'Core Configuration',
    _sa_nav_persona_api: 'Persona API Setting',
    gdxConnectionCacheHint: 'This provider is only for Welfare/GDX (hot-reload). The Redis status below means the backend can connect and write a health key; welfare cards write Redis when LogWelfareQuery runs and Cache is enabled. Card interactions are stored in SQL logs.',
    gdxRedisChipPrefix: 'Redis',
    gdxRedisConnectable: 'connectable',
    gdxRedisConnectableCacheOff: 'connectable · cache switch OFF',
    gdxRedisNotConnectable: 'not connectable',
    gdxRedisNotConfigured: 'not configured',
    gdxCredentialSourceLabel: 'Credential Source',
    gdxKeyVaultSecretPrefix: 'Key Vault Secret Prefix',
    gdxCredentialTitle: 'GDX Credentials',
    gdxCredentialModeHint: 'Set a prefix and leave all 3 credential fields blank to use Key Vault and clear DB overrides on Save; enter any credential field to use Dbsettings override (dev/manual). Applies immediately after hot-reload.',
    gdxCredentialChipPrefix: 'Credential',
    gdxKeyVaultSecretsChip: 'Key Vault secrets',
    gdxCredentialSourceKeyVault: 'Key Vault',
    gdxCredentialSourceDbsettings: 'Dbsettings',
    gdxCredentialSourceError: 'Error',
    gdxCredentialSourceNone: 'None',
    gdxCredentialPrefixHint: 'Example: GDX → GDX-ConsumerKey, GDX-ConsumerSecret, GDX-AgentId',
    nexaApiKeyVaultPrefix: 'Key Vault Secret Prefix',
    nexaApiKeyVaultPrefixPlaceholder: 'NEXA',
    nexaApiKeyVaultPrefixHint: 'Prefix for NEXA API key secrets in environments that still use a Key Vault prefix',
    _sa_nav_consent_config: 'Terms & Conditions',
    _sa_nav_llm: 'LLM Management',
    _sa_nav_llm_groups: 'LLM Groups',
    _llmgroup_title: 'Manage LLM Groups',
    _llmgroup_subtitle: 'Allocate LLM models to companies via groups',
    _llmgroup_tab_groups: 'Groups',
    _llmgroup_tab_assign: 'Assign Companies',
    _llmgroup_assign_readonly_hint: 'Assignment is now managed in the group editor (add multiple companies to a group at once) — this tab is a read-only overview.',
    _llmgroup_tab_drift: 'Out-of-group Configs',
    _llmgroup_add: 'New Group',
    _llmgroup_edit_title: 'Edit LLM Group',
    _llmgroup_add_title: 'Create LLM Group',
    _llmgroup_col_name: 'Group Name',
    _llmgroup_col_members: 'Members',
    _llmgroup_col_assigned: 'Assigned Companies',
    _llmgroup_col_default: 'Default',
    _llmgroup_col_actions: 'Actions',
    _llmgroup_members: 'Models in Group',
    _llmgroup_default: 'Default Group',
    _llmgroup_default_model: 'Group Default Model',
    _llmgroup_set_default: 'Set as Default Group',
    _llmgroup_is_default_chip: 'Default',
    _llmgroup_field_name: 'Group Name',
    _llmgroup_field_members: 'Select Models in Group',
    _llmgroup_field_default_model: 'Select Default Model',
    _llmgroup_field_companies: 'Companies in this group',
    _llmgroup_field_companies_hint: 'Add multiple companies to this group at once — removed companies revert to the Default group',
    _llmgroup_required: 'This field is required',
    _llmgroup_confirm_delete: 'Confirm delete this group?',
    _llmgroup_delete_blocked_assigned: 'Cannot delete — companies are still assigned to this group',
    _llmgroup_delete_blocked_default: 'Cannot delete the default group',
    _llmgroup_success: 'Saved successfully',
    _llmgroup_assign: 'Assign to Company',
    _llmgroup_assign_col_company: 'Company',
    _llmgroup_assign_col_group: 'Current Group',
    _llmgroup_assign_group_placeholder: 'Select group',
    _llmgroup_assign_default_unset: 'Default (not assigned)',
    _llmgroup_assign_success: 'Group assigned successfully',
    _llmgroup_drift: 'Out-of-group Configs',
    _llmgroup_drift_col_model: 'Model',
    _llmgroup_drift_col_company: 'Company',
    _llmgroup_drift_col_status: 'Status',
    _llmgroup_drift_status_in_group: 'In Group',
    _llmgroup_drift_status_out_of_group: 'Out of Group',
    _llmgroup_drift_status_orphan: 'Not Found in Catalog',
    _llmgroup_remediate: 'Remediate',
    _llmgroup_remediate_reassign: 'Reassign to group default',
    _llmgroup_remediate_disable: 'Disable this model',
    _llmgroup_remediate_confirm: 'Confirm remediate this config?',
    _llmgroup_remediate_success: 'Config remediated successfully',
    _llmgroup_model_not_allowed: 'This model is not in the group allowed for this company',
    _llmgroup_model_out_of_group: 'Not permitted',
    _llmgroup_model_out_of_group_tip: "This model uses an LLM outside the company's permitted group — it will be blocked or replaced with the group default at runtime",
    _llmgroup_model_out_of_group_banner: 'This model uses an LLM the organization is no longer permitted to use — please change it to a model within the permitted group.',
    _llmgroup_company_field_label: 'LLM Group',
    _llmgroup_company_field_default_option: 'Default (no group assigned)',
    _sa_nav_subscriptions: 'Subscriptions',
    _sa_nav_packages: 'Packages',
    _sa_nav_event_logs: 'Event Logs',
    _sa_nav_inv_mgmt: 'Invitation Management',
    _sa_nav_landing_page: 'Landing Page',
    _sa_nav_release_notes: 'Release Notes',
    _sa_nav_documents: 'Documents',
    _sa_doc_title: 'Document Management',
    _sa_doc_subtitle: 'Manage documents (Knowledge) across all companies',
    _sa_doc_col_name: 'Document Name',
    _sa_doc_col_company: 'Company',
    _sa_doc_col_createby: 'Created By',
    _sa_doc_col_process: 'Process Status',
    _sa_doc_search_name: 'Search document name',
    _sa_doc_filter_company: 'Filter by company',
    _sa_doc_all_companies: 'All companies',
    _sa_doc_add: 'Add Document',
    _sa_doc_add_title: 'Add New Document',
    _sa_doc_field_company: 'Target Company',
    _sa_doc_field_name: 'Document Name',
    _sa_doc_field_process_type: 'Processing Method',
    _sa_doc_field_maxchar: 'Max characters per chunk',
    _sa_doc_field_custom_char: 'Split character (CustomSplit)',
    _sa_doc_field_detect_lang: 'Auto detect language',
    _sa_doc_field_personal_info: 'Detect personal information',
    _sa_doc_field_file: 'Document file',
    _sa_doc_view: 'View',
    _sa_doc_share: 'Share',
    _sa_doc_detail_title: 'Document Detail',
    _sa_doc_chunk_no: 'No',
    _sa_doc_chunk_org: 'Original Text',
    _sa_doc_chunk_en: 'Text (EN)',
    _sa_doc_chunk_status: 'Status',
    _sa_doc_required: 'Please fill all required fields',
    _sa_doc_upload_success: 'Document added successfully',
    _sa_doc_no_file: 'Please select a file',
    _sa_doc_drag_drop: 'Drag & drop a file here or click to browse',
    _sa_doc_drop_here: 'Drop the file here',
    _sa_doc_click_browse: 'Click to browse',
    _sa_doc_select_doctype_first: 'Select a document type first',
    _sa_doc_invalid_file_type: 'File type does not match the selected document type',
    _sa_doc_upload_file: 'Upload File',
    _sa_doc_upload_mode_label: 'Choose upload method',
    _sa_doc_add_mode: 'Add (keep existing content)',
    _sa_doc_replace_mode: 'Replace all',
    _sa_doc_replace_warning: 'Replacing will delete all existing content first, then import from the new file.',
    _sa_doc_change_file: 'Change file',
    _sa_doc_remove_file: 'Remove',
    _sa_doc_back: 'Back',
    _sa_doc_add_chunk: 'Add Content',
    _sa_doc_edit_chunk: 'Edit Content',
    _sa_doc_chunk_content: 'Content',
    _sa_doc_reprocess: 'Reprocess',
    _sa_doc_delete: 'Delete',
    _sa_doc_delete_all: 'Delete All',
    _sa_doc_actions: 'Manage',
    _sa_doc_confirm_delete_chunk: 'Confirm delete this content?',
    _sa_doc_confirm_delete_doc: 'Confirm delete the entire document?',
    _sa_doc_confirm_reprocess: 'Confirm reprocess this document?',
    _sa_doc_personal_info: 'Personal Information',
    _sa_doc_success: 'Success',
    _sa_doc_active: 'Active',
    _sa_doc_inactive: 'Inactive',
    _sa_doc_duplicate: 'Duplicate',
    _sa_doc_replace: 'Replace',
    _sa_doc_version_history: 'Version History',
    _sa_doc_download: 'Download',
    _sa_doc_duplicate_title: 'Duplicate Document',
    _sa_doc_new_name: 'New document name',
    _sa_doc_replace_title: 'Replace Document',
    _sa_doc_replace_target: 'Select target document to be replaced',
    _sa_doc_version: 'Version',
    _sa_doc_modified: 'Modified',
    _sa_doc_modified_by: 'Modified By',
    _sa_doc_restore: 'Restore',
    _sa_doc_view_version_title: 'View Version Data',
    _sa_doc_confirm_restore: 'Confirm restore this version?',
    _sa_doc_duplicate_success: 'Duplicated successfully',
    _rn_page_title: 'Release Note Management',
    _rn_page_subtitle: 'Create and manage Release Notes for each system',
    _rn_new: 'New Release Note',
    _rn_col_version: 'Version',
    _rn_col_title: 'Title',
    _rn_col_target_system: 'System',
    _rn_col_status: 'Status',
    _rn_col_release_date: 'Release Date',
    _rn_col_items: 'Items',
    _rn_col_published_at: 'Published At',
    _rn_col_actions: 'Actions',
    _rn_filter_all_systems: 'All Systems',
    _rn_status_draft: 'Draft',
    _rn_status_published: 'Published',
    _rn_status_archived: 'Archived',
    _rn_cat_feature: 'Feature',
    _rn_cat_bugfix: 'Bugfix',
    _rn_cat_improvement: 'Improvement',
    _rn_cat_external_api: 'External API',
    _rn_item_connector: 'Connector',
    _rn_item_api_version: 'API Version',
    _rn_validation_required_connector: 'Please select a connector',
    _rn_validation_required_api_version: 'Please select an API version',
    _rn_sys_product_admin: 'Product Admin',
    _rn_sys_chat_framework: 'Chat Framework',
    _rn_sys_both: 'Both',
    _rn_field_version: 'Version',
    _rn_field_title: 'Release Note Title',
    _rn_field_summary: 'Summary',
    _rn_field_release_date: 'Release Date',
    _rn_field_target_system: 'Target System',
    _rn_items_section: 'Change Items',
    _rn_item_category: 'Category',
    _rn_item_detail: 'Detail',
    _rn_add_item: 'Add Item',
    _rn_move_up: 'Move up',
    _rn_move_down: 'Move down',
    _rn_dialog_create: 'Create Release Note',
    _rn_dialog_edit: 'Edit Release Note',
    _rn_confirm_publish: 'Do you want to publish this Release Note?',
    _rn_confirm_publish_title: 'Confirm Publish',
    _rn_confirm_delete: 'Do you want to delete this Release Note?',
    _rn_confirm_delete_title: 'Confirm Delete',
    _rn_success_create: 'Release Note created successfully',
    _rn_success_update: 'Release Note updated successfully',
    _rn_success_publish: 'Release Note published successfully',
    _rn_success_delete: 'Release Note deleted successfully',
    _rn_error_load: 'Failed to load Release Notes',
    _rn_no_data: 'No Release Notes found',
    _rn_validation_required_version: 'Please enter a version',
    _rn_validation_required_title: 'Please enter a release note title',
    _rn_validation_required_release_date: 'Please select a release date',
    _rn_validation_required_target_system: 'Please select a target system',
    _rn_validation_max_version: 'Version must not exceed 20 characters',
    _rn_validation_max_title: 'Title must not exceed 200 characters',
    _rn_validation_items_required: 'Please add at least one change item',
    _rn_validation_item_detail_required: 'Please enter the detail of this item',
    _noti_title: 'Notifications',
    _noti_mark_all_read: 'Mark all as read',
    _noti_empty: 'No notifications',
    _noti_view_all: 'View all',
    _noti_just_now: 'Just now',
    _noti_minutes_ago: '{n} minutes ago',
    _noti_hours_ago: '{n} hours ago',
    _noti_history_subtitle: 'All notification history',
    _noti_type: 'Type',
    _noti_level: 'Level',
    _noti_mark_read: 'Mark as read',
    _noti_go_to: 'Go to',
    _noti_col_level: 'Level',
    _noti_col_type: 'Type',
    _noti_col_title: 'Details',
    _noti_col_read: 'Read',
    _noti_col_date: 'Date',
    reset: 'Reset',
    _sa_inv_mgmt: 'SuperAdmin Invitation',
    _sa_inv_page_title: 'SuperAdmin Invitation Management',
    _sa_inv_page_subtitle: 'Send invitations to users to join as SuperAdmin',
    _sa_portal: 'Super Admin',
    _sa_companies_subtitle: 'Manage all companies in the system',
    _sa_workgroups_subtitle: 'Manage organization structure',
    _sa_users_subtitle: 'Manage all users in the system',
    _sa_sales_subtitle: 'Manage all contact points in the system',
    _sa_sales_search_placeholder: 'Search name, e-mail...',
    _sa_sales_staff_section: 'Contact Point',
    _sa_sales_organization: 'Organization',
    _sa_admin_contact: 'Admin Contact',
    _sa_packages_subtitle: 'Manage all packages in the system',
    _sa_event_logs_subtitle: 'Monitor API event logs in the system',
    _sa_core_config_subtitle: 'Configure core system settings for GPT, Blob, Mail and more',
    _sa_consent_config_subtitle: 'Manage Terms & Conditions text in Thai / English',
    consentAudienceBackend: 'Backend (Admin)',
    consentAudienceFrontend: 'Frontend (End-user)',
    consentAudiencePrivacy: 'Privacy Notice',
    consentAudienceSnippet: 'Terms & Conditions',
    consentUnsavedWarn: 'There are unsaved changes. If you continue, your changes will be discarded.',
    termsDialogTitle: 'Terms & Conditions',
    termsDialogAccept: 'Accept Terms',
    termsDialogDecline: 'Decline',
    termsDialogEnPending: 'English version is being prepared',
    termsDialogLoading: 'Loading Terms & Conditions...',
    termsDialogError: 'Unable to load Terms & Conditions. Please try again.',
    termsDialogRetry: 'Retry',
    termsDialogClose: 'Close',
    // Backend (government-agency) dialog titles — two-part per Figma dialogs 2070:44239 / 2070:44567
    termsDialogTitleBackend: 'Terms and Conditions for the Ask AI Service\nAI-Powered Information Search System (Ask AI) (for Government Agencies)',
    privacyDialogTitleBackend: 'AI-Powered Information Search Service (Ask AI) (for Government Agencies)',
    _sa_new_company: 'New Company',
    _sa_new_user: 'New User',
    _sa_new_sale: 'New Contact Point',
    _sa_new_package: 'New Package',
    _sa_add_subscription: 'Add Subscription',
    _sa_change_password: 'Change Password',
    _sa_new_password: 'New Password',
    _sa_no_data: 'No data found',
    _sa_no_data_desc: 'Try adjusting the filters or adding new data',
    _sa_no_results: 'No results found',
    _sa_ds_gallery_title: 'Design System Gallery',
    _portal_ds_gallery_title: 'Portal Design System Gallery',
    loading: 'Loading',
    _sa_inv_title: 'Send Invitation',
    _sa_inv_emails: 'Recipient Emails',
    _sa_inv_emailHint: 'Type email and press Enter',
    _sa_inv_company: 'Company',
    _sa_inv_role: 'Role',
    _sa_inv_expireDays: 'Expiry Days',
    _sa_inv_send: 'Send Invitation',
    _sa_inv_success: 'Invitation sent successfully',
    _sa_inv_btnLabel: 'Invitation',
    _sa_add_endpoint: 'Add Endpoint',
    _sa_login_config: 'Login Configuration',
    _sa_enable_username_password_login: 'Enable Username / Password Login',
    _sa_login_config_hint: 'Show the Company Code / Username / Password form on the login page',
    loginConfigNoMethodError: 'Cannot disable Username/Password: no SSO method is enabled — this would lock everyone out',
    _sa_payment_history: 'Payment History',
    _sa_history_date: 'Date',
    _sa_history_action: 'Action',
    _sa_history_amount: 'Amount',
    _sa_history_note: 'Note',
    _sa_subscription_tier_project: 'Project',
    _sa_subscription_tier_ministry: 'Company',
    _sa_subscription_tier_new: 'New',
    _sa_subscription_project_summary: 'Overall token usage aggregated from all ministry-level subscriptions',
    _sa_subscription_ministry_count: '{n} ministries',
    _sa_subscription_project_token_usage: 'Project token usage',
    _sa_subscription_project_token_usage_tip: 'Cumulative usage counted against the subscription quota (summed across all ministry-level subscriptions). This is an all-time total and is not affected by the date filter — so it differs from Token Detail, which only counts the selected date range.',
    _sa_subscription_project_remaining_token: 'Remaining project tokens',
    _sa_subscription_edit_project: 'Edit project tier',
    _sa_subscription_project_token_limit: 'Total project tokens',
    _sa_subscription_project_image_limit: 'Total project image credit ($)',
    _sa_subscription_project_unlimited_token: 'Unlimited project tokens',
    _sa_subscription_project_unlimited_image: 'Unlimited project image credit',
    _sa_subscription_project_config_hint: 'Set the total token pool shared by all ministries. The backend blocks usage when the aggregate reaches the limit.',
    _sa_subscription_project_save_success: 'Project tier saved successfully',
    _sa_validation_required_start_date: 'Please select a start date',
    _sa_validation_required_end_date: 'Please select an end date',
    _sa_validation_invalid_date_range: 'End date must be greater than or equal to start date',
    _sa_validation_token_limit_headroom: 'Token limit must be at least 1,000 above the amount already used (minimum {min})',
    _sa_validation_token_limit_min: 'Token limit cannot be negative',
    _sa_reset_token_note: 'Note: When selected, the token usage will be reset to 0 and the limit can be set freely.',
    _sa_token_limit_hint_min: 'Used {used} • minimum limit {min}',
    _sa_token_limit_hint_free: 'Limit can be set freely (no minimum)',
    _sa_subscription_project_controls_ministry: 'Controls ministry tier token usage from this aggregate total',
    _sa_subscription_ministry_list_hint: 'Current subscriptions by organization',
    _sa_subscription_current_tier: 'Current tier',
    _sa_subscription_active_count: 'Active subscriptions',
    _sa_subscription_usage_percent: 'Usage percent',
    _sa_email_rules_title: 'Email Notification Rules',
    _sa_email_rules_subtitle: 'A summary of every case where the system sends an automatic notification email, so you know when to expect one',
    _sa_email_rules_group_expiry: 'Subscription Expiry',
    _sa_email_rules_expiry_30: '30 days before expiry — advance notice',
    _sa_email_rules_expiry_7: '7 days before expiry — urgent renewal reminder',
    _sa_email_rules_expiry_0: 'Already expired — service suspended',
    _sa_email_rules_group_token: 'Token Quota Usage',
    _sa_email_rules_token_80: 'Token usage reaches 80% — advance warning',
    _sa_email_rules_token_95: 'Token usage reaches 95% — nearly critical',
    _sa_email_rules_token_100: 'Token usage reaches 100% — usage blocked',
    _sa_email_rules_group_system: 'System Events (Super Admin only)',
    _sa_email_rules_system_newcompany: 'A new agency/company registers',
    _sa_email_rules_system_newsub: 'A subscription is created or renewed',
    _sa_email_rules_system_suspended: 'An agency is disabled',
    _sa_email_rules_group_general: 'Sending Rules',
    _sa_email_rules_general_schedule: 'Expiry is checked every day at 08:00',
    _sa_email_rules_general_active: 'Only active, non-cancelled subscriptions are notified',
    _sa_email_rules_general_recipients: 'Recipients: Super Admins for all notification types, plus the agency\'s admins for Token and Subscription alerts',
    _sa_email_rules_general_antispam: 'Anti-spam: expiry alerts are sent once per item per day; token alerts once per subscription period',
    _sa_email_rules_general_email_required: 'Recipients must have an email on file, otherwise nothing is sent',
    _sa_items_per_page: 'Items per page',
    _sa_of: 'of',
    _sa_manage: 'Manage',
    _ConsentConfig_NAV: 'Terms & Conditions',
    _CoreConfig_NAV: 'Core Configuration',
    _CompanyManagement_NAV: 'Company Management',
    _WorkgroupManagement_NAV: 'Workgroup Management',
    _sa_wg_org_hierarchy: 'Organization Hierarchy',
    _sa_wg_add_company: 'Add Company',
    _sa_wg_no_company: 'No Company found in the system',
    _sa_wg_editor_mode: 'EDITOR MODE',
    _sa_wg_add_child: 'Add Child Company',
    _sa_wg_view_company: 'View Company',
    _sa_wg_select_node: 'Select a Node to Manage',
    _sa_wg_select_node_hint: 'Click a Company or Workgroup in the list on the left',
    _sa_wg_choose_action: 'Choose an action for this Company',
    _sa_wg_child_workgroup: 'Child Workgroup',
    _sa_wg_edit_in: 'Edit Workgroup in',
    _sa_wg_add_child_for: 'Add Child Company to',
    _sa_wg_child_company: 'CHILD COMPANY *',
    _sa_wg_search_child: 'Search or select a child company',
    _sa_wg_type: 'WORKGROUP TYPE *',
    _sa_wg_select_type: 'Select organization type',
    _sa_wg_portal_user: 'Portal User Chat framework',
    _sa_wg_lock_status: 'Lock Status',
    _sa_wg_locked: 'Locked',
    _sa_wg_unlocked: 'Unlocked',
    _sa_wg_save_changes: 'Save Changes',
    _sa_wg_error_title: 'Error',
    _sa_wg_ok: 'OK',
    _sa_wg_err_company_name: 'Please enter a Company name',
    _sa_wg_err_child_company: 'Please select a child company',
    _sa_wg_err_type: 'Please select a Workgroup Type',
    _sa_wg_err_circular: 'This Company is already assigned as a child of another tree.\nEach Company can have only one parent.',
    _sa_wg_err_move_child: 'Unable to move child Workgroup',
    _sa_wg_err_delete: 'Delete failed',
    _sa_wg_total_companies: 'Companies',
    _sa_wg_total_workgroups: 'Total Workgroups',
    _sa_wg_filter_tree: 'Search Company / Workgroup...',
    _sa_wg_company_code: 'Company Code',
    _sa_wg_company_name: 'Company Name *',
    _sa_wg_mobile: 'Mobile Number',
    _sa_wg_province: 'Province',
    _sa_wg_district: 'District',
    _sa_wg_sub_district: 'Sub District',
    _sa_wg_country: 'Country',
    _sa_wg_post_code: 'Post Code',
    _sa_wg_address: 'Address',
    _sa_wg_email: 'E-mail',
    _sa_wg_username: 'Username',
    _sa_wg_password: 'Password',
    _sa_wg_firstname: 'First Name',
    _sa_wg_lastname: 'Last Name',
    _sa_wg_idcard: 'ID Card',
    _sa_wg_company_section: 'Company Information',
    _UserManagement_NAV: 'User Management',
    _SaleManagement_NAV: 'Contact Point',
    _SubscriptionManagement_NAV: 'Subscription Management',
    _PackageManagement_NAV: 'Package Management',
    _EventLog_NAV: 'Event Logs',
    ClearFilters: 'Clear Filters',
    AdvancedFilters: 'Advanced Filters',
    Download: 'Download',
    ClearAll: 'Clear All',
    Result: 'Result',
    PositiveQuestionSet: 'Positive Question Set',
    search: 'Search',
    UserQuery: 'User Query',
    OrgVectorSearch: 'Original Vector Search',
    ModVectorSearch: 'Translated Vector Search (Eng.)',
    Company: 'Company',
    StreamUploadPrivateMemory: 'Upload',
    StreamFileNamePrivateMemory: 'Document Name',
    StreamPrivateMemory: 'VECTOR',
    StreamPrivateMemoryAdd: 'ADD',
    StreamPrivateMemoryEdit: 'EDIT',
    StreamPopupFileHeader: 'Upload File',
    StreamPopupVoiceHeader: 'Speech',

    StreamPopuplang: 'Language',
    StreamPopupRecord: 'Record',
    FullStream: 'Full Stream',
    Stream: 'Chat Playground',
    no: 'No.',
    date: 'Date',
    description: 'Description',
    usermanagement: 'Portal User Management',
    userChatManagement: 'Chat User Management',
    user: 'User',
    _CompanyCode: 'Company Code',
    companyCodePlaceholder: 'Enter your company code',
    companyCodeLoginHint: 'Chat Framework users must enter a company code. Product Admin SuperAdmin users can leave it blank.',
    loginWithUsername: 'Login with username',
    loginWithSSO: 'Login with SSO',
    orLoginWith: 'Or sign in with',
    loginErrorWithCompanyCodeHint: 'Login failed. Check your username/password, or enter a company code for Chat Framework users.',
    username: 'Username',
    email: 'Email',
    search: 'Search',

    UploadImageEx: 'Example',
    UploadImage: 'Icon',
    add: 'Add',
    New: 'New',
    manage: 'Manage',
    phonenumber: 'Phone Number',
    employeename: 'Employee Name',
    usertype: 'User Type',
    edit: 'Edit',
    delete: 'Delete',
    download: 'Download',
    deleteAll: 'Delete all',
    users: 'Users',
    usergroup: 'User Group',
    permissionmanagement: 'Permission Management',
    menumanagement: 'Menu Management',
    managementModelQuick: 'Management : Quick Model',
    managementGPTModel: 'Model Creator',
    // managementGPTModelDetail: "Management : LLMs Model Detail",
    managementGPTModelNode: 'Management : GPT Model Internal',
    managementModelAndVector: 'Management Model & Vector DB',
    ValidationGenerateUpload: 'Validation generate : Upload',
    calendar: 'Calendar',
    log: 'Log',
    setting: 'Setting',
    groupname: 'Group Name',
    adduseringroup: 'Add user in group',
    permissionname: 'Permission Name',
    save: 'Save',
    close: 'Close',
    update: 'Update',
    firstname: 'First Name',
    lastname: 'Last Name',
    indicatesrequiredfield: 'Indicates required field',
    userprofile: 'User Profile',
    switchcompany: 'Switch Organization',
    logout: 'Log Out',
    password: 'Password',
    confirmpassword: 'Confirm Password',
    checklengthcharacters: 'Length of a least 8 letter',
    checklowercaseletter: 'At least 1 lowercase letter',
    checkuppercaseletter: 'At least 1 uppercase letter',
    checknumber: 'Numbers(0-9)',
    checkspecialcharacter: 'At least 1 special character',
    checkpasswordmatch: 'Confirm password not match',
    rememberme: 'Remember Me',
    forgotpassword: 'Forgot Password?',
    login: 'Login',
    successMessage: 'Logged In Successfully',
    menuname: 'Menu Name',
    number: 'No',
    addgroupinmenu: 'Add group in menu',
    addGPTModel: 'Create GPTModel',
    updateGPTModel: 'Update GPTModel',
    addGPTModelNode: 'Create GPTModelNode',
    updateGPTModelNode: 'Update GPTModelNode',
    uploadCSV: 'Upload CSV',
    uploadNegativeQuestionSet: 'Upload Negative Question Set',
    upload: 'Upload',
    ddfile_browseFilesToUpload: 'Browse Files To Upload',
    ddfile_bytes: 'bytes',
    ddfile_normalQuestion: 'Normal Question',
    ddfile_chainQuestion: 'Chain Question',
    ddfile_download: 'Download',
    ddfile_pleaseUploadCorrectType: 'Please Upload Correct Type!',
    downloadTemplate: 'Download template',
    addModelAndVector: 'Add Model and Vector DB',
    type: 'Type',
    role: 'Role',
    setup_title: 'Platform Integration',
    general_title: 'Core Configurations',
    chatLogs_title: 'Chat Logs',
    setup_search_name: 'Name',
    setup_table_no: 'ID',
    setup_table_key: 'Name',
    setup_table_value: 'Value',
    setup_btn_apply: 'Apply',
    dashboard: 'Dashboard',
    dashboardScore: 'Dashboard score',
    question: 'Question',
    answer: 'Answer',
    score: 'Score',
    Validation: 'Validation',
    GenerateTestQuestions_title: 'Generate Test Questions',
    NegativeDataset_title: 'Negative Question Sets',
    ExecuteTestRuns_title: 'Execute Test Runs',
    DatabaseIntegration_title: 'Database Integration',
    FileManagement_title: 'File Management',
    Documents_title: 'Documents',
    validationScore: 'Validation score',
    calculateScores: 'Calculate Scores',
    averageScore: 'Average score',
    totalUser: 'Total Users',
    totalQuery: 'Total Queries',
    month: 'month',
    LastDayTotalUserUsage: 'Last day total user usage',
    WithinThis30daysagoToTotalUsers: 'Users within the last 30 days/Total Users',
    UserWithinThisDay: 'Users within',
    DaysToTotalUsers: 'days/Total Users',
    UpdatedIn: 'Within the last day',
    UsageOverview: 'Usage Overview',
    TokensUsedMonth: 'Token Usage',
    Usage: 'Usage',
    TokensUsed: 'Total Tokens Used',
    TokensUsedTokensChat: 'Total Tokens Used in Chat',
    DetailTokensUsedTokensChat: 'Token Usage in Chat',
    DetailImageGenChat: 'Image Generation Usage in Chat',
    ImageGenTotalInChat: 'Total generated image in chat',
    ImageGenTotal: 'Total image generated',
    ImageGenTotalPrice: 'Total generated image price',
    ImageGenTotalPriceInChat: 'Total generated image price in chat',
    TokensUsedPromptTokensChat: 'Total Prompt Tokens Used in Chat',
    TokensUsedCompletionTokensChat: 'Total Completion Tokens Used in Chat',
    TokensUsedCachedTokensChat: 'Total Cached Tokens Used in Chat',
    TokensUsedEmbedding: 'Total Embedding Tokens',
    NumberUsers: 'Total Users',
    TotalModels: 'Total Models',
    WithinThisMonth: 'Within this month',
    UserUsage: 'User usage',
    TotalUsagePerMonth: 'Total usage per month',
    NumberPeople: 'Number of people',
    NumberData: 'Number of data',
    People: 'User',
    NumberQuestions: 'Number of questions',
    LoginUserChartTitle: 'Daily Login & Non-Login Users',
    CategoryQuestionMonthly: 'Category Questions',
    OtherQuestionMonthly: 'Other Questions',
    AnalyticsPendingNotice: 'Question ranking is still being processed for the selected date range (showing a partial result so the page loads in time). The numbers may be incomplete.',
    QuestionsTabLogin: 'Login users',
    QuestionsTabNonLogin: 'Non-login users',
    QuestionsEmpty: 'No questions in the selected range',
    LoginCountPerDayTooltip: 'Each day\'s count of active users, added up across the range — e.g. someone active on 3 days counts as 3, not 1',
    RankNo: 'Rank',
    TopicLabel: 'Topic',
    SearchCountLabel: 'Search Count',
    QuestionCompanyLabel: 'Company',
    SeriesLoginUsers: 'Users (Login)',
    SeriesNonLoginUsers: 'Users (Non-Login)',
    SeriesTotal: 'Total',
    ChartSubtotalLogin: 'Login',
    ChartSubtotalNonLogin: 'Non-Login',
    People2: 'users',
    saDashboardWelcome: 'Welcome back',
    saDashboardWelcomeSubtitle: 'Overall Super Admin system overview',
    saDashboardExportAll: 'Export All',
    saDashboardProvider: 'Provider',
    saDashboardAllProviders: 'All Providers',
    saDashboardChooseAgencies: 'Choose agencies',
    saDashboardAllAgencies: 'All agencies',
    saDashboardSearchAgency: 'Search agency...',
    saDashboardSelectByStructure: 'Select by structure',
    saDashboardApplyFilter: 'Apply',
    saDashboardNoCompanyFound: 'No agency found',
    saDashboardStartDate: 'Start date',
    saDashboardEndDate: 'End date',
    saDashboardOverview: 'Overview',
    saDashboardOverviewSubtitle: 'Overall system statistics',
    saDashboardTotalUser: 'Smart Chat Users',
    saDashboardSmartChat: 'Smart Chat',
    saDashboardAIUsers: 'AI Users',
    saDashboardLikeLabel: 'Like',
    saDashboardTotalModels: 'Total Models',
    saDashboardActiveModels: 'Active Models',
    saDashboardActiveModelsTrend: 'Models active in selected period',
    saDashboardLikedMessages: 'Liked Messages',
    saDashboardDislikeLabel: 'Dislike',
    saDashboardCompanies: 'Origanizations',
    saDashboardSelectedFilters: 'Selected filters',
    saDashboardAllValue: 'All',
    saDashboardAgencies: 'agencies',
    saDashboardTotalAgencies: 'Total agencies',
    saDashboardTokenDetail: 'Token Detail',
    saDashboardUsage: 'Usage',
    saDashboardTokenDetailSubtitle: 'Token usage breakdown across all agencies',
    saDashboardTokenUsageTitle: 'Token Usage',
    saDashboardTokenUsageSubtitle: 'Top 5 by model',
    saDashboardSystemUsersTitle: 'Daily Smart Chat Usage Trend',
    saDashboardPerMonth: 'Per month',
    saDashboardPerDay: 'Per day',
    saDashboardCategoryQuestionsSubtitle: 'Most searched category questions',
    saDashboardOtherQuestionsSubtitle: 'Most searched other questions',
    saDashboardCompanyDetails: 'Company Details',
    saDashboardCompanyDetailsSubtitle: 'Workgroup type, name, used tokens, and users by company',
    saDashboardWorkgroupType: 'Workgroup Type',
    saDashboardCode: 'Code',
    saDashboardCompanyCards: 'Company Summary Cards',
    saDashboardCompanyCardsSubtitle: 'Tokens, users, and documents per company',
    saDashboardCardUsage: 'Usage',
    saDashboardName: 'Name',
    saDashboardUsedToken: 'Used Token',
    saDashboardUsers: 'Users',
    saDashboardNoData: 'No data',
    saDashboardNoCompanyData: 'No company data',
    saDashboardNoSubscription: 'No subscription yet',
    saDashboardExportFail: 'Export failed. Please try again.',
    saDashboardExportSuccess: 'Export completed successfully.',
    saDashboardDocuments: 'Documents',
    saDashboardDocLastUpdated: 'Document Last Updated',
    saDashboardDocSortTip: 'Click to sort by last document update date (newest → oldest → default)',
    saDashboardDocDaysAgo: 'days ago',
    saDashboardDocToday: 'today',
    saDashboardDocumentDetails: 'Knowledge Document Details',
    saDashboardDocumentName: 'Document Name',
    saDashboardDocumentCreatedBy: 'Created By',
    saDashboardDocumentUpdatedAt: 'Last Updated',
    saDashboardDocumentProcess: 'Process',
    saDashboardDocReviewStatus: 'Status',
    saDocStatusDraft: 'Draft',
    saDocStatusTesting: 'Testing',
    saDocStatusReady: 'Ready',
    saDocStatusIssue: 'Has Issue',
    saDocStatusNone: 'Not set',
    saDocStatusUpdated: 'Status updated',
    saDocStatusUpdateFailed: 'Failed to update status',
    saDashboardDocumentNoData: 'No knowledge documents',
    saDashboardDocumentDialogClose: 'Close',
    saDashboardViewDocuments: 'View documents for',
    saDashboardTotalTokensAll: 'Total Tokens (All)',
    saDashboardPromptTokens: 'Prompt Tokens',
    saDashboardTotalTokensFormulaTip: 'Prompt Tokens + Completion Tokens + Embedding Tokens = Total Tokens (All) · Cached is already included in Prompt',
    saDashboardTotalTokensFormulaNote: 'Cached is in Prompt · Embedding included',
    saDashboardChatPromptTokens: 'Chat Prompt Tokens',
    saDashboardCachedTokens: 'Cached Tokens',
    saDashboardNonCachedTokens: 'Non-Cached Tokens',
    saDashboardNonCachedFormulaTip: 'Prompt Tokens − Cached Tokens = Non-Cached Tokens · the portion of Prompt that did not hit the cache (charged at full price)',
    saDashboardNonCachedFormulaNote: 'Prompt − Cached · portion not served from cache',
    saDashboardCompletionTokens: 'Completion Tokens',
    saDashboardEmbeddingTokens: 'Embedding Tokens',
    saDashboardProcessingTokens: 'Processing Tokens',
    saDashboardProcessingTokensInfo: 'Tokens the AI uses behind the scenes to process a request but that don\'t appear as chat messages: intent detection, knowledge/document retrieval (RAG/vector), data/SQL query generation, response formatting (JSON), and retries. These count toward your usage quota just like chat answers.',
    saDashboardTotalInclProcessing: 'Total (incl. processing)',
    saDashboardTotalInclProcessingNote: 'Total Tokens (All) + Processing · equals quota usage for the selected period',
    saDashboardLimitTokens: 'Limit Tokens',
    saDashboardQuotaValidUntil: 'Valid until',
    saDashboardQuotaExpiredOn: 'Expired on',
    saDashboardTokenDetailPeriod: 'Token Detail (selected period)',
    saDashboardTokenDetailPeriodTip: 'Actual token usage from logs for the selected date range only.',
    saDashboardQuotaGroup: 'Subscription Quota (total)',
    saDashboardQuotaGroupTip: 'Quota used by the current subscription package — the counter resets every time the package is renewed or changed, and it is independent of the selected date range. If an agency recently renewed, this number can be lower than the period usage (from the Subscription table).',
    saDashboardUnlimited: 'Unlimited',
    saDashboardNoSubscription: 'No package',
    saDashboardFooterTotal: 'Grand Total',
    saDashboardTokensSeries: 'Tokens',
    saDashboardUserActivity: 'User Activity',
    saDashboardTotalLikeDislike: 'Total Like/Dislike',
    saDashboardSelectedAgencies: '{n} agencies selected',
    saDashboardClearAll: 'Clear all',
    saDashboardShowTokens: 'Tokens',
    saDashboardShowUsd: 'USD ($)',
    saDashboardShowThb: 'THB (฿)',
    saDashboardPriceApproxNote: 'Approx. price',
    saDashboardBillableNote: 'Actual amount billed to the customer (incl. processing — matches quota deducted)',
    gpt_model_management_replace: 'Replace',
    gpt_model_management_version_history: 'Version history',
    gpt_model_management_version_history_detail: 'Version history detail',
    gpt_model_management_export_file_config: 'Export file',
    importVectorTitle: 'Do you want to import a Vector?',
    importPrivate_MemoryTitle: 'Do you want to import a Vector?',
    doctype: 'DocType',
    vectortype: 'VectorType',
    process_type: 'Process Type',
    yes: 'Yes',
    cancel: 'Cancel',
    // ── Consent (PDPA) before register / link with DGA Digital ID or ThaID ──
    ssoConsentTitle: 'Consent to Collect Personal Data',
    ssoConsentIntroRegister: 'To register and verify your identity via {provider}, the system needs to collect and use the following personal data:',
    ssoConsentIntroLink: 'To link your account with {provider}, the system needs to collect and use the following personal data:',
    ssoConsentItem1: 'Full name',
    ssoConsentItem2: 'National ID number',
    ssoConsentItem3: 'Date of birth and gender',
    ssoConsentItem4: 'Registered address',
    ssoConsentItem5: 'Other data received from the identity verification provider',
    ssoConsentPurpose: 'The data above will be collected and used for identity verification and to provide services in accordance with the system’s purposes, under the Personal Data Protection Act B.E. 2562 (PDPA).',
    ssoConsentCheckbox: 'I have read and consent to the collection and use of the personal data above.',
    ssoConsentAgree: 'Consent & Continue',
    confirm: 'Confirm',
    confirmDeletion: 'Delete Confirmation',
    confirmRenewal: 'Renew Confirmation',
    confirmDeletion2: 'Do you want to confirm this deletion?',
    confirmDeletionGroup: 'Do you want to confirm deletion of this group?',
    // confirmDeletionModel: 'Do you want to confirm deletion of this model?',
    confirmDeletionModelPart1: 'Are you sure you want to delete model', // Added part 1
    confirmDeletionModelPart2: '', // Added part 2 (empty for English structure)
    confirmDeletionMessage: 'Do you want to confirm deletion of this message?',
    confirmDeletionModelGroup: 'Do you want to confirm deletion of this model group?',
    confirmDeletionModelShortcut: 'Do you want to confirm deletion of this model shortcut?',
    confirmDeletionSetting: 'Do you want to confirm deletion of this setting?',
    confirmDeletionVectorName: 'Do you want to confirm deletion of this vector name?',
    confirmDeletionVector: 'Do you want to confirm deletion of this vector?',
    confirmDeletionDocument: 'Do you want to confirm deletion of this document?',
    confirmDeletionDocumentName: 'Do you want to confirm deletion of this document name?',
    confirmDeletionTableName: 'Do you want to confirm deletion of this table name?',
    confirmDeletionIntentGroup: 'Do you want to confirm deletion of this intent group?',
    confirmDeletionIntentSession: 'Do you want to confirm deletion of this intent session?',
    confirmDeletionUser: 'Do you want to confirm deletion of this user?',
    confirmDeletionFile: 'Do you want to confirm deletion of this file?',
    confirmDeletionAllFile: 'Do you want to confirm deletion of this all file?',
    confirmDeletionQuestion: 'Do you want to confirm deletion of this question?',
    confirmDeletionAllQuestion: 'Do you want to confirm deletion of all these questions?',
    confirmDeletionPrompt: 'Do you want to confirm deletion of this Prompt?',
    confirmOn: 'Confirm opening',
    confirmOff: 'Confirm closing',
    confirmOnVectorName: 'Do you want to confirm the opening of this vector?',
    confirmOffVectorName: 'Do you want to confirm the closure of this vector?',
    confirmDeleteConfirmation: 'Delete confirmation',
    vectorReprocess: 'Do you want to Reprocess?',
    conditionScore0: '0 = the answer from GPT is not related to question.',
    conditionScore1: '1 = the answer from GPT is related to question around 50% - 80%.',
    conditionScore2: '2 = the answer from GPT is most relevant to the question and the answers that GPT cannot answer also.',
    general: 'General',
    social: 'Social',
    groupModel: 'Model Grouping',
    QuickModel: 'Model Shortcut',
    groupModelName: 'Model Group Name',
    groupIntentName: 'Name group Intent',
    modelQuickGroupName: 'Name quick model',
    modelID: 'Model ID',
    model: 'Model',
    modelName: 'Model Name',
    modeldata: 'LLMs Management',
    editnewmodel: 'Edit New Model',
    deletemodeldata: 'Delete Model data',
    areyousuretodeletethisdata: 'Are you sure to delete this data?',
    addnewmodel: 'Add New Model',
    loadingpleasewait: 'Loading Please Wait...',
    pleasefillininformation: 'Please fill in information',
    superAdmin: 'Super admin',
    oneSuperAdmin: 'There must be at least one SuperAdmin role.',
    notAuthoritySuperAdmin: 'You do not have the authority to delete the SuperAdmin role.',
    admin: 'Admin',
    generalUsers: 'User',
    totalNumber: 'Total Number',
    groupReplaceText: 'Text Replacement',
    replaceText: 'ReplaceText',
    specificText: 'SpecificText',
    warning: 'Warning',
    warningSpecialCharacters: 'String contains special characters! Please remove them.',
    warningFillAll: 'Please fill in the complete information.',
    questionSetName: 'Question Set Name',
    questionSetType: 'Question Set Type',
    warningFillIntentGroupName: 'Please fill Intent Group Name',
    warningModelName: 'Please enter the Model name',
    warningProvider: 'Please select a Provider',
    warningModel: 'Please select a Model',
    warningPublish: 'Please select Draft or Publish',
    warningTemperature: 'Please enter a Temperature value between 0 - 1 (2 decimal)',
    warningChainMassage: 'Please enter a Sequence or Duration(s) for Enable Multi-Turn Input.',
    warningTopP: 'Please enter a topP value between 0 - 1 (2 decimal)',
    warningVectordbName: 'Please select a Vector DB name (more than one can be selected)',
    warningTopVDB: 'Please enter a Top VDB value starting from 1',
    warningAPIVersion: 'Please add API Version in Master Data',
    warningWaitProcess: 'Please wait for the previous process to finish working first',
    warningFillCustomMaxCharacter: 'Please fill in the Custom Max Character',
    warnningStartdateEnddate: 'Please fill in the StartDate and EndDate.',
    warningDuplicateDomain: 'The domain is already in use.',
    warningEnableTime: 'Time Zone is required. Since you have enabled time, please select a time zone for accurate responses.',

    errorUploadImage: 'Unable to upload image, please try again.',
    importReplaceTextTitle: 'Do you want to import a Replace Text?',
    importIntentText: 'Do you want to import a Intent Text?',
    totalUsedChatExpense: 'Total used chat expense',
    totalExpense: 'Total price',
    totalPriceForEmbedding: 'Total price for Embedding',
    priceForAllChatUsage: 'Total price for chat usage',
    totalPriceOfPromptChat: 'Total price of Prompt Chat',
    totalPriceOfCompletionChat: 'Total price of Completion Chat',
    totalPriceOfCachedChat: 'Total price of Cached Chat',
    totalPriceOfPromptGPT3: 'Total price of Prompt GPT-3-Turbo',
    totalPriceOfPromptGPT316k: 'Total price of Prompt GPT-3-Turbo-16k',
    totalPriceOfPromptGPT4: 'Total price of Prompt GPT-4',
    totalPriceOfPromptGPTOTHER: 'Total price of Prompt Other',
    totalPriceOfCompletionChatGPT3: 'Total price of Completion Chat GPT-3-Turbo',
    totalPriceOfCompletionChatGPT316k: 'Total price of Completion Chat GPT-3-Turbo-16k',
    totalPriceOfCompletionChatGPT4: 'Total price of Completion Chat GPT-4',
    totalPriceOfCompletionChatGPTOTHER: 'Total price of Completion Chat Other',
    baht: 'THB',
    TokensUsedPromptGPT3TokensChat: 'Total Prompt Tokens GPT-3-Turbo used in Chat',
    TokensUsedPromptGPT316kTokensChat: 'Total Prompt Tokens GPT-3-Turbo-16k used in Chat',
    TokensUsedPromptGPT4TokensChat: 'Total Prompt Tokens GPT-4 used in Chat',
    TokensUsedCompletionGPT3TokensChat: 'Total Completion Tokens GPT-3-Turbo  used in Chat',
    TokensUsedCompletionGPT316kTokensChat: 'Total Completion Tokens GPT-3-Turbo-16k  used in Chat',
    TokensUsedCompletionGPT4TokensChat: 'Total Completion Tokens GPT-4 used in Chat',
    promptPrice: 'Prompt price',
    completionPrice: 'Completion price',
    T30dayago: 'Within the last 30 days',
    WithinThis30daysago: 'Within the last 30 days',
    WithinThisDaysAgo: 'Within',
    Day: 'day',
    ReportQuestion: 'Question Trends',
    ReportUser: 'Top Users',
    ReportFeedback: 'Report Feedback',
    Questions: 'Questions',
    Answers: 'Answers',
    LikeDislike: 'Like/Dislike',
    Comments: 'Comments',
    PromptTemplate: 'Prompt Template',
    Active: 'Active',
    Inactive: 'Inactive',
    active: 'Active',
    inactive: 'Inactive',
    ReportTotalQuestionByUser: 'Total Usage Insights',
    SettingExternalConnector: 'External Connector',
    previousTab: 'Previous tab',
    nextTab: 'Next tab',
    ModelDisplay: 'Model Display',
    Provider: 'Provider',
    releases: 'Release notes',
    vector_management_duplicate: 'Duplicate',
    vector_management_replace: 'Replace',
    vector_duplicate: 'Add Vector',
    importUserTitle: 'Do you want to import a User?',
    system: 'System',
    internal: 'Internal',
    external: 'External',
    testConnection: 'Test Connection',
    allcolumn: 'Get All Column',
    connectionString: 'Connection string',
    view: 'view',
    view_detail: 'View detail',
    dataIntegrationName: 'Data Integration Name',
    SocialUserID: 'Line UserID',
    RecipientId: 'Facebook UserID',
    RecipientId_Instagram: 'Instagram User ID',
    ConfirmDataAddition: 'Confirm data addition',
    TranslateEnglish: 'Translate english',
    DataSearchVector: 'Data search vector',
    selectToDeleteFile: 'Select to delete file',

    _InfoModelDisplay: 'The Model Display information will show the Model Display number when it is Published or Drafted.',
    _InfoModelName: 'Model name.',
    _InfoProvider: 'Select a service provider.',
    _InfoModel: 'Model from the service provider.',
    _InfoExtension: 'Extension of the model',
    _InfoDescriptiion: 'Additional description',
    _InfoGender: 'The gender of Chatbot',
    _InfoVersion: 'The version currently in use',
    _InfoStream: 'In the case of selecting Stream, it will be a situation where the Chat Framework will display responses one character at a time.',
    _InfoByPass:
      'In the case of selecting Bypass, it will be a situation where the Chat Framework is allowed to respond with information outside of the specified Prompt or Vector data, and can search for information from public knowledge to answer.',
    _InfoFeedback:
      'In the case of selecting Feedback, it will be a situation where the Chat Framework is allowed to respond with information outside of the specified Prompt or Vector data, and can search for information from public knowledge to answer.',
    _InfoEnableTime: 'If enabled, the system will include the current date and time in the prompt, allowing the bot to understand and respond based on real-time information.',
    _InfoImageUpload: 'In the case of selecting “Upload image”, it allows the Chat Framework to use the image upload function for questioning.',
    _InfoVectorDBName: 'Pick one or more existing knowledge collections. To add or edit their contents, go to the "Document Management" menu.',
    _InfoGroupReplaceText: 'The edited word group can be modified on the Text Replacement page.',
    _InfoTopVDB: 'The maximum sequence of probabilities',
    _InfoCosine: 'The maximum number of probabilities',
    _InfoSequence: 'The number of conversation sequences to be combined for use in the latest search and answer questions',
    _InfoTimeSeconds: 'Link the questions within a specified time range (seconds)',
    _InfoMemory: 'Memory',
    _InfoMultiTurnInput: 'Enable Multi-Turn Input',
    _InfoTurn: 'The number of turn data can be stored.',
    _InfoMinute: 'The time that can remember the data.',
    _InfoShortMemory: 'The number of characters for storing data.',
    _InfoLongtermMemory: 'Long-term data storage (storing data in chunk format).',
    _InfoTemperature:
      'Controls randomness. Lowering the temperature means that the model will produce more repetitive and deterministic responses. Increasing the temperature will result in more unexpected or creative responses. Try adjusting temperature or Top P but not both.',
    _InfoTopP:
      'Similar to temperature, this controls randomness but uses a different method. Lowering Top P will narrow the model’s token selection to likelier tokens. Increasing Top P will let the model choose from tokens with both high and low likelihood. Try adjusting temperature or Top P but not both.',
    _InfoFrequencyPenalty:
      'Reduce the chance of repeating a token proportionally based on how often it has appeared in the text so far. This decreases the likelihood of repeating the exact same text in a response.',
    _InfoPresencePenalty: 'Reduce the chance of repeating any token that has appeared in the text at all so far. This increases the likelihood of introducing new topics in a response.',
    _InfoMaxToken: 'Maximum number of Tokens',
    _InfoStop:
      "Make the model end its response at a desired point. The model response will end before the specified sequence, so it won't contain the stop sequence text. For ChatGPT, using <{'|'}im_end{'|'}> ensures that the model response doesn't generate a follow-up user query. You can include as many as four stop sequences.",
    _InfoDataIntegration: 'Data from Data Integration',
    _InfoSQLExtractStatement: 'The model used to create SQL Statement',
    _InfoPromt:
      'Give the model instructions about how it should behave and any context it should reference when generating a response. You can describe the assistant’s personality, tell it what it should and shouldn’t answer, and tell it how to format responses. There’s no token limit for this section, but it will be included with every API call, so it counts against the overall token limit.',
    _InfoAdditionalPromt: 'Can select a prompt template to replace the current prompt.',
    prefixMessage: 'Prefix message',
    prefixPreview: 'Response preview',
    prefixQuestionLine: 'ตามที่ถามผมว่า',
    prefixSampleQuestion: 'Sample question',
    prefixSampleAnswer: 'Sample AI answer',
    enabled: 'Enabled',
    disabled: 'Disabled',
    _InfoVectorDatabaseName: 'The name is Vector.',
    _InfoProcess_type: 'Choose the type of operation.',
    _InfoCustomMaxCharacter: 'Custom Max Character',
    _InfoDetectLanguage: 'Check the language.',
    _InfoDoctype: 'The type of document you want to upload.',
    _InfoVectortype: 'Check the structure type of the uploaded document. You can check the document type at the Template.',
    _InfofillterModelType: 'Types of data segmentation',
    _InfoDataIntegrationName: 'The name used to refer to this data connection inside the system. You choose it yourself; it must be unique within your company — you will pick this name when assigning a data source to a model or flow.',
    _InfoConnectionString: 'Connect to SQL Server Connection string',
    _InfoSchema: 'Schema name',
    _InfoTable: 'Table name',
    _InfoFuzzy: 'Compare data in the table for use in correcting errors.',
    _InfoFuzzyWithBot: 'FuzzyWithBot : Compare data in the table for use in correcting errors By Bot.',
    _Personal_Info: 'This column data will be checked for user access.',
    _InfoAllCloumns: 'Get All Columns in Table.',
    _InfoAddColumn: 'Add only the desired column (not necessary to use every column in the table).',
    _InfoReplaceGroup: 'Please enter the group name.',
    _InfoNumberOfQuestions: 'Number of questions to be generated',
    _InfoNumberOfQuestionsTone: 'Set the number to create questions for each Tone.',
    _InfoTypeOptions: 'Token usage = For checking the number of tokens used, Raw log = All logs, Memory Debugger = Memory data stored in each question and answer session.',
    _InfoStartDate: 'Start date',
    _InfoEndDate: 'End date',
    _InfoValidationNegariveName: 'Validation Negative name',
    _InfoValidationPositiveName: 'Validation Positive name',
    _InfoValidationName: 'Validation name',
    _InfoQuestionPositiveName: 'Question Positive name',
    _InfoQuestionNegativeName: 'Question Negative name',
    _InfoSelectModel: 'Select Model',

    _InfoBoxFirm: 'Firm',
    _InfoBoxConfident: 'Confident',
    _InfoBoxPoetic: 'Poetic',
    _InfoBoxNarrative: 'Narrative',
    _InfoBoxProfessional: 'Professional',
    _InfoBoxDescriptive: 'Descriptive',
    _InfoBoxHumorous: 'Humorous',
    _InfoBoxAcademic: 'Academic',
    _InfoBoxPersausive: 'Persausive',
    _InfoBoxFormat: 'Format',
    _InfoBoxInformal: 'Informal',
    _InfoBoxFriendly: 'Friendly',

    _InfoSelectGroupModel: 'Select the Group model if you want to edit a Model that is within a group. You can make edits on the Group model page.',
    _InfoSelectQuickModel: 'Choose a model shortcut. To edit the models inside the group, go to the "Model Quick Reply" page.',
    _InfoCurrentPrompPrice: 'The price for asking questions per 1,000 tokens',
    _InfoCurrentComppletionPrice: 'The price for answering questions per 1,000 tokens',
    _InfoVersionOfModel: 'Version of the model',
    _InfoPromptTemplateName: 'Name of the Prompt template',
    _InfoStatusTemplate: 'The status of using the Template. You can activate up to 10 Templates.',
    _InfoPriority: 'Priority',
    _InfoGroupModelName: 'Name of the model that is grouped',
    _InfoGroupPromptTemplate: 'Select Group Prompt template.',
    _InfoAllModel: 'All model',
    _InfoModelinGroup: 'The selected model will be grouped together.',
    _InfoTimeDelay: 'Time Delay(millisec)',
    _InfoLimitedCharacter: 'Limited Character.',
    _InfoHostName: 'Host name',
    _InfoEmailHost: 'Email host',
    _InfoSetupLinkMS: 'Link for use on MS Teams (iFrame).',
    _InfoModelQuickGroupName: 'Models under the Group model.',
    _InfoGroupName: 'Models Group Name.',
    _InfoMSTeamsName: 'Name used for MS Teams.',
    _InfoMonitorLINEUserid: 'UserID of Line used for Monitor.',
    _InfoLINEName: 'Line name',
    _InfoTypingSpeed: 'Typing Speed(millisec)',
    _InfoMaximumChatInput: 'Maximum chat input text area(character)',
    _InfoDomainNameForSnippet: 'Domain name used for Snippet.',
    _InfoFacebookName: 'Name used for Facebook.',
    _InfoAPI_Version: 'API Version for Facebook Messenger API.',
    _InfoPageId: 'Page ID for Facebook Page.',
    _InfoMaximumFileUpload: 'Set the file upload limit (KB)',
    _UseUploadFile: 'Use file upload',
    _InfoScore: 'Score is the level of importance, ranked from least to most. For example, if there is more than one matching intent, the intent with the lowest score will be selected.',
    _InfoForUploadDateTimeDataType: 'If you select the data type as datetime, put it as in the format yyyy/MM/dd HH:mm:ss only, e.g., 2024/12/31 12:30:00.',
    _InfoForDeleteAllFile: 'Delete all files',
    _InfoInstagramName: 'Name used for Instagram.',

    _InfoNotiOn: 'Notification sound turned on',
    _InfoNotiOff: 'Notification sound has been turned off.',

    loginMicrosoft: 'Sign in with Microsoft',
    sync: 'Sync',
    _SSOWarning: 'Single Sign-On is not yet enabled. Please go to the Setup menu to enable it.',
    PlayGround: 'Dual Chat Playground',
    _columnDataIntegration: 'Column',
    _typeDataIntegration: 'Data Type',
    _duplicateColumn: 'Duplicate Column',
    _incorrectColumn: 'Incorrect Column',
    _ConfirmDataUpdate: 'Confirm data update',

    _ShowAllText: 'Show all text',
    _ShowAllTextOn: 'ON',
    _ShowAllTextOff: 'OFF',
    _ShowPromptTemplate: 'Show Prompt Template',
    _ShowAll: 'Show All',

    //Navbar Name
    _Dashboard: 'Dashboard',
    _ModelCreator: 'Model Creator',
    _KnowledgeManagement: 'Knowledge Management',
    _Documents: 'Documents',
    _DatabaseIntegration: 'Database Integration',
    _OptimizationTechniques: 'Optimization Techniques',
    _TextReplacement: 'Text Replacement',
    _ModelTesting: 'Model Testing',
    _GenerateTestQuestions: 'Generate Test Questions',
    _NegativeQuestionSet: 'Negative Question Set',
    _UploadNegativeQuestionSet: 'Upload Negative Question Set',
    _ExecuteTestRuns: 'Execute Test Runs',
    _UserManagement: 'User Management',
    _PortalUserManagement: 'Portal User Management',
    _ChatUserManagement: 'Chat User Management',
    _ChatManagement: 'Chat Management',
    _Setting: 'Setting',
    _CoreConfigurations: 'Core Configurations',
    _PlatformIntegration: 'Platform Integration',
    _EntraApps: 'Entra Apps',
    _entraVerification: 'Microsoft Entra Verification',
    _entraVerificationOn: 'ON — Users must verify Entra before using the bot',
    _entraVerificationOff: 'OFF — Bot works normally without verification (default)',
    _entraApp: 'Entra App',
    _entraAppPlaceholder: '— Select Entra App —',
    _manageEntraApps: 'Manage Entra apps',
    _liffId: 'LIFF ID',
    _liffIdPlaceholder: 'e.g. 2001234567-AbCdEfGh',
    _entraAppName: 'Entra App Name',
    _entraTenantId: 'Tenant ID',
    _entraClientId: 'Client ID',
    _entraClientSecret: 'Client Secret',
    _entraScopes: 'Scopes',
    _entraSecretHint: 'The current secret is loaded (hidden) — click the eye icon to reveal; edit and save to overwrite.',
    _addEntraApp: 'Add Entra App',
    _editEntraApp: 'Edit Entra App',
    _entraAppManagement: 'Microsoft Entra App Configurations',
    _entraAppTableHint: '1 row = 1 Entra app registration — LINE OA cards in Platform Integration select one via dropdown (multiple OAs can share the same app)',
    _lineEntraLinkManagement: 'Verified LINE Users (Entra)',
    _lineEntraLinkTableHint: '1 row = one LINE user verified against Entra — "Unlink" forces the user to verify again on their next message.',
    _manageVerifiedUsers: 'Manage Verified Users',
    _backToEntraApps: 'Back to Entra Apps',
    _filterByEntraApp: 'Filter by Entra App',
    _lineDisplayName: 'LINE Display Name',
    _entraUpn: 'Entra Account (UPN)',
    _entraName: 'Entra Name',
    _verifiedAt: 'Verified At',
    _unlink: 'Unlink',
    _showInactive: 'Show unlinked',
    _confirmUnlinkTitle: 'Confirm unlink?',
    _confirmUnlinkText: 'This user will need to verify again on their next message.',
    _unlinkSuccess: 'Unlinked successfully',
    _ModelGrouping: 'Model Grouping',
    _ExternalConnector: 'External Connector',
    _SnippetCustomization: 'Snippet Customization',
    _SnippetSmallCustomization: 'Snippet Customization (Small)',
    _SnippetFullCustomization: 'Snippet Customization (Full)',
    _ModelShortcut: 'Model Shortcut',
    _LLMsManagement: 'LLMs Management',
    _PromptTemplate: 'Prompt Template',
    _Reports: 'Reports',
    _QuestionTrends: 'Question Trends',
    _TopUsers: 'Top Users',
    _TotalUsageInsights: 'Total Usage Insights',
    _TokenPerPage: 'Token Per Page',
    rpt_title: 'Token Usage Per Page',
    rpt_pageTokenManagement: 'Token Usage Per Page',
    rpt_dateRange: 'Date Range',
    rpt_startDate: 'Start Date',
    rpt_endDate: 'End Date',
    rpt_search: 'Search',
    rpt_rank: 'Rank',
    rpt_no: 'No.',
    rpt_pageName: 'Page Name',
    rpt_modelName: 'Model Name',
    rpt_totalToken: 'Total Token',
    rpt_cachedToken: 'Cached Token',
    rpt_pageNameTooltip: 'The page/feature that consumed tokens, e.g. Chat Playground, Dual Chat Playground, Snippet, External API, Document', // BUG3 fix: examples match pageLabel() localized values
    rpt_modelNameTooltip: 'AI model used on this page (embedding is shown as a dash)',
    rpt_totalTokenTooltip: 'Total tokens (input + output + embedding) for this page',
    rpt_cachedTokenTooltip: 'Cached tokens for this page',
    rpt_dataRecords: '{n} records',
    rpt_noModel: '-',
    rpt_loadingPleaseWait: 'Loading, please wait...',
    rpt_pleaseFillRequiredFields: 'Please select a complete date range',
    _ChatLogs: 'Chat Logs',
    _ChatPlayground: 'Chat Playground',
    _DualChatPlayground: 'Dual Chat Playground',
    _Snippet: 'Snippet', // BUG3 fix: channel/PageName label
    _ExternalAPI: 'External API', // BUG3 fix: channel/PageName label
    _Document: 'Document', // BUG3 fix: channel/PageName label
    _ChatService: 'Chat Service',
    _DocumentManagement: 'Document Management',
    _Product: 'Product',
    _ProductDetail: 'Product Detail',
    _KnowledgeGraphs: 'Knowledge Graphs',
    _KnowledgeGraphDetail: 'Knowledge Graph Detail',
    _KnowledgeGraphCreate: 'Create Knowledge Graph',
    _KnowledgeGraphVisualize: 'Visualize Graph',
    _KnowledgeGraphImport: 'Import Data',
    _KnowledgeGraphSchema: 'Manage Schema',
    _KnowledgeGraphAdvancedRetrieval: 'Advanced Retrieval Settings',
    _KnowledgeGraphCitationContext: 'Use citation references',
    _KnowledgeGraphCitationContextHint: 'Read NEXA citation_context_text and let the LLM cite sources with [n] markers when available.',
    _KgCitationPromptLabel: 'Citation Rule prompt',
    _KgCitationPromptHint: 'Instruction telling the LLM to cite with [n] markers — leave blank to use the system default.',
    _WaterfallTierCitationLabel: 'Enable citations for this tier',
    _CitationReference: 'Reference',
    _CitationFile: 'เอกสาร',
    _CitationGraph: 'Graph',
    _CitationType: 'Type',
    _CitationNode: 'หัวข้อ',
    _CitationSection: 'Section',
    _CitationDate: 'วันที่',
    _CitationEvidence: 'อ้างอิง',
    _PdfToMarkdownTool: 'Tool',
    _PdfToMarkdownDialogButton: 'PDF to Markdown',
    _PdfToMarkdownClose: 'Close',
    _PdfToMarkdownRefresh: 'Refresh',
    _PdfToMarkdownOpenNewTab: 'Open in new tab',
    _PdfToMarkdownNotConfigured: 'Tool URL is not configured',
    _PdfToMarkdownConfigureHint: 'Configure it in SuperAdmin / Core Configuration',
    _PdfToMarkdownGoCoreConfig: 'Go to Core Configuration',
    _PdfToMarkdownLoadFailed: 'Unable to load tool settings',
    _PdfToMarkdownCoreConfigTitle: 'Tool',
    _PdfToMarkdownCoreConfigSubtitle: 'URL used to display the PDF to Markdown tool inside an iframe.',
    _PdfToMarkdownIframeUrl: 'PDF to Markdown iframe URL',
    _PdfToMarkdownIframeUrlPlaceholder: 'https://pdf2md.example.com',
    _PdfToMarkdownIframeUrlHint: 'Use the URL of the deployed pdf2md application.',
    _PdfToMarkdownLeaveTitle: 'Upload still in progress',
    _PdfToMarkdownLeaveMessage: 'A file is still being converted. Leaving this page may cancel it. Leave anyway?',
    _PdfToMarkdownLeaveConfirm: 'Leave page',
    _PdfToMarkdownLeaveStay: 'Stay',

    _EnableTime: 'Enable date and time in prompt',
    serviceTheme: 'Service Theme',
    consentConfig: 'Consent Config',
    IntentGroup: 'Intent Group',
    IntentSession: 'Intent Session',
    TokenSummation: 'Token summation',
    Intent: 'Intent',
    Flow: 'Flow',
    'Create Model': 'Create Model',
    DataIntegrationDetail: 'Data Integration Detail',
    'Generate Question Set': 'Generate Question Set',
    'Intent Session Detail': 'Intent Session Detail',
    'Prompt Template Detail': 'Prompt Template Detail',
    'Add Text Group': 'Add Text Group',
    'Upload Positive Question Set': 'Upload Positive Question Set',
    'Dashboard score': 'Dashboard score',
    'API External Log': 'API External Log',
    _uploadCSVVector: 'Upload Vector',
    configTheme: 'Config Theme',
    loginAuthentik: 'Sign in with Authentik',
    _GroupUserManagement: 'Group User Management',
    groupPromptName: 'Group Prompt Template',
    modelGroup: 'Model Group',
    _UserGroupDetail: 'User Group Detail',
    _SetupUserGroup: 'Setup User Group',
    action: 'Action',
    groupObjectID: 'Group ObjectID',
    fullName: 'Full name',
    loginLine: 'Sign in with Line',
    statusSync: 'Status Sync',
    _BlacklistChatUserManagement: 'Blacklist Chat User Management',
    _InvitationManagement: 'Invitation Management',
    _SendInvitation: 'Send Invitation',
    _username: 'User name',
    _userid: 'User ID',
    _date: 'Date',
    _FileManagement: 'File Management',
    confirmToSetDefault: 'Confirm To Set Default',
    infoconfirmToSetDefault: 'Do you want to confirm To set the default?',
    headerLogo: 'Header Logo',
    background: 'Background',
    _LockStatus: 'Lock Status',
    _Locked: 'Locked',
    _Unlocked: 'Unlocked',
    _Connection_failed: 'Connection failed.',
    _Please_check_internet: 'Please check your internet.',
    _Operator: 'Operator',
    _Please_Question: 'Please specify your question.',
    _HumanAnswer: 'Human Answer',
    _Reprocess: 'Do you want to Reprocess?',
    'Upload Sound To Document': 'Upload Sound To Document',
    'Positive Question set': 'Positive Question set',
    'Model Quick Reply': 'Model Quick Reply',
    Logs: 'Logs',
    'Report Feedback': 'Report Feedback',
    ShortcutCommands: 'Shortcut Commands',
    shortcutMenu: 'Shortcut menu',
    usermanual: 'User Manual',
    releasesnotes: 'Release Notes',
    backtosuperadmin: 'Back to SuperAdmin',

    alreadyPublishedModel: 'This model has already been published.',
    gotIt: 'Got it',
    'Event Log': 'Event Log',
    _ReasoningEffort: 'Apply the reasoning effort level configuration',
    _EndPointURL: 'End Point URL',
    _WarningJSONFormat: 'Enter the data in JSON format.',
    _API_Key: 'API Key',
    warningReasoningEffort: 'Please select the reasoning effort level configuration.',
    publish: 'Publish',
    restoreVersion: 'Restore version',
    success: 'Success',
    latest: 'Latest',
    logEvent: 'LogEvent',
    log_menagement: 'Log Management',
    dateRange: 'Date Range',
    Filters: 'Filters',
    editLLMModel: 'Edit LLM Model',
    actions: 'Actions',
    price: 'Price',
    itemPerPage: 'Items per page',
    confirmDeletionModel: 'Are you sure you want to delete this model?',
    _basicInformation: 'Basic Information',
    _modelDetails: 'Model Details',
    _configuration: 'Configuration',
    _imageOptions: 'Image Options',
    _additionalOptions: 'Additional Options',
    _apiVersion: 'API Version',
    _maxToken: 'Max Token',
    _inputPrice: 'Input Price',
    _outputPrice: 'Output Price',
    _imagePriceUSD: 'Image Price (USD)',
    _pricePerImage: 'Price per image',
    _quality: 'Quality',
    _chooseQuality: 'Choose quality',
    _resolution: 'Resolution (pixels)',
    _selectResolution: 'Select resolution',
    _enableFileUpload: 'Enable file upload',
    _enableReasoningEffort: 'Enable reasoning effort',
    _jsonFormat: 'JSON Format',
    _moreDetail: 'more detail',
    _authenHeaderName: 'Authentication Header Name',
    _profile_digital_identity: 'Link Digital Identity',
    _profile_digital_identity_hint: 'Connect your account with Thai ID or DGA Digital ID for easier login.',
    _profile_thaid_desc: 'Sign in with Thai ID (National ID Card)',
    _profile_dgaid_desc: 'Sign in with DGA Digital ID',
    _profile_link_thaid: 'Link Thai ID',
    _profile_link_dgaid: 'Link DGA Digital ID',
    _profile_link_success: 'Digital Identity linked successfully',
    _profile_link_fail: 'Failed to link Digital Identity. Please try again.',
    _profile_linked: 'Connected',
    _profile_unlink_thaid: 'Unlink Thai ID',
    _profile_unlink_confirm_title: 'Confirm Unlink Thai ID',
    _profile_unlink_confirm_text: 'Are you sure you want to unlink Thai ID from this account? You will not be able to sign in with Thai ID until you link again.',
    _profile_unlink_confirm_btn: 'Confirm Unlink',
    _profile_unlink_success: 'Thai ID unlinked successfully',
    _profile_unlink_dgaid: 'Unlink DGA Digital ID',
    _profile_unlink_dga_confirm_title: 'Confirm Unlink DGA Digital ID',
    _profile_unlink_dga_confirm_text: 'Are you sure you want to unlink DGA Digital ID from this account?',
    _profile_unlink_dga_success: 'DGA Digital ID unlinked successfully',
    _profile_unlink_no_password_title: 'Password Required',
    _profile_unlink_no_password_text: 'This account has no password set. Please set a password before unlinking so you can still log in afterwards.',
    _profile_unlink_last_method_title: 'Cannot unlink',
    _profile_unlink_last_method_text: 'This is the last sign-in method on your account — at least one sign-in method must remain',
    _profile_digital_identity_disabled: 'Digital Identity Login is not enabled for this system.',
    _sa_profile_title: 'Super Admin Profile',
    _vid_title: 'Verified Identity',
    _vid_readonly_note: 'This information is verified by the identity provider and cannot be edited.',
    _vid_group_personal: 'Personal Information',
    _vid_name_th: 'Full Name (Thai)',
    _vid_name_en: 'Full Name (English)',
    _vid_idcard: 'National ID',

    // Organization Structure page
    _sa_org_breadcrumb_root: 'Super Admin',
    _sa_org_title: 'Organization Structure',
    _sa_org_subtitle: 'Manage organizational hierarchy (Ministry → Department)',
    _sa_org_create_ministry: 'Create Ministry',
    _sa_org_create_unit: 'Create Department',
    _sa_org_search: 'Search ministry or department',
    _sa_org_col_name: 'Department Name',
    _sa_org_col_type: 'Type',
    _sa_org_col_code: 'Department Code',
    _sa_org_code_copied: 'Code copied',
    _sa_org_col_action: 'Action',
    _sa_org_dlg_code_ministry: 'Ministry Code',
    _sa_org_dlg_name_ministry: 'Ministry Name',
    _sa_org_dlg_email: 'Department Email',
    _sa_org_dlg_phone: 'Phone Number',
    _sa_org_dlg_enable: 'Enable',
    _sa_org_dlg_parent: 'Under',
    _sa_org_dlg_code_unit: 'Department Code',
    _sa_org_dlg_code_unit_hint: 'Maximum 10 characters',
    _sa_org_dlg_name_unit: 'Department Name',
    _sa_org_dlg_unit_type: 'Department Type',
    _sa_org_dlg_code_unit_placeholder: 'e.g. COM004-01',
    _sa_org_dlg_name_unit_placeholder: 'e.g. Department of Land Transport',
    _sa_org_col_phone: 'Mobile',
    _sa_org_col_email: 'Email',
    _sa_org_col_owner: 'Owner',
    _sa_org_create_company: 'Create Company',
    _sa_org_edit_company: 'Edit Company',
    _sa_org_section_company: 'Company Info',
    _sa_org_form_code: 'Company Code *',
    _sa_org_form_code_hint: 'Maximum 10 characters',
    _sa_org_form_type: 'Organization Type',
    _sa_org_form_name: 'Company Name *',
    _sa_org_form_mobile: 'Mobile number',
    _sa_org_form_province: 'Province',
    _sa_org_form_district: 'District',
    _sa_org_form_subdistrict: 'Sub District',
    _sa_org_form_country: 'Country',
    _sa_org_form_postcode: 'Post Code',
    _sa_org_form_address: 'Address',
    _sa_org_form_email: 'E-mail',
    _sa_org_section_user: 'Portal User Chat Framework',
    _sa_org_form_username: 'Username *',
    _sa_org_form_password: 'Password *',
    _sa_org_form_firstname: 'Name *',
    _sa_org_form_lastname: 'Last name *',
    _sa_org_form_lock_status: 'Owner Account Lock (User):',
    _sa_org_form_locked: 'Locked',
    _sa_org_form_unlocked: 'Unlocked',
    _sa_org_form_status: 'Organization Status:',
    _sa_org_form_enabled: 'Enabled',
    _sa_org_form_disabled: 'Disabled',
    _sa_org_sub_units: 'Sub-units',
    _sa_org_add_child: 'Add Child',
    _sa_org_new: 'New',
    _sa_org_no_children: 'No sub-units',
    _sa_org_select_unit_title: 'Select Sub-unit',
    _sa_org_search_name_code: 'Search name or code',
    _sa_org_selected_count: 'Selected {count} item(s)',
    _sa_org_add_selected: 'Add ({count})',
    _sa_org_edit_unit: 'Edit Unit',
    _sa_org_new_password: 'New Password *',
    _sa_org_confirm_password: 'Confirm New Password *',
    _sa_org_hierarchy_warning_title: 'Cannot Change Organization Type',
    _sa_org_hierarchy_warning_msg: 'The selected type has a lower hierarchy level than child units. Cannot be set.',
    _sa_org_hierarchy_warning_hint: 'Please select a type with a higher level than all child units.',
    _sa_org_acknowledge: 'Acknowledge',
    _sa_org_confirm_delete_title: 'Confirm Delete',
    _sa_org_confirm_delete_msg: 'Are you sure you want to delete {name} from the system?',
    _sa_org_delete_warning: 'Warning: This item has sub-units that will also be deleted.',
    _sa_org_delete: 'Delete',
    _sa_org_type_company: 'Company',
    _sa_org_type_ministry: 'Ministry',
    _sa_org_type_unit: 'Department',
    _sa_validation_required_company_code: 'Please fill the company code !',
    _sa_validation_company_code_max: 'Company code must be 10 characters or fewer !',
    _sa_validation_required_company_name: 'Please fill the company name !',
    _sa_validation_required_unit_code: 'Please fill the unit code !',
    _sa_validation_unit_code_max: 'Unit code must be 10 characters or fewer !',
    _sa_validation_required_unit_name: 'Please fill the unit name !',
    _sa_validation_max_length: '{field} must be {max} characters or fewer !',
    _sa_validation_max_length_hint: 'Maximum {max} characters',
    _sa_validation_required_username: 'Please fill the username !',
    _sa_validation_required_password: 'Please fill the password !',
    _sa_validation_password_format: 'Please fill correct password format !',
    _sa_validation_required_first_name: 'Please fill the first name !',
    _sa_validation_required_last_name: 'Please fill the last name !',
    _sa_validation_required_email: 'Please fill the e-mail !',
    _sa_validation_email_format: 'Please fill correct e-mail format !',
    _sa_validation_duplicate_email: 'Do not use duplicate e-mail !',
    _sa_validation_required_company: 'Please select the company !',
    _sa_validation_password_min: 'At least 8 characters',
    _sa_validation_password_lowercase: 'Lowercase letter',
    _sa_validation_password_uppercase: 'Uppercase letter',
    _sa_validation_password_number: 'Number',
    _sa_validation_password_special: 'Special character',
    _sa_validation_confirm_password_match: 'Confirm password matched',
    _sa_validation_confirm_password_not_match: 'Confirm password does not match',
    _sa_loading_login: 'Logging in...',
    _sa_loading_processing: 'Saving data...',
    _sa_loading_deleting: 'Deleting data...',
    _sa_loading_manage_company: 'Entering company...',
    _sa_loading_please_wait: 'Please do not close this page',
    _sa_json_invalid: 'Please enter valid JSON format',
    _sa_unlimited: 'Unlimited',
    // FullStream V2
    fs2NewChat: 'New Chat',
    fs2NewChatLabel: 'New chat',
    fs2Login: 'Login',
    fs2Greeting: 'Hello',
    fs2GreetingUser: 'Hello, {name}',
    fs2Tagline: 'I am Nong Deeden AI, an intelligent assistant for citizens',
    fs2Subtitle1: 'Feel free to ask anything you want to know!',
    fs2Subtitle2: 'I will help summarize concisely, clearly, and reliably',
    fs2WelcomeBeta: 'Beta version - learning and improving for you',
    fs2PersonalizedDemo: 'Personalized for you',
    fs2PersonalizedSection: 'Personalized recommendations',
    fs2RecCardDefaultAction: 'View details',
    fs2RecCardDismiss: 'Dismiss',
    fs2RecCarouselNav: 'Scroll recommendation list',
    fs2RecCarouselPrev: 'Scroll recommendations left',
    fs2RecCarouselNext: 'Scroll recommendations right',
    fs2InputPlaceholder: 'Ask what you want to know...',
    fs2DefaultModel: 'Our Services',
    fs2QuickChipRights: 'Rights and welfare',
    fs2QuickChipBooking: 'Book a document service appointment',
    fs2QuickChipLand: 'Ask about land matters',
    fs2QuickChipPolicy: 'Government policy',
    fs2QuickChipDga: 'DGA information',
    fs2QuickChipServices: 'Key services',
    fs2QuickChipFinance: 'Finance and insurance',
    fs2QuickChipHousing: 'Land and housing',
    fs2QuickChipNhso: 'Ask about NHSO information',
    fs2Send: 'Send message',
    fs2Disclaimer: 'This system provides preliminary automatic responses. Please verify with the relevant agency.',
    fs2Home: 'Home',
    fs2History: 'Chat History',
    fs2NoHistory: 'No conversation history yet',
    fs2ErrorGeneric: 'An error occurred. Please try again.',
    fs2ErrorNoToken: 'Token not found. Please log in again.',
    fs2Retry: 'Retry',
    fs2Portal: 'Go to Portal',
    fs2Logout: 'Logout',
    fs2User: 'User',
    fs2ToggleSidebar: 'Toggle menu',
    fs2SwitchLanguage: 'Switch language',
    fs2LanguageThai: 'Thai',
    fs2LanguageEnglish: 'English',
    fs2Copy: 'Copy',
    fs2Copied: 'Copied',
    fs2Like: 'Like',
    fs2NewChatConfirm: 'Start new conversation',
    fs2NewChatAction: 'Start new chat',
    fs2Stop: 'Stop',
    fs2Stopped: 'Response stopped',
    fs2OurService: '+ Our Services',
    fs2TermsOfService: 'Terms & Conditions',
    fs2PrivacyNotice: 'Privacy Notice',
    fs2AnonymousUser: 'Anonymous User',
    fs2Folders: 'Folders',
    fs2CreateFolder: 'Create folder',
    fs2RenameFolder: 'Rename folder',
    fs2DeleteFolder: 'Delete folder',
    fs2FolderName: 'Folder name',
    fs2MoveToFolder: 'Move to folder',
    fs2RemoveFromFolder: 'Remove from folder',
    fs2EmptyFolder: 'No chats in this folder',
    fs2OtherTopics: 'Other chats',
    fs2Cancel: 'Cancel',
    fs2Save: 'Save',
    fs2Create: 'Create',
    fs2DeleteFolderConfirm: 'Delete this folder? Chats inside will be moved out but not deleted.',
    fs2HistoryLoading: 'Loading history...',
    fs2UploadImage: 'Attach file/image',
    fs2RemoveImage: 'Remove file/image',
    fs2ImageTooLarge: 'File exceeds {kb} KB',
    fs2UploadError: 'Failed to upload file',
    fs2UploadedFile: 'Attached file',
    fs2UploadFileBtn: 'Attach document',
    fs2UploadImageBtn: 'Attach image',
    fs2UnsupportedUploadType: 'Only CSV, Excel, PDF, Word, TXT, PowerPoint, and image files are supported',
    fs2UploadDisabledByModel: 'This model does not allow image upload',
    fs2StartRecording: 'Start recording',
    fs2StopRecording: 'Stop recording',
    fs2VoiceLanguageTitle: 'Select voice language',
    fs2VoiceLanguageLabel: 'Language',
    fs2VoiceLanguageThai: 'TH',
    fs2VoiceLanguageEnglish: 'EN',
    fs2Speak: 'Read aloud',
    fs2StopSpeak: 'Stop reading',
    fs2SpeechUnavailable: 'Speech service is not available right now',
    fs2MicPermissionDenied: 'Please allow microphone access in your browser settings',
    fs2Dislike: 'Dislike',
    fs2RenameTopic: 'Rename chat',
    fs2DeleteTopic: 'Delete chat',
    fs2DeleteTopicConfirm: 'Delete this chat? All messages will be removed permanently.',
    fs2TopicName: 'Chat name',
    fs2LoadingMore: 'Loading more...',
    fs2FeedbackError: 'Could not save feedback',
    fs2TokenExpired: 'Token expired or invalid. Please log in again.',
    fs2SnippetMode: 'Snippet mode',
    fs2Anonymous: 'Anonymous',
    fs2PrivateMemory: 'Private Memory',
    fs2PmFileName: 'File name',
    fs2PmVectorDBName: 'Vector DB name',
    fs2PmVersion: 'Version',
    fs2PmStatus: 'Status',
    fs2PmActions: 'Actions',
    fs2PmActive: 'Active',
    fs2PmInactive: 'Inactive',
    fs2PmEmpty: 'No private memory files yet',
    fs2Search: 'Search',
    fs2PmUploadTitle: 'Upload Private Memory',
    fs2PmSelectFile: 'Select file',
    fs2PmUpload: 'Upload',
    fs2PmUploadSuccess: 'Upload successful',
    fs2PmUploadError: 'Upload failed',
    fs2PmUploadIncomplete: 'Please enter a file name and select a file',
    fs2PmVectorDBHint: 'Leave blank to auto-generate',
    fs2PmChunksOf: 'Chunks of',
    fs2PmChunksEmpty: 'No chunks available',
    fs2PmChunkEdit: 'Edit chunk',
    fs2PmChunkText: 'Chunk content',
    fs2PmChunkSave: 'Save chunk',
    fs2PmChunkSaved: 'Chunk saved',
    fs2PmChunkSaveError: 'Failed to save chunk',
    fs2PmDelete: 'Delete',
    fs2PmDeleted: 'Deleted successfully',
    fs2PmDeleteError: 'Failed to delete',
    fs2PmDeleteTitle: 'Confirm Private Memory deletion',
    fs2PmDeleteConfirm: 'This action cannot be undone.',
    fs2PmOpen: 'Open chunks',
    fs2PmRefresh: 'Refresh',
    fs2PmDeleteAll: 'Delete all chunks',
    fs2PmDetect: 'Detect language',
    fs2PmReplaceExisting: 'Replace existing data',
    fs2LoginDGA: 'Login with DGA Digital ID',
    fs2LoginThaID: 'Login with ThaID',
    fs2LoginError: 'Login failed. Please check your username and password.',
    companyDisabledError: 'This organization/company has been disabled. Please contact your administrator.',
    fs2LoginSnippetOnly: 'Login on this page must be opened through an organization snippet.',
    fs2ForgotInstruction: 'Enter your registered email or username. We will send a new password to your email.',
    fs2ForgotEmailLabel: 'Email or Username',
    fs2ForgotSend: 'Send new password',
    fs2ForgotRequired: 'Please enter your email or username.',
    fs2ForgotSuccess: 'A new password has been sent to your email. Please check your inbox.',
    fs2ForgotFailed: 'Account not found or failed to send email. Please try again.',
    fs2Register: 'Register',
    fs2RegisterSnippetOnly: 'Registration must be opened through an organization snippet.',
    fs2RegisterRequired: 'Please enter first name, last name, email, and password.',
    fs2RegisterUsernameRequired: 'Please enter username.',
    fs2RegisterUsernameRule: 'Username must be 3-50 characters and use only a-z, 0-9, dot, underscore, or hyphen.',
    fs2RegisterFirstNameRequired: 'Please enter first name.',
    fs2RegisterLastNameRequired: 'Please enter last name.',
    fs2RegisterEmailRequired: 'Please enter email.',
    fs2RegisterEmailInvalid: 'Please enter a valid email.',
    fs2RegisterPasswordRequired: 'Please enter password.',
    fs2RegisterConfirmPasswordRequired: 'Please confirm password.',
    fs2RegisterPasswordMismatch: 'Confirm password does not match.',
    fs2RegisterPasswordRule: 'Password must be at least 8 characters and include uppercase, lowercase, number, and special character.',
    fs2PwdRuleLength: 'At least 8 characters',
    fs2PwdRuleLowercase: 'Lowercase letter',
    fs2PwdRuleUppercase: 'Uppercase letter',
    fs2PwdRuleNumber: 'Number',
    fs2PwdRuleSpecial: 'Special character',
    fs2PwdRuleMatch: 'Passwords match',
    fs2RegisterSuccess: 'Registration completed.',
    fs2RegisterFailed: 'Registration failed. Please try again.',
    fs2RegisterOrUseSso: 'Or register with',
    fs2RegisterDGA: 'Register with DGA Digital ID',
    fs2RegisterThaID: 'Register with ThaID',
    fs2RegisterSsoSuccess: 'Registered via SSO successfully',
    fs2LoginSsoSuccess: 'Logged in successfully',
    fs2RegisterSsoDuplicate: 'This account is already registered as staff. Please log in instead.',
    fs2RegisterSsoProviderNotLinked: 'This account is not linked to the selected sign-in method. Please log in with the method you registered with, or link it in your profile first.',
    fs2RegisterSsoInvalidSnippet: 'Invalid snippet link',
    fs2ChatSnippetUnavailable: 'Unable to start chat. This chat is not authorized for this website. Please contact the site administrator. (Ref: {ref})',
    fs2RegisterSsoDeleted: 'This account has been deactivated. Please contact your administrator.',
    fs2LoginSsoNotRegistered: 'You have not registered yet. Please register before logging in.',
    fs2RegisterSsoDuplicateAccount: 'This email or username already exists. Cannot register again.',
    fs2RegisterSsoAccountExists: 'This account already exists. Please log in instead.',
    fs2RegisterSsoContextMissing: 'Missing snippet information for SSO registration. Please open the organization snippet link again.',
    fs2RegisterSsoFailed: 'SSO registration failed. Please try again.',
    fs2RequireLogin: 'Please log in to use this feature.',
    fs2AnonCtaTitle: 'Try it free!',
    fs2AnonCtaSubtitle: 'Sign in to save your chats',
    fs2AnonSessionHeader: "This session's chats",
    fs2AnonLocalBadge: 'local',
    fs2AnonWarnEphemeral: 'Chats will be lost when you close the browser',
    fs2LoginToUpload: 'Sign in to upload files',
    fs2LoginToUseVoice: 'Sign in to use voice input',
    fs2LoginToUsePrivateMemory: 'Sign in to use Private Memory',
    fs2AnonRemaining: '{count} messages remaining',
    fs2AnonLimitReached: 'Free trial used up',
    fs2AnonLimitMsg: 'Sign in to continue without limits',
    fs2LoginNudgeTitle: 'Unlock more features',
    fs2LoginNudgeSubtitle: 'Sign in or register to get the full experience',
    fs2LoginNudgeFeatureFolder: 'Organize chats into folders',
    fs2LoginNudgeFeatureHistory: 'Save and revisit your chat history',
    fs2LoginNudgeFeatureImage: 'Ask with images and attach files',
    fs2LoginNudgeRegister: 'Register',
    fs2LoginNudgeDismiss: 'Maybe later',
    fs2LoginNudgeContext: 'Sign in to use folders, chat history, and image questions',
    fs2ChatFramework: 'Chat Framework',
    fs2ProductAdmin: 'Product Admin',
    fs2PortalProductAdmin: 'Portal Product Admin',
    fs2PortalChatFramework: 'Portal Chat Framework',
    landingTitle: 'DGA Chat Framework',
    landingHeroBadge: 'AI-Powered Chat Platform',
    landingHeroTitle: 'Information Search Powered by Artificial Intelligence',
    landingHeroSubtitle: 'Powered by AI — secure, fast, and easy to use. Scales to millions of concurrent users.',
    landingHeroBody: 'The Government AI Smart Search System is a centralized platform that enables users to search for information from government agencies. It can be integrated into digital service systems to enhance the efficiency of public services and related operations.',
    landingHeroSecondaryCTA: 'Learn More',
    landingCTA: 'Get Started',
    landingCTAChat: 'Go to Chat',
    landingNavAbout: 'About',
    landingNavFeatures: 'Features',
    landingNavSitemap: 'Site Map',
    landingNavTerms: 'Terms',
    landingNavPrivacy: 'Privacy',
    landingSitemapEyebrow: 'Site Map',
    landingPrivacyEyebrow: 'Privacy Notice',
    landingFooterQuickLinks: 'Quick Links',
    landingFooterGetStarted: 'Get Started',
    landingToggleLang: 'Switch language',
    landingTrustSecurity: 'PDPA-Grade Security',
    landingTrustSpeed: 'Lightning Fast',
    landingTrustScale: 'Scales to Millions',
    landingFeaturesEyebrow: 'Key Features',
    landingFeaturesTitle: 'Everything Your Agency Needs',
    landingFeaturesSubtitle: 'A complete chat platform designed specifically for government agencies',
    landingFeatureAITitle: 'AI That Understands Thai',
    landingFeatureAIDesc: 'Connect to leading LLMs — OpenAI, Azure OpenAI, Vertex AI — tuned for your agency.',
    landingFeatureSecurityTitle: 'Enterprise-Grade Security',
    landingFeatureSecurityDesc: 'Argon2id encryption, multi-tenant data isolation, fully PDPA-compliant.',
    landingFeatureSpeedTitle: 'Scales to Millions',
    landingFeatureSpeedDesc: 'Cloud-native architecture on Azure with auto-scaling and real-time SignalR.',
    landingAboutEyebrow: 'About Us',
    landingAboutTitle: 'Get to Know Us',
    landingTermsEyebrow: 'Terms of Service',
    landingTermsTitle: 'Terms & Conditions',
    landingTermsAskAiSubtitle: 'Terms and Conditions of Service for the AI-Powered Information Search Service (Ask AI)',
    landingPrivacySubtitle: 'Privacy Notice of the Digital Government Development Agency (Public Organization)',
    landingShowMore: 'Read more',
    landingShowLess: 'Collapse',
    landingNoContentForLang: 'No content available in this language',
    landingCTABannerTitle: 'Ready to get started?',
    landingCTABannerSubtitle: 'Start using Chat Framework right away — no signup required.',
    landingFooterTagline: 'An intelligent chat platform designed for Thai government agencies, powered by context-aware AI.',
    landingFooterSitemap: 'Site Map',
    landingFooterLegal: 'Legal',
    landingFooterCopyright: '© {year} DGA Chat Framework. All rights reserved.',
    back: 'Back',
    moveUp: 'Move Up',
    moveDown: 'Move Down',
    landingPrivacyLink: 'Privacy Notice',
    // Landing page redesign — DGA theme
    landingNavHome: 'Home',
    landingHomeHeroTitle: 'Answer Questions and Search\nGovernment Information',
    landingHomeHeroSubtitle: 'Powered by Artificial Intelligence',
    landingHomeHeroLead: 'Powered by AI — secure, fast, and easy to use. Scales to millions of concurrent users.',
    landingHomeHeroBody: 'The Government AI Smart Search System is a centralized platform that enables users to search for information from government agencies.',
    landingHomeAnswerTitle: 'Providing Answers to Every Question',
    landingHomeAnswerSubtitle: 'An AI-powered platform that enables users to search and access government information quickly, accurately, and efficiently through a unified digital experience.',
    landingHomeServicesHeadline: 'Intelligent Search System\nPowered by Artificial Intelligence',
    landingHomeServicesLead: 'Powered by secure, fast, and easy-to-use AI technology\nthat is ready to support millions of concurrent users.',
    landingHomeFeaturesTitle: 'We Have Answers to All Your Questions.',
    landingHomePartnersTitle: 'Our Partner Agencies',
    landingNavAboutUs: 'About Us',
    landingNavContactUs: 'Contact Us',
    landingSearchPlaceholder: 'Search this page...',
    landingSearchNoResult: 'No results found',
    landingHeroTitleMain: 'Intelligent Chat System\nfor Government',
    landingHeroTitleAccent: 'Agencies',
    landingMockTryTitle: 'Try it free!',
    landingMockTrySubtitle: 'Sign in to save your chats',
    landingMockLogin: 'LOGIN',
    landingMockHome: 'HOME',
    landingMockNewChat: 'New Chat',
    landingMockGreeting: 'Hello',
    landingMockTagline: 'I am your intelligent assistant!',
    landingMockSubtitle1: 'Feel free to ask anything you want to know',
    landingMockSubtitle2: 'I will summarize concisely, clearly and reliably',
    landingMockInputPlaceholder: 'Ask what you want to know...',
    landingMockService: '+ Our Services',
    landingMockChipRights: 'สิทธิและสวัสดิการ',
    landingMockChipBooking: 'จองคิวทำเอกสารที่ อำเภอ-เขต',
    landingMockChipLand: 'สอบถามเรื่องที่ดิน',
    landingMockChipPolicy: 'นโยบายรัฐบาล',
    landingMockChipDga: 'ข้อมูลของ สพร.',
    landingMockChipServices: 'บริการสำคัญ',
    landingMockChipFinance: 'การเงินและประกัน',
    landingMockChipHousing: 'ที่ดินและที่อยู่',
    landingStatUsersValue: '15M+',
    landingStatUsersLabel: 'Users',
    landingStatConversationsValue: '10M+',
    landingStatConversationsLabel: 'Conversations',
    landingStatServiceValue: '24/7',
    landingStatServiceLabel: 'Service',
    landingAboutOrgTitle: 'DGA — Digital Government Development Agency',
    landingFooterWebsiteTitle: 'Official Website',
    landingFooterWebsiteValue: 'www.dga.or.th',
    landingFooterContactTitle: 'Contact',
    landingFooterContactEmail: "contact{'@'}dga.or.th",
    landingFooterContactTel: '+66 (0) 2612-6000',
    landingFooterAddressTitle: 'Address',
    landingFooterAddressValue: '120 Moo 3, 7th Floor, Rotfaifa Building (Building B), The Government Complex Commemorating His Majesty, Chaeng Watthana Road, Lak Si, Bangkok 10210',
    landingFooterEmailLabel: 'Email',
    landingFooterTelLabel: 'Phone',
    landingFooterWebsiteLabel: 'Website',
    landingFooterOrgAddress: 'Digital Government Development Agency (Public Organization) 120 Moo 3, 8th-9th Floor, Government Complex Commemorating His Majesty the King\'s 80th Birthday Anniversary, (Building C), Chaeng Watthana Soi 7, Chaeng Watthana Road, Thung Song Hong, Lak Si, Bangkok 10210',
    landingNavServices: 'Our Service',
    landingServicesPageLead: 'An AI-powered information discovery experience that is secure, fast, easy to use, and ready to support millions of concurrent users.',
    landingServicesPageSessionChats: 'THIS SESSION\'S CHATS',
    landingServicesPageProfileTitle: 'Profile',
    landingServicesPagePersonalized: 'Personalized for you',
    landingServicesPageWeatherMeta: '33°C · Cloudy · Bangkok',
    landingServicesPageAirMeta: 'PM2.5 15.9 · Good',
    landingServicesPageEventMeta: 'Visakha Bucha Day · in 3 days',
    landingServicesPageCardAlertLabel: 'Notification',
    landingServicesPageCardRecommendLabel: 'Recommend',
    landingServicesPageCardAlertTitle: 'Your citizen ID card will expire in 29 days',
    landingServicesPageCardAlertBody: 'Renew within 7 July 2569 at the district office or local registry before the deadline.',
    landingServicesPageCardAlertAction: 'View details',
    landingServicesPageCardHousingTitle: 'Check your eligibility for community vocational training and family support services',
    landingServicesPageCardHousingBody: 'Summarized from public welfare rules and the latest service conditions for you.',
    landingServicesPageCardHousingAction: 'Open details',
    landingServicesPageCardWalletTitle: 'Review senior welfare and social support center services near you',
    landingServicesPageCardWalletBody: 'Verify eligible conditions, available programs, and current contact channels in one place.',
    landingServicesPageCardWalletAction: 'Explore services',
    landingServicesPageDismiss: 'Dismiss',
    landingServicesPageDetailTitle: 'Intelligent Chat System for\nGovernment Agencies',
    landingServicesPageDetailLead: 'Powered by AI — secure, fast, and easy to use.\nScales to millions of concurrent users.',
    landingServicesPageDetailCta: 'GET STARTED',
    landingServicesPageDetailParagraph1: 'Government AI Smart Search is a centralized intelligent search platform designed to improve how people discover and access information from government agencies. Powered by advanced AI, it enables more natural exploration, faster discovery, and clearer understanding of public-sector knowledge in one place.',
    landingServicesPageDetailParagraph2: 'Today, citizens and public officers often face fragmented data across websites, databases, regulations, and digital services from many agencies. Government AI Smart Search addresses that fragmentation by connecting information sources together, creating a faster, simpler, and more effective search experience on a single platform.',
    landingPartnershipPageTitle: 'Government Agency Partnership Network',
    landingPartnershipOlderPersons: 'Department of Older Persons',
    landingPartnershipChildrenYouth: 'Department of Children and Youth',
    landingPartnershipSocialDevelopmentWelfare: 'Department of Social Development\nand Welfare',
    landingPartnershipCommunityDevelopment: 'Community Development Department',
    landingPartnershipMinistry: 'Ministry of Social Development\nand Human Security',
    landingPartnershipSocialSecurity: 'Social Security Office',
    landingPartnershipNHSO: 'National Health Security Office (NHSO)',
    landingPartnershipWomenFamily: 'Department of Women\nAffairs and Family Development',
    landingPartnershipLandDevelopment: 'Land Development Department',
    landingPartnershipDisabledEmpowerment: 'Department of Empowerment\nof Persons with Disabilities',
    landingPartnershipLandDepartment: 'Land Department',
    landingPartnershipBangKruaiMunicipality: 'Bangkruai Municipality',
    landingNavPartnership: 'Partnership',
    landingFeatureScaleTitle: 'Scales to Millions',
    landingFeatureScaleDesc: 'Cloud-native architecture on Azure with auto-scaling and real-time SignalR.',
    // 2FA Email OTP
    twoFactorAuth: 'Two-Factor Authentication (2FA)',
    twoFactorAuthDesc: 'When enabled, an OTP code will be sent to your email every time you log in.',
    enable2FA: 'Enable 2FA',
    disable2FA: 'Disable 2FA',
    enterOtp: 'Enter OTP Code',
    otpCode: 'OTP Code',
    otpSentToEmail: 'An OTP code has been sent to your email.',
    verifyOtp: 'Verify OTP',
    resendOtp: 'Resend Code',
    resendIn: 'Resend in {n}s',
    twoFactorEnabledMsg: '2FA has been enabled successfully.',
    twoFactorDisabledMsg: '2FA has been disabled successfully.',
    otpInvalid: 'Invalid OTP code. Please try again.',
    otpExpired: 'OTP code has expired. Please request a new one.',
    otpMaxAttempts: 'Too many failed attempts. Please log in again.',
    otpNotFound: 'OTP not found. Please request a new code.',
    preauthExpired: 'Session expired. Please log in again.',
    twoFactorAlreadyEnabled: '2FA is already enabled.',
    twoFactorNotEnabled: '2FA is not enabled.',
    sendOtpFailed: 'Failed to send OTP. Please try again.',
    confirmDisable2FATitle: 'Disable 2FA?',
    confirmDisable2FAText: 'Once disabled, your next login will no longer require an OTP verification code.',
    twoFactorDisableFailed: 'Failed to disable 2FA. Please try again.',
    twoFactorRequiresPasswordNote: 'Set a password and add an email to your account before enabling two-factor authentication',
    twoFactorRequiresPasswordTitle: 'Not available yet',
    twoFactorRequiresPasswordText: 'Your account signs in with Digital ID and has no password yet. Please set a password and add your email before enabling two-factor authentication.',
    twoFactorPasswordOnlyNote: 'Two-factor authentication applies to username/password sign-in only. Signing in with ThaID or DGA Digital ID is not affected.',

    // Edit Profile (FullStream V2)
    fs2EditProfile: 'View Profile',
    fs2EditProfileTitle: 'View Profile',
    fs2ProfileTabInfo: 'Personal Info',
    fs2ProfileTabPassword: 'Change Password',
    fs2ProfileTabSetPassword: 'Set Password',
    fs2ProfileSetPasswordHint: 'This account signs in with DGA Digital ID / ThaID and has no password yet. Set a password so you can unlink your Digital ID and still sign in with a password next time.',
    fs2ProfileTabSecurity: 'Security',
    fs2ProfileSsoLocked: 'This information is managed by DGA Digital ID / ThaID and cannot be edited here.',
    fs2ProfileSaveSuccess: 'Profile saved successfully.',
    fs2ProfileSaveError: 'Failed to save profile. Please check your information.',
    fs2ProfileInvalidEmail: 'Please enter a valid email address.',
    fs2ProfileInvalidPhone: 'Please enter a valid 10-digit phone number.',
    fs2ProfileRequiredName: 'Please enter your first and last name.',
    fs2ProfilePwdChanged: 'Password changed successfully.',
    fs2ProfilePwdError: 'Failed to change password. Please check your information.',
    fs2ProfilePwdEmpty: 'Please enter and confirm your new password.',
    fs2ProfilePwdMismatch: 'Passwords do not match.',
    fs2ProfilePwdFormat: 'Password does not meet the requirements.',
    fs2ProfileNoPassword: 'SSO users cannot change their password here.',
    fs2ProfileLoading: 'Loading profile...',
    fs2ProfileLinkUnavailable: 'Account linking will be available soon.',
    fs2ProfileLinkAction: 'Link account',
    fs2ProfileDigitalIdSection: 'Digital Account Linking',
    fs2ProfileThaiIDLabel: 'ThaID',
    fs2ProfileDGALabel: 'DGA Digital ID',
    fs2ProfileLinkedStatus: 'Linked',
    fs2ProfileNotLinkedStatus: 'Not linked',

    landingPageConfig: {
      breadcrumbRoot: 'Super Admin',
      title: 'Landing Page Content',
      subtitle: 'Manage HTML content for the 5 panels shown on the Landing page',
      editButton: 'Edit',
      previewButton: 'Preview',
      saveButton: 'Save All',
      resetButton: 'Reset to Default',
      charCount: '{count} characters',
      saveSuccess: 'All panels saved successfully',
      saveError: 'Save failed',
      resetSuccess: 'Reset successfully',
      resetConfirmTitle: 'Confirm Reset',
      resetConfirm: 'TH content will be reset to default and EN content will be cleared. Continue?',
      previewLabel: 'Login screen sidebar',
      hint: 'This content is displayed on the Landing Page — supports HTML',
      previewTooltip: 'Toggle between edit and preview (does not save)',
      tab: {
        about: 'About Us',
        aboutSubtitle: 'Organization information and mission',
        sitemap: 'Site Map',
        sitemapSubtitle: 'Footer link list',
        terms: 'Terms & Conditions',
        termsSubtitle: 'Terms of service for users',
        privacy: 'Privacy Notice',
        privacySubtitle: 'Privacy Notice per PDPA',
        cookie: 'Cookie Policy',
        cookieSubtitle: 'Website cookie policy',
      },
      lang: {
        th: 'Thai',
        en: 'English',
      },
    },
    bannerPopup: {
      tab: 'Banner / Popup',
      settings: {
        title: 'General Settings',
        subtitle: 'Enable/disable display, choose target pages, and screen-edge padding',
        save: 'Save Settings',
        saved: 'Settings saved',
        saveError: 'Failed to save settings',
        enabledOn: 'Banner enabled',
        enabledOff: 'Banner disabled',
        pages: 'Pages to show the banner',
        pagesHint: 'Select multiple pages. The active banner shows on the selected pages.',
        enabledTooltip: 'Master switch to show/hide banners site-wide',
        pageToggleTooltip: 'Click to select/deselect a page for the banner',
      },
      pages: {
        login: 'Login',
        productAdmin: 'Product Admin',
        portal: 'Portal',
        fullsnippet: 'Chat (Fullsnippet)',
        landing: 'Landing',
      },
      gallery: {
        title: 'Banner Library',
        subtitle: 'Upload many images, but only one can be shown at a time',
        add: 'Add Banner',
        empty: 'No banners yet. Click Add Banner to start.',
        active: 'Showing',
        untitled: '(Untitled)',
        use: 'Use',
        inUse: 'Showing',
        activated: 'Set as the displayed banner',
        activateError: 'Failed to set active',
        editTooltip: 'Edit this banner',
        deleteTooltip: 'Delete this banner',
        useTooltip: 'Make this the banner shown to users (one active at a time)',
      },
      form: {
        createTitle: 'Add Banner',
        editTitle: 'Edit Banner',
        image: 'Image',
        imageHint: 'Supports .png .jpg .jpeg .webp, up to 5 MB',
        uploading: 'Uploading...',
        titleField: 'Title / description (for admin reference)',
        altField: 'Alt text',
        linkField: 'Link when banner is clicked (optional)',
        createBtn: 'Add',
        invalidType: 'Unsupported file type',
        tooLarge: 'File exceeds {mb} MB',
        uploadError: 'Failed to upload image',
        created: 'Banner added',
        updated: 'Banner updated',
        saveError: 'Failed to save',
        clearImageTooltip: 'Clear the selected image',
      },
      delete: {
        title: 'Confirm Delete',
        confirm: 'Delete this banner?',
        btn: 'Delete',
        deleted: 'Banner deleted',
        error: 'Failed to delete',
      },
    },
    _km_share: 'Share',
    _km_share_title: 'Share document across companies',
    _km_shared_from: 'Shared from',
    _km_permissions: 'Granted permissions',
    _km_perm_view: 'View / Ask',
    _km_perm_edit: 'Edit',
    _km_perm_delete: 'Delete',
    _km_perm_update_failed: 'Failed to update permission',
    _km_share_document: 'Document',
    _km_share_targets: 'Share targets',
    _km_share_select_all: 'Select all',
    _km_share_clear_all: 'Clear all',
    _km_share_selected_count: '{count} companies selected',
    _km_share_select_companies: 'Select companies to share with',
    _km_share_no_children: 'No companies available to share',
    _km_share_saved: 'Sharing saved',
    _km_share_revoked: 'Sharing revoked',
    _km_share_name_clash: 'These companies already have a document with the same name and were skipped — please rename first',
    _km_share_current: 'Currently shared',
    _km_revoke: 'Revoke',
    _km_shared_banner: 'This document is shared from',
    _km_no_permission: 'You do not have permission to perform this action on the shared document',
    _km_delete_will_revoke: 'Deleting will automatically revoke sharing from all companies',
    _km_confirm_revoke: 'Revoke sharing for this company?',
    _km_shared_out: 'Shared to {count} companies',
    _km_key_title: 'Company Share Key',
    _km_key_desc: 'Give this key to another company so they can share documents into yours — the key expires in 1 day.',
    _km_key_generate: 'Generate Key',
    _km_key_regenerate: 'Regenerate',
    _km_key_copy: 'Copy',
    _km_key_copied: 'Copied',
    _km_key_expires: 'Expires {date}',
    _km_key_none: 'No active key',
    _km_key_enter: "Enter the destination company's key",
    _km_key_validate: 'Verify',
    _km_key_invalid: 'Invalid or expired key',
    _km_key_target_company: 'Destination company',
    _km_key_generated_by: 'Generated by',
    _km_key_self_share: 'Cannot share to your own company',
    _km_share_pending: 'Pending acceptance',
    _km_accept: 'Accept',
    _km_reject: 'Reject',
    _km_accept_before_open: 'Please accept the shared document first before viewing, adding data, or importing.',
    _km_accept_confirm: 'Accept this shared document?',
    _km_reject_confirm: 'Reject and remove this shared document?',
    _km_accepted: 'Accepted',
    _km_rejected: 'Rejected',
    _km_key_expired: 'Key expired',
    _km_cancel_shared: 'Remove this document',
    _km_cancel_shared_confirm: 'Remove this shared document from your company?',
    _km_cancel_shared_done: 'Shared document removed',
    _km_manage_shares: 'Manage sharing',
    _km_manage_shares_title: 'Companies this document is shared with',
    _km_revoke_confirm: 'Revoke sharing of this document from this company?',
    _km_revoked: 'Sharing revoked',
    _km_manage_no_targets: 'This document is not shared with any company',
    _km_search_company: 'Search company',
        'gmm_import': "IMPORT",
    'gmm_importFileConfiguration': "Import file configuration",
    'gmm_create': "CREATE",
    'gmm_createNewGptModel': "Create new GPT model",
    'gmm_modelId': "Model ID",
    'gmm_modelName': "Model Name",
    'gmm_search': "Search",
    'gmm_publish': "Publish",
    'gmm_draft': "Draft",
    'gmm_modelRequired': "Model*",
    'gmm_restore': "Restore",
    'gmm_view': "View",
    'gmm_loading': "Loading...",
    'gmm_pleaseWait': "Please wait",
    'gmm_provider': "Provider",
    'gmm_model': "Model",
    'gmm_createBy': "Create by",
    'gmm_status': "Status",
    'gmm_version': "Version",
    'gmm_modified': "Modified",
    'gmm_modifiedBy': "Modified By",
    'kgl_subtitle': "Connected to NEXA service · Graphs are scoped to your company",
    'kgl_refresh': "Refresh",
    'kgl_searchPlaceholder': "Search by name or description…",
    'kgl_unnamed': "(unnamed)",
    'kgl_clickToEdit': "Click to edit",
    'kgl_clickToAddDescription': "Click to add description",
    'kgl_edit': "Edit",
    'kgl_delete': "Delete",
    'kgl_emptyTitle': "No knowledge graphs yet",
    'kgl_emptySubtitlePrefix': "Click",
    'kgl_emptySubtitleSuffix': "to add your first one.",
    'kgl_create': "Create",
    'kgl_cancel': "Cancel",
    'kgl_name': "Name",
    'kgl_required': "Required",
    'kgl_descriptionOptional': "Description (optional)",
    'kgl_editKnowledgeGraph': "Edit Knowledge Graph",
    'kgl_save': "Save",
    'kgl_description': "Description",
    'kgl_descriptionPlaceholder': "What is this graph about?",
    'kgl_deleteKnowledgeGraph': "Delete Knowledge Graph",
    'kgl_deleteConfirmMessage': "Delete {name}? This permanently removes the graph from NEXA service. This action cannot be undone.",
    'kgl_colName': "Name",
    'kgl_colCompany': "Company",
    'kgl_colDescription': "Description",
    'kgl_colActions': "Actions",
    'logv_pageTitle': "Log",
    'logv_logId': "Log ID",
    'logv_ipAddress': "IP address",
    'logv_logType': "Log Type",
    'logv_methodName': "Method Name",
    'logv_exception': "Exception",
    'logv_logTrace': "Log Trace",
    'logv_loadingPleaseWait': "Loading Please Wait...",
    'levt_startDate': "Start Date",
    'levt_endDate': "End Date",
    'levt_active': "active",
    'levt_apiName': "API Name",
    'levt_createBy': "Create By",
    'levt_action': "Action",
    'levt_all': "All",
    'levt_login': "Login",
    'levt_statusCode': "Status Code",
    'levt_statusApi': "Status API",
    'levt_viewDetails': "View Details",
    'levt_colNo': "No.",
    'levt_colApiName': "Api Name",
    'levt_colAction': "Action",
    'levt_colStatusCode': "Status code",
    'levt_colStatusApi': "Status api",
    'levt_colMessage': "Message",
    'levt_colIpAddress': "IP Address",
    'levt_colCreateBy': "Create by",
    'levt_colCreateDate': "Create date",
    'rts_tokenSummation': "Token summation",
    'rts_downloadReport': "Download Report",
    'rts_reportManagementTitle': "Token Summation Report Management",
    'rts_modelFilters': "Model Filters",
    'rts_modelId': "Model ID",
    'rts_enterModelId': "Enter Model ID",
    'rts_enterModelIdTooltip': "Enter model ID to filter results",
    'rts_modelName': "Model Name",
    'rts_enterModelName': "Enter Model Name",
    'rts_enterModelNameTooltip': "Enter model name to filter results",
    'rts_statistics': "Statistics",
    'rts_models': "Models",
    'rts_dateRange': "Date Range",
    'rts_startDate': "Start Date",
    'rts_selectStartDateTooltip': "Select start date for report",
    'rts_endDate': "End Date",
    'rts_selectEndDateTooltip': "Select end date for report",
    'rts_search': "Search",
    'rts_tokenSummationDataRecords': "Token Summation Data ({count} records)",
    'rts_loading': "Loading...",
    'rts_pleaseWait': "Please wait",
    'rts_colNo': "No.",
    'rts_colModel': "Model",
    'rts_colLlm': "LLM",
    'rts_inputTokens': "Input Tokens",
    'rts_outputTokens': "Output Tokens",
    'rts_totalTokens': "Total Tokens",
    'rts_imageGen': "Image Gen.",
    'rts_cached': "Cached",
    'rts_reasoning': "Reasoning",
    'ucsv_refresh': "Refresh",
    'ucsv_documentName': "Document Name",
    'ucsv_search': "Search",
    'ucsv_togglePersonalInfoDetection': "Toggle Personal Information Detection",
    'ucsv_reprocessDocument': "Reprocess document",
    'ucsv_edit': "Edit",
    'ucsv_vectordbNameRequired': "vectordbName*",
    'ucsv_vectorRequired': "Vector*",
    'ucsv_restore': "Restore",
    'ucsv_view': "View",
    'ucsv_loading': "Loading...",
    'ucsv_pleaseWait': "Please wait",
    'ucsv_createBy': "Create by",
    'ucsv_personalInfo': "Personal Info",
    'ucsv_process': "Process",
    'ucsv_reprocess': "Reprocess",
    'ucsv_action': "Action",
    'ucsv_version': "Version",
    'ucsv_modified': "Modified",
    'ucsv_modifiedBy': "Modified By",
    'ucsv_pleaseFillAllFields': "Please Fill All The Fields!",
    'ucsv_pleaseEnterCorrectFormat': "Please Enter Correct Format!",
    'vpos_positiveNamePlaceholder': "Positive name",
    'vpos_loading': "Loading...",
    'vpos_pleaseWait': "Please wait",
    'vpos_positiveQuestionSetColumn': "Positive Question Set",
    'vpos_createByColumn': "Create by",
        'flst_flowManagement': "Flow Management",
    'flst_create': "CREATE",
    'flst_search': "Search",
    'flst_viewFlow': "View Flow",
    'flst_editFlow': "Edit Flow",
    'flst_exportFlow': "Export Flow",
    'flst_versionHistory': "Version History",
    'flst_deleteFlow': "Delete Flow",
    'flst_deleteOwnOnly': "You can only delete flows you created",
    'flst_confirmDelete': "Confirm Delete",
    'flst_confirmDeleteMessage': "Are you sure you want to delete flow \"{name}\"? This action cannot be undone.",
    'flst_cancel': "Cancel",
    'flst_close': "Close",
    'flst_deletedSuccessfully': "Deleted Successfully!",
    'flst_flowLabel': "Flow",
    'flst_operationLabel': "Operation",
    'flst_delete': "Delete",
    'flst_ok': "OK",
    'flst_current': "Current",
    'flst_currentVersion': "Current version",
    'flst_restoreThisVersion': "Restore this version",
    'flst_noPermissionToRestore': "No permission to restore",
    'flst_noVersionHistory': "No Version History",
    'flst_noVersionHistorySubtitle': "This flow has no version history available",
    'flst_restoreVersion': "Restore Version",
    'flst_restoreVersionSubtitle': "This will create a new version from the selected one",
    'flst_restoringVersionPrefix': "Restoring",
    'flst_versionLabel': "version",
    'flst_restoringVersionSuffix': "will create a new version based on its configuration.",
    'flst_versionNoteOptional': "Version Note (Optional)",
    'flst_versionNotePlaceholder': "Describe why you're restoring this version...",
    'flst_loading': "Loading...",
    'flst_pleaseWait': "Please wait",
    'flst_failedToLoadFlows': "Failed to load flows",
    'flst_flowExportedSuccessfully': "Flow \"{name}\" exported successfully",
    'flst_failedToGetFlowDataForExport': "Failed to get flow data for export",
    'flst_failedToExportFlow': "Failed to export flow",
    'flst_canOnlyDeleteOwnFlows': "You can only delete flows that you created",
    'flst_notAuthorizedToDelete': "You are not authorized to delete this flow",
    'flst_flowDeletedSuccessfully': "Flow \"{name}\" deleted successfully",
    'flst_failedToDeleteFlow': "Failed to delete flow",
    'flst_failedToLoadVersionHistory': "Failed to load version history",
    'flst_restoredFromVersion': "Restored from version {version}",
    'flst_versionRestoredSuccessfully': "Version {version} restored successfully",
    'flst_versionDeletedCannotRestore': "This version has been deleted and cannot be restored",
    'flst_noPermissionToRestoreVersion': "You don't have permission to restore this version",
    'flst_failedToRestoreVersion': "Failed to restore version",
    'flst_failedToRestoreVersionWithReason': "Failed to restore version: {reason}",
    'flst_unknownError': "Unknown error",
        'lmsg_logManagement': "Log Management",
    'lmsg_startDate': "Start Date",
    'lmsg_selectStartDateFilter': "Select start date for filtering",
    'lmsg_endDate': "End Date",
    'lmsg_selectEndDateFilter': "Select end date for filtering",
    'lmsg_userChannel': "User Channel",
    'lmsg_sessionId': "Session ID",
    'lmsg_exportLogMessage': "Export Log Message",
    'lmsg_exportLogMonitoring': "Export Log Monitoring",
    'lmsg_exportToQuestionSet': "Export to Question Set",
    'lmsg_logDataRecords': "Log Data ({n} records)",
    'lmsg_viewFlow': "View Flow",
    'lmsg_flowVisualization': "Flow Visualization",
    'lmsg_stepByStepTracking': "Step-by-step execution tracking",
    'lmsg_main': "Main",
    'lmsg_parallel': "Parallel",
    'lmsg_selected': "Selected",
    'lmsg_selectNodeToViewDetails': "Select a Node to View Details",
    'lmsg_clickNodeHint': "Click on any node above to see its input/output data and timing information",
    'lmsg_details': "Details",
    'lmsg_inputData': "Input Data",
    'lmsg_outputData': "Output Data",
    'mdata_addModel': "Add Model",
    'mdata_loadingModels': "Loading models...",
    'mdata_textBased': "Text-Based",
    'mdata_textToImage': "Text-to-Image",
    'mdata_per1kTokens': "per 1K tokens",
    'mdata_perImage': "per image",
    'mdata_addNewModel': "Add New Model",
    'mdata_addNewModelSubtitle': "Configure a new AI model for your chatbot",
    'mdata_basicInformation': "Basic Information",
    'mdata_modelType': "Model Type",
    'mdata_modelConfiguration': "Model Configuration",
    'mdata_displayName': "Display Name",
    'mdata_apiVersion': "API Version",
    'mdata_maxToken': "Max Token",
    'mdata_endpointUrl': "Endpoint URL",
    'mdata_authenticationHeaderName': "Authentication Header Name",
    'mdata_authHeaderNameHint': "Name of the header used for authentication",
    'mdata_apiKey': "API Key",
    'mdata_pricingConfiguration': "Pricing Configuration",
    'mdata_inputPriceUsd': "Input Price (USD)",
    'mdata_outputPriceUsd': "Output Price (USD)",
    'mdata_imagePriceUsd': "Image Price (USD)",
    'mdata_imageGenerationOptions': "Image Generation Options",
    'mdata_quality': "Quality",
    'mdata_resolution': "Resolution",
    'mdata_additionalOptions': "Additional Options",
    'mdata_fileUploadSupport': "File Upload Support",
    'mdata_allowFileUploadsHint': "Allow file uploads with this model",
    'mdata_reasoningEffort': "Reasoning Effort",
    'mdata_enableAdvancedReasoningHint': "Enable advanced reasoning capabilities",
    'mdata_jsonConfiguration': "JSON Configuration",
    'mdata_systemPromptFormatTitle': "System Prompt Format (OpenAI o1+)",
    'mdata_roleNote': "Specifies system role for better context",
    'mdata_maxCompletionTokensNote': "Maximum response length",
    'mdata_streamNote': "Enable streaming responses",
    'mdata_invalidJsonFormat': "Invalid JSON format. Please check your syntax.",
    'mdata_addValue': "Add Value",
    'mdata_updateModelSubtitle': "Update model configuration and settings",
    'mdata_selectAiProviderHint': "Select the AI provider",
    'mdata_chooseModelTypeHint': "Choose model type",
    'mdata_friendlyNameHint': "Friendly name for display",
    'saCore_gptConfiguration': "GPT Configuration",
    'saCore_azureOpenAIEndpoints': "Azure OpenAI Endpoints",
    'saCore_priority': "Priority",
    'saCore_azureOpenAIUrl': "AzureOpenAI Url",
    'saCore_apiKey': "API Key",
    'saCore_embeddingConfiguration': "Embedding Configuration",
    'saCore_embeddingLoadBalance': "Embedding Load Balance",
    'saCore_on': "ON",
    'saCore_off': "OFF",
    'saCore_azureOpenAIEmbeddingUrl': "AzureOpenAI Embedding Url",
    'saCore_azureOpenAIEmbeddingApiKey': "AzureOpenAI Embedding API Key",
    'saCore_azureOpenAIEmbeddingApiVersion': "AzureOpenAI Embedding API Version",
    'saCore_azureOpenAIEmbeddingType': "AzureOpenAI Embedding Type",
    'saCore_gptModeConfiguration': "GPT Mode Configuration",
    'saCore_gptMode': "GPT Mode",
    'saCore_priorityMode': "Priority",
    'saCore_fastMode': "Fast",
    'saCore_repeatTimeMinutes': "Repeat Time (Minutes)*",
    'saCore_modelRequired': "Model*",
    'saCore_testOfQuestions': "Test of Questions*",
    'saCore_no': "No",
    'saCore_responseTimeMs': "ResponseTime (Milliseconds)",
    'saCore_answers': "Answers",
    'saCore_nexaKnowledgeGraphService': "NEXA Knowledge Graph Service",
    'saCore_nexaConnectionSettingsHint': "Connection settings for the embedded NEXA service.",
    'saCore_nexaBaseUrl': "NEXA Base URL",
    'saCore_nexaBaseUrlHint': "Where ChatFramework reaches the NEXA service",
    'saCore_nexaSsoTokenTtl': "SSO Token TTL (seconds)",
    'saCore_nexaSsoTokenTtlHint': "Default 28800 (8 hours)",
    'saCore_nexaSsoSharedSecret': "SSO Shared Secret",
    'saCore_nexaSsoSharedSecretPlaceholder': "Enter the shared HMAC secret",
    'saCore_nexaSsoSharedSecretHint': "Must match CF_SSO_SHARED_SECRET on the NEXA side.",
    'saCore_openAiConfig': "Open AI config",
    'saCore_openAiUrl': "Open AI Url",
    'saCore_openAiKey': "Open AI Key",
    'saCore_blobConfig': "Blob config",
    'saCore_azureStorageConnection': "Azure storage connection",
    'saCore_azureContainer': "Azure container",
    'saCore_azureStorageConnectionPdfVector': "Azure storage connection PDFVector",
    'saCore_azureContainerPdfVector': "Azure container PDFVector",
    'saCore_azureStorageConnectionGptVision': "Azure storage connection GPT Vision",
    'saCore_azureContainerGptVision': "Azure container GPT Vision",
    'saCore_azureStorageSpeechDocument': "Azure storage Speech document",
    'saCore_azureContainerSpeechDocument': "Azure container Speech document",
    'saCore_azureStorageQuickReplyIcon': "Azure storage quick reply icon",
    'saCore_azureContainerQuickReplyIcon': "Azure container quick reply icon",
    'saCore_azureStorageSnippetIcon': "Azure storage snippet icon",
    'saCore_azureContainerSnippetIcon': "Azure container snippet icon",
    'saCore_languageTranslator': "Language translator",
    'saCore_languageTranslatorEndpoint': "Language translator endpoint",
    'saCore_languageTranslatorKey': "Language translator key",
    'saCore_languageTranslatorLocation': "Language translator location",
    'saCore_languageService': "Language service",
    'saCore_languageServiceEndpoint': "Language service endpoint",
    'saCore_languageServiceKey': "Language service key",
    'saCore_speechToTextConfig': "Speech to text config",
    'saCore_speechToTextKey': "Speech to text key",
    'saCore_speechToTextRegion': "Speech to text region",
    'saCore_speechToTextLanguage': "Speech to text language",
    'saCore_pathFFMpeg': "Path FFMpeg",
    'saCore_pathFFMpegLocal': "Path FFMpeg local",
    'saCore_mailConfiguration': "Mail configuration",
    'saCore_emailSendingMethod': "Email Sending Method",
    'saCore_emailSendingMethodRequired': "Email Sending Method *",
    'saCore_smtpProviderRequired': "SMTP Provider *",
    'saCore_authenticationMethod': "Authentication Method",
    'saCore_oauth2Required': "OAuth2 (Required)",
    'saCore_basicAuth': "Basic Auth",
    'saCore_serverSettings': "Server Settings",
    'saCore_smtpHostRequired': "SMTP Host *",
    'saCore_smtpPortRequired': "SMTP Port *",
    'saCore_enableSsl': "Enable SSL",
    'saCore_timeoutMs': "Timeout (ms)",
    'saCore_fromEmailSettings': "From Email Settings",
    'saCore_emailAddressFromRequired': "Email Address (From) *",
    'saCore_emailAddressFromHint': "The email address used to send emails",
    'saCore_displayNameRequired': "Display Name *",
    'saCore_displayNameHint': "The display name shown to recipients",
    'saCore_authentication': "Authentication",
    'saCore_requiresAppPassword': "Requires App Password",
    'saCore_appPasswordRequired': "App Password *",
    'saCore_passwordRequired': "Password *",
    'saCore_gmailWith2fa': "Gmail with 2FA",
    'saCore_gmailAppPasswordHint': "You need to generate an App Password from your Google Account settings.",
    'saCore_learnCreateAppPassword': "Learn how to create an App Password",
    'saCore_oauth2Configuration': "OAuth2 Configuration",
    'saCore_requiredForOffice365': "Required for Office 365",
    'saCore_office365Oauth2Setup': "Office 365 OAuth2 Setup",
    'saCore_office365Oauth2SetupHint': "You need to register an application in Microsoft Entra ID (Azure AD).",
    'saCore_viewMicrosoftDocs': "View Microsoft Documentation",
    'saCore_tenantIdRequired': "Tenant ID *",
    'saCore_clientIdRequired': "Client ID *",
    'saCore_clientSecretRequired': "Client Secret *",
    'saCore_mailgunConfiguration': "Mailgun Configuration",
    'saCore_mailgunApiUrlRequired': "Mailgun API URL *",
    'saCore_mailgunApiUrlHint': "e.g., https://api.mailgun.net/v3/your-domain.com",
    'saCore_mailgunApiKeyRequired': "Mailgun API Key *",
    'saCore_fromEmailRequired': "From Email *",
    'saCore_fromEmailFormatHint': "Format: Display Name <email{'@'}domain.com>",
    'saCore_autoConfiguration': "Auto configuration",
    'saCore_stream': "Stream",
    'saCore_auto': "auto",
    'saCore_notAuto': "not auto",
    'saCore_anonymous': "Anonymous",
    'saCore_enable': "enable",
    'saCore_disable': "disable",
    'saCore_timeDelay': "Time delay",
    'saCore_limitedCharacters': "Limited Characters",
    'saCore_forceDisableGpt': "Force Disable GPT",
    'saCore_autoDisableGpt': "Auto Disable GPT",
    'saCore_gptAutoDisableDatePeriod': "GPT Auto-Disable Date Period",
    'saCore_gptAutoDisableMessage': "GPT Auto-Disable Message",
    'saCore_gptAutoDisablePricingUsd': "GPT Auto-Disable Pricing (USD)",
    'saCore_googleConfiguration': "Google Configuration",
    'saCore_projectId': "Project ID",
    'saCore_locationId': "Location ID",
    'saCore_jsonCredential': "JSON Credential",
    'saCore_anthropicConfig': "Anthropic config",
    'saCore_anthropicClaudeApiKey': "AnthropicClaude APIKey",
    'saCore_singleSignOn': "Single Sign-On",
    'saCore_singleSignOnProvider': "Single Sign-On",
    'saCore_open': "Open",
    'saCore_close': "Close",
    'saCore_inChat': "in Chat",
    'saCore_instance': "Instance",
    'saCore_domain': "Domain",
    'saCore_tenantId': "Tenant ID",
    'saCore_clientId': "Client ID",
    'saCore_priorityMustBeUnique': "Please set unique Priority values for Azure OpenAI Endpoints",
    'saCore_failedToReadFile': "Failed to read file!",
    'saPersona_pageTitle': "Persona API Setting",
    'saPersona_pageSubtitle': "Configure the GDX (Government Data Exchange) connection used to fetch individual welfare/entitlement data",
    'saPersona_section1Title': "1. Company Entitlement — enable Persona access per child company",
    'saPersona_section1Hint': "A child company can call Persona/GDX only when explicitly \"enabled\" here (fail-closed — off by default). Leave Allowed Services empty = all supported services; or pick specific services from the list (sourced from section 4, Service Master). Must be the <b>full code</b>, e.g. <code>DEP001</code>, <code>DEP002</code> — an agency abbreviation like <code>DEP</code> alone will not match any service. Every change is recorded in EventLog for audit.",
    'saPersona_allowedServicesPlaceholder': "All services (leave empty)",
    'saPersona_allowedServicesNoData': "No services yet — add one in section 4 (Service Master) first",
    'saPersona_on': "On",
    'saPersona_off': "Off",
    'saPersona_noCompanyFound': "No company found",
    'saPersona_section2Title': "2. GDX Welfare API — Connection & Cache",
    'saPersona_providerLabel': "Provider",
    'saPersona_providerHint': "mock = simulated data, real = actual GDX",
    'saPersona_baseUrlLabel': "Base URL",
    'saPersona_defaultCacheTtlLabel': "Default Cache TTL (seconds)",
    'saPersona_ttl6HoursHint': "21600 = 6 hours",
    'saPersona_cacheLabelPrefix': "Cache",
    'saPersona_onCaps': "ON",
    'saPersona_offCaps': "OFF",
    'saPersona_consumerKeyLabel': "Consumer Key",
    'saPersona_credentialSetPlaceholder': "●●●● already set (type to change)",
    'saPersona_credentialNotSetPlaceholder': "Not set",
    'saPersona_emptyChip': "empty",
    'saPersona_consumerSecretLabel': "Consumer Secret",
    'saPersona_agentIdLabel': "Agent ID (organization, fixed)",
    'saPersona_saveGdxSettings': "Save GDX Settings",
    'saPersona_section3Title': "3. Data Sources — Persona data sources (air quality / forecast / civil registry)",
    'saPersona_section3Hint': "Each source can switch mock/real independently (config-driven, <code>sy.PersonaDataSource</code>); no row = use the <b>built-in default</b>. air/weather settings must be edited on this card only — they are not read from the GDX Connection & Cache Base URL or Provider. Sources containing <b>PII</b> (DOPA) cannot be tested against real data — the test button always uses mock. Every call is logged in <code>log.Log_PersonaApiCall</code>; child-company calls are governed by the Company Entitlement above.",
    'saPersona_defaultBuiltIn': "default (built-in)",
    'saPersona_test': "Test",
    'saPersona_noDataSourceFound': "No data source found",
    'saPersona_km': "km",
    'saPersona_today': "Today",
    'saPersona_tomorrow': "Tomorrow",
    'saPersona_currentWeather': "Current weather",
    'saPersona_humidity': "Humidity",
    'saPersona_rain': "Rain",
    'saPersona_loadMshTemplate': "Load MSH template",
    'saPersona_scopeLabel': "Scope",
    'saPersona_agencyParamHint': "actual casing of ?Agency=",
    'saPersona_activeLabelPrefix': "Active",
    'saPersona_section4Title': "4. Service Master — individual MSDHS services (on/off · cache · TTL)",
    'saPersona_addService': "Add Service",
    'saPersona_section4Hint': "Service registry keyed by Service Code. <b>Coverage = enabled ∧ has GDX API</b> (single source of truth). Each service sets its own <b>cache on/off</b> and <b>TTL</b> — edit then click <b>Save</b> per row (applies on the next call). No row = use the built-in coverage in code. <code>sy.GdxService</code>.",
    'saPersona_deleteAction': "Delete",
    'saPersona_noServiceFound': "No services yet — the system uses built-in coverage (click \"Add Service\")",
    'saPersona_serviceNameLabel': "Service Name",
    'saPersona_hasApiLabelPrefix': "Has API",
    'saPersona_noBoolean': "No",
    'saPersona_enabledLabelPrefix': "Enabled",
    'saPersona_section5Title': "5. Agency Configuration — per-agency GDX call logic",
    'saPersona_addAgency': "Add Agency",
    'saPersona_section5Hint': "Config-driven per-agency logic overrides (agency param, endpoint paths, coverage 17/6, field mapping, TTL). If there is no row, the system uses the <b>built-in defaults (17 MSDHS services)</b> in code. Editing here updates <code>sy.GdxAgencyConfig</code> (hot-applies on the next call).",
    'saPersona_codeUnit': "codes",
    'saPersona_mapUnit': "maps",
    'saPersona_noAgencyConfigFound': "No agency config yet — using the 17-service default (click \"Add Agency\" to override)",
    'saPersona_editDataSourceTitle': "Edit Data Source: {name}",
    'saPersona_ttlSecondsHint': "empty = default, 0 = no cache",
    'saPersona_piiSourceWarning': "This source contains personal data (PII) — the test button always uses the <b>mock</b> provider; admins cannot fetch real citizen data.",
    'saPersona_gdxProviderMock': "Mock (simulated GDX/Welfare data)",
    'saPersona_gdxProviderReal': "Real (actual GDX)",
    'saPersona_personaProviderMock': "Mock (simulated data)",
    'saPersona_personaProviderReal': "Real (this source's actual API)",
    'saPersona_coverageHeader': "Coverage",
    'saPersona_fieldMapHeader': "Field map",
    'saPersona_scopeHeader': "Scope",
    'saPersona_activeHeader': "Active",
    'saPersona_serviceNameHeader': "Service Name",
    'saPersona_hasApiHeader': "Has API",
    'saPersona_enabledHeader': "Enabled",
    'saPersona_companyHeader': "Company",
    'saPersona_allowedServicesHeader': "Allowed Services (pick codes · empty = all services)",
    'saPersona_dataSourceHeader': "Data Source",
    'saPersona_globalAllCompanies': "Global (all companies)",
    'saPersona_sourceBaseUrlPlaceholderDefault': "Base URL for this data source",
    'saPersona_sourceBaseUrlHintAir': "Used for Air4Thai only, unrelated to the GDX Base URL",
    'saPersona_sourceBaseUrlHintWeather': "Used for TMD only, unrelated to the GDX Base URL",
    'saPersona_sourceBaseUrlHintDopa': "DOPA uses the GDX provider, but admin tests are forced to mock because it is PII",
    'saPersona_sourceBaseUrlHintDefault': "Base URL value is set per source",
    'saPersona_sourceKvPlaceholderAir': "(no key used)",
    'saPersona_sourceKvPlaceholderDefault': "(blank if no key is used)",
    'saPersona_sourceKvHintAir': "Air4Thai does not need a Key Vault prefix",
    'saPersona_sourceKvHintWeather': "The TMD real provider uses a TMD API key",
    'saPersona_sourceKvHintDopa': "DOPA uses the GDX credential for the citizen runtime only",
    'saPersona_sourceKvHintDefault': "Leave blank if this source doesn't use a key",
    'saSet_gptConfiguration': "GPT Configuration",
    'saSet_azureOpenAIEndpoints': "Azure OpenAI Endpoints",
    'saSet_priority': "Priority",
    'saSet_azureOpenAIUrl': "AzureOpenAI Url",
    'saSet_apiKey': "API Key",
    'saSet_addEndpoint': "Add Endpoint",
    'saSet_embeddingConfiguration': "Embedding Configuration",
    'saSet_embeddingLoadBalance': "Embedding Load Balance",
    'saSet_on': "ON",
    'saSet_off': "OFF",
    'saSet_azureOpenAIEmbedingUrl': "AzureOpenAI Embeding Url",
    'saSet_azureOpenAIEmbedingApiKey': "AzureOpenAI Embeding API Key",
    'saSet_azureOpenAIEmbedingApiVersion': "AzureOpenAI Embeding API Version",
    'saSet_azureOpenAIEmbeddingType': "AzureOpenAI Embedding Type",
    'saSet_gptModeConfiguration': "GPT Mode Configuration",
    'saSet_gptMode': "GPT Mode",
    'saSet_fast': "Fast",
    'saSet_repeatTimeMinutes': "Repeat Time (Minutes)*",
    'saSet_modelRequired': "Model*",
    'saSet_testOfQuestions': "Test of Questions*",
    'saSet_openAIConfig': "Open AI config",
    'saSet_openAIUrl': "Open AI Url",
    'saSet_openAIKey': "Open AI Key",
    'saSet_blobConfig': "Blob config",
    'saSet_azureStorageConnection': "Azure storage connection",
    'saSet_azureContainer': "Azure container",
    'saSet_azureStorageConnectionPDFVector': "Azure storage connection PDFVector",
    'saSet_azureContainerPDFVector': "Azure container PDFVector",
    'saSet_azureStorageConnectionGptVision': "Azure storage connection GPT Vision",
    'saSet_azureContainerGptVision': "Azure container GPT Vision",
    'saSet_azureStorageSpeechDocument': "Azure storage Speech document",
    'saSet_azureContainerSpeechDocument': "Azure container Speech document",
    'saSet_azureStorageQuickReplyIcon': "Azure storage quick reply icon",
    'saSet_azureContainerQuickReplyIcon': "Azure container quick reply icon",
    'saSet_languageTranslator': "Language translator",
    'saSet_languageTranslatorEndpoint': "Language translator endpoint",
    'saSet_languageTranslatorKey': "Language translator key",
    'saSet_languageTranslatorLocation': "Language translator location",
    'saSet_languageService': "Language service",
    'saSet_languageServiceEndpoint': "Language service endpoint",
    'saSet_languageServiceKey': "Language service key",
    'saSet_speechToTextConfig': "Speech to text config",
    'saSet_speechToTextKey': "Speech to text key",
    'saSet_speechToTextRegion': "Speech to text region",
    'saSet_speechToTextLanguage': "Speech to text language",
    'saSet_pathFFMpeg': "Path FFMpeg",
    'saSet_pathFFMpegLocal': "Path FFMpeg local",
    'saSet_mailConfiguration': "Mail configuration",
    'saSet_emailSendingMethod': "Email Sending Method",
    'saSet_emailSendingMethodRequired': "Email Sending Method *",
    'saSet_smtpProviderRequired': "SMTP Provider *",
    'saSet_authenticationMethod': "Authentication Method",
    'saSet_oauth2Required': "OAuth2 (Required)",
    'saSet_basicAuth': "Basic Auth",
    'saSet_oauth2': "OAuth2",
    'saSet_serverSettings': "Server Settings",
    'saSet_smtpHostRequired': "SMTP Host *",
    'saSet_smtpPortRequired': "SMTP Port *",
    'saSet_enableSSL': "Enable SSL",
    'saSet_timeoutMs': "Timeout (ms)",
    'saSet_fromEmailSettings': "From Email Settings",
    'saSet_emailAddressFromRequired': "Email Address (From) *",
    'saSet_emailAddressHint': "The email address used to send emails",
    'saSet_displayNameRequired': "Display Name *",
    'saSet_displayNameHint': "The display name shown to recipients",
    'saSet_authentication': "Authentication",
    'saSet_requiresAppPassword': "Requires App Password",
    'saSet_appPasswordRequired': "App Password *",
    'saSet_passwordRequired': "Password *",
    'saSet_gmailWith2FA': "Gmail with 2FA:",
    'saSet_gmailAppPasswordHint': "You need to generate an App Password from your Google Account settings.",
    'saSet_learnCreateAppPassword': "Learn how to create an App Password",
    'saSet_oauth2Configuration': "OAuth2 Configuration",
    'saSet_requiredForOffice365': "Required for Office 365",
    'saSet_office365OAuth2Setup': "Office 365 OAuth2 Setup:",
    'saSet_office365OAuth2Hint': "You need to register an application in Microsoft Entra ID (Azure AD) and configure the required permissions.",
    'saSet_viewMicrosoftDocs': "View Microsoft Documentation",
    'saSet_tenantIdRequired': "Tenant ID *",
    'saSet_clientIdRequired': "Client ID *",
    'saSet_clientSecretRequired': "Client Secret *",
    'saSet_mailgunConfiguration': "Mailgun Configuration",
    'saSet_mailgunApiUrlRequired': "Mailgun API URL *",
    'saSet_mailgunApiUrlHint': "e.g., https://api.mailgun.net/v3/your-domain.com",
    'saSet_mailgunApiKeyRequired': "Mailgun API Key *",
    'saSet_fromEmailRequired': "From Email *",
    'saSet_fromEmailFormatHint': "Format: Display Name <email{'@'}domain.com>",
    'saSet_autoConfiguration': "Auto configuration",
    'saSet_stream': "Stream",
    'saSet_auto': "auto",
    'saSet_notAuto': "not auto",
    'saSet_setupAutoStream': "Setup auto stream",
    'saSet_anonymous': "Anonymous",
    'saSet_enable': "enable",
    'saSet_disable': "disable",
    'saSet_setupAnonymous': "Setup anonymous",
    'saSet_timeDelay': "Time delay",
    'saSet_limitedCharacters': "Limited Characters",
    'saSet_forceDisableGPT': "Force Disable GPT",
    'saSet_setupForceDisableGPT': "Setup Force Disable GPT",
    'saSet_autoDisableGPT': "Auto Disable GPT",
    'saSet_setupAutoDisableGPT': "Setup Auto Disable GPT",
    'saSet_gptAutoDisableDatePeriod': "GPT Auto-Disable Date Period",
    'saSet_gptAutoDisableMessage': "GPT Auto-Disable Message",
    'saSet_gptAutoDisablePricingUSD': "GPT Auto-Disable Pricing (USD)",
    'saSet_googleConfiguration': "Google Configuration",
    'saSet_projectId': "Project ID",
    'saSet_locationId': "Location ID",
    'saSet_jsonCredential': "JSON Credential",
    'saSet_anthropicConfig': "Antropic config",
    'saSet_anthropicClaudeApiKey': "AnthropicClaude APIKey",
    'saSet_singleSignOn': "Single Sign-On",
    'saSet_open': "Open",
    'saSet_close': "Close",
    'saSet_inChat': "in Chat",
    'saSet_instance': "Instance",
    'saSet_domain': "Domain",
    'saSet_tenantId': "Tenant ID",
    'saSet_clientId': "Client ID",
    'saSet_callbackPath': "CallbackPath",
    'ssoc_configuration': "Configuration",
    'ssoc_lineMessagingApi': "LINE Messaging API",
    'ssoc_lineDescription': "Configure LINE Bot integration with channel secrets and tokens",
    'ssoc_addConfig': "Add Config",
    'ssoc_configurations': "Configurations",
    'ssoc_noLineConfigYet': "No LINE configurations yet",
    'ssoc_createFirstLineConfig': "Create your first LINE bot configuration to get started",
    'ssoc_createFirstConfiguration': "Create First Configuration",
    'ssoc_configNumber': "Config #{n}",
    'ssoc_basicInformation': "Basic Information",
    'ssoc_configurationName': "Configuration Name",
    'ssoc_enterConfigurationName': "Enter configuration name",
    'ssoc_groupModel': "Group Model",
    'ssoc_selectGroupModel': "Select group model",
    'ssoc_authenticationDetails': "Authentication Details",
    'ssoc_channelSecret': "Channel Secret",
    'ssoc_enterChannelSecret': "Enter channel secret",
    'ssoc_channelToken': "Channel Token",
    'ssoc_enterChannelToken': "Enter channel token",
    'ssoc_addNewConfiguration': "Add New Configuration",
    'ssoc_createNewLineConfig': "Create a new LINE bot configuration",
    'ssoc_microsoftTeams': "Microsoft Teams",
    'ssoc_configureMsTeams': "Configure MS Teams",
    'ssoc_noTeamsConfigYet': "No Teams configurations yet",
    'ssoc_createFirstTeamsConfig': "Create your first Microsoft Teams bot configuration",
    'ssoc_createNewTeamsConfig': "Create a new Teams bot configuration",
    'ssoc_facebookMessenger': "Facebook Messenger",
    'ssoc_configureFacebookIntegration': "Configure Facebook integration",
    'ssoc_noFacebookConfigYet': "No Facebook configurations yet",
    'ssoc_createFirstFacebookConfig': "Create your first Facebook Messenger bot configuration",
    'ssoc_createNewFacebookConfig': "Create a new Facebook bot configuration",
    'ssoc_instagramMessaging': "Instagram Messaging",
    'ssoc_configureInstagramDm': "Configure Instagram for direct messages",
    'ssoc_noInstagramConfigYet': "No Instagram configurations yet",
    'ssoc_createFirstInstagramConfig': "Create your first Instagram messaging bot configuration",
    'ssoc_createNewInstagramConfig': "Create a new Instagram bot configuration",
    'ssoc_webSnippetIntegration': "Web Snippet Integration",
    'ssoc_configureWebSnippet': "Configure web snippet for website chatbot integration",
    'ssoc_noSnippetConfigYet': "No Snippet configurations yet",
    'ssoc_createFirstSnippetConfig': "Create your first web snippet configuration",
    'ucm_accountLockedDesc': "Account is currently locked and cannot access the system",
    'ucm_accountSettings': "Account Settings",
    'ucm_accountUnlockedDesc': "Account is unlocked and can access the system",
    'ucm_addNewChatUser': "Add New Chat User",
    'ucm_addNewUser': "Add New User",
    'ucm_addUserSubtitle': "Create a new user chat account with required information",
    'ucm_atLeast8Characters': "At least 8 characters",
    'ucm_basicInformation': "Basic Information",
    'ucm_changePassword': "Change Password",
    'ucm_changePasswordSubtitle': "Create a new secure password for your account",
    'ucm_confirmNewPasswordPlaceholder': "Confirm new password",
    'ucm_confirmNewPasswordRequired': "Confirm New Password *",
    'ucm_confirmPasswordPlaceholder': "Confirm password",
    'ucm_confirmPasswordRequired': "Confirm Password *",
    'ucm_downloadTemplate': "Download Template",
    'ucm_downloadTemplateFilesDesc': "Download template files for user import",
    'ucm_downloadUserCsvTemplate': "Download User - CSV Template",
    'ucm_downloadUserExcelTemplate': "Download User - Excel Template",
    'ucm_editUserSubtitle': "Edit user chat account information",
    'ucm_email': "Email",
    'ucm_emailRequired': "Email *",
    'ucm_enterEmailAddress': "Enter email address",
    'ucm_enterFacebookRecipientId': "Enter Facebook recipient ID",
    'ucm_enterFirstName': "Enter first name",
    'ucm_enterInstagramRecipientId': "Enter Instagram recipient ID",
    'ucm_enterLastName': "Enter last name",
    'ucm_enterNewPassword': "Enter new password",
    'ucm_enterPassword': "Enter password",
    'ucm_enterPhoneNumber': "Enter phone number",
    'ucm_enterSocialUserId': "Enter social user ID",
    'ucm_enterUsername': "Enter username",
    'ucm_error': "Error",
    'ucm_export': "Export",
    'ucm_exportToExcel': "Export to Excel",
    'ucm_failedToProcessExcelFile': "Failed to process Excel file.",
    'ucm_firstNameRequired': "First Name *",
    'ucm_howToUseTemplates': "How to use templates:",
    'ucm_import': "Import",
    'ucm_importFile': "Import File",
    'ucm_integrationSocial': "Integration Social",
    'ucm_invalidFileType': "Invalid file type",
    'ucm_lastNameRequired': "Last Name *",
    'ucm_loading': "Loading...",
    'ucm_lowercaseLetter': "Lowercase letter",
    'ucm_missingColumns': "Missing Columns",
    'ucm_missingColumnsText': "The following required columns are missing: {columns}",
    'ucm_model': "Model",
    'ucm_modelConfiguration': "Model Configuration",
    'ucm_modelGrouping': "Model Grouping",
    'ucm_modelShortcut': "Model Shortcut",
    'ucm_name': "Name",
    'ucm_newAccountLockedDesc': "New account will be locked and cannot access the system",
    'ucm_newAccountUnlockedDesc': "New account will be unlocked and can access the system",
    'ucm_newPasswordRequired': "New Password *",
    'ucm_noPassword': "No password",
    'ucm_number': "Number",
    'ucm_pageTitle': "Chat User Management",
    'ucm_passwordRequired': "Password *",
    'ucm_passwordRequirements': "Password Requirements",
    'ucm_passwordSetup': "Password Setup",
    'ucm_passwordStrength': "Password Strength",
    'ucm_passwordsMatch': "Passwords match",
    'ucm_phoneNumber': "Phone Number",
    'ucm_pleaseUploadExcelOrCsv': "Please upload an Excel (.xlsx) or CSV (.csv) file.",
    'ucm_pleaseWait': "Please wait",
    'ucm_readOnly': "Read Only",
    'ucm_recipientIdFacebook': "Recipient ID (Facebook)",
    'ucm_recipientIdInstagram': "Recipient ID (Instagram)",
    'ucm_securityTips': "Security Tips:",
    'ucm_selectAvailableModels': "Select available models",
    'ucm_selectModelGrouping': "Select model grouping",
    'ucm_selectModelShortcut': "Select model shortcut",
    'ucm_socialUserId': "Social User ID",
    'ucm_specialCharacter': "Special character",
    'ucm_strengthFair': "Fair",
    'ucm_strengthGood': "Good",
    'ucm_strengthStrong': "Strong",
    'ucm_strengthWeak': "Weak",
    'ucm_syncUsers': "Sync Users",
    'ucm_template': "Template",
    'ucm_templateStepDownload': "Download the template file",
    'ucm_templateStepFillData': "Fill in your user data following the template structure",
    'ucm_templateStepSelectFormat': "Select the appropriate template format for your needs",
    'ucm_templateStepUpload': "Upload the completed file using the import section",
    'ucm_templateUser': "Template User",
    'ucm_tipAvoidPersonalInfo': "Avoid personal information like names, birthdays, or common words",
    'ucm_tipChangeRegularly': "Change your password regularly for better security",
    'ucm_tipPassphrase': "Consider using a passphrase with mixed case, numbers, and symbols",
    'ucm_tipUniquePassword': "Use a unique password that you don't use elsewhere",
    'ucm_uppercaseLetter': "Uppercase letter",
    'ucm_usernameReadOnly': "Username (Read Only)",
    'ucm_usernameRequired': "Username *",
    'umgt_template': "Template",
    'umgt_downloadTemplate': "Download Template",
    'umgt_import': "Import",
    'umgt_importFile': "Import File",
    'umgt_export': "Export",
    'umgt_exportToExcel': "Export to Excel",
    'umgt_addNewUser': "Add New User",
    'umgt_editUserSubtitle': "Edit user account information",
    'umgt_changePassword': "Change Password",
    'umgt_basicInformation': "Basic Information",
    'umgt_usernameReadOnly': "Username (Read Only)",
    'umgt_firstNameRequired': "First Name *",
    'umgt_enterFirstName': "Enter first name",
    'umgt_lastNameRequired': "Last Name *",
    'umgt_enterLastName': "Enter last name",
    'umgt_emailReadOnly': "Email (Read Only)",
    'umgt_enterPhoneNumber': "Enter phone number",
    'umgt_rolePermissions': "Role & Permissions",
    'umgt_userRoleRequired': "User Role *",
    'umgt_userRoleUser': "User",
    'umgt_availableModels': "Available Models",
    'umgt_model': "Model",
    'umgt_selectAvailableModels': "Select available models",
    'umgt_document': "Document",
    'umgt_selectDocument': "Select document",
    'umgt_databaseIntegration': "Database integration",
    'umgt_selectDatabaseIntegration': "Select database integration",
    'umgt_productGroupName': "Product Group Name",
    'umgt_selectProductGroupName': "Select product group name",
    'umgt_intentGroupName': "Intent Group Name",
    'umgt_selectIntentGroupName': "Select intent group name",
    'umgt_flows': "Flows",
    'umgt_accountLockedSubtitle': "Account is locked - User cannot access the system",
    'umgt_accountUnlockedSubtitle': "Account is unlocked - User can access the system",
    'umgt_addUserSubtitle': "Create a new user account with required information",
    'umgt_usernameRequired': "Username *",
    'umgt_enterUsername': "Enter username",
    'umgt_emailRequired': "Email *",
    'umgt_enterEmailAddress': "Enter email address",
    'umgt_passwordSetup': "Password Setup",
    'umgt_passwordRequired': "Password *",
    'umgt_enterPassword': "Enter password",
    'umgt_confirmPasswordRequired': "Confirm Password *",
    'umgt_confirmPasswordPlaceholder': "Confirm password",
    'umgt_passwordsMatch': "Passwords match",
    'umgt_accountStatus': "Account Status",
    'umgt_changePasswordSubtitle': "Create a new secure password for your account",
    'umgt_passwordRequirements': "Password Requirements",
    'umgt_newPasswordRequired': "New Password *",
    'umgt_enterNewPassword': "Enter new password",
    'umgt_confirmNewPasswordRequired': "Confirm New Password *",
    'umgt_confirmNewPasswordPlaceholder': "Confirm new password",
    'umgt_passwordStrength': "Password Strength:",
    'umgt_securityTips': "Security Tips:",
    'umgt_tipUniquePassword': "Use a unique password that you don't use elsewhere",
    'umgt_tipPassphrase': "Consider using a passphrase with mixed case, numbers, and symbols",
    'umgt_tipAvoidPersonalInfo': "Avoid personal information like names, birthdays, or common words",
    'umgt_tipChangeRegularly': "Change your password regularly for better security",
    'umgt_loading': "Loading...",
    'umgt_pleaseWait': "Please wait",
        'lmsg_graphId': "Graph ID",
    'lmsg_status': "Status",
    'lmsg_mode': "Mode",
    'lmsg_time': "Time",
    'lmsg_nodes': "Nodes",
    'lmsg_edges': "Edges",
    'lmsg_anchors': "Anchors",
    'lmsg_sources': "Sources",
    'lmsg_context': "Context",
    'lmsg_notes': "Notes",
    'lmsg_noMatchingEntities': "No matching entities",
    'lmsg_contextAppended': "Context appended",
    'lmsg_anchorMatches': "Anchor Matches ({n})",
    'lmsg_id': "ID",
    'lmsg_label': "Label",
    'lmsg_type': "Type",
    'lmsg_score': "Score",
    'lmsg_contextTextChars': "Context Text ({n} chars)",
    'lmsg_copyFullContext': "Copy full context",
    'lmsg_nexaNoAnchorsFound': "NEXA found no anchors and returned no context for this query.",
    'lmsg_skipped': "Skipped",
    'lmsg_hitAtLayer': "HIT {'@'} {layer}",
    'lmsg_noHit': "No hit",
    'lmsg_typeLabel': "type: {type}",
    'lmsg_scoreLabel': "score: {score}",
    'lmsg_layersAttempted': "{n} layers attempted",
    'lmsg_miniappStatus': "miniapp: {status}",
    'lmsg_on': "on",
    'lmsg_off': "off",
    'lmsg_logReferencesLayerWalk': "Log References — Layer Walk ({n})",
    'lmsg_layer': "Layer",
    'lmsg_outcome': "Outcome",
    'lmsg_http': "HTTP",
    'lmsg_winner': "Winner",
    'lmsg_winningLayer': "Winning layer",
    'lmsg_noResult': "No result",
    'lmsg_resultItems': "Result Items ({n})",
    'lmsg_title': "Title",
    'lmsg_injectedContextChars': "Injected Context ({n} chars)",
    'lmsg_summary': "Summary",
    'lmsg_fallbackReason': "Fallback reason",
    'lmsg_detail': "Detail",
    'lmsg_layerNoUsableResult': "Layer returned no usable result — waterfall moved to the next tier.",
    'lmsg_layerOutcome': "Layer outcome: {outcome}",
    'lmsg_unknown': "unknown",
    'lmsg_warnings': "Warnings",
    'lmsg_errors': "Errors",
    'lmsg_modeLabel': "mode: {mode}",
    'lmsg_toolCallsCount': "{n} tool call(s)",
    'lmsg_iterationsCount': "{n} iteration(s)",
    'lmsg_toolsAvailableCount': "{n} tools available",
    'lmsg_toolCallsHeader': "Tool Calls ({n})",
    'lmsg_tool': "Tool",
    'lmsg_arguments': "Arguments",
    'lmsg_result': "Result",
    'lmsg_success': "Success",
    'lmsg_failed': "Failed",
    'lmsg_modelDidNotCallMcpTools': "The model did not call any MCP tools for this message.",
    'lmsg_error': "Error",
    'lmsg_logReferencesHeader': "Log References ({n})",
    'lmsg_loadingReferenceData': "Loading reference data...",
    'lmsg_monitor': "Monitor",
    'lmsg_intent': "Intent",
    'lmsg_message': "Message",
    'lmsg_reply': "Reply",
    'lmsg_tokens': "Tokens",
    'lmsg_responseTime': "Response Time",
    'lmsg_endpoint': "Endpoint",
    'lmsg_used': "Used",
    'lmsg_viewMonitor': "View Monitor",
    'lmsg_promptLabel': "Prompt",
    'lmsg_completionLabel': "Completion",
    'lmsg_embedLabel': "Embedding",
    'lmsg_totalLabel': "Total",
    'lmsg_cachedLabel': "Cached",
    'lmsg_notUsed': "Not Used",
    'lmsg_method': "Method",
    'lmsg_apiEndpoint': "API Endpoint",
    'lmsg_requestBody': "Request Body",
    'lmsg_jsonResponse': "JSON Response",
    'lmsg_statusCode': "Status Code",
    'lmsg_statusName': "Status Name",
    'lmsg_documentName': "Document name",
    'lmsg_textOrg': "Text ORG",
    'lmsg_idLabel': "ID: {id}",
    'lmsg_timing': "Timing",
    'lmsg_start': "Start",
    'lmsg_end': "End",
    'lmsg_duration': "Duration",
    'lmsg_noFlowDataAvailable': "No Flow Data Available",
    'lmsg_exportLogToQuestionSet': "Export log to Question Set",
    'lmsg_condition': "Condition",
    'lmsg_startDateLabel': "StartDate",
    'lmsg_endDateLabel': "EndDate",
    'lmsg_typeLabelPlain': "Type",
    'lmsg_userChannelLabel': "User Channel",
    'lmsg_sessionIdLabel': "SessionID",
    'lmsg_exportFile': "Export file",
    'lmsg_chatLog': "Chat log",
    'lmsg_monitorDetails': "Monitor Details",
    'lmsg_loadingMonitorData': "Loading monitor data...",
    'lmsg_userQuery': "User Query",
    'lmsg_model': "Model",
    'lmsg_systemAndPrompts': "System & Prompts",
    'lmsg_systemMessageAndWorkflowConfig': "System message and workflow configuration",
    'lmsg_systemMessage': "System Message",
    'lmsg_copy': "Copy",
    'lmsg_workFlow': "Work Flow",
    'lmsg_knowledgeAndVectors': "Knowledge & Vectors",
    'lmsg_vectorDbAndSimilaritySearchResults': "Vector database and similarity search results",
    'lmsg_knowledge': "Knowledge",
    'mdata_pricePerImageHint': "Price per image generation",
    'mdata_chooseImageQualityHint': "Choose image quality",
    'mdata_selectImageResolutionHint': "Select image resolution",
    'mdata_requiredField': "Required",
    'mdata_mustBeANumber': "Must be a number.",
    'mdata_qualityHd': "HD",
    'mdata_qualityStandard': "Standard",
    'mdata_columnId': "ID",
    'mdata_columnApiVersion': "API Version",
    'mdata_columnModelType': "Model Type",
    'mdata_columnPrice': "Price",
    'mdata_dataIsDuplicate': "Data is duplicate",
    'saPersona_agencyConfigLabel': "Agency Config",
    'saPersona_agencyCodeLabel': "Agency Code",
    'saPersona_agencyParamLabel': "Agency Param",
    'saPersona_endpointPathsLabel': "Endpoint Paths (JSON object)",
    'saPersona_coverageListLabel': "Coverage List (JSON array)",
    'saPersona_fieldMappingLabel': "Field Mapping (JSON object: contractKey → GDX field)",
    'saPersona_cacheTtlHoursLabel': "Cache TTL (hrs)",
    'saPersona_serviceCodeLabel': "Service Code",
    'saPersona_agencyParamCasingHint': "casing of ?Agency=",
    'saPersona_providerFieldLabel': "Provider",
    'saPersona_baseUrlFieldLabel': "Base URL",
    'saPersona_cacheTtlSecondsLabel': "Cache TTL (seconds)",
    'saPersona_keyVaultPrefixLabel': "Key Vault Prefix",
    'saPersona_extrasJsonLabel': "Extras (JSON object)",
    'saPersona_agencyHeader': "Agency",
    'saPersona_paramHeader': "Param",
    'saPersona_ttlHoursHeader': "TTL (hrs)",
    'saPersona_serviceCodeHeader': "Service Code",
    'saPersona_cacheHeader': "Cache",
    'saPersona_ownerHeader': "Owner",
    'saPersona_personaHeader': "Persona",
    'saPersona_piiHeader': "PII",
    'saPersona_gdxSettingsSavedTitle': "GDX settings saved",
    'saPersona_hotReloadNoRestartText': "Takes effect immediately (hot-reload), no restart needed",
    'saPersona_saveFailedTitle': "Save failed",
    'saPersona_unknownErrorText': "Unknown error",
    'saPersona_requestErrorText': "Request error",
    'saPersona_companyFallbackLabel': "company {id}",
    'saPersona_invalidJsonError': "Invalid JSON",
    'saPersona_mustBeJsonArrayError': "Must be a JSON array, e.g. [\"MSH001\"]",
    'saPersona_mustBeJsonObjectError': "Must be a JSON object, e.g. {'{'}\"welfare\":\"WelfareType\"{'}'}",
    'saPersona_agencyCodeRequiredError': "Agency Code is required",
    'saPersona_agencyConfigSavedTitle': "Agency config saved",
    'saPersona_effectiveNextCallText': "Takes effect on the next call (config-driven)",
    'saPersona_deleteAgencyConfigTitle': "Delete agency config?",
    'saPersona_deleteAgencyConfigDetail': "After deletion, this agency will revert to its built-in default values",
    'saPersona_deleteConfirmButton': "Delete",
    'saPersona_cancelButton': "Cancel",
    'saPersona_deletedTitle': "Deleted",
    'saPersona_revertedToDefaultText': "{code} reverted to default",
    'saPersona_deleteFailedTitle': "Delete failed",
    'saPersona_serviceCodeRequiredError': "Service Code is required",
    'saPersona_agencyParamRequiredError': "Agency Param to send in ?Agency= is required",
    'saPersona_savedTitle': "Saved",
    'saPersona_effectiveNextCallSuffixText': "{code} — takes effect on the next call",
    'saPersona_serviceEditedTitle': "Service updated",
    'saPersona_serviceSavedTitle': "Service saved",
    'saPersona_deleteServiceTitle': "Delete service?",
    'saPersona_deleteServiceDetail': "If all services are deleted, the system reverts to built-in coverage",
    'saPersona_companyIdNotFoundTitle': "Company ID not found",
    'saPersona_reloadCompanyListText': "Reload the company list and try again",
    'saPersona_personaEnabledTitle': "Persona enabled",
    'saPersona_personaDisabledTitle': "Persona disabled",
    'saPersona_sourceDisabledTitle': "Data source is disabled",
    'saPersona_enableBeforeTestText': "Enable it first before testing",
    'saPersona_testFailedTitle': "Test failed",
    'saPersona_locationRequired': "Please allow location access to use weather and air-quality data",
    'saPersona_testNotAvailableTitle': "Testing not available",
    'saPersona_piiSourceCannotTestText': "This source contains personal data and cannot be tested with real data",
    'saPersona_dataSourceSavedTitle': "Data source saved",
    'saPersona_extrasMustBeJsonObjectError': "Extras: must be a JSON object, e.g. {'{'}\"province\":\"bangkok\"{'}'}",
    'saSet_answers': "Answers",
    'saSet_apiScope': "APIScope",
    'saSet_applyChange': "Apply change",
    'saSet_clickForSyncSSO': "Click for sync config Single Sign-On",
    'saSet_clientSecret': "ClientSecret",
    'saSet_failedToReadFile': "Failed to read file!",
    'saSet_gmailAppPasswordOption': "Gmail (App Password)",
    'saSet_minTenNumbers': "Min 10 numbers",
    'saSet_msEntraGroupConfig': "Microsoft Entra ID Group Configuration",
    'saSet_office365OAuth2RequiredOption': "Office 365 (OAuth2 Required)",
    'saSet_otherOption': "Other",
    'saSet_required': "Required.",
    'saSet_responseTimeMs': "ResponseTime (Milliseconds)",
    'saSet_syncSSO': "Sync SSO",
    'saSet_syncSingleSignOn': "Sync Single Sign-On",
    'saSet_urlConfig': "URLConfig",
    'ssoc_apiConfiguration': "API Configuration",
    'ssoc_apiVersion': "API Version",
    'ssoc_configurationDetails': "Configuration Details",
    'ssoc_createNewSnippetConfig': "Create a new Snippet configuration",
    'ssoc_domainName': "Domain Name",
    'ssoc_enterAccessToken': "Enter access token",
    'ssoc_enterApiVersionExample': "Enter API version (e.g., v18.0)",
    'ssoc_enterDefaultUserId': "Enter default user ID",
    'ssoc_enterDomainName': "Enter domain name",
    'ssoc_enterFacebookPageId': "Enter Facebook Page ID",
    'ssoc_enterInstagramPageId': "Enter Instagram Page ID",
    'ssoc_enterTokenOptional': "Enter token (optional)",
    'ssoc_enterVerifyToken': "Enter verify token",
    'ssoc_facebookAccessToken': "Facebook Access Token",
    'ssoc_facebookVerifyToken': "Facebook Verify Token",
    'ssoc_generatedIntegrationLink': "Generated integration link",
    'ssoc_generatedLink': "Generated Link",
    'ssoc_generatedResources': "Generated Resources",
    'ssoc_instagramAccessToken': "Instagram Access Token",
    'ssoc_instagramVerifyToken': "Instagram Verify Token",
    'ssoc_integrationLink': "Integration Link",
    'ssoc_loading': "Loading...",
    'ssoc_max100Characters': "Max 100 characters",
    'ssoc_modelDisplay': "Model Display",
    'ssoc_modelShortcut': "Model Shortcut",
    'ssoc_nameMustBeLessThan100Characters': "Name must be less than 100 characters",
    'ssoc_pageId': "Page ID",
    'ssoc_platformNameFacebook': "Facebook",
    'ssoc_platformNameInstagram': "Instagram",
    'ssoc_platformNameLine': "LINE",
    'ssoc_platformNameSnippet': "Snippet",
    'ssoc_platformNameTeams': "Teams",
    'ssoc_requiredField': "Required.",
    'ssoc_selectModelDisplay': "Select model display",
    'ssoc_selectQuickGroupModel': "Select quick group model",
    'ssoc_selectShortcutMenu': "Select shortcut menu",
    'ssoc_shortcutMenu': "Shortcut Menu",
    'ssoc_teamsConfiguration': "Teams Configuration",
    'ssoc_token': "Token",
    'ssoc_userDefault': "User Default",
    'ucm_close': "Close",
    'ucm_csvFormat': "CSV",
    'ucm_duplicateEmail': "duplicate email",
    'ucm_duplicateEmails': "Duplicate emails",
    'ucm_duplicateSocialUserId': "duplicate Social UserID",
    'ucm_duplicateUsername': "duplicate username",
    'ucm_duplicateUsernames': "Duplicate usernames",
    'ucm_emailNotFormattedCorrectly': "Email is not formatted correctly",
    'ucm_excelFormat': "Excel",
    'ucm_invalidEmail': "invalid email",
    'ucm_invalidPhoneFormat': "Invalid Phone format",
    'ucm_min10Numbers': "Min 10 numbers",
    'ucm_modelNotFormattedCorrectly': "Model is not formatted correctly",
    'ucm_pleaseFillAllFieldsExclaim': "please fill all fields!!!",
    'ucm_pleaseFillCorrectFormat': "please fill correct format",
    'ucm_pleaseFillCorrectFormatExclaim': "please fill correct format!",
    'ucm_pleaseFillRequiredFields': "Please fill the required fields",
    'ucm_pleaseFillPassword': "Please fill Password",
    'ucm_pleaseFillConfirmPassword': "Please fill Confirm Password",
    'ucm_pleaseFillPasswordAndConfirmPassword': "Please fill Password and Confirm Password",
    'ucm_passwordConfirmMismatch': "Password and Confirm Password do not match. Please fill correctly.",
    'ucm_requiredField': "Required.",
    'ucm_warningExclaim': "Warning!",
    'umgt_templateUserTitle': "Template User",
    'umgt_templateUserSubtitle': "Download template files for user import",
    'umgt_howToUseTemplates': "How to use templates:",
    'umgt_templateStepSelectFormat': "Select the appropriate template format for your needs",
    'umgt_templateStepDownload': "Download the template file",
    'umgt_templateStepFillData': "Fill in your user data following the template structure",
    'umgt_templateStepUpload': "Upload the completed file using the import section",
    'umgt_loadingText': "Loading...",
    'umgt_downloadUserCsvTemplate': "Download User - CSV Template",
    'umgt_downloadUserExcelTemplate': "Download User - Excel Template",
    'umgt_ruleRequired': "Required.",
    'umgt_ruleMin10Numbers': "Min 10 numbers",
    'umgt_fullName': "Name",
    'umgt_passwordStrengthWeak': "Weak",
    'umgt_passwordStrengthFair': "Fair",
    'umgt_passwordStrengthGood': "Good",
    'umgt_passwordStrengthStrong': "Strong",
    'umgt_passwordStrengthNone': "No password",
    'umgt_noWorksheetFound': "No worksheet found in the Excel file",
    'umgt_invalidFileType': "Invalid file type. Please upload an Excel (.xlsx) or CSV (.csv) file.",
    'umgt_missingColumns': "Missing Columns",
    'umgt_missingColumnsText': "The following required columns are missing: {columns}",
    'umgt_duplicateUsernames': "Duplicate usernames",
    'umgt_duplicateEmails': "Duplicate emails",
    'umgt_duplicateUsernameLower': "duplicate username",
    'umgt_duplicateEmailLower': "duplicate email",
    'umgt_emailNotFormattedCorrectly': "Email is not formatted correctly",
    'umgt_pleaseFillRequiredFields': "Please fill the required fields",
    'umgt_modelNotFormattedCorrectly': "Model is not formatted correctly",
    'umgt_usernameNotAllowedSuperAdmin': "This username is not allowed to be a SuperAdmin role.",
    'umgt_warningExclaim': "Warning!",
    'umgt_invalidPhoneFormat': "Invalid Phone format",
    'umgt_invalidEmail': "invalid email",
    'umgt_ruleFillCorrectFormat': "Please fill correct format!",
    'umgt_ruleFillAllFields': "Please fill all the fields!!!",
    'umgt_ruleFillPasswordAndConfirm': "Please fill Password and Confirm Password",
    'umgt_ruleFillPassword': "Please fill Password",
    'umgt_ruleFillConfirmPassword': "Please fill Confirm Password",
    'umgt_passwordMismatchFillCorrectly': "Password and Confirm Password do not match. Please fill correctly.",
        'isd_intentSessionDetail': "Intent Session Detail",
    'isd_intentSessionName': "Intent Session Name*",
    'isd_score': "Score",
    'isd_useMemory': "Use memory",
    'isd_promptSession': "Prompt Session",
    'isd_enterThePrompt': "Enter the Prompt...",
    'isd_intent': "Intent",
    'isd_template': "Template",
    'isd_enterTheMessageIntent': "Enter the message intent...",
    'isd_delete': "Delete",
    'isd_action': "Action",
    'isd_actionAnswer': "Action Answer",
    'isd_actionParallel': "Action Parallel",
    'isd_actionType': "Action type*",
    'isd_actionTypeInformation': "Action type information",
    'isd_mergePrompt': "Merge prompt",
    'isd_vectorName': "Vector Name*",
    'isd_loading': "Loading...",
    'isd_selectedVectors': "Selected Vectors:",
    'isd_prompt': "Prompt",
    'isd_message': "Message",
    'isd_enterTheMessage': "Enter the message...",
    'isd_nextRouting': "Next Routing*",
    'isd_botDisableTimeMinutes': "Bot Disable Time (minutes)",
    'isd_enterTimeInMinutes': "Enter time in minutes",
    'isd_botDisableTimeHint': "Specify the duration for bot deactivation (in minutes) when transferring to an agent. If left blank, the bot will remain active.",
    'isd_contactAgentMessage': "Contact Agent Message",
    'isd_method': "Method*",
    'isd_apiEndpoint': "API Endpoint*",
    'isd_headers': "Headers",
    'isd_key': "Key",
    'isd_value': "Value",
    'isd_addHeader': "Add Header",
    'isd_jsonRequest': "JSON Request",
    'isd_modelJson': "Model JSON*",
    'isd_availableVariablesHint': "Available Variables (Click or Drag to insert)",
    'isd_transactionId': "Transaction ID",
    'isd_channel': "Channel",
    'isd_channelId': "Channel ID",
    'isd_userChannel': "User Channel",
    'isd_sessionId': "Session ID",
    'isd_validation': "Validation",
    'isd_typeValidate': "Type Validate*",
    'isd_numberOfCharacter': "Number of Character",
    'isd_regularExpression': "Regular Expression",
    'isd_errorMessage': "Error Message",
    'isd_enterTheValidationErrorMessage': "Enter the validation error message...",
    'isd_addValidation': "Add Validation",
    'isd_textResponse': "Text Response",
    'isd_responseMessage': "Response Message",
    'isd_enterTheResponseMessage': "Enter the response message...",
    'isd_addNewAction': "Add New Action",
    'isd_close': "Close",
    'isd_save': "Save",
    'isd_pleaseWait': "Please wait",
    'isd_copiedToClipboard': "Copied to clipboard!",
    'isd_required': "Required.",
    'isd_errorReadingExcelFile': "Error reading Excel file",
    'isd_fileFormatNotSupported': "The file format is not supported or the file is corrupted.",
    'isd_textOrg': "text_org",
    'isd_textEn': "text_en",
    'isd_actionTypeVector': "Vector",
    'isd_actionTypeModelRouting': "Model Routing",
    'isd_actionTypeNextRouting': "Next Routing",
    'isd_actionTypeContactAgent': "Contact Agent (Disable Bot)",
    'isd_actionTypeApiTrigger': "API Trigger",
    'isd_validationPhone': "Validation Phone",
    'isd_validationEmail': "Validation Email",
    'isd_validationMaxCharacter': "Validation Max Character",
    'isd_validationRegularExpression': "Validation Regular Expression",
    'mqg_loading': "Loading...",
    'mqg_pleaseWait': "Please wait",
    'mqg_editShortcutGroup': "Edit Shortcut Group",
    'mqg_modifyModelShortcutGroupConfiguration': "Modify model shortcut group configuration",
    'mqg_basicInformation': "Basic Information",
    'mqg_shortcutGroupName': "Shortcut Group Name",
    'mqg_enterUniqueNameForShortcutGroup': "Enter a unique name for this shortcut group",
    'mqg_enterGroupNamePlaceholder': "Enter group name...",
    'mqg_modelConfiguration': "Model Configuration",
    'mqg_allModels': "All Models",
    'mqg_includeAllAvailableModelsInGroup': "Include all available models in this group",
    'mqg_modelSetup': "Model Setup",
    'mqg_model': "model",
    'mqg_modelsPlural': "models",
    'mqg_modelNameHeader': "Model Name",
    'mqg_uploadImage': "Upload Image",
    'mqg_imagePreview': "Image Preview",
    'mqg_actionsHeader': "Actions",
    'mqg_selectModel': "Select Model",
    'mqg_chooseModelForShortcut': "Choose a model for this shortcut",
    'mqg_previewAlt': "Preview",
    'mqg_remove': "Remove",
    'mqg_add': "Add",
    'mqg_addMultipleModelsAndUploadCustomImages': "You can add multiple models and upload custom images for each model",
    'mqg_allModelsIncluded': "All Models Included",
    'mqg_groupWillAutoIncludeAllModels': "This group will automatically include all available models",
    'mqg_modelsConfiguredCount': "{n} {unit} configured",
    'mqg_close': "Close",
    'mqg_save': "Save",
    'mqg_addShortcutGroup': "Add Shortcut Group",
    'mqg_createNewModelShortcutGroup': "Create a new model shortcut group",
    'mqg_modelDetailsAndInformation': "Model details and information",
    'mqg_noModelsFound': "No models found",
    'mqg_noModelDataAvailableToDisplay': "No model data available to display",
    'mqg_view': "View",
    'mqg_modelsCount': "{n} models",
    'mqg_required': "Required.",
    'mqg_errorOccurred': "An error occurred!",
    'mqg_somethingWentWrong': "Something went wrong!",
    'mqg_onlyAcceptJpegOrPngFiles': "Only JPEG or PNG files are accepted",
    'sacomp_statusEnable': "Enable",
    'sacomp_statusDisable': "Disable",
    'sacomp_sectionCompany': "Company",
    'sacomp_labelCompanyCodeRequired': "Company Code *",
    'sacomp_labelCompanyNameRequired': "Company Name *",
    'sacomp_labelMobileNumber': "Mobile number",
    'sacomp_labelProvince': "Province",
    'sacomp_labelDistrict': "District",
    'sacomp_labelSubDistrict': "Sub District",
    'sacomp_labelCountry': "Country",
    'sacomp_labelPostCode': "Post Code",
    'sacomp_labelAddress': "Address",
    'sacomp_labelEmailRequired': "E-mail *",
    'sacomp_labelEmail': "E-mail",
    'sacomp_sectionPortalUserChatFramework': "Portal User Chat framework",
    'sacomp_labelUsernameRequired': "Username *",
    'sacomp_labelPasswordRequired': "Password *",
    'sacomp_labelNameRequired': "Name *",
    'sacomp_labelLastNameRequired': "Last name *",
    'sacomp_labelIdCard': "ID Card",
    'sacomp_labelLockStatus': "Lock Status:",
    'sacomp_lockStatusLocked': "Locked",
    'sacomp_lockStatusUnlocked': "Unlocked",
    'sacomp_labelCompanyCode': "Company Code",
    'sacomp_labelStatusPrefix': "Status: ",
    'sacomp_labelUsername': "Username",
    'sacomp_titleChangePassword': "Change Password",
    'sacomp_labelNewPasswordRequired': "New Password *",
    'sacomp_labelConfirmNewPasswordRequired': "Confirm New Password *",
    'sacomp_headerNo': "No",
    'sacomp_headerCompanyCode': "Company Code",
    'sacomp_headerCompanyName': "Company Name",
    'sacomp_headerEmail': "E-mail",
    'sacomp_headerTelephone': "Telephone",
    'sacomp_headerOwner': "Owner",
    'sacomp_headerStatus': "Status",
    'sacomp_headerActions': "Actions",
    'sacomp_headerManage': "Manage",
    'sacomp_validationCompanyCodeMaxLength': "Must not exceed 10 characters",
    'sacomp_confirmDeleteCompanyText': "Delete company \"{name}\" ({code})?",
    'sacomp_companyDeletedSuccess': "Company deleted successfully",
    'sacomp_deleteFailed': "Delete failed",
    'sacomp_switchCompanyFailed': "Switch company failed",
    'sacomp_networkError': "Network error",
    'strm_modelTopicLabel': "Model {model} : {topic}",
    'strm_helpUserId': ":userid (request MS Team ID)",
    'strm_helpClearMemory': ":clearmemory (clear short memory)",
    'strm_helpMemory': ":memory (show short memory)",
    'strm_helpLastMemory': ":lastmemory (show last memory of last conversation)",
    'strm_helpModel': ":model (show all model)",
    'strm_fullStream': "Full Stream",
    'strm_parameters': "Parameters",
    'strm_userId': "User ID",
    'strm_enterUserId': "Enter User ID",
    'strm_timeDelay': "Time Delay",
    'strm_ms': "ms",
    'strm_log': "Log",
    'strm_systemMessage': "System Message",
    'strm_knowledge': "Knowledge",
    'strm_sqlQuery': "SQL Query",
    'strm_sqlQueryResult': "SQL Query Result",
    'strm_workFlow': "Work Flow",
    'strm_memory': "Memory",
    'strm_llmsModel': "LLMs Model",
    'strm_modelIdLabel': "ModelID : {value}",
    'strm_modelNameLabel': "ModelName : {value}",
    'strm_providerLabel': "Provider : {value}",
    'strm_modelLabel': "Model : {value}",
    'strm_systemMessageLabel': "SystemMessage",
    'strm_knowledgeDocuments': "KnowledgeDocuments",
    'strm_extensionLabel': "Extension : {value}",
    'strm_descriptionLabel': "Description : {value}",
    'strm_genderLabel': "Gender : {value}",
    'strm_topNChunksLabel': "TopN_Chunks : {value}",
    'strm_internetLabel': "Internet : {value}",
    'strm_feedbackLabel': "Feedback : {value}",
    'strm_historyCountLabel': "HistoryCount : {value}",
    'strm_historyMinuteLabel': "HistoryMinute : {value}",
    'strm_temperatureLabel': "Temperature : {value}",
    'strm_topPLabel': "Top_P : {value}",
    'strm_frequencyPenaltyLabel': "Frequency_Penalty : {value}",
    'strm_presencePenaltyLabel': "Presence_Penalty : {value}",
    'strm_stopSequenceLabel': "Stop_Sequence : {value}",
    'strm_maxTokensResponseLabel': "MaxTokensResponse : {value}",
    'strm_isStreamLabel': "IsStream : {value}",
    'strm_endpoint': "Endpoint",
    'strm_vectorCosine': "Vector Cosine",
    'strm_privateMemory': "Private Memory",
    'strm_topicList': "Topic list",
    'strm_rename': "Rename",
    'strm_deleteChat': "Delete chat",
    'strm_findingAnswer': "Finding answer ...",
    'strm_typeMessagePlaceholder': "Type your message here... (Shift + Enter for new line)",
    'strm_attachImages': "Images",
    'strm_attachFiles': "Files",
    'strm_requiredField': "Required.",
    'strm_textOrg': "text_org",
    'strm_textEn': "text_en",
    'strm_type': "Type",
    'strm_csv': "CSV",
    'strm_excel': "Excel",
    'strm_pdf': "PDF",
    'strm_word': "Word",
    'strm_powerPoint': "PowerPoint",
    'strm_text': "Text",
    'strm_version': "Version",
    'strm_modified': "Modified",
    'strm_modifiedBy': "Modified By",
    'strm_addReplaceHint': "ADD adds new data to the Vector, Replace edits the answer",
    'strm_fileTooLargeLimit': "File size exceeds {limit} KB",
    'strm_micPermissionDenied': "No permission to access microphone",
    'strm_genericError': "An error occurred",
    'strm_speaking': "Speaking...",
    'strm_audioFile': "Audio file",
    'strm_noAudioDataInFile': "No audio data found in file",
    'strm_audioConversionFailed': "Unable to convert audio file",
    'strm_audioFormatUnsupported': "Only MP3, WAV and M4A files are supported",
    'strm_allowPopupForFullStream': "Please allow popups to open FullStream in a new tab",
    'strm_authNotFound': "Auth not found",
    'usdd_pageTitle': "Upload Sound To Document",
    'usdd_currentDocument': "Current Document",
    'usdd_noDocumentSelected': "No Document Selected",
    'usdd_collapse': "Collapse",
    'usdd_expand': "Expand",
    'usdd_edit': "Edit",
    'usdd_importToKnowledgeBase': "Import to Knowledge Base",
    'usdd_summarizeWithAiModel': "Summarize with AI Model",
    'usdd_delete': "Delete",
    'usdd_close': "Close",
    'usdd_uploadSpeechFiles': "Upload Speech Files",
    'usdd_uploadSpeechFilesSubtitle': "Upload and process audio files for transcription",
    'usdd_uploadFiles': "Upload Files",
    'usdd_filesSelected': "{n} file(s) selected",
    'usdd_documentNameRequired': "Document Name *",
    'usdd_language': "Language",
    'usdd_aiModelForSummation': "AI Model (for summation)",
    'usdd_selectAiModelForSummation': "Select AI model for text summation",
    'usdd_required': "Required.",
    'usdd_botSummation': "Bot Summation",
    'usdd_uploadAudioFiles': "Upload Audio Files",
    'usdd_supportedFormatsHint': "Supported formats: MP3, WAV, M4A, FLAC (Max size: 100MB per file)",
    'usdd_editTextSummarization': "Edit Text Summarization",
    'usdd_editTextSummarizationSubtitle': "Edit original and summarized text content",
    'usdd_saveChanges': "Save Changes",
    'usdd_originalTextRequired': "Original Text *",
    'usdd_summarizedText': "Summarized Text",
    'usdd_importToKnowledgeDocument': "Import To Knowledge Document",
    'usdd_importToKnowledgeDocumentSubtitle': "Import processed content to knowledge base",
    'usdd_import': "Import",
    'usdd_selectDocumentRequired': "Select Document *",
    'usdd_chooseKnowledgeDocument': "Choose a knowledge document",
    'usdd_maxSplitCharactersRequired': "Max Split Characters *",
    'usdd_importInformationTitle': "Import Information:",
    'usdd_importInformationText': "This will process and split the content for knowledge base integration.",
    'usdd_summarizeText': "Summarize Text",
    'usdd_summarizeTextSubtitle': "Generate AI-powered text summary",
    'usdd_generateSummary': "Generate Summary",
    'usdd_aiModelForSummarizationRequired': "AI Model for Summarization *",
    'usdd_chooseAiModel': "Choose an AI model",
    'usdd_summarizationProcessTitle': "Summarization Process:",
    'usdd_summarizationProcessText': "The selected AI model will analyze and create a concise summary of the original text.",
    'usdd_loadingPleaseWait': "Loading Please Wait...",
    'usdd_headerNo': "No.",
    'usdd_headerOriginalText': "Original text",
    'usdd_headerSummarizedText': "Summarized text",
    'usdd_headerAction': "Action",
    'usdd_pleaseFillAllFields': "Please Fill All The Fields!",
    'usdd_pleaseAddSomeFile': "Please Add some file!",
    'uvec_basicInformation': "Basic Information",
    'uvec_documentName': "Document Name",
    'uvec_enterUniqueDocumentName': "Enter unique document name",
    'uvec_textReplacement': "Text Replacement",
    'uvec_selectReplacementRules': "Select replacement rules",
    'uvec_maxCharacterLimit': "Max Character Limit",
    'uvec_maxCharacterLimitPlaceholder': "Enter maximum character limit",
    'uvec_documentTypeAndProcessing': "Document Type & Processing",
    'uvec_processingMethod': "Processing Method",
    'uvec_customCharacter': "Custom Character",
    'uvec_enterCharacter': "Enter character",
    'uvec_customCharacterHint': "Enter the custom character used to split the content",
    'uvec_languageDetection': "Language Detection",
    'uvec_autoDetection': "Auto Detection",
    'uvec_manualMode': "Manual Mode",
    'uvec_personalInformation': "Personal Information",
    'uvec_detectionOn': "Detection ON",
    'uvec_detectionOff': "Detection OFF",
    'uvec_enablePersonalInfoDetectionHint': "Enable detection of personal information",
    'uvec_template': "Template",
    'uvec_searchInDocumentContent': "Search in document content",
    'uvec_search': "Search",
    'uvec_reprocess': "Reprocess",
    'uvec_loading': "Loading...",
    'uvec_collapseText': "Collapse text",
    'uvec_expandText': "Expand text",
    'uvec_active': "Active",
    'uvec_inactive': "Inactive",
    'uvec_editContent': "Edit content",
    'uvec_deleteItem': "Delete item",
    'uvec_close': "Close",
    'uvec_editVectorContent': "Edit Vector Content",
    'uvec_modifyYourDocumentContent': "Modify your document content",
    'uvec_content': "Content",
    'uvec_enterYourContentHere': "Enter your content here...",
    'uvec_addVectorContent': "Add Vector Content",
    'uvec_createNewDocumentContent': "Create new document content",
    'uvec_loadingPleaseWait': "Loading Please Wait...",
    'uvec_templateVector': "Template Vector",
    'uvec_downloadTemplateFilesHint': "Download template files for different document types",
    'uvec_howToUseTemplates': "How to use templates:",
    'uvec_selectAppropriateTemplateHint': "Select the appropriate template for your document type",
    'uvec_downloadTemplateFileFormatHint': "Download the template file format you prefer",
    'uvec_fillInDataHint': "Fill in your data following the template structure",
    'uvec_uploadCompletedFileHint': "Upload the completed file using the upload section above",
    'uvec_customSplitTemplateLabel': "CustomSplit Template:",
    'uvec_useSeparatorHint': "Set any separator you want (e.g. {'||!'})",
    'uvec_exampleSplitChunkContent': "Example: SplitChunkContent",
    'uvec_csv': "CSV",
    'uvec_downloadTemplate': "Download {modeType} - {format} Template",
    'uvec_excel': "Excel",
    'uvec_multiCol': "Multi-Col",
    'uvec_excelMultipleColumns': "Excel (Multiple Columns)",
    'uvec_pdf': "PDF",
    'uvec_word': "Word",
    'uvec_ppt': "PPT",
    'uvec_powerPoint': "PowerPoint",
    'uvec_txt': "TXT",
    'uvec_text': "Text",
    'uvec_processingType': "Processing Type",
    'vgu_generateQuestionSet': "Generate Question Set",
    'vgu_pageSubtitle': "Create intelligent questions from your knowledge documents",
    'vgu_questionSetName': "Question Set Name",
    'vgu_knowledgeDocuments': "Knowledge Documents",
    'vgu_documentName': "Document Name",
    'vgu_questionsPerChunk': "Questions per Chunk",
    'vgu_parameters': "Parameters",
    'vgu_temperature': "Temperature*",
    'vgu_topP': "Top P",
    'vgu_frequencyPenalty': "Frequency Penalty",
    'vgu_presencePenalty': "Presence Penalty",
    'vgu_maxTokensResponse': "Max Tokens Response",
    'vgu_stopSequence': "Stop Sequence",
    'vgu_tone': "Tone",
    'vgu_questionsPerTone': "Questions per Tone",
    'vgu_toneFirmTitle': "Firm",
    'vgu_toneFirmDescription': "Generate questions with decisive and assertive language that demands clear, definitive answers",
    'vgu_toneConfidentTitle': "Confident",
    'vgu_toneConfidentDescription': "Create questions with strong conviction and certainty that inspire authoritative responses",
    'vgu_tonePoeticTitle': "Poetic",
    'vgu_tonePoeticDescription': "Craft questions with artistic and expressive language that evokes creativity and imagination",
    'vgu_toneNarrativeTitle': "Narrative",
    'vgu_toneNarrativeDescription': "Design questions that encourage storytelling and detailed explanations with context",
    'vgu_toneProfessionalTitle': "Professional",
    'vgu_toneProfessionalDescription': "Generate questions using business-appropriate language suitable for workplace communications",
    'vgu_toneDescriptiveTitle': "Descriptive",
    'vgu_toneDescriptiveDescription': "Create questions that prompt detailed, vivid explanations and comprehensive responses",
    'vgu_toneHumorousTitle': "Humorous",
    'vgu_toneHumorousDescription': "Formulate questions with light-hearted and entertaining elements that engage users playfully",
    'vgu_toneAcademicTitle': "Academic",
    'vgu_toneAcademicDescription': "Develop questions using scholarly language appropriate for educational and research contexts",
    'vgu_tonePersuasiveTitle': "Persuasive",
    'vgu_tonePersuasiveDescription': "Generate questions that encourage influential and convincing responses with strong arguments",
    'vgu_toneFormalTitle': "Formal",
    'vgu_toneFormalDescription': "Create questions using proper, structured language suitable for official communications",
    'vgu_toneInformalTitle': "Informal",
    'vgu_toneInformalDescription': "Formulate questions using casual, conversational language for relaxed interactions",
    'vgu_toneFriendlyTitle': "Friendly",
    'vgu_toneFriendlyDescription': "Design questions with warm, approachable language that creates comfortable dialogue",
    'vgu_promptConfiguration': "Prompt Configuration",
    'vgu_addMorePrompts': "Add more prompts",
    'vgu_promptTemplate': "Prompt template",
    'vgu_copied': "Copied!",
    'vgu_copyPromptTemplate': "Copy prompt template",
    'vgu_back': "Back",
    'vgu_process': "Process",
    'vgu_loadingPleaseWait': "Loading Please Wait...",
    'vgu_required': "Required.",
    'vgu_warning': "Warning",
    'vgu_pleaseFillAllFields': "Please Fill All The Fields!",
    'vgu_invalidRange0To1': "Please enter a number between 0 and 1 with up to 2 decimal places",
    'vgu_invalidRange0To2': "Please enter a number between 0 and 2 with up to 2 decimal places",
        'dash_provider': "Provider",
    'dash_startDate': "Start Date",
    'dash_endDate': "End Date",
    'dash_download': "Download",
    'dash_usdToThbRate': "1 USD = 35 THB",
    'dash_showPrice': "Show Price",
    'dash_totalTokensAll': "Total Tokens (All)",
    'dash_chatNonCached': "Chat: Non-Cached",
    'dash_chatCached': "Chat: Cached",
    'dash_chatCompletion': "Chat: Completion",
    'dash_embeddingInput': "Embedding: Input",
    'dash_feedbackSummary': "Feedback Summary",
    'dash_likeDislike': "Like / Dislike",
    'dash_like': "Like",
    'dash_dislike': "Dislike",
    'dash_total': "Total",
    'dash_loading': "Loading...",
    'dash_pleaseWait': "Please wait",
    'dint_addNewTable': "Add New Table",
    'dint_configureDataIntegrationTable': "Configure your data integration table",
    'dint_internalConfiguration': "Internal Configuration",
    'dint_tableName': "Table Name",
    'dint_tableNameInformation': "Table name information",
    'dint_uploadFile': "Upload File",
    'dint_selectExcelFileToUpload': "Select Excel file (.xlsx) to upload",
    'dint_supportedFormatExcelOnly': "Supported format: Excel (.xlsx) files only",
    'dint_columnConfiguration': "Column Configuration",
    'dint_columnsCount': "{n} columns",
    'dint_fuzzyMatching': "Fuzzy Matching",
    'dint_personalInfoLabel': "Personal Info:",
    'dint_statusOn': "ON",
    'dint_statusOff': "OFF",
    'dint_externalConfiguration': "External Configuration",
    'dint_databaseRequired': "Database*",
    'dint_databaseInformation': "Type of the target database to connect to (SQL Server, Oracle, PostgreSQL) — determines the SQL dialect the system generates",
    'dint_columnNameInformation': "Column name matching the header row in the uploaded Excel file — the system creates the table column with this name and uses it when querying",
    'dint_connectionString': "Connection String",
    'dint_schema': "Schema",
    'dint_view': "View",
    'dint_viewInformation': "Name of the table or view in the target database to read from — used after Schema as [Schema].[this name]",
    'dint_addColumn': "Add Column",
    'dint_addOnlyNeededColumnsHint': "Add only the columns you need (not all columns in the table are required)",
    'dint_column': "Column",
    'dint_testConnection': "Test Connection",
    'dint_getAllColumns': "Get All Columns",
    'dint_saveConfiguration': "Save Configuration",
    'dint_loading': "Loading...",
    'dint_pleaseWait': "Please wait",
    'dint_required': "Required.",
    'dint_fuzzyOptionNone': "None",
    'dint_fuzzyOptionNoneDescription': "No fuzzy matching applied",
    'dint_fuzzyOptionFuzzySearch': "Fuzzy Search",
    'dint_fuzzyOptionFuzzySearchDescription': "Enable approximate text matching for this column",
    'dint_fuzzyOptionFuzzyWithBot': "Fuzzy with Bot",
    'dint_fuzzyOptionFuzzyWithBotDescription': "AI-powered smart matching with enhanced accuracy",
    'dint_system': "System",
    'dint_createBy': "Create by",
    'dint_action': "Action",
    'dint_columnNameNoLeadingTrailingSpaces': "Column name cannot have leading or trailing spaces!",
    'dint_noWorksheetFoundInExcelFile': "No worksheet found in the Excel file",
    'dint_columnDataExceedsCharacterLimit': "The data in column {column}, row {row} exceeds the limit of 800 characters.",
    'dint_pleaseFillInConnectionString': "Please fill in information Connection String!",
    'dint_pleaseFillInSchema': "Please fill in information Schema!",
    'dint_pleaseFillInView': "Please fill in information View!",
    'dint_pleaseFillInAllColumnNames': "Please fill in all column names!",
    'dint_okay': "Okay",
    'dint_pleaseFillAllFields': "Please Fill All The Fields!",
    'dintd_dataIntegrationDetail': "Data Integration Detail",
    'dintd_dataIntegrationName': "Data Integration Name",
    'dintd_configuration': "Configuration",
    'dintd_columnIndex': "Column {n}",
    'dintd_fuzzyMatching': "Fuzzy Matching",
    'dintd_validateColumn': "Validate Column",
    'dintd_personalInfoLabel': "Personal Info:",
    'dintd_on': "ON",
    'dintd_off': "OFF",
    'dintd_addColumn': "Add Column",
    'dintd_addColumnHint': "Add only the columns you need (not all columns in the table are required)",
    'dintd_data': "Data",
    'dintd_search': "Search",
    'dintd_uploadExcel': "Upload Excel",
    'dintd_dataTable': "Data Table",
    'dintd_noDataAvailable': "No data available",
    'dintd_tryDifferentSearch': "Try different search",
    'dintd_itemsPerPage': "Items per page:",
    'dintd_of': "of",
    'dintd_addNewDataSubtitle': "Add new data to your integration",
    'dintd_true': "True",
    'dintd_false': "False",
    'dintd_editDataSubtitle': "Edit existing data record",
    'dintd_loadingPleaseWait': "Loading Please Wait...",
    'dintd_fuzzyNone': "None",
    'dintd_fuzzyNoneDescription': "No fuzzy matching applied",
    'dintd_fuzzySearch': "Fuzzy Search",
    'dintd_fuzzySearchDescription': "Enable approximate text matching for this column",
    'dintd_fuzzyWithBot': "Fuzzy with Bot",
    'dintd_fuzzyWithBotDescription': "AI-powered smart matching with enhanced accuracy",
    'dintd_requiredField': "Required.",
    'dintd_modeAdd': "Add",
    'dintd_modeReplace': "Replace",
    'dintd_pleaseFillAllFields': "Please Fill All The Fields!",
    'dintd_columnDuplicate': "Column Duplicate!",
    'dintd_columnNameRequired': "Column name is required!",
    'dintd_pleaseFillColumnName': "Please fill in the column name.",
    'dintd_okay': "Okay",
    'dintd_columnNameAlreadyExists': "Column name already exists!",
    'dintd_pleaseChooseDifferentColumnName': "Please choose a different column name.",
    'dintd_columnValidationSuccess': "Column validation completed successfully!",
    'dintd_columnValidationFailed': "Column validation failed!",
    'dintd_columnValidationErrorOccurred': "Error occurred during column validation!",
    'dintd_pleaseTryAgainLater': "Please try again later.",
    'gmnm_nodeName': "Node Name",
    'gmnm_prompt': "Prompt",
    'gmnm_charTokenHint': "4 char = 1 token",
    'gmnm_role1': "Role 1",
    'gmnm_content1': "Content 1",
    'gmnm_role2': "Role 2",
    'gmnm_content2': "Content 2",
    'gmnm_role3': "Role 3",
    'gmnm_content3': "Content 3",
    'gmnm_role4': "Role 4",
    'gmnm_content4': "Content 4",
    'gmnm_role5': "Role 5",
    'gmnm_content5': "Content 5",
    'gmnm_loadingPleaseWait': "Loading Please Wait...",
    'gmnm_confirmDeleteData': "Are you sure to delete this data?",
    'gmnm_modelName': "Model name",
    'gum_noGroup': "No Group",
    'gum_viewDetails': "View Details",
    'gum_synced': "Synced",
    'gum_notSynced': "Not Synced",
    'gum_createOrManageGroupSettings': "Create or manage group settings",
    'gum_readyToSave': "Ready to save",
    'gum_basicInformation': "Basic Information",
    'gum_modelConfiguration': "Model Configuration",
    'gum_modelGrouping': "Model Grouping",
    'gum_model': "Model",
    'gum_modelsSelectedCount': "{n} model(s) selected",
    'gum_modelDetailsAndInformation': "Model details and information",
    'gum_noModelsFound': "No models found",
    'gum_noModelDataAvailable': "No model data available to display",
    'gum_view': "View",
    'gum_modelsCount': "{n} models",
    'gum_loading': "Loading...",
    'gum_pleaseWait': "Please wait",
    'gum_templateUser': "Template User",
    'gum_userCsv': "User - CSV",
    'gum_userExcel': "User - Excel",
    'gum_inputIsRequired': "Input is required!",
    'gum_required': "Required.",
    'gum_min10Numbers': "Min 10 numbers",
    'gum_csv': "CSV",
    'gum_excel': "Excel",
    'gum_pleaseFillRequiredFields': "Please fill the required fields!!!",
    'gum_pleaseSelectYourModel': "Please select your model!!!",
    'saevt_startDate': "Start date",
    'saevt_endDate': "End date",
    'saevt_apiName': "API Name",
    'saevt_searchApiNamePlaceholder': "Search API name...",
    'saevt_createBy': "Create By",
    'saevt_searchCreateByPlaceholder': "Search create by...",
    'saevt_actionCreate': "Create",
    'saevt_actionDelete': "Delete",
    'saevt_actionUpdate': "Update",
    'saevt_statusCodeOk': "OK",
    'saevt_statusCodeBadRequest': "Bad request",
    'saevt_statusCodeInternalServerError': "Internal server error",
    'saevt_statusApiSuccessful': "Successful",
    'saevt_statusApiError': "Error",
    'saevt_statusApiSystemError': "System error",
    'saevt_statusApiDuplicate': "Duplicate",
    'saevt_statusApiLess': "Less",
    'saevt_statusApiException': "Exception",
    'saevt_colNo': "No.",
    'saevt_colApiName': "API Name",
    'saevt_colAction': "Action",
    'saevt_colStatusCode': "Status Code",
    'saevt_colIpAddress': "IP Address",
    'saevt_colStatusApi': "Status API",
    'saevt_colMessage': "Message",
    'saevt_colCreateBy': "Create By",
    'saevt_colCreateDate': "Create Date",
    'sampkg_superAdmin': "Super Admin",
    'sampkg_masterPackage': "Master Package",
    'sampkg_search': "Search",
    'sampkg_searchPlaceholder': "Company name, Package",
    'sampkg_addMasterPackage': "Add Master Package",
    'sampkg_loading': "Loading...",
    'sampkg_statusActive': "Active",
    'sampkg_statusInactive': "Inactive",
    'sampkg_colNo': "No.",
    'sampkg_colCompany': "Company",
    'sampkg_colPackage': "Package",
    'sampkg_colStartDate': "Start Date",
    'sampkg_colEndDate': "End Date",
    'sampkg_colStatus': "Status",
    'sampkg_colActions': "Actions",
    'sampkg_companyRequired': "Company*",
    'sampkg_packageRequired': "Package*",
    'sampkg_startDate': "Start Date",
    'sampkg_endDate': "End Date",
    'sampkg_status': "Status",
    'sampkg_required': "Required.",
    'sampkg_mockModeTitle': "Mock mode",
    'sampkg_mockModeText': "Not yet connected to backend",
    'scmenu_pageTitle': "Shortcut menu",
    'scmenu_loading': "Loading...",
    'scmenu_pleaseWait': "Please wait",
    'scmenu_editDialogTitle': "Edit Shortcut Menu",
    'scmenu_editDialogSubtitle': "Modify shortcut menu configuration",
    'scmenu_basicInformation': "Basic Information",
    'scmenu_groupNameLabel': "Shortcut Commands Group Name",
    'scmenu_enterGroupNamePlaceholder': "Enter group name...",
    'scmenu_commandSingular': "command",
    'scmenu_commandPlural': "commands",
    'scmenu_actions': "Actions",
    'scmenu_quickReplyNamePlaceholder': "Quick reply name",
    'scmenu_quickReplyDataPlaceholder': "Quick reply data",
    'scmenu_quickReplyDataSentHint': "Quick reply data that will be sent",
    'scmenu_previewAlt': "Preview",
    'scmenu_remove': "Remove",
    'scmenu_configureShortcutCommandsHint': "Configure shortcut commands with labels, messages, and custom icons",
    'scmenu_commandsConfigured': "{n} command{plural} configured",
    'scmenu_addDialogTitle': "Add Shortcut Menu",
    'scmenu_addDialogSubtitle': "Create a new shortcut menu",
    'scmenu_shortcutMenuNameTooltip': "Shortcut Menu Name",
    'scmenu_shortcutCommandsNamePlaceholder': "Shortcut commands name",
    'scmenu_shortcutCommandsDataPlaceholder': "Shortcut Commands data",
    'scmenu_shortcutCommandsDataSentHint': "Shortcut Commands data that will be sent",
    'scmenu_required': "Required.",
    'scmenu_duplicatedModelsError': "The group must not have any duplicated models.",
    'scmenu_fillRequiredFields': "Please fill the required fields!!!",
    'scmenu_errorOccurred': "An error occurred!",
    'scmenu_somethingWentWrong': "Something went wrong!",
    'scmenu_onlyJpegPngAllowed': "Only jpeg or png files are supported",
    'ugd_syncUsers': "Sync Users",
    'ugd_syncing': "Syncing...",
    'ugd_setupUserGroup': "Setup User Group",
    'ugd_search': "Search",
    'ugd_changePassword': "Change Password",
    'ugd_createNewSecurePassword': "Create a new secure password for your account",
    'ugd_basicInformation': "Basic Information",
    'ugd_integrationSocial': "Integration Social",
    'ugd_modelConfiguration': "Model Configuration",
    'ugd_modelGrouping': "Model Grouping",
    'ugd_model': "Model",
    'ugd_modelShortcut': "Model Shortcut",
    'ugd_loading': "Loading...",
    'ugd_pleaseWait': "Please wait",
    'ugd_passwordRequirements': "Password Requirements",
    'ugd_newPassword': "New Password",
    'ugd_confirmPasswordLabel': "Confirm Password",
    'ugd_securityTips': "Security Tips:",
    'ugd_tipUseCombination': "Use a combination of letters, numbers, and symbols",
    'ugd_tipAvoidPersonalInfo': "Avoid using personal information in passwords",
    'ugd_tipDontReuse': "Don't reuse passwords from other accounts",
    'ugd_tipUsePasswordManager': "Consider using a password manager",
    'ugd_required': "Required.",
    'ugd_min10Numbers': "Min 10 numbers",
    'ugd_close': "Close",
    'ugd_invalidPhoneFormat': "Invalid Phone format",
    'ugd_invalidEmail': "invalid email",
    'ugd_pleaseFillCorrectFormat': "please fill correct format!",
    'ugd_pleaseFillAllFields': "please fill all fields!!!",
    'usd_pageTitle': "Upload Sound To Document",
    'usd_documentNameLabel': "Document name",
    'usd_editTooltip': "Edit",
    'usd_importToKnowledgeBaseTooltip': "Import to Knowledge Base",
    'usd_deleteTooltip': "Delete",
    'usd_uploadSpeechFilesTitle': "Upload Speech Files",
    'usd_uploadSpeechFilesSubtitle': "Upload and process audio files for transcription",
    'usd_documentNameRequiredLabel': "Document Name *",
    'usd_documentNamePlaceholder': "Enter a descriptive name for your document",
    'usd_languageLabel': "Language",
    'usd_aiModelForSummationLabel': "AI Model (for summation)",
    'usd_selectAiModelPlaceholder': "Select AI model for text summation",
    'usd_requiredRule': "Required.",
    'usd_botSummationLabel': "Bot Summation",
    'usd_uploadAudioFilesTitle': "Upload Audio Files",
    'usd_supportedFormatsHint': "Supported formats: MP3, WAV, M4A, FLAC (Max size: 100MB per file)",
    'usd_filesSelectedCount': "{n} file(s) selected",
    'usd_cancelButton': "Cancel",
    'usd_uploadFilesButton': "Upload Files",
    'usd_importToKnowledgeDocumentTitle': "Import To Knowledge Document",
    'usd_importToKnowledgeBaseSubtitle': "Import processed content to knowledge base",
    'usd_selectDocumentRequiredLabel': "Select Document *",
    'usd_chooseKnowledgeDocumentPlaceholder': "Choose a knowledge document",
    'usd_maxSplitCharactersRequiredLabel': "Max Split Characters *",
    'usd_importInformationLabel': "Import Information:",
    'usd_documentLabel': "Document:",
    'usd_importInformationDescription': "This will process and split the content for knowledge base integration.",
    'usd_importButton': "Import",
    'usd_loadingTitle': "Loading...",
    'usd_pleaseWaitSubtitle': "Please wait",
    'usd_pleaseFillAllFields': "Please Fill All The Fields!",
    'usd_headerNo': "No.",
    'usd_headerDocument': "Document",
    'usd_headerCreateBy': "Create by",
    'usd_headerProcess': "Process",
    'usd_headerAction': "Action",
    'vpd_uploadPositiveQuestionSet': "Upload Positive Question Set",
    'vpd_questionSetName': "Question Set Name",
    'vpd_template': "Template",
    'vpd_normalQuestion': "Normal Question",
    'vpd_chainQuestion': "Chain Question",
    'vpd_process': "PROCESS",
    'vpd_back': "BACK",
    'vpd_loading': "Loading...",
    'vpd_pleaseWait': "Please wait",
    'vpd_addQuestionSet': "Add Question Set",
    'vpd_createNewQuestionAnswerPair': "Create a new question and answer pair",
    'vpd_question': "Question",
    'vpd_enterYourQuestionHere': "Enter your question here...",
    'vpd_humanAnswer': "Human Answer",
    'vpd_enterExpectedAnswerHere': "Enter the expected answer here...",
    'vpd_questionType': "Question Type",
    'vpd_selectQuestionTypeHint': "Select the type of question: Normal or Chain",
    'vpd_editQuestionSet': "Edit Question Set",
    'vpd_modifyExistingQuestionAnswerPair': "Modify the existing question and answer pair",
    'vpd_required': "Required.",
    'vpd_pleaseFillAllFields': "Please Fill All The Fields!",
    'vpd_invalidFileFormat': "Invalid file format!",
    'vpd_ensureFileCorrectFormat': "Please ensure the file is in the correct format.",
    'vpd_pleaseSpecifyQuestionType': "Please specify your question type.",
    'vpd_type': "Type",
    'vproc_refresh': "Refresh",
    'vproc_testName': "Test Name",
    'vproc_reprocess': "Reprocess",
    'vproc_viewScoreDashboard': "View Score Dashboard",
    'vproc_completeProcessToViewScores': "Complete process to view scores",
    'vproc_editValidationProcess': "Edit Validation Process",
    'vproc_uploadQuestionSet': "Upload Question Set",
    'vproc_modifyExistingValidationConfig': "Modify the existing validation configuration",
    'vproc_createNewValidationTestConfig': "Create a new validation test configuration",
    'vproc_testNameRequired': "Test Name*",
    'vproc_modelName': "Model Name",
    'vproc_questionType': "Question Type",
    'vproc_positive': "Positive",
    'vproc_positiveValidationQuestions': "Positive validation questions",
    'vproc_negative': "Negative",
    'vproc_negativeValidationQuestions': "Negative validation questions",
    'vproc_processingType': "Processing Type",
    'vproc_chain': "Chain",
    'vproc_chainProcessingMode': "Chain processing mode",
    'vproc_questionSetName': "Question Set Name",
    'vproc_chainQuestion': "Chain Question",
    'vproc_questionPositiveName': "Question positive name",
    'vproc_questionsNegativeName': "Questions negative Name",
    'vproc_uploadFile': "Upload File",
    'vproc_template': "Template",
    'vproc_sizeBytes': "{size} bytes",
    'vproc_prompt': "Prompt",
    'vproc_scoreModel': "Score Model",
    'vproc_pleaseSelectScoreModel': "Please select a score model.",
    'vproc_scoreModelEmpty': "No score-capable model is available in your organization's LLM group. Please contact your administrator.",
    'vproc_scoreModelLoadFailed': "Could not load the score model list. Please try again.",
    'vproc_scoreModelNotAvailable': "The selected score model is no longer available. Please choose another one.",
    'vproc_scoreModelLoading': "Loading model list…",
    'vproc_scoreModelMissingOption': "The saved model was removed or disabled (ID {id})",
    'vproc_scoreModelUnnamed': "(unnamed model) ID {id}",
    'vproc_scoreModelRetry': "Reload the model list",
    'vproc_loading': "Loading...",
    'vproc_pleaseWait': "Please wait",
    'vproc_requiredField': "Required.",
    'vproc_process': "Process",
    'vproc_status': "Status",
    'vproc_createBy': "Create by",
    'vproc_dataProcessed': "Data Processed",
    'vproc_action': "Action",
    'vproc_result': "Result",
    'vproc_pleaseFillAllFields': "Please Fill All The Fields!",
    'vproc_pleaseEnterCorrectFormat': "Please Enter Correct Format!",
    'vproc_confirmDeletionText': "Do you want to confirm deletion of this validation",
    'vproc_somethingWentWrong': "Something went wrong",
        'csvc_chatTitle': "Chat",
    'csvc_filterOptions': "Filter Options",
    'csvc_contactStatus': "Contact Status",
    'csvc_all': "All",
    'csvc_contactAgent': "Contact Agent",
    'csvc_contactBot': "Contact Bot",
    'csvc_reset': "Reset",
    'csvc_apply': "Apply",
    'csvc_noDataAvailable': "No data available",
    'csvc_admin': "Admin",
    'csvc_bot': "Bot",
    'csvc_toggleUserList': "Toggle user list",
    'csvc_userNotSelected': "User not selected",
    'csvc_typeYourMessage': "Type your message...",
    'gmnd_update': "Update",
    'gmnd_create': "Create",
    'gmnd_gptModelInternal': "GPT Model Internal",
    'gmnd_nodeName': "Node name",
    'gmnd_prompt': "Prompt",
    'gmnd_charTokenHint': "4 char = 1 token",
    'gmnd_example1': "Example 1",
    'gmnd_role1': "Role 1",
    'gmnd_content1': "Content 1",
    'gmnd_example2': "Example 2",
    'gmnd_role2': "Role 2",
    'gmnd_content2': "Content 2",
    'gmnd_example3': "Example 3",
    'gmnd_role3': "Role 3",
    'gmnd_content3': "Content 3",
    'gmnd_example4': "Example 4",
    'gmnd_role4': "Role 4",
    'gmnd_content4': "Content 4",
    'gmnd_example5': "Example 5",
    'gmnd_role5': "Role 5",
    'gmnd_content5': "Content 5",
    'gmnd_back': "Back",
    'gmnd_save': "Save",
    'gmnd_loadingPleaseWait': "Loading Please Wait...",
    'lae_apiExternalLog': "API External Log",
    'lae_apiEndpointPlaceholder': "API Endpoint",
    'lae_search': "Search",
    'lae_export': "Export",
    'lae_filterTooltip': "Filter",
    'lae_apiExternalLogRecords': "Api External Log ({count} records)",
    'lae_notAvailable': "-",
    'lae_noDataAvailable': "No data available",
    'lae_noApiLogsFound': "No API logs found matching your criteria",
    'lae_filterOptions': "Filter Options",
    'lae_transactionId': "Transaction ID",
    'lae_method': "Method",
    'lae_statusCode': "Status Code",
    'lae_createBy': "Create By",
    'lae_startDate': "Start Date",
    'lae_selectStartDateHint': "Select start date for filtering",
    'lae_endDate': "End Date",
    'lae_selectEndDateHint': "Select end date for filtering",
    'lae_clearAll': "Clear All",
    'lae_applyFilter': "Apply Filter",
    'lae_apiExternalDetail': "API External Detail",
    'lae_transactionIdLabel': "Transaction ID:",
    'lae_apiEndpointLabel': "API Endpoint:",
    'lae_methodLabel': "Method:",
    'lae_statusCodeLabel': "Status Code:",
    'lae_createByLabel': "Create By :",
    'lae_createDateLabel': "Create Date :",
    'lae_requestBody': "Request Body",
    'lae_jsonResponse': "JSON Response",
    'lae_close': "Close",
    'lae_loading': "Loading...",
    'lae_pleaseWait': "Please wait",
    'lae_no': "no",
    'lae_apiEndpoint': "Api EndPoint",
    'lae_createDate': "Create date",
    'lae_details': "Details",
    'mmgt_all': "All",
    'mmgt_menuNameRequired': "Menu Name*",
    'mmgt_userGroupRequired': "User Group*",
    'mmgt_requiredFieldIndicator': "*indicates required field",
    'mmgt_pleaseEnterMenuName': "Please enter Menu Name!!!",
    'mmgt_noChosenGroup': "This menu had no chosen group",
    'mmgt_pleaseSelectAllFields': "Please select all fields!!",
    'mmgt_pleaseFillAllFields': "Please fill all fields!!!",
    'mmgt_pleaseFillAllFieldsAlt': "Please fill all fields!!",
    'ptmpl_pageTitle': "Prompt Template Detail",
    'ptmpl_addTemplate': "Add Template",
    'ptmpl_textGroupName': "Text Group Name",
    'ptmpl_statusOn': "ON",
    'ptmpl_statusOff': "OFF",
    'ptmpl_createSubtitle': "Create a new prompt template",
    'ptmpl_templateName': "Template Name",
    'ptmpl_templateNamePlaceholder': "Enter template name...",
    'ptmpl_active': "Active",
    'ptmpl_inactive': "Inactive",
    'ptmpl_promptTemplateLabel': "Prompt Template",
    'ptmpl_promptTemplatePlaceholder': "Enter your prompt template here...",
    'ptmpl_editSubtitle': "Modify the existing prompt template",
    'ptmpl_loading': "Loading...",
    'ptmpl_pleaseWait': "Please wait",
    'ptmpl_requiredField': "Required.",
    'ptmpl_promptColumnHeader': "Prompt",
    'ptmpl_statusColumnHeader': "Status",
    'ptmpl_pleaseEnterTextGroupName': "Please enter Text Group Name",
    'rfb_download': "Download",
    'rfb_feedbackReportManagement': "Feedback Report Management",
    'rfb_dateRange': "Date Range",
    'rfb_startDate': "Start Date",
    'rfb_endDate': "End Date",
    'rfb_actions': "Actions",
    'rfb_search': "SEARCH",
    'rfb_feedbackAnalytics': "Feedback Analytics",
    'rfb_likeDislikeDistribution': "Like/Dislike Distribution",
    'rfb_feedbackByModel': "Feedback by Model",
    'rfb_loading': "Loading...",
    'rfb_pleaseWait': "Please wait",
    'rfb_like': "Like",
    'rfb_dislike': "Dislike",
    'rfb_fillStartEndDate': "Please fill Start Date and End Date!",
    'rfb_fillRequiredFields': "Please fill the required fields!!!",
    'sasub_email': "E-mail",
    'sasub_phone': "Phone",
    'sasub_subscriptionPeriod': "Subscription Period",
    'sasub_statusCancelled': "CANCELLED",
    'sasub_statusExpired': "EXPIRED",
    'sasub_statusExpireSoon': "EXPIRE SOON",
    'sasub_createDate': "Create Date",
    'sasub_textTokenUsage': "Text token usage",
    'sasub_imageGenerationUsage': "Image generation usage ($)",
    'sasub_itemsPerPage': "Items per page",
    'sasub_subscription': "Subscription",
    'sasub_companyName': "Company Name",
    'sasub_packageName': "Package Name",
    'sasub_startDate': "Start Date",
    'sasub_expirationDate': "Expiration Date",
    'sasub_expirationDateOptionalHint': "Optional — leave empty for no expiry (∞)",
    'sasub_priceBaht': "Price (Baht)",
    'sasub_tokenLimit': "Token Limit",
    'sasub_unlimitedToken': "Unlimited token",
    'sasub_resetToken': "Reset Token",
    'sasub_imageGenerationCreditLimit': "Image Generation Credit Limit",
    'sasub_unlimitedImageCredit': "Unlimited image credit",
    'sasub_resetImageCreditUsed': "Reset Image Credit Used",
    'sasub_imageCreditUsageKeptNote': "Note: The image credit usage will be kept as is.",
    'sasub_errorOccurred': "An error occurred",
    'sasub_renewConfirmText': "Renew the subscription for \"{companyName}\"?",
    'sasub_cancelConfirmText': "Cancel the subscription for \"{companyName}\"?",
    'sasub_testNotiConfirmTitle': "Send Test Notification",
    'sasub_testNotiConfirmText': "Send a test notification for \"{companyName}\" now? (sends a real email to admins)",
    'sasub_testNotiSent': "Test notification sent",
    'saumgt_export': "Export",
    'saumgt_searchPlaceholder': "Search username, name, e-mail...",
    'saumgt_admin': "Admin",
    'saumgt_username': "Username",
    'saumgt_password': "Password",
    'saumgt_firstName': "First Name",
    'saumgt_lastName': "Last Name",
    'saumgt_email': "E-mail",
    'saumgt_mobile': "Mobile",
    'saumgt_headerNo': "No",
    'saumgt_fullName': "Full Name",
    'saumgt_role': "Role",
    'saumgt_actions': "Actions",
    'sgm_modelGroup': "Model Group",
    'sgm_viewDetails': "View Details",
    'sgm_loading': "Loading...",
    'sgm_pleaseWait': "Please wait",
    'sgm_editModelGroup': "Edit Model Group",
    'sgm_modifyModelGroupConfig': "Modify model group configuration",
    'sgm_basicInformation': "Basic Information",
    'sgm_enterGroupNamePlaceholder': "Enter group name...",
    'sgm_modelConfiguration': "Model Configuration",
    'sgm_allModel': "All Model",
    'sgm_selectModelsPlaceholder': "Select models...",
    'sgm_allModelsIncludedInfo': "All available models will be included in this group",
    'sgm_allModelsIncluded': "All models included",
    'sgm_modelsSelectedCount': "{n} models selected",
    'sgm_addModelGroup': "Add Model Group",
    'sgm_createNewModelGroupConfig': "Create a new model group configuration",
    'sgm_modelGroupName': "Model Group Name",
    'sgm_modelName': "Model Name",
    'sgm_modelDetailsAndInfo': "Model details and information",
    'sgm_noModelsFound': "No models found",
    'sgm_noModelDataAvailable': "No model data available to display",
    'sgm_view': "View",
    'sgm_modelsCount': "{n} models",
    'sgm_requiredField': "Required.",
    'sug_formSubtitle': "Configure group settings and model access",
    'sug_basicInformation': "Basic Information",
    'sug_enterGroupNamePlaceholder': "Enter group name",
    'sug_groupNameRequired': "Group name is required",
    'sug_groupNameHint': "Enter a descriptive name for this user group",
    'sug_enterObjectIdPlaceholder': "Enter object ID (optional)",
    'sug_groupObjectIdHint': "Azure AD Object ID for integration (optional)",
    'sug_modelConfiguration': "Model Configuration",
    'sug_modelGrouping': "Model Grouping",
    'sug_selectModelGroupingPlaceholder': "Select model grouping",
    'sug_modelGroupingRequired': "Model grouping is required",
    'sug_modelGroupingHint': "Select the model grouping category for this user group",
    'sug_availableModels': "Available Models",
    'sug_selectModelsPlaceholder': "Select models",
    'sug_atLeastOneModelRequired': "At least one model is required",
    'sug_availableModelsHint': "Select which AI models this group can access",
    'sug_add': "Add",
    'sug_loadingPleaseWait': "Loading Please Wait...",
    'sug_name': "Name",
    'sug_pleaseSelectUserToAdd': "Please select a user to add to the group.",
    'sug_pleaseFillRequiredFields': "Please fill the required fields!!!",
    'sug_pleaseSelectYourModel': "Please select your model!!!",
    'sug_close': "Close",
        'bcum_noBlacklistedUsersFoundTitle': "No Blacklisted Users Found",
    'bcum_noBlacklistedUsersFoundSubtitle': "There are currently no users in the blacklist. Add users to manage chat restrictions.",
    'bcum_addToBlacklistTitle': "Add to Blacklist",
    'bcum_addToBlacklistSubtitle': "Select users to add to the blacklist",
    'bcum_selectLineUsers': "Select Line Users",
    'bcum_searchAndSelectUsers': "Search and select users",
    'bcum_typeToSearchUsers': "Type to search users...",
    'bcum_pleaseSelectAtLeastOneUser': "Please select at least one user",
    'bcum_noUsersFound': "No users found",
    'bcum_selectedUsersRestrictedNotice': "Selected users will be restricted from chat functionality",
    'bcum_loading': "Loading...",
    'bcum_pleaseWait': "Please wait",
    'bcum_pleaseFillAllFields': "Please fill all the fields!!!",
    'cfgconsent_configurationPanel': "Configuration Panel",
    'cfgconsent_currentVersion': "Current Version",
    'cfgconsent_notAvailable': "N/A",
    'cfgconsent_viewPreviousVersion': "View Previous Version",
    'cfgconsent_selectVersionToPreview': "Select version to preview",
    'cfgconsent_savingChanges': "Saving changes...",
    'cfgconsent_consentThLabel': "Consent(TH)",
    'cfgconsent_consentEnLabel': "Consent(EN)",
    'cfgt_login': "Login",
    'cfgt_logo': "Logo",
    'cfgt_chatPanel': "Chat panel",
    'cfgt_chatbotName': "Chatbot name",
    'cfgt_you': "You",
    'cfgt_header': "Header",
    'cfgt_versionPlaceholder': "Version R1.xx.x",
    'cfgt_username': "Username",
    'cfgt_buttonColor': "Button color",
    'cfgt_textColor': "Text color",
    'cfgt_loadingPleaseWait': "Loading Please Wait...",
    'cfgt_more': "More",
    'cfgt_previewMsgHi': "Hi",
    'cfgt_previewMsgHello': "Hello",
    'cfgt_previewMsgFoo': "FOO",
    'cfgt_previewMsgBar': "BAR",
    'cfgt_fileSizeExceeded': "File size exceeds {limitFile} MB",
    'cfgt_imageDimensionExceeded': "Image dimensions must not exceed {maxWidth}x{maxHeight} pixels",
    'dscore_reprocess': "REPROCESS",
    'dscore_validationProcess': "Validation process",
    'dscore_selectValidationProcessHint': "Select validation process to view dashboard score",
    'dscore_modelNameLabel': "Model Name : {name}",
    'dscore_versioningLabel': "Versioning : {version}",
    'dscore_scoreModelNameLabel': "Score Model : {name} ({provider})",
    'dscore_scoreModelLegacy': "Score Model : same as the answering model (legacy run)",
    'dscore_scoreModelMissing': "Score Model : removed or disabled (ID {id})",
    'dscore_scoreModelDisabled': "Score Model : {name} ({provider}) — disabled",
    'dscore_processingDateLabel': "Processing Date :  {date}",
    'dscore_modelName': "Model Name",
    'dscore_prompt': "Prompt",
    'dscore_close': "Close",
    'dscore_save': "Save",
    'dscore_loadingPleaseWait': "Loading Please Wait...",
    'dscore_chatWorkFlow': "Chat work flow",
    'dscore_required': "Required",
    'dscore_pleaseSelectModel': "Please select a model.",
    'dscore_pleaseEnterPrompt': "Please enter the prompt.",
    'dscore_reprocessTitle': "Reprocess",
    'dscore_infoModelName': "Select the model to use for reprocessing",
    'dscore_scoreModel': "Score Model",
    'dscore_pleaseSelectScoreModel': "Please select a score model.",
    'dscore_infoScoreModel': "Select the base model that will grade the answers in this re-run",
    'fmgt_startDate': "Start Date",
    'fmgt_endDate': "End Date",
    'fmgt_fileNamePlaceholder': "File Name",
    'fmgt_deleteAll': "Delete all",
    'fmgt_infoForDeleteAllFile': "Delete all files",
    'fmgt_view': "View",
    'fmgt_delete': "Delete",
    'fmgt_confirmDeleteConfirmation': "Delete confirmation",
    'fmgt_deleteAllConfirmPrefix': "This action will delete ",
    'fmgt_deleteAllConfirmSuffix': " items.",
    'fmgt_deleteAllTypeToConfirm': "Please fill \"delete\" or \"Delete\" if you want to delete all files.",
    'fmgt_viewDetail': "View detail",
    'fmgt_fileName': "File name",
    'fmgt_fileType': "File type",
    'fmgt_sizeKB': "Size (KB)",
    'fmgt_fileUrl': "File url",
    'fmgt_container': "Container",
    'fmgt_fileImageAlt': "File Image",
    'fmgt_noImageAvailable': "No Image Available",
    'fmgt_close': "Close",
    'fmgt_loadingPleaseWait': "Loading Please Wait...",
    'fmgt_headerNo': "No",
    'fmgt_headerFileName': "File Name",
    'fmgt_headerCreateDate': "Create date",
    'fmgt_headerCreateBy': "Create by",
    'fmgt_headerAction': "Action",
    'fmgt_requiredField': "Required.",
    'isess_pageTitle': "Intent Session",
    'isess_intentGroupName': "Intent Group Name",
    'isess_intentSessionNamePlaceholder': "Intent Session Name",
    'isess_search': "Search",
    'isess_loadingTitle': "Loading...",
    'isess_loadingSubtitle': "Please wait",
    'isess_ruleRequired': "Required.",
    'isess_intentSessionNameHeader': "Intent Session Name",
    'isess_createByHeader': "Create By",
    'isess_warningFillIntentGroupNameCorrectly': "Please fill in your Intent Group Name correctly",
    'mvm_modelName': "Model Name",
    'mvm_vectorDBName': "Vector DB Name",
    'mvm_loadingPleaseWait': "Loading, please wait",
    'mvm_requiredField': "This field is required",
    'mvm_pleaseFillAllFields': "Please fill in all fields",
    'mvm_noConnectedModels': "No connected models",
    'mvm_confirmDeleteData': "Are you sure you want to delete this data?",
    'mvm_webSearchDomains': "Web Search Domains",
    'mvm_webSearchNotSupported': "The selected model does not support Web Search (Azure text models only) — settings will be saved but take no effect until a supported model is used.",
    'mvm_webSearchInvalidDomain': "Invalid domain format (e.g. dga.or.th — no https:// or path)",
    'mvm_webSearchMaxDomains': "Maximum 20 domains",
    'mvm_webSearchColumn': "Web Search",
    'mvm_webSearchOn': "On ({n})",
    'mvm_webSearchLoadFailed': "Failed to load Web Search Domains — this field is temporarily locked and existing settings will not be changed (close and reopen this dialog to retry)",
    'mvm_webSearchSaveFailed': "Model–Vector mapping saved, but saving Web Search Domains failed — press Save again to retry",
    'rqt_process': "PROCESS",
    'rqt_refresh': "Refresh",
    'rqt_questionReportManagement': "Question Report Management",
    'rqt_dateRange': "Date Range",
    'rqt_startDate': "Start Date",
    'rqt_selectStartDateForReport': "Select start date for report",
    'rqt_endDate': "End Date",
    'rqt_selectEndDateForReport': "Select end date for report",
    'rqt_processingStatus': "Processing Status",
    'rqt_promptTemplate': "Prompt Template",
    'rqt_enterYourPromptTemplateForQuestionGeneration': "Enter your prompt template for question generation",
    'rqt_questionReportDataRecords': "Question Report Data ({count} records)",
    'rqt_loadingPleaseWait': "Loading Please Wait...",
    'rqt_questionCategory': "Question Category",
    'rqt_total': "Total",
    'rqt_pleaseEnterNoMoreThanCharacters': "Please enter no more than {n} characters",
    'rqt_pleaseFillTheRequiredFields': "Please fill the required fields!!!",
    'rtext_addTextGroup': "Add Text Group",
    'rtext_uploadCsv': "Upload CSV",
    'rtext_textGroupName': "Text Group Name",
    'rtext_template': "Template",
    'rtext_loadingPleaseWait': "Loading Please Wait...",
    'rtext_modifyTheReplacementText': "Modify the replacement text",
    'rtext_addNewReplacementText': "Add new replacement text",
    'rtext_originalText': "Original Text",
    'rtext_replacementText': "Replacement Text",
    'rtext_action': "Action",
    'rtext_required': "Required",
    'rtext_pleaseFillTextGroupNameFields': "Please Fill Text Group Name Fields!",
    'rtext_groupNameIsDuplicate': "Group name is duplicate",
    'rtext_pleaseFillTextGroupName': "Please Fill Text Group Name!",
    'rtext_formatExcelCsvIncorrect': "Format Excel/CSV incorrect",
    'saconsent_audience': "Audience",
    'saconsent_currentVersion': "Current Version",
    'saconsent_notAvailable': "N/A",
    'saconsent_viewVersion': "View Version",
    'saconsent_termsConditionsTH': "Terms and Conditions (TH)",
    'saconsent_termsConditionsEN': "Terms and Conditions (EN)",
    'saconsent_privacyNoticeTH': "Privacy Notice (TH)",
    'saconsent_privacyNoticeEN': "Privacy Notice (EN)",
    'saconsent_consentRequired': "Consent is Required",
    'saconsent_ok': "OK",
    'saconsent_fillBothRequired': "Please fill in both Consent (TH) and Consent (EN)",
    'saconsent_fillThRequired': "Please fill in Consent (TH)",
    'saconsent_fillEnRequired': "Please fill in Consent (EN)",
    'sallm_textBased': "Text-Based",
    'sallm_textToImage': "Text-to-Image",
    'sallm_jsonConfiguration': "JSON Configuration",
    'sallm_systemPromptFormat': "System Prompt Format (OpenAI o1+)",
    'sallm_roleNote': "Specifies system role for better context",
    'sallm_maxCompletionTokensNote': "Maximum response length",
    'sallm_streamNote': "Enable streaming responses",
    'sallm_addValue': "Add Value",
    'sallm_loadingFallback': "Loading...",
    'sallm_pleaseWaitFallback': "Please wait",
    'sallm_ruleRequired': "Required.",
    'sallm_ruleMustBeNumber': "Must be a number.",
    'sallm_qualityHD': "HD",
    'sallm_qualityStandard': "Standard",
    'sallm_no': "No.",
    'sapkg_searchPlaceholder': "Search package name...",
    'sapkg_unlimited': "Unlimited",
    'sapkg_packageNameLabel': "Package Name *",
    'sapkg_detailLabel': "Detail",
    'sapkg_limitTokenLabel': "Limit Token",
    'sapkg_limitTokenPlaceholder': "Leave blank = unlimited",
    'sapkg_headerNo': "No",
    'sapkg_headerPackageName': "Package Name",
    'sapkg_headerDetail': "Detail",
    'sapkg_headerLimitToken': "Limit Token",
    'sapkg_headerActions': "Actions",
    'sapkg_fillRequiredFields': "Please fill in all required fields",
    'sapkg_genericError': "An error occurred",
    'sapkg_confirmDeleteText': "Delete package \"{name}\"?",
    'ugrp_loadingPleaseWait': "Loading, please wait...",
    'ugrp_pleaseEnterGroupName': "Please enter a group name.",
    'ugrp_confirmDeleteData': "Are you sure you want to delete this data?",
    'ugrp_groupNameAlreadyExists': "This group name already exists.",
    'ugrp_pleaseFillAllFields': "Please fill in all required fields.",
    'uprof_fusionFusion': "Fusion Fusion",
    'uprof_required': "Required",
    'uprof_changePassword': "Change Password",
    'uprof_loadingPleaseWait': "Loading, please wait...",
    'uprof_pleaseEnterCorrectPhoneNumber': "Please enter a correct phone number",
    'uprof_pleaseEnterCorrectEmail': "Please enter a correct email",
    'uprof_pleaseEnterCorrectFormat': "Please enter the correct format!",
    'uprof_pleaseFillAllTheFields': "Please fill in all the fields!",
    'uprof_pleaseFillPassword': "Please fill in the password!",
    'uprof_pleaseFillConfirmPassword': "Please fill in the confirm password!",
    'uprof_pleaseFillPasswordAndConfirmPassword': "Please fill in the password and confirm password",
    'uprof_pleaseFillCorrectFormat': "Please fill in the correct format!",
    'uprof_passwordConfirmMismatch': "Password and Confirm Password do not match. Please fill in correctly.",
    'uprof_pleaseFillAllTheFieldsExclaim': "Please fill in all the fields!!!",
    'vgen_refresh': "Refresh",
    'vgen_questionSet': "Question Set",
    'vgen_reprocess': "Reprocess",
    'vgen_loadingText': "Loading...",
    'vgen_pleaseWait': "Please wait",
    'vgen_process': "Process",
    'vgen_status': "Status",
    'vgen_createBy': "Create by",
    'vgen_action': "Action",
    'vgen_pleaseEnterCorrectFormat': "Please Enter Correct Format!",
    'vnd_questionSetName': "Question Set Name",
    'vnd_template': "Template",
    'vnd_upload': "Upload",
    'vnd_process': "PROCESS",
    'vnd_back': "BACK",
    'vnd_loading': "Loading...",
    'vnd_pleaseWait': "Please wait",
    'vnd_required': "Required.",
    'vnd_zeroBytes': "0 Bytes",
    'vnd_unitBytes': "Bytes",
    'vnd_unitKB': "KB",
    'vnd_unitMB': "MB",
    'vnd_unitGB': "GB",
    'vnd_pleaseFillAllFields': "Please Fill All The Fields!",
    'vnd_question': "Question",
    'consentpg_pageTitle': "Terms and Conditions of Service",
    'consentpg_pageSubtitle': "Privacy Policy & Consent",
    'consentpg_versionLabel': "Version {version}",
    'consentpg_versionNotAvailable': "N/A",
    'consentpg_languageThai': "Thai",
    'consentpg_languageEnglish': "English",
    'consentpg_noContentAvailable': "No consent content available.",
    'flowpg_back': "Back",
    'flowpg_undo': "Undo",
    'flowpg_unknown': "Unknown",
    'flowpg_none': "None",
    'flowpg_redo': "Redo",
    'flowpg_flowName': "Flow Name",
    'flowpg_chatAiModelConfiguration': "Chat AI Model Configuration",
    'flowpg_flowAiModel': "Flow AI Model",
    'flowpg_aiModelConfiguration': "AI Model Configuration",
    'flowpg_basicInformation': "Basic Information",
    'flowpg_providerModelAndBasicSettings': "Provider, model, and basic settings",
    'flowpg_serviceConfiguration': "Service Configuration",
    'flowpg_providerRequired': "Provider*",
    'flowpg_selectAiServiceProvider': "Select AI service provider",
    'flowpg_modelRequired': "Model*",
    'flowpg_selectSpecificModelVersion': "Select specific model version",
    'flowpg_behaviorSettings': "Behavior Settings",
    'flowpg_male': "Male",
    'flowpg_female': "Female",
    'flowpg_gender': "Gender",
    'flowpg_voicePersonaGenderPreference': "Voice/persona gender preference",
    'flowpg_typingSpeed': "Typing Speed",
    'flowpg_charactersPerSecond': "Characters per second (0 = instant)",
    'flowpg_maxInputLength': "Max Input Length",
    'flowpg_maximumCharactersAllowedInInput': "Maximum characters allowed in user input",
    'flowpg_turnCount': "Turn Count",
    'flowpg_numberOfConversationTurnsToRemember': "Number of conversation turns to remember",
    'flowpg_durationMinutes': "Duration (minutes)",
    'flowpg_howLongToKeepMemoryActive': "How long to keep memory active",
    'flowpg_shortTermMemory': "Short-Term Memory",
    'flowpg_recentContextWindowSize': "Recent context window size",
    'flowpg_sequence': "Sequence",
    'flowpg_numberOfConversationTurnsInSequence': "Number of conversation turns in sequence",
    'flowpg_durationSeconds': "Duration (seconds)",
    'flowpg_timeDurationForMultiTurnSession': "Time duration for multi-turn session",
    'flowpg_temperatureRequired': "Temperature*",
    'flowpg_creativityLevel': "Creativity level (0 = focused, 1 = creative)",
    'flowpg_topP': "Top P",
    'flowpg_tokenSelectionProbabilityThreshold': "Token selection probability threshold",
    'flowpg_frequencyPenalty': "Frequency Penalty",
    'flowpg_reduceRepetitionOfFrequentTokens': "Reduce repetition of frequent tokens",
    'flowpg_presencePenalty': "Presence Penalty",
    'flowpg_reduceRepetitionOfAnyTokens': "Reduce repetition of any tokens",
    'flowpg_maxTokensResponse': "Max Tokens Response",
    'flowpg_maximumResponseLengthInTokens': "Maximum response length in tokens",
    'flowpg_stopSequence': "Stop Sequence",
    'flowpg_textSequenceToStopGeneration': "Text sequence to stop generation",
    'flowpg_cacheTtlMinutes': "Cache TTL (minutes)",
    'flowpg_howLongToKeepCachedResponses': "How long to keep cached responses (1-10080 min)",
    'flowpg_cacheScope': "Cache Scope",
    'flowpg_whoCanUseCachedResponses': "Who can use cached responses",
    'flowpg_loadingDurationSeconds': "Loading Duration (seconds)",
    'flowpg_durationForLoadingAnimation': "Duration for loading animation display",
    'flowpg_monitorLineUserId': "Monitor Line User ID",
    'flowpg_lineUserIdForMonitoringNotifications': "LINE user ID for monitoring notifications",
    'flowpg_monitorLineName': "Monitor Line Name",
    'flowpg_selectMonitorLineName': "Select monitor line name",
    'flowpg_enterWordOrPhrase': "Enter word or phrase",
    'flowpg_messageShownOnFirstInteraction': "Message shown to user on first interaction",
    'flowpg_timeZone': "Time Zone",
    'flowpg_selectYourTimezoneForTimeAware': "Select your timezone for time-aware responses",
    'flowpg_selectYourTimezone': "Select your timezone",
    'flowpg_enterSystemMessageHere': "Enter your system message here...",
    'flowpg_searchTemplates': "Search templates",
    'flowpg_selectTemplateGroup': "Select Template Group",
    'flowpg_intentAiModelConfiguration': "Intent AI Model Configuration",
    'flowpg_intentConfiguration': "Intent Configuration",
    'flowpg_intentHandlerName': "Intent handler Name",
    'flowpg_intents': "Intents",
    'flowpg_addIntent': "Add Intent",
    'flowpg_intentDefaultName': "Intent",
    'flowpg_priority': "Priority",
    'flowpg_enterPriority': "Enter priority",
    'flowpg_priorityZeroIsHighest': "Priority 0 is the highest importance",
    'flowpg_intentName': "Intent Name",
    'flowpg_useMemory': "Use memory",
    'flowpg_editBasePrompt': "Edit Base Prompt",
    'flowpg_basePrompt': "Base Prompt",
    'flowpg_findIntentBasePromptHint': "Find the Intent from the message of users.\n#Condition for Response\n1. If the user asks a question related to or similar in meaning to the #Group Intent below. You must response 1. Otherwise, 0",
    'flowpg_intentPrompt': "Intent Prompt",
    'flowpg_exampleMessages': "Example Messages",
    'flowpg_exampleUserMessage': "Example user message...",
    'flowpg_mainAction': "Main Action",
    'flowpg_mainActionLabelPlaceholder': "Main action label...",
    'flowpg_parallelActions': "Parallel Actions",
    'flowpg_parallelActionLabelPlaceholder': "Parallel action label...",
    'flowpg_smartIntentConfiguration': "Smart Intent Configuration",
    'flowpg_smartIntentHandlerName': "Smart Intent Handler Name",
    'flowpg_smartIntents': "Smart Intents",
    'flowpg_addSmartIntent': "Add Smart Intent",
    'flowpg_smartIntentDefaultName': "Smart Intent",
    'flowpg_smartIntentName': "Smart Intent Name",
    'flowpg_smartIntentPrompt': "Smart Intent Prompt",
    'flowpg_actionLabel': "Action Label",
    'flowpg_useAiModel': "Use AI Model",
    'flowpg_loadConfig': "Load Config",
    'flowpg_providerParametersAndBehaviorSettings': "Provider, parameters, and behavior settings",
    'flowpg_timeContext': "Time Context",
    'flowpg_enableTimeAwareness': "Enable time awareness for AI responses",
    'flowpg_transactionIdContext': "TransactionID Context",
    'flowpg_addTransactionIdToPrompt': "Add TransactionID to Prompt",
    'flowpg_includeTransactionIdentifier': "Include transaction identifier in AI context",
    'flowpg_configureSystemMessage': "Configure system message for your AI",
    'flowpg_configureAdditionalPromptsAndTemplates': "Configure additional prompts and templates",
    'flowpg_showTemplates': "Show Templates",
    'flowpg_tipsForBetterPrompts': "Tips for better prompts:",
    'flowpg_tipBeSpecificAboutRole': "Be specific about the AI's role and expertise",
    'flowpg_tipDefineToneAndStyle': "Define the tone and communication style",
    'flowpg_tipIncludeRestrictions': "Include any restrictions or guidelines",
    'flowpg_tipSpecifyHandleUnknown': "Specify how to handle unknown information",
    'flowpg_knowledgeSources': "Knowledge Sources",
    'flowpg_configureKnowledgeIntegrationForContext': "Configure knowledge integration for context",
    'flowpg_enableKnowledgeSources': "Enable Knowledge Sources",
    'flowpg_documents': "Documents",
    'flowpg_vectorBasedDocumentSearch': "Vector-based document search",
    'flowpg_documentsConfiguration': "Documents Configuration",
    'flowpg_document': "Document",
    'flowpg_selectDocuments': "Select documents",
    'flowpg_topNChunks': "Top-N Chunks",
    'flowpg_numberOfDocumentChunksToRetrieve': "Number of document chunks to retrieve",
    'flowpg_databaseIntegration': "Database Integration",
    'flowpg_sqlDatabaseQueries': "SQL database queries",
    'flowpg_databaseIntegrationConfiguration': "Database Integration Configuration",
    'flowpg_tableName': "Table Name",
    'flowpg_selectDatabaseTable': "Select database table",
    'flowpg_sqlExtractionModel': "SQL Extraction Model",
    'flowpg_selectAiModelForSqlGeneration': "Select AI model for SQL generation",
    'flowpg_promptForNoData': "Prompt for No Data",
    'flowpg_enterMessageWhenNoDataFound': "Enter the message to display when no data is found in the database...",
    'flowpg_messageShownWhenNoResults': "Message shown when database query returns no results",
    'flowpg_products': "Products",
    'flowpg_productCatalogSearch': "Product catalog search",
    'flowpg_productsConfiguration': "Products Configuration",
    'flowpg_productGroupList': "Product Group List",
    'flowpg_selectProductGroup': "Select product group",
    'flowpg_enterNumberOfChunks': "Enter number of chunks",
    'flowpg_numberOfProductChunksToRetrieve': "Number of product chunks to retrieve",
    'flowpg_cosineSimilarity': "Cosine Similarity",
    'flowpg_enterSimilarityThreshold': "Enter similarity threshold (0.0001 - 1.0)",
    'flowpg_similarityThresholdForProductMatching': "Similarity threshold for product matching",
    'flowpg_apiKnowledge': "API Knowledge",
    'flowpg_externalApiIntegration': "External API integration",
    'flowpg_apiKnowledgeConfiguration': "API Knowledge Configuration",
    'flowpg_apiUrl': "API URL",
    'flowpg_httpMethod': "HTTP Method",
    'flowpg_requestHeaders': "Request Headers",
    'flowpg_addHeader': "Add Header",
    'flowpg_headerName': "Header Name",
    'flowpg_headerValue': "Header Value",
    'flowpg_noHeadersConfigured': "No headers configured",
    'flowpg_requestBody': "Request Body",
    'flowpg_requestBodyJson': "Request Body JSON",
    'flowpg_jsonPayloadForApiRequest': "JSON payload for API request (use {'{{'} variables {'}}'} for dynamic values)",
    'flowpg_responseDataPath': "Response Data Path",
    'flowpg_jsonPathToExtractKnowledgeData': "JSON path to extract knowledge data from API response",
    'flowpg_knowledgeIntegrationTips': "Knowledge Integration Tips:",
    'flowpg_tipEnableMultipleKnowledgeSources': "You can enable multiple knowledge sources simultaneously",
    'flowpg_tipConfigureSimilarityThresholds': "Configure similarity thresholds for better content matching",
    'flowpg_tipUseMultipleDocumentsOrGroups': "Use multiple documents or product groups for broader coverage",
    'flowpg_tipTestApiEndpoints': "Test API endpoints before deploying in production",
    'flowpg_tipKnowledgeSourcesQueriedInOrder': "Knowledge sources will be queried in order and combined for context",
    'flowpg_fallbackConfiguration': "Fallback Configuration",
    'flowpg_useAiModelForFallback': "Use AI Model for Fallback",
    'flowpg_fallbackAiConfiguration': "Fallback AI Configuration",
    'flowpg_backupAiSettingsWhenFails': "Backup AI settings when primary intent fails",
    'flowpg_responseOptions': "Response Options",
    'flowpg_configureHowResponsesGenerated': "Configure how responses are generated",
    'flowpg_streamResponse': "Stream Response",
    'flowpg_progressiveTextGeneration': "Progressive text generation",
    'flowpg_memorySettings': "Memory Settings",
    'flowpg_configureConversationMemory': "Configure conversation memory and context",
    'flowpg_conversationMemory': "Conversation Memory",
    'flowpg_memoryTypes': "Memory Types",
    'flowpg_longTermMemory': "Long-Term Memory",
    'flowpg_persistentStorage': "Persistent storage",
    'flowpg_aiParameters': "AI Parameters",
    'flowpg_fineTuneModelBehavior': "Fine-tune model behavior and output",
    'flowpg_coreParameters': "Core Parameters",
    'flowpg_penaltySettings': "Penalty Settings",
    'flowpg_outputControl': "Output Control",
    'flowpg_lineConfiguration': "Line Configuration",
    'flowpg_lineMessagingPlatformSettings': "LINE messaging platform settings",
    'flowpg_displayOptions': "Display Options",
    'flowpg_showName': "Show Name",
    'flowpg_displayUserName': "Display user name",
    'flowpg_loadingIndicator': "Loading Indicator",
    'flowpg_showTypingAnimation': "Show typing animation",
    'flowpg_loadingAndDuration': "Loading & Duration",
    'flowpg_monitoring': "Monitoring",
    'flowpg_contentFiltering': "Content Filtering",
    'flowpg_forbiddenWord': "Forbidden word",
    'flowpg_delete': "delete",
    'flowpg_systemPrompt': "System Prompt",
    'flowpg_defineAiBehaviorAndPersonality': "Define AI behavior and personality",
    'flowpg_aiPersonalityAndInstructions': "AI Personality & Instructions",
    'flowpg_defineHowAiShouldBehave': "Define how your AI should behave, respond, and interact with users",
    'flowpg_configureKnowledgeIntegrationForFallback': "Configure knowledge integration for fallback",
    'flowpg_similarityThresholdForDocumentMatching': "Similarity threshold for document matching",
    'flowpg_jsonPayloadHint': "JSON payload for API request (use {'{{'} variables {'}}'} for dynamic values)",
    'flowpg_jsonPathExtractHint': "JSON path to extract knowledge data from API response",
    'flowpg_fallbackKnowledgeTipsTitle': "Fallback Knowledge Integration Tips:",
    'flowpg_fallbackTip1': "Fallback knowledge is used when no Smart Intent matches",
    'flowpg_fallbackTip2': "Configure broader knowledge sources for better coverage",
    'flowpg_fallbackTip3': "Consider using general documents or FAQ data",
    'flowpg_fallbackTip4': "Test fallback responses to ensure helpful answers",
    'flowpg_smartIntentPromptTemplates': "Smart Intent Prompt Templates",
    'flowpg_noTemplatesFound': "No templates found",
    'flowpg_close': "Close",
    'flowpg_fallbackPromptTemplates': "Fallback Prompt Templates",
    'flowpg_apiConfiguration': "API Configuration",
    'flowpg_jsonRequestBody': "JSON Request Body",
    'flowpg_jsonValidatorModel': "JSON Validator Model",
    'flowpg_availableVariablesCount': "{n} available variables",
    'flowpg_jsonValidationSchema': "JSON Validation Schema",
    'flowpg_clickOrDragVariableHint': "Click variables to insert or drag & drop into editor",
    'flowpg_headersConfiguration': "Headers Configuration",
    'flowpg_key': "Key",
    'flowpg_value': "Value",
    'flowpg_validationConfiguration': "Validation Configuration",
    'flowpg_validationType': "Validation Type",
    'flowpg_numberOfCharacters': "Number of Characters",
    'flowpg_regularExpression': "Regular Expression",
    'flowpg_errorMessage': "Error Message",
    'flowpg_errorMessagePlaceholder': "Error message to display when validation fails",
    'flowpg_addValidation': "Add Validation",
    'flowpg_textResponse': "Text Response",
    'flowpg_responseMessage': "Response Message",
    'flowpg_enterResponseMessagePlaceholder': "Enter the response message...",
    'flowpg_configuration': "Configuration",
    'flowpg_contactAgentMessage': "Contact Agent Message",
    'flowpg_agentHandoffMessagePlaceholder': "Enter the message for agent handoff...",
    'flowpg_botDisableTimeMinutes': "Bot Disable Time (minutes)",
    'flowpg_enterTimeInMinutes': "Enter time in minutes",
    'flowpg_botDisableTimeHint': "Specify the duration for bot deactivation (in minutes) when transferring to an agent. Minimum value is 1 minute. If left blank, the bot will remain active.",
    'flowpg_emailConfiguration': "Email Configuration",
    'flowpg_emailProvider': "Email Provider",
    'flowpg_recipientConfiguration': "Recipient Configuration",
    'flowpg_toEmailRequired': "To Email *",
    'flowpg_ccEmailsOptional': "CC Emails (Optional)",
    'flowpg_bccEmailsOptional': "BCC Emails (Optional)",
    'flowpg_emailContent': "Email Content",
    'flowpg_subject': "Subject",
    'flowpg_emailSubjectPlaceholder': "Email subject",
    'flowpg_emailTemplateCustom': "Custom (Manual Content)",
    'flowpg_emailTemplateRegistration': "Registration",
    'flowpg_emailTemplateResetPassword': "Reset Password",
    'flowpg_emailTemplate': "Email Template",
    'flowpg_emailBody': "Email Body",
    'flowpg_emailBodyPlaceholder': "Enter email content here...",
    'flowpg_templateSelected': "Template Selected:",
    'flowpg_templateAutoGenerateHint': "This template will automatically generate the email content based on context variables.",
    'flowpg_advancedRouterConfiguration': "Advanced Router Configuration",
    'flowpg_advancedRouterName': "Advanced Router Name",
    'flowpg_routingPrompt': "Routing Prompt",
    'flowpg_routingPromptPlaceholder': "Additional instructions for hierarchical intent routing...",
    'flowpg_confidenceThreshold': "Confidence Threshold",
    'flowpg_maximumIntentDepth': "Maximum Intent Depth",
    'flowpg_levelsCount': "{n} levels",
    'flowpg_intentDepthHint': "How many levels deep the intent hierarchy can go (1-4)",
    'flowpg_responseSchemaGoogleProvider': "Response Schema (Google Provider)",
    'flowpg_enableCustomResponseSchema': "Enable Custom Response Schema",
    'flowpg_customSchemaGoogleHint': "Use node-defined schema for Google structured output",
    'flowpg_customSchemaGoogleOnlyNotice': "Custom schema is applied only when IntentAI provider is Google.",
    'flowpg_intentField': "Intent Field",
    'flowpg_confidenceField': "Confidence Field",
    'flowpg_subIntentsField': "Sub-Intents Field",
    'flowpg_customSchemaJson': "Custom Schema JSON",
    'flowpg_resetDefaultSchema': "Reset Default Schema",
    'flowpg_intentHierarchyLevel1': "Intent Hierarchy (Level 1)",
    'flowpg_intentNumbered': "Intent {n}",
    'flowpg_subIntentsCount': "{n} sub-intents",
    'flowpg_leafOutput': "Leaf (Output)",
    'flowpg_intentNameExamplePlaceholder': "e.g., Product, Support, Billing",
    'flowpg_subIntentsLevel2': "Sub-Intents (Level 2)",
    'flowpg_addSubIntent': "Add Sub-Intent",
    'flowpg_subIntentName': "Sub-Intent Name",
    'flowpg_level3Intents': "Level 3 Intents",
    'flowpg_level3IntentNamePlaceholder': "Level 3 intent name",
    'flowpg_level4Abbrev': "L4:",
    'flowpg_level4IntentPlaceholder': "Level 4 intent",
    'flowpg_cacheSettings': "Cache Settings",
    'flowpg_enableCache': "Enable Cache",
    'flowpg_enableCacheHint': "Cache intent routing results to reduce LLM calls",
    'flowpg_cacheTtlHint': "How long to keep cached routing results (1-10080 min)",
    'flowpg_semanticCache': "Semantic Cache",
    'flowpg_semanticMatch': "Semantic Match",
    'flowpg_semanticMatchHint': "Match similar questions using BGE-M3 AI embeddings",
    'flowpg_similarityThreshold': "Similarity Threshold",
    'flowpg_similarityThresholdHint': "Higher = more strict (exact match), Lower = more flexible",
    'flowpg_hierarchicalIntentDetection': "Hierarchical Intent Detection:",
    'flowpg_hierarchicalIntentDetectionDesc1': "Detects intents at multiple levels. Routes to",
    'flowpg_deepestMatchingLeaf': "deepest matching leaf",
    'flowpg_hierarchicalIntentDetectionDesc2': "intent.",
    'flowpg_hierarchicalIntentDetectionExample': "Example: User says \"ประกันชีวิต\" → Product > ประกันชีวิต",
    'flowpg_hierarchicalIntentDetectionLeafNote': "Only leaf nodes (without sub-intents) have output handles.",
    'flowpg_switchConfiguration': "Switch Configuration",
    'flowpg_switchName': "Switch Name",
    'flowpg_conditionalSwitchPlaceholder': "Conditional Switch",
    'flowpg_outputPaths': "Output Paths",
    'flowpg_addOutput': "Add Output",
    'flowpg_outputNumbered': "Output {n}",
    'flowpg_outputName': "Output Name",
    'flowpg_conditionBuilder': "Condition Builder",
    'flowpg_simple': "Simple",
    'flowpg_advanced': "Advanced",
    'flowpg_conditionTypeTextContains': "Text Contains",
    'flowpg_conditionTypeTextEquals': "Text Equals",
    'flowpg_conditionTypeNumberComparison': "Number Comparison",
    'flowpg_conditionTypeBooleanCheck': "Boolean Check",
    'flowpg_conditionTypeRegexMatch': "Regex Match",
    'flowpg_conditionTypeLengthCheck': "Length Check",
    'flowpg_conditionType': "Condition Type",
    'flowpg_sourceField': "Source Field",
    'flowpg_containsText': "Contains Text",
    'flowpg_keywordPlaceholder': "keyword",
    'flowpg_caseSensitive': "Case Sensitive",
    'flowpg_equalsTo': "Equals To",
    'flowpg_exactTextPlaceholder': "exact text",
    'flowpg_numberSource': "Number Source",
    'flowpg_operatorGreaterThan': "Greater than (>)",
    'flowpg_operatorLessThan': "Less than (<)",
    'flowpg_operatorEqual': "Equal (=)",
    'flowpg_operatorGreaterOrEqual': "Greater or equal (>=)",
    'flowpg_operatorLessOrEqual': "Less or equal (<=)",
    'flowpg_operatorNotEqual': "Not equal (!=)",
    'flowpg_operator': "Operator",
    'flowpg_compareValue': "Compare Value",
    'flowpg_booleanSource': "Boolean Source",
    'flowpg_true': "True",
    'flowpg_false': "False",
    'flowpg_expectedValue': "Expected Value",
    'flowpg_regexPattern': "Regex Pattern",
    'flowpg_regexFlagsOptional': "Regex Flags (Optional)",
    'flowpg_lengthOperatorEqualTo': "Equal to",
    'flowpg_lengthOperatorBetween': "Between",
    'flowpg_lengthOperator': "Length Operator",
    'flowpg_lengthValue': "Length Value",
    'flowpg_maxLength': "Max Length",
    'flowpg_generatedCondition': "Generated Condition:",
    'flowpg_customConditionExpression': "Custom Condition Expression",
    'flowpg_description': "Description",
    'flowpg_optionalDescriptionPlaceholder': "Optional description...",
    'flowpg_conditionConfiguration': "Condition Configuration",
    'flowpg_conditionTypeValueComparison': "Value Comparison",
    'flowpg_conditionTypeNumberRange': "Number Range",
    'flowpg_conditionTypeCustomExpression': "Custom Expression",
    'flowpg_leftValue': "Left Value",
    'flowpg_inputTextExamplePlaceholder': "e.g., input.text",
    'flowpg_operatorEquals': "Equals",
    'flowpg_operatorNotEquals': "Not Equals",
    'flowpg_rightValue': "Right Value",
    'flowpg_helloExamplePlaceholder': "e.g., 'hello'",
    'flowpg_textSource': "Text Source",
    'flowpg_keywordExamplePlaceholder': "e.g., 'keyword'",
    'flowpg_minValue': "Min Value",
    'flowpg_maxValue': "Max Value",
    'flowpg_customExpression': "Custom Expression",
    'flowpg_customExpressionPlaceholder': "e.g., input.text.length > 5 && input.text.includes('hello')",
    'flowpg_outputLabels': "Output Labels",
    'flowpg_trueOutputLabel': "true output",
    'flowpg_falseOutputLabel': "false output",
    'flowpg_optionalConditionDescriptionPlaceholder': "Optional description of this condition...",
    'flowpg_delayConfiguration': "Delay Configuration",
    'flowpg_delayTypeFixedDuration': "Fixed Duration",
    'flowpg_delayTypeRandomRange': "Random Range",
    'flowpg_delayTypeVariableDelay': "Variable Delay",
    'flowpg_delayType': "Delay Type",
    'flowpg_duration': "Duration",
    'flowpg_unitSeconds': "Seconds",
    'flowpg_unitMinutes': "Minutes",
    'flowpg_unitHours': "Hours",
    'flowpg_unit': "Unit",
    'flowpg_minDuration': "Min Duration",
    'flowpg_maxDuration': "Max Duration",
    'flowpg_delayExpression': "Delay Expression",
    'flowpg_delayMessageOptional': "Delay Message (Optional)",
    'flowpg_pleaseWaitPlaceholder': "Please wait while processing...",
    'flowpg_showProgressIndicator': "Show Progress Indicator",
    'flowpg_durationPreview': "Duration Preview:",
    'flowpg_variableBasedOnExpression': "Variable based on expression",
    'flowpg_optionalDelayDescriptionPlaceholder': "Optional description of this delay...",
    'flowpg_selectDocumentsPlaceholder': "Select documents",
    'flowpg_useSpecificDataSelection': "Use Specific Data Selection",
    'flowpg_selectDocumentData': "Select Document Data",
    'flowpg_selectDocumentForData': "Select Document for Data",
    'flowpg_selectDocumentToViewDataHint': "Select a document to view its data",
    'flowpg_selectedDocumentData': "Selected Document Data:",
    'flowpg_loadingDocumentData': "Loading document data...",
    'flowpg_textReplacement': "Text Replacement",
    'flowpg_selectTextReplacementGroups': "Select text replacement groups",
    'flowpg_summaryMemoryEmbedding': "Summary Memory (Embedding)",
    'flowpg_summaryMemoryDocSearchHint': "When enabled, an LLM summarizes recent conversation turns + the latest message into the search query so follow-up questions retrieve the right documents. Affects document search only — the final answer is unaffected. Memory Turns = 0 embeds the latest message directly.",
    'flowpg_enableSummaryMemory': "Enable Summary Memory",
    'flowpg_provider': "Provider",
    'flowpg_model': "Model",
    'flowpg_apiVersion': "API Version",
    'flowpg_memoryTurns': "Memory Turns",
    'flowpg_memoryTurnsEmbedHint': "0 = embed latest message only",
    'flowpg_memoryDurationMin': "Memory Duration (min)",
    'flowpg_temperature': "Temperature",
    'flowpg_maxTokens': "Max Tokens",
    'flowpg_summarizerSystemPromptPlaceholder': "You are a conversation summarizer. Given the chat history and the latest user message, write a concise standalone search query that captures the full context.",
    'flowpg_llmTimeoutSeconds': "LLM Timeout (seconds)",
    'flowpg_overrideGlobalTimeoutHint': "Override global timeout for summary LLM call (0 = use global)",
    'flowpg_knowledgeGraphConfiguration': "Knowledge Graph Configuration",
    'flowpg_knowledgeGraphs': "Knowledge Graphs",
    'flowpg_selectOneOrMoreGraphs': "Select one or more graphs",
    'flowpg_nexaDefaultsHint': "Defaults shown match NEXA's recommended values. Leave as-is unless this flow needs per-node tuning.",
    'flowpg_maxHops': "Max Hops",
    'flowpg_bfsDepthDefault3': "BFS depth (default 3)",
    'flowpg_searchMode': "Search Mode",
    'flowpg_anchorMatchingDefaultFuzzyFirst': "Anchor matching (default fuzzy-first)",
    'flowpg_fuzzyThreshold': "Fuzzy Threshold",
    'flowpg_range0to100Default70': "0-100 (default 70)",
    'flowpg_semanticThreshold': "Semantic Threshold",
    'flowpg_range0to1Default065': "0-1 (default 0.65)",
    'flowpg_maxContextNodes': "Max Context Nodes",
    'flowpg_default30': "Default 30",
    'flowpg_maxContextEdges': "Max Context Edges",
    'flowpg_default60': "Default 60",
    'flowpg_baselineTopK': "Baseline Top K",
    'flowpg_forBaselineVectorOnlyMode1to100': "For baseline-vector-only mode (1-100)",
    'flowpg_baselineMinSimilarity': "Baseline Min Similarity",
    'flowpg_forBaselineVectorOnlyMode0to1': "For baseline-vector-only mode (0-1)",
    'flowpg_waterfallSearchConfiguration': "Waterfall Search Configuration",
    'flowpg_waterfallSearchTierHint': "Search runs tier by tier from top to bottom and stops at the first tier that returns a hit (ขั้นบันได).",
    'flowpg_includeMiniappTierBeforeGraphs': "Include MiniApp tier (DGA Czp) before graphs",
    'flowpg_graphTiers': "Graph Tiers",
    'flowpg_addTier': "Add Tier",
    'flowpg_noGraphTiersYet': "No graph tiers yet. Click \"Add Tier\" to build the ladder.",
    'flowpg_tierNumber': "Tier {n}",
    'flowpg_graph': "Graph",
    'flowpg_selectAGraph': "Select a graph",
    'flowpg_advancedOptional': "Advanced (optional)",
    'flowpg_leaveBlankNexaDefaultsTier': "Leave blank to use NEXA defaults for this tier.",
    'flowpg_anchorFinalTopK': "Anchor Final Top K",
    'flowpg_summaryMemoryWaterfallHint': "When enabled, an LLM summarizes recent conversation turns + the latest message into the waterfall search query so follow-up questions search with the right context. Affects the waterfall search query only — the final answer is unaffected. Memory Turns = 0 searches with the latest message directly.",
    'flowpg_memoryTurnsSearchHint': "0 = search with latest message only",
    'flowpg_enterNoDataMessagePlaceholder': "Enter the message to display when no data is found in the database...",
    'flowpg_knowledgeApiConfiguration': "Knowledge API Configuration",
    'flowpg_requestBodyJsonLabel': "Request Body (JSON)",
    'flowpg_clickVariablesToInsertOrDrag': "Click variables to insert or drag & drop into editor",
    'flowpg_dataResultsJsonPathPlaceholder': "data.results (JSON path to extract knowledge)",
    'flowpg_jsonPathExtractKnowledgeHint': "JSON path to extract knowledge data from API response",
    'flowpg_sharePointConfiguration': "SharePoint Configuration",
    'flowpg_fileLocation': "File Location",
    'flowpg_filename': "Filename",
    'flowpg_subfolderPath': "Subfolder Path",
    'flowpg_subfolderNameOptionalPlaceholder': "/SubfolderName (optional)",
    'flowpg_subfolderPathHint': "Subfolder path within the SharePoint site<br><strong>Root: /Documents</strong><br>Example: /Data will become /Documents/Data",
    'flowpg_connectionSettings': "Connection Settings",
    'flowpg_siteUrl': "Site URL",
    'flowpg_tenantId': "Tenant ID",
    'flowpg_authentication': "Authentication",
    'flowpg_clientId': "Client ID",
    'flowpg_applicationClientIdPlaceholder': "Application (client) ID",
    'flowpg_clientSecret': "Client Secret",
    'flowpg_enterClientSecret': "Enter client secret",
    'flowpg_mcpServerConfiguration': "MCP Server Configuration",
    'flowpg_serverUrl': "Server URL",
    'flowpg_authHeaderName': "Auth Header Name",
    'flowpg_authTokenOptional': "Auth Token (optional)",
    'flowpg_bearerTokenApiKeyPlaceholder': "Bearer token / API key",
    'flowpg_connectTimeoutSeconds': "Connect Timeout (s)",
    'flowpg_agenticLlmPicksTools': "Agentic (LLM picks tools)",
    'flowpg_singleTool': "Single tool",
    'flowpg_mode': "Mode",
    'flowpg_maxToolIterations': "Max Tool Iterations",
    'flowpg_toolChoice': "Tool Choice",
    'flowpg_tools': "Tools",
    'flowpg_discoverTools': "Discover Tools",
    'flowpg_selectedTools': "Selected Tools",
    'flowpg_leaveEmptyExposeAllToolsHint': "Leave empty to expose all discovered tools (agentic mode)",
    'flowpg_loadingPleaseWait': "Loading Please Wait...",
    'flowpg_updateFlow': "Update Flow",
    'flowpg_saveFlow': "Save Flow",
    'flowpg_untitledFlow': "Untitled Flow",
    'flowpg_updateThisFlow': "Update this flow?",
    'flowpg_saveThisFlow': "Save this flow?",
    'flowpg_warning': "Warning",
    'flowpg_flowHasValidationIssues': "Flow has {n} validation issue(s).",
    'flowpg_canStillSaveMayNotWork': "You can still save, but the flow may not work correctly.",
    'flowpg_readyToSave': "Ready to save",
    'flowpg_flowValidationPassed': "Flow validation passed successfully.",
    'flowpg_versionNoteOptional': "Version Note (Optional)",
    'flowpg_describeWhatChangedPlaceholder': "Describe what changed in this version...",
    'flowpg_cancel': "Cancel",
    'flowpg_loadFromExistingModel': "Load from Existing Model",
    'flowpg_selectModelToLoad': "Select Model to Load",
    'flowpg_selectModel': "Select Model",
    'flowpg_chooseModelToLoadConfigFrom': "Choose a model to load configuration from",
    'flowpg_configurationPreview': "Configuration Preview",
    'flowpg_providerLabel': "Provider:",
    'flowpg_modelLabel': "Model:",
    'flowpg_temperatureLabel': "Temperature:",
    'flowpg_maxTokensLabel': "Max Tokens:",
    'flowpg_topPLabel': "Top P:",
    'flowpg_frequencyPenaltyLabel': "Frequency Penalty:",
    'flowpg_note': "Note",
    'flowpg_loadingConfigWillOverwriteNodeSettings': "Loading configuration will overwrite current AI model settings in this node.",
    'flowpg_loadConfiguration': "Load Configuration",
    'flowpg_loadConfigFor': "Load Config for {n}",
    'flowpg_loadingConfigWillOverwriteAiSettingsFor': "Loading configuration will overwrite current AI settings for {n}.",
    'flowpg_successExclaim': "Success!",
    'flowpg_flowLabel': "Flow: {n}",
    'flowpg_ok': "OK",
    'flowpg_confirmNavigation': "Confirm Navigation",
    'flowpg_areYouSureYouWantToLeave': "Are you sure you want to leave?",
    'flowpg_anyUnsavedChangesWillBeLost': "Any unsaved changes will be lost.",
    'flowpg_unsavedChanges': "Unsaved Changes",
    'flowpg_currentFlowModificationsNotSaved': "Your current flow modifications have not been saved.",
    'flowpg_leaveAnyway': "Leave Anyway",
    'flowpg_stayHere': "Stay Here",
    'flowpg_copiedToClipboard': "Copied to clipboard!",
    'flowpg_undoneAction': "Undone: {action}",
    'flowpg_redoneAction': "Redone: {action}",
    'flowpg_modelsReloadedSuccess': "Models reloaded successfully",
    'flowpg_modelsReloadFailed': "Failed to reload models. Please try again.",
    'flowpg_undoRedoHistoryCleared': "Undo/Redo history cleared",
    'flowpg_botDisableTimeMinWarning': "Bot Disable Time must be at least 1 minute",
    'flowpg_mcpServerUrlRequired': "MCP server URL is required",
    'flowpg_mcpToolsDiscovered': "Discovered {count} MCP tool(s)",
    'flowpg_mcpToolsDiscoverFailed': "Failed to discover MCP tools",
    'flowpg_mcpServerConnectFailed': "Failed to connect to MCP server",
    'flowpg_nodeTypeMessageInput': "Message Input",
    'flowpg_nodeTypeAiModel': "AI Model",
    'flowpg_nodeTypeGuardrailAi': "Guardrail AI",
    'flowpg_nodeTypeIntentAiModel': "Intent AI Model",
    'flowpg_nodeTypeIntentClassifier': "Intent Classifier",
    'flowpg_nodeTypeIntent': "Intent",
    'flowpg_nodeTypeAdvancedRouter': "Advanced Router",
    'flowpg_nodeTypeApiTrigger': "API Trigger",
    'flowpg_nodeTypeContactAgent': "Contact Agent",
    'flowpg_nodeTypeInterestOptimizer': "Interest Optimizer",
    'flowpg_nodeTypeLoanInterest': "Loan Interest",
    'flowpg_nodeTypeSwitch': "Switch",
    'flowpg_nodeTypeCondition': "Condition",
    'flowpg_nodeTypeDelay': "Delay",
    'flowpg_nodeTypeDocuments': "Documents",
    'flowpg_nodeTypeKnowledgeGraph': "Knowledge Graph",
    'flowpg_nodeTypeWaterfallSearch': "Waterfall Search",
    'flowpg_nodeTypeDatabaseIntegration': "Database Integration",
    'flowpg_nodeTypeKnowledgeApi': "Knowledge API",
    'flowpg_nodeTypeMcp': "MCP",
    'flowpg_nodeTypeProducts': "Products",
    'flowpg_connectionAlreadyExists': "Connection already exists between these nodes",
    'flowpg_sourceOrTargetNodeNotFound': "Source or target node not found",
    'flowpg_cannotConnectNodeToItself': "Cannot connect node to itself",
    'flowpg_cannotDragFromInputHandle': "Cannot drag from input handle. Input handles can only receive connections.",
    'flowpg_cannotConnectToOutputHandle': "Cannot connect to output handle. Output handles can only send connections.",
    'flowpg_messageInputCannotReceiveConnections': "Message Input node cannot receive connections as it is a start node",
    'flowpg_responseNodeCannotSendConnections': "Response node cannot send connections as it is an end node",
    'flowpg_messageInputOnlyConnectsToModelOrIntent': "Message Input node can only connect to AI Model nodes or Intent Handler nodes",
    'flowpg_apiCallOnlyConnectsToModelOrIntent': "API Call Input node can only connect to AI Model nodes or Intent Handler nodes",
    'flowpg_sourceModelOfIntentOnlyConnectsToIntentAI': "Source model of Intent node can only connect to Intent AI nodes",
    'flowpg_intentOnlyConnectsToIntentModelApiContactResponse': "Intent node can only connect to Intent, AI Model, API Trigger, Contact Agent nodes or Response",
    'flowpg_smartIntentOnlyConnectsToIntentModelApiContactResponse': "Smart Intent node can only connect to Intent, AI Model, API Trigger, Contact Agent nodes or Response",
    'flowpg_advancedRouterBottomOnlyConnectsToIntentAI': "Advanced Router output-bottom can only connect to Intent AI nodes",
    'flowpg_advancedRouterOutputOnlyConnectsToFlowNodes': "Advanced Router output can only connect to flow nodes (Model, Intent, Response, etc.)",
    'flowpg_interestOptimizerCannotConnectToThisType': "Interest Optimizer node can't connect to this node type",
    'flowpg_loanInterestCannotConnectToThisType': "Loan Interest node can't connect to this node type",
    'flowpg_modelKnowledgeSourceOnlyConnectsToKnowledgeNodes': "AI Model node knowledge souce can only connect to knowledge nodes;",
    'flowpg_modelOnlyConnectsToModelIntentResponse': "AI Model node can only connect to AI Model, Intent or Response nodes",
    'flowpg_emailNodeCannotConnectToThisType': "Email node can't connect to this node type",
    'flowpg_apiTriggerOnlyConnectsToModelResponseApiContact': "API Trigger node can only connect to AI Model, Response nodes, API Trigger nodes or Contact Agent nodes",
    'flowpg_contactAgentOnlyConnectsToModelResponseApiContact': "Contact Agent node can only connect to AI Model, Response nodes, API Trigger nodes or Contact Agent nodes",
    'flowpg_invalidOutputHandleForCondition': "Invalid output handle for Condition node",
    'flowpg_knowledgeNodeOnlyConnectsToModel': "{nodeType} can only connect to AI Model nodes",
    'flowpg_connectionWouldCreateCircularReference': "This connection would create a circular reference in the flow",
    'flowpg_modelCanOnlyConnectToOneKnowledgeNode': "AI Model can only connect to one {nodeType} node from output-bottom handle",
    'flowpg_nodeCanOnlyHaveOneInputConnection': "{nodeType} node can only have one input connection",
    'flowpg_switchNodeMaxThreeInputs': "Switch node can have maximum 3 input connections",
    'flowpg_conditionNodeMaxTwoInputs': "Condition node can have maximum 2 input connections",
    'flowpg_messageInputCanOnlyHaveOneOutput': "Message Input node can only have one output connection",
    'flowpg_intentFallbackCanOnlyHaveOneOutput': "Intent fallback can only have one output connection",
    'flowpg_eachIntentActionCanOnlyHaveOneOutput': "Each intent action can only have one output connection",
    'flowpg_intentCanOnlyHaveOneIntentAIConnection': "Intent can only have one Intent AI connection",
    'flowpg_smartIntentFallbackCanOnlyHaveOneOutput': "Smart Intent fallback can only have one output connection",
    'flowpg_smartIntentCanOnlyHaveOneIntentAIConnection': "Smart intent can only have one Intent AI connection",
    'flowpg_intentAIConnectionLabel': "Intent AI connection",
    'flowpg_fallbackOutputLabel': "fallback output",
    'flowpg_intentOutputLabel': "intent output",
    'flowpg_advancedRouterHandleOnlyOneConnection': "Advanced Router {handleLabel} can only have one connection",
    'flowpg_switchOutputLabel': "switch output",
    'flowpg_defaultOutputLabel': "default output",
    'flowpg_outputLabel': "output",
    'flowpg_nodeHandleOnlyOneOutputConnection': "{nodeName} {handleName} can only have one output connection",
    'flowpg_messageInputAlreadyExists': "Message Input node already exists. Only one Message Input node is allowed per flow.",
    'flowpg_addedNodeToFlow': "Added {label} to flow",
    'flowpg_nodeDeletedSuccessfully': "Node deleted successfully",
    'flowpg_nNodesDeletedSuccessfully': "{n} node(s) deleted successfully",
    'flowpg_cannotDuplicateMessageInput': "Cannot duplicate Message Input node. Only one Message Input node is allowed per flow.",
    'flowpg_nNodesDuplicatedSuccessfully': "{n} node(s) duplicated successfully",
    'flowpg_nNodesCopiedToClipboard': "{n} node(s) copied to clipboard",
    'flowpg_cannotPasteMessageInput': "Cannot paste Message Input node. Only one Message Input node is allowed per flow.",
    'flowpg_nNodesPastedSuccessfully': "{n} node(s) pasted successfully",
    'flowpg_cannotSaveEmptyFlow': "Cannot save empty flow",
    'flowpg_flowValidationFailed': "Flow validation failed: {errors}",
    'flowpg_flowUpdatedSuccessfully': "Flow updated successfully",
    'flowpg_flowSavedSuccessfully': "Flow saved successfully",
    'flowpg_failedToSaveFlow': "Failed to save flow",
    'flowpg_failedToSaveFlowWithReason': "Failed to save flow: {reason}",
    'flowpg_flowNameRequired': "Flow name is required",
    'flowpg_flowMustContainRootNode': "Flow must contain at least one root node",
    'flowpg_nodeAtPathMissingId': "Node at path {path} is missing ID",
    'flowpg_duplicateNodeIdFound': "Duplicate node ID found: {id} at path {path}",
    'flowpg_nodeMissingNodeType': "Node {id} is missing nodeType",
    'flowpg_messageInputRequiresModel': "Message Input node ({id}) requires at least one selected model",
    'flowpg_aiModelRequiresSelectedModel': "AI Model node ({id}) requires a selected model",
    'flowpg_intentAIRequiresModelAndProvider': "Intent AI node ({id}) requires a model and provider",
    'flowpg_intentRequiresAtLeastOneIntent': "Intent node ({id}) requires at least one intent",
    'flowpg_switchRequiresAtLeastTwoOutputs': "Switch node ({id}) requires at least two output paths",
    'flowpg_apiTriggerRequiresApiUrl': "API Trigger node ({id}) requires API URL",
    'flowpg_knowledgeApiRequiresApiUrl': "Knowledge API node ({id}) requires API URL",
    'flowpg_mcpRequiresServerUrl': "MCP node ({id}) requires a server URL",
    'flowpg_mcpSingleToolRequiresOneTool': "MCP node ({id}) in single-tool mode requires exactly one selected tool",
    'flowpg_emailRequiresRecipient': "Email node ({id}) requires a recipient email address",
    'flowpg_emailInvalidRecipientFormat': "Email node ({id}) has invalid recipient email format",
    'flowpg_emailRequiresSubject': "Email node ({id}) requires a subject",
    'flowpg_emailRequiresContentForCustomTemplate': "Email node ({id}) requires email content when using custom template",
    'flowpg_sharepointRequiresAllFields': "SharePoint node ({id}) requires all configuration fields: Site URL, Tenant ID, Client ID, Client Secret, Folder Path, and Filename",
    'flowpg_flowMustContainAtLeastOneNode': "Flow must contain at least one node",
    'flowpg_nodeNumberMissingId': "Node {n} is missing ID",
    'flowpg_duplicateNodeIdFoundSimple': "Duplicate node ID found: {n}",
    'flowpg_nodeMissingNodeTypeSimple': "Node {n} is missing nodeType",
    'flowpg_waterfallNodeInvalidGraphTiers': "Waterfall Search node {n} has invalid or incomplete graph tiers",
    'flowpg_nodeMissingPosition': "Node {n} is missing position",
    'flowpg_nodeTargetMissingNodeId': "Node {n} target {idx} is missing nodeId",
    'flowpg_nodeReferencesNonExistentTarget': "Node {n} references non-existent target node: {target}",
    'flowpg_unknownErrorOccurred': "Unknown error occurred",
    'flowpg_apiCallFailed': "API call failed",
    'flowpg_flowLoadedSuccess': "Flow \"{n}\" loaded successfully",
    'flowpg_failedLoadFlow': "Failed to load flow",
    'flowpg_failedLoadFlowColon': "Failed to load flow: {n}",
    'flowpg_flowImportedSuccessNamed': "Flow \"{n}\" imported successfully",
    'flowpg_failedImportFlowData': "Failed to import flow data",
    'flowpg_flowLoadedSuccessGeneric': "Flow loaded successfully",
    'flowpg_flowCleared': "Flow cleared",
    'flowpg_failedLoadModelConfig': "Failed to load model configuration",
    'flowpg_errorLoadModelConfig': "Error loading model configuration",
    'flowpg_successLoadedConfigFrom': "Successfully loaded configuration from {n}",
    'flowpg_selectedModel': "selected model",
    'flowpg_failedLoadModelConfigColon': "Failed to load model configuration: ",
    'flowpg_failedLoadModelConfigRetry': "Failed to load model configuration. Please try again.",
    'flowpg_noModelConfigToLoad': "No model configuration to load",
    'flowpg_successLoadedConfigFromTo': "Successfully loaded configuration from {n} to {target}",
    'flowpg_fallback': "Fallback",
    'flowpg_smartIntent': "Smart Intent",
    'flowpg_noTargetSelectedForConfig': "No target selected for configuration loading",
    'flowpg_smartIntentNumbered': "Smart Intent {n}",
    'flowpg_flowExportedSuccess': "Flow exported successfully",
    'flowpg_failedExportFlow': "Failed to export flow",
    'flowpg_importedFlow': "Imported Flow",
    'flowpg_flowImportedSuccess': "Flow imported successfully",
    'flowpg_failedImportFlowInvalidFormat': "Failed to import flow: Invalid file format",
    'flowpg_isolatedNodeFound': "{n} isolated node found",
    'flowpg_today': "Today",
    'flowpg_yesterday': "Yesterday",
    'flowpg_daysAgo': "{n} days ago",
    'flowpg_confirmLeaveUnsavedChanges': "Are you sure you want to leave? Any unsaved changes will be lost.",
    'flowpg_failedLoadAiModelsRefresh': "Failed to load AI models. Please refresh the page.",
    'entra_guidPlaceholder': "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
    'entra_secretMaskedPlaceholder': "••••••••",
    'entra_scopesPlaceholder': "openid profile email",
    'entra_requiredField': "Required.",
    'flowpg_cacheScopeFlowLevel': "Flow Level (All Users)",
    'flowpg_cacheScopeUserLevel': "User Level (Per User)",
    'flowpg_documentDataHeaderTextEnglish': "Text English",
    'flowpg_documentDataHeaderTextOriginal': "Text Original",
    'gmd_createModelTitle': "Create Model",
    'gmd_loadingPleaseWait': "Loading Please Wait...",
    'gptmpl_addTemplate': "Template",
    'gptmpl_groupNamePlaceholder': "Group Name",
    'gptmpl_loading': "Loading...",
    'gptmpl_pleaseWait': "Please wait",
    'gptmpl_requiredField': "Required.",
    'grtext_textGroup': "Text Group",
    'grtext_action': "Action",
    'grtext_requiredField': "Required.",
    'grtext_loading': "Loading...",
    'grtext_pleaseWait': "Please wait",
    'igrp_loadingTitle': "Loading...",
    'igrp_loadingSubtitle': "Please wait",
    'igrp_required': "Required.",
    'invm_addMultipleHint': "multiple items allowed",
    'invm_roleAdmin': "Admin",
    'invm_roleUser': "User",
    'invm_roleOperator': "Operator",
    'invm_roleSuperAdmin': "Super admin",
    'kgde_backToList': "Back to list",
    'mquick_company': "Company",
    'mquick_name': "Name",
    'mquick_channelSecret': "Channel secret",
    'mquick_channelToken': "Channel token",
    'mquick_loadingPleaseWait': "Loading Please Wait...",
    'mquick_required': "Required.",
    'relnotes_whatsNew': "What's new?",
    'relnotes_feature': "Feature",
    'relnotes_bugfix': "Bugfix",
    'relnotes_improvement': "Improvement",
    'relnotes_externalApi': "External API",
    'sadash_usersLabel': "Users",
    'sadash_toggle': "Toggle",
    'sadash_loadingTitle': "Loading...",
    'sadash_pleaseWaitText': "Please wait",
    'sasales_columnNo': "No",
    'sasales_columnFullName': "Full Name",
    'sasales_columnEmail': "E-mail",
    'sasales_columnPhone': "Phone",
    'sasales_columnActions': "Actions",
    'sawg_companyLabel': "Company",
    'sawg_typeLabel': "Type {type}",
    'sawg_maxLength10': "Must not exceed 10 characters",
    'sawg_genericError': "An error occurred",
    'vneg_negativeNamePlaceholder': "Negative name",
    'vneg_loadingTitle': "Loading...",
    'vneg_pleaseWait': "Please wait",
    'vneg_negativeQuestionSet': "Negative Question Set",
    'vneg_createBy': "Create by",
        'mqr_quickReply': "Quick Reply",
    'mqr_quickReplyGroup': "Quick reply group",
    'Quick reply Group': "Quick Reply Group",
    'Add Quick Reply group': "Add Quick Reply Group",
    'mqr_dash': "-",
    'mqr_loading': "Loading...",
    'mqr_pleaseWait': "Please wait",
    'mqr_editQuickReplyGroup': "Edit Quick Reply Group",
    'mqr_modifyQuickReplyGroupConfiguration': "Modify quick reply group configuration",
    'mqr_basicInformation': "Basic Information",
    'mqr_quickReplyGroupName': "Quick Reply Group Name",
    'mqr_enterGroupNamePlaceholder': "Enter group name...",
    'mqr_importFromShortcut': "Import From Shortcut",
    'mqr_shortcutGroup': "Shortcut Group",
    'mqr_importGroupFromShortcutGroup': "Import group from shortcut group",
    'mqr_modelConfiguration': "Model Configuration",
    'mqr_allModels': "All Models",
    'mqr_allModel': "All model",
    'mqr_modelSetup': "Model Setup",
    'mqr_model': "model",
    'mqr_models': "models",
    'mqr_modelName': "Model Name",
    'mqr_actions': "Actions",
    'mqr_selectModel': "Select Model",
    'mqr_remove': "Remove",
    'mqr_add': "Add",
    'mqr_allModelsIncluded': "All Models Included",
    'mqr_allModelsIncludedDescription': "This group will automatically include all available models",
    'mqr_command': "command",
    'mqr_commands': "commands",
    'mqr_quickReplyNamePlaceholder': "Quick reply name",
    'mqr_quickReplyDataPlaceholder': "Quick reply data",
    'mqr_postbackMessageTypeExplanation': "Postback is the type that the user not seeing any sent data. <br />Message is the type that the user sees sent data.",
    'mqr_previewAlt': "Preview",
    'mqr_configureQuickReplyCommandsHint': "Configure quick reply commands with labels, messages, and custom icons",
    'mqr_commandsConfigured': "{n} command(s) configured",
    'mqr_createNewQuickReplyGroup': "Create a new quick reply group",
    'mqr_quickModelNameTooltip': "Quick model name",
    'mqr_modelDetailsAndInformation': "Model details and information",
    'mqr_noModelsFound': "No models found",
    'mqr_noModelDataAvailable': "No model data available to display",
    'mqr_view': "View",
    'mqr_modelsCount': "{n} models",
    'mqr_importShortcutGroup': "Import Shortcut Group",
    'mqr_selectShortcutGroupToImport': "Select a shortcut group to import",
    'mqr_selectShortcutGroup': "Select Shortcut Group",
    'mqr_availableShortcutGroups': "Available Shortcut Groups",
    'mqr_chooseShortcutGroupToImportModels': "Choose a shortcut group to import its models",
    'mqr_selectShortcutGroupLabel': "Select shortcut group",
    'mqr_chooseShortcutGroupPlaceholder': "Choose a shortcut group...",
    'mqr_importingWillAddModelsHint': "Importing will add the selected group's models to your current configuration",
    'mqr_availableGroupsCount': "{n} available group(s)",
    'mqr_cancel': "Cancel",
    'mqr_import': "Import",
    'mqr_required': "Required.",
    'mqr_allModelCannotImportMoreGroup': "All model cannot import more group.",
    'mqr_groupMustNotHaveDuplicatedModels': "The group must not have any duplicated models.",
    'mqr_errorOccurred': "An error occurred!",
    'mqr_somethingWentWrong': "Something went wrong!",
    'mqr_onlyJpegPngAllowed': "Only JPEG or PNG files are allowed",
    'pdet_productGroupInformation': "Product Group Information",
    'pdet_productGroupName': "Product Group Name",
    'pdet_productGroupNameRequired': "Product Group Name is required",
    'pdet_products': "Products",
    'pdet_productCount': "{n} product | {n} products",
    'pdet_reprocess': "Reprocess",
    'pdet_categories': "Categories",
    'pdet_addProduct': "Add Product",
    'pdet_searchProductsPlaceholder': "Search products...",
    'pdet_allCategories': "All Categories",
    'pdet_filterByCategory': "Filter by category",
    'pdet_resultCount': "{n} result | {n} results",
    'pdet_clearFilters': "Clear filters",
    'pdet_noProductsYet': "No products yet",
    'pdet_addFirstProduct': "Add your first product to get started",
    'pdet_noResultsFound': "No results found",
    'pdet_tryAdjustingFilters': "Try adjusting your search or filters",
    'pdet_noPrice': "No price",
    'pdet_rec': "Rec",
    'pdet_notRec': "Not Rec",
    'pdet_visible': "Visible",
    'pdet_hidden': "Hidden",
    'pdet_editProduct': "Edit Product",
    'pdet_addNewProduct': "Add New Product",
    'pdet_update': "Update",
    'pdet_save': "Save",
    'pdet_productName': "Product Name",
    'pdet_price': "Price",
    'pdet_categoryOptional': "Category (Optional)",
    'pdet_changeImage': "Change Image",
    'pdet_uploadImage': "Upload Image",
    'pdet_recommendThisProduct': "Recommend this product",
    'pdet_productDetails': "Product Details",
    'pdet_imagePreview': "Image Preview",
    'pdet_categoryManagement': "Category Management",
    'pdet_categoryName': "Category Name",
    'pdet_currentCategories': "Current Categories",
    'pdet_noCategoriesYet': "No categories added yet",
    'pdet_addFirstCategory': "Add your first category above",
    'pdet_close': "Close",
    'pdet_saveChanges': "Save Changes",
    'pdet_loading': "Loading...",
    'pdet_pleaseWait': "Please wait",
    'pdet_requiredField': "Required field",
    'pdet_pricePositiveError': "Price must be positive",
    'pdet_maxTwoDecimalsError': "Maximum 2 decimal places allowed",
    'pdet_noCategory': "No Category",
    'pdet_productGroupNameRequiredTitle': "Product Group Name Required",
    'pdet_productGroupNameRequiredBeforeAddText': "Please enter a Product Group Name before adding products.",
    'pdet_duplicateCategoryTitle': "Duplicate Category",
    'pdet_duplicateCategoryText': "Category \"{name}\" already exists.",
    'pdet_cannotRemoveCategoryTitle': "Cannot Remove Category",
    'pdet_cannotRemoveCategoryText': "This category is being used by one or more products.",
    'pdet_categoryNameRequiredTitle': "Category Name Required",
    'pdet_categoryNameRequiredText': "Category name cannot be empty.",
    'pdet_deleteProductTitle': "Delete Product",
    'pdet_deleteProductText': "Are you sure you want to delete this product? This action cannot be undone.",
    'pdet_productDeletedSuccess': "Product deleted successfully",
    'pdet_reprocessProductTitle': "Reprocess Product",
    'pdet_reprocessProductText': "Are you sure you want to reprocess this product group? This action cannot be undone.",
    'pdet_productReprocessSuccess': "Product reprocess successfully",
    'pdet_success': "Success",
    'setpg_settingTitle': "Setting",
    'setpg_generalSection': "General Settings",
    'setpg_generalSectionHint': "This section is coming soon.",
    'setpg_comingSoon': "Coming soon",
    'setpg_userColorCode': "User Color Code",
    'setpg_logo': "Logo",
    'setpg_selectImage': "Select Image",
    'setpg_uploadLogoTitle': "Click to upload logo",
    'setpg_uploadLogoHint': "PNG, JPG (recommended 350×250 px)",
    'setpg_changeLogo': "Change image",
    'setpg_langThai': "Thai",
    'setpg_langEnglish': "English",
    'setpg_defaultLanguageForMobileUsers': "Default Language for Mobile Users",
    'setpg_english': "English",
    'setpg_save': "Save",
    'setpg_cancel': "Cancel",
    'setpg_snippetIconCropTitle': "Adjust bubble icon",
    'setpg_snippetIconCropHint': "Drag to reposition · scroll/pinch to zoom (zoom out to fit the whole image) — only the circle is used; anything past the image edge becomes transparent",
    'setpg_snippetIconCropConfirm': "Use this image",
    'setpg_snippetSection': "Customize Snippet (Chat Widget)",
    'setpg_snippetNavbarColor': "Navbar Color",
    'setpg_snippetNavbarColorStart': "Navbar Color (Start)",
    'setpg_snippetNavbarColorEnd': "Navbar Color (End)",
    'setpg_snippetNavbarTextColor': "Navbar title text color",
    'setpg_snippetFontColorHint': "The system does not check whether the text color is readable on the chosen background — preview it before saving.",
    'setpg_snippetBubbleIcon': "Bubble Icon",
    'setpg_snippetBubbleColor': "Bubble Background Color",
    'setpg_snippetText': "Text",
    'setpg_snippetNavbarTitle': "Navbar Title",
    'setpg_snippetGreetingTh': "Greeting Message (Thai)",
    'setpg_snippetGreetingEn': "Greeting Message (English)",
    'setpg_snippetDefaultLanguage': "Default language",
    'setpg_snippetGreetingUserTh': "Greeting (logged-in, Thai)",
    'setpg_snippetGreetingUserEn': "Greeting (logged-in, English)",
    'setpg_snippetGreetingUserHint': "Use {'{'}name{'}'} for the user's name, e.g. Hello {'{'}name{'}'}",
    'setpg_snippetSuggestionKeywords': "Our Service menu",
    'setpg_snippetSuggestionKeywordsTh': "Service suggestions (Thai)",
    'setpg_snippetSuggestionKeywordsEn': "Service suggestions (English)",
    'setpg_snippetSuggestionKeywordsHint': "Type and press Enter to add · empty = use defaults",
    'setpg_snippetChipColor': "Chip Color",
    'setpg_snippetShowLogin': "Show Login Button in Widget",
    'setpg_snippetShowTranslate': "Show Language Switcher in Widget",
    'setpg_snippetShowHistory': "Show Chat History Sidebar in Widget",
    'setpg_snippetShowMic': "Show Microphone (Speech-to-Text) Button in Widget",
    'setpg_snippetWelcomeSection': "Welcome Screen Text",
    'setpg_snippetQuickChips': "Quick Chips",
    'setpg_snippetWelcomeTaglineTh': "Welcome Tagline (Thai)",
    'setpg_snippetWelcomeTaglineEn': "Welcome Tagline (English)",
    'setpg_snippetWelcomeSubtitle1Th': "Subtitle Line 1 (Thai)",
    'setpg_snippetWelcomeSubtitle1En': "Subtitle Line 1 (English)",
    'setpg_snippetWelcomeSubtitle2Th': "Subtitle Line 2 (Thai)",
    'setpg_snippetWelcomeSubtitle2En': "Subtitle Line 2 (English)",
    'setpg_snippetWelcomeBetaTh': "Beta Text (Thai)",
    'setpg_snippetWelcomeBetaEn': "Beta Text (English)",
    'setpg_snippetQuickChipsTh': "Quick Chips (Thai)",
    'setpg_snippetQuickChipsEn': "Quick Chips (English)",
    'setpg_snippetPreview': "Preview",
    'setpg_snippetPreviewChip1': "Suggested question 1",
    'setpg_snippetPreviewChip2': "Suggested question 2",
    'setpg_snippetSaved': "Snippet settings saved successfully",
    'setpg_snippetReset': "Reset to Default",
    'setpg_snippetFullSection': "Customize Full-Screen Snippet (Chat Widget)",
    'setpg_snippetFullScopeHint': "Applies only to the full-screen (FullV2) widget embedded on your site — the small widget and the in-portal chat page are not affected",
    'setpg_snippetShowUpload': "Show file/image attach buttons in widget",
    'setpg_snippetShowUploadHint': "When off, both the document and image attach buttons are hidden even if the current model supports uploads",
    'wdt_dirtyStructureMessage': "The structure has been changed — please save for the changes to take effect",
    'wdt_cancel': "Cancel",
    'wdt_save': "Save",
    'wdt_noWorkgroupForCompany': "No workgroups yet for this company",
    'wdt_saveFailed': "Save failed",
    'wdtn_addChild': "Add Child",
    'wdtn_edit': "Edit",
    'wdtn_delete': "Delete",
        'calpg_today': "Today",
    'calpg_week': "Week",
    'calpg_month': "Month",
    'calpg_scheduleName': "Schedule Name",
    'calpg_enterYourScheduleName': "Enter Your Schedule Name",
    'calpg_startDate': "Start Date",
    'calpg_cancel': "Cancel",
    'calpg_ok': "OK",
    'calpg_endDate': "End Date",
    'calpg_close': "Close",
    'calpg_save': "Save",
    'calpg_updateCalendarEvent': "Update Calendar Event",
    'calpg_update': "Update",
    'calpg_pleaseAddScheduleInformation': "Please add your schedule information",
    'calpg_confirmDeleteData': "Are you sure you want to delete this data?",
    'pgnd_hintClearMemory': ":clearmemory (clear short memory)",
    'pgnd_hintMemory': ":memory (show short memory)",
    'pgnd_hintLastMemory': ":lastmemory (show last memory of last conversation)",
    'pgnd_parameters': "Parameters",
    'pgnd_timeDelayModelA': "Time Delay Model A",
    'pgnd_timeDelayModelB': "Time Delay Model B",
    'pgnd_logModelA': "Log Model A",
    'pgnd_expandLogModelA': "Expand Log Model A",
    'pgnd_collapseLogModelA': "Collapse Log Model A",
    'pgnd_systemMessage': "System Message",
    'pgnd_knowledge': "Knowledge",
    'pgnd_sqlQuery': "SQL Query",
    'pgnd_sqlQueryResult': "SQL Query Result",
    'pgnd_intentFlow': "Intent Flow",
    'pgnd_memory': "Memory",
    'pgnd_llmsModel': "LLMs Model",
    'pgnd_modelIdLabel': "ModelID",
    'pgnd_modelNameLabel': "ModelName",
    'pgnd_providerLabel': "Provider",
    'pgnd_modelLabel': "Model",
    'pgnd_systemMessageNoSpace': "SystemMessage",
    'pgnd_knowledgeDocuments': "KnowledgeDocuments",
    'pgnd_extensionLabel': "Extension",
    'pgnd_descriptionLabel': "Description",
    'pgnd_genderLabel': "Gender",
    'pgnd_topNChunksLabel': "TopN_Chunks",
    'pgnd_internetLabel': "Internet",
    'pgnd_feedbackLabel': "Feedback",
    'pgnd_historyCountLabel': "HistoryCount",
    'pgnd_historyMinuteLabel': "HistoryMinute",
    'pgnd_temperatureLabel': "Temperature",
    'pgnd_topPLabel': "Top_P",
    'pgnd_frequencyPenaltyLabel': "Frequency_Penalty",
    'pgnd_presencePenaltyLabel': "Presence_Penalty",
    'pgnd_stopSequenceLabel': "Stop_Sequence",
    'pgnd_maxTokensResponseLabel': "MaxTokensResponse",
    'pgnd_isStreamLabel': "IsStream",
    'pgnd_endpointLabel': "Endpoint",
    'pgnd_vectorCosine': "Vector Cosine",
    'pgnd_privateMemory': "Private Memory",
    'pgnd_logModelB': "Log Model B",
    'pgnd_expandLogModelB': "Expand Log Model B",
    'pgnd_collapseLogModelB': "Collapse Log Model B",
    'pgnd_rename': "Rename",
    'pgnd_deleteChat': "Delete chat",
    'pgnd_modelA': "Model A",
    'pgnd_modelB': "Model B",
    'pgnd_modelName': "Model name",
    'pgnd_selectForCompareYourModel': "select for compare your model",
    'pgnd_create': "Create",
    'pgnd_edit': "Edit",
    'pgnd_save': "Save",
    'pgnd_clearModel': "Clear model",
    'pgnd_configurationA': "Configuration A",
    'pgnd_userId': "User Id",
    'pgnd_promptTemplate': "Prompt template",
    'pgnd_temperature': "Temperature*",
    'pgnd_temperatureHint': "Controls randomness: 0 = focused, 1 = creative",
    'pgnd_topP': "Top p*",
    'pgnd_topPHint': "Nucleus sampling parameter",
    'pgnd_frequencyPenalty': "Frequency penalty",
    'pgnd_frequencyPenaltyHint': "Reduces repetition of frequent tokens",
    'pgnd_presencePenalty': "Presence penalty",
    'pgnd_presencePenaltyHint': "Encourages new topics and ideas",
    'pgnd_you': "You",
    'pgnd_findingAnswer': "Finding answer ...",
    'pgnd_configurationB': "Configuration B",
    'pgnd_messageInputPlaceholder': "Type your message here... (Shift + Enter for new line)",
    'pgnd_sendMessage': "Send message",
    'pgnd_stopGeneration': "Stop generation",
    'pgnd_clearConversation': "Clear conversation",
    'pgnd_aiDisclaimer': "AI can make mistakes. Please double-check responses.",
    'rut_userReportManagement': "User Report Management",
    'rut_dateRange': "Date Range",
    'rut_startDate': "Start Date",
    'rut_selectStartDateForReport': "Select start date for report",
    'rut_endDate': "End Date",
    'rut_selectEndDateForReport': "Select end date for report",
    'rut_search': "SEARCH",
    'rut_top3Users': "Top 3 Users",
    'rut_questionsCount': "{n} Questions",
    'rut_userReportDataRecords': "User Report Data ({n} records)",
    'rut_loadingPleaseWait': "Loading Please Wait...",
    'rut_userId': "User ID",
    'rut_channelHeader': "Channel",
    'rut_hideTestChannelLabel': "Hide test data",
    'rut_hideTestChannelOn': "ON",
    'rut_hideTestChannelOff': "OFF",
    'rut_unknownChannel': "Other (real traffic, channel not further broken down)",
    // BUG3 fix: channel / page (PageName) filter + labels for the user report
    'rut_channelFilterLabel': "Channel / Page",
    'rut_channelAll': "All",
    'rut_channelSnippet': "Snippet",
    'rut_channelExternalAPI': "External API",
    'rut_channelChatPlayground': "Chat Playground",
    'rut_channelDualChatPlayground': "Dual Chat Playground",
    'rut_channelValidation': "Validation / Test Runner",
    'rut_channelOther': "Other",
    'rut_totalQuestions': "Total Questions",
    'rut_pleaseFillRequiredFields': "Please fill the required fields!!!",
    'ruu_downloadReport': "Download Report",
    'ruu_userUsageReportManagement': "User Usage Report Management",
    'ruu_dateRange': "Date Range",
    'ruu_startDate': "Start Date",
    'ruu_selectStartDateForReport': "Select start date for report",
    'ruu_endDate': "End Date",
    'ruu_selectEndDateForReport': "Select end date for report",
    'ruu_reportStatistics': "Report Statistics",
    'ruu_search': "Search",
    'ruu_userUsageDataRecords': "User Usage Data ({n} records)",
    'ruu_loading': "Loading...",
    'ruu_pleaseWait': "Please wait",
    'ruu_pleaseFillRequiredFields': "Please fill the required fields!!!",
    'ruu_userId': "User ID",
    'ruu_channelHeader': "Channel",
    'ruu_hideTestChannelLabel': "Hide test data",
    'ruu_hideTestChannelOn': "ON",
    'ruu_hideTestChannelOff': "OFF",
    'ruu_unknownChannel': "Other (real traffic, channel not further broken down)",
    // BUG3 fix: channel / page (PageName) filter + labels for the user usage report
    'ruu_channelFilterLabel': "Channel / Page",
    'ruu_channelAll': "All",
    'ruu_channelSnippet': "Snippet",
    'ruu_channelExternalAPI': "External API",
    'ruu_channelChatPlayground': "Chat Playground",
    'ruu_channelDualChatPlayground': "Dual Chat Playground",
    'ruu_channelValidation': "Validation / Test Runner",
    'ruu_channelOther': "Other",
    'ruu_totalQuestions': "Total Questions",
    'ruu_totalTokens': "Total Tokens",
    'ruu_imageGeneration': "Image Generation",
    'ruu_cachedTokens': "Cached Tokens",
    'ruu_reasoningTokens': "Reasoning Tokens",
    'saprof_required': "Required",
    'saprof_thaiId': "Thai ID",
    'saprof_dgaDigitalId': "DGA Digital ID",
    'saprof_thaId': "ThaID",
    'saprof_breadcrumbSuperAdmin': "Super Admin",
    'saprof_breadcrumbProfile': "Profile",
    'saprof_pleaseFillCorrectFormat': "Please fill correct format!",
    'sarnm_emptyValueDash': "—",
    'sec_addToken': "Add Token",
    'sec_loadingPleaseWait': "Loading... Please wait",
    'sec_copiedIndicator': "Copied! ✓",
    'sec_statusActive': "Active",
    'sec_statusExpired': "Expired",
    'sec_updatedOn': "Updated {date}",
    'sec_parameters': "Parameters",
    'sec_request': "Request",
    'sec_response': "Response",
    'sec_codeExamples': "Code Examples",
    'sec_responseExample': "Response Example",
    'sec_apiKeyDialogTitle': "API Key",
    'sec_apiKeyDialogSubtitle': "Your secure access token",
    'sec_apiKeyUsageHintPrefix': "Use this key in your application by passing it with the",
    'sec_apiKeyUsageHintSuffix': "parameter.",
    'sec_yourApiKey': "Your API Key",
    'sec_copyToClipboard': "Copy to clipboard",
    'sec_gotIt': "Got it",
    'sec_createNewTokenTitle': "Create New Token",
    'sec_renewTokenTitle': "Renew Token",
    'sec_createNewTokenSubtitle': "Generate a secure API access token for your application",
    'sec_renewTokenSubtitle': "Update the expiration date and settings for your existing token",
    'sec_basicInformation': "Basic Information",
    'sec_tokenName': "Token Name",
    'sec_enterTokenName': "Enter token name",
    'sec_emailAddress': "Email Address",
    'sec_enterEmailAddress': "Enter email address",
    'sec_currentApiKey': "Current API Key",
    'sec_expirationSettings': "Expiration Settings",
    'sec_presetDuration': "Preset Duration",
    'sec_presetDurationDescription': "Choose from common durations",
    'sec_customDate': "Custom Date",
    'sec_customDateDescription': "Set a specific expiration date",
    'sec_selectDate': "Select date",
    'sec_modelConfiguration': "Model Configuration",
    'sec_modelDisplay': "Model Display",
    'sec_selectModel': "Select model",
    'sec_modelGroup': "Model Group",
    'sec_selectGroup': "Select group",
    'sec_cancel': "Cancel",
    'sec_createTokenAction': "Create Token",
    'sec_updateTokenAction': "Update Token",
    'sec_revokeTokenTitle': "Revoke Token",
    'sec_revokeTokenSubtitle': "This action cannot be undone",
    'sec_revokeWarningPrefix': "This",
    'sec_revokeWarningApiKeyLabel': "API Key",
    'sec_revokeWarningSuffix': "will be permanently deleted and can no longer be used to make API requests.",
    'sec_tokenNameLabel': "Token Name:",
    'sec_keepToken': "Keep Token",
    'sec_revokeTokenAction': "Revoke Token",
    'sec_loadingEllipsis': "Loading...",
    'sec_headerKey': "Key",
    'sec_headerDescription': "Description",
    'sec_headerType': "Type",
    'sec_headerExample': "Example",
    'sec_headerNo': "No",
    'sec_headerTokenName': "Token name",
    'sec_headerEmail': "Email",
    'sec_headerEndDate': "End date",
    'sec_headerToken': "Token",
    'sec_headerStatus': "Status",
    'sec_headerActions': "Actions",
    'sec_menuRenew': "Renew",
    'sec_menuRevoke': "Revoke",
    'setuppg_configuration': "Configuration",
    'setuppg_gptConfiguration': "GPT Configuration",
    'setuppg_azureOpenAIEndpoints': "Azure OpenAI Endpoints",
    'setuppg_priority': "Priority",
    'setuppg_azureOpenAIUrl': "Azure OpenAI URL",
    'setuppg_apiKey': "API Key",
    'setuppg_addEndpoint': "Add Endpoint",
    'setuppg_embeddingConfiguration': "Embedding Configuration",
    'setuppg_embeddingUrl': "Embedding URL",
    'setuppg_embeddingApiKey': "Embedding API Key",
    'setuppg_embeddingApiVersion': "Embedding API Version",
    'setuppg_embeddingType': "Embedding Type",
    'setuppg_gptModeConfiguration': "GPT Mode Configuration",
    'setuppg_gptMode': "GPT Mode",
    'setuppg_priorityMode': "Priority",
    'setuppg_fastMode': "Fast",
    'setuppg_repeatTimeMinutes': "Repeat Time (Minutes)*",
    'setuppg_modelRequired': "Model*",
    'setuppg_testOfQuestionsRequired': "Test of Questions*",
    'setuppg_storageConfiguration': "Storage Configuration",
    'setuppg_azureBlobStorage': "Azure Blob Storage",
    'setuppg_storageConnection': "Storage Connection",
    'setuppg_containerName': "Container Name",
    'setuppg_pdfVectorStorage': "PDF Vector Storage",
    'setuppg_imageStorage': "Image Storage",
    'setuppg_speechDocumentStorage': "Speech Document Storage",
    'setuppg_quickReplyIconStorage': "Quick Reply Icon Storage",
    'setuppg_languageServices': "Language Services",
    'setuppg_translator': "Translator",
    'setuppg_languageService': "Language Service",
    'setuppg_speechToText': "Speech to Text",
    'setuppg_endpoint': "Endpoint",
    'setuppg_location': "Location",
    'setuppg_languageEndpoint': "Language Endpoint",
    'setuppg_languageKey': "Language Key",
    'setuppg_speechToTextKey': "Speech to Text Key",
    'setuppg_speechToTextRegion': "Speech to Text Region",
    'setuppg_speechToTextLanguage': "Speech to Text Language",
    'setuppg_ffmpegPath': "FFmpeg Path",
    'setuppg_ffmpegLocalPath': "FFmpeg Local Path",
    'setuppg_mailConfig': "Mail Config",
    'setuppg_emailHost': "Email Host",
    'setuppg_hostName': "Host Name",
    'setuppg_password': "Password",
    'setuppg_systemSettings': "System Settings",
    'setuppg_autoStream': "Auto Stream",
    'setuppg_enabled': "Enabled",
    'setuppg_disabled': "Disabled",
    'setuppg_anonymousMode': "Anonymous Mode",
    'setuppg_on': "On",
    'setuppg_off': "Off",
    'setuppg_timeDelayMs': "Time Delay (ms)",
    'setuppg_characterLimit': "Character Limit",
    'setuppg_forceDisableGpt': "Force Disable GPT",
    'setuppg_autoDisableGpt': "Auto Disable GPT",
    'setuppg_gptAutoDisableDatePeriod': "GPT Auto-Disable Date Period",
    'setuppg_gptAutoDisableMessage': "GPT Auto-Disable Message",
    'setuppg_gptAutoDisablePricingUsd': "GPT Auto-Disable Pricing (USD)",
    'setuppg_otherConfig': "Other Config",
    'setuppg_googleConfig': "Google Config",
    'setuppg_anthropicConfig': "Anthropic Config",
    'setuppg_projectId': "Project ID",
    'setuppg_locationId': "Location ID",
    'setuppg_jsonCredential': "JSON Credential",
    'setuppg_anthropicApiKey': "Anthropic API Key",
    'setuppg_singleSignOn': "Single Sign-On",
    'setuppg_singleSignOnProviderStatus': "Single Sign-On {provider}: {status}",
    'setuppg_open': "Open",
    'setuppg_close': "Close",
    'setuppg_singleSignOnProviderChatStatus': "Single Sign-On {provider} in Chat: {status}",
    'setuppg_instance': "Instance",
    'setuppg_issuerAuthorityUrl': "Issuer (Authority URL)",
    'setuppg_domain': "Domain",
    'setuppg_tenantId': "Tenant ID",
    'setuppg_clientId': "Client ID",
    'setuppg_redirectUrl': "Redirect URL",
    'setuppg_callbackPath': "Callback Path",
    'setuppg_clientSecret': "Client Secret",
    'setuppg_scope': "Scope",
    'setuppg_apiScope': "API Scope",
    'setuppg_urlJwks': "URL JWKS",
    'setuppg_urlConfig': "URL Config",
    'setuppg_addDgaDigitalId': "Add DGA Digital ID",
    'setuppg_microsoftEntraIdGroupConfiguration': "Microsoft Entra ID Group Configuration",
    'setuppg_syncSsoGroups': "Sync SSO Groups",
    'setuppg_savingConfiguration': "Saving configuration...",
    'setuppg_azureOpenAIUrlColumn': "AzureOpenAIUrl",
    'setuppg_responseTimeMilliseconds': "ResponseTime (Milliseconds)",
    'setuppg_answers': "Answers",
    'setuppg_applyChange': "Apply change",
    'setuppg_failedToReadFile': "Failed to read file!",
        'flowpg_exportFlow': "Export Flow",
    'flowpg_importFlow': "Import Flow",
    'flowpg_duplicateSelected': "Duplicate Selected",
    'flowpg_copySelected': "Copy Selected",
    'flowpg_pasteAction': "Paste",
    'flowpg_deleteSelected': "Delete Selected",
    'flowpg_clearFlow': "Clear Flow",
    'flowpg_saveButtonText': "Save",
    'flowpg_viewModeText': "View Mode",
    'flowpg_nodePropertiesTitle': "Node Properties",
    'flowpg_streamResponseTitle': "Stream Response",
    'flowpg_jsonResponseTitle': "JSON Response",
    'flowpg_returnStructuredJsonFormat': "Return structured JSON format",
    'flowpg_memorySettingsTitle': "Memory Settings",
    'flowpg_configureConversationMemoryContext': "Configure conversation memory and context",
    'flowpg_conversationMemoryLabel': "Conversation Memory",
    'flowpg_memoryTypesLabel': "Memory Types",
    'flowpg_longTermMemoryTitle': "Long-Term Memory",
    'flowpg_multiTurnInputConfigLabel': "Multi-turn Input Configuration",
    'flowpg_enableMultiTurnInputTitle': "Enable Multi-Turn Input",
    'flowpg_allowContinuousConversation': "Allow continuous conversation",
    'flowpg_aiParametersTitle': "AI Parameters",
    'flowpg_fineTuneModelBehaviorOutput': "Fine-tune model behavior and output",
    'flowpg_cacheSettingsTitle': "Cache Settings",
    'flowpg_configureResponseCachingPerformance': "Configure response caching for performance",
    'flowpg_enableCacheTitle': "Enable Cache",
    'flowpg_cacheResponsesReduceLlmCalls': "Cache responses to reduce LLM calls",
    'flowpg_semanticMatchTitle': "Semantic Match",
    'flowpg_matchSimilarQuestionsUsingAi': "Match similar questions using AI",
    'flowpg_lineConfigurationTitle': "Line Configuration",
    'flowpg_showNameTitle': "Show Name",
    'flowpg_loadingIndicatorTitle': "Loading Indicator",
    'flowpg_greetingMessageFirstInteraction': "Greeting message for first interaction",
    'flowpg_systemPromptTitle': "System Prompt",
    'flowpg_defineAiBehaviorPersonality': "Define AI behavior and personality",
    'flowpg_timeContextTitle': "Time Context",
    'flowpg_enableTimeAwarenessAiResponses': "Enable time awareness for AI responses",
    'flowpg_addTransactionIdToPromptTitle': "Add TransactionID to Prompt",
    'flowpg_includeTransactionIdentifierAiContext': "Include transaction identifier in AI context",
    'flowpg_closeButton': "Close",
    'flowpg_tipDefineToneStyle': "Define the tone and communication style",
    'flowpg_tipSpecifyUnknownHandling': "Specify how to handle unknown information",
    'flowpg_authorizationPlaceholder': "Authorization",
    'lmsg_clickToCopy': "Click to copy",
    'lmsg_nexaKnowledgeGraphWaterfall': "NEXA Knowledge (Graph / Waterfall)",
    'lmsg_noNexaGraphContext': "No NEXA graph / waterfall context for this turn",
    'lmsg_normalQuestion': "Normal Question",
    'lmsg_chainQuestion': "Chain Question",
    'lmsg_tokenUsage': "Token Usage",
    'lmsg_chatLogOption': "Chat Log",
    'lmsg_rawLog': "Raw Log",
    'lmsg_sqlLog': "SQL Log",
    'lmsg_intentLog': "Intent Log",
    'lmsg_errorLog': "Error Log",
    'lmsg_memoryDebugger': "Memory Debugger",
    'lmsg_flow': "Flow",
    'lmsg_inputMessage': "Input Message",
    'lmsg_outputMessage': "Output Message",
    'lmsg_logsId': "Logs ID",
    'lmsg_sessionIdHeader': "Session ID",
    'lmsg_userChannelHeader': "User Channel",
    'lmsg_createDate': "Create Date",
    'lmsg_responseTimeMs': "Response Time (ms)",
    'lmsg_copied': "Copied",
    'lmsg_copiedToClipboard': "copied to clipboard",
    'lmsg_pleaseSelectQuestionSetType': "Please select a Question Set Type.",
    'lmsg_nodeMessageInput': "Message Input",
    'lmsg_nodeIntentRouter': "Intent Router",
    'lmsg_nodeAiModel': "AI Model",
    'lmsg_nodeCache': "Cache",
    'lmsg_nodeAiModelProcessing': "AI Model Processing",
    'lmsg_nodeInterestOptimizer': "Interest Optimizer",
    'lmsg_nodeMessageOutput': "Message Output",
    'lmsg_nodeApiKnowledge': "API Knowledge",
    'lmsg_nodeDbIntegration': "DB Integration",
    'lmsg_nodeApiTrigger': "API Trigger",
    'lmsg_nodeContactAgent': "Contact Agent",
    'lmsg_nodeLoanInterest': "Loan Interest",
    'lmsg_nodeDocuments': "Documents",
    'lmsg_nodeVectorEmbedding': "Vector Embedding",
    'lmsg_nodeSummaryDocumentsMemory': "Summary Documents Memory",
    'lmsg_nodeKnowledgeGraph': "Knowledge Graph",
    'lmsg_nodeNexaWaterfall': "NEXA Waterfall",
    'lmsg_nodeMcp': "MCP",
    'lmsg_nodeAdvancedRouter': "Advanced Router",
    'lmsg_failedToLoadMonitorData': "Failed to load monitor data",
    'saCore_callbackPath': "CallbackPath",
    'saCore_clientSecret': "ClientSecret",
    'saCore_apiScope': "APIScope",
    'saCore_urlConfig': "URLConfig",
    'saCore_required': "Required.",
        'pgnd_allowPopupFullStream': "Please allow popups to open FullStream in a new tab",
    'pgnd_errorOccurred': "An error occurred",
    'pgnd_maxLengthCharError': "Please enter no more than",
    'pgnd_enterNumberRange0_1': "Please enter a number between 0 and 1 with 2 decimal places",
        'FlowResponseFieldMode': "Response Field Mode",
    'FlowResponseFields': "Response Fields",
    'FlowAddField': "Add Field",
    'FlowResponseFieldPath': "Field Path",
    'FlowApiTest': "API Test",
    'FlowApiTestSubtitle': "Test the API call to verify the response before using it in production",
    'FlowUseTestMessage': "Use Test Message",
    'FlowApiTestHowItWorksTitle': "How It Works",
    'FlowApiTestReplaceRule': "The system will replace the variables below with your specified test message",
    'FlowTestMessage': "Test Message",
    'FlowTestMessagePlaceholder': "Enter a test message",
    'FlowTestApi': "Test API",
    'FlowApiTestStatus': "Status",
    'FlowApiTestResponseTime': "Response Time",
    'FlowConfiguredResponseTitle': "Configured Response",
    'FlowConfiguredResponseDescription': "Result after applying the configured field filters",
    'FlowCollapseResponse': "Collapse Response",
    'FlowExpandResponse': "Expand Response",
    'FlowCopyResponse': "Copy Response",
    'FlowRawResponseTitle': "Raw Response",
    'FlowRawResponseDescription': "Original data received from the API without filtering",
    'FlowResponseFilterNone': "None",
    'FlowResponseFilterInclude': "Include Specified Fields",
    'FlowResponseFilterExclude': "Exclude Specified Fields",
    'FlowApiUrlRequired': "Please enter the API URL",
    'FlowApiTestSuccess': "API test succeeded",
    'FlowApiTestFailed': "API test failed",
    'FlowApiTestNoResponse': "No response data",
    'FlowCopyResponseSuccess': "Response copied",
    'FlowCopyResponseFailed': "Failed to copy response",
    'ConfirmDeletion': "Confirm Deletion",
    'Manage': "Manage",
    'Actions': "Actions",
    'Type': "Type",
    'SpecificText': "Specific Text",
    'Upload': "Upload",
    'Action': "Action",
    'Error': "Error",
    'default': "Default",
    'SystemUsageStat': "System Usage Statistics",
    'LoginUsersViaGov': "Users Logged In via Government System",
    'NonLoginUsersViaGov': "Users Not Logged In via Government System",
    'TotalUsersViaGovLabel': "Total Users via Government System",
    'HumanAnswer': "Human Answer",
    'records': "records",
    'ImportDataIntegration': "Import Data Integration",
    'status': "Status",
    'flowName': "Flow Name",
    'warningmaximumChatInput': "You have exceeded the maximum chat input length allowed",
    'Group': "Group",
    'Label': "Label",
    'Message': "Message",
    'Rank': "Rank",
    'confirmDeletionAzureOpenAI': "Are you sure you want to delete this Azure OpenAI configuration?",
    'modelType': "Model Type",
    'TenantId': "Tenant ID",
    'ClientId': "Client ID",
    'ClientSecret': "Client Secret",
    'setup': "Setup",
    'Template': "Template",
    'niframe_connectingToNexa': "Connecting to NEXA...",
    'niframe_cannotOpenService': "Cannot open NEXA service",
    'niframe_retry': "Retry",
    'niframe_iframeUrlNotSetYet': "Iframe URL not set yet.",
    'niframe_reload': "Reload",
    'niframe_noPayloadInResponse': "No payload in response.",
    'niframe_missingTokenOrBaseUrl': "Missing token or baseUrl from server.",
    'niframe_getEmbedTokenFailed': "GetEmbedToken failed",
    'npanel_nodes': "Nodes",
    'npanel_searchNodesPlaceholder': "Search nodes...",
    'npanel_collapse': "Collapse",
    'npanel_categoryInputOutput': "Input/Output",
    'npanel_categoryAI': "AI",
    'npanel_categoryIntent': "Intent",
    'npanel_categoryKnowledge': "Knowledge",
    'npanel_categoryActions': "Actions",
    'npanel_nodeMessageInput': "Message Input",
    'npanel_nodeMessageInputDesc': "User text input",
    'npanel_nodeResponse': "Response",
    'npanel_nodeResponseDesc': "Bot response output",
    'npanel_nodeAIModel': "AI Model",
    'npanel_nodeAIModelDesc': "Language model processor",
    'npanel_nodeIntentAIModel': "Intent AI Model",
    'npanel_nodeIntentAIModelDesc': "AI-powered intent detection",
    'npanel_nodeAdvancedRouter': "Advanced Router",
    'npanel_nodeAdvancedRouterDesc': "Hierarchical multi-level intent routing",
    'npanel_nodeIntentRouter': "Intent Router",
    'npanel_nodeIntentRouterDesc': "Handle specific intent",
    'npanel_nodeSmartIntent': "Smart Intent",
    'npanel_nodeSmartIntentDesc': "AI-enhanced intent handler with individual AI config",
    'npanel_nodeAPITrigger': "API Trigger",
    'npanel_nodeAPITriggerDesc': "Trigger external API action",
    'npanel_nodeContactAgent': "Contact Agent",
    'npanel_nodeContactAgentDesc': "Transfer to human agent",
    'npanel_nodeDocuments': "Documents",
    'npanel_nodeDocumentsDesc': "Document management and search",
    'npanel_nodeKnowledgeGraph': "Knowledge Graph",
    'npanel_nodeKnowledgeGraphDesc': "Retrieve context from NEXA graphs",
    'npanel_nodeWaterfallSearch': "Waterfall Search",
    'npanel_nodeWaterfallSearchDesc': "Tiered NEXA search: stop at first tier that hits",
    'npanel_nodeDatabaseIntegration': "Database Integration",
    'npanel_nodeDatabaseIntegrationDesc': "Connect to knowledge database",
    'npanel_nodeAPIKnowledge': "API Knowledge",
    'npanel_nodeAPIKnowledgeDesc': "Fetch knowledge from external API",
    'npanel_nodeMCPServer': "MCP Server",
    'npanel_nodeMCPServerDesc': "Model Context Protocol tools for the AI Model",
    'npanel_nodeEmail': "Email",
    'npanel_nodeEmailDesc': "Send an email to user",
    'mmd_thinking': "Thinking",
    'mmd_thinkingEllipsis': "Thinking...",
    'mmd_codeCopiedToClipboard': "Code copied to clipboard!",
    'mmd_failedToCopyCode': "Failed to copy code",
    'mmd_copyOperationFailed': "Copy operation failed",
        'flist_version': "Version",
    'flist_comment': "Comment",
    'flist_date': "Date",
    'flist_createdBy': "Created By",
    'flist_name': "Name",
    'flist_createdDate': "Created Date",
    'fnode_deleteNode': "Delete Node",
    'fnode_message': "Message",
    'fnode_userInput': "User Input",
    'fnode_apiCall': "API Call",
    'fnode_externalService': "External Service",
    'fnode_response': "Response",
    'fnode_botOutput': "Bot Output",
    'fnode_aiModel': "AI Model",
    'fnode_basePrompt': "Base Prompt",
    'fnode_intentAI': "Intent AI",
    'fnode_intentRouter': "Intent Router",
    'fnode_newIntentGroup': "New Intent Group",
    'fnode_priority': "Priority",
    'fnode_fallback': "Fallback",
    'fnode_noIntentMatch': "No intent match",
    'fnode_smartIntent': "Smart Intent",
    'fnode_newSmartIntentGroup': "New Smart Intent Group",
    'fnode_documentsKnowledge': "Documents Knowledge",
    'fnode_databaseIntegration': "Database Integration",
    'fnode_productsKnowledge': "Products Knowledge",
    'fnode_apiKnowledge': "API Knowledge",
    'fnode_databaseKnowledge': "Database Knowledge",
    'fnode_if': "If",
    'fnode_logicCheck': "Logic Check",
    'fnode_true': "True",
    'fnode_false': "False",
    'fnode_delay': "Delay",
    'fnode_seconds': "seconds",
    'fnode_variableDelay': "Variable Delay",
    'fnode_timeWait': "Time Wait",
    'fnode_switch': "Switch",
    'fnode_multiPath': "Multi-Path",
    'fnode_defaultCase': "Default Case",
    'fnode_fallbackPath': "Fallback path",
    'fnode_advancedRouter': "Advanced Router",
    'fnode_hierarchicalRouting': "Hierarchical Routing",
    'fnode_lowConfidenceOrNoMatch': "Low confidence or no match",
    'fnode_webhook': "Webhook",
    'fnode_httpNotify': "HTTP Notify",
    'fnode_action': "ACTION",
    'fnode_mailgun': "Mailgun",
    'fnode_smtp': "SMTP",
    'fnode_cc': "CC",
    'fnode_email': "Email",
    'fnode_configureRecipient': "Configure recipient",
    'fnode_apiTrigger': "API Trigger",
    'fnode_externalAction': "External Action",
    'fnode_contactAgent': "Contact Agent",
    'fnode_toDisabledBot': "To disabled bot",
    'fnode_documents': "Documents",
    'fnode_documentSearch': "Document Search",
    'fnode_mcp': "MCP",
    'fnode_notConfigured': "Not configured",
    'fnode_knowledgeGraph': "Knowledge Graph",
    'fnode_citationReferences': "Citation References",
    'fnode_waterfallSearch': "Waterfall Search",
    'fnode_tieredNexa': "Tiered NEXA",
    'fnode_dbIntegration': "DB Integration",
    'fnode_knowledgeBase': "Knowledge Base",
    'fnode_apiResponseKnowledge': "API Response Knowledge",
    'fnode_products': "Products",
    'fnode_productCatalog': "Product Catalog",
    'fnode_noModelSelected': "No Model Selected",
    'fnode_selectModel': "Select Model",
    'fnode_noModel': "No Model",
    'fnode_fileAccess': "File Access",
    'fnode_unnamed': "Unnamed",
    'fnode_nexaRetrieval': "NEXA Retrieval",
    'fnode_graphSingular': "graph",
    'fnode_graphsPlural': "graphs",
    'fnode_citationsOff': "Citations Off",
    'fnode_citationsOn': "Citations On",
    'mm_additionalSettings': "Additional Settings",
    'mm_adminOnly': "Admin Only",
    'mm_allowUsersUploadImagesHint': "Allow users to upload images for analysis",
    'mm_availableTemplates': "Available Templates",
    'mm_baselineMinSimilarity': "Baseline Min Similarity",
    'mm_baselineMinSimilarityHint': "For baseline-vector-only mode (0-1)",
    'mm_baselineTopK': "Baseline Top K",
    'mm_baselineTopKHint': "For baseline-vector-only mode (1-100)",
    'mm_basicInformation': "Basic Information",
    'mm_bot': "Bot",
    'mm_briefDescriptionHint': "Brief description of what this model does",
    'mm_chooseAFlow': "Choose a flow...",
    'mm_chooseArtisticStyleHint': "Choose the artistic style for generated images",
    'mm_chooseImageStyle': "Choose image style",
    'mm_chooseWorkflowIntegrationHint': "Choose the workflow integration for this model",
    'mm_close': "CLOSE",
    'mm_configureAiImageParamsHint': "Configure AI image generation parameters",
    'mm_configureSystemMessageForYourAI': "Configure system message for your AI",
    'mm_configureWorkflowIntegrationHint': "Configure workflow integration for this model",
    'mm_controlModelVisibility': "Control model visibility and availability across all platforms",
    'mm_cosineSimilarity': "Cosine Similarity",
    'mm_createMode': "Create Mode",
    'mm_database': "Database",
    'mm_defaultsMatchNexaRecommended': "Defaults shown match NEXA's recommended values. Leave as-is unless you need to tune retrieval for this specific model.",
    'mm_delete': "delete",
    'mm_describeModelPurpose': "Describe the model's purpose",
    'mm_description': "Description",
    'mm_detection': "Detection",
    'mm_displayLineNameInMonitorView': "Display line name in the monitor view",
    'mm_documentName': "Document Name",
    'mm_documents': "Documents",
    'mm_draft': "Draft",
    'mm_draftUpper': "DRAFT",
    'mm_durationMin': "Duration (min)",
    'mm_enableProgressiveTextGeneration': "Enable progressive text generation",
    'mm_enableTimeAwarenessHint': "Enable time awareness in responses",
    'mm_enterNumberBetween0And1': "Please enter a number between 0 and 1 with 2 decimal places",
    'mm_enterNumberBetween0And2': "Please enter a number between 0 and 2 with 2 decimal places",
    'mm_enterPromptWhenNoData': "Enter the Prompt when No data.",
    'mm_enterTheMessage': "Enter the message",
    'mm_enterUniqueModelName': "Enter a unique model name",
    'mm_enterYourSystemMessageHere': "Enter your system message here...",
    'mm_extension': "Extension",
    'mm_flowConfiguration': "Flow Configuration",
    'mm_flowConnected': "Flow Connected",
    'mm_flowIdLabel': "Flow ID",
    'mm_flowStatus': "Flow Status",
    'mm_forbiddenWord': "Forbidden word",
    'mm_frequencyPenalty': "Frequency Penalty",
    'mm_fuzzyThreshold': "Fuzzy Threshold",
    'mm_fuzzyThresholdHint': "Min fuzzy match score 0-100 (default 70)",
    'mm_gender': "Gender",
    'mm_genderFemale': "Female",
    'mm_genderMale': "Male",
    'mm_graphsFromNexaHint': "Graphs from NEXA — auto-queried during chat with this model",
    'mm_groupIntent': "Group Intent",
    'mm_guardRail': "Guard Rail",
    'mm_guardRailModel': "Guard Rail Model",
    'mm_imageGenerationSettings': "Image Generation Settings",
    'mm_imageResolutionPixelsHint': "Image resolution in pixels",
    'mm_imageSize': "Image Size",
    'mm_imageStyle': "Image Style",
    'mm_imageUpload': "Image Upload",
    'mm_includeLineNameInMonitoringInterface': "Include line name in monitoring interface",
    'mm_insertTemplate': "Insert Template",
    'mm_intent': "Intent",
    'mm_knowledge': "Knowledge",
    'mm_lineConfiguration': "Line Configuration",
    'mm_loading': "Loading",
    'mm_loadingBar': "Loading bar",
    'mm_loadingDuration': "Loading duration",
    'mm_longTermMemory': "Long-Term Memory",
    'mm_maxCharacterExceeded': "Please enter text not exceeding ",
    'mm_maxContextEdges': "Max Context Edges",
    'mm_maxContextEdgesHint': "Cap on returned edges (default 60)",
    'mm_maxContextNodes': "Max Context Nodes",
    'mm_maxContextNodesHint': "Cap on returned nodes (default 30)",
    'mm_maxHops': "Max Hops",
    'mm_maxHopsHint': "BFS depth from anchor nodes (default 3)",
    'mm_maxInputLength': "Max Input Length",
    'mm_maxTokensExceedLimit': "Max tokens cannot exceed the total tokens limit ",
    'mm_maxTokensResponse': "Max Tokens Response",
    'mm_maximumCharactersAllowedHint': "Maximum characters allowed",
    'mm_maximumFileSize': "Maximum file size",
    'mm_mediaAndContext': "Media & Context",
    'mm_memorySettings': "Memory Settings",
    'mm_model': "Model",
    'mm_modelConfiguration': "Model Configuration",
    'mm_modelIdExists': "Model ID is exist",
    'mm_modelIdLabel': "Model ID",
    'mm_modelInfo': "Model Info",
    'mm_modelIntegratedWithWorkflow': "Model is integrated with selected workflow",
    'mm_modelIsLiveAndAvailable': "Model is live and available for users",
    'mm_modelNameRequired': "Model Name*",
    'mm_modelRequired': "Model*",
    'mm_modelSavedNotAccessible': "Model is saved but not accessible to users",
    'mm_modelType': "Model Type",
    'mm_monitor': "Monitor",
    'mm_noFlowSelected': "No Flow Selected",
    'mm_noTemplatesAvailable': "No templates available",
    'mm_notAvailable': "N/A",
    'mm_optionalModelExtensionHint': "Optional model extension",
    'mm_parameters': "Parameters",
    'mm_pleaseEnterCorrectFormat': "Please Enter Correct Format!",
    'mm_pleaseSelectModel': "Please select model",
    'mm_pleaseSelectModelWarning': "Please select model",
    'mm_pleaseWait': "Please wait",
    'mm_presencePenalty': "Presence Penalty",
    'mm_promptForNoData': "Prompt for No data",
    'mm_promptTemplate': "Prompt Template",
    'mm_promptTemplates': "Prompt Templates",
    'mm_providerLabel': "Provider:",
    'mm_providerRequired': "Provider*",
    'mm_publicAccess': "Public Access",
    'mm_publicationControl': "Publication Control",
    'mm_publicationStatus': "Publication Status",
    'mm_published': "PUBLISHED",
    'mm_quality': "Quality",
    'mm_qualityLevel': "Quality Level",
    'mm_realisticNaturalLooking': "Realistic and natural looking",
    'mm_reasonHigh': "High",
    'mm_reasonLow': "Low",
    'mm_reasonMedium': "Medium",
    'mm_reasoningDepthHint': "Lets the model think through the problem longer before answering — higher is more accurate on complex questions, but slower and uses more tokens",
    'mm_reasoningEffort': "Reasoning Effort",
    'mm_recommended1024kbHint': "Recommended: 1024KB for most cases",
    'mm_required': "Required",
    'mm_resolution': "Resolution",
    'mm_responseOptions': "Response Options",
    'mm_responseSpeed': "Response Speed",
    'mm_samplingNotSupportedHint': "Not supported by gpt-5.x models — this value will not be sent to the provider.",
    'mm_save': "SAVE",
    'mm_saveAndClose': "SAVE & CLOSE",
    'mm_searchMode': "Search Mode",
    'mm_searchModeHint': "Anchor matching strategy (default fuzzy-first)",
    'mm_searchTemplates': "Search templates",
    'mm_selectAiProviderHint': "Select AI service provider",
    'mm_selectFlow': "Select Flow",
    'mm_selectFlowToEnableIntegration': "Select a flow to enable workflow integration",
    'mm_selectLevel': "Select level",
    'mm_selectModelVersionHint': "Select specific model version",
    'mm_selectTemplateGroup': "Select Template Group",
    'mm_selectYourTimezone': "Select your timezone",
    'mm_semanticThreshold': "Semantic Threshold",
    'mm_semanticThresholdHint': "Min cosine similarity 0-1 (default 0.65)",
    'mm_shortTermMemory': "Short-Term Memory",
    'mm_showLineName': "Show Line Name",
    'mm_speedFast': "Fast",
    'mm_speedMedium': "Medium",
    'mm_speedOfTextGenerationHint': "Speed of text generation",
    'mm_speedSlow': "Slow",
    'mm_sqlExtractionModel': "SQL Extraction Model",
    'mm_statusInfo': "Status Info",
    'mm_stopSequence': "Stop Sequence",
    'mm_streamResponse': "Stream Response",
    'mm_styleNatural': "Natural",
    'mm_styleVivid': "Vivid",
    'mm_systemMessage': "System Message",
    'mm_tableName': "Table Name",
    'mm_temperatureRequired': "Temperature*",
    'mm_templates': "templates",
    'mm_testingMode': "Testing mode",
    'mm_textReplacement': "Text Replacement",
    'mm_timeContext': "Time Context",
    'mm_timeZone': "Time Zone",
    'mm_topNChunks': "Top-N Chunks",
    'mm_topP': "Top P",
    'mm_turn': "Turn",
    'mm_typeLabel': "Type:",
    'mm_typingSpeed': "Typing Speed",
    'mm_tzAustralia': "Australia",
    'mm_tzEngland': "England",
    'mm_tzHongKong': "Hong Kong",
    'mm_tzJapan': "Japan",
    'mm_tzThailand': "Thailand",
    'mm_tzUsa': "USA",
    'mm_uniqueIdentifierHint': "A unique identifier for your model",
    'mm_updateMode': "Update Mode",
    'mm_usersCanAccess': "Users can access",
    'mm_versionLabel': "Version:",
    'mm_vibrantDramaticStyle': "Vibrant and dramatic style",
    'mm_viewMode': "View Mode",
    'mm_warningSelectStyleAndFormat': "Please select style image and response format image",
    'navb_newChat': "New chat",
    'navb_settings': "Settings",
    'navb_logout': "Logout",
    'navb_login': "LOGIN",
    'navb_openSidebar': "Open sidebar",
    'navb_llmsDefault': "LLMs (default)",
    'navb_selectLlmModel': "Select LLM Model",
    'navb_closeSidebar': "Close sidebar",
    'navb_version': "Version",
        'dintd_fillAllDataType': "Please Fill All The Data Type!",
    'dintd_columnNameNoLeadingTrailingSpaces': "Column name cannot have leading or trailing spaces!",
    'dintd_pleaseValidateAllColumnsBeforeSaving': "Please validate all columns\nbefore saving.",
    'dintd_errorOccurred': "Error occurred",
    'dintd_noWorksheetFoundInExcelFile': "No worksheet found in the Excel file",
    'dintd_dataInColumnRowExceedsLimit': "The data in column {column}, row {row} exceeds the limit of 800 characters.",
    'perm_pid': "PID",
    'perm_loadingPleaseWait': "Loading Please Wait...",
    'perm_permissionNameHeader': "Permission Name",
    'perm_groupNameHeader': "Group Name",
    'perm_editHeader': "Edit",
    'perm_pleaseEnterGroupName': "Please enter Group Name!!",
    'perm_noGroup': "No Group",
    'perm_pleaseFillAllFields': "Please fill all fields!!",
    'pdet_productNameRequiredTitle': "Product Name Required",
    'pdet_productNameRequiredBeforeSaveText': "Please enter a Product Name before saving.",
    'pdet_productDetailRequiredTitle': "Product detail Required",
    'pdet_productDetailRequiredBeforeSaveText': "Please enter a Product detail before saving.",
    'pdet_productGroupNameRequiredBeforeSaveText': "Please enter a Product Group Name before saving.",
    'pdet_productAddedSuccess': "Product added successfully",
    'pdet_productUpdatedSuccess': "Product updated successfully",
    'pdet_allDataSavedSuccess': "All data saved successfully",
    'pdet_unsavedChangesTitle': "Unsaved Changes",
    'pdet_unsavedChangesText': "You have unsaved changes. Are you sure you want to close without saving?",
    'pdet_yesClose': "Yes, close",
    'pdet_noKeepEditing': "No, keep editing",
    'pgrp_productGroupName': "Product Group Name",
    'pgrp_search': "Search",
    'pgrp_updateBy': "Update By",
    'pgrp_updateDate': "Update date",
    'pgrp_deleteProductGroupTitle': "Delete Product Group",
    'pgrp_deleteProductGroupText': "Are you sure you want to delete this product group? This action cannot be undone.",
    'rfb_likeDislike': "Like/Dislike",
    'rfb_percentage': "Percentage",
    'rfb_numberOfFeedback': "Number of feedback",
    'landingPageConfig.breadcrumbRoot': "Super Admin",
    '_sa_role_user': "User",
    '_sa_role_snippet': "Snippet",
    '_sa_role_msTeams': "MS Teams",
    '_sa_role_operator': "Operator",
    '_sa_excel_sheetUsers': "Users",
    '_sa_excel_headerEmail': "Email",
    'ugd_warning': "Warning",
    'ugd_pleaseFillConfirmPassword': "Please fill Confirm Password",
    'ugd_pleaseFillPassword': "Please fill Password",
    'ugd_pleaseFillPasswordAndConfirmPassword': "Please fill Password and Confirm Password",
    'ugd_passwordConfirmMismatch': "Password and Confirm Password do not match. Please fill correctly.",
    'ugd_pleaseFillAllFieldsExclaim': "Please fill all the fields!!!",
        'flowpg_configureYourAiModelSettingsAndParameters': "Configure your AI model settings and parameters",
    'flowpg_loadFromModel': "Load from Model",
    'flowpg_useBaseModelPrompt': "Use Base Model Prompt",
    'flowpg_combineWithDefaultModelPrompt': "Combine with the default model prompt",
    'flowpg_responseCache': "Response Cache",
    'flowpg_cacheWillSkipWhenStreamingOrDataIntegrations': "Cache will skip when streaming is enabled or when data integrations are used.",
    'flowpg_configureYourIntentAiModelSettingsAndParameters': "Configure your Intent AI model settings and parameters",
    'flowpg_webSearchDomains': "Web Search Domains",
    'flowpg_webSearchDomainsHint': "Domains this node may search the web on (e.g. dga.or.th) — ≥ 1 enables (searches every question, slower), empty disables; not inherited from the model management page (Azure models only, max 20)",
    'flowpg_webSearchNotSupported': "This node's model does not support Web Search (Azure models only) — saved but has no effect at flow runtime",
    'pgnd_imageDownloading': "The image is downloading...",
    'pgnd_update': "Update",
    'pgnd_yourModel': "your model",
    'pgnd_confirmTo': "Please confirm to",
    'pgnd_loadingPleaseWait': "Loading Please Wait...",
    'pgnd_commandNotSupported': "Command is not support for this page",
    'uvec_processTypeAdd': "Add",
    'uvec_processTypeReplace': "Replace",
    'uvec_originalText': "text_org",
    'uvec_translatedText': "text_en",
    'uvec_required': "Required.",
    'uvec_duplicate': "Duplicate",
    'uvec_pleaseFillAllFields': "Please Fill All The Fields!",
    'uvec_pleaseFillCustomMaxCharacter': "Please fill in the Custom Max Character",
        'invm_statusPending': "Pending",
    'invm_statusUsed': "Used",
    'invm_statusExpired': "Expired",
    'invm_statusRevoked': "Revoked",
    'invm_statusRejected': "Rejected",
        'sec_doc1': "Versioned API v0",
    'sec_doc2': "Versioned API v1",
    'sec_doc3': "Versioned API v2",
    'sec_doc4': "Versioned API v3",
    'sec_doc5': "30 Days",
    'sec_doc6': "60 Days",
    'sec_doc7': "90 Days",
    'sec_doc8': "120 Days",
    'sec_doc9': "Embed scripts for standard chat, FullStream, and FullStream V2 on an external website.",
    'sec_doc10': "Domain token / generated snippet settings",
    'sec_doc11': "Authenticates an external user and returns a JWT token for legacy v0 ExternalAPI calls.",
    'sec_doc12': "Public username/password",
    'sec_doc13': "Creates or appends one text item into the configured vector database for external knowledge import.",
    'sec_doc14': "Imports multiple text chunks into a vector database in one request.",
    'sec_doc15': "Selects or changes the active model for an external chat user using the same runtime as chat commands.",
    'sec_doc16': "Sends a normal external chat message into the ChatFramework runtime and returns the bot reply.",
    'sec_doc17': "Sends a chat message with custom prompt context for retrieval or controlled answer generation.",
    'sec_doc18': "Imports portal users from an external system and returns duplicate or validation details.",
    'sec_doc19': "Imports chat users with social user mapping, group model, and quick model group fields.",
    'sec_doc20': "Agency-style chat endpoint with responseTime and a structured userMessage/botMessage response.",
    'sec_doc21': "Api-Key: <api-key from Token Management>",
    'sec_doc22': "Returns external chat history for a user after resolving company context from Api-Key or related headers.",
    'sec_doc23': "Clears external chat history for a user in the resolved company context.",
    'sec_doc24': "External API documentation for ChatFramework integration.",
    'sec_doc25': "See endpoint notes",
        'strm_aiDisclaimer': "AI can make mistakes. Please double-check responses.",
    'csvc_tabAll': "All",
    cookieBannerTitle: 'This website uses cookies',
    cookieBannerDesc: 'We use strictly necessary cookies to keep sign-in and security working, and functional cookies to remember your preferences.',
    cookieBannerPolicyLink: 'Read the cookie policy',
    cookieBannerAcceptAll: 'Accept all',
    cookieBannerNecessaryOnly: 'Necessary only',
    cookieBannerSettings: 'Cookie settings',
    cookieBannerAcknowledge: 'Got it',
    cookieSettingsTitle: 'Cookie privacy settings',
    cookieSettingsIntro: 'You can choose which categories of cookies to allow, except strictly necessary cookies, which must stay on for the website to work.',
    cookieCatNecessaryTitle: 'Strictly necessary cookies',
    cookieCatNecessaryDesc: 'Required for sign-in, security, and core website functionality, so they cannot be turned off.',
    cookieCatNecessaryAlways: 'Always on',
    cookieCatFunctionalTitle: 'Functional cookies',
    cookieCatFunctionalDesc: 'Help remember your chosen language (Thai/English) and keep you signed in for a smoother experience.',
    cookieSettingsSave: 'Save settings',
    cookiePageTitle: 'Cookie Policy',
    cookiePageUpdatedLabel: 'Last updated',
    cookiePageUpdatedValue: '6 July 2026',
    cookiePageIntro: 'This Cookie Policy explains how the website and services of the Digital Government Development Agency (Public Organization), or DGA, use cookies and similar technologies, so that you understand why they are used and can manage your consent. It should be read together with the DGA Privacy Policy.',
    cookiePageWhatTitle: 'What are cookies?',
    cookiePageWhatBody: 'Cookies are small text files that a website stores on your device when you visit, in order to remember certain information such as your sign-in state or chosen language. Alongside cookies, we also use in-browser storage (such as Local Storage and Session Storage) in a similar way. In this policy, these are referred to collectively as "cookies".',
    cookiePageTypesTitle: 'Types of cookies we use',
    cookiePageTypesIntro: 'We group cookies by their purpose into two categories, as follows.',
    cookiePageNecessaryBody: 'These cookies are essential for the basic operation of the website, such as maintaining your sign-in state, authentication, and security. Without them, the website cannot function correctly. They therefore cannot be turned off, and consent is not legally required for them, but we will always inform you.',
    cookiePageFunctionalBody: 'These cookies improve convenience, such as remembering your chosen language (Thai/English) and keeping you signed in. You can accept or decline them. Declining may make some features less convenient, but you can still use the website as normal.',
    cookiePageNoTrackingNote: 'This website does not currently use analytics cookies or advertising/marketing cookies, and does not share cookie data with third parties for such purposes.',
    cookiePageTableTitle: 'Details of the cookies we use',
    cookiePageColName: 'Name',
    cookiePageColPurpose: 'Purpose',
    cookiePageColType: 'Type',
    cookiePageColRetention: 'Retention',
    cookiePurposeAuth: 'Maintains your sign-in state and authenticates the user',
    cookiePurposeCsrf: 'Protects against cross-site request forgery (CSRF)',
    cookiePurposeSession: 'Stores temporary state during your session',
    cookiePurposeConsent: 'Stores your cookie consent choices',
    cookiePurposeLocale: 'Remembers your chosen language (Thai/English)',
    cookiePurposeRemember: 'Keeps you signed in for convenience next time',
    cookieRetentionSession: 'Session',
    cookieRetentionUntilClosed: 'Until the tab/browser is closed',
    cookieRetentionPersistent: 'Until browser data is cleared',
    cookiePageManageTitle: 'Managing your cookies',
    cookiePageManageBody: 'You can manage or delete cookies through your browser settings. Note that deleting necessary cookies may prevent you from signing in or using parts of the website.',
    cookiePageChangesTitle: 'Changes to this policy',
    cookiePageChangesBody: 'We may update this Cookie Policy from time to time to reflect changes in our services or legal requirements. If we make a significant change, we will show the consent banner again and update the last-updated date at the top of this page.',
    cookiePageContactTitle: 'Contact us',
    cookiePageContactBody: 'If you have questions about this Cookie Policy, or wish to exercise your rights regarding personal data under the Personal Data Protection Act B.E. 2562 (PDPA), you can contact the Digital Government Development Agency (Public Organization) at:',
    ugrp_editGroup: 'Edit group',
    ugrp_deleteGroup: 'Delete group',
    gum_editGroupTooltip: 'Manage group users',
    gum_deleteGroupTooltip: 'Delete security group',
    ugd_editUserTooltip: 'Edit user',
    ugd_deleteUserTooltip: 'Remove user from group',
    umgt_togglePasswordVisibility: 'Show/hide password',
    umgt_editUser: 'Edit user',
    umgt_deleteUser: 'Delete user',
    ucm_togglePasswordVisibility: 'Show/hide password',
    ucm_editUser: 'Edit user',
    ucm_deleteUser: 'Delete user',
    uprof_toggleIdCardVisibility: 'Show/hide ID card number',
    uprof_togglePasswordVisibility: 'Show/hide password',
    uprof_changeAvatar: 'Change profile picture',
    perm_editPermission: "Edit this role's permission and groups",
    bcum_removeFromBlacklist: 'Remove from blacklist (restore chat access)',
    invm_resendInvite: 'Resend the invitation email',
    invm_revokeInvite: 'Revoke this invitation (link will stop working)',
    mdata_toggleApiKeyVisibility: 'Show/hide API key',
    mdata_copyPlaceholderHint: 'Click to copy / drag in',
    mdata_maxTokenHint: 'Max tokens per request',
    mquick_removeChannel: 'Remove this channel',
    mquick_addChannel: 'Add channel',
    gmnm_fewShotExampleHint: 'Few-shot example pair: role = speaker (user/assistant), content = the example message',
    gmnd_fewShotExampleHint: 'Few-shot example pair: role = speaker (user/assistant), content = the example message',
    mqg_viewGroupModels: 'View models in group',
    mqr_viewGroupModels: 'View models in group',
    mqg_viewModelNewTab: 'Open model details in a new tab',
    mqr_viewModelNewTab: 'Open model details in a new tab',
    gmm_moreActions: 'More actions',
    gmm_editModelConfig: 'Edit model configuration',
    flowpg_moreActionsTooltip: 'More actions',
    flowpg_toggleInspectorSizeTooltip: 'Expand / collapse panel',
    flowpg_closeInspectorTooltip: 'Close properties panel',
    flowpg_moveTierUpTooltip: 'Move tier up',
    flowpg_moveTierDownTooltip: 'Move tier down',
    flowpg_removeTierTooltip: 'Remove tier',
    flowpg_toggleVariablesTooltip: 'Show / hide variables',
    flowpg_toggleDocumentDataTooltip: 'Expand / collapse data selection',
    flowpg_usePromptTemplateTooltip: 'Use this template',
    flowpg_addRowTooltip: 'Add item',
    flowpg_removeRowTooltip: 'Remove item',
    flowpg_deleteEntryTooltip: 'Delete entry',
    fedge_removeConnection: 'Delete connection',
    fnode_toggleBranchTooltip: 'Expand / collapse children',
    npanel_togglePanelTooltip: 'Collapse / expand palette',
    fnode_handleInputTooltip: 'Input',
    fnode_handleOutputTooltip: 'Output',
    fnode_handleTrueTooltip: 'True',
    fnode_handleFalseTooltip: 'False',
    fnode_handleFallbackTooltip: 'Fallback',
    fnode_handleModelAttachTooltip: 'Attach model',
    dint_editTableTooltip: 'Edit this data integration table configuration',
    dint_deleteTableTooltip: 'Delete this data integration table and all its data',
    dint_removeColumn: 'Remove this column',
    uvec_embeddingProgressTooltip: 'Chunks embedded / total — click to refresh status',
    uvec_reprocessNeededBadge: 'Unsaved changes need reprocessing — click Reprocess to re-embed',
    uvec_vectorToggleTooltip: 'Enable/disable this chunk for semantic (RAG) retrieval',
    ucsv_moreActionsTooltip: 'More actions (share / duplicate / replace / version history)',
    ucsv_versionActionsTooltip: 'Version actions (restore / view)',
    ucsv_downloadExcelTooltip: 'Download this document as an Excel (.xlsx) file',
    ucsv_deleteDocumentTooltip: 'Delete this document and all its vector chunks',
    dintd_paginationFirstPage: 'Go to first page',
    dintd_paginationPreviousPage: 'Previous page',
    dintd_paginationNextPage: 'Next page',
    dintd_paginationLastPage: 'Go to last page',
    dintd_validateColumnTooltip: "Auto-detect and validate this column's data type from the external source",
    dintd_removeColumnTooltip: 'Remove this column from the configuration',
    dintd_uploadExcelTooltip: 'Upload an Excel file to bulk-import data rows',
    kgl_editDescriptionTooltip: "Click to edit this knowledge graph's name and description",
    usdd_botSummationTooltip: 'Enable AI summarization of the uploaded audio',
    usd_processStatusTooltip: 'Audio files transcribed / total',
    usdd_filesSelectedTooltip: 'Number of selected files',
    rtext_downloadTemplateTooltip: 'Download a sample CSV template for importing replacement text',
    rtext_uploadCsvTooltip: 'Import replacement pairs from a CSV or Excel file',
    scmenu_viewModelTooltip: 'Open model details in a new tab',
    scmenu_uploadImageTooltip: 'Upload an icon image for this shortcut (auto-resized, .jpg/.png)',
    mmgt_editMenuTooltip: 'Edit / assign user groups to this menu',
    pdet_editCategoryTooltip: 'Edit category name',
    pdet_confirmEditCategoryTooltip: 'Confirm category name change',
    pdet_removeCategoryTooltip: 'Remove category',
    pdet_removeImageTooltip: 'Remove selected image',
    pdet_addCategoryTooltip: 'Add new category',
    pdet_reprocessTooltip: 'Rebuild product vector embeddings for AI search',
    igrp_editTooltip: 'Manage intent sessions in this group',
    igrp_deleteTooltip: 'Delete this intent group and its sessions',
    isess_editTooltip: 'Edit intent session details',
    isess_deleteTooltip: 'Delete this intent session',
    isd_toggleFullTextTooltip: 'Show / collapse full text',
    isd_deleteHeaderTooltip: 'Remove this header',
    isd_deleteValidationTooltip: 'Remove this validation rule',
    isd_deleteActionTooltip: 'Delete this action',
    isd_insertVariableTooltip: 'Click or drag to insert this variable into the JSON',
    vgen_editTooltip: 'Edit question-set configuration',
    vgen_downloadTooltip: 'Download generated questions as CSV',
    vgen_deleteTooltip: 'Delete this generated question set',
    vgu_infoPromptMore: 'Extra instructions appended to the question-generation prompt',
    vneg_editTooltip: 'Edit negative question set',
    vneg_deleteTooltip: 'Delete this entire negative question set',
    vnd_removeFileTooltip: 'Remove this file',
    vnd_deleteRowTooltip: 'Delete this negative question',
    vpos_editTooltip: 'Edit positive question set',
    vpos_deleteTooltip: 'Delete this entire positive question set',
    vpd_removeFileTooltip: 'Remove this file',
    vpd_editRowTooltip: 'Edit this question and answer',
    vpd_deleteRowTooltip: 'Delete this question and answer',
    vpd_closeDialogTooltip: 'Close',
    vproc_editTooltip: 'Edit test-run configuration',
    vproc_downloadTooltip: 'Download test-run answers (CSV)',
    vproc_deleteTooltip: 'Delete this test run',
    chatinput_send: 'Send message',
    chatinput_skip: 'Skip this step',
    chatinput_suggestions: 'Suggested prompts',
    chatinput_scrollBottom: 'Scroll to latest',
    welcome_scrollLeft: 'Scroll left',
    welcome_scrollRight: 'Scroll right',
    pgnd_downloadImage: 'Download image',
    pgnd_closePreview: 'Close preview',
    strm_sendMessage: 'Send message',
    strm_stopGeneration: 'Stop response',
    strm_clearConversation: 'Clear conversation',
    strm_voiceInput: 'Voice input',
    strm_stopVoice: 'Stop recording',
    strm_uploadAudioFile: 'Upload audio file',
    strm_attach: 'Attach file',
    strm_topicOptions: 'Topic options',
    strm_expandPanel: 'Expand',
    strm_collapsePanel: 'Collapse',
    strm_removeAttachment: 'Remove attachment',
    csvc_sendMessage: 'Send message',
    csvc_attachFile: 'Attach file',
    csvc_filter: 'Filter conversations',
    csvc_toggleAdminReply: 'Toggle admin/bot reply',
    csvc_removeFile: 'Remove file',
    csvc_addMoreFiles: 'Add more files',
    fsdrawer_close: 'Close drawer',
    fsdrawer_newChat: 'New chat',
    fsdrawer_folderOptions: 'Folder options',
    fsdrawer_topicOptions: 'Topic options',
    fsdrawer_createFolder: 'Create new folder',
    StreamSendMessage: 'Send message',
    StreamStopGeneration: 'Stop response',
    StreamClearConversation: 'Clear conversation',
    StreamVoiceInput: 'Voice input',
    StreamStopVoice: 'Stop recording',
    StreamUploadAudio: 'Upload audio file',
    StreamAttachDocument: 'Attach document',
    StreamSelectModel: 'Select model',
    StreamEditDocument: 'Edit document',
    StreamDeleteDocument: 'Delete document',
    StreamRemoveImagePreview: 'Remove image',
    StreamRemoveFilePreview: 'Remove file',
    StreamPrivateMemoryFileMenu: 'More options',
    StreamScrollToBottom: 'Scroll to bottom',
    StreamScrollShortcutsLeft: 'Scroll left',
    StreamScrollShortcutsRight: 'Scroll right',
    StreamTogglePrivateMemoryActive: 'Toggle file in RAG',
    StreamToggleChunkActive: 'Toggle chunk',
    StreamToggleTextExpand: 'Expand/collapse text',
    StreamCloseFeedbackDialog: 'Close feedback',
    StreamEditFile: 'Edit',
    StreamDeleteFile: 'Delete',
    StreamEditChunk: 'Edit',
    StreamDeleteChunk: 'Delete',
    fs2OpenUserMenu: 'Open account menu',
    fs2FolderMenu: 'Folder options',
    fs2TopicMenu: 'Topic options',
    dash_exportAllTooltip: 'Download the full dashboard as Excel',
    dash_totalUserTooltip: 'Each day\'s count of users who logged in via Government Gateway, added up across the range — e.g. someone active on 3 days counts as 3, not 1',
    dash_totalQueryTooltip: 'Total chat queries in the range',
    dash_totalModelsTooltip: 'Count of distinct LLM models used',
    dash_totalTokensAllTooltip: 'Total tokens across all types',
    dash_showPriceTooltip: 'On: THB price; Off: raw token counts',
    dash_chatNonCachedTooltip: 'Chat prompt tokens not served from cache',
    dash_chatCachedTooltip: 'Chat prompt tokens served from cache',
    dash_chatCompletionTooltip: 'Completion tokens generated by chat models',
    dash_embeddingInputTooltip: 'Tokens used for embedding calls',
    dscore_reprocessTooltip: 'Re-run validation scoring with a chosen model/prompt',
    dscore_calculateScoresTooltip: 'Enable to use a custom scoring prompt',
    rfb_downloadTooltip: 'Export the feedback report to Excel',
    rfb_searchTooltip: 'Search feedback data',
    rfb_toggleReplyTooltip: 'Show/hide the full reply text',
    rqt_processTooltip: 'Generate the top-10 questions',
    rqt_refreshTooltip: 'Refresh processing status',
    rts_downloadTooltip: 'Export the token summation report to Excel',
    rts_modelsCountTooltip: 'Total models in the filtered report',
    rts_searchTooltip: 'Search the token summation report',
    rts_inputTokensTooltip: 'Total prompt (input) tokens',
    rts_outputTokensTooltip: 'Total completion (output) tokens',
    rts_totalTokensTooltip: 'Total tokens (input + output)',
    rts_imageGenTooltip: 'Image-generation requests',
    rts_cachedTooltip: 'Tokens served from cache',
    rts_reasoningTooltip: 'Reasoning tokens (e.g. o1/o3)',
    rut_countTooltip: 'Total questions by this user',
    rut_totalQuestionsTooltip: 'Total questions per user',
    rut_hideTestChannelTooltip: 'When enabled, hides data from Chat Playground, Stream preview, and Test Runner from this report. Legacy rows without a Channel value (Unknown) are never hidden.',
    rut_userIdTooltip: 'IDs prefixed DCP- come from Dual Chat Playground, CP- from Chat Playground (Stream), and ETR-/VG- from Test Runner (Validation). IDs without a prefix are real users from actual channels such as Line, Facebook, Teams, or External API.',
    ruu_downloadTooltip: 'Export the per-user usage report to Excel. The downloaded file includes the Channel column and reflects the current "Hide test data" filter state on this screen.',
    ruu_hideTestChannelTooltip: 'When enabled, hides data from Chat Playground, Stream preview, and Test Runner from this report. Legacy rows without a Channel value (Unknown) are never hidden.',
    ruu_userIdTooltip: 'IDs prefixed DCP- come from Dual Chat Playground, CP- from Chat Playground (Stream), and ETR-/VG- from Test Runner (Validation). IDs without a prefix are real users from actual channels such as Line, Facebook, Teams, or External API.',
    ruu_usersCountTooltip: 'Users with activity in the range',
    ruu_totalQuestionsTooltip: 'Total questions per user',
    ruu_totalTokensTooltip: 'Total tokens per user',
    ruu_imageGenerationTooltip: 'Image-generation requests per user',
    ruu_cachedTokensTooltip: 'Cached tokens per user',
    ruu_reasoningTokensTooltip: 'Reasoning tokens per user',
    levt_expandDateRangeTooltip: 'Expand/collapse date range',
    levt_expandFiltersTooltip: 'Expand/collapse filters',
    levt_clearFiltersTooltip: 'Clear all filters',
    lmsg_toggleReplyTooltip: 'Show/hide full reply message',
    lmsg_togglePromptTooltip: 'Show/hide full prompt message',
    lmsg_copyInputJsonTooltip: 'Copy input data as JSON',
    lmsg_copyOutputSummaryTooltip: 'Copy output summary',
    lmsg_copyContextTextTooltip: 'Copy full context text',
    lmsg_copyWfInputJsonTooltip: 'Copy waterfall input as JSON',
    lmsg_copyWfOutputSummaryTooltip: 'Copy waterfall output summary',
    lmsg_winningLayerTooltip: 'Winning layer (best match)',
    lmsg_copyWfContextTextTooltip: 'Copy full waterfall context text',
    lmsg_copyMcpInputJsonTooltip: 'Copy MCP input as JSON',
    lmsg_copyMcpOutputSummaryTooltip: 'Copy MCP output summary',
    lmsg_toolCallStatusTooltip: 'Tool-call result status',
    lmsg_copyAiRequestJsonTooltip: 'Copy AI request as JSON',
    lmsg_copyAiResponseJsonTooltip: 'Copy AI response as JSON',
    lmsg_copyIntentNameTooltip: 'Copy intent name',
    lmsg_copyIntentMessageTooltip: 'Copy intent message',
    lmsg_copyIntentReplyTooltip: 'Copy intent reply',
    lmsg_copyApiUrlTooltip: 'Copy API URL',
    lmsg_usageStatusTooltip: 'Usage status (used/skipped)',
    lmsg_copyApiEndpointTooltip: 'Copy API endpoint',
    lmsg_copyApiRequestBodyTooltip: 'Copy API request body',
    lmsg_copyApiResponseTooltip: 'Copy API response',
    lmsg_copyDocumentNameTooltip: 'Copy document name',
    lmsg_copyDocumentTextTooltip: 'Copy document content',
    sec_toggleApiKeyVisibility: "Show or hide this token's API key",
    sec_copyApiKey: 'Copy the API key to the clipboard',
    sec_tokenActions: 'Token actions (renew / revoke)',
    sec_copyParameter: 'Copy this parameter value',
    sec_copyCodeExample: 'Copy the code example',
    setuppg_toggleSecretVisibility: 'Show or hide the secret value in this field',
    setuppg_removeEndpoint: 'Remove this endpoint from the list',
    setuppg_ssoToggleHint: 'Enable/disable {provider} SSO for portal',
    setuppg_ssoChatToggleHint: 'Enable/disable {provider} SSO for chat',
    setuppg_syncSsoGroupsHint: 'Enable syncing of Entra security-group membership',
    setuppg_jsonCredentialHint: 'Upload the Google service-account JSON credential',
    setuppg_callbackPathHint: 'The redirect URI the IdP calls back after login',
    setuppg_apiScopeHint: 'OAuth scopes requested, space-separated',
    setuppg_urlConfigHint: 'OIDC config URL (or JWKS for DGADigitalID)',
    setuppg_addDgaDigitalIdHint: 'Add a DGA Digital ID provider configuration',
    ssoc_copyIntegrationLink: 'Copy the integration link for Microsoft Teams',
    ssoc_copySnippetLink: 'Copy the web-snippet link to embed',
    ssoc_deleteConfiguration: 'Delete this channel configuration',
    ssoc_toggleSecretVisibility: 'Show or hide the secret value',
    ssoc_entraVerificationToggleHint: 'Require Entra verification before using this LINE channel',
    ssoc_liffIdHint: 'The LINE LIFF ID for the Entra verification mini-app',
    ssoc_channelSecretHint: 'Channel Secret (verifies webhooks)',
    ssoc_channelTokenHint: 'Access Token (calls Messaging API)',
    ssoc_fbVerifyTokenHint: 'Verify token must match Meta webhook',
    ssoc_fbAccessTokenHint: 'Page access token',
    sug_searchUsers: 'Search users by username / email',
    sug_addSelectedUsersHint: 'Add the selected users to this group',
    cfgt_resetChatbotAppearance: 'Reset the chatbot icon, colour and name to defaults',
    cfgt_chooseChatbotIcon: 'Choose a chatbot icon or upload your own',
    cfgt_resetToDefault: 'Reset this image to the default',
    cfgt_uploadImageHint: 'Drag-drop or click to upload an image',
    cfgt_colorPickerHint: 'Pick the hex colour for this element',
    entra_toggleSecretVisibility: 'Show or hide the client secret',
    entra_tenantIdHint: 'The Microsoft Entra tenant (directory) ID',
    entra_clientIdHint: 'The registered application (client) ID',
    entra_scopesHint: 'Requested scopes, space-separated',
    _showInactiveHint: 'Also show unlinked (inactive) records',
    _unlinkHint: "Revoke this user's LINE↔Entra verification",
    calpg_previousPeriod: 'Go to the previous period',
    calpg_nextPeriod: 'Go to the next period',
    calpg_deleteEvent: 'Delete this event',
    calpg_closeDialog: 'Close without saving',
    calpg_changeView: 'Change the calendar view',
    setpg_selectImageHint: 'Click to browse and pick a logo image',
    setpg_snippetBubbleIconHint: 'Click or drag an image (PNG/JPG/GIF/WebP) or a PDF here',
    setpg_snippetIconConverting: 'Converting PDF to an image...',
    setpg_snippetIconPdfFailed: 'Could not read this PDF (it may be corrupt or password-protected) — try another file or convert it to PNG first',
    setpg_snippetShowLoginHint: 'When off, users can only chat anonymously (no login button or prompts)',
    setpg_snippetShowTranslateHint: 'When off, users cannot switch language in the widget (hides the translate button in the top bar)',
    setpg_snippetShowHistoryHint: 'When off, the widget has no left history sidebar (single-chat mode, history not shown)',
    setpg_snippetShowMicHint: 'When off, the widget text box has no microphone button (users can only type — no speech-to-text)',
    setpg_snippetQuickChipsHint: 'Type and press Enter to add · Click ✕ to remove · No drag reordering — the typed order is the display order · Chip text = the question that gets sent · Leave all empty to use the 9 default chips (chips cannot be hidden entirely) · Maximum 10 chips · Up to 120 characters per chip (40 or fewer recommended to avoid overflow on mobile)',
    setpg_snippetWelcomeScopeHint: 'These texts and chips apply only to the embedded Chat Widget (snippet) — the full-page chat in the portal is unaffected.',
    cfgconsent_saveHint: 'Save this consent version',
    cfgconsent_viewPreviousVersionHint: 'Preview a previous consent version',
    sacomp_manageTooltip: 'Enter and manage this company as its admin (session switch)',
    sacomp_editTooltip: 'Edit company & owner details',
    sacomp_deleteTooltip: 'Delete this company permanently',
    saumgt_editTooltip: 'Edit user name & email',
    saumgt_deleteTooltip: 'Delete this SuperAdmin user',
    _sa_wg_refresh_tooltip: 'Reload org tree',
    _sa_wg_toggle_tooltip: 'Expand / collapse child units',
    wdtn_toggleTooltip: 'Expand / collapse children',
    wdtn_menuTooltip: 'More actions (add / edit / delete)',
    wdtn_dragTooltip: 'Drag to move or reorder this unit',
    _sa_org_manage_tooltip: 'Enter & manage this org as its admin (session switch)',
    _sa_org_toggle_tooltip: 'Expand / collapse sub-units',
    _sa_org_edit_tooltip: 'Edit organization details',
    _sa_org_delete_tooltip: 'Delete this organization node',
    _sa_org_remove_child_tooltip: 'Remove this sub-unit',
    _sa_org_cancel_child_tooltip: 'Cancel this newly added sub-unit',
    saDashboardSearchTooltip: 'Search & reload dashboard with filters',
    saDashboardManageTooltip: 'Enter & manage this company as its admin (session switch)',
    saDashboardViewDocsTooltip: "View this company's knowledge documents",
    saDashboardCloseTooltip: 'Close',
    saDashboardReviewStatusTooltip: 'Change document review status',
    sasub_renewTooltip: 'Renew this subscription',
    sasub_cancelTooltip: 'Cancel this subscription',
    sasub_editTooltip: 'Edit subscription details',
    sasub_historyTooltip: "View this subscription's change history",
    saCore_deleteEndpointTooltip: 'Remove this Azure OpenAI endpoint',
    saCore_gptModeTooltip: 'Choose GPT routing: Priority vs Fastest',
    saCore_embeddingLoadBalanceTooltip: 'Load-balance embedding calls across endpoints',
    saCore_streamTooltip: 'Toggle automatic streaming of replies',
    saCore_anonymousTooltip: 'Allow anonymous (guest) users to chat',
    saCore_forceDisableGptTooltip: 'Force-disable all GPT replies platform-wide',
    saCore_autoDisableGptTooltip: 'Auto-disable GPT when the cost/period limit is hit',
    saCore_enableLocalLoginTooltip: 'Toggle username/password login (off = SSO only)',
    saCore_ssoProviderTooltip: 'Enable this SSO provider (portal)',
    saCore_ssoChatTooltip: 'Enable this SSO provider (in-chat)',
    saSet_deleteEndpointTooltip: 'Remove this Azure OpenAI endpoint',
    saconsent_audienceToggleTooltip: 'Switch which content set you are editing (backend / frontend / privacy notice / snippet terms)',
    saPersona_enabledTooltip: 'Enable/disable Persona API (saves on toggle)',
    saPersona_sourceEnabledTooltip: 'Enable/disable this GDX data source (saves on toggle)',
    saPersona_serviceEnabledTooltip: 'Enable/disable this service (needs GDX API)',
    saPersona_cacheEnabledTooltip: 'Enable/disable response caching for this service',
    _sa_doc_more_menu: 'More actions for this document',
    _sa_doc_swap_file: 'Change the file to upload',
    _sa_doc_clear_file: 'Remove the selected file',
    _sa_doc_detect_pii_tooltip: 'Detect and mask personal information during processing',
    _sa_doc_chunk_active_tooltip: 'Include/exclude this chunk from retrieval',
    _sa_doc_refresh_chunks: 'Refresh the chunk list',
    _noti_navigate: 'Go to the page this notification refers to',
    saprof_toggleIdcardTooltip: 'Show/hide the ID card number',
    sapkg_editTooltip: 'Edit this package',
    sapkg_deleteTooltip: 'Delete this package',
    sampkg_editTooltip: 'Edit package assignment',
    sampkg_deleteTooltip: 'Remove package assignment',
    sasales_editTooltip: 'Edit this sales staff',
    sasales_deleteTooltip: 'Delete this sales staff',
    navb_toggleSidebar: 'Toggle sidebar',
    navb_toggleMenu: 'Toggle menu',
    navb_language: 'Change language (Thai/English)',
    navb_toggleSound: 'Turn notification sound on/off',
    navb_accountMenu: 'Account menu',
    navb_clearModel: 'Clear selected model',
    navb_createFolder: 'New folder',
    navb_moreActions: 'More options',
    _sa_notifications: 'Notifications',
    _sa_toggleLanguage: 'Switch language (Thai/English)',
    _sa_accountMenu: 'Account menu',
    _sa_toggleSidebar: 'Collapse / expand sidebar',
    _km_share_toggle_edit: 'Toggle edit permission',
    _km_share_toggle_delete: 'Toggle delete permission',
    termsDialogLangToggle: 'Language of this document',
    ddfile_removeFile: 'Remove file',
    ddfile_attachFile: 'Attach file',
    mdad_removeFile: 'Remove file',
    mdad_clearAll: 'Clear all',
    _noti_open: 'Open notification',
    ttSendMessage: 'Send message',
    ttSkipTyping: 'Show the full answer now',
    ttScrollToBottom: 'Scroll to the latest message',
    ttSuggestionMenu: 'Suggested questions and services',
    ttNewConversation: 'Start a new conversation (clears chat history)',
    ttCopyMessage: 'Copy this message',
    ttFeedbackLike: 'Like this answer',
    ttFeedbackUnlike: 'Remove your like',
    ttAttach: 'Attach an image or file',
    ttDownloadImage: 'Download image',
    ttClosePreview: 'Close image preview',
    ttRemoveAttachment: 'Remove attached image / file',
    ttCarouselPrev: 'Scroll left',
    ttCarouselNext: 'Scroll right',
    ttTogglePassword: 'Show or hide password',
    flowpg_expandTextTooltip: "Expand text",
    flowpg_collapseTextTooltip: "Collapse text",
    vproc_removeFileTooltip: "Remove this file from the upload list",
    pgnd_openFullStream: "Open Full Stream",
    pgnd_toggleSettings: "Show/hide parameter settings panel",
    pgnd_toggleLogPanel: "Show/hide the debug log panel (what model A/B used for its last answer)",
    pgnd_logEmptyHint: "No log yet — send a message in the chat and the fields below will show what this model used for its last answer",
    pgnd_logEmptyNoModelHint: "No model selected on this side yet — pick a model and send a message; the fields below will show what it used for its last answer",
    pgnd_topicOptions: "Topic options (rename / delete)",
    strm_toggleSettings: "Show/hide settings panel",
    strm_downloadImage: "Download image",
    strm_closePreview: "Close preview",
    strm_fileOptions: "File options (version history)",
    strm_versionOptions: "Version options (restore / view)",
    strm_togglePrivateMemoryActive: "Enable/disable this private memory file",
    strm_toggleChunkActive: "Enable/disable this chunk",
    strm_reprocessHint: "Reprocess (re-embed) this file's vectors",
    strm_refreshProgress: "Refresh processing progress",
    StreamReprocessHint: "Reprocess (re-embed) this file's vectors",
    StreamRefreshProgress: "Refresh processing progress",
    StreamTemplateHint: "Download the import template file",
    fs2PmReupload: "Upload a new version",
    fs2PmChunkDelete: "Delete this chunk",
    fs2ShowIdcard: "Show ID card number",
    fs2HideIdcard: "Hide ID card number",
    lae_viewDetailTooltip: "View details",
    sgm_viewModelDetailHint: "Open model details in a new tab",
    setuppg_autoStreamHint: "Enable automatic response streaming (show the answer progressively while the model is generating)",
    setuppg_anonymousModeHint: "Allow users to access the chat without logging in",
    setuppg_forceDisableGptHint: "Force-disable all GPT responses across the system immediately",
    setuppg_autoDisableGptHint: "Automatically disable GPT responses when the configured limit (period or spending cap) is reached",
    saDashboardExportAllTooltip: "Download the full dashboard report for the selected date range as an Excel file",
    navb_scrollToTop: "Scroll to top",
    navb_clearInput: "Clear text",
    umgt_help_rolePermissions: "Sets what the user can do: Super Admin manages every company, Admin manages only their own company, General User can only use chat, and Operator is a live agent who can monitor and take over conversations from the bot (human takeover).",
    umgt_help_document: "Selects which knowledge base(s) (RAG documents) this user's AI assistant may search. The assistant will only draw answers from the document sets you choose here.",
    umgt_help_availableModels: "Whitelists which AI models this user is allowed to pick in chat. Leave it empty and the user only sees the system's default model.",
    umgt_help_databaseIntegration: "Lets this user's AI assistant query the connected external database(s) (Data Integration) to answer from live data in real time.",
    umgt_help_intentGroup: "Chooses which intent set(s) — predefined question/answer intents — this user can use. The system matches incoming questions to these intents before replying.",
    umgt_help_flows: "Assigns which chatbot flows (pre-designed automated conversation steps) this user is allowed to run.",
    umgt_help_productGroup: "Limits the assistant's answers to the selected product/service group(s) — useful for separating assistants by product line.",
    ucm_help_modelConfiguration: "Three ways to assign models: 'Model Grouping' picks a ready-made bundle of models at once, 'Model' adds individual models on top, and 'Model Shortcut' is a quick-switch preset the user can tap to change models fast in chat.",
    ucm_help_integrationSocial: "Links this account to the user's identity on chat platforms: Social User ID is their LINE User ID, and Recipient ID is their Facebook/Instagram messaging ID. Once linked, conversations from those channels map to this user.",
    ucm_help_sync: "Pulls the latest users from the connected source (e.g. SSO or a chat channel) into this table, so users added or removed upstream stay in sync.",
    gum_help_statusSync: "Shows whether this group is linked and syncing its members with Microsoft Entra ID (Azure AD). When 'Synced', the member list updates automatically from the matching Entra ID group.",
    gum_help_modelConfiguration: "Assigns AI models to the whole user group at once — every member of the group automatically inherits the model group and models you choose here.",
    ugd_help_setup: "Configures how this group maps to an Entra ID / SSO group — e.g. which source group to link and the member-sync rules. Set this up before you run Sync.",
    ugd_help_sync: "Pulls this group's latest members from the source system (e.g. Microsoft Entra ID / SSO) to refresh the list in the table.",
    perm_help_pageOverview: "This page maps a role (permission) to user groups, defining which user groups that role is allowed to manage or access.",
    perm_help_groupName: "Select the user group(s) this role will manage — you can pick more than one.",
    invm_help_pageOverview: "Sends email invitations for outsiders to register as users. The recipient gets a sign-up link, and once they register they become a user with the role set in the invitation.",
    invm_help_status: "Invitation status: Pending = sent, awaiting sign-up; Used = recipient has registered; Expired = past its expiry date; Revoked = cancelled by an admin; Rejected = declined by the recipient.",
    invm_help_expireIn: "Sets how many days the invitation link stays valid. After it expires the link stops working and the recipient needs a new invitation.",
    invm_help_permissionUsage: "Choose the role the recipient will receive after signing up (e.g. Admin, User, Operator), which determines that account's permissions.",
    invm_help_userDeleted: "The user who registered through this invitation has since been deleted; the invitation record is kept for history.",
    bcum_help_pageOverview: "A list of chat users (e.g. LINE users) blocked from using the bot. Users on this list get no responses from the AI assistant until they are removed from the blacklist.",
    usergroup_help_purpose: "Create user groups to bundle multiple users together, so you can later assign permissions or settings to the whole group at once.",
    mm_help_modelType: "Choose Bot to build an AI assistant that talks to users directly. Choose Guard Rail for a policy-checking model that never chats with users — it screens incoming questions or the Bot's answers for unsafe or off-topic content before they are allowed through.",
    mm_help_guardRailModel: "Attach a Guard Rail model to this Bot. Each user message is first checked by that model; if it flags unsafe or out-of-scope content the Bot's reply is blocked. Leave empty if you don't need a filter.",
    mm_help_groupIntent: "Link an Intent Group so the system can classify what the user is asking for (e.g. \"check status\" vs \"request a document\") and route the reply accordingly. Use it when questions must be categorised before answering.",
    mm_help_promptForNoData: "The message the AI uses when a database (SQL) lookup finds no matching rows — e.g. \"Sorry, I couldn't find that in our records.\" Prevents the AI from inventing an answer when there is no data.",
    mm_help_knowledge: "Knowledge sources the AI pulls from when answering. Pick document sets (Vector DB) so it answers from your files (RAG), set Top-N for how many passages to retrieve, set Cosine as the minimum similarity threshold, and optionally connect a database or knowledge graph. More on-topic sources = more accurate answers.",
    mm_help_database: "Lets the AI answer from a database table: choose a connected table, then choose the model that turns the user's plain-language question into a SQL query (SQL Extraction Model). The system runs the query and answers with live data — use it when replies must reflect current records (balances, statuses, etc.).",
    mm_help_memorySettings: "Controls how much of the earlier conversation the AI \"remembers\": Turn = how many recent question-answer rounds are fed back in, Duration = how many minutes back, Short-term = short-term memory length, Long-term = remembering across separate chats. More memory = better continuity but higher token cost.",
    mm_help_detection: "Configure how the chat \"reads intent\" and \"stays safe\": the Intent Group classifies questions before answering, and the Guard Rail model screens out unsafe or off-topic content before the Bot replies.",
    mm_help_prefixMessage: "A fixed opening line prepended to every Bot reply (e.g. a greeting or a \"this is Beta info\" disclaimer). Different from the System Message, which is the hidden persona/instructions — the Prefix is always shown to the user. Toggle it on/off with the switch.",
    mm_help_loadingBar: "Turn on the Loading Bar to show LINE's \"typing…\" animation while the AI is thinking, and set Loading Duration for how many seconds it shows. Reassures users the system is working rather than frozen.",
    mm_help_llmSelection: "Allow users to change the AI model themselves during a chat session. When off, users can only use the model configured here.",
    mm_help_parameters: "These tune the model's answering \"style\": low Temperature/Top-P = focused, consistent; high = more creative/varied. Frequency/Presence penalty reduce repetition, Max tokens caps reply length. The provided defaults usually work well.",
    gmm_help_replace: "Re-points every channel and group currently using this model to a different model you choose. Use it to swap the model behind the scenes without editing each binding by hand — double-check the target before confirming.",
    gmm_help_publish: "Publishes the model so it goes live (status Draft → Publish). Only after publishing can end users actually use it; before that it's visible to admins only.",
    gmm_help_versionHistory: "View every saved version of this model with its date and editor. You can open an older version to inspect it or restore it as the active one.",
    gmm_help_exportFileConfig: "Downloads the model's entire configuration as a JSON file — use it to back up the model or to Import it and recreate the same model in another environment or company (pairs with the Import button above).",
    gmm_help_restore: "Makes this older version the current, live version, replacing what's published now. Handy when a recent change caused problems and you need to roll back.",
    gmm_help_view: "Opens this version in read-only mode without applying it — so you can compare before deciding whether to restore.",
    gmm_help_status: "Publish = the model is live and reachable by end users · Draft = still a working copy, visible to admins only, for testing before you publish.",
    gmnm_help_node: "A \"Node\" is a reusable, pre-built instruction block — a main Prompt plus sample dialogue (few-shot examples) that teach the AI to answer in a desired style. Build it here once and reuse it across models/features.",
    gmnm_help_fewShot: "Each pair is a \"teach-by-example\" (few-shot) sample: in Role put who is speaking — user (a sample question), assistant (the answer you want the AI to imitate), or system (an instruction) — and in Content put the actual sample text. Better examples make the AI copy the desired style more closely.",
    gmnd_help_fewShot: "Each pair is a \"teach-by-example\" (few-shot) sample: in Role put who is speaking — user (a sample question), assistant (the answer you want the AI to imitate), or system (an instruction) — and in Content put the actual sample text. Better examples make the AI copy the desired style more closely.",
    gmnd_help_prompt: "The main Prompt is the base instruction/context the AI always uses; the \"Example\" panels below are optional sample dialogues that teach the answering style.",
    mdata_help_jsonConfiguration: "The JSON request-body template sent to the model's API. Needed only when the provider is Other (a custom endpoint). Placeholders in braces such as {max_completion_tokens} and {stream} are auto-filled at call time. Leave it alone for the standard providers.",
    mdata_help_provider: "Pick a standard provider (OpenAI, Google, etc.), or pick Other to connect a custom / self-hosted model endpoint — which then requires an Endpoint URL, an authentication Header name, an API Key, and a JSON request template.",
    mvm_help_page: "This page links a model to a Vector DB (knowledge store) so the model can pull content from those documents when answering (RAG). One model can map to several stores. It's a central way to manage the pairing, separate from the Vector DB field inside the model editor.",
    mvm_help_vectorDBName: "A Vector DB is a store that holds your documents in a form the AI can search by meaning (not just exact keywords). Pick the store whose content matches this model's job.",
    mvm_help_webSearchDomains: "List of domains the model is allowed to search the web on (e.g. dga.or.th) — at least 1 domain enables Web Search restricted to the list; remove all to disable. Supported on every Azure text model. Max 20 domains. When enabled the model searches on every question (slower responses, higher token usage) — instruct the System Prompt to cite sources and to say so when nothing is found; if unsure about subdomains, add both dga.or.th and www.dga.or.th.",
    mqg_help_shortcutGroup: "A Shortcut Group is a bundle of models offered as quick-pick options to users in the chat screen. Tick All Models to include every model, or hand-pick a few — and upload an icon for each so users can recognise them.",
    mqr_help_command: "Defines the tappable quick-reply buttons shown under the (LINE) chat: Label is the text on the button, Message is what gets sent/triggered when tapped, and Type chooses message (sends visible text) or postback (sends a hidden value for the system to process).",
    mqr_help_labelMessage: "Label = the text the user sees on the button · Message = the value the system receives when the user taps it.",
    mquick_help_company: "Each row connects one LINE Official Account (via its credentials) to a model group. When users message that LINE account, the system replies using the models in the selected group. Use + to add another channel.",
    mquick_help_channelCredentials: "The Channel Secret and Channel Access Token are the LINE Official Account's authentication keys, copied from the LINE Developers Console (Messaging API tab). They must be correct for the system to send and receive messages through this LINE account.",
    mquick_help_groupModelName: "Choose the model group (Shortcut Group) this LINE channel will answer with; users will only be able to switch between the models in this group.",
    npanel_help_nodes: "This panel holds the building blocks of a flow. Drag or click a block to drop it on the canvas. They're grouped by category: Input/Output (receiving/sending messages), AI (models), Intent (intent routing), Knowledge (knowledge sources) and Actions.",
    flst_help_versionHistory: "Version History keeps a snapshot of the flow every time you save. You can review or restore any older version at any time; restoring doesn't delete the current version — it creates a new one from the old snapshot.",
    flst_help_current: "The green \"Current\" badge marks the version that is live on the bot right now. Other versions are history you can restore.",
    flst_help_restoreThisVersion: "Restore makes this version the live/current one — the flow is replaced with this version's contents and saved as a new version.",
    flst_help_exportFlow: "Downloads this flow as a JSON file for backup or to import into another environment.",
    fnode_help_advancedRouterChips: "Node badges: the percentage is the minimum confidence needed to accept an intent match; Ln is the maximum depth of the intent hierarchy (e.g. L2 = 2 levels).",
    fnode_help_fallback: "The Fallback (F) output is the safety path used when the user's message matches no intent or confidence is too low — connect it to a default reply or a request for more detail.",
    fnode_help_basePrompt: "The \"Base Prompt\" badge shows this node is combining the company's shared base prompt with its own prompt.",
    fnode_help_delaySubtitle: "The node subtitle summarises the delay mode in effect: fixed value, random range, or computed from a variable.",
    flow_help_aiModelNode: "The AI Model node is the main brain: it uses an LLM to generate the bot's replies. Configure the provider, model version, behaviour and parameters here. Use it whenever the bot should answer with free-form conversation.",
    flow_help_intentAiModelNode: "The Intent AI Model classifies the user's message into one of the intents defined on an Intent Router / Advanced Router — it decides the branch, it does not write the reply. Usually set for accuracy (low temperature).",
    flow_help_intentRouterNode: "The Intent Router splits the conversation into branches based on the user's intent. Each intent has its own output, plus a Fallback output used when nothing matches. Good for predefined topics/menus.",
    flow_help_smartIntentNode: "Unlike the Intent Router, each Smart Intent can answer on its own — it has its own AI model, prompt and knowledge sources (documents / database / API). Use it when each topic needs different expertise or persona.",
    flow_help_advancedRouterNode: "The Advanced Router does multi-level (hierarchical) intent routing, e.g. category → sub-category. The model picks the most confident branch; if confidence is below the threshold it goes to Fallback. Good for deep, multi-level menus.",
    flow_help_knowledgeGraphNode: "Knowledge Graph retrieves answers from a graph of entities and their relationships (nodes and edges). Unlike plain vector document search it can follow links across multiple hops — good for questions that connect several facts.",
    flow_help_waterfallSearchNode: "Waterfall Search runs in tiers: it tries Tier 1 first, and only if that returns nothing does it fall through to Tier 2, then Tier 3, and so on. Lets you search precise sources first and widen the net only when needed.",
    flow_help_databaseIntegrationNode: "Database Integration lets the AI turn the user's plain-language question into a SQL query and pull live data from your database table to answer. Pick the table and the model that generates the SQL here.",
    flow_help_mcpServerNode: "The MCP Server node connects external tools/functions (via the Model Context Protocol) that the AI can call mid-conversation — e.g. fetch data or act in another system. Enter the server URL and choose which tools are allowed.",
    flow_help_knowledgeApiNode: "The Knowledge API node calls your external API and feeds its response back to the AI as extra context for the answer. Set the URL, method, headers and body (you can inject conversation variables).",
    flow_help_documentsNode: "The Documents node searches your uploaded documents for the passages (chunks) most relevant to the question and gives them to the AI to ground its answer (RAG). Choose the document set and how many chunks to pull.",
    flow_help_switchNode: "The Switch node branches into many paths based on conditions (unlike the If node which is only true/false). Each output has its own condition, plus a Default output when none match.",
    flow_help_conditionNode: "The If node checks one condition and splits into two paths: True and False. Use it for simple decisions (checking a value or text) before sending the flow down the right branch.",
    flow_help_contactAgentNode: "Contact Agent hands the conversation to a human agent and temporarily disables the bot for that user. Use it as an end-point when the bot can't help or the user asks for a person.",
    flow_help_delayNode: "The Delay node pauses before the next step: Fixed = a set time, Random = a random range (feels more natural), Variable = computed from an expression/variable.",
    flow_help_temperature: "Temperature controls how creative/random the answer is: low (0–0.3) is focused and consistent — best for accuracy; high (0.7–1) is more varied and creative but less predictable. A typical range is 0.2–0.7.",
    flow_help_topP: "Top P (nucleus sampling) limits word choice to the smallest set of most-likely words whose probabilities add up to this value — e.g. 0.9 considers only the top 90%. Lower = safer/narrower output. Most people leave it at 1 and tune Temperature instead.",
    flow_help_frequencyPenalty: "Frequency Penalty discourages the model from repeating the same words too often — higher (0–2) pushes it harder away from words it has already used a lot. Useful when replies get repetitive. Default 0.",
    flow_help_presencePenalty: "Presence Penalty encourages the model to bring up new words/topics. Unlike Frequency Penalty (which counts how often a word appears), it only cares whether a word has appeared at all — higher values make answers roam across more topics. Default 0.",
    flow_help_maxTokens: "Max Tokens caps how long the reply can be (1 token ≈ ~¾ of an English word). Set it too low and answers get cut off mid-sentence; higher allows longer answers but is slower and costs more.",
    flow_help_stopSequence: "A Stop Sequence is a piece of text that makes the model stop generating the moment it produces it — handy to cut a reply off at a marker (e.g. before a new heading). Leave blank if not needed.",
    flow_help_useBaseModelPrompt: "When on, the company-wide Base Prompt is merged with this node's prompt, so every node shares the same baseline persona/rules without retyping them. Turn off to make this node use only its own prompt.",
    flow_help_streamResponse: "On = the answer appears word-by-word as it's generated, so users see progress sooner (good for long replies). Off = the full answer is sent at once. Note: streaming disables response caching.",
    flow_help_jsonResponse: "Turn on when you need the AI to reply as structured JSON instead of plain text, so downstream nodes (API, conditions) can parse fields out of it. Describe the desired JSON shape in the prompt as well.",
    flow_help_memorySettings: "Configure conversation memory: Turn Count = how many recent question/answer rounds to remember, Duration = for how many minutes, Short-Term = the context window sent to the model now, Long-Term = persistent storage across sessions. Enable when the bot must remember earlier messages.",
    flow_help_longTermMemory: "Turn on to store memory permanently so the bot still remembers the user when they return in a later session (short-term memory is cleared when the conversation ends).",
    flow_help_cacheSettings: "The cache stores previously generated answers so repeat questions are served instantly without calling the LLM again — cutting latency and cost. Note: caching is skipped when streaming or live data/database integrations are used.",
    flow_help_semanticCache: "Turn on so the cache matches questions with similar meaning, not just identical text — e.g. \"what time do you open?\" and \"opening hours?\" are treated as the same. This lets the cache hit far more often.",
    flow_help_similarityThreshold: "The similarity score at which two questions count as \"close enough\" to reuse a cached answer. High (e.g. 95%) is strict — only near-identical questions reuse; lower is more flexible but risks answering the wrong context. 85–95% is a good range.",
    flow_help_cacheScope: "Choose who may share a cached answer: whole company (everyone reuses it — most savings) or per-user (keeps personalised answers from leaking between users). Pick based on how personal the answers are.",
    flow_help_cacheTtl: "How long (in minutes) an answer stays in the cache before it expires and must be regenerated. Use a short time if the underlying info changes often, longer if answers are stable.",
    flow_help_confidenceThreshold: "The minimum confidence at which a matched intent is trusted. Below this, the flow is sent to Fallback instead. Higher = safer but falls back more often; lower = matches more easily but risks wrong routing. 60–80% is typical.",
    flow_help_maximumIntentDepth: "The maximum number of intent levels the model drills through — e.g. 2 levels = category → sub-category. Deeper means finer classification but requires defining more sub-intents and is slower.",
    flow_help_customResponseSchema: "Google providers only: define the exact JSON shape the model must return, so you can name the intent / confidence / sub-intent fields yourself. Use only when the default structure doesn't fit.",
    flow_help_searchMode: "How the graph is searched: fuzzy-first matches near-spelled names, semantic-first matches by meaning, bm25-node-name matches exact keywords in node names, hybrid-union combines several methods, hybrid-rerank combines then re-ranks for accuracy, baseline-vector-only uses pure vector search. Start with fuzzy-first if unsure.",
    flow_help_maxHops: "The maximum number of relationship steps to follow out from the starting node — e.g. 2 hops follows links two connections deep. More hops gives broader context but is slower and can pull in less-relevant facts (default 3).",
    flow_help_fuzzySemanticThreshold: "Fuzzy Threshold (0–100) sets how strict spelling-similarity matching is (higher = must be more identical); Semantic Threshold (0–1) sets how strict meaning-similarity matching is (higher = must be closer in meaning). Set either too high and nothing is found.",
    flow_help_maxContextNodesEdges: "Caps how many graph nodes/edges are passed to the AI as context. More is more complete but uses more tokens and is slower — reduce these if answers get long or slow (defaults 30 nodes / 60 edges).",
    flow_help_baselineTopKMinSimilarity: "Used only in baseline-vector-only mode: Top-K = how many closest matches to retrieve, Min Similarity = the lowest similarity score (0–1) allowed — results below it are dropped.",
    flow_help_includeMiniappTier: "Turn on to add a MiniApp source as the first tier, searched before the knowledge graphs. Use it when most answers live in the MiniApp and you want it tried first.",
    flow_help_citationContext: "Turn on to attach the source references pulled from the graph to the answer, so users can see where the information came from — boosting trust. The Citation Prompt controls how references are formatted.",
    flow_help_mcpMode: "How tools are used: Agentic lets the AI choose and call tools itself, possibly several times, until it has an answer (most flexible); Single Tool calls one fixed tool only (more predictable and controllable).",
    flow_help_toolChoice: "Controls tool calling: auto lets the AI decide whether to use a tool, required forces it to call at least one tool, none forbids tools (answer from the model's own knowledge).",
    flow_help_maxToolIterations: "The maximum number of times the AI may call tools in Agentic mode before it must finalise an answer — prevents endless loops. Higher handles more complex tasks but is slower and costlier.",
    flow_help_connectTimeout: "How long (seconds) to wait when connecting to the MCP server before giving up. Increase it if the server is slow to respond.",
    flow_help_selectedTools: "Pick which tools the AI is allowed to use. Leave empty to allow every tool the server offers. Use \"Discover Tools\" to pull the list from the server first.",
    flow_help_knowledgeSources: "Choose which knowledge this intent draws on when answering: Documents (search files), Database Integration (pull data via SQL), Products (product catalog), Knowledge API (call an external API). Enable only what's needed to keep answers focused and fast.",
    flow_help_topNChunks: "How many document passages (chunks) to retrieve for the AI to reference per question. More = broader coverage but more tokens and possible noise; too few may miss the answer. Start around 3–5.",
    flow_help_timeContext: "Turn on to inject the current date/time (in the selected time zone) into the prompt, so the bot can answer time-aware questions correctly, e.g. \"what day is it?\" or \"are you open now?\".",
    flow_help_addTransactionId: "Turn on to include the conversation's Transaction ID in the prompt — useful when the bot needs to reference or track a specific user transaction.",
    flow_help_useMemory: "Turn on so this intent uses the earlier conversation history when answering. Turn off to answer fresh each time without prior context — e.g. for standalone commands.",
    flow_help_editBasePrompt: "Turn on to edit a Base Prompt specific to this intent (its persona/general rules), separate from the Intent Prompt which describes how to match the intent. Off keeps the group's default base prompt.",
    flow_help_exampleMessages: "Add sample messages users typically type for this intent. The system uses them as few-shot examples so the model matches this intent more accurately — the more varied the examples, the better.",
    flow_help_sqlExtractionModel: "Pick the AI model that turns the user's question into a SQL query to fetch data from the table. Use a model strong at code/reasoning so the generated SQL is correct.",
    flow_help_promptForNoData: "The message the bot replies with when the SQL query finds no matching data. Make it polite and guide the user on what to do next, e.g. rephrase or give more detail.",
    flow_help_simpleAdvancedCondition: "Simple builds the condition from a guided form (pick field / operator / value) — best for beginners. Advanced lets you write the condition expression yourself (e.g. input.confidence > 0.8) — more powerful but requires knowing the syntax.",
    flow_help_expectedValue: "Choose the value this condition should treat as a pass. The system compares the source field (e.g. user.isLoggedIn) against it — if they match, the flow takes the True path.",
    flow_help_exportImportFlow: "Export saves the whole flow as a JSON file for backup or moving elsewhere; Import loads a flow from a JSON file, replacing the current canvas.",
    flow_help_clearFlow: "Removes every node and connection from the canvas so you can start the flow over. (Undo with Ctrl+Z before saving.)",
    dint_help_section: "This section connects tabular data (an uploaded Excel file, or an external database such as SQL Server/Oracle) so the bot can look up and answer from structured records — prices, stock, lists, etc. This is different from the document/vector knowledge base, which is for long free-text content.",
    dint_help_systemType: "Choose \"Internal\" to upload an Excel file that the platform stores and manages for you. Choose \"External\" to connect to your own live database via a connection string — the bot then reads current data straight from your database at query time.",
    dint_help_getAllColumns: "When on, every column from the connected table/view is imported automatically so you don't have to add them one by one. Leave it off if you only want the specific columns you added.",
    dint_help_fuzzyMatching: "Fuzzy matching lets the bot find a record even when the user's wording isn't an exact match. \"None\" requires an exact match; \"Fuzzy Search\" tolerates small spelling/spacing differences; \"Fuzzy with Bot\" additionally lets the LLM interpret the question before matching — best for full-sentence queries. Only text columns support this.",
    dint_help_columnType: "Sets the column's data type: nvarchar = text, int = whole number, float = decimal, datetime = date/time, bit = yes/no. The type controls how the value is stored and searched; only text columns can enable Fuzzy matching or personal-info detection.",
    dintd_help_panels: "The \"Configuration\" panel defines the table structure — column names, data types, fuzzy matching and personal-info flags. The \"Data\" panel is where you view, search, add and bulk-upload (Excel) the actual rows. Set up the structure first, then manage the data.",
    uvec_help_processingMethod: "This controls how the document is split into vector \"chunks\" before embedding — the biggest factor in answer quality. General = automatic standard-size split; MaxCharacter = split by the character limit you set; CustomSplit = you insert a separator to control exactly where chunks break; Article = keep a whole long article as one chunk; HeaderAllChunk = repeat the heading in every chunk to preserve context; HeaderFirstChunk = heading only in the first chunk; WordImage/PDFImage = extract both text and images from Word/PDF files.",
    uvec_help_vectorType: "Pick the type that matches your content: General = ordinary knowledge text; Article = long-form articles; PriceList = price/product tables. The platform tunes how the content is chunked and retrieved for the chosen type.",
    ucsv_help_shareAction: "Share: give another company access to this document (view/edit/delete per permission).",
    ucsv_help_duplicateAction: "Duplicate: copy this document under a new name, leaving the original untouched.",
    ucsv_help_replaceAction: "Replace: overwrite another selected document with this one's content.",
    ucsv_help_versionHistoryAction: "Version history: view and restore earlier versions of this document.",
    ucsv_help_restoreVersion: "Restore: make this version the current one (replacing what's live now).",
    ucsv_help_viewVersion: "View: open this version's content read-only without changing the current version.",
    ucsv_help_processStatus: "This shows embedding progress: chunks finished / total chunks. Grey = not started, orange = still processing, green = fully embedded and ready for the bot to use.",
    ucsv_help_personalInfoDetection: "When on, the system detects and masks personal data (PII) — names, phone numbers, ID numbers, etc. — in this document's content before it is sent to the AI, reducing the risk of leaking sensitive information.",
    pdf_help_toolPurpose: "This tool converts a PDF into clean, structured Markdown text — ideal for then uploading into the vector knowledge base. It helps the bot read PDF content more accurately than uploading a raw PDF would.",
    pdf_help_testCasePurpose: "This page generates model test cases from an uploaded document — AI reads the content and drafts the questions and expected answers for you, which you can then download and use for testing.",
    kgl_help_concept: "A Knowledge Graph stores knowledge as \"nodes\" (things, people, concepts) and the \"relationships\" that connect them. It helps the bot understand context and answer questions that require linking several facts together — better than plain text search. Create a graph, then add nodes from a file/folder to get started.",
    kgde_help_editor: "This is the Knowledge Graph editor: add nodes from a file or folder, connect relationships between nodes, and view the graph visually. When a graph is still empty, the \"Add Nodes from File/Folder\" dialog opens automatically.",
    usd_help_pagePurpose: "This section transcribes uploaded audio files into text (speech-to-text), can optionally have an AI model summarize them, and lets you import the result into the knowledge base for the bot to answer from.",
    usd_help_botSummation: "When on, the selected AI model summarizes the transcribed speech before saving, trimming filler into concise content. When off, the full verbatim transcript is kept.",
    usd_help_language: "Select the language spoken in the audio so speech recognition transcribes it correctly (e.g. Thai or English) — this is not the interface language.",
    usd_help_maxSplitCharacters: "Sets the maximum number of characters per chunk when importing the text into the knowledge document. Smaller = shorter, more focused chunks; larger = longer chunks that keep more context (default 5000).",
    usdd_help_textColumns: "\"Original Text\" is the full verbatim transcript from the audio; \"Summarized Text\" is the AI-condensed version (\"-\" means it hasn't been summarized yet). On import to the knowledge base, the summarized version is used when available.",
    ptmpl_help_statusToggle: "Turn this on to make the prompt template active — its text is applied to the AI and shapes how it answers. Templates left off are saved but never used.",
    ptmpl_help_promptText: "This is the instruction (prompt) sent to the AI that defines its role, tone and rules — e.g. \"You are a support agent; answer politely and concisely.\" The clearer it is, the more on-target the AI's answers.",
    ptmpl_help_groupName: "The group name bundles several prompt templates together. Once the group is created the name is locked, and you add individual templates under it.",
    gptmpl_help_pageOverview: "This page lists prompt-template groups. Each group bundles instruction sets that define the AI's persona and answering style; click edit to manage the templates inside a group.",
    rtext_help_pageOverview: "The Replace Text feature finds the \"original text\" you define in conversations and automatically swaps it for the \"replacement text\" — handy for standardizing wording, fixing specific terms, or normalizing product/agency names.",
    rtext_help_replaceFields: "Original text = the word the system looks for; Replacement text = what it writes instead. e.g. original \"ฟุตบอล\" → replacement \"Football\" turns every \"ฟุตบอล\" into \"Football\".",
    grtext_help_pageOverview: "This page lists replace-text groups; each group bundles word pairs (original → replacement). Click edit to manage the pairs inside a group.",
    grtext_help_totalNumber: "The number of replacement pairs configured in this group (total original→replacement entries).",
    scmenu_help_pageOverview: "A Shortcut menu is a set of ready-made command buttons shown in the chat. When a user taps one, the preset message is sent automatically — a fast way to start common conversations.",
    scmenu_help_labelVsMessage: "Label = the caption shown on the button; Message = the actual text sent into the chat when that button is tapped. The two can differ.",
    scmenu_help_uploadVsPreview: "The \"Upload image\" column is where you pick the button's icon; the preview column shows the uploaded image so you can confirm it.",
    mmgt_help_pageOverview: "Menu Management controls which user groups can see and open which menus/submenus. Pick a menu, choose the user groups, then save to bind their access rights.",
    mmgt_help_allCheckbox: "Tick \"All\" to apply access to every submenu of this menu at once (the submenu picker is then disabled because all are already included).",
    pgrp_help_pageOverview: "A Product Group is a catalog of products the AI searches to answer questions and recommend items to customers in chat. Click edit to add and manage the products and categories inside a group.",
    pgrp_help_deleteDisabled: "Delete is disabled because your account (User role) can only delete product groups it created. Ask an Admin to remove items created by others.",
    pdet_help_reprocess: "\"Reprocess\" converts your products into vectors (embeddings) so the AI can search and recommend them accurately. After adding, editing, or deleting products, click this to refresh the search index. The red \"!\" badge means the data has changed and hasn't been reprocessed yet.",
    pdet_help_recommendSwitch: "Turn on to flag this as a recommended product; the AI gives it priority and is more likely to surface it to customers when relevant.",
    pdet_help_visibleSwitch: "On = Visible: customers and the AI can see and use this product in answers. Off = Hidden: it's kept but excluded from chat answers and recommendations.",
    pdet_help_statusChips: "Card status badges: \"Recommended / Not\" shows whether the product is flagged as recommended, and \"Visible / Hidden\" shows whether it's active for customers or hidden.",
    pdet_help_productsSection: "Products section: add and manage the items the AI uses to answer customers — organize them with categories, set recommend/visibility, and remember to click \"Reprocess\" after changes so the AI uses the latest data.",
    igrp_help_intentGroup: "An Intent Group bundles several Intent Sessions the bot uses to detect what a user wants. The system checks every session in the group to find which intent the message matches, then runs that intent's configured Action. Setup order: create a group → add sessions → define Intents and Actions.",
    isess_help_intentSession: "An Intent Session is a single intent-detection unit inside a group (e.g. \"asking about registration\"). Each session holds example phrases (Intents) and the Action the bot performs when that intent matches. A group can contain many sessions.",
    isd_help_useMemory: "Use Memory: lets the bot take the earlier conversation into account when detecting intent and answering — useful for multi-turn chats. When off, the bot considers only the latest message.",
    isd_help_promptSession: "The Session Prompt is the instruction sent to the LLM telling it how to decide whether the user's message matches this group's intents (returns 1 = match, 0 = no match). The default usually works; edit only when you need more specific matching rules.",
    isd_help_intent: "Intents are example phrases that all express the same intent (e.g. \"how do I register\", \"how to sign up\"). The system compares these against the user's message to detect intent — more varied examples improve accuracy. You can bulk-upload them as an Excel file.",
    isd_help_action: "An Action is what the bot does when this intent matches. The first action (purple \"Action Answer\") is the main reply sent to the user; \"Action Parallel\" actions run alongside it (e.g. call an API or hand off to an agent). Each action can be a different type.",
    isd_help_actionType: "Action types: Vector = answer from the knowledge base (RAG) · Text Response = reply with fixed text · Model Routing = hand off to another GPT model · Next Routing = hand off to another intent group · Contact Agent = escalate to a human (temporarily disables the bot) · API Trigger = call an external API and use its result.",
    isd_help_mergePrompt: "Merge Prompt: when on, this action's prompt is combined with the session/previous-action prompt so the bot answers with the accumulated context. When off, this action uses only its own prompt.",
    isd_help_vectorName: "Vector Name (knowledge base): pick the knowledge source the bot searches to answer from. The system retrieves the most relevant knowledge chunks to build the reply; you can select multiple chunks from the table below.",
    isd_help_modelRouting: "Model Routing: hands the reply off to another configured GPT model — use when this intent should be answered by a different model than the default.",
    isd_help_nextRouting: "Next Routing: forwards the flow to another intent group to continue intent detection in the next step — used to chain multi-level conversations.",
    isd_help_jsonVariables: "These are placeholders the system fills in automatically when the API is actually called (e.g. {sessionID} = the conversation's session id, {channel} = the channel the user came from). Drag or click to insert them into the JSON sent to your API.",
    isd_help_typeValidate: "How to validate the value returned by the API: Phone = must be a phone number · Email = must be an email · Max Character = limit the character count · Regular Expression = match a custom regex. If it fails, the configured error message is shown.",
    vgen_help_pageTitle: "This page auto-generates test question sets from your knowledge documents (vector store) using an LLM, so you can later test whether the chatbot answers them correctly on the Execute Test Runs page.",
    vgen_help_status: "Question-set generation status: Processing = being generated · success = finished, ready to download · Reprocess = regenerating · error = something failed, use Reprocess to retry.",
    vgen_help_process: "Progress: how many knowledge chunks have had questions generated versus the total (e.g. 3/10 = 3 of 10 done).",
    vgen_help_reprocess: "Reprocess: regenerates the question set from the same documents — use when a previous run was incomplete or failed.",
    vgu_help_tone: "Tone: choose language styles so the system generates test questions in several variations (formal, friendly, academic, etc.), letting you test whether the bot understands questions phrased in different styles. \"Questions per tone\" is how many extra questions to generate for each selected tone.",
    vgu_help_promptTemplate: "Prompt Template: the instruction the system assembles automatically from your choices (question count / tone / extra prompt) and sends to the LLM. This box is read-only — change the result by editing the fields on the left or the \"Add more prompts\" box.",
    vneg_help_pageTitle: "A Negative question set contains out-of-scope questions the bot should refuse or not answer. Use it to test that the bot doesn't fabricate answers to questions it shouldn't handle (unlike a Positive set, which the bot should answer correctly).",
    vnd_help_pageTitle: "Upload a Negative question set: import a file of questions the bot should not answer (out of scope) to test its refusal behavior. Name the set, then upload a file using the template.",
    vpos_help_pageTitle: "A Positive question set contains in-scope questions the bot should answer correctly, usually paired with a reference \"Human Answer\" for scoring. Use it to test the bot's accuracy.",
    vpd_help_template: "Template: \"Normal Question\" = single question–answer pairs, one per row · \"Chain Question\" = multi-turn conversations, using #End# to separate each dialogue. Pick the one matching the data you'll upload.",
    vpd_help_questionType: "Question Type: Normal Question = a standalone Q&A · Chain Question = part of a multi-turn conversation. Choose the one matching the question you're saving.",
    vpd_help_humanAnswer: "Human Answer: the correct answer defined by a person. The system compares it against the bot's reply to score accuracy during a test run (optional).",
    vproc_help_pageTitle: "This page runs a chatbot test: choose a model and a question set — positive, negative, or chain (multi-turn conversations). The system sends every question to the bot, then (if scoring is on) uses an LLM to grade the answers. View results in the Score dashboard.",
    vproc_help_calculateScores: "Calculate Scores: when on, an LLM judge grades how relevant each bot answer is (0 = not related, 1 = somewhat, 2 = very related) and the scoring-prompt box appears below. When off, you get the bot's answers with no scores.",
    vproc_help_scoringPrompt: "Scoring Prompt: the instruction sent to the LLM judge telling it how to grade the bot's answers (default grades 0–2 by relevance). Edit it for different criteria; it can use the variables {'{'}Question{'}'}, {'{'}Bot's Response{'}'}, {'{'}Human's Response{'}'}.",
    vproc_help_scoreModel: "Score Model: the plain base LLM that acts as the judge grading the bot's answers — no knowledge base (RAG), no Flow, no memory, so it reliably returns the numeric score your prompt asks for, unlike reusing the answering model. Required when \"Calculate Scores\" is on.",
    vproc_help_status: "Test status: Processing = sending questions to the bot · Processing score = grading answers · success = done, scores available · Reprocess = re-running · error:score = scoring failed, use Reprocess to retry grading.",
    csvc_help_adminBotTakeover: "Switch to \"Admin\" to take this conversation over yourself — the AI bot stops replying automatically. Switch back to \"Bot\" to let the AI resume answering.",
    csvc_help_contactStatusFilter: "Filter the chat list by who is currently handling it: \"Contact Agent\" = chats a human has taken over, \"Contact Bot\" = chats still answered by the AI, \"All\" = show everything.",
    pgnd_help_compareWorkflow: "This playground lets you set up two model configurations (A and B) and send the same message to both at once, so you can compare their answers and tune the prompt/parameters before saving a model for real use.",
    pgnd_help_typingDelay: "Delay between characters (in milliseconds) when the answer streams out, to mimic human typing. Lower = faster replies; 0 shows the answer instantly.",
    pgnd_help_logPanel: "This panel shows the behind-the-scenes data the model used for its last answer — retrieved knowledge (RAG), SQL query, matched intent/flow, memory, and similarity scores — to help you debug why the bot replied the way it did.",
    pgnd_help_vectorCosine: "The similarity score (0-1) between the question and each retrieved knowledge chunk. Closer to 1 means more relevant — use it to check whether the bot pulled the right documents.",
    pgnd_help_intentFlow: "Shows which intent or Flow step this message matched, so you can see whether the bot followed the conversation path you designed.",
    strm_help_privateMemory: "\"Private Memory\" is this chatbot's own document library. Uploaded files are split into chunks and vector-indexed; when a user asks a question the bot searches them for relevant content to ground its answer (RAG).",
    strm_help_processType: "Choose how the file is processed: \"Add\" appends the new content to what already exists, while \"Replace\" deletes all existing chunks for this file first and rebuilds them.",
    strm_help_detectLanguage: "Keep on to auto-detect the document's language and translate it before vectorizing, which improves cross-language search. Turn off if the document is single-language and you don't want it translated.",
    strm_help_versionRestoreView: "\"Restore\" rolls this memory file back to the selected version's content (overwriting the current data); \"View\" opens that version read-only without changing anything.",
    strm_help_showAllText: "Show each chunk's full text (original and translated) in the table instead of a truncated preview. It only affects the display, not the stored data.",
    strm_help_intentFlow: "Shows which intent or Flow step this message matched, so you can see whether the bot followed the conversation path you designed.",
    strm_help_vectorCosine: "The similarity score (0-1) between the question and each retrieved knowledge chunk. Closer to 1 means more relevant — use it to check whether the bot pulled the right documents.",
    fs_help_privateMemory: "\"Private Memory\" is this chatbot's own document library. Uploaded files are split into chunks and vector-indexed; when a user asks a question the bot searches them for relevant content to ground its answer (RAG).",
    fs_help_processType: "\"Add\" appends to existing data; \"Replace\" deletes all existing chunks for this file before rebuilding.",
    fs_help_detectLanguage: "Keep on to auto-detect and translate the document's language before vectorizing for better cross-language search; turn off if you don't want translation.",
    fsrd_help_versionRestoreView: "\"Restore\" rolls the file back to the selected version (overwriting current data); \"View\" opens that version read-only.",
    fsrd_help_detectLanguage: "Keep on to auto-detect and translate the document before vectorizing for better cross-language search; turn off to skip translation.",
    fsrd_help_showAllModels: "Turn on to list every available model instead of only the curated/recommended group.",
    fs2_help_topVdb: "How many of the most-similar knowledge chunks are retrieved and fed to the model per question (typically 3-5). Higher gives more context but can add noise and cost.",
    fs2_help_cosine: "The minimum similarity score (0-1) a chunk must reach to be used. Higher is stricter (only very relevant chunks); set -1 to turn the threshold off.",
    fs2_help_replaceExisting: "Turn on to delete all previously stored chunks for this file and replace them with the new upload; leave off to append to the existing content. Replacing cannot be undone.",
    fs2_help_detectLanguage: "Keep on to auto-detect and translate the file's language before vectorizing, improving cross-language search.",
    fs2_help_activeStatus: "\"Active\" means this file is searched to help the bot answer; \"Inactive\" means it stays stored but is excluded from search — a way to disable it temporarily without deleting.",
    fs2_help_digitalId: "Link your account to DGA Connect or ThaID so you can sign in with that verified national identity. Toggle a switch off to unlink it.",
    fs2_help_ourService: "A shortcut menu of popular suggested questions/services you can ask with one tap, plus starting a new conversation.",
    dash_help_categoryQuestions: "Category questions are the ones the system matched to a predefined topic/intent; Other questions are free-form questions that matched no category. Compare the two lists to see both expected topics and what users ask beyond them.",
    dash_help_systemUsageCounters: "Non-login users are people who used the chatbot through the government channel without signing in (anonymous); Total = login + non-login, counted uniquely per day.",
    dash_help_tokenModelBreakdown: "Per-model token breakdown: Prompt = text sent to the model, Completion = the model's generated answer, Cached = tokens reused from cache (cheaper). Use it to compare each model's cost.",
    dash_unknownModel: 'Unknown model', // per-model token card label when the SP cannot resolve the model name (returns 'Unknown')
    dash_help_feedbackSummary: "Feedback summary: how many times end users rated the bot's answers Like/Dislike in the selected date range — a quick gauge of overall user satisfaction.",
    dash_help_imageGenDetail: "Image generation detail: how many images the bot created with AI and the cost, by model — billed per image, not per token.",
    dscore_help_validationScore: "Validation Score dashboard: compares the bot's answers against human reference answers in a Validation Process run and grades their quality — use it to see how well the bot answers before going live.",
    dscore_help_scorePrompt: "The grading prompt the AI judge uses: it defines how the bot's answer is compared to the reference answer and how points are assigned. It only applies when \"Calculate Scores\" is on.",
    dscore_help_scoreModel: "Score Model: the LLM that graded this run. \"Same as the answering model (legacy run)\" means this test set was created before separate score models were supported — use Reprocess and pick a model to get more reliable grades next time.",
    dscore_help_averageScore: "Average score across all questions in this validation run — higher means closer to the human reference answer (see the score-band conditions card below).",
    dscore_help_scoreColumn: "This row's grade for the bot answer compared to the Human Answer, based on the configured scoring prompt.",
    rfb_help_showAllText: "Turn on to expand the full answer text for every row at once (off keeps long answers collapsed for easier scanning).",
    rfb_help_feedbackByModel: "Feedback by model: compares Like/Dislike counts per AI model so you can see which model produces answers users prefer.",
    rqt_help_reportOverview: "Question category report: the system uses AI to cluster real user questions from the selected date range into categories based on your prompt. Click \"Process\" to start, wait for the counter to complete, then the ranked categories appear.",
    rqt_help_processingStatus: "Processing progress: questions already categorized / total. When the two numbers match, processing is complete and the results are up to date.",
    rts_help_modelIdentity: "Model Name is the label configured inside the system; Model is the provider's actual version id (e.g. gpt-4o); LLM is the provider/model family (e.g. OpenAI, Vertex).",
    logv_help_pageOverview: "Developer/system log: records exceptions, the method that ran, and a log trace to help diagnose technical issues — not a general usage report.",
    logevt_help_statusApi: "The API's internal business result (different from the HTTP Status Code): 0=Successful, 1=business error, 2=system error, 3=duplicate, 4=incomplete data, 5=exception. Filter by it to find why a request succeeded or failed.",
    logevt_help_statusCode: "The HTTP status of the request: 200=OK, 400=bad request, 500=server error. Filter by it to review how API calls resolved.",
    logevt_help_eventLogOverview: "Event log: an audit trail of system actions (create/update/delete/login) and API calls — who did what, when, and the result — for review and troubleshooting.",
    lmsg_help_exportLogMessage: "Export Log Message: the full chat log (Q&A, system message, knowledge) to Excel using the current filters.",
    lmsg_help_exportLogMonitoring: "Export Log Monitoring: performance data (response times / per-step flow status) to analyze speed and issues.",
    lmsg_help_exportToQuestionSet: "Export to Question Set: turn the real user questions into a Question Set for training/testing or improving the bot.",
    lmsg_help_knowledge: "The knowledge the system retrieved (RAG): content pulled from the knowledge/vector base and injected into the prompt so the bot answers from real data — use it to check the bot retrieved the right information.",
    lmsg_help_flowVisualization: "Flow view: shows step by step which nodes processed the message (e.g. detect intent → search knowledge → call model → respond). Color shows status (success/failed/skipped) and the ms value is how long that step took. Click a node to see its input/output.",
    lmsg_help_flowNodeTypes: "Flow node types: Intent/Smart Intent detect what the user wants; Cache reuses a stored answer for speed/cost; Knowledge Graph searches a knowledge graph for related facts; NEXA Waterfall searches data tier by tier until it finds a hit; MCP calls external tools via the MCP protocol; Advanced Router picks the path/model by rules; Interest Optimizer tailors results to the user's interests.",
    lmsg_help_systemMessage: "System message (system prompt): the instruction/context sent to the model before the user's question — it sets the bot's persona and answering rules for that turn.",
    lmsg_help_flowColorCoding: "Node colors: green=success, red=failed, amber=skipped. The ms badge color shows speed (green=fast, amber=medium, red=slow) to help spot bottleneck steps.",
    lmsg_help_userChannel: "User channel: the platform the message came from (e.g. Web, LINE, Facebook, MS Teams) — filter to review conversations per channel.",
    lmsg_help_sessionId: "Session ID: groups messages that belong to the same conversation for one user — use it to trace the earlier context of a question.",
    lae_help_apiExternalOverview: "External API log: a history of calls the system made to third-party/external APIs (e.g. data integrations), with the request and response bodies, so you can verify integrations or debug failures.",
    lae_help_transactionId: "Transaction ID: a reference id to trace a single API call end to end and match it with the partner system's logs when troubleshooting.",
    setup_help_gptConfiguration: "Configures the AI connections that answer chat. The system calls your Azure OpenAI endpoints in priority order and fails over to the next if one is down. It also sets the Embedding model used to turn documents into vectors for knowledge search (RAG).",
    setup_help_priority: "The order this endpoint is tried. A lower number is used first; if the top-priority endpoint fails, the system automatically falls through to the next one.",
    setup_help_embeddingType: "The model that converts text into vectors for RAG search. It must match the model used when the vector database was built — changing it later makes search results inaccurate. \"large\" is more accurate but slower/costlier; \"small\" is faster/cheaper.",
    setup_help_gptMode: "Chooses how an endpoint is picked. Priority Mode always uses your configured priority order. Fast Mode periodically sends test questions to every endpoint and routes real traffic to whichever responds fastest.",
    setup_help_repeatTimeMinutes: "How often (in minutes) the system re-benchmarks each endpoint's speed with test questions. More frequent = adapts faster to real conditions but uses more API calls.",
    setup_help_testQuestions: "Sample questions the system sends to each endpoint to measure response time (they are not shown to end users). Use questions similar to real usage for an accurate benchmark.",
    setup_help_timeDelayMs: "Delay in milliseconds between each character while the reply streams out. A small value makes text appear quickly; a larger value types it out more slowly, like a human.",
    setup_help_characterLimit: "The maximum number of characters a user may send in a single message. Longer messages are rejected — used to control cost and block abnormally long input.",
    setup_help_gptAutoDisablePricing: "The spending ceiling in USD. When GPT usage reaches this amount within the configured period, GPT is switched off automatically to prevent runaway bills (works together with the \"Auto-Disable GPT\" switch).",
    setup_help_gptAutoDisablePeriod: "How many days back GPT spending is totalled — a rolling window, not a billing cycle. E.g. 30 = always the last 30 days. When the total reaches the price cap GPT is switched off; as older days drop out of the window it comes back on by itself. The total covers all companies in the system, and day boundaries follow UTC.",
    setup_help_gptAutoDisableMessage: "The message shown to end users in place of an AI reply when GPT has been auto-disabled after hitting the spending ceiling.",
    setup_help_entraGroupConfig: "Configures a Microsoft Entra app (Tenant/Client ID/Secret) so the system can pull members of an Entra security group and map them to in-app user groups automatically — no need to add users one by one — once the Sync switch is on.",
    ssoc_help_groupModel: "Selects the Model Group that limits which AI models this channel may use. Leave empty to allow all models by default.",
    ssoc_help_modelShortcut: "A quick set of models Teams users can switch between rapidly.",
    ssoc_help_shortcutMenu: "The quick-command menu shown inside the Teams chat so users can trigger common actions in one tap.",
    ssoc_help_webSnippet: "Creates an embeddable web-chat widget. Enter the website domain that will host it, pick a model, then copy the generated link/script into your page. Each domain gets its own token.",
    ssoc_help_domainName: "The website domain that will embed the chat widget (e.g. www.example.com). It is bound to the token and allow-lists the widget to run only on this domain.",
    ssoc_help_userDefault: "A default user id for anonymous web visitors. The system uses it as the reference identity when no real user info is available (optional).",
    ssoc_help_entraVerification: "Turn on to require LINE users to verify with their corporate account (Microsoft Entra) via a LIFF page before chatting — useful when you must know who each user is. Turning it off keeps the saved Entra App/LIFF values but stops enforcing verification.",
    sec_help_menuRenew: "Extends the token by issuing a fresh API key and a new expiry date — the old key stops working.",
    sec_help_menuRevoke: "Permanently cancels the token — any external system using this key loses API access immediately.",
    sec_help_statusBadge: "Active = the token can still call the API. Expired = past its end date and can no longer authenticate — use Renew to issue a new key.",
    sec_help_modelDisplay: "The specific model this token can use — controls which model an external system holding this token can reach.",
    sec_help_modelGroup: "The allowed group of models this token may use — scopes which models an external system holding this token can reach.",
    sec_help_vectorInsert: "This tab documents the API for adding text into the vector knowledge base (RAG) from an external system. Submitted text is converted to vectors and used to search/ground the AI's answers. \"List\" inserts many items at once.",
    sec_help_selectorModel: "This tab documents the API that takes an incoming message and lets the system automatically select/route it to the model best suited to that message's intent.",
    sgm_help_modelGroup: "A Model Group is a named bundle of AI models. You assign a group to a channel (LINE/Teams/web) or a user group to restrict them to just those models — define it once and reuse it in many places.",
    sug_help_userGroup: "This page sets which AI models a user group may use and who belongs to it. Add members manually from the table below, or enter a Group Object ID to have the system auto-sync members from Microsoft Entra when you Save.",
    entra_help_appManagement: "This is the registry of Microsoft Entra apps used to verify users with their corporate account. Once registered, an app can be selected in Setup Social (LINE Entra Verification) to require corporate login before users can chat.",
    entra_help_statusChip: "Active = this Entra app is available for identity verification. Inactive = disabled — channels referencing it cannot verify users.",
    lel_help_linkManagement: "This page lists LINE users who have verified against a corporate account (Microsoft Entra) — showing which LINE identity maps to which UPN/name. Use Unlink to break the link; the user will have to verify again next time.",
    cfgconsent_help_configurationPanel: "Edit the Consent (privacy agreement) text in both Thai and English. Pressing Save creates a new version, and every user must accept it again. You can review past versions from the version selector.",
    cfgconsent_help_currentVersion: "The version number of the Consent that users currently see and must accept. It increments every time you save an edit.",
    theme_help_configTheme: "Customize the look of the system: the login logo/background, the chat window's name/icon/color, and the top header's colors/logo/background. A live preview is on the right; pressing Save reloads the app to apply the new theme.",
    sacomp_help_portalUserSection: "This section creates the organization's first administrator (owner) account. These credentials are what that organization uses to log in to its own Admin Portal.",
    sacomp_help_lockStatus: "When set to Locked, the owner account is temporarily blocked from signing in without being deleted — useful when you need to suspend this organization's access.",
    sacomp_help_status: "A Disabled company is suspended from using the system (login/chat) but its data is fully retained — unlike Delete, which removes it permanently.",
    sacomp_help_manage: "Enter this organization: the system temporarily switches you in as that organization's admin so you can configure or view its data, then return to SuperAdmin.",
    sacomp_help_companyCode: "A short code (max 10 chars) that identifies the organization. It is set once and cannot be changed later, so choose a meaningful value that is unique across organizations.",
    sawg_help_orgHierarchy: "This chart organizes agencies into a parent-child tree (e.g. Ministry → Department → Division). A \"workgroup\" here is a link that places an existing agency as a child under another — it is not a group of users.",
    sawg_help_childCompany: "Pick an agency that already exists to nest as a child under this node. If it doesn't exist yet, create the agency first, then come back and add it as a child.",
    sawg_help_type: "The classification of the child agency (e.g. Department/Division/Section). It sets the level and the label shown in the org chart.",
    saorg_help_type: "The agency type sets its level in the hierarchy, which limits sub-units to exactly the next level down (e.g. a Department can contain Divisions but cannot skip a level).",
    saorg_help_subUnits: "The agencies nested under this one. Use \"Add sub-unit\" to place existing agencies as children; additions and removals only take effect when you Save.",
    saorg_help_colType: "The agency type as configured in the system (Ministry / Department / Division / Section, etc.). A grey chip marks a root of the tree with no parent; a blue chip marks a sub-unit grouped beneath a parent.",
    saorg_help_lockStatus: "Turn on Lock to temporarily block the owner account from signing in without deleting it; unlock to restore its access.",
    saorg_help_enableStatus: "Turn off to temporarily deactivate this unit while keeping all its data; you can re-enable it later.",
    saumgt_help_role: "The user's privilege level: a SuperAdmin can access and manage every organization across the whole system, while an Admin manages only their own organization.",
    saumgt_help_page: "This page manages system-level administrator accounts (SuperAdmin/Admin) only — not the everyday end users of each organization.",
    sainv_help_status: "Invitation states — Pending: sent but not yet used · Used: registered successfully · Expired: past its expiry date · Revoked: admin cancelled the link · Used (User Deleted): the registered account was deleted · Needs Relink: the SSO link was broken · Used (DGA Taken by Another): that DGA identity is already linked to another account.",
    sainv_help_send: "Emails a one-time sign-up link inviting the recipient to register as a SuperAdmin. Each link can be used only once and expires after the number of days you set.",
    sainv_help_expireDays: "How many days the invite link stays valid. If the recipient doesn't register in time, the link expires and a new invitation must be sent.",
    sainv_help_reinvite: "Creates a fresh invitation for this email — used when the original account lost its SSO link, so the user can register and re-link (unlike Resend, which re-mails the same pending link).",
    sainv_help_registeredBy: "The account that actually used this invite to register, which may differ from the recipient email if the link was forwarded.",
    sadash_help_embeddingTokens: "Tokens used to turn documents/text into vectors for knowledge search (RAG). They accrue both when documents are uploaded and when the system retrieves context to build an answer.",
    sadash_help_reviewStatus: "Knowledge-document review states — Draft: not ready · Testing: being validated · Ready: approved for the bot to use in answers · Issue: a problem was found and needs fixing.",
    sadash_help_provider: "Filters the usage data by AI model provider (e.g. OpenAI, Azure OpenAI, Vertex AI). Leave empty to include all providers.",
    sadash_help_promptTokens: "Tokens for the input sent to the model (the user's question plus any attached context/documents). The longer the context, the more prompt tokens are used.",
    sadash_help_cachedTokens: "The portion of prompt tokens served from the provider's cache, billed at a lower rate — it lowers cost when the same context is reused.",
    sadash_help_completionTokens: "Tokens for the output the model generates (its answer). Longer answers consume more completion tokens.",
    sadash_help_subscriptionTiers: "Subscription tiers — \"Project\": the overall token quota for the whole platform · \"Ministry/Agency\": the quota allocated to each individual organization.",
    saDashboardCompanyTypeBreakdownTitle: "Company Type Breakdown",
    saDashboardCompanyTypeBreakdownColType: "Type",
    saDashboardCompanyTypeBreakdownColTotal: "Total Companies",
    saDashboardCompanyTypeBreakdownColSubscribed: "With Active Subscription",
    saDashboardCompanyTypeBreakdownGrandTotal: "Grand Total",
    saDashboardCompanyTypeUnassigned: "Unassigned Type",
    sadash_help_companyTypeBreakdown: "Type is a naming category, not org-chart position — e.g. DGA is tagged \"Office\" (level 3) despite being a top-level tenant.",
    saDashboardCompanyTypeBreakdownEmpty: "No company type data",
    sadash_help_priceMode: "Switches the figures between raw token counts and estimated cost (USD/THB) using a fixed rate (~1 USD = 35 THB), so treat the money values as a rough estimate only.",
    sadash_help_noSubscription: "This organization has no token-quota subscription assigned yet, so it may be unable to use the model until a quota is set for it.",
    saCore_help_priority: "Endpoint priority — the system calls the endpoint with the lowest number first, and only falls back to higher numbers if that one fails or is rate-limited. Use it to set the failover order across multiple endpoints.",
    saCore_help_gptMode: "Endpoint selection mode: \"Priority\" always uses your fixed order, while \"Fast\" periodically sends sample questions to every endpoint and automatically routes traffic to whichever responds fastest. Use Fast when speed matters more than a fixed order.",
    saCore_help_repeatTime: "How often (in minutes) the system re-benchmarks the speed of every endpoint. A smaller value refreshes the speed ranking more often but uses more resources (e.g. 30–60 minutes).",
    saCore_help_testQuestions: "The sample questions the system fires at each endpoint to measure response time — these are internal probes, not shown to end-users. Use questions similar to real usage so the speed test is representative.",
    saCore_help_embeddingType: "The embedding model/type used to turn text into vectors. It must match the model used when your documents were originally processed — otherwise knowledge-base search (RAG) breaks because the vector dimensions no longer line up.",
    saCore_help_autoDisablePricing: "The spending ceiling (USD). When accumulated GPT cost within the configured period exceeds this amount, the system automatically disables GPT. Works together with the \"Auto-Disable GPT\" switch.",
    saCore_help_autoDisablePeriod: "How many days back GPT spending is totalled — a rolling window, not a billing cycle. E.g. 30 = always the last 30 days. When the total reaches the price cap GPT is switched off; as older days drop out of the window it comes back on by itself. The total covers all companies in the system, and day boundaries follow UTC.",
    saCore_help_timeDelay: "Delay (milliseconds) between each streamed character in the bot's reply. Controls the \"typing\" animation speed — a higher value makes replies appear more slowly.",
    saCore_help_limitedCharacters: "The maximum number of characters a user can type in a single message. Prevents overly long inputs that waste tokens and slow down responses.",
    saCore_help_autoDisableMessage: "The message shown to end-users when GPT has been auto-disabled (e.g. \"Service temporarily unavailable, please try again later\").",
    saCore_help_nexaService: "The NEXA Knowledge Graph service is an external knowledge source the platform connects to via SSO to enrich answers with graph data. Configure its base URL, SSO token lifetime, and shared secret here.",
    saCore_help_ssoChatVsPortal: "There are two SSO switches per provider: the first enables SSO on the portal login page, while \"in Chat\" lets users sign in with this provider directly from the chat/snippet window.",
    sallm_help_maxToken: "The maximum number of tokens the model may generate in a single reply. Higher = longer possible answers but slower and more costly. Left blank, it defaults to 4096.",
    sallm_help_modelNameVsDisplay: "\"Model Display\" is the friendly, human-readable name shown in admin menus. \"Model Name\" must be the exact provider identifier (e.g. gpt-4o) that is sent to the API — it has to match the provider's spelling precisely.",
    sallm_help_authHeaderName: "The name of the HTTP header used to send the API key to the external provider (e.g. \"Authorization\" or \"api-key\"). Check the target API's documentation for which header name it expects the key in.",
    sallm_help_reasoningEffort: "For reasoning-capable models only — lets the model \"think\" more internally before answering, giving more accurate answers to complex questions at the cost of speed and extra tokens.",
    saconsent_help_versionOnSave: "Every time you press Save, the system creates a new consent version and all users must re-accept the terms before they can continue. Finalise your edits before saving.",
    saconsent_help_viewVersion: "Select a past consent version to view it read-only, for comparing against the current text. It does not change the version currently in use.",
    saconsent_help_audience: "Choose which audience this content applies to: \"Backend (Admin)\" = staff/admins using the back office, \"Frontend (End-user)\" = end-users on the public chat/website, \"Privacy Notice\" = the public Privacy Notice page, \"Terms of Service (Snippet)\" = the Terms of Service shown on /Landing/Terms (also opened from the snippet chat menu).",
    sapkg_help_limitToken: "The maximum token quota this package grants per cycle (the amount of AI usage it buys) when an organisation subscribes to it. Leave blank for unlimited.",
    sasub_help_tierModel: "Subscriptions have two levels: the \"Project\" tier is the overall cap for the whole project, while each \"Ministry\" subscription is a per-agency quota within it. The combined usage of all ministries must stay under the project cap.",
    sasub_help_imageCredit: "Spending cap for image generation, metered independently from text tokens. Each image consumes credit based on the model's actual cost (not a per-image count). The system allows a further 20% over the cap before blocking — e.g. a cap of 100 blocks once usage passes 120. Leave blank / tick unlimited for no limit.",
    sasub_help_renew: "The renew button is only enabled once a subscription has expired or been cancelled. Renewing extends the end date by 30 days from today.",
    sasub_help_statusChips: "Subscription state: \"Expire soon\" = close to the end date, \"Expired\" = past the end date, \"Cancelled\" = ended early by an admin.",
    _sa_doc_help_ingestionCascade: "This is the knowledge-base (RAG) ingestion setup: pick \"DocType\" → \"VectorType\" (content shape) → \"Processing Method\" (how the document is split into small chunks before being turned into searchable vectors). Each choice narrows the next.",
    _sa_doc_help_vectorType: "The content shape of the document: \"General\" = ordinary documents, \"Article\" = long-form content that must keep whole-article context, \"PriceList\" = tabular/row data such as price tables (CSV/Excel only). It affects how text is grouped.",
    _sa_doc_help_processType: "How the document is split into \"chunks\" before vectorising: General = automatic, MaxCharacter = split by a fixed character count, CustomSplit = split on a delimiter you specify, HeaderAllChunk/FirstChunk = attach the table header to every chunk / only the first, WordImage/PDFImage = also extract and process images from the file.",
    _sa_doc_help_maxChar: "The maximum size of each text chunk, in characters. Larger chunks keep more context but reduce search precision; smaller chunks search more precisely but hold less context (default ~1000).",
    _sa_doc_help_detectLanguage: "When on, the system detects and stores an English translation of each chunk, improving cross-language search (e.g. an English question can find a Thai document). It makes processing take longer.",
    _sa_doc_help_personalInfo: "Turn on when the document contains personal data (PII); the system then handles sensitive information under the privacy policy. Enable it for documents containing names, ID numbers, or personal contact details.",
    _sa_doc_help_processChip: "Vector processing status: the numbers are chunks embedded / total. Grey = not started, amber = in progress, green = fully processed and ready for search.",
    _sa_doc_help_reprocess: "Re-runs chunking and embedding on the existing file from scratch. Use it after changing the processing method or when search results are poor.",
    _sa_doc_help_duplicate: "Creates a copy of this document (with its vectors) under a new name. Use it to experiment with a variant without touching the original.",
    _sa_doc_help_replace: "Replaces the content of another chosen document with this one's vector data (overwriting the target). Use it to swap new content into a document that is already referenced elsewhere, without changing the name other systems rely on.",
    _sa_doc_help_versionHistory: "View the document's version history. Each reprocess/replace saves a snapshot, which you can open to inspect or restore an earlier version.",
    _sa_doc_help_download: "Exports the document's chunk data as an Excel file for review or offline editing (not the original source file).",
    _sa_doc_help_restore: "Restores the document to this version, overwriting the current live content with the selected one. Use \"View\" first if you want to inspect it before restoring.",
    _sa_doc_help_enColumn: "The \"Original\" column is the chunk's source text; the \"EN\" column is the English translation the system generated for embedding and cross-language search (present only when Detect Language is on).",
    _sa_doc_help_uploadMode: "Upload mode: \"Add\" appends the new file's chunks to the existing ones, while \"Replace\" deletes all current chunks first and rebuilds from this file (caution — this overwrites permanently).",
    _sa_doc_help_processBanner: "Chunks vectorised / total chunks for this document. When the two match, processing is complete and the document is ready for search.",
    _noti_help_type: "Notification types: TOKEN_80/TOKEN_100 = token usage reached 80%/100%, SUB_EXPIRY_7/30 = 7/30 days before a subscription expires, SUB_EXPIRED = already expired, NEW_COMPANY/NEW_SUBSCRIPTION = a new agency/package was created, SYSTEM = a system event.",
    _noti_help_level: "Severity level: info = general notice, warning = worth watching (e.g. quota running low), critical = needs urgent action (e.g. quota exhausted / expired).",
    saPersona_help_pii: "This data source returns personal data (PII, e.g. DOPA civil-registration records). The system blocks admin \"Test\" against real data to prevent exposing individuals' information.",
    saPersona_help_credentialSource: "Where GDX secrets are stored: \"Key Vault\" reads from Azure Key Vault (recommended for production, more secure), while \"Dbsettings\" stores them in the database with instant hot-reload (suited to development).",
    saPersona_help_gdxProvider: "GDX provider mode: \"Mock\" returns simulated data for testing without calling the live API, while \"Real\" calls the actual government API (with real cost and real data). Switch to Real only when ready for production.",
    saPersona_help_test: "The Test button is only available for sources that are enabled and not PII, letting you fetch a live sample (e.g. PM2.5 readings) without touching personal data.",
    bannerPopup_help_targetPages: "Choose which pages show the banner/popup: login = the sign-in page, product_admin = the admin back office, portal = the user dashboard, fullsnippet = the full chat window, landing = the public landing page.",
    bannerPopup_help_useButton: "Only one banner can be active at a time. Press \"Use\" to make this image the one shown live, replacing the previously active banner.",
    navb_help_timeDelay: "The delay (in milliseconds) applied while the bot streams its reply — higher values make the answer appear more slowly, like real typing; set 0 for an instant response. Allowed range 0–1000.",
    navb_help_llmSelector: "Pick which AI model answers in this chat. \"LLMs (default)\" uses the model your administrator assigned; choose another to compare answers, then press ✕ to return to the default.",
    navb_help_parameters: "Settings that control how this chat behaves — such as the reply typing speed (Time Delay) and which AI model (LLM) answers you. These apply only to the current chat session.",
    navb_help_topicMenuActions: "\"Remove from folder\" just moves the chat back to your main chat list — nothing is deleted; \"Delete chat\" permanently erases the whole conversation and cannot be undone.",
    navb_help_folderDelete: "Permanently deletes this folder and every chat inside it. To keep those chats, move them out of the folder before deleting.",
    navb_help_clearModel: "Reverts this chat back to the default AI model set by your administrator.",
    _sa_help_coreConfig: "Platform-wide default settings applied across all companies, such as core system parameters and baseline defaults.",
    _sa_help_personaApi: "Configure the chatbot's persona and the API connection/keys the platform uses to call the external service.",
    _sa_help_consentConfig: "Manage the versions of the Terms & Conditions (PDPA/consent) that users and admins must accept before using the system; publishing a new version re-prompts everyone.",
    _sa_help_llmManagement: "Register and manage the LLM providers and models (e.g. Azure, Google, Anthropic) that companies can use to power their chat answers.",
    ddfile_help_templateType: "Choose which template format to upload — \"Normal Question\" is standalone question-and-answer pairs, while \"Chain Question\" is a set of linked, step-by-step follow-up questions.",
    _km_help_share: "Share this knowledge document with child companies so their chatbots can use its content to answer questions. Choose which companies get View / Edit / Delete access, then Save (un-selecting a company revokes it).",
    _km_help_permissions: "View / Ask = the company can read and use the document to answer questions (granted automatically when selected); Edit = can modify or re-upload it; Delete = can remove it on their side.",
    _km_help_currentShared: "This badge means the company already has this document shared. Un-checking it and saving will revoke that company's access.",
    termsDialog_help_decline: "If you decline the terms, you cannot continue using the system and will be signed out immediately.",
    snippet_help_privateMemoryDialog: "This is the bot's private knowledge base (Private Memory / RAG). Uploading a document splits it into text chunks and converts them into vectors that the AI searches to answer questions. Anything added here becomes a source the bot draws its answers from.",
    snippet_help_fileListDialog: "This list shows every document in the bot's knowledge base. Each file can be edited, deleted, version-tracked, or switched on/off. A file that is switched off is excluded from the AI's answers.",
    snippet_help_fileActiveSwitch: "Include or exclude this entire document from answers. When off, the file stays in the library but the AI will no longer pull any content from it — useful for temporarily retiring a document without deleting it.",
    snippet_help_reprocess: "Rebuilds this document's vectors from scratch — it re-splits and re-embeds every chunk using the current settings (Custom Max Character, Text Replacement, DetectLanguage). Use it after changing the chunking settings so they apply to the whole document; existing chunks are replaced.",
    snippet_help_chunkActiveSwitch: "Turns just this single chunk (one split passage) on or off. When off, the AI ignores this passage but still uses the other chunks in the same file — handy for muting an incorrect or duplicated passage without deleting it.",
    snippet_help_restoreVersion: "Roll back to this version — its content replaces the current one and becomes the live version used in answers.",
    snippet_help_viewVersion: "Preview this older version's content for inspection without changing the live version. (Use Restore if you actually want to bring it back.)",
    snippet_help_versionHistory: "View this document's upload history. The system keeps every past version, so you can review or roll back to an earlier one.",
    snippet_help_refreshProgress: "This number shows embedding progress (chunks finished / total). Click to refresh the latest status — it does not reprocess anything.",
    snippet_help_customCharacter: "The delimiter that marks where the document is split into chunks in CustomSplit mode. The system starts a new chunk every time it hits this delimiter (e.g. {'||!'}) — use it when you want to control the split points yourself.",
    snippet_help_typeModes: "\"Type\" is how the document is split into chunks before embedding — General auto-splits, MaxCharacter splits by a character limit, CustomSplit splits on your own delimiter, Article keeps a whole article as one chunk, HeaderAllChunk/HeaderFirstChunk split by headings, and WordImage/PDFImage extract images from Word/PDF files. The strategy you pick directly affects answer accuracy.",
    snippet_help_templateButton: "Opens sample template files for each chunking mode (General, MaxCharacter, CustomSplit, etc.). Download one as a starting format so your document is structured the way the system expects.",
    snippet_help_showAllText: "Expands every chunk's full text (original / translated) in the table instead of truncating it. This only changes the view — it does not alter the data.",
    snippet_help_processTypeAddReplace: "Add = append new data to the existing vectors; Replace = delete all of this document's existing vectors first, then rebuild (caution: existing data is removed).",
    // S24-P4 Agent Log View
    agentLog_expandToggle: "Expand/collapse hops",
    agentLog_statusOk: "OK",
    agentLog_statusError: "Error",
    agentLog_statusPartial: "Partial",
    agentLog_hopSeq: "Seq",
    agentLog_hopTime: "Time",
    agentLog_hopQuestion: "Question",
    agentLog_hopAnswer: "Answer",
    agentLog_hopTokens: "Tokens",
    agentLog_hopStatus: "Status",
    agentLog_hopResponseTime: "Response time (s)",
    agentLog_hopModel: "Model",
    agentLog_hopUrlEndpoint: "Upstream URL",
    agentLog_hopsTitle: "Hop details ({n})",
    agentLog_promptTokens: "Prompt",
    agentLog_completionTokens: "Completion",
    agentLog_cachedTokens: "Cached",
    agentLog_totalTokens: "Total",
    agentLog_contentMaskedHint: "Content is hidden for your role (SuperAdmin only)",
    lmsg_agentRunBadge: "Agent",
    lmsg_agentClientUnknown: "Unknown client",
    lmsg_agentFlowTitle: "Agent Flow",
    lmsg_agentFlowMessage: "Message",
    lmsg_agentFlowReply: "Reply",
    lmsg_agentFlowToolCalls: "Tool Calls",
    lmsg_agentFlowNoToolCalls: "No tool calls",
    lmsg_agentFlowEmpty: "No flow data available for this hop (historical record from before this feature)",
    lmsg_agentFlowLoadError: "Failed to load agent flow data",
    lmsg_noRecordsFound: "No records found",
    /* @@AUTO_I18N_EN@@ */
  },
};
const supportedLocales = ['th', 'en'];
const getInitialLocale = () => {
  try {
    const savedLocale = localStorage.getItem('locale');
    return supportedLocales.includes(savedLocale) ? savedLocale : 'th';
  } catch (_) {
    return 'th';
  }
};

const i18n = createI18n({
  legacy: true, // สำหรับใช้กับ Vue 2 API ใน Vue 3
  locale: getInitialLocale(), // set locale
  fallbackLocale: 'th', // set fallback locale
  messages, // set locale messages
});

const i18nPlugin = {
  install(app) {
    app.config.globalProperties.$filters = {
      myLocale(value) {
        return i18n.global.t(value);
      },
    };
  },
};

// ─────────────────────────────────────────────────────────────
// Organization type labels (Thai government org hierarchy)
// Maps mas.CompanyType.TypeCode → localized label.
// DB เก็บ TypeName เป็นภาษาไทยอย่างเดียว และ tree node / subscription row
// ส่งมาแค่ TypeName (ไม่มี TypeCode) → orgTypeLabel() จึงรับได้ทั้ง TypeCode
// และ Thai TypeName แล้ว reverse-map กลับเป็น code
// ─────────────────────────────────────────────────────────────
export const organizationTypes = {
  en: {
    KRASUANG: 'Ministry',
    KROM: 'Department',
    SAMNAK_NGAN: 'Office',
    ONGKARN: 'Organization',
    KONG: 'Division',
    SAMNAK: 'Bureau',
    SUUN: 'Center',
    SATHABAN: 'Institute',
    FAI: 'Section',
    KLUM: 'Group',
    SUAN: 'Sub-division',
    NGAN: 'Unit',
  },
  th: {
    KRASUANG: 'กระทรวง',
    KROM: 'กรม',
    SAMNAK_NGAN: 'สำนักงาน',
    ONGKARN: 'องค์การ',
    KONG: 'กอง',
    SAMNAK: 'สำนัก',
    SUUN: 'ศูนย์',
    SATHABAN: 'สถาบัน',
    FAI: 'ฝ่าย',
    KLUM: 'กลุ่ม',
    SUAN: 'ส่วน',
    NGAN: 'งาน',
  },
};

// reverse lookup: Thai TypeName → TypeCode
// ใช้ exact-string match (ชื่อไทยทั้ง 12 ตัวไม่ซ้ำกัน) — ห้ามใช้ includes()
// เพราะ สำนัก vs สำนักงาน / งาน vs สำนักงาน จะชนกัน
const orgTypeCodeByThaiName = Object.fromEntries(Object.entries(organizationTypes.th).map(([code, thName]) => [thName, code]));

/**
 * แปลงประเภทหน่วยงาน → label ตามภาษา
 * @param {string} value  TypeCode (เช่น 'KRASUANG') หรือ Thai TypeName (เช่น 'กระทรวง') ที่ backend ส่งมา
 * @param {string} locale 'th' | 'en' (ค่าอื่น/ว่าง → fallback 'th')
 * @returns {string} label ตามภาษา; input ว่าง → '' (คง `||` fallback เดิม); ไม่รู้จัก → คืนค่าเดิม (custom type)
 */
export function orgTypeLabel(value, locale) {
  if (value == null || value === '') return '';
  const key = String(value).trim();
  const lang = organizationTypes[locale] ? locale : 'th';
  // resolve → canonical TypeCode: เป็น code อยู่แล้ว หรือ reverse-map จาก Thai TypeName
  const code = organizationTypes.en[key] ? key : orgTypeCodeByThaiName[key] ?? null;
  if (!code) return value; // custom/unknown type → แสดงตามเดิม
  return organizationTypes[lang]?.[code] ?? value;
}

export default i18n;
export { i18nPlugin };
